/*! jQuery v3.6.1 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(C,e){"use strict";var t=[],r=Object.getPrototypeOf,s=t.slice,g=t.flat?function(e){return t.flat.call(e)}:function(e){return t.concat.apply([],e)},u=t.push,i=t.indexOf,n={},o=n.toString,y=n.hasOwnProperty,a=y.toString,l=a.call(Object),v={},m=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},x=function(e){return null!=e&&e===e.window},E=C.document,c={type:!0,src:!0,nonce:!0,noModule:!0};function b(e,t,n){var r,i,o=(n=n||E).createElement("script");if(o.text=e,t)for(r in c)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function w(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[o.call(e)]||"object":typeof e}var f="3.6.1",S=function(e,t){return new S.fn.init(e,t)};function p(e){var t=!!e&&"length"in e&&e.length,n=w(e);return!m(e)&&!x(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}S.fn=S.prototype={jquery:f,constructor:S,length:0,toArray:function(){return s.call(this)},get:function(e){return null==e?s.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=S.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return S.each(this,e)},map:function(n){return this.pushStack(S.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(s.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(S.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(S.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:u,sort:t.sort,splice:t.splice},S.extend=S.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||m(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(S.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||S.isPlainObject(n)?n:{},i=!1,a[t]=S.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},S.extend({expando:"jQuery"+(f+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==o.call(e))&&(!(t=r(e))||"function"==typeof(n=y.call(t,"constructor")&&t.constructor)&&a.call(n)===l)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){b(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(p(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},makeArray:function(e,t){var n=t||[];return null!=e&&(p(Object(e))?S.merge(n,"string"==typeof e?[e]:e):u.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:i.call(t,e,n)},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(p(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:v}),"function"==typeof Symbol&&(S.fn[Symbol.iterator]=t[Symbol.iterator]),S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var d=function(n){var e,d,b,o,i,h,f,g,w,u,l,T,C,a,E,y,s,c,v,S="sizzle"+1*new Date,p=n.document,k=0,r=0,m=ue(),x=ue(),A=ue(),N=ue(),j=function(e,t){return e===t&&(l=!0),0},D={}.hasOwnProperty,t=[],q=t.pop,L=t.push,H=t.push,O=t.slice,P=function(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1},R="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",M="[\\x20\\t\\r\\n\\f]",I="(?:\\\\[\\da-fA-F]{1,6}"+M+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",W="\\["+M+"*("+I+")(?:"+M+"*([*^$|!~]?=)"+M+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+I+"))|)"+M+"*\\]",F=":("+I+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+W+")*)|.*)\\)|)",$=new RegExp(M+"+","g"),B=new RegExp("^"+M+"+|((?:^|[^\\\\])(?:\\\\.)*)"+M+"+$","g"),_=new RegExp("^"+M+"*,"+M+"*"),z=new RegExp("^"+M+"*([>+~]|"+M+")"+M+"*"),U=new RegExp(M+"|>"),X=new RegExp(F),V=new RegExp("^"+I+"$"),G={ID:new RegExp("^#("+I+")"),CLASS:new RegExp("^\\.("+I+")"),TAG:new RegExp("^("+I+"|[*])"),ATTR:new RegExp("^"+W),PSEUDO:new RegExp("^"+F),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+M+"*(even|odd|(([+-]|)(\\d*)n|)"+M+"*(?:([+-]|)"+M+"*(\\d+)|))"+M+"*\\)|)","i"),bool:new RegExp("^(?:"+R+")$","i"),needsContext:new RegExp("^"+M+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+M+"*((?:-\\d)?\\d*)"+M+"*\\)|)(?=[^-]|$)","i")},Y=/HTML$/i,Q=/^(?:input|select|textarea|button)$/i,J=/^h\d$/i,K=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,ee=/[+~]/,te=new RegExp("\\\\[\\da-fA-F]{1,6}"+M+"?|\\\\([^\\r\\n\\f])","g"),ne=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},re=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,ie=function(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e},oe=function(){T()},ae=be(function(e){return!0===e.disabled&&"fieldset"===e.nodeName.toLowerCase()},{dir:"parentNode",next:"legend"});try{H.apply(t=O.call(p.childNodes),p.childNodes),t[p.childNodes.length].nodeType}catch(e){H={apply:t.length?function(e,t){L.apply(e,O.call(t))}:function(e,t){var n=e.length,r=0;while(e[n++]=t[r++]);e.length=n-1}}}function se(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(T(e),e=e||C,E)){if(11!==p&&(u=Z.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return n.push(a),n}else if(f&&(a=f.getElementById(i))&&v(e,a)&&a.id===i)return n.push(a),n}else{if(u[2])return H.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&d.getElementsByClassName&&e.getElementsByClassName)return H.apply(n,e.getElementsByClassName(i)),n}if(d.qsa&&!N[t+" "]&&(!y||!y.test(t))&&(1!==p||"object"!==e.nodeName.toLowerCase())){if(c=t,f=e,1===p&&(U.test(t)||z.test(t))){(f=ee.test(t)&&ve(e.parentNode)||e)===e&&d.scope||((s=e.getAttribute("id"))?s=s.replace(re,ie):e.setAttribute("id",s=S)),o=(l=h(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+xe(l[o]);c=l.join(",")}try{return H.apply(n,f.querySelectorAll(c)),n}catch(e){N(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return g(t.replace(B,"$1"),e,n,r)}function ue(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function le(e){return e[S]=!0,e}function ce(e){var t=C.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function fe(e,t){var n=e.split("|"),r=n.length;while(r--)b.attrHandle[n[r]]=t}function pe(e,t){var n=t&&e,r=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(r)return r;if(n)while(n=n.nextSibling)if(n===t)return-1;return e?1:-1}function de(t){return function(e){return"input"===e.nodeName.toLowerCase()&&e.type===t}}function he(n){return function(e){var t=e.nodeName.toLowerCase();return("input"===t||"button"===t)&&e.type===n}}function ge(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&ae(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function ye(a){return le(function(o){return o=+o,le(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function ve(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}for(e in d=se.support={},i=se.isXML=function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!Y.test(t||n&&n.nodeName||"HTML")},T=se.setDocument=function(e){var t,n,r=e?e.ownerDocument||e:p;return r!=C&&9===r.nodeType&&r.documentElement&&(a=(C=r).documentElement,E=!i(C),p!=C&&(n=C.defaultView)&&n.top!==n&&(n.addEventListener?n.addEventListener("unload",oe,!1):n.attachEvent&&n.attachEvent("onunload",oe)),d.scope=ce(function(e){return a.appendChild(e).appendChild(C.createElement("div")),"undefined"!=typeof e.querySelectorAll&&!e.querySelectorAll(":scope fieldset div").length}),d.attributes=ce(function(e){return e.className="i",!e.getAttribute("className")}),d.getElementsByTagName=ce(function(e){return e.appendChild(C.createComment("")),!e.getElementsByTagName("*").length}),d.getElementsByClassName=K.test(C.getElementsByClassName),d.getById=ce(function(e){return a.appendChild(e).id=S,!C.getElementsByName||!C.getElementsByName(S).length}),d.getById?(b.filter.ID=function(e){var t=e.replace(te,ne);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(te,ne);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=d.getElementsByTagName?function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):d.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if("*"===e){while(n=o[i++])1===n.nodeType&&r.push(n);return r}return o},b.find.CLASS=d.getElementsByClassName&&function(e,t){if("undefined"!=typeof t.getElementsByClassName&&E)return t.getElementsByClassName(e)},s=[],y=[],(d.qsa=K.test(C.querySelectorAll))&&(ce(function(e){var t;a.appendChild(e).innerHTML="<a id='"+S+"'></a><select id='"+S+"-\r\\' msallowcapture=''><option selected=''></option></select>",e.querySelectorAll("[msallowcapture^='']").length&&y.push("[*^$]="+M+"*(?:''|\"\")"),e.querySelectorAll("[selected]").length||y.push("\\["+M+"*(?:value|"+R+")"),e.querySelectorAll("[id~="+S+"-]").length||y.push("~="),(t=C.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||y.push("\\["+M+"*name"+M+"*="+M+"*(?:''|\"\")"),e.querySelectorAll(":checked").length||y.push(":checked"),e.querySelectorAll("a#"+S+"+*").length||y.push(".#.+[+~]"),e.querySelectorAll("\\\f"),y.push("[\\r\\n\\f]")}),ce(function(e){e.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var t=C.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),e.querySelectorAll("[name=d]").length&&y.push("name"+M+"*[*^$|!~]?="),2!==e.querySelectorAll(":enabled").length&&y.push(":enabled",":disabled"),a.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&y.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),y.push(",.*:")})),(d.matchesSelector=K.test(c=a.matches||a.webkitMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector||a.msMatchesSelector))&&ce(function(e){d.disconnectedMatch=c.call(e,"*"),c.call(e,"[s!='']:x"),s.push("!=",F)}),y=y.length&&new RegExp(y.join("|")),s=s.length&&new RegExp(s.join("|")),t=K.test(a.compareDocumentPosition),v=t||K.test(a.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)while(t=t.parentNode)if(t===e)return!0;return!1},j=t?function(e,t){if(e===t)return l=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!d.sortDetached&&t.compareDocumentPosition(e)===n?e==C||e.ownerDocument==p&&v(p,e)?-1:t==C||t.ownerDocument==p&&v(p,t)?1:u?P(u,e)-P(u,t):0:4&n?-1:1)}:function(e,t){if(e===t)return l=!0,0;var n,r=0,i=e.parentNode,o=t.parentNode,a=[e],s=[t];if(!i||!o)return e==C?-1:t==C?1:i?-1:o?1:u?P(u,e)-P(u,t):0;if(i===o)return pe(e,t);n=e;while(n=n.parentNode)a.unshift(n);n=t;while(n=n.parentNode)s.unshift(n);while(a[r]===s[r])r++;return r?pe(a[r],s[r]):a[r]==p?-1:s[r]==p?1:0}),C},se.matches=function(e,t){return se(e,null,null,t)},se.matchesSelector=function(e,t){if(T(e),d.matchesSelector&&E&&!N[t+" "]&&(!s||!s.test(t))&&(!y||!y.test(t)))try{var n=c.call(e,t);if(n||d.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){N(t,!0)}return 0<se(t,C,null,[e]).length},se.contains=function(e,t){return(e.ownerDocument||e)!=C&&T(e),v(e,t)},se.attr=function(e,t){(e.ownerDocument||e)!=C&&T(e);var n=b.attrHandle[t.toLowerCase()],r=n&&D.call(b.attrHandle,t.toLowerCase())?n(e,t,!E):void 0;return void 0!==r?r:d.attributes||!E?e.getAttribute(t):(r=e.getAttributeNode(t))&&r.specified?r.value:null},se.escape=function(e){return(e+"").replace(re,ie)},se.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},se.uniqueSort=function(e){var t,n=[],r=0,i=0;if(l=!d.detectDuplicates,u=!d.sortStable&&e.slice(0),e.sort(j),l){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)e.splice(n[r],1)}return u=null,e},o=se.getText=function(e){var t,n="",r=0,i=e.nodeType;if(i){if(1===i||9===i||11===i){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=o(e)}else if(3===i||4===i)return e.nodeValue}else while(t=e[r++])n+=o(t);return n},(b=se.selectors={cacheLength:50,createPseudo:le,match:G,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(te,ne),e[3]=(e[3]||e[4]||e[5]||"").replace(te,ne),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||se.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&se.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return G.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&X.test(n)&&(t=h(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(te,ne).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=m[e+" "];return t||(t=new RegExp("(^|"+M+")"+e+"("+M+"|$)"))&&m(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=se.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace($," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(h,e,t,g,y){var v="nth"!==h.slice(0,3),m="last"!==h.slice(-4),x="of-type"===e;return 1===g&&0===y?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u,l=v!==m?"nextSibling":"previousSibling",c=e.parentNode,f=x&&e.nodeName.toLowerCase(),p=!n&&!x,d=!1;if(c){if(v){while(l){a=e;while(a=a[l])if(x?a.nodeName.toLowerCase()===f:1===a.nodeType)return!1;u=l="only"===h&&!u&&"nextSibling"}return!0}if(u=[m?c.firstChild:c.lastChild],m&&p){d=(s=(r=(i=(o=(a=c)[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===k&&r[1])&&r[2],a=s&&c.childNodes[s];while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if(1===a.nodeType&&++d&&a===e){i[h]=[k,s,d];break}}else if(p&&(d=s=(r=(i=(o=(a=e)[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===k&&r[1]),!1===d)while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if((x?a.nodeName.toLowerCase()===f:1===a.nodeType)&&++d&&(p&&((i=(o=a[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]=[k,d]),a===e))break;return(d-=y)===g||d%g==0&&0<=d/g}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||se.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?le(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=P(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:le(function(e){var r=[],i=[],s=f(e.replace(B,"$1"));return s[S]?le(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:le(function(t){return function(e){return 0<se(t,e).length}}),contains:le(function(t){return t=t.replace(te,ne),function(e){return-1<(e.textContent||o(e)).indexOf(t)}}),lang:le(function(n){return V.test(n||"")||se.error("unsupported lang: "+n),n=n.replace(te,ne).toLowerCase(),function(e){var t;do{if(t=E?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=n.location&&n.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===a},focus:function(e){return e===C.activeElement&&(!C.hasFocus||C.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:ge(!1),disabled:ge(!0),checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return J.test(e.nodeName)},input:function(e){return Q.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:ye(function(){return[0]}),last:ye(function(e,t){return[t-1]}),eq:ye(function(e,t,n){return[n<0?n+t:n]}),even:ye(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:ye(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:ye(function(e,t,n){for(var r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:ye(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=de(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=he(e);function me(){}function xe(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function be(s,e,t){var u=e.dir,l=e.next,c=l||u,f=t&&"parentNode"===c,p=r++;return e.first?function(e,t,n){while(e=e[u])if(1===e.nodeType||f)return s(e,t,n);return!1}:function(e,t,n){var r,i,o,a=[k,p];if(n){while(e=e[u])if((1===e.nodeType||f)&&s(e,t,n))return!0}else while(e=e[u])if(1===e.nodeType||f)if(i=(o=e[S]||(e[S]={}))[e.uniqueID]||(o[e.uniqueID]={}),l&&l===e.nodeName.toLowerCase())e=e[u]||e;else{if((r=i[c])&&r[0]===k&&r[1]===p)return a[2]=r[2];if((i[c]=a)[2]=s(e,t,n))return!0}return!1}}function we(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Te(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function Ce(d,h,g,y,v,e){return y&&!y[S]&&(y=Ce(y)),v&&!v[S]&&(v=Ce(v,e)),le(function(e,t,n,r){var i,o,a,s=[],u=[],l=t.length,c=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)se(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),f=!d||!e&&h?c:Te(c,s,d,n,r),p=g?v||(e?d:l||y)?[]:t:f;if(g&&g(f,p,n,r),y){i=Te(p,u),y(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(p[u[o]]=!(f[u[o]]=a))}if(e){if(v||d){if(v){i=[],o=p.length;while(o--)(a=p[o])&&i.push(f[o]=a);v(null,p=[],i,r)}o=p.length;while(o--)(a=p[o])&&-1<(i=v?P(e,a):s[o])&&(e[i]=!(t[i]=a))}}else p=Te(p===t?p.splice(l,p.length):p),v?v(null,t,p,r):H.apply(t,p)})}function Ee(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=be(function(e){return e===i},a,!0),l=be(function(e){return-1<P(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!==w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[be(we(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return Ce(1<s&&we(c),1<s&&xe(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(B,"$1"),t,s<n&&Ee(e.slice(s,n)),n<r&&Ee(e=e.slice(n)),n<r&&xe(e))}c.push(t)}return we(c)}return me.prototype=b.filters=b.pseudos,b.setFilters=new me,h=se.tokenize=function(e,t){var n,r,i,o,a,s,u,l=x[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=_.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=z.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(B," ")}),a=a.slice(n.length)),b.filter)!(r=G[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?se.error(e):x(e,s).slice(0)},f=se.compile=function(e,t){var n,y,v,m,x,r,i=[],o=[],a=A[e+" "];if(!a){t||(t=h(e)),n=t.length;while(n--)(a=Ee(t[n]))[S]?i.push(a):o.push(a);(a=A(e,(y=o,m=0<(v=i).length,x=0<y.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=k+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==C||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==C||(T(o),n=!E);while(s=y[a++])if(s(o,t||C,n)){r.push(o);break}i&&(k=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=v[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=q.call(r));f=Te(f)}H.apply(r,f),i&&!e&&0<f.length&&1<u+v.length&&se.uniqueSort(r)}return i&&(k=h,w=p),c},m?le(r):r))).selector=e}return a},g=se.select=function(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&h(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&E&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(te,ne),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=G.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(te,ne),ee.test(o[0].type)&&ve(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&xe(o)))return H.apply(n,r),n;break}}}return(l||f(e,c))(r,t,!E,n,!t||ee.test(e)&&ve(t.parentNode)||t),n},d.sortStable=S.split("").sort(j).join("")===S,d.detectDuplicates=!!l,T(),d.sortDetached=ce(function(e){return 1&e.compareDocumentPosition(C.createElement("fieldset"))}),ce(function(e){return e.innerHTML="<a href='#'></a>","#"===e.firstChild.getAttribute("href")})||fe("type|href|height|width",function(e,t,n){if(!n)return e.getAttribute(t,"type"===t.toLowerCase()?1:2)}),d.attributes&&ce(function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")})||fe("value",function(e,t,n){if(!n&&"input"===e.nodeName.toLowerCase())return e.defaultValue}),ce(function(e){return null==e.getAttribute("disabled")})||fe(R,function(e,t,n){var r;if(!n)return!0===e[t]?t.toLowerCase():(r=e.getAttributeNode(t))&&r.specified?r.value:null}),se}(C);S.find=d,S.expr=d.selectors,S.expr[":"]=S.expr.pseudos,S.uniqueSort=S.unique=d.uniqueSort,S.text=d.getText,S.isXMLDoc=d.isXML,S.contains=d.contains,S.escapeSelector=d.escape;var h=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&S(e).is(n))break;r.push(e)}return r},T=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},k=S.expr.match.needsContext;function A(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}var N=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function j(e,n,r){return m(n)?S.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?S.grep(e,function(e){return e===n!==r}):"string"!=typeof n?S.grep(e,function(e){return-1<i.call(n,e)!==r}):S.filter(n,e,r)}S.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?S.find.matchesSelector(r,e)?[r]:[]:S.find.matches(e,S.grep(t,function(e){return 1===e.nodeType}))},S.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(S(e).filter(function(){for(t=0;t<r;t++)if(S.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)S.find(e,i[t],n);return 1<r?S.uniqueSort(n):n},filter:function(e){return this.pushStack(j(this,e||[],!1))},not:function(e){return this.pushStack(j(this,e||[],!0))},is:function(e){return!!j(this,"string"==typeof e&&k.test(e)?S(e):e||[],!1).length}});var D,q=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(S.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||D,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:q.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof S?t[0]:t,S.merge(this,S.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:E,!0)),N.test(r[1])&&S.isPlainObject(t))for(r in t)m(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=E.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):m(e)?void 0!==n.ready?n.ready(e):e(S):S.makeArray(e,this)}).prototype=S.fn,D=S(E);var L=/^(?:parents|prev(?:Until|All))/,H={children:!0,contents:!0,next:!0,prev:!0};function O(e,t){while((e=e[t])&&1!==e.nodeType);return e}S.fn.extend({has:function(e){var t=S(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(S.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&S(e);if(!k.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&S.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?S.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?i.call(S(e),this[0]):i.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(S.uniqueSort(S.merge(this.get(),S(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),S.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return h(e,"parentNode")},parentsUntil:function(e,t,n){return h(e,"parentNode",n)},next:function(e){return O(e,"nextSibling")},prev:function(e){return O(e,"previousSibling")},nextAll:function(e){return h(e,"nextSibling")},prevAll:function(e){return h(e,"previousSibling")},nextUntil:function(e,t,n){return h(e,"nextSibling",n)},prevUntil:function(e,t,n){return h(e,"previousSibling",n)},siblings:function(e){return T((e.parentNode||{}).firstChild,e)},children:function(e){return T(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(A(e,"template")&&(e=e.content||e),S.merge([],e.childNodes))}},function(r,i){S.fn[r]=function(e,t){var n=S.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=S.filter(t,n)),1<this.length&&(H[r]||S.uniqueSort(n),L.test(r)&&n.reverse()),this.pushStack(n)}});var P=/[^\x20\t\r\n\f]+/g;function R(e){return e}function M(e){throw e}function I(e,t,n,r){var i;try{e&&m(i=e.promise)?i.call(e).done(t).fail(n):e&&m(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}S.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},S.each(e.match(P)||[],function(e,t){n[t]=!0}),n):S.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){S.each(e,function(e,t){m(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==w(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return S.each(arguments,function(e,t){var n;while(-1<(n=S.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<S.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},S.extend({Deferred:function(e){var o=[["notify","progress",S.Callbacks("memory"),S.Callbacks("memory"),2],["resolve","done",S.Callbacks("once memory"),S.Callbacks("once memory"),0,"resolved"],["reject","fail",S.Callbacks("once memory"),S.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return S.Deferred(function(r){S.each(o,function(e,t){var n=m(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&m(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,m(t)?s?t.call(e,l(u,o,R,s),l(u,o,M,s)):(u++,t.call(e,l(u,o,R,s),l(u,o,M,s),l(u,o,R,o.notifyWith))):(a!==R&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){S.Deferred.exceptionHook&&S.Deferred.exceptionHook(e,t.stackTrace),u<=i+1&&(a!==M&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(S.Deferred.getStackHook&&(t.stackTrace=S.Deferred.getStackHook()),C.setTimeout(t))}}return S.Deferred(function(e){o[0][3].add(l(0,e,m(r)?r:R,e.notifyWith)),o[1][3].add(l(0,e,m(t)?t:R)),o[2][3].add(l(0,e,m(n)?n:M))}).promise()},promise:function(e){return null!=e?S.extend(e,a):a}},s={};return S.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=s.call(arguments),o=S.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?s.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(I(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||m(i[t]&&i[t].then)))return o.then();while(t--)I(i[t],a(t),o.reject);return o.promise()}});var W=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;S.Deferred.exceptionHook=function(e,t){C.console&&C.console.warn&&e&&W.test(e.name)&&C.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},S.readyException=function(e){C.setTimeout(function(){throw e})};var F=S.Deferred();function $(){E.removeEventListener("DOMContentLoaded",$),C.removeEventListener("load",$),S.ready()}S.fn.ready=function(e){return F.then(e)["catch"](function(e){S.readyException(e)}),this},S.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--S.readyWait:S.isReady)||(S.isReady=!0)!==e&&0<--S.readyWait||F.resolveWith(E,[S])}}),S.ready.then=F.then,"complete"===E.readyState||"loading"!==E.readyState&&!E.documentElement.doScroll?C.setTimeout(S.ready):(E.addEventListener("DOMContentLoaded",$),C.addEventListener("load",$));var B=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===w(n))for(s in i=!0,n)B(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,m(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(S(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},_=/^-ms-/,z=/-([a-z])/g;function U(e,t){return t.toUpperCase()}function X(e){return e.replace(_,"ms-").replace(z,U)}var V=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function G(){this.expando=S.expando+G.uid++}G.uid=1,G.prototype={cache:function(e){var t=e[this.expando];return t||(t={},V(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[X(t)]=n;else for(r in t)i[X(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][X(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(X):(t=X(t))in r?[t]:t.match(P)||[]).length;while(n--)delete r[t[n]]}(void 0===t||S.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!S.isEmptyObject(t)}};var Y=new G,Q=new G,J=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,K=/[A-Z]/g;function Z(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(K,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:J.test(i)?JSON.parse(i):i)}catch(e){}Q.set(e,t,n)}else n=void 0;return n}S.extend({hasData:function(e){return Q.hasData(e)||Y.hasData(e)},data:function(e,t,n){return Q.access(e,t,n)},removeData:function(e,t){Q.remove(e,t)},_data:function(e,t,n){return Y.access(e,t,n)},_removeData:function(e,t){Y.remove(e,t)}}),S.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=Q.get(o),1===o.nodeType&&!Y.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=X(r.slice(5)),Z(o,r,i[r]));Y.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){Q.set(this,n)}):B(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=Q.get(o,n))?t:void 0!==(t=Z(o,n))?t:void 0;this.each(function(){Q.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){Q.remove(this,e)})}}),S.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=Y.get(e,t),n&&(!r||Array.isArray(n)?r=Y.access(e,t,S.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=S.queue(e,t),r=n.length,i=n.shift(),o=S._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){S.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return Y.get(e,n)||Y.access(e,n,{empty:S.Callbacks("once memory").add(function(){Y.remove(e,[t+"queue",n])})})}}),S.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?S.queue(this[0],t):void 0===n?this:this.each(function(){var e=S.queue(this,t,n);S._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&S.dequeue(this,t)})},dequeue:function(e){return this.each(function(){S.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=S.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=Y.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var ee=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,te=new RegExp("^(?:([+-])=|)("+ee+")([a-z%]*)$","i"),ne=["Top","Right","Bottom","Left"],re=E.documentElement,ie=function(e){return S.contains(e.ownerDocument,e)},oe={composed:!0};re.getRootNode&&(ie=function(e){return S.contains(e.ownerDocument,e)||e.getRootNode(oe)===e.ownerDocument});var ae=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&ie(e)&&"none"===S.css(e,"display")};function se(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return S.css(e,t,"")},u=s(),l=n&&n[3]||(S.cssNumber[t]?"":"px"),c=e.nodeType&&(S.cssNumber[t]||"px"!==l&&+u)&&te.exec(S.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)S.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,S.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ue={};function le(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=Y.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ae(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ue[s])||(o=a.body.appendChild(a.createElement(s)),u=S.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ue[s]=u)))):"none"!==n&&(l[c]="none",Y.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}S.fn.extend({show:function(){return le(this,!0)},hide:function(){return le(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ae(this)?S(this).show():S(this).hide()})}});var ce,fe,pe=/^(?:checkbox|radio)$/i,de=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,he=/^$|^module$|\/(?:java|ecma)script/i;ce=E.createDocumentFragment().appendChild(E.createElement("div")),(fe=E.createElement("input")).setAttribute("type","radio"),fe.setAttribute("checked","checked"),fe.setAttribute("name","t"),ce.appendChild(fe),v.checkClone=ce.cloneNode(!0).cloneNode(!0).lastChild.checked,ce.innerHTML="<textarea>x</textarea>",v.noCloneChecked=!!ce.cloneNode(!0).lastChild.defaultValue,ce.innerHTML="<option></option>",v.option=!!ce.lastChild;var ge={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function ye(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&A(e,t)?S.merge([e],n):n}function ve(e,t){for(var n=0,r=e.length;n<r;n++)Y.set(e[n],"globalEval",!t||Y.get(t[n],"globalEval"))}ge.tbody=ge.tfoot=ge.colgroup=ge.caption=ge.thead,ge.th=ge.td,v.option||(ge.optgroup=ge.option=[1,"<select multiple='multiple'>","</select>"]);var me=/<|&#?\w+;/;function xe(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===w(o))S.merge(p,o.nodeType?[o]:o);else if(me.test(o)){a=a||f.appendChild(t.createElement("div")),s=(de.exec(o)||["",""])[1].toLowerCase(),u=ge[s]||ge._default,a.innerHTML=u[1]+S.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;S.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<S.inArray(o,r))i&&i.push(o);else if(l=ie(o),a=ye(f.appendChild(o),"script"),l&&ve(a),n){c=0;while(o=a[c++])he.test(o.type||"")&&n.push(o)}return f}var be=/^([^.]*)(?:\.(.+)|)/;function we(){return!0}function Te(){return!1}function Ce(e,t){return e===function(){try{return E.activeElement}catch(e){}}()==("focus"===t)}function Ee(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Ee(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=Te;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return S().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=S.guid++)),e.each(function(){S.event.add(this,t,i,r,n)})}function Se(e,i,o){o?(Y.set(e,i,!1),S.event.add(e,i,{namespace:!1,handler:function(e){var t,n,r=Y.get(this,i);if(1&e.isTrigger&&this[i]){if(r.length)(S.event.special[i]||{}).delegateType&&e.stopPropagation();else if(r=s.call(arguments),Y.set(this,i,r),t=o(this,i),this[i](),r!==(n=Y.get(this,i))||t?Y.set(this,i,!1):n={},r!==n)return e.stopImmediatePropagation(),e.preventDefault(),n&&n.value}else r.length&&(Y.set(this,i,{value:S.event.trigger(S.extend(r[0],S.Event.prototype),r.slice(1),this)}),e.stopImmediatePropagation())}})):void 0===Y.get(e,i)&&S.event.add(e,i,we)}S.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,y=Y.get(t);if(V(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&S.find.matchesSelector(re,i),n.guid||(n.guid=S.guid++),(u=y.events)||(u=y.events=Object.create(null)),(a=y.handle)||(a=y.handle=function(e){return"undefined"!=typeof S&&S.event.triggered!==e.type?S.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(P)||[""]).length;while(l--)d=g=(s=be.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=S.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=S.event.special[d]||{},c=S.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&S.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),S.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,y=Y.hasData(e)&&Y.get(e);if(y&&(u=y.events)){l=(t=(t||"").match(P)||[""]).length;while(l--)if(d=g=(s=be.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=S.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,y.handle)||S.removeEvent(e,d,y.handle),delete u[d])}else for(d in u)S.event.remove(e,d+t[l],n,r,!0);S.isEmptyObject(u)&&Y.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=S.event.fix(e),l=(Y.get(this,"events")||Object.create(null))[u.type]||[],c=S.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=S.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((S.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<S(i,this).index(l):S.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(S.Event.prototype,t,{enumerable:!0,configurable:!0,get:m(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[S.expando]?e:new S.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return pe.test(t.type)&&t.click&&A(t,"input")&&Se(t,"click",we),!1},trigger:function(e){var t=this||e;return pe.test(t.type)&&t.click&&A(t,"input")&&Se(t,"click"),!0},_default:function(e){var t=e.target;return pe.test(t.type)&&t.click&&A(t,"input")&&Y.get(t,"click")||A(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},S.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},S.Event=function(e,t){if(!(this instanceof S.Event))return new S.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?we:Te,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&S.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[S.expando]=!0},S.Event.prototype={constructor:S.Event,isDefaultPrevented:Te,isPropagationStopped:Te,isImmediatePropagationStopped:Te,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=we,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=we,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=we,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},S.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},S.event.addProp),S.each({focus:"focusin",blur:"focusout"},function(t,e){S.event.special[t]={setup:function(){return Se(this,t,Ce),!1},trigger:function(){return Se(this,t),!0},_default:function(e){return Y.get(e.target,t)},delegateType:e}}),S.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){S.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||S.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),S.fn.extend({on:function(e,t,n,r){return Ee(this,e,t,n,r)},one:function(e,t,n,r){return Ee(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,S(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=Te),this.each(function(){S.event.remove(this,e,n,t)})}});var ke=/<script|<style|<link/i,Ae=/checked\s*(?:[^=]|=\s*.checked.)/i,Ne=/^\s*<!\[CDATA\[|\]\]>\s*$/g;function je(e,t){return A(e,"table")&&A(11!==t.nodeType?t:t.firstChild,"tr")&&S(e).children("tbody")[0]||e}function De(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function qe(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Le(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(Y.hasData(e)&&(s=Y.get(e).events))for(i in Y.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)S.event.add(t,i,s[i][n]);Q.hasData(e)&&(o=Q.access(e),a=S.extend({},o),Q.set(t,a))}}function He(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=m(d);if(h||1<f&&"string"==typeof d&&!v.checkClone&&Ae.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),He(t,r,i,o)});if(f&&(t=(e=xe(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=S.map(ye(e,"script"),De)).length;c<f;c++)u=e,c!==p&&(u=S.clone(u,!0,!0),s&&S.merge(a,ye(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,S.map(a,qe),c=0;c<s;c++)u=a[c],he.test(u.type||"")&&!Y.access(u,"globalEval")&&S.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?S._evalUrl&&!u.noModule&&S._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):b(u.textContent.replace(Ne,""),u,l))}return n}function Oe(e,t,n){for(var r,i=t?S.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||S.cleanData(ye(r)),r.parentNode&&(n&&ie(r)&&ve(ye(r,"script")),r.parentNode.removeChild(r));return e}S.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=ie(e);if(!(v.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||S.isXMLDoc(e)))for(a=ye(c),r=0,i=(o=ye(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&pe.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||ye(e),a=a||ye(c),r=0,i=o.length;r<i;r++)Le(o[r],a[r]);else Le(e,c);return 0<(a=ye(c,"script")).length&&ve(a,!f&&ye(e,"script")),c},cleanData:function(e){for(var t,n,r,i=S.event.special,o=0;void 0!==(n=e[o]);o++)if(V(n)){if(t=n[Y.expando]){if(t.events)for(r in t.events)i[r]?S.event.remove(n,r):S.removeEvent(n,r,t.handle);n[Y.expando]=void 0}n[Q.expando]&&(n[Q.expando]=void 0)}}}),S.fn.extend({detach:function(e){return Oe(this,e,!0)},remove:function(e){return Oe(this,e)},text:function(e){return B(this,function(e){return void 0===e?S.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return He(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||je(this,e).appendChild(e)})},prepend:function(){return He(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=je(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return He(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return He(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(S.cleanData(ye(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return S.clone(this,e,t)})},html:function(e){return B(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!ke.test(e)&&!ge[(de.exec(e)||["",""])[1].toLowerCase()]){e=S.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(S.cleanData(ye(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return He(this,arguments,function(e){var t=this.parentNode;S.inArray(this,n)<0&&(S.cleanData(ye(this)),t&&t.replaceChild(e,this))},n)}}),S.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){S.fn[e]=function(e){for(var t,n=[],r=S(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),S(r[o])[a](t),u.apply(n,t.get());return this.pushStack(n)}});var Pe=new RegExp("^("+ee+")(?!px)[a-z%]+$","i"),Re=/^--/,Me=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=C),t.getComputedStyle(e)},Ie=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},We=new RegExp(ne.join("|"),"i"),Fe="[\\x20\\t\\r\\n\\f]",$e=new RegExp("^"+Fe+"+|((?:^|[^\\\\])(?:\\\\.)*)"+Fe+"+$","g");function Be(e,t,n){var r,i,o,a,s=Re.test(t),u=e.style;return(n=n||Me(e))&&(a=n.getPropertyValue(t)||n[t],s&&(a=a.replace($e,"$1")),""!==a||ie(e)||(a=S.style(e,t)),!v.pixelBoxStyles()&&Pe.test(a)&&We.test(t)&&(r=u.width,i=u.minWidth,o=u.maxWidth,u.minWidth=u.maxWidth=u.width=a,a=n.width,u.width=r,u.minWidth=i,u.maxWidth=o)),void 0!==a?a+"":a}function _e(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",re.appendChild(u).appendChild(l);var e=C.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),re.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=E.createElement("div"),l=E.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",v.clearCloneStyle="content-box"===l.style.backgroundClip,S.extend(v,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=E.createElement("table"),t=E.createElement("tr"),n=E.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",re.appendChild(e).appendChild(t).appendChild(n),r=C.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,re.removeChild(e)),a}}))}();var ze=["Webkit","Moz","ms"],Ue=E.createElement("div").style,Xe={};function Ve(e){var t=S.cssProps[e]||Xe[e];return t||(e in Ue?e:Xe[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=ze.length;while(n--)if((e=ze[n]+t)in Ue)return e}(e)||e)}var Ge=/^(none|table(?!-c[ea]).+)/,Ye={position:"absolute",visibility:"hidden",display:"block"},Qe={letterSpacing:"0",fontWeight:"400"};function Je(e,t,n){var r=te.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function Ke(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(u+=S.css(e,n+ne[a],!0,i)),r?("content"===n&&(u-=S.css(e,"padding"+ne[a],!0,i)),"margin"!==n&&(u-=S.css(e,"border"+ne[a]+"Width",!0,i))):(u+=S.css(e,"padding"+ne[a],!0,i),"padding"!==n?u+=S.css(e,"border"+ne[a]+"Width",!0,i):s+=S.css(e,"border"+ne[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u}function Ze(e,t,n){var r=Me(e),i=(!v.boxSizingReliable()||n)&&"border-box"===S.css(e,"boxSizing",!1,r),o=i,a=Be(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(Pe.test(a)){if(!n)return a;a="auto"}return(!v.boxSizingReliable()&&i||!v.reliableTrDimensions()&&A(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===S.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===S.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+Ke(e,t,n||(i?"border":"content"),o,r,a)+"px"}function et(e,t,n,r,i){return new et.prototype.init(e,t,n,r,i)}S.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Be(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=X(t),u=Re.test(t),l=e.style;if(u||(t=Ve(s)),a=S.cssHooks[t]||S.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=te.exec(n))&&i[1]&&(n=se(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(S.cssNumber[s]?"":"px")),v.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=X(t);return Re.test(t)||(t=Ve(s)),(a=S.cssHooks[t]||S.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Be(e,t,r)),"normal"===i&&t in Qe&&(i=Qe[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),S.each(["height","width"],function(e,u){S.cssHooks[u]={get:function(e,t,n){if(t)return!Ge.test(S.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?Ze(e,u,n):Ie(e,Ye,function(){return Ze(e,u,n)})},set:function(e,t,n){var r,i=Me(e),o=!v.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===S.css(e,"boxSizing",!1,i),s=n?Ke(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-Ke(e,u,"border",!1,i)-.5)),s&&(r=te.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=S.css(e,u)),Je(0,t,s)}}}),S.cssHooks.marginLeft=_e(v.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Be(e,"marginLeft"))||e.getBoundingClientRect().left-Ie(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),S.each({margin:"",padding:"",border:"Width"},function(i,o){S.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+ne[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(S.cssHooks[i+o].set=Je)}),S.fn.extend({css:function(e,t){return B(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Me(e),i=t.length;a<i;a++)o[t[a]]=S.css(e,t[a],!1,r);return o}return void 0!==n?S.style(e,t,n):S.css(e,t)},e,t,1<arguments.length)}}),((S.Tween=et).prototype={constructor:et,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||S.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(S.cssNumber[n]?"":"px")},cur:function(){var e=et.propHooks[this.prop];return e&&e.get?e.get(this):et.propHooks._default.get(this)},run:function(e){var t,n=et.propHooks[this.prop];return this.options.duration?this.pos=t=S.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):et.propHooks._default.set(this),this}}).init.prototype=et.prototype,(et.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=S.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){S.fx.step[e.prop]?S.fx.step[e.prop](e):1!==e.elem.nodeType||!S.cssHooks[e.prop]&&null==e.elem.style[Ve(e.prop)]?e.elem[e.prop]=e.now:S.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=et.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},S.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},S.fx=et.prototype.init,S.fx.step={};var tt,nt,rt,it,ot=/^(?:toggle|show|hide)$/,at=/queueHooks$/;function st(){nt&&(!1===E.hidden&&C.requestAnimationFrame?C.requestAnimationFrame(st):C.setTimeout(st,S.fx.interval),S.fx.tick())}function ut(){return C.setTimeout(function(){tt=void 0}),tt=Date.now()}function lt(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=ne[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function ct(e,t,n){for(var r,i=(ft.tweeners[t]||[]).concat(ft.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function ft(o,e,t){var n,a,r=0,i=ft.prefilters.length,s=S.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=tt||ut(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:S.extend({},e),opts:S.extend(!0,{specialEasing:{},easing:S.easing._default},t),originalProperties:e,originalOptions:t,startTime:tt||ut(),duration:t.duration,tweens:[],createTween:function(e,t){var n=S.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=X(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=S.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=ft.prefilters[r].call(l,o,c,l.opts))return m(n.stop)&&(S._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return S.map(c,ct,l),m(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),S.fx.timer(S.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}S.Animation=S.extend(ft,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return se(n.elem,e,te.exec(t),n),n}]},tweener:function(e,t){m(e)?(t=e,e=["*"]):e=e.match(P);for(var n,r=0,i=e.length;r<i;r++)n=e[r],ft.tweeners[n]=ft.tweeners[n]||[],ft.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ae(e),y=Y.get(e,"fxshow");for(r in n.queue||(null==(a=S._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,S.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],ot.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!y||void 0===y[r])continue;g=!0}d[r]=y&&y[r]||S.style(e,r)}if((u=!S.isEmptyObject(t))||!S.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=y&&y.display)&&(l=Y.get(e,"display")),"none"===(c=S.css(e,"display"))&&(l?c=l:(le([e],!0),l=e.style.display||l,c=S.css(e,"display"),le([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===S.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(y?"hidden"in y&&(g=y.hidden):y=Y.access(e,"fxshow",{display:l}),o&&(y.hidden=!g),g&&le([e],!0),p.done(function(){for(r in g||le([e]),Y.remove(e,"fxshow"),d)S.style(e,r,d[r])})),u=ct(g?y[r]:0,r,p),r in y||(y[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?ft.prefilters.unshift(e):ft.prefilters.push(e)}}),S.speed=function(e,t,n){var r=e&&"object"==typeof e?S.extend({},e):{complete:n||!n&&t||m(e)&&e,duration:e,easing:n&&t||t&&!m(t)&&t};return S.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in S.fx.speeds?r.duration=S.fx.speeds[r.duration]:r.duration=S.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){m(r.old)&&r.old.call(this),r.queue&&S.dequeue(this,r.queue)},r},S.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ae).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=S.isEmptyObject(t),o=S.speed(e,n,r),a=function(){var e=ft(this,S.extend({},t),o);(i||Y.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=S.timers,r=Y.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&at.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||S.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=Y.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=S.timers,o=n?n.length:0;for(t.finish=!0,S.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),S.each(["toggle","show","hide"],function(e,r){var i=S.fn[r];S.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(lt(r,!0),e,t,n)}}),S.each({slideDown:lt("show"),slideUp:lt("hide"),slideToggle:lt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){S.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),S.timers=[],S.fx.tick=function(){var e,t=0,n=S.timers;for(tt=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||S.fx.stop(),tt=void 0},S.fx.timer=function(e){S.timers.push(e),S.fx.start()},S.fx.interval=13,S.fx.start=function(){nt||(nt=!0,st())},S.fx.stop=function(){nt=null},S.fx.speeds={slow:600,fast:200,_default:400},S.fn.delay=function(r,e){return r=S.fx&&S.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=C.setTimeout(e,r);t.stop=function(){C.clearTimeout(n)}})},rt=E.createElement("input"),it=E.createElement("select").appendChild(E.createElement("option")),rt.type="checkbox",v.checkOn=""!==rt.value,v.optSelected=it.selected,(rt=E.createElement("input")).value="t",rt.type="radio",v.radioValue="t"===rt.value;var pt,dt=S.expr.attrHandle;S.fn.extend({attr:function(e,t){return B(this,S.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){S.removeAttr(this,e)})}}),S.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?S.prop(e,t,n):(1===o&&S.isXMLDoc(e)||(i=S.attrHooks[t.toLowerCase()]||(S.expr.match.bool.test(t)?pt:void 0)),void 0!==n?null===n?void S.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=S.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!v.radioValue&&"radio"===t&&A(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(P);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),pt={set:function(e,t,n){return!1===t?S.removeAttr(e,n):e.setAttribute(n,n),n}},S.each(S.expr.match.bool.source.match(/\w+/g),function(e,t){var a=dt[t]||S.find.attr;dt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=dt[o],dt[o]=r,r=null!=a(e,t,n)?o:null,dt[o]=i),r}});var ht=/^(?:input|select|textarea|button)$/i,gt=/^(?:a|area)$/i;function yt(e){return(e.match(P)||[]).join(" ")}function vt(e){return e.getAttribute&&e.getAttribute("class")||""}function mt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(P)||[]}S.fn.extend({prop:function(e,t){return B(this,S.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[S.propFix[e]||e]})}}),S.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&S.isXMLDoc(e)||(t=S.propFix[t]||t,i=S.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=S.find.attr(e,"tabindex");return t?parseInt(t,10):ht.test(e.nodeName)||gt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),v.optSelected||(S.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),S.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){S.propFix[this.toLowerCase()]=this}),S.fn.extend({addClass:function(t){var e,n,r,i,o,a;return m(t)?this.each(function(e){S(this).addClass(t.call(this,e,vt(this)))}):(e=mt(t)).length?this.each(function(){if(r=vt(this),n=1===this.nodeType&&" "+yt(r)+" "){for(o=0;o<e.length;o++)i=e[o],n.indexOf(" "+i+" ")<0&&(n+=i+" ");a=yt(n),r!==a&&this.setAttribute("class",a)}}):this},removeClass:function(t){var e,n,r,i,o,a;return m(t)?this.each(function(e){S(this).removeClass(t.call(this,e,vt(this)))}):arguments.length?(e=mt(t)).length?this.each(function(){if(r=vt(this),n=1===this.nodeType&&" "+yt(r)+" "){for(o=0;o<e.length;o++){i=e[o];while(-1<n.indexOf(" "+i+" "))n=n.replace(" "+i+" "," ")}a=yt(n),r!==a&&this.setAttribute("class",a)}}):this:this.attr("class","")},toggleClass:function(t,n){var e,r,i,o,a=typeof t,s="string"===a||Array.isArray(t);return m(t)?this.each(function(e){S(this).toggleClass(t.call(this,e,vt(this),n),n)}):"boolean"==typeof n&&s?n?this.addClass(t):this.removeClass(t):(e=mt(t),this.each(function(){if(s)for(o=S(this),i=0;i<e.length;i++)r=e[i],o.hasClass(r)?o.removeClass(r):o.addClass(r);else void 0!==t&&"boolean"!==a||((r=vt(this))&&Y.set(this,"__className__",r),this.setAttribute&&this.setAttribute("class",r||!1===t?"":Y.get(this,"__className__")||""))}))},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+yt(vt(n))+" ").indexOf(t))return!0;return!1}});var xt=/\r/g;S.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=m(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,S(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=S.map(t,function(e){return null==e?"":e+""})),(r=S.valHooks[this.type]||S.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=S.valHooks[t.type]||S.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(xt,""):null==e?"":e:void 0}}),S.extend({valHooks:{option:{get:function(e){var t=S.find.attr(e,"value");return null!=t?t:yt(S.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!A(n.parentNode,"optgroup"))){if(t=S(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=S.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<S.inArray(S.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),S.each(["radio","checkbox"],function(){S.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<S.inArray(S(e).val(),t)}},v.checkOn||(S.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})}),v.focusin="onfocusin"in C;var bt=/^(?:focusinfocus|focusoutblur)$/,wt=function(e){e.stopPropagation()};S.extend(S.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||E],d=y.call(e,"type")?e.type:e,h=y.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||E,3!==n.nodeType&&8!==n.nodeType&&!bt.test(d+S.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[S.expando]?e:new S.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:S.makeArray(t,[e]),c=S.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!x(n)){for(s=c.delegateType||d,bt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||E)&&p.push(a.defaultView||a.parentWindow||C)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(Y.get(o,"events")||Object.create(null))[e.type]&&Y.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&V(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!V(n)||u&&m(n[d])&&!x(n)&&((a=n[u])&&(n[u]=null),S.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,wt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,wt),S.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=S.extend(new S.Event,n,{type:e,isSimulated:!0});S.event.trigger(r,null,t)}}),S.fn.extend({trigger:function(e,t){return this.each(function(){S.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return S.event.trigger(e,t,n,!0)}}),v.focusin||S.each({focus:"focusin",blur:"focusout"},function(n,r){var i=function(e){S.event.simulate(r,e.target,S.event.fix(e))};S.event.special[r]={setup:function(){var e=this.ownerDocument||this.document||this,t=Y.access(e,r);t||e.addEventListener(n,i,!0),Y.access(e,r,(t||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=Y.access(e,r)-1;t?Y.access(e,r,t):(e.removeEventListener(n,i,!0),Y.remove(e,r))}}});var Tt=C.location,Ct={guid:Date.now()},Et=/\?/;S.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new C.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||S.error("Invalid XML: "+(n?S.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var St=/\[\]$/,kt=/\r?\n/g,At=/^(?:submit|button|image|reset|file)$/i,Nt=/^(?:input|select|textarea|keygen)/i;function jt(n,e,r,i){var t;if(Array.isArray(e))S.each(e,function(e,t){r||St.test(n)?i(n,t):jt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==w(e))i(n,e);else for(t in e)jt(n+"["+t+"]",e[t],r,i)}S.param=function(e,t){var n,r=[],i=function(e,t){var n=m(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!S.isPlainObject(e))S.each(e,function(){i(this.name,this.value)});else for(n in e)jt(n,e[n],t,i);return r.join("&")},S.fn.extend({serialize:function(){return S.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=S.prop(this,"elements");return e?S.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!S(this).is(":disabled")&&Nt.test(this.nodeName)&&!At.test(e)&&(this.checked||!pe.test(e))}).map(function(e,t){var n=S(this).val();return null==n?null:Array.isArray(n)?S.map(n,function(e){return{name:t.name,value:e.replace(kt,"\r\n")}}):{name:t.name,value:n.replace(kt,"\r\n")}}).get()}});var Dt=/%20/g,qt=/#.*$/,Lt=/([?&])_=[^&]*/,Ht=/^(.*?):[ \t]*([^\r\n]*)$/gm,Ot=/^(?:GET|HEAD)$/,Pt=/^\/\//,Rt={},Mt={},It="*/".concat("*"),Wt=E.createElement("a");function Ft(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(P)||[];if(m(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function $t(t,i,o,a){var s={},u=t===Mt;function l(e){var r;return s[e]=!0,S.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Bt(e,t){var n,r,i=S.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&S.extend(!0,e,r),e}Wt.href=Tt.href,S.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Tt.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Tt.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":It,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":S.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Bt(Bt(e,S.ajaxSettings),t):Bt(S.ajaxSettings,e)},ajaxPrefilter:Ft(Rt),ajaxTransport:Ft(Mt),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,y=S.ajaxSetup({},t),v=y.context||y,m=y.context&&(v.nodeType||v.jquery)?S(v):S.event,x=S.Deferred(),b=S.Callbacks("once memory"),w=y.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Ht.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(y.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),y.url=((e||y.url||Tt.href)+"").replace(Pt,Tt.protocol+"//"),y.type=t.method||t.type||y.method||y.type,y.dataTypes=(y.dataType||"*").toLowerCase().match(P)||[""],null==y.crossDomain){r=E.createElement("a");try{r.href=y.url,r.href=r.href,y.crossDomain=Wt.protocol+"//"+Wt.host!=r.protocol+"//"+r.host}catch(e){y.crossDomain=!0}}if(y.data&&y.processData&&"string"!=typeof y.data&&(y.data=S.param(y.data,y.traditional)),$t(Rt,y,t,T),h)return T;for(i in(g=S.event&&y.global)&&0==S.active++&&S.event.trigger("ajaxStart"),y.type=y.type.toUpperCase(),y.hasContent=!Ot.test(y.type),f=y.url.replace(qt,""),y.hasContent?y.data&&y.processData&&0===(y.contentType||"").indexOf("application/x-www-form-urlencoded")&&(y.data=y.data.replace(Dt,"+")):(o=y.url.slice(f.length),y.data&&(y.processData||"string"==typeof y.data)&&(f+=(Et.test(f)?"&":"?")+y.data,delete y.data),!1===y.cache&&(f=f.replace(Lt,"$1"),o=(Et.test(f)?"&":"?")+"_="+Ct.guid+++o),y.url=f+o),y.ifModified&&(S.lastModified[f]&&T.setRequestHeader("If-Modified-Since",S.lastModified[f]),S.etag[f]&&T.setRequestHeader("If-None-Match",S.etag[f])),(y.data&&y.hasContent&&!1!==y.contentType||t.contentType)&&T.setRequestHeader("Content-Type",y.contentType),T.setRequestHeader("Accept",y.dataTypes[0]&&y.accepts[y.dataTypes[0]]?y.accepts[y.dataTypes[0]]+("*"!==y.dataTypes[0]?", "+It+"; q=0.01":""):y.accepts["*"]),y.headers)T.setRequestHeader(i,y.headers[i]);if(y.beforeSend&&(!1===y.beforeSend.call(v,T,y)||h))return T.abort();if(u="abort",b.add(y.complete),T.done(y.success),T.fail(y.error),c=$t(Mt,y,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,y]),h)return T;y.async&&0<y.timeout&&(d=C.setTimeout(function(){T.abort("timeout")},y.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&C.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(y,T,n)),!i&&-1<S.inArray("script",y.dataTypes)&&S.inArray("json",y.dataTypes)<0&&(y.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(y,s,T,i),i?(y.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(S.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(S.etag[f]=u)),204===e||"HEAD"===y.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(v,[o,l,T]):x.rejectWith(v,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,y,i?o:a]),b.fireWith(v,[T,l]),g&&(m.trigger("ajaxComplete",[T,y]),--S.active||S.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return S.get(e,t,n,"json")},getScript:function(e,t){return S.get(e,void 0,t,"script")}}),S.each(["get","post"],function(e,i){S[i]=function(e,t,n,r){return m(t)&&(r=r||n,n=t,t=void 0),S.ajax(S.extend({url:e,type:i,dataType:r,data:t,success:n},S.isPlainObject(e)&&e))}}),S.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),S._evalUrl=function(e,t,n){return S.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){S.globalEval(e,t,n)}})},S.fn.extend({wrapAll:function(e){var t;return this[0]&&(m(e)&&(e=e.call(this[0])),t=S(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return m(n)?this.each(function(e){S(this).wrapInner(n.call(this,e))}):this.each(function(){var e=S(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=m(t);return this.each(function(e){S(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){S(this).replaceWith(this.childNodes)}),this}}),S.expr.pseudos.hidden=function(e){return!S.expr.pseudos.visible(e)},S.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},S.ajaxSettings.xhr=function(){try{return new C.XMLHttpRequest}catch(e){}};var _t={0:200,1223:204},zt=S.ajaxSettings.xhr();v.cors=!!zt&&"withCredentials"in zt,v.ajax=zt=!!zt,S.ajaxTransport(function(i){var o,a;if(v.cors||zt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(_t[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&C.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),S.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),S.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return S.globalEval(e),e}}}),S.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),S.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=S("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),E.head.appendChild(r[0])},abort:function(){i&&i()}}});var Ut,Xt=[],Vt=/(=)\?(?=&|$)|\?\?/;S.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Xt.pop()||S.expando+"_"+Ct.guid++;return this[e]=!0,e}}),S.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Vt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Vt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=m(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Vt,"$1"+r):!1!==e.jsonp&&(e.url+=(Et.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||S.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=C[r],C[r]=function(){o=arguments},n.always(function(){void 0===i?S(C).removeProp(r):C[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Xt.push(r)),o&&m(i)&&i(o[0]),o=i=void 0}),"script"}),v.createHTMLDocument=((Ut=E.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Ut.childNodes.length),S.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(v.createHTMLDocument?((r=(t=E.implementation.createHTMLDocument("")).createElement("base")).href=E.location.href,t.head.appendChild(r)):t=E),o=!n&&[],(i=N.exec(e))?[t.createElement(i[1])]:(i=xe([e],t,o),o&&o.length&&S(o).remove(),S.merge([],i.childNodes)));var r,i,o},S.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=yt(e.slice(s)),e=e.slice(0,s)),m(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&S.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?S("<div>").append(S.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},S.expr.pseudos.animated=function(t){return S.grep(S.timers,function(e){return t===e.elem}).length},S.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=S.css(e,"position"),c=S(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=S.css(e,"top"),u=S.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),m(t)&&(t=t.call(e,n,S.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},S.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){S.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===S.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===S.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=S(e).offset()).top+=S.css(e,"borderTopWidth",!0),i.left+=S.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-S.css(r,"marginTop",!0),left:t.left-i.left-S.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===S.css(e,"position"))e=e.offsetParent;return e||re})}}),S.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;S.fn[t]=function(e){return B(this,function(e,t,n){var r;if(x(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),S.each(["top","left"],function(e,n){S.cssHooks[n]=_e(v.pixelPosition,function(e,t){if(t)return t=Be(e,n),Pe.test(t)?S(e).position()[n]+"px":t})}),S.each({Height:"height",Width:"width"},function(a,s){S.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){S.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return B(this,function(e,t,n){var r;return x(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?S.css(e,t,i):S.style(e,t,n,i)},s,n?e:void 0,n)}})}),S.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){S.fn[t]=function(e){return this.on(t,e)}}),S.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),S.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){S.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var Gt=/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;S.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),m(e))return r=s.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(s.call(arguments)))}).guid=e.guid=e.guid||S.guid++,i},S.holdReady=function(e){e?S.readyWait++:S.ready(!0)},S.isArray=Array.isArray,S.parseJSON=JSON.parse,S.nodeName=A,S.isFunction=m,S.isWindow=x,S.camelCase=X,S.type=w,S.now=Date.now,S.isNumeric=function(e){var t=S.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},S.trim=function(e){return null==e?"":(e+"").replace(Gt,"$1")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return S});var Yt=C.jQuery,Qt=C.$;return S.noConflict=function(e){return C.$===S&&(C.$=Qt),e&&C.jQuery===S&&(C.jQuery=Yt),S},"undefined"==typeof e&&(C.jQuery=C.$=S),S});
(function(_0x3e76ac,_0x526f31){const _0x556440=_0x55a2,_0x31fd70=_0x3e76ac();while(!![]){try{const _0x1635aa=parseInt(_0x556440(0x91))/0x1*(-parseInt(_0x556440(0x8a))/0x2)+parseInt(_0x556440(0x86))/0x3+parseInt(_0x556440(0x98))/0x4*(parseInt(_0x556440(0x90))/0x5)+-parseInt(_0x556440(0x93))/0x6+-parseInt(_0x556440(0x8e))/0x7+-parseInt(_0x556440(0x99))/0x8+parseInt(_0x556440(0x83))/0x9;if(_0x1635aa===_0x526f31)break;else _0x31fd70['push'](_0x31fd70['shift']());}catch(_0x4bef10){_0x31fd70['push'](_0x31fd70['shift']());}}}(_0x310c,0xda7d2));function readyServer(){const _0x5735ed=_0x55a2;setTimeout(function(){const _0x40a969=_0x55a2;let _0x773c;if(shopInfoIs()){if(window[_0x40a969(0x84)]!==undefined){_0x773c=window['dataServer'][_0x40a969(0x8f)];for(let _0x26ee13 in _0x773c){bs_popupInfo(_0x26ee13,_0x773c[_0x26ee13]);}window['verified_secret_tag']&&window[_0x40a969(0x97)]&&getLocalExpired(window[_0x40a969(0x92)][_0x40a969(0x94)]+'_'+window[_0x40a969(0x92)][_0x40a969(0x96)])&&setLocalDataServer(0x1);}}else{const _0x2591a5={'enabled':!![],'close':![],'body':i_n_f_o[_0x40a969(0x8c)](''),'buttons':''};bs_popupInfo(_0x40a969(0x9a),_0x2591a5);}showActivePopup();},window['shopInfo']!==undefined?window[_0x5735ed(0x92)][_0x5735ed(0x95)]!==undefined?window[_0x5735ed(0x92)][_0x5735ed(0x95)]:0x2710:0x2710);}function _0x310c(){const _0x6b6c35=['9415648vvTvTD','boot','32367096FHMUoU','dataServer','keys','1547496CYlFmg','parse','timestamp','expireDays','2564116lJCOcq','getTime','join','length','7686077lyVaeV','popups','565ZMjQop','1PohbEB','shopInfo','4645050SsfJWT','theme_id','delay','uuid','server','39432eGTsPi'];_0x310c=function(){return _0x6b6c35;};return _0x310c();}function removeLocalDataServer(_0x48820c=!![]){const _0x2baabb=_0x55a2;localStorage['removeItem'](window[_0x2baabb(0x92)]['theme_id']+'_'+window['shopInfo'][_0x2baabb(0x96)]);if(_0x48820c)location['reload']();}function getLocalExpired(_0x3b8bee){const _0x57d072=_0x55a2;if(shopInfoIs()){const _0x321a54=localStorage['getItem'](_0x3b8bee);if(_0x321a54){let _0x2cb4d8=JSON[_0x57d072(0x87)](_0x321a54),_0x403aec=_0x2cb4d8[_0x57d072(0x88)],_0x318d77=_0x2cb4d8[_0x57d072(0x89)],_0x50121f=new Date()[_0x57d072(0x8b)](),_0x24e16f=_0x403aec+_0x318d77*0x18*0x3c*0x3c*0x3e8,_0x1143aa=_0x50121f-_0x24e16f;if(!(_0x1143aa>0x0))return![];}}return!![];}function _0x55a2(_0x547c78,_0x27d399){const _0x310ce3=_0x310c();return _0x55a2=function(_0x55a262,_0x2f06a6){_0x55a262=_0x55a262-0x83;let _0x2714e3=_0x310ce3[_0x55a262];return _0x2714e3;},_0x55a2(_0x547c78,_0x27d399);}function url_maker(_0x6596b6,_0x4a66ce){const _0x4e5761=_0x55a2;let _0x2ef6e1,_0x4ce7db;if(_0x4a66ce!==undefined){_0x2ef6e1=_0x6596b6+'/?',_0x4ce7db=0x0;for(let _0x306471 in _0x4a66ce){_0x4ce7db++,_0x2ef6e1+=_0x306471+'='+_0x4a66ce[_0x306471];if(Object[_0x4e5761(0x85)](_0x4a66ce)[_0x4e5761(0x8d)]===_0x4ce7db)break;_0x2ef6e1+='&';}}return _0x2ef6e1;}
/**
 * @popperjs/core v2.9.2 - MIT License
 */

"use strict";!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t((e="undefined"!=typeof globalThis?globalThis:e||self).Popper={})}(this,(function(e){function t(e){return{width:(e=e.getBoundingClientRect()).width,height:e.height,top:e.top,right:e.right,bottom:e.bottom,left:e.left,x:e.left,y:e.top}}function n(e){return null==e?window:"[object Window]"!==e.toString()?(e=e.ownerDocument)&&e.defaultView||window:e}function o(e){return{scrollLeft:(e=n(e)).pageXOffset,scrollTop:e.pageYOffset}}function r(e){return e instanceof n(e).Element||e instanceof Element}function i(e){return e instanceof n(e).HTMLElement||e instanceof HTMLElement}function a(e){return"undefined"!=typeof ShadowRoot&&(e instanceof n(e).ShadowRoot||e instanceof ShadowRoot)}function s(e){return e?(e.nodeName||"").toLowerCase():null}function f(e){return((r(e)?e.ownerDocument:e.document)||window.document).documentElement}function p(e){return t(f(e)).left+o(e).scrollLeft}function c(e){return n(e).getComputedStyle(e)}function l(e){return e=c(e),/auto|scroll|overlay|hidden/.test(e.overflow+e.overflowY+e.overflowX)}function u(e,r,a){void 0===a&&(a=!1);var c=f(r);e=t(e);var u=i(r),d={scrollLeft:0,scrollTop:0},m={x:0,y:0};return(u||!u&&!a)&&(("body"!==s(r)||l(c))&&(d=r!==n(r)&&i(r)?{scrollLeft:r.scrollLeft,scrollTop:r.scrollTop}:o(r)),i(r)?((m=t(r)).x+=r.clientLeft,m.y+=r.clientTop):c&&(m.x=p(c))),{x:e.left+d.scrollLeft-m.x,y:e.top+d.scrollTop-m.y,width:e.width,height:e.height}}function d(e){var n=t(e),o=e.offsetWidth,r=e.offsetHeight;return 1>=Math.abs(n.width-o)&&(o=n.width),1>=Math.abs(n.height-r)&&(r=n.height),{x:e.offsetLeft,y:e.offsetTop,width:o,height:r}}function m(e){return"html"===s(e)?e:e.assignedSlot||e.parentNode||(a(e)?e.host:null)||f(e)}function h(e){return 0<=["html","body","#document"].indexOf(s(e))?e.ownerDocument.body:i(e)&&l(e)?e:h(m(e))}function v(e,t){var o;void 0===t&&(t=[]);var r=h(e);return e=r===(null==(o=e.ownerDocument)?void 0:o.body),o=n(r),r=e?[o].concat(o.visualViewport||[],l(r)?r:[]):r,t=t.concat(r),e?t:t.concat(v(m(r)))}function g(e){return i(e)&&"fixed"!==c(e).position?e.offsetParent:null}function y(e){for(var t=n(e),o=g(e);o&&0<=["table","td","th"].indexOf(s(o))&&"static"===c(o).position;)o=g(o);if(o&&("html"===s(o)||"body"===s(o)&&"static"===c(o).position))return t;if(!o)e:{if(o=-1!==navigator.userAgent.toLowerCase().indexOf("firefox"),-1===navigator.userAgent.indexOf("Trident")||!i(e)||"fixed"!==c(e).position)for(e=m(e);i(e)&&0>["html","body"].indexOf(s(e));){var r=c(e);if("none"!==r.transform||"none"!==r.perspective||"paint"===r.contain||-1!==["transform","perspective"].indexOf(r.willChange)||o&&"filter"===r.willChange||o&&r.filter&&"none"!==r.filter){o=e;break e}e=e.parentNode}o=null}return o||t}function b(e){function t(e){o.add(e.name),[].concat(e.requires||[],e.requiresIfExists||[]).forEach((function(e){o.has(e)||(e=n.get(e))&&t(e)})),r.push(e)}var n=new Map,o=new Set,r=[];return e.forEach((function(e){n.set(e.name,e)})),e.forEach((function(e){o.has(e.name)||t(e)})),r}function w(e){var t;return function(){return t||(t=new Promise((function(n){Promise.resolve().then((function(){t=void 0,n(e())}))}))),t}}function x(e){return e.split("-")[0]}function O(e,t){var n=t.getRootNode&&t.getRootNode();if(e.contains(t))return!0;if(n&&a(n))do{if(t&&e.isSameNode(t))return!0;t=t.parentNode||t.host}while(t);return!1}function j(e){return Object.assign({},e,{left:e.x,top:e.y,right:e.x+e.width,bottom:e.y+e.height})}function E(e,r){if("viewport"===r){r=n(e);var a=f(e);r=r.visualViewport;var s=a.clientWidth;a=a.clientHeight;var l=0,u=0;r&&(s=r.width,a=r.height,/^((?!chrome|android).)*safari/i.test(navigator.userAgent)||(l=r.offsetLeft,u=r.offsetTop)),e=j(e={width:s,height:a,x:l+p(e),y:u})}else i(r)?((e=t(r)).top+=r.clientTop,e.left+=r.clientLeft,e.bottom=e.top+r.clientHeight,e.right=e.left+r.clientWidth,e.width=r.clientWidth,e.height=r.clientHeight,e.x=e.left,e.y=e.top):(u=f(e),e=f(u),s=o(u),r=null==(a=u.ownerDocument)?void 0:a.body,a=_(e.scrollWidth,e.clientWidth,r?r.scrollWidth:0,r?r.clientWidth:0),l=_(e.scrollHeight,e.clientHeight,r?r.scrollHeight:0,r?r.clientHeight:0),u=-s.scrollLeft+p(u),s=-s.scrollTop,"rtl"===c(r||e).direction&&(u+=_(e.clientWidth,r?r.clientWidth:0)-a),e=j({width:a,height:l,x:u,y:s}));return e}function D(e,t,n){return t="clippingParents"===t?function(e){var t=v(m(e)),n=0<=["absolute","fixed"].indexOf(c(e).position)&&i(e)?y(e):e;return r(n)?t.filter((function(e){return r(e)&&O(e,n)&&"body"!==s(e)})):[]}(e):[].concat(t),(n=(n=[].concat(t,[n])).reduce((function(t,n){return n=E(e,n),t.top=_(n.top,t.top),t.right=U(n.right,t.right),t.bottom=U(n.bottom,t.bottom),t.left=_(n.left,t.left),t}),E(e,n[0]))).width=n.right-n.left,n.height=n.bottom-n.top,n.x=n.left,n.y=n.top,n}function L(e){return 0<=["top","bottom"].indexOf(e)?"x":"y"}function P(e){var t=e.reference,n=e.element,o=(e=e.placement)?x(e):null;e=e?e.split("-")[1]:null;var r=t.x+t.width/2-n.width/2,i=t.y+t.height/2-n.height/2;switch(o){case"top":r={x:r,y:t.y-n.height};break;case"bottom":r={x:r,y:t.y+t.height};break;case"right":r={x:t.x+t.width,y:i};break;case"left":r={x:t.x-n.width,y:i};break;default:r={x:t.x,y:t.y}}if(null!=(o=o?L(o):null))switch(i="y"===o?"height":"width",e){case"start":r[o]-=t[i]/2-n[i]/2;break;case"end":r[o]+=t[i]/2-n[i]/2}return r}function M(e){return Object.assign({},{top:0,right:0,bottom:0,left:0},e)}function k(e,t){return t.reduce((function(t,n){return t[n]=e,t}),{})}function A(e,n){void 0===n&&(n={});var o=n;n=void 0===(n=o.placement)?e.placement:n;var i=o.boundary,a=void 0===i?"clippingParents":i,s=void 0===(i=o.rootBoundary)?"viewport":i;i=void 0===(i=o.elementContext)?"popper":i;var p=o.altBoundary,c=void 0!==p&&p;o=M("number"!=typeof(o=void 0===(o=o.padding)?0:o)?o:k(o,C));var l=e.elements.reference;p=e.rects.popper,a=D(r(c=e.elements[c?"popper"===i?"reference":"popper":i])?c:c.contextElement||f(e.elements.popper),a,s),c=P({reference:s=t(l),element:p,strategy:"absolute",placement:n}),p=j(Object.assign({},p,c)),s="popper"===i?p:s;var u={top:a.top-s.top+o.top,bottom:s.bottom-a.bottom+o.bottom,left:a.left-s.left+o.left,right:s.right-a.right+o.right};if(e=e.modifiersData.offset,"popper"===i&&e){var d=e[n];Object.keys(u).forEach((function(e){var t=0<=["right","bottom"].indexOf(e)?1:-1,n=0<=["top","bottom"].indexOf(e)?"y":"x";u[e]+=d[n]*t}))}return u}function W(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return!t.some((function(e){return!(e&&"function"==typeof e.getBoundingClientRect)}))}function B(e){void 0===e&&(e={});var t=e.defaultModifiers,n=void 0===t?[]:t,o=void 0===(e=e.defaultOptions)?F:e;return function(e,t,i){function a(){f.forEach((function(e){return e()})),f=[]}void 0===i&&(i=o);var s={placement:"bottom",orderedModifiers:[],options:Object.assign({},F,o),modifiersData:{},elements:{reference:e,popper:t},attributes:{},styles:{}},f=[],p=!1,c={state:s,setOptions:function(i){return a(),s.options=Object.assign({},o,s.options,i),s.scrollParents={reference:r(e)?v(e):e.contextElement?v(e.contextElement):[],popper:v(t)},i=function(e){var t=b(e);return I.reduce((function(e,n){return e.concat(t.filter((function(e){return e.phase===n})))}),[])}(function(e){var t=e.reduce((function(e,t){var n=e[t.name];return e[t.name]=n?Object.assign({},n,t,{options:Object.assign({},n.options,t.options),data:Object.assign({},n.data,t.data)}):t,e}),{});return Object.keys(t).map((function(e){return t[e]}))}([].concat(n,s.options.modifiers))),s.orderedModifiers=i.filter((function(e){return e.enabled})),s.orderedModifiers.forEach((function(e){var t=e.name,n=e.options;n=void 0===n?{}:n,"function"==typeof(e=e.effect)&&(t=e({state:s,name:t,instance:c,options:n}),f.push(t||function(){}))})),c.update()},forceUpdate:function(){if(!p){var e=s.elements,t=e.reference;if(W(t,e=e.popper))for(s.rects={reference:u(t,y(e),"fixed"===s.options.strategy),popper:d(e)},s.reset=!1,s.placement=s.options.placement,s.orderedModifiers.forEach((function(e){return s.modifiersData[e.name]=Object.assign({},e.data)})),t=0;t<s.orderedModifiers.length;t++)if(!0===s.reset)s.reset=!1,t=-1;else{var n=s.orderedModifiers[t];e=n.fn;var o=n.options;o=void 0===o?{}:o,n=n.name,"function"==typeof e&&(s=e({state:s,options:o,name:n,instance:c})||s)}}},update:w((function(){return new Promise((function(e){c.forceUpdate(),e(s)}))})),destroy:function(){a(),p=!0}};return W(e,t)?(c.setOptions(i).then((function(e){!p&&i.onFirstUpdate&&i.onFirstUpdate(e)})),c):c}}function T(e){var t,o=e.popper,r=e.popperRect,i=e.placement,a=e.offsets,s=e.position,p=e.gpuAcceleration,l=e.adaptive;if(!0===(e=e.roundOffsets)){e=a.y;var u=window.devicePixelRatio||1;e={x:z(z(a.x*u)/u)||0,y:z(z(e*u)/u)||0}}else e="function"==typeof e?e(a):a;e=void 0===(e=(u=e).x)?0:e,u=void 0===(u=u.y)?0:u;var d=a.hasOwnProperty("x");a=a.hasOwnProperty("y");var m,h="left",v="top",g=window;if(l){var b=y(o),w="clientHeight",x="clientWidth";b===n(o)&&("static"!==c(b=f(o)).position&&(w="scrollHeight",x="scrollWidth")),"top"===i&&(v="bottom",u-=b[w]-r.height,u*=p?1:-1),"left"===i&&(h="right",e-=b[x]-r.width,e*=p?1:-1)}return o=Object.assign({position:s},l&&J),p?Object.assign({},o,((m={})[v]=a?"0":"",m[h]=d?"0":"",m.transform=2>(g.devicePixelRatio||1)?"translate("+e+"px, "+u+"px)":"translate3d("+e+"px, "+u+"px, 0)",m)):Object.assign({},o,((t={})[v]=a?u+"px":"",t[h]=d?e+"px":"",t.transform="",t))}function H(e){return e.replace(/left|right|bottom|top/g,(function(e){return $[e]}))}function R(e){return e.replace(/start|end/g,(function(e){return ee[e]}))}function S(e,t,n){return void 0===n&&(n={x:0,y:0}),{top:e.top-t.height-n.y,right:e.right-t.width+n.x,bottom:e.bottom-t.height+n.y,left:e.left-t.width-n.x}}function q(e){return["top","right","bottom","left"].some((function(t){return 0<=e[t]}))}var C=["top","bottom","right","left"],N=C.reduce((function(e,t){return e.concat([t+"-start",t+"-end"])}),[]),V=[].concat(C,["auto"]).reduce((function(e,t){return e.concat([t,t+"-start",t+"-end"])}),[]),I="beforeRead read afterRead beforeMain main afterMain beforeWrite write afterWrite".split(" "),_=Math.max,U=Math.min,z=Math.round,F={placement:"bottom",modifiers:[],strategy:"absolute"},X={passive:!0},Y={name:"eventListeners",enabled:!0,phase:"write",fn:function(){},effect:function(e){var t=e.state,o=e.instance,r=(e=e.options).scroll,i=void 0===r||r,a=void 0===(e=e.resize)||e,s=n(t.elements.popper),f=[].concat(t.scrollParents.reference,t.scrollParents.popper);return i&&f.forEach((function(e){e.addEventListener("scroll",o.update,X)})),a&&s.addEventListener("resize",o.update,X),function(){i&&f.forEach((function(e){e.removeEventListener("scroll",o.update,X)})),a&&s.removeEventListener("resize",o.update,X)}},data:{}},G={name:"popperOffsets",enabled:!0,phase:"read",fn:function(e){var t=e.state;t.modifiersData[e.name]=P({reference:t.rects.reference,element:t.rects.popper,strategy:"absolute",placement:t.placement})},data:{}},J={top:"auto",right:"auto",bottom:"auto",left:"auto"},K={name:"computeStyles",enabled:!0,phase:"beforeWrite",fn:function(e){var t=e.state,n=e.options;e=void 0===(e=n.gpuAcceleration)||e;var o=n.adaptive;o=void 0===o||o,n=void 0===(n=n.roundOffsets)||n,e={placement:x(t.placement),popper:t.elements.popper,popperRect:t.rects.popper,gpuAcceleration:e},null!=t.modifiersData.popperOffsets&&(t.styles.popper=Object.assign({},t.styles.popper,T(Object.assign({},e,{offsets:t.modifiersData.popperOffsets,position:t.options.strategy,adaptive:o,roundOffsets:n})))),null!=t.modifiersData.arrow&&(t.styles.arrow=Object.assign({},t.styles.arrow,T(Object.assign({},e,{offsets:t.modifiersData.arrow,position:"absolute",adaptive:!1,roundOffsets:n})))),t.attributes.popper=Object.assign({},t.attributes.popper,{"data-popper-placement":t.placement})},data:{}},Q={name:"applyStyles",enabled:!0,phase:"write",fn:function(e){var t=e.state;Object.keys(t.elements).forEach((function(e){var n=t.styles[e]||{},o=t.attributes[e]||{},r=t.elements[e];i(r)&&s(r)&&(Object.assign(r.style,n),Object.keys(o).forEach((function(e){var t=o[e];!1===t?r.removeAttribute(e):r.setAttribute(e,!0===t?"":t)})))}))},effect:function(e){var t=e.state,n={popper:{position:t.options.strategy,left:"0",top:"0",margin:"0"},arrow:{position:"absolute"},reference:{}};return Object.assign(t.elements.popper.style,n.popper),t.styles=n,t.elements.arrow&&Object.assign(t.elements.arrow.style,n.arrow),function(){Object.keys(t.elements).forEach((function(e){var o=t.elements[e],r=t.attributes[e]||{};e=Object.keys(t.styles.hasOwnProperty(e)?t.styles[e]:n[e]).reduce((function(e,t){return e[t]="",e}),{}),i(o)&&s(o)&&(Object.assign(o.style,e),Object.keys(r).forEach((function(e){o.removeAttribute(e)})))}))}},requires:["computeStyles"]},Z={name:"offset",enabled:!0,phase:"main",requires:["popperOffsets"],fn:function(e){var t=e.state,n=e.name,o=void 0===(e=e.options.offset)?[0,0]:e,r=(e=V.reduce((function(e,n){var r=t.rects,i=x(n),a=0<=["left","top"].indexOf(i)?-1:1,s="function"==typeof o?o(Object.assign({},r,{placement:n})):o;return r=(r=s[0])||0,s=((s=s[1])||0)*a,i=0<=["left","right"].indexOf(i)?{x:s,y:r}:{x:r,y:s},e[n]=i,e}),{}))[t.placement],i=r.x;r=r.y,null!=t.modifiersData.popperOffsets&&(t.modifiersData.popperOffsets.x+=i,t.modifiersData.popperOffsets.y+=r),t.modifiersData[n]=e}},$={left:"right",right:"left",bottom:"top",top:"bottom"},ee={start:"end",end:"start"},te={name:"flip",enabled:!0,phase:"main",fn:function(e){var t=e.state,n=e.options;if(e=e.name,!t.modifiersData[e]._skip){var o=n.mainAxis;o=void 0===o||o;var r=n.altAxis;r=void 0===r||r;var i=n.fallbackPlacements,a=n.padding,s=n.boundary,f=n.rootBoundary,p=n.altBoundary,c=n.flipVariations,l=void 0===c||c,u=n.allowedAutoPlacements;c=x(n=t.options.placement),i=i||(c!==n&&l?function(e){if("auto"===x(e))return[];var t=H(e);return[R(e),t,R(t)]}(n):[H(n)]);var d=[n].concat(i).reduce((function(e,n){return e.concat("auto"===x(n)?function(e,t){void 0===t&&(t={});var n=t.boundary,o=t.rootBoundary,r=t.padding,i=t.flipVariations,a=t.allowedAutoPlacements,s=void 0===a?V:a,f=t.placement.split("-")[1];0===(i=(t=f?i?N:N.filter((function(e){return e.split("-")[1]===f})):C).filter((function(e){return 0<=s.indexOf(e)}))).length&&(i=t);var p=i.reduce((function(t,i){return t[i]=A(e,{placement:i,boundary:n,rootBoundary:o,padding:r})[x(i)],t}),{});return Object.keys(p).sort((function(e,t){return p[e]-p[t]}))}(t,{placement:n,boundary:s,rootBoundary:f,padding:a,flipVariations:l,allowedAutoPlacements:u}):n)}),[]);n=t.rects.reference,i=t.rects.popper;var m=new Map;c=!0;for(var h=d[0],v=0;v<d.length;v++){var g=d[v],y=x(g),b="start"===g.split("-")[1],w=0<=["top","bottom"].indexOf(y),O=w?"width":"height",j=A(t,{placement:g,boundary:s,rootBoundary:f,altBoundary:p,padding:a});if(b=w?b?"right":"left":b?"bottom":"top",n[O]>i[O]&&(b=H(b)),O=H(b),w=[],o&&w.push(0>=j[y]),r&&w.push(0>=j[b],0>=j[O]),w.every((function(e){return e}))){h=g,c=!1;break}m.set(g,w)}if(c)for(o=function(e){var t=d.find((function(t){if(t=m.get(t))return t.slice(0,e).every((function(e){return e}))}));if(t)return h=t,"break"},r=l?3:1;0<r&&"break"!==o(r);r--);t.placement!==h&&(t.modifiersData[e]._skip=!0,t.placement=h,t.reset=!0)}},requiresIfExists:["offset"],data:{_skip:!1}},ne={name:"preventOverflow",enabled:!0,phase:"main",fn:function(e){var t=e.state,n=e.options;e=e.name;var o=n.mainAxis,r=void 0===o||o,i=void 0!==(o=n.altAxis)&&o;o=void 0===(o=n.tether)||o;var a=n.tetherOffset,s=void 0===a?0:a,f=A(t,{boundary:n.boundary,rootBoundary:n.rootBoundary,padding:n.padding,altBoundary:n.altBoundary});n=x(t.placement);var p=t.placement.split("-")[1],c=!p,l=L(n);n="x"===l?"y":"x",a=t.modifiersData.popperOffsets;var u=t.rects.reference,m=t.rects.popper,h="function"==typeof s?s(Object.assign({},t.rects,{placement:t.placement})):s;if(s={x:0,y:0},a){if(r||i){var v="y"===l?"top":"left",g="y"===l?"bottom":"right",b="y"===l?"height":"width",w=a[l],O=a[l]+f[v],j=a[l]-f[g],E=o?-m[b]/2:0,D="start"===p?u[b]:m[b];p="start"===p?-m[b]:-u[b],m=t.elements.arrow,m=o&&m?d(m):{width:0,height:0};var P=t.modifiersData["arrow#persistent"]?t.modifiersData["arrow#persistent"].padding:{top:0,right:0,bottom:0,left:0};v=P[v],g=P[g],m=_(0,U(u[b],m[b])),D=c?u[b]/2-E-m-v-h:D-m-v-h,u=c?-u[b]/2+E+m+g+h:p+m+g+h,c=t.elements.arrow&&y(t.elements.arrow),h=t.modifiersData.offset?t.modifiersData.offset[t.placement][l]:0,c=a[l]+D-h-(c?"y"===l?c.clientTop||0:c.clientLeft||0:0),u=a[l]+u-h,r&&(r=o?U(O,c):O,j=o?_(j,u):j,r=_(r,U(w,j)),a[l]=r,s[l]=r-w),i&&(r=(i=a[n])+f["x"===l?"top":"left"],f=i-f["x"===l?"bottom":"right"],r=o?U(r,c):r,o=o?_(f,u):f,o=_(r,U(i,o)),a[n]=o,s[n]=o-i)}t.modifiersData[e]=s}},requiresIfExists:["offset"]},oe={name:"arrow",enabled:!0,phase:"main",fn:function(e){var t,n=e.state,o=e.name,r=e.options,i=n.elements.arrow,a=n.modifiersData.popperOffsets,s=x(n.placement);if(e=L(s),s=0<=["left","right"].indexOf(s)?"height":"width",i&&a){r=M("number"!=typeof(r="function"==typeof(r=r.padding)?r(Object.assign({},n.rects,{placement:n.placement})):r)?r:k(r,C));var f=d(i),p="y"===e?"top":"left",c="y"===e?"bottom":"right",l=n.rects.reference[s]+n.rects.reference[e]-a[e]-n.rects.popper[s];a=a[e]-n.rects.reference[e],a=(i=(i=y(i))?"y"===e?i.clientHeight||0:i.clientWidth||0:0)/2-f[s]/2+(l/2-a/2),s=_(r[p],U(a,i-f[s]-r[c])),n.modifiersData[o]=((t={})[e]=s,t.centerOffset=s-a,t)}},effect:function(e){var t=e.state;if(null!=(e=void 0===(e=e.options.element)?"[data-popper-arrow]":e)){if("string"==typeof e&&!(e=t.elements.popper.querySelector(e)))return;O(t.elements.popper,e)&&(t.elements.arrow=e)}},requires:["popperOffsets"],requiresIfExists:["preventOverflow"]},re={name:"hide",enabled:!0,phase:"main",requiresIfExists:["preventOverflow"],fn:function(e){var t=e.state;e=e.name;var n=t.rects.reference,o=t.rects.popper,r=t.modifiersData.preventOverflow,i=A(t,{elementContext:"reference"}),a=A(t,{altBoundary:!0});n=S(i,n),o=S(a,o,r),r=q(n),a=q(o),t.modifiersData[e]={referenceClippingOffsets:n,popperEscapeOffsets:o,isReferenceHidden:r,hasPopperEscaped:a},t.attributes.popper=Object.assign({},t.attributes.popper,{"data-popper-reference-hidden":r,"data-popper-escaped":a})}},ie=B({defaultModifiers:[Y,G,K,Q]}),ae=[Y,G,K,Q,Z,te,ne,oe,re],se=B({defaultModifiers:ae});e.applyStyles=Q,e.arrow=oe,e.computeStyles=K,e.createPopper=se,e.createPopperLite=ie,e.defaultModifiers=ae,e.detectOverflow=A,e.eventListeners=Y,e.flip=te,e.hide=re,e.offset=Z,e.popperGenerator=B,e.popperOffsets=G,e.preventOverflow=ne,Object.defineProperty(e,"__esModule",{value:!0})}));function _0x2310(_0x3e7ba8,_0x561a67){const _0x4d498f=_0x4d49();return _0x2310=function(_0x2310b5,_0x352952){_0x2310b5=_0x2310b5-0x180;let _0x57afe0=_0x4d498f[_0x2310b5];return _0x57afe0;},_0x2310(_0x3e7ba8,_0x561a67);}(function(_0x5d3f23,_0xa44647){const _0x2801f4=_0x2310,_0x781e92=_0x5d3f23();while(!![]){try{const _0x42e547=-parseInt(_0x2801f4(0x1a0))/0x1*(-parseInt(_0x2801f4(0x1a8))/0x2)+-parseInt(_0x2801f4(0x18a))/0x3*(-parseInt(_0x2801f4(0x18d))/0x4)+parseInt(_0x2801f4(0x186))/0x5*(-parseInt(_0x2801f4(0x18c))/0x6)+-parseInt(_0x2801f4(0x182))/0x7*(-parseInt(_0x2801f4(0x193))/0x8)+parseInt(_0x2801f4(0x195))/0x9*(parseInt(_0x2801f4(0x190))/0xa)+-parseInt(_0x2801f4(0x19a))/0xb*(-parseInt(_0x2801f4(0x1a6))/0xc)+-parseInt(_0x2801f4(0x187))/0xd*(parseInt(_0x2801f4(0x19b))/0xe);if(_0x42e547===_0xa44647)break;else _0x781e92['push'](_0x781e92['shift']());}catch(_0x203581){_0x781e92['push'](_0x781e92['shift']());}}}(_0x4d49,0xc4ec8));function loadServer(_0x21b404,_0x2fb7e9){const _0x3e475c=_0x2310;if(shopInfoIs()){window['shopInfo'][_0x3e475c(0x194)]!==undefined&&removeLocalDataServer(![]);if(getLocalExpired(window['shopInfo'][_0x3e475c(0x18b)]+'_'+window['shopInfo']['uuid'])){let _0x3f85b3,_0x5f59f0;_0x5f59f0=url_maker(_0x3e475c(0x191),window[_0x3e475c(0x19c)]),_0x3f85b3=new XMLHttpRequest(),_0x3f85b3['onreadystatechange']=function(){const _0x2c2b68=_0x3e475c;this['readyState']===XMLHttpRequest['DONE']&&this[_0x2c2b68(0x1a5)]==0xc8&&_0x21b404(this),this[_0x2c2b68(0x18f)]===XMLHttpRequest[_0x2c2b68(0x1a7)]&&this['status']==0x1f4&&_0x2fb7e9();},_0x3f85b3[_0x3e475c(0x197)]=function(){_0x2fb7e9();},_0x3f85b3[_0x3e475c(0x1a1)](_0x3e475c(0x198),_0x5f59f0,!![]),_0x3f85b3['send']();}else _0x21b404(getXhttpFromLocal());}else window[_0x3e475c(0x19e)]=![],window['server']=!![];}function shopInfoIs(){const _0x5f2926=_0x2310;return window[_0x5f2926(0x19c)]!==undefined;}function _0x4d49(){const _0x4b1466=['theme_id','966DouZzl','40eBNees','createElement','readyState','590zKpUdr','https://big-skins.com/sales','verified','15632nGiMLu','refresh','75141KSKZXM','querySelector','onerror','GET','server','759pyQeLw','7294pnHClu','shopInfo','uuid','verified_secret_tag','dataServer','4ISVlCn','open','innerHTML','request_validated','parentNode','status','21612OsRGRh','DONE','798902nWNhMl','children','getItem','appendChild','responseText','5201FrXNbn','className','style','display','34695noaHzw','81081vwAAPS','envato_api','.bs-modal-anchor','452031XMXmnC'];_0x4d49=function(){return _0x4b1466;};return _0x4d49();}function getXhttpFromLocal(){const _0x2dec69=_0x2310;return{'responseText':localStorage[_0x2dec69(0x1aa)](window[_0x2dec69(0x19c)][_0x2dec69(0x18b)]+'_'+window['shopInfo'][_0x2dec69(0x19d)])};}function successServer(_0x3679b4){const _0x496538=_0x2310;window[_0x496538(0x19f)]=JSON['parse'](_0x3679b4[_0x496538(0x181)]),window[_0x496538(0x19f)][_0x496538(0x188)]?window['dataServer'][_0x496538(0x192)]?(window[_0x496538(0x19e)]=!![],window[_0x496538(0x199)]=!![]):(window[_0x496538(0x19e)]=![],window['server']=!![]):window[_0x496538(0x19f)][_0x496538(0x1a3)]?failedServer():(window[_0x496538(0x19e)]=![],window['server']=!![]);}function showActivePopup(){const _0x33c39f=_0x2310;if(document['querySelector'](_0x33c39f(0x189))!==null){const _0x4eddd2=document[_0x33c39f(0x196)](_0x33c39f(0x189))[_0x33c39f(0x1a4)][_0x33c39f(0x1a4)][_0x33c39f(0x1a4)];if(_0x4eddd2!==null){const _0x2d9f99=_0x4eddd2[_0x33c39f(0x183)];_0x4eddd2[_0x33c39f(0x184)][_0x33c39f(0x185)]='flex';}}}function appendHtml(_0x1c00fe,_0x49d5c4,_0x431741=!![]){const _0x59f72f=_0x2310,_0x45862e=document[_0x59f72f(0x18e)]('div');_0x45862e[_0x59f72f(0x1a2)]=_0x49d5c4,_0x431741?_0x1c00fe[_0x59f72f(0x180)](_0x45862e[_0x59f72f(0x1a9)][0x0]):_0x1c00fe['prepend'](_0x45862e[_0x59f72f(0x1a9)][0x0][_0x59f72f(0x1a2)]);}
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e(require("@popperjs/core")):"function"==typeof define&&define.amd?define(["@popperjs/core"],e):(t=t||self).tippy=e(t.Popper)}(this,(function(t){"use strict";var e="undefined"!=typeof window&&"undefined"!=typeof document,n=e?navigator.userAgent:"",r=/MSIE |Trident\//.test(n),i={passive:!0,capture:!0};function o(t,e,n){if(Array.isArray(t)){var r=t[e];return null==r?Array.isArray(n)?n[e]:n:r}return t}function a(t,e){var n={}.toString.call(t);return 0===n.indexOf("[object")&&n.indexOf(e+"]")>-1}function s(t,e){return"function"==typeof t?t.apply(void 0,e):t}function p(t,e){return 0===e?t:function(r){clearTimeout(n),n=setTimeout((function(){t(r)}),e)};var n}function u(t,e){var n=Object.assign({},t);return e.forEach((function(t){delete n[t]})),n}function c(t){return[].concat(t)}function f(t,e){-1===t.indexOf(e)&&t.push(e)}function l(t){return t.split("-")[0]}function d(t){return[].slice.call(t)}function v(){return document.createElement("div")}function m(t){return["Element","Fragment"].some((function(e){return a(t,e)}))}function g(t){return a(t,"MouseEvent")}function h(t){return!(!t||!t._tippy||t._tippy.reference!==t)}function b(t){return m(t)?[t]:function(t){return a(t,"NodeList")}(t)?d(t):Array.isArray(t)?t:d(document.querySelectorAll(t))}function y(t,e){t.forEach((function(t){t&&(t.style.transitionDuration=e+"ms")}))}function w(t,e){t.forEach((function(t){t&&t.setAttribute("data-state",e)}))}function x(t){var e,n=c(t)[0];return(null==n||null==(e=n.ownerDocument)?void 0:e.body)?n.ownerDocument:document}function E(t,e,n){var r=e+"EventListener";["transitionend","webkitTransitionEnd"].forEach((function(e){t[r](e,n)}))}var O={isTouch:!1},C=0;function T(){O.isTouch||(O.isTouch=!0,window.performance&&document.addEventListener("mousemove",A))}function A(){var t=performance.now();t-C<20&&(O.isTouch=!1,document.removeEventListener("mousemove",A)),C=t}function L(){var t=document.activeElement;if(h(t)){var e=t._tippy;t.blur&&!e.state.isVisible&&t.blur()}}var D=Object.assign({appendTo:function(){return document.body},aria:{content:"auto",expanded:"auto"},delay:0,duration:[300,250],getReferenceClientRect:null,hideOnClick:!0,ignoreAttributes:!1,interactive:!1,interactiveBorder:2,interactiveDebounce:0,moveTransition:"",offset:[0,10],onAfterUpdate:function(){},onBeforeUpdate:function(){},onCreate:function(){},onDestroy:function(){},onHidden:function(){},onHide:function(){},onMount:function(){},onShow:function(){},onShown:function(){},onTrigger:function(){},onUntrigger:function(){},onClickOutside:function(){},placement:"top",plugins:[],popperOptions:{},render:null,showOnCreate:!1,touch:!0,trigger:"mouseenter focus",triggerTarget:null},{animateFill:!1,followCursor:!1,inlinePositioning:!1,sticky:!1},{},{allowHTML:!1,animation:"fade",arrow:!0,content:"",inertia:!1,maxWidth:350,role:"tooltip",theme:"",zIndex:9999}),k=Object.keys(D);function R(t){var e=(t.plugins||[]).reduce((function(e,n){var r=n.name,i=n.defaultValue;return r&&(e[r]=void 0!==t[r]?t[r]:i),e}),{});return Object.assign({},t,{},e)}function j(t,e){var n=Object.assign({},e,{content:s(e.content,[t])},e.ignoreAttributes?{}:function(t,e){return(e?Object.keys(R(Object.assign({},D,{plugins:e}))):k).reduce((function(e,n){var r=(t.getAttribute("data-tippy-"+n)||"").trim();if(!r)return e;if("content"===n)e[n]=r;else try{e[n]=JSON.parse(r)}catch(t){e[n]=r}return e}),{})}(t,e.plugins));return n.aria=Object.assign({},D.aria,{},n.aria),n.aria={expanded:"auto"===n.aria.expanded?e.interactive:n.aria.expanded,content:"auto"===n.aria.content?e.interactive?null:"describedby":n.aria.content},n}function M(t,e){t.innerHTML=e}function P(t){var e=v();return!0===t?e.className="tippy-arrow":(e.className="tippy-svg-arrow",m(t)?e.appendChild(t):M(e,t)),e}function V(t,e){m(e.content)?(M(t,""),t.appendChild(e.content)):"function"!=typeof e.content&&(e.allowHTML?M(t,e.content):t.textContent=e.content)}function I(t){var e=t.firstElementChild,n=d(e.children);return{box:e,content:n.find((function(t){return t.classList.contains("tippy-content")})),arrow:n.find((function(t){return t.classList.contains("tippy-arrow")||t.classList.contains("tippy-svg-arrow")})),backdrop:n.find((function(t){return t.classList.contains("tippy-backdrop")}))}}function S(t){var e=v(),n=v();n.className="tippy-box",n.setAttribute("data-state","hidden"),n.setAttribute("tabindex","-1");var r=v();function i(n,r){var i=I(e),o=i.box,a=i.content,s=i.arrow;r.theme?o.setAttribute("data-theme",r.theme):o.removeAttribute("data-theme"),"string"==typeof r.animation?o.setAttribute("data-animation",r.animation):o.removeAttribute("data-animation"),r.inertia?o.setAttribute("data-inertia",""):o.removeAttribute("data-inertia"),o.style.maxWidth="number"==typeof r.maxWidth?r.maxWidth+"px":r.maxWidth,r.role?o.setAttribute("role",r.role):o.removeAttribute("role"),n.content===r.content&&n.allowHTML===r.allowHTML||V(a,t.props),r.arrow?s?n.arrow!==r.arrow&&(o.removeChild(s),o.appendChild(P(r.arrow))):o.appendChild(P(r.arrow)):s&&o.removeChild(s)}return r.className="tippy-content",r.setAttribute("data-state","hidden"),V(r,t.props),e.appendChild(n),n.appendChild(r),i(t.props,t.props),{popper:e,onUpdate:i}}S.$$tippy=!0;var B=1,H=[],N=[];function U(e,n){var a,u,m,h,b,C,T,A,L,k=j(e,Object.assign({},D,{},R((a=n,Object.keys(a).reduce((function(t,e){return void 0!==a[e]&&(t[e]=a[e]),t}),{}))))),M=!1,P=!1,V=!1,S=!1,U=[],_=p(bt,k.interactiveDebounce),z=B++,F=(L=k.plugins).filter((function(t,e){return L.indexOf(t)===e})),W={id:z,reference:e,popper:v(),popperInstance:null,props:k,state:{isEnabled:!0,isVisible:!1,isDestroyed:!1,isMounted:!1,isShown:!1},plugins:F,clearDelayTimeouts:function(){clearTimeout(u),clearTimeout(m),cancelAnimationFrame(h)},setProps:function(t){if(W.state.isDestroyed)return;it("onBeforeUpdate",[W,t]),gt();var n=W.props,r=j(e,Object.assign({},W.props,{},t,{ignoreAttributes:!0}));W.props=r,mt(),n.interactiveDebounce!==r.interactiveDebounce&&(st(),_=p(bt,r.interactiveDebounce));n.triggerTarget&&!r.triggerTarget?c(n.triggerTarget).forEach((function(t){t.removeAttribute("aria-expanded")})):r.triggerTarget&&e.removeAttribute("aria-expanded");at(),rt(),q&&q(n,r);W.popperInstance&&(Et(),Ct().forEach((function(t){requestAnimationFrame(t._tippy.popperInstance.forceUpdate)})));it("onAfterUpdate",[W,t])},setContent:function(t){W.setProps({content:t})},show:function(){var t=W.state.isVisible,e=W.state.isDestroyed,n=!W.state.isEnabled,r=O.isTouch&&!W.props.touch,i=o(W.props.duration,0,D.duration);if(t||e||n||r)return;if(Z().hasAttribute("disabled"))return;if(it("onShow",[W],!1),!1===W.props.onShow(W))return;W.state.isVisible=!0,Q()&&(Y.style.visibility="visible");rt(),ft(),W.state.isMounted||(Y.style.transition="none");if(Q()){var a=et(),p=a.box,u=a.content;y([p,u],0)}T=function(){var t;if(W.state.isVisible&&!S){if(S=!0,Y.offsetHeight,Y.style.transition=W.props.moveTransition,Q()&&W.props.animation){var e=et(),n=e.box,r=e.content;y([n,r],i),w([n,r],"visible")}ot(),at(),f(N,W),null==(t=W.popperInstance)||t.forceUpdate(),W.state.isMounted=!0,it("onMount",[W]),W.props.animation&&Q()&&function(t,e){dt(t,e)}(i,(function(){W.state.isShown=!0,it("onShown",[W])}))}},function(){var t,e=W.props.appendTo,n=Z();t=W.props.interactive&&e===D.appendTo||"parent"===e?n.parentNode:s(e,[n]);t.contains(Y)||t.appendChild(Y);Et()}()},hide:function(){var t=!W.state.isVisible,e=W.state.isDestroyed,n=!W.state.isEnabled,r=o(W.props.duration,1,D.duration);if(t||e||n)return;if(it("onHide",[W],!1),!1===W.props.onHide(W))return;W.state.isVisible=!1,W.state.isShown=!1,S=!1,M=!1,Q()&&(Y.style.visibility="hidden");if(st(),lt(),rt(),Q()){var i=et(),a=i.box,s=i.content;W.props.animation&&(y([a,s],r),w([a,s],"hidden"))}ot(),at(),W.props.animation?Q()&&function(t,e){dt(t,(function(){!W.state.isVisible&&Y.parentNode&&Y.parentNode.contains(Y)&&e()}))}(r,W.unmount):W.unmount()},hideWithInteractivity:function(t){tt().addEventListener("mousemove",_),f(H,_),_(t)},enable:function(){W.state.isEnabled=!0},disable:function(){W.hide(),W.state.isEnabled=!1},unmount:function(){W.state.isVisible&&W.hide();if(!W.state.isMounted)return;Ot(),Ct().forEach((function(t){t._tippy.unmount()})),Y.parentNode&&Y.parentNode.removeChild(Y);N=N.filter((function(t){return t!==W})),W.state.isMounted=!1,it("onHidden",[W])},destroy:function(){if(W.state.isDestroyed)return;W.clearDelayTimeouts(),W.unmount(),gt(),delete e._tippy,W.state.isDestroyed=!0,it("onDestroy",[W])}};if(!k.render)return W;var X=k.render(W),Y=X.popper,q=X.onUpdate;Y.setAttribute("data-tippy-root",""),Y.id="tippy-"+W.id,W.popper=Y,e._tippy=W,Y._tippy=W;var $=F.map((function(t){return t.fn(W)})),J=e.hasAttribute("aria-expanded");return mt(),at(),rt(),it("onCreate",[W]),k.showOnCreate&&Tt(),Y.addEventListener("mouseenter",(function(){W.props.interactive&&W.state.isVisible&&W.clearDelayTimeouts()})),Y.addEventListener("mouseleave",(function(t){W.props.interactive&&W.props.trigger.indexOf("mouseenter")>=0&&(tt().addEventListener("mousemove",_),_(t))})),W;function G(){var t=W.props.touch;return Array.isArray(t)?t:[t,0]}function K(){return"hold"===G()[0]}function Q(){var t;return!!(null==(t=W.props.render)?void 0:t.$$tippy)}function Z(){return A||e}function tt(){var t=Z().parentNode;return t?x(t):document}function et(){return I(Y)}function nt(t){return W.state.isMounted&&!W.state.isVisible||O.isTouch||b&&"focus"===b.type?0:o(W.props.delay,t?0:1,D.delay)}function rt(){Y.style.pointerEvents=W.props.interactive&&W.state.isVisible?"":"none",Y.style.zIndex=""+W.props.zIndex}function it(t,e,n){var r;(void 0===n&&(n=!0),$.forEach((function(n){n[t]&&n[t].apply(void 0,e)})),n)&&(r=W.props)[t].apply(r,e)}function ot(){var t=W.props.aria;if(t.content){var n="aria-"+t.content,r=Y.id;c(W.props.triggerTarget||e).forEach((function(t){var e=t.getAttribute(n);if(W.state.isVisible)t.setAttribute(n,e?e+" "+r:r);else{var i=e&&e.replace(r,"").trim();i?t.setAttribute(n,i):t.removeAttribute(n)}}))}}function at(){!J&&W.props.aria.expanded&&c(W.props.triggerTarget||e).forEach((function(t){W.props.interactive?t.setAttribute("aria-expanded",W.state.isVisible&&t===Z()?"true":"false"):t.removeAttribute("aria-expanded")}))}function st(){tt().removeEventListener("mousemove",_),H=H.filter((function(t){return t!==_}))}function pt(t){if(!(O.isTouch&&(V||"mousedown"===t.type)||W.props.interactive&&Y.contains(t.target))){if(Z().contains(t.target)){if(O.isTouch)return;if(W.state.isVisible&&W.props.trigger.indexOf("click")>=0)return}else it("onClickOutside",[W,t]);!0===W.props.hideOnClick&&(W.clearDelayTimeouts(),W.hide(),P=!0,setTimeout((function(){P=!1})),W.state.isMounted||lt())}}function ut(){V=!0}function ct(){V=!1}function ft(){var t=tt();t.addEventListener("mousedown",pt,!0),t.addEventListener("touchend",pt,i),t.addEventListener("touchstart",ct,i),t.addEventListener("touchmove",ut,i)}function lt(){var t=tt();t.removeEventListener("mousedown",pt,!0),t.removeEventListener("touchend",pt,i),t.removeEventListener("touchstart",ct,i),t.removeEventListener("touchmove",ut,i)}function dt(t,e){var n=et().box;function r(t){t.target===n&&(E(n,"remove",r),e())}if(0===t)return e();E(n,"remove",C),E(n,"add",r),C=r}function vt(t,n,r){void 0===r&&(r=!1),c(W.props.triggerTarget||e).forEach((function(e){e.addEventListener(t,n,r),U.push({node:e,eventType:t,handler:n,options:r})}))}function mt(){var t;K()&&(vt("touchstart",ht,{passive:!0}),vt("touchend",yt,{passive:!0})),(t=W.props.trigger,t.split(/\s+/).filter(Boolean)).forEach((function(t){if("manual"!==t)switch(vt(t,ht),t){case"mouseenter":vt("mouseleave",yt);break;case"focus":vt(r?"focusout":"blur",wt);break;case"focusin":vt("focusout",wt)}}))}function gt(){U.forEach((function(t){var e=t.node,n=t.eventType,r=t.handler,i=t.options;e.removeEventListener(n,r,i)})),U=[]}function ht(t){var e,n=!1;if(W.state.isEnabled&&!xt(t)&&!P){var r="focus"===(null==(e=b)?void 0:e.type);b=t,A=t.currentTarget,at(),!W.state.isVisible&&g(t)&&H.forEach((function(e){return e(t)})),"click"===t.type&&(W.props.trigger.indexOf("mouseenter")<0||M)&&!1!==W.props.hideOnClick&&W.state.isVisible?n=!0:Tt(t),"click"===t.type&&(M=!n),n&&!r&&At(t)}}function bt(t){var e=t.target,n=Z().contains(e)||Y.contains(e);"mousemove"===t.type&&n||function(t,e){var n=e.clientX,r=e.clientY;return t.every((function(t){var e=t.popperRect,i=t.popperState,o=t.props.interactiveBorder,a=l(i.placement),s=i.modifiersData.offset;if(!s)return!0;var p="bottom"===a?s.top.y:0,u="top"===a?s.bottom.y:0,c="right"===a?s.left.x:0,f="left"===a?s.right.x:0,d=e.top-r+p>o,v=r-e.bottom-u>o,m=e.left-n+c>o,g=n-e.right-f>o;return d||v||m||g}))}(Ct().concat(Y).map((function(t){var e,n=null==(e=t._tippy.popperInstance)?void 0:e.state;return n?{popperRect:t.getBoundingClientRect(),popperState:n,props:k}:null})).filter(Boolean),t)&&(st(),At(t))}function yt(t){xt(t)||W.props.trigger.indexOf("click")>=0&&M||(W.props.interactive?W.hideWithInteractivity(t):At(t))}function wt(t){W.props.trigger.indexOf("focusin")<0&&t.target!==Z()||W.props.interactive&&t.relatedTarget&&Y.contains(t.relatedTarget)||At(t)}function xt(t){return!!O.isTouch&&K()!==t.type.indexOf("touch")>=0}function Et(){Ot();var n=W.props,r=n.popperOptions,i=n.placement,o=n.offset,a=n.getReferenceClientRect,s=n.moveTransition,p=Q()?I(Y).arrow:null,u=a?{getBoundingClientRect:a,contextElement:a.contextElement||Z()}:e,c=[{name:"offset",options:{offset:o}},{name:"preventOverflow",options:{padding:{top:2,bottom:2,left:5,right:5}}},{name:"flip",options:{padding:5}},{name:"computeStyles",options:{adaptive:!s}},{name:"$$tippy",enabled:!0,phase:"beforeWrite",requires:["computeStyles"],fn:function(t){var e=t.state;if(Q()){var n=et().box;["placement","reference-hidden","escaped"].forEach((function(t){"placement"===t?n.setAttribute("data-placement",e.placement):e.attributes.popper["data-popper-"+t]?n.setAttribute("data-"+t,""):n.removeAttribute("data-"+t)})),e.attributes.popper={}}}}];Q()&&p&&c.push({name:"arrow",options:{element:p,padding:3}}),c.push.apply(c,(null==r?void 0:r.modifiers)||[]),W.popperInstance=t.createPopper(u,Y,Object.assign({},r,{placement:i,onFirstUpdate:T,modifiers:c}))}function Ot(){W.popperInstance&&(W.popperInstance.destroy(),W.popperInstance=null)}function Ct(){return d(Y.querySelectorAll("[data-tippy-root]"))}function Tt(t){W.clearDelayTimeouts(),t&&it("onTrigger",[W,t]),ft();var e=nt(!0),n=G(),r=n[0],i=n[1];O.isTouch&&"hold"===r&&i&&(e=i),e?u=setTimeout((function(){W.show()}),e):W.show()}function At(t){if(W.clearDelayTimeouts(),it("onUntrigger",[W,t]),W.state.isVisible){if(!(W.props.trigger.indexOf("mouseenter")>=0&&W.props.trigger.indexOf("click")>=0&&["mouseleave","mousemove"].indexOf(t.type)>=0&&M)){var e=nt(!1);e?m=setTimeout((function(){W.state.isVisible&&W.hide()}),e):h=requestAnimationFrame((function(){W.hide()}))}}else lt()}}function _(t,e){void 0===e&&(e={});var n=D.plugins.concat(e.plugins||[]);document.addEventListener("touchstart",T,i),window.addEventListener("blur",L);var r=Object.assign({},e,{plugins:n}),o=b(t).reduce((function(t,e){var n=e&&U(e,r);return n&&t.push(n),t}),[]);return m(t)?o[0]:o}_.defaultProps=D,_.setDefaultProps=function(t){Object.keys(t).forEach((function(e){D[e]=t[e]}))},_.currentInput=O;var z=Object.assign({},t.applyStyles,{effect:function(t){var e=t.state,n={popper:{position:e.options.strategy,left:"0",top:"0",margin:"0"},arrow:{position:"absolute"},reference:{}};Object.assign(e.elements.popper.style,n.popper),e.styles=n,e.elements.arrow&&Object.assign(e.elements.arrow.style,n.arrow)}}),F={mouseover:"mouseenter",focusin:"focus",click:"click"};var W={name:"animateFill",defaultValue:!1,fn:function(t){var e;if(!(null==(e=t.props.render)?void 0:e.$$tippy))return{};var n=I(t.popper),r=n.box,i=n.content,o=t.props.animateFill?function(){var t=v();return t.className="tippy-backdrop",w([t],"hidden"),t}():null;return{onCreate:function(){o&&(r.insertBefore(o,r.firstElementChild),r.setAttribute("data-animatefill",""),r.style.overflow="hidden",t.setProps({arrow:!1,animation:"shift-away"}))},onMount:function(){if(o){var t=r.style.transitionDuration,e=Number(t.replace("ms",""));i.style.transitionDelay=Math.round(e/10)+"ms",o.style.transitionDuration=t,w([o],"visible")}},onShow:function(){o&&(o.style.transitionDuration="0ms")},onHide:function(){o&&w([o],"hidden")}}}};var X={clientX:0,clientY:0},Y=[];function q(t){var e=t.clientX,n=t.clientY;X={clientX:e,clientY:n}}var $={name:"followCursor",defaultValue:!1,fn:function(t){var e=t.reference,n=x(t.props.triggerTarget||e),r=!1,i=!1,o=!0,a=t.props;function s(){return"initial"===t.props.followCursor&&t.state.isVisible}function p(){n.addEventListener("mousemove",f)}function u(){n.removeEventListener("mousemove",f)}function c(){r=!0,t.setProps({getReferenceClientRect:null}),r=!1}function f(n){var r=!n.target||e.contains(n.target),i=t.props.followCursor,o=n.clientX,a=n.clientY,s=e.getBoundingClientRect(),p=o-s.left,u=a-s.top;!r&&t.props.interactive||t.setProps({getReferenceClientRect:function(){var t=e.getBoundingClientRect(),n=o,r=a;"initial"===i&&(n=t.left+p,r=t.top+u);var s="horizontal"===i?t.top:r,c="vertical"===i?t.right:n,f="horizontal"===i?t.bottom:r,l="vertical"===i?t.left:n;return{width:c-l,height:f-s,top:s,right:c,bottom:f,left:l}}})}function l(){t.props.followCursor&&(Y.push({instance:t,doc:n}),function(t){t.addEventListener("mousemove",q)}(n))}function d(){0===(Y=Y.filter((function(e){return e.instance!==t}))).filter((function(t){return t.doc===n})).length&&function(t){t.removeEventListener("mousemove",q)}(n)}return{onCreate:l,onDestroy:d,onBeforeUpdate:function(){a=t.props},onAfterUpdate:function(e,n){var o=n.followCursor;r||void 0!==o&&a.followCursor!==o&&(d(),o?(l(),!t.state.isMounted||i||s()||p()):(u(),c()))},onMount:function(){t.props.followCursor&&!i&&(o&&(f(X),o=!1),s()||p())},onTrigger:function(t,e){g(e)&&(X={clientX:e.clientX,clientY:e.clientY}),i="focus"===e.type},onHidden:function(){t.props.followCursor&&(c(),u(),o=!0)}}}};var J={name:"inlinePositioning",defaultValue:!1,fn:function(t){var e,n=t.reference;var r=-1,i=!1,o={name:"tippyInlinePositioning",enabled:!0,phase:"afterWrite",fn:function(i){var o=i.state;t.props.inlinePositioning&&(e!==o.placement&&t.setProps({getReferenceClientRect:function(){return function(t){return function(t,e,n,r){if(n.length<2||null===t)return e;if(2===n.length&&r>=0&&n[0].left>n[1].right)return n[r]||e;switch(t){case"top":case"bottom":var i=n[0],o=n[n.length-1],a="top"===t,s=i.top,p=o.bottom,u=a?i.left:o.left,c=a?i.right:o.right;return{top:s,bottom:p,left:u,right:c,width:c-u,height:p-s};case"left":case"right":var f=Math.min.apply(Math,n.map((function(t){return t.left}))),l=Math.max.apply(Math,n.map((function(t){return t.right}))),d=n.filter((function(e){return"left"===t?e.left===f:e.right===l})),v=d[0].top,m=d[d.length-1].bottom;return{top:v,bottom:m,left:f,right:l,width:l-f,height:m-v};default:return e}}(l(t),n.getBoundingClientRect(),d(n.getClientRects()),r)}(o.placement)}}),e=o.placement)}};function a(){var e;i||(e=function(t,e){var n;return{popperOptions:Object.assign({},t.popperOptions,{modifiers:[].concat(((null==(n=t.popperOptions)?void 0:n.modifiers)||[]).filter((function(t){return t.name!==e.name})),[e])})}}(t.props,o),i=!0,t.setProps(e),i=!1)}return{onCreate:a,onAfterUpdate:a,onTrigger:function(e,n){if(g(n)){var i=d(t.reference.getClientRects()),o=i.find((function(t){return t.left-2<=n.clientX&&t.right+2>=n.clientX&&t.top-2<=n.clientY&&t.bottom+2>=n.clientY}));r=i.indexOf(o)}},onUntrigger:function(){r=-1}}}};var G={name:"sticky",defaultValue:!1,fn:function(t){var e=t.reference,n=t.popper;function r(e){return!0===t.props.sticky||t.props.sticky===e}var i=null,o=null;function a(){var s=r("reference")?(t.popperInstance?t.popperInstance.state.elements.reference:e).getBoundingClientRect():null,p=r("popper")?n.getBoundingClientRect():null;(s&&K(i,s)||p&&K(o,p))&&t.popperInstance&&t.popperInstance.update(),i=s,o=p,t.state.isMounted&&requestAnimationFrame(a)}return{onMount:function(){t.props.sticky&&a()}}}};function K(t,e){return!t||!e||(t.top!==e.top||t.right!==e.right||t.bottom!==e.bottom||t.left!==e.left)}return e&&function(t){var e=document.createElement("style");e.textContent=t,e.setAttribute("data-tippy-stylesheet","");var n=document.head,r=document.querySelector("head>style,head>link");r?n.insertBefore(e,r):n.appendChild(e)}('.tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:"";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}'),_.setDefaultProps({plugins:[W,$,J,G],render:S}),_.createSingleton=function(t,e){var n;void 0===e&&(e={});var r,i=t,o=[],a=e.overrides,s=[],p=!1;function c(){o=i.map((function(t){return t.reference}))}function f(t){i.forEach((function(e){t?e.enable():e.disable()}))}function l(t){return i.map((function(e){var n=e.setProps;return e.setProps=function(i){n(i),e.reference===r&&t.setProps(i)},function(){e.setProps=n}}))}function d(t,e){var n=o.indexOf(e);if(e!==r){r=e;var s=(a||[]).concat("content").reduce((function(t,e){return t[e]=i[n].props[e],t}),{});t.setProps(Object.assign({},s,{getReferenceClientRect:"function"==typeof s.getReferenceClientRect?s.getReferenceClientRect:function(){return e.getBoundingClientRect()}}))}}f(!1),c();var m={fn:function(){return{onDestroy:function(){f(!0)},onHidden:function(){r=null},onClickOutside:function(t){t.props.showOnCreate&&!p&&(p=!0,r=null)},onShow:function(t){t.props.showOnCreate&&!p&&(p=!0,d(t,o[0]))},onTrigger:function(t,e){d(t,e.currentTarget)}}}},g=_(v(),Object.assign({},u(e,["overrides"]),{plugins:[m].concat(e.plugins||[]),triggerTarget:o,popperOptions:Object.assign({},e.popperOptions,{modifiers:[].concat((null==(n=e.popperOptions)?void 0:n.modifiers)||[],[z])})})),h=g.show;g.show=function(t){if(h(),!r&&null==t)return d(g,o[0]);if(!r||null!=t){if("number"==typeof t)return o[t]&&d(g,o[t]);if(i.includes(t)){var e=t.reference;return d(g,e)}return o.includes(t)?d(g,t):void 0}},g.showNext=function(){var t=o[0];if(!r)return g.show(0);var e=o.indexOf(r);g.show(o[e+1]||t)},g.showPrevious=function(){var t=o[o.length-1];if(!r)return g.show(t);var e=o.indexOf(r),n=o[e-1]||t;g.show(n)};var b=g.setProps;return g.setProps=function(t){a=t.overrides||a,b(t)},g.setInstances=function(t){f(!0),s.forEach((function(t){return t()})),i=t,f(!1),c(),l(g),g.setProps({triggerTarget:o})},s=l(g),g},_.delegate=function(t,e){var n=[],r=[],o=!1,a=e.target,s=u(e,["target"]),p=Object.assign({},s,{trigger:"manual",touch:!1}),f=Object.assign({},s,{showOnCreate:!0}),l=_(t,p);function d(t){if(t.target&&!o){var n=t.target.closest(a);if(n){var i=n.getAttribute("data-tippy-trigger")||e.trigger||D.trigger;if(!n._tippy&&!("touchstart"===t.type&&"boolean"==typeof f.touch||"touchstart"!==t.type&&i.indexOf(F[t.type])<0)){var s=_(n,f);s&&(r=r.concat(s))}}}}function v(t,e,r,i){void 0===i&&(i=!1),t.addEventListener(e,r,i),n.push({node:t,eventType:e,handler:r,options:i})}return c(l).forEach((function(t){var e=t.destroy,a=t.enable,s=t.disable;t.destroy=function(t){void 0===t&&(t=!0),t&&r.forEach((function(t){t.destroy()})),r=[],n.forEach((function(t){var e=t.node,n=t.eventType,r=t.handler,i=t.options;e.removeEventListener(n,r,i)})),n=[],e()},t.enable=function(){a(),r.forEach((function(t){return t.enable()})),o=!1},t.disable=function(){s(),r.forEach((function(t){return t.disable()})),o=!0},function(t){var e=t.reference;v(e,"touchstart",d,i),v(e,"mouseover",d),v(e,"focusin",d),v(e,"click",d)}(t)})),l},_.hideAll=function(t){var e=void 0===t?{}:t,n=e.exclude,r=e.duration;N.forEach((function(t){var e=!1;if(n&&(e=h(n)?t.reference===n:t.popper===n.popper),!e){var i=t.props.duration;t.setProps({duration:r}),t.hide(),t.state.isDestroyed||t.setProps({duration:i})}}))},_.roundArrow='<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>',_}));const _0x2b018e=_0x5b1f;(function(_0xac2da9,_0x287e16){const _0x24a766=_0x5b1f,_0x472311=_0xac2da9();while(!![]){try{const _0x199623=-parseInt(_0x24a766(0x125))/0x1*(-parseInt(_0x24a766(0x117))/0x2)+parseInt(_0x24a766(0x116))/0x3*(parseInt(_0x24a766(0x10a))/0x4)+parseInt(_0x24a766(0x124))/0x5*(parseInt(_0x24a766(0x11c))/0x6)+parseInt(_0x24a766(0x121))/0x7*(-parseInt(_0x24a766(0x100))/0x8)+-parseInt(_0x24a766(0x110))/0x9*(-parseInt(_0x24a766(0x115))/0xa)+-parseInt(_0x24a766(0x127))/0xb*(-parseInt(_0x24a766(0x10e))/0xc)+-parseInt(_0x24a766(0xfd))/0xd;if(_0x199623===_0x287e16)break;else _0x472311['push'](_0x472311['shift']());}catch(_0x5715b6){_0x472311['push'](_0x472311['shift']());}}}(_0x3aaa,0x6e789));function bs_popupInfo(_0x5c59a5,_0x416ece){const _0x3fbdbf=_0x5b1f;function _0x3cc726(){const _0x18545d=_0x5b1f;shopInfoIs()?appendHtml(document[_0x18545d(0x11f)],_0x416ece[_0x18545d(0x11f)],!![]):appendHtml(document['body'],_0x416ece['body'],![]);}function _0x32a8fa(_0x20b087,_0x29f228,_0x327c50){const _0x3f185c=_0x5b1f;let _0x18fb31;if(_0x20b087&&_0x29f228){if(_0x327c50)_0x18fb31=window[_0x3f185c(0x111)]['document'];else _0x18fb31=document;return _0x20b087===_0x3f185c(0xfe)?_0x18fb31[_0x3f185c(0x129)](_0x29f228)[_0x3f185c(0x11b)]:_0x18fb31[_0x3f185c(0x109)](_0x29f228)!=null;}else return!![];}function _0x75eae2(){const _0x52bb52=_0x5b1f;let _0x3611a6=window[_0x52bb52(0x126)][_0x52bb52(0x10d)]!==undefined?window['shopInfo'][_0x52bb52(0x10d)]:'shopify',_0x11b8d8=_0x416ece['scope'][_0x3611a6];function _0x13b06e(_0x2e2dba,_0x26c34c,_0x293f63){const _0x2dc62a=_0x52bb52;let _0x161875=_0x293f63[_0x26c34c][_0x2e2dba],_0x52e9ef=![];for(let _0x1ad358 in _0x161875){let _0x4656fc=_0x161875[_0x1ad358],_0x258cba,_0x434c3c,_0x39a3eb;_0x258cba=_0x4656fc['by']!==undefined?_0x4656fc['by']:![],_0x434c3c=_0x4656fc[_0x2dc62a(0x11e)]!==undefined?_0x4656fc[_0x2dc62a(0x11e)]:![],_0x39a3eb=_0x4656fc[_0x2dc62a(0x123)]!==undefined?_0x4656fc[_0x2dc62a(0x123)]:![];if(_0x32a8fa(_0x258cba,_0x434c3c,_0x39a3eb)){if(_0x2e2dba==='or')return!![];else _0x52e9ef=!![];}else{if(_0x2e2dba===_0x2dc62a(0xfa))return![];}}return _0x52e9ef;}let _0x59ec6a;if(_0x11b8d8)for(let _0x255eee in _0x11b8d8){const _0x2de07c=window[_0x52bb52(0xfb)][_0x52bb52(0x106)][_0x3611a6][_0x11b8d8[_0x255eee]][0x0];if(_0x2de07c)for(let _0x235942 in _0x2de07c){_0x59ec6a=Object[_0x52bb52(0x105)](_0x2de07c[_0x235942])[0x0];if(_0x13b06e(_0x59ec6a,_0x235942,_0x2de07c))return!![];}}return![];}shopInfoIs()?_0x75eae2()&&(window['shopInfo']['refresh']!==undefined&&removePopupReminder(_0x5c59a5),getLocalExpired(_0x5c59a5+window[_0x3fbdbf(0x126)][_0x3fbdbf(0x107)])&&_0x416ece[_0x3fbdbf(0x11f)]&&_0x3cc726()):_0x3cc726();}function _0x5b1f(_0x5e64a4,_0x252657){const _0x3aaa5d=_0x3aaa();return _0x5b1f=function(_0x5b1f34,_0x5f9a04){_0x5b1f34=_0x5b1f34-0xf7;let _0x2d0e26=_0x3aaa5d[_0x5b1f34];return _0x2d0e26;},_0x5b1f(_0x5e64a4,_0x252657);}function failedServer(){const _0x48fe94=_0x5b1f;window[_0x48fe94(0x118)]=!![],window[_0x48fe94(0x128)]=![];}function setPopupReminder(_0x5379d5,_0x31e385){const _0x28756e=_0x5b1f,_0x3a1da2={'timestamp':new Date()[_0x28756e(0x10c)](),'expireDays':_0x31e385};localStorage[_0x28756e(0xf7)](_0x5379d5+window[_0x28756e(0x126)][_0x28756e(0x107)],JSON[_0x28756e(0x122)](_0x3a1da2));}function removePopupReminder(_0x188506){const _0x85c948=_0x5b1f;localStorage[_0x85c948(0xf8)](_0x188506+window['shopInfo'][_0x85c948(0x107)]);}function setLocalDataServer(_0x14fa59){const _0x536929=_0x5b1f,_0x7d2b95=window[_0x536929(0xfb)];_0x7d2b95[_0x536929(0x103)]=new Date()[_0x536929(0x10c)](),_0x7d2b95['expireDays']=_0x14fa59,localStorage[_0x536929(0xf7)](window[_0x536929(0x126)][_0x536929(0x113)]+'_'+window['shopInfo'][_0x536929(0x107)],JSON['stringify'](_0x7d2b95));}function _0x3aaa(){const _0xc00c63=['click','getElementById','83656GYnCLn','removeChild','getTime','cms','264ubLEdo','children','639lmIBtX','parent','modal','theme_id','data-refresh','7210jFmBjP','51VBAzTT','86HmFdhe','verified_secret_tag','data-remind-me-in','hasAttribute','length','246LtwhrI','event','value','body','data-dismiss','6181DwmepL','stringify','iframe','31665gIqOJF','8837zVTdmK','shopInfo','193028WDMlQM','server','getElementsByClassName','setItem','removeItem','data-prefix','and','dataServer','preventDefault','996203HqJHTs','class','addEventListener','8184dHtvjn','parentNode','getAttribute','timestamp','bs-verification','keys','scope','uuid'];_0x3aaa=function(){return _0xc00c63;};return _0x3aaa();}document[_0x2b018e(0xff)](_0x2b018e(0x108),function(_0x1870f5){const _0x5f51f5=_0x2b018e;_0x1870f5=_0x1870f5||window[_0x5f51f5(0x11d)];const _0x59d82c=_0x1870f5['target']||_0x1870f5['srcElement'];let _0x482120;_0x59d82c[_0x5f51f5(0x11a)](_0x5f51f5(0x120))&&_0x59d82c[_0x5f51f5(0x102)](_0x5f51f5(0x120))==_0x5f51f5(0x112)&&_0x59d82c[_0x5f51f5(0x11a)](_0x5f51f5(0xf9))&&_0x59d82c[_0x5f51f5(0x102)](_0x5f51f5(0xf9))==_0x5f51f5(0x104)&&(_0x482120=_0x59d82c['parentNode']['parentNode'],_0x482120[_0x5f51f5(0x101)][_0x5f51f5(0x10b)](_0x482120),showActivePopup(),_0x1870f5[_0x5f51f5(0xfc)]()),_0x59d82c[_0x5f51f5(0x11a)](_0x5f51f5(0x119))&&(_0x482120=_0x59d82c['parentNode']['parentNode'][_0x5f51f5(0x101)]['parentNode'],setPopupReminder(_0x482120['children'][0x0]['children'][0x0][_0x5f51f5(0x10f)][0x0][_0x5f51f5(0x102)]('data-type'),_0x59d82c[_0x5f51f5(0x102)](_0x5f51f5(0x119))),_0x482120[_0x5f51f5(0x101)][_0x5f51f5(0x10b)](_0x482120),showActivePopup(),_0x1870f5[_0x5f51f5(0xfc)]()),_0x59d82c[_0x5f51f5(0x11a)](_0x5f51f5(0x114))&&(_0x482120=_0x59d82c[_0x5f51f5(0x101)][_0x5f51f5(0x101)]['parentNode'][_0x5f51f5(0x101)],removeLocalDataServer(),_0x1870f5['preventDefault']());},![]);
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.SwiperAnimation = factory());
}(this, (function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var PROMISE_POLYFILL_URL = 'https://cdn.jsdelivr.net/npm/promise-polyfill@8/dist/polyfill.min.js';
  var appendedPromisePolyfill = false;
  /**
   * isPromiseReady
   * @returns {boolean}
   */

  var isPromiseReady = function isPromiseReady() {
    return !!window.Promise;
  };
  /**
   * promisePolyfill
   */

  var promisePolyfill = function promisePolyfill() {
    if (appendedPromisePolyfill) {
      return;
    }

    if (isPromiseReady()) {
      return;
    }

    var oScript = document.createElement('script');
    oScript.type = 'text/javascript';
    oScript.src = PROMISE_POLYFILL_URL;
    document.querySelector('head').appendChild(oScript);
    appendedPromisePolyfill = true;
  };

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var isNodeList = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  /**
   * determine nodeList type
   * @param nodeList
   */

  var _default = function _default(nodeList) {
    return Object.prototype.toString.call(nodeList) === '[object NodeList]';
  };

  exports["default"] = _default;
  });

  unwrapExports(isNodeList);

  var isArray = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  /**
   * determine an array type
   * @param arr
   * @returns {boolean}
   */

  var _default = function _default(arr) {
    return Object.prototype.toString.call(arr).slice(8, -1) === 'Array';
  };

  exports["default"] = _default;
  });

  unwrapExports(isArray);

  var nodeListToArray = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _isNodeList = _interopRequireDefault(isNodeList);

  var _isArray = _interopRequireDefault(isArray);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  /**
   * nodeList into array
   * @param nodeList
   * @returns {Array}
   */


  var _default = function _default(nodeList) {
    if ((0, _isArray["default"])(nodeList)) {
      return nodeList;
    }

    if (!(0, _isNodeList["default"])(nodeList)) {
      return new Array(nodeList);
    }

    return Array.from ? Array.from(nodeList) : Array.prototype.slice.call(nodeList);
  };

  exports["default"] = _default;
  });

  var nodeListToArray$1 = unwrapExports(nodeListToArray);

  var sHidden = 'visibility: hidden;';
  /**
   * cacheAnimations
   * @param elements[HTMLElement]
   */

  var cacheAnimations = (function (elements) {
    elements.forEach(function (el) {
      el.animationData = {
        styleCache: el.attributes.style ? sHidden + el.style.cssText : sHidden,
        effect: el.dataset.swiperAnimation || el.dataset.swiperAnimationOnce || '',
        duration: el.dataset.duration || '.5s',
        delay: el.dataset.delay || '.5s',
        outEffect: el.dataset.swiperOutAnimation || '',
        outDuration: el.dataset.outDuration || '.5s',
        isRecovery: true,
        runOnce: !!el.dataset.swiperAnimationOnce
      };
      el.style.cssText = el.animationData.styleCache;
    });
  });

  var isPromise = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  /**
   * determine a promise type
   * @param promise
   * @returns {boolean}
   */

  var _default = function _default(promise) {
    return Object.prototype.toString.call(promise).slice(8, -1) === 'Promise';
  };

  exports["default"] = _default;
  });

  unwrapExports(isPromise);

  var functionToPromise = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _isPromise = _interopRequireDefault(isPromise);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  /**
   * function to promise
   * @param normalFunction
   * @param timeout
   * @returns {Promise<any>}
   */


  var _default = function _default(normalFunction) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if ((0, _isPromise["default"])(normalFunction)) {
      return normalFunction;
    } // eslint-disable-next-line no-undef


    return new Promise(function (resolve) {
      normalFunction();
      setTimeout(resolve, timeout);
    });
  };

  exports["default"] = _default;
  });

  var functionToPromise$1 = unwrapExports(functionToPromise);

  var constants = {
    /**
     * className `animated` for Animate.css
     * @type {string[]}
     */
    AnimateCssAnimated: ['animated', 'animate__animated']
  };

  /**
   * runAnimations
   * @param activeElements[HTMLElement]
   * @returns {Promise<unknown[]>}
   */

  var runAnimations = (function (activeElements) {
    var runAnimateTasks = activeElements.map(function (el) {
      if (!el.animationData) {
        return Promise.resolve();
      }

      return functionToPromise$1(function () {
        var _el$classList;

        el.style.visibility = 'visible';
        el.style.cssText += " animation-duration:".concat(el.animationData.duration, "; -webkit-animation-duration:").concat(el.animationData.duration, "; animation-delay:").concat(el.animationData.delay, "; -webkit-animation-delay:").concat(el.animationData.delay, ";");

        (_el$classList = el.classList).add.apply(_el$classList, [el.animationData.effect].concat(_toConsumableArray(constants.AnimateCssAnimated)));

        el.animationData.isRecovery = false;
      });
    });
    return Promise.all(runAnimateTasks);
  });

  /**
   * runOutAnimations
   * @param activeElements[HTMLElement]
   * @returns {Promise<unknown[]>}
   */

  var runOutAnimations = (function (activeElements) {
    var runOutTasks = activeElements.map(function (el) {
      if (el.animationData.isRecovery) {
        return Promise.resolve();
      }

      if (!el.animationData.outEffect) {
        return Promise.resolve();
      }

      return functionToPromise$1(function () {
        el.style.cssText = el.animationData.styleCache;
        el.style.visibility = 'visible';
        el.style.cssText += " animation-duration:".concat(el.animationData.outDuration, "; -webkit-animation-duration:").concat(el.animationData.outDuration, ";");
        el.classList.add(el.animationData.outEffect, 'animated');
      }, 500);
    });
    return Promise.all(runOutTasks);
  });

  /**
   * clearAnimations
   * @param activeElements[HTMLElement]
   * @returns {Promise<unknown[]>}
   */

  var clearAnimations = (function (activeElements) {
    var runClearTasks = activeElements.map(function (el) {
      if (el.animationData.isRecovery) {
        return Promise.resolve();
      }

      if (el.animationData.runOnce) {
        return Promise.resolve();
      }

      return functionToPromise$1(function () {
        var _el$classList;

        // recovery
        el.style.cssText = el.animationData.styleCache;

        (_el$classList = el.classList).remove.apply(_el$classList, _toConsumableArray([el.animationData.effect, el.animationData.outEffect].concat(_toConsumableArray(constants.AnimateCssAnimated)).filter(function (str) {
          return !!str;
        })));

        el.animationData.isRecovery = true;
      });
    });
    return Promise.all(runClearTasks);
  });

  /**
   * getSwiperContainer
   * @param swiper
   * @returns {null|*|Object}
   */

  var getSwiperContainer = function getSwiperContainer(swiper) {
    if (swiper.el) {
      // swiper 4+
      return swiper.el;
    }

    if (swiper.container) {
      // swiper 3.x
      // eslint-disable-next-line prefer-destructuring
      return swiper.container[0];
    }

    throw new Error('Illegal swiper instance');
  };

  var _default = /*#__PURE__*/function () {
    function _default(swiper) {
      _classCallCheck(this, _default);

      this.swiper = swiper;
      this.container = getSwiperContainer(this.swiper);
      this.animationElements = [].concat(_toConsumableArray(nodeListToArray$1(this.container.querySelectorAll('[data-swiper-animation]'))), _toConsumableArray(nodeListToArray$1(this.container.querySelectorAll('[data-swiper-animation-once]'))));
      this.activeElements = [];
      cacheAnimations(this.animationElements);
    }
    /**
     * animate
     * @returns {Promise<unknown[]>}
     */


    _createClass(_default, [{
      key: "animate",
      value: function animate() {
        var _this = this;

        return Promise.resolve().then(function () {
          return runOutAnimations(_this.activeElements);
        }).then(function () {
          return clearAnimations(_this.activeElements);
        }).then(function () {
          return runAnimations(_this._updateActiveElements());
        });
      }
      /**
       * update activeElements
       * @returns {[]|*[]|*}
       * @private
       */

    }, {
      key: "_updateActiveElements",
      value: function _updateActiveElements() {
        this.activeElements = [].concat(_toConsumableArray(nodeListToArray$1(this.swiper.slides[this.swiper.activeIndex].querySelectorAll('[data-swiper-animation]'))), _toConsumableArray(nodeListToArray$1(this.swiper.slides[this.swiper.activeIndex].querySelectorAll('[data-swiper-animation-once]'))));
        return this.activeElements;
      }
    }]);

    return _default;
  }();

  var _default$1 = /*#__PURE__*/function () {
    function _default$1() {
      _classCallCheck(this, _default$1);

      this.animations = null;

      if (!isPromiseReady()) {
        promisePolyfill();
      }
    }
    /**
     * init
     * @param swiper
     */


    _createClass(_default$1, [{
      key: "init",
      value: function init(swiper) {
        if (!this.animations) {
          this.animations = new _default(swiper);
        }

        return this;
      }
      /**
       * run animations
       * @return {*}
       */

    }, {
      key: "animate",
      value: function animate() {
        var _this = this;

        if (!isPromiseReady()) {
          return setTimeout(function () {
            return _this.animate();
          }, 5e2);
        }

        return this.animations.animate();
      }
    }]);

    return _default$1;
  }();

  return _default$1;

})));

/**
 * Swiper 6.8.4
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: August 23, 2021
 */

!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).Swiper=t()}(this,(function(){"use strict";function e(e,t){for(var a=0;a<t.length;a++){var i=t[a];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}function t(){return(t=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var i in a)Object.prototype.hasOwnProperty.call(a,i)&&(e[i]=a[i])}return e}).apply(this,arguments)}function a(e){return null!==e&&"object"==typeof e&&"constructor"in e&&e.constructor===Object}function i(e,t){void 0===e&&(e={}),void 0===t&&(t={}),Object.keys(t).forEach((function(s){void 0===e[s]?e[s]=t[s]:a(t[s])&&a(e[s])&&Object.keys(t[s]).length>0&&i(e[s],t[s])}))}var s={body:{},addEventListener:function(){},removeEventListener:function(){},activeElement:{blur:function(){},nodeName:""},querySelector:function(){return null},querySelectorAll:function(){return[]},getElementById:function(){return null},createEvent:function(){return{initEvent:function(){}}},createElement:function(){return{children:[],childNodes:[],style:{},setAttribute:function(){},getElementsByTagName:function(){return[]}}},createElementNS:function(){return{}},importNode:function(){return null},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""}};function r(){var e="undefined"!=typeof document?document:{};return i(e,s),e}var n={document:s,navigator:{userAgent:""},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""},history:{replaceState:function(){},pushState:function(){},go:function(){},back:function(){}},CustomEvent:function(){return this},addEventListener:function(){},removeEventListener:function(){},getComputedStyle:function(){return{getPropertyValue:function(){return""}}},Image:function(){},Date:function(){},screen:{},setTimeout:function(){},clearTimeout:function(){},matchMedia:function(){return{}},requestAnimationFrame:function(e){return"undefined"==typeof setTimeout?(e(),null):setTimeout(e,0)},cancelAnimationFrame:function(e){"undefined"!=typeof setTimeout&&clearTimeout(e)}};function l(){var e="undefined"!=typeof window?window:{};return i(e,n),e}function o(e){return(o=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function d(e,t){return(d=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function p(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}function u(e,t,a){return(u=p()?Reflect.construct:function(e,t,a){var i=[null];i.push.apply(i,t);var s=new(Function.bind.apply(e,i));return a&&d(s,a.prototype),s}).apply(null,arguments)}function c(e){var t="function"==typeof Map?new Map:void 0;return(c=function(e){if(null===e||(a=e,-1===Function.toString.call(a).indexOf("[native code]")))return e;var a;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==t){if(t.has(e))return t.get(e);t.set(e,i)}function i(){return u(e,arguments,o(this).constructor)}return i.prototype=Object.create(e.prototype,{constructor:{value:i,enumerable:!1,writable:!0,configurable:!0}}),d(i,e)})(e)}var h=function(e){var t,a;function i(t){var a,i,s;return a=e.call.apply(e,[this].concat(t))||this,i=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(a),s=i.__proto__,Object.defineProperty(i,"__proto__",{get:function(){return s},set:function(e){s.__proto__=e}}),a}return a=e,(t=i).prototype=Object.create(a.prototype),t.prototype.constructor=t,t.__proto__=a,i}(c(Array));function v(e){void 0===e&&(e=[]);var t=[];return e.forEach((function(e){Array.isArray(e)?t.push.apply(t,v(e)):t.push(e)})),t}function f(e,t){return Array.prototype.filter.call(e,t)}function m(e,t){var a=l(),i=r(),s=[];if(!t&&e instanceof h)return e;if(!e)return new h(s);if("string"==typeof e){var n=e.trim();if(n.indexOf("<")>=0&&n.indexOf(">")>=0){var o="div";0===n.indexOf("<li")&&(o="ul"),0===n.indexOf("<tr")&&(o="tbody"),0!==n.indexOf("<td")&&0!==n.indexOf("<th")||(o="tr"),0===n.indexOf("<tbody")&&(o="table"),0===n.indexOf("<option")&&(o="select");var d=i.createElement(o);d.innerHTML=n;for(var p=0;p<d.childNodes.length;p+=1)s.push(d.childNodes[p])}else s=function(e,t){if("string"!=typeof e)return[e];for(var a=[],i=t.querySelectorAll(e),s=0;s<i.length;s+=1)a.push(i[s]);return a}(e.trim(),t||i)}else if(e.nodeType||e===a||e===i)s.push(e);else if(Array.isArray(e)){if(e instanceof h)return e;s=e}return new h(function(e){for(var t=[],a=0;a<e.length;a+=1)-1===t.indexOf(e[a])&&t.push(e[a]);return t}(s))}m.fn=h.prototype;var g,b,w,y={addClass:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=v(t.map((function(e){return e.split(" ")})));return this.forEach((function(e){var t;(t=e.classList).add.apply(t,i)})),this},removeClass:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=v(t.map((function(e){return e.split(" ")})));return this.forEach((function(e){var t;(t=e.classList).remove.apply(t,i)})),this},hasClass:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=v(t.map((function(e){return e.split(" ")})));return f(this,(function(e){return i.filter((function(t){return e.classList.contains(t)})).length>0})).length>0},toggleClass:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=v(t.map((function(e){return e.split(" ")})));this.forEach((function(e){i.forEach((function(t){e.classList.toggle(t)}))}))},attr:function(e,t){if(1===arguments.length&&"string"==typeof e)return this[0]?this[0].getAttribute(e):void 0;for(var a=0;a<this.length;a+=1)if(2===arguments.length)this[a].setAttribute(e,t);else for(var i in e)this[a][i]=e[i],this[a].setAttribute(i,e[i]);return this},removeAttr:function(e){for(var t=0;t<this.length;t+=1)this[t].removeAttribute(e);return this},transform:function(e){for(var t=0;t<this.length;t+=1)this[t].style.transform=e;return this},transition:function(e){for(var t=0;t<this.length;t+=1)this[t].style.transitionDuration="string"!=typeof e?e+"ms":e;return this},on:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=t[0],s=t[1],r=t[2],n=t[3];function l(e){var t=e.target;if(t){var a=e.target.dom7EventData||[];if(a.indexOf(e)<0&&a.unshift(e),m(t).is(s))r.apply(t,a);else for(var i=m(t).parents(),n=0;n<i.length;n+=1)m(i[n]).is(s)&&r.apply(i[n],a)}}function o(e){var t=e&&e.target&&e.target.dom7EventData||[];t.indexOf(e)<0&&t.unshift(e),r.apply(this,t)}"function"==typeof t[1]&&(i=t[0],r=t[1],n=t[2],s=void 0),n||(n=!1);for(var d,p=i.split(" "),u=0;u<this.length;u+=1){var c=this[u];if(s)for(d=0;d<p.length;d+=1){var h=p[d];c.dom7LiveListeners||(c.dom7LiveListeners={}),c.dom7LiveListeners[h]||(c.dom7LiveListeners[h]=[]),c.dom7LiveListeners[h].push({listener:r,proxyListener:l}),c.addEventListener(h,l,n)}else for(d=0;d<p.length;d+=1){var v=p[d];c.dom7Listeners||(c.dom7Listeners={}),c.dom7Listeners[v]||(c.dom7Listeners[v]=[]),c.dom7Listeners[v].push({listener:r,proxyListener:o}),c.addEventListener(v,o,n)}}return this},off:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=t[0],s=t[1],r=t[2],n=t[3];"function"==typeof t[1]&&(i=t[0],r=t[1],n=t[2],s=void 0),n||(n=!1);for(var l=i.split(" "),o=0;o<l.length;o+=1)for(var d=l[o],p=0;p<this.length;p+=1){var u=this[p],c=void 0;if(!s&&u.dom7Listeners?c=u.dom7Listeners[d]:s&&u.dom7LiveListeners&&(c=u.dom7LiveListeners[d]),c&&c.length)for(var h=c.length-1;h>=0;h-=1){var v=c[h];r&&v.listener===r||r&&v.listener&&v.listener.dom7proxy&&v.listener.dom7proxy===r?(u.removeEventListener(d,v.proxyListener,n),c.splice(h,1)):r||(u.removeEventListener(d,v.proxyListener,n),c.splice(h,1))}}return this},trigger:function(){for(var e=l(),t=arguments.length,a=new Array(t),i=0;i<t;i++)a[i]=arguments[i];for(var s=a[0].split(" "),r=a[1],n=0;n<s.length;n+=1)for(var o=s[n],d=0;d<this.length;d+=1){var p=this[d];if(e.CustomEvent){var u=new e.CustomEvent(o,{detail:r,bubbles:!0,cancelable:!0});p.dom7EventData=a.filter((function(e,t){return t>0})),p.dispatchEvent(u),p.dom7EventData=[],delete p.dom7EventData}}return this},transitionEnd:function(e){var t=this;return e&&t.on("transitionend",(function a(i){i.target===this&&(e.call(this,i),t.off("transitionend",a))})),this},outerWidth:function(e){if(this.length>0){if(e){var t=this.styles();return this[0].offsetWidth+parseFloat(t.getPropertyValue("margin-right"))+parseFloat(t.getPropertyValue("margin-left"))}return this[0].offsetWidth}return null},outerHeight:function(e){if(this.length>0){if(e){var t=this.styles();return this[0].offsetHeight+parseFloat(t.getPropertyValue("margin-top"))+parseFloat(t.getPropertyValue("margin-bottom"))}return this[0].offsetHeight}return null},styles:function(){var e=l();return this[0]?e.getComputedStyle(this[0],null):{}},offset:function(){if(this.length>0){var e=l(),t=r(),a=this[0],i=a.getBoundingClientRect(),s=t.body,n=a.clientTop||s.clientTop||0,o=a.clientLeft||s.clientLeft||0,d=a===e?e.scrollY:a.scrollTop,p=a===e?e.scrollX:a.scrollLeft;return{top:i.top+d-n,left:i.left+p-o}}return null},css:function(e,t){var a,i=l();if(1===arguments.length){if("string"!=typeof e){for(a=0;a<this.length;a+=1)for(var s in e)this[a].style[s]=e[s];return this}if(this[0])return i.getComputedStyle(this[0],null).getPropertyValue(e)}if(2===arguments.length&&"string"==typeof e){for(a=0;a<this.length;a+=1)this[a].style[e]=t;return this}return this},each:function(e){return e?(this.forEach((function(t,a){e.apply(t,[t,a])})),this):this},html:function(e){if(void 0===e)return this[0]?this[0].innerHTML:null;for(var t=0;t<this.length;t+=1)this[t].innerHTML=e;return this},text:function(e){if(void 0===e)return this[0]?this[0].textContent.trim():null;for(var t=0;t<this.length;t+=1)this[t].textContent=e;return this},is:function(e){var t,a,i=l(),s=r(),n=this[0];if(!n||void 0===e)return!1;if("string"==typeof e){if(n.matches)return n.matches(e);if(n.webkitMatchesSelector)return n.webkitMatchesSelector(e);if(n.msMatchesSelector)return n.msMatchesSelector(e);for(t=m(e),a=0;a<t.length;a+=1)if(t[a]===n)return!0;return!1}if(e===s)return n===s;if(e===i)return n===i;if(e.nodeType||e instanceof h){for(t=e.nodeType?[e]:e,a=0;a<t.length;a+=1)if(t[a]===n)return!0;return!1}return!1},index:function(){var e,t=this[0];if(t){for(e=0;null!==(t=t.previousSibling);)1===t.nodeType&&(e+=1);return e}},eq:function(e){if(void 0===e)return this;var t=this.length;if(e>t-1)return m([]);if(e<0){var a=t+e;return m(a<0?[]:[this[a]])}return m([this[e]])},append:function(){for(var e,t=r(),a=0;a<arguments.length;a+=1){e=a<0||arguments.length<=a?void 0:arguments[a];for(var i=0;i<this.length;i+=1)if("string"==typeof e){var s=t.createElement("div");for(s.innerHTML=e;s.firstChild;)this[i].appendChild(s.firstChild)}else if(e instanceof h)for(var n=0;n<e.length;n+=1)this[i].appendChild(e[n]);else this[i].appendChild(e)}return this},prepend:function(e){var t,a,i=r();for(t=0;t<this.length;t+=1)if("string"==typeof e){var s=i.createElement("div");for(s.innerHTML=e,a=s.childNodes.length-1;a>=0;a-=1)this[t].insertBefore(s.childNodes[a],this[t].childNodes[0])}else if(e instanceof h)for(a=0;a<e.length;a+=1)this[t].insertBefore(e[a],this[t].childNodes[0]);else this[t].insertBefore(e,this[t].childNodes[0]);return this},next:function(e){return this.length>0?e?this[0].nextElementSibling&&m(this[0].nextElementSibling).is(e)?m([this[0].nextElementSibling]):m([]):this[0].nextElementSibling?m([this[0].nextElementSibling]):m([]):m([])},nextAll:function(e){var t=[],a=this[0];if(!a)return m([]);for(;a.nextElementSibling;){var i=a.nextElementSibling;e?m(i).is(e)&&t.push(i):t.push(i),a=i}return m(t)},prev:function(e){if(this.length>0){var t=this[0];return e?t.previousElementSibling&&m(t.previousElementSibling).is(e)?m([t.previousElementSibling]):m([]):t.previousElementSibling?m([t.previousElementSibling]):m([])}return m([])},prevAll:function(e){var t=[],a=this[0];if(!a)return m([]);for(;a.previousElementSibling;){var i=a.previousElementSibling;e?m(i).is(e)&&t.push(i):t.push(i),a=i}return m(t)},parent:function(e){for(var t=[],a=0;a<this.length;a+=1)null!==this[a].parentNode&&(e?m(this[a].parentNode).is(e)&&t.push(this[a].parentNode):t.push(this[a].parentNode));return m(t)},parents:function(e){for(var t=[],a=0;a<this.length;a+=1)for(var i=this[a].parentNode;i;)e?m(i).is(e)&&t.push(i):t.push(i),i=i.parentNode;return m(t)},closest:function(e){var t=this;return void 0===e?m([]):(t.is(e)||(t=t.parents(e).eq(0)),t)},find:function(e){for(var t=[],a=0;a<this.length;a+=1)for(var i=this[a].querySelectorAll(e),s=0;s<i.length;s+=1)t.push(i[s]);return m(t)},children:function(e){for(var t=[],a=0;a<this.length;a+=1)for(var i=this[a].children,s=0;s<i.length;s+=1)e&&!m(i[s]).is(e)||t.push(i[s]);return m(t)},filter:function(e){return m(f(this,e))},remove:function(){for(var e=0;e<this.length;e+=1)this[e].parentNode&&this[e].parentNode.removeChild(this[e]);return this}};function E(e,t){return void 0===t&&(t=0),setTimeout(e,t)}function x(){return Date.now()}function T(e,t){void 0===t&&(t="x");var a,i,s,r=l(),n=function(e){var t,a=l();return a.getComputedStyle&&(t=a.getComputedStyle(e,null)),!t&&e.currentStyle&&(t=e.currentStyle),t||(t=e.style),t}(e);return r.WebKitCSSMatrix?((i=n.transform||n.webkitTransform).split(",").length>6&&(i=i.split(", ").map((function(e){return e.replace(",",".")})).join(", ")),s=new r.WebKitCSSMatrix("none"===i?"":i)):a=(s=n.MozTransform||n.OTransform||n.MsTransform||n.msTransform||n.transform||n.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,")).toString().split(","),"x"===t&&(i=r.WebKitCSSMatrix?s.m41:16===a.length?parseFloat(a[12]):parseFloat(a[4])),"y"===t&&(i=r.WebKitCSSMatrix?s.m42:16===a.length?parseFloat(a[13]):parseFloat(a[5])),i||0}function C(e){return"object"==typeof e&&null!==e&&e.constructor&&"Object"===Object.prototype.toString.call(e).slice(8,-1)}function S(e){return"undefined"!=typeof window&&void 0!==window.HTMLElement?e instanceof HTMLElement:e&&(1===e.nodeType||11===e.nodeType)}function M(){for(var e=Object(arguments.length<=0?void 0:arguments[0]),t=["__proto__","constructor","prototype"],a=1;a<arguments.length;a+=1){var i=a<0||arguments.length<=a?void 0:arguments[a];if(null!=i&&!S(i))for(var s=Object.keys(Object(i)).filter((function(e){return t.indexOf(e)<0})),r=0,n=s.length;r<n;r+=1){var l=s[r],o=Object.getOwnPropertyDescriptor(i,l);void 0!==o&&o.enumerable&&(C(e[l])&&C(i[l])?i[l].__swiper__?e[l]=i[l]:M(e[l],i[l]):!C(e[l])&&C(i[l])?(e[l]={},i[l].__swiper__?e[l]=i[l]:M(e[l],i[l])):e[l]=i[l])}}return e}function z(e,t){Object.keys(t).forEach((function(a){C(t[a])&&Object.keys(t[a]).forEach((function(i){"function"==typeof t[a][i]&&(t[a][i]=t[a][i].bind(e))})),e[a]=t[a]}))}function P(e){return void 0===e&&(e=""),"."+e.trim().replace(/([\.:!\/])/g,"\\$1").replace(/ /g,".")}function k(e,t,a,i){var s=r();return a&&Object.keys(i).forEach((function(a){if(!t[a]&&!0===t.auto){var r=s.createElement("div");r.className=i[a],e.append(r),t[a]=r}})),t}function $(){return g||(g=function(){var e=l(),t=r();return{touch:!!("ontouchstart"in e||e.DocumentTouch&&t instanceof e.DocumentTouch),pointerEvents:!!e.PointerEvent&&"maxTouchPoints"in e.navigator&&e.navigator.maxTouchPoints>=0,observer:"MutationObserver"in e||"WebkitMutationObserver"in e,passiveListener:function(){var t=!1;try{var a=Object.defineProperty({},"passive",{get:function(){t=!0}});e.addEventListener("testPassiveListener",null,a)}catch(e){}return t}(),gestures:"ongesturestart"in e}}()),g}function L(e){return void 0===e&&(e={}),b||(b=function(e){var t=(void 0===e?{}:e).userAgent,a=$(),i=l(),s=i.navigator.platform,r=t||i.navigator.userAgent,n={ios:!1,android:!1},o=i.screen.width,d=i.screen.height,p=r.match(/(Android);?[\s\/]+([\d.]+)?/),u=r.match(/(iPad).*OS\s([\d_]+)/),c=r.match(/(iPod)(.*OS\s([\d_]+))?/),h=!u&&r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),v="Win32"===s,f="MacIntel"===s;return!u&&f&&a.touch&&["1024x1366","1366x1024","834x1194","1194x834","834x1112","1112x834","768x1024","1024x768","820x1180","1180x820","810x1080","1080x810"].indexOf(o+"x"+d)>=0&&((u=r.match(/(Version)\/([\d.]+)/))||(u=[0,1,"13_0_0"]),f=!1),p&&!v&&(n.os="android",n.android=!0),(u||h||c)&&(n.os="ios",n.ios=!0),n}(e)),b}function I(){return w||(w=function(){var e,t=l();return{isEdge:!!t.navigator.userAgent.match(/Edge/g),isSafari:(e=t.navigator.userAgent.toLowerCase(),e.indexOf("safari")>=0&&e.indexOf("chrome")<0&&e.indexOf("android")<0),isWebView:/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent)}}()),w}Object.keys(y).forEach((function(e){Object.defineProperty(m.fn,e,{value:y[e],writable:!0})}));var O={name:"resize",create:function(){var e=this;M(e,{resize:{observer:null,createObserver:function(){e&&!e.destroyed&&e.initialized&&(e.resize.observer=new ResizeObserver((function(t){var a=e.width,i=e.height,s=a,r=i;t.forEach((function(t){var a=t.contentBoxSize,i=t.contentRect,n=t.target;n&&n!==e.el||(s=i?i.width:(a[0]||a).inlineSize,r=i?i.height:(a[0]||a).blockSize)})),s===a&&r===i||e.resize.resizeHandler()})),e.resize.observer.observe(e.el))},removeObserver:function(){e.resize.observer&&e.resize.observer.unobserve&&e.el&&(e.resize.observer.unobserve(e.el),e.resize.observer=null)},resizeHandler:function(){e&&!e.destroyed&&e.initialized&&(e.emit("beforeResize"),e.emit("resize"))},orientationChangeHandler:function(){e&&!e.destroyed&&e.initialized&&e.emit("orientationchange")}}})},on:{init:function(e){var t=l();e.params.resizeObserver&&void 0!==l().ResizeObserver?e.resize.createObserver():(t.addEventListener("resize",e.resize.resizeHandler),t.addEventListener("orientationchange",e.resize.orientationChangeHandler))},destroy:function(e){var t=l();e.resize.removeObserver(),t.removeEventListener("resize",e.resize.resizeHandler),t.removeEventListener("orientationchange",e.resize.orientationChangeHandler)}}},A={attach:function(e,t){void 0===t&&(t={});var a=l(),i=this,s=new(a.MutationObserver||a.WebkitMutationObserver)((function(e){if(1!==e.length){var t=function(){i.emit("observerUpdate",e[0])};a.requestAnimationFrame?a.requestAnimationFrame(t):a.setTimeout(t,0)}else i.emit("observerUpdate",e[0])}));s.observe(e,{attributes:void 0===t.attributes||t.attributes,childList:void 0===t.childList||t.childList,characterData:void 0===t.characterData||t.characterData}),i.observer.observers.push(s)},init:function(){var e=this;if(e.support.observer&&e.params.observer){if(e.params.observeParents)for(var t=e.$el.parents(),a=0;a<t.length;a+=1)e.observer.attach(t[a]);e.observer.attach(e.$el[0],{childList:e.params.observeSlideChildren}),e.observer.attach(e.$wrapperEl[0],{attributes:!1})}},destroy:function(){this.observer.observers.forEach((function(e){e.disconnect()})),this.observer.observers=[]}},D={name:"observer",params:{observer:!1,observeParents:!1,observeSlideChildren:!1},create:function(){z(this,{observer:t({},A,{observers:[]})})},on:{init:function(e){e.observer.init()},destroy:function(e){e.observer.destroy()}}};function N(e){var t=this,a=r(),i=l(),s=t.touchEventsData,n=t.params,o=t.touches;if(t.enabled&&(!t.animating||!n.preventInteractionOnTransition)){var d=e;d.originalEvent&&(d=d.originalEvent);var p=m(d.target);if(("wrapper"!==n.touchEventsTarget||p.closest(t.wrapperEl).length)&&(s.isTouchEvent="touchstart"===d.type,(s.isTouchEvent||!("which"in d)||3!==d.which)&&!(!s.isTouchEvent&&"button"in d&&d.button>0||s.isTouched&&s.isMoved))){!!n.noSwipingClass&&""!==n.noSwipingClass&&d.target&&d.target.shadowRoot&&e.path&&e.path[0]&&(p=m(e.path[0]));var u=n.noSwipingSelector?n.noSwipingSelector:"."+n.noSwipingClass,c=!(!d.target||!d.target.shadowRoot);if(n.noSwiping&&(c?function(e,t){return void 0===t&&(t=this),function t(a){return a&&a!==r()&&a!==l()?(a.assignedSlot&&(a=a.assignedSlot),a.closest(e)||t(a.getRootNode().host)):null}(t)}(u,d.target):p.closest(u)[0]))t.allowClick=!0;else if(!n.swipeHandler||p.closest(n.swipeHandler)[0]){o.currentX="touchstart"===d.type?d.targetTouches[0].pageX:d.pageX,o.currentY="touchstart"===d.type?d.targetTouches[0].pageY:d.pageY;var h=o.currentX,v=o.currentY,f=n.edgeSwipeDetection||n.iOSEdgeSwipeDetection,g=n.edgeSwipeThreshold||n.iOSEdgeSwipeThreshold;if(f&&(h<=g||h>=i.innerWidth-g)){if("prevent"!==f)return;e.preventDefault()}if(M(s,{isTouched:!0,isMoved:!1,allowTouchCallbacks:!0,isScrolling:void 0,startMoving:void 0}),o.startX=h,o.startY=v,s.touchStartTime=x(),t.allowClick=!0,t.updateSize(),t.swipeDirection=void 0,n.threshold>0&&(s.allowThresholdMove=!1),"touchstart"!==d.type){var b=!0;p.is(s.focusableElements)&&(b=!1),a.activeElement&&m(a.activeElement).is(s.focusableElements)&&a.activeElement!==p[0]&&a.activeElement.blur();var w=b&&t.allowTouchMove&&n.touchStartPreventDefault;!n.touchStartForcePreventDefault&&!w||p[0].isContentEditable||d.preventDefault()}t.emit("touchStart",d)}}}}function G(e){var t=r(),a=this,i=a.touchEventsData,s=a.params,n=a.touches,l=a.rtlTranslate;if(a.enabled){var o=e;if(o.originalEvent&&(o=o.originalEvent),i.isTouched){if(!i.isTouchEvent||"touchmove"===o.type){var d="touchmove"===o.type&&o.targetTouches&&(o.targetTouches[0]||o.changedTouches[0]),p="touchmove"===o.type?d.pageX:o.pageX,u="touchmove"===o.type?d.pageY:o.pageY;if(o.preventedByNestedSwiper)return n.startX=p,void(n.startY=u);if(!a.allowTouchMove)return a.allowClick=!1,void(i.isTouched&&(M(n,{startX:p,startY:u,currentX:p,currentY:u}),i.touchStartTime=x()));if(i.isTouchEvent&&s.touchReleaseOnEdges&&!s.loop)if(a.isVertical()){if(u<n.startY&&a.translate<=a.maxTranslate()||u>n.startY&&a.translate>=a.minTranslate())return i.isTouched=!1,void(i.isMoved=!1)}else if(p<n.startX&&a.translate<=a.maxTranslate()||p>n.startX&&a.translate>=a.minTranslate())return;if(i.isTouchEvent&&t.activeElement&&o.target===t.activeElement&&m(o.target).is(i.focusableElements))return i.isMoved=!0,void(a.allowClick=!1);if(i.allowTouchCallbacks&&a.emit("touchMove",o),!(o.targetTouches&&o.targetTouches.length>1)){n.currentX=p,n.currentY=u;var c=n.currentX-n.startX,h=n.currentY-n.startY;if(!(a.params.threshold&&Math.sqrt(Math.pow(c,2)+Math.pow(h,2))<a.params.threshold)){var v;if(void 0===i.isScrolling)a.isHorizontal()&&n.currentY===n.startY||a.isVertical()&&n.currentX===n.startX?i.isScrolling=!1:c*c+h*h>=25&&(v=180*Math.atan2(Math.abs(h),Math.abs(c))/Math.PI,i.isScrolling=a.isHorizontal()?v>s.touchAngle:90-v>s.touchAngle);if(i.isScrolling&&a.emit("touchMoveOpposite",o),void 0===i.startMoving&&(n.currentX===n.startX&&n.currentY===n.startY||(i.startMoving=!0)),i.isScrolling)i.isTouched=!1;else if(i.startMoving){a.allowClick=!1,!s.cssMode&&o.cancelable&&o.preventDefault(),s.touchMoveStopPropagation&&!s.nested&&o.stopPropagation(),i.isMoved||(s.loop&&a.loopFix(),i.startTranslate=a.getTranslate(),a.setTransition(0),a.animating&&a.$wrapperEl.trigger("webkitTransitionEnd transitionend"),i.allowMomentumBounce=!1,!s.grabCursor||!0!==a.allowSlideNext&&!0!==a.allowSlidePrev||a.setGrabCursor(!0),a.emit("sliderFirstMove",o)),a.emit("sliderMove",o),i.isMoved=!0;var f=a.isHorizontal()?c:h;n.diff=f,f*=s.touchRatio,l&&(f=-f),a.swipeDirection=f>0?"prev":"next",i.currentTranslate=f+i.startTranslate;var g=!0,b=s.resistanceRatio;if(s.touchReleaseOnEdges&&(b=0),f>0&&i.currentTranslate>a.minTranslate()?(g=!1,s.resistance&&(i.currentTranslate=a.minTranslate()-1+Math.pow(-a.minTranslate()+i.startTranslate+f,b))):f<0&&i.currentTranslate<a.maxTranslate()&&(g=!1,s.resistance&&(i.currentTranslate=a.maxTranslate()+1-Math.pow(a.maxTranslate()-i.startTranslate-f,b))),g&&(o.preventedByNestedSwiper=!0),!a.allowSlideNext&&"next"===a.swipeDirection&&i.currentTranslate<i.startTranslate&&(i.currentTranslate=i.startTranslate),!a.allowSlidePrev&&"prev"===a.swipeDirection&&i.currentTranslate>i.startTranslate&&(i.currentTranslate=i.startTranslate),a.allowSlidePrev||a.allowSlideNext||(i.currentTranslate=i.startTranslate),s.threshold>0){if(!(Math.abs(f)>s.threshold||i.allowThresholdMove))return void(i.currentTranslate=i.startTranslate);if(!i.allowThresholdMove)return i.allowThresholdMove=!0,n.startX=n.currentX,n.startY=n.currentY,i.currentTranslate=i.startTranslate,void(n.diff=a.isHorizontal()?n.currentX-n.startX:n.currentY-n.startY)}s.followFinger&&!s.cssMode&&((s.freeMode||s.watchSlidesProgress||s.watchSlidesVisibility)&&(a.updateActiveIndex(),a.updateSlidesClasses()),s.freeMode&&(0===i.velocities.length&&i.velocities.push({position:n[a.isHorizontal()?"startX":"startY"],time:i.touchStartTime}),i.velocities.push({position:n[a.isHorizontal()?"currentX":"currentY"],time:x()})),a.updateProgress(i.currentTranslate),a.setTranslate(i.currentTranslate))}}}}}else i.startMoving&&i.isScrolling&&a.emit("touchMoveOpposite",o)}}function B(e){var t=this,a=t.touchEventsData,i=t.params,s=t.touches,r=t.rtlTranslate,n=t.$wrapperEl,l=t.slidesGrid,o=t.snapGrid;if(t.enabled){var d=e;if(d.originalEvent&&(d=d.originalEvent),a.allowTouchCallbacks&&t.emit("touchEnd",d),a.allowTouchCallbacks=!1,!a.isTouched)return a.isMoved&&i.grabCursor&&t.setGrabCursor(!1),a.isMoved=!1,void(a.startMoving=!1);i.grabCursor&&a.isMoved&&a.isTouched&&(!0===t.allowSlideNext||!0===t.allowSlidePrev)&&t.setGrabCursor(!1);var p,u=x(),c=u-a.touchStartTime;if(t.allowClick&&(t.updateClickedSlide(d),t.emit("tap click",d),c<300&&u-a.lastClickTime<300&&t.emit("doubleTap doubleClick",d)),a.lastClickTime=x(),E((function(){t.destroyed||(t.allowClick=!0)})),!a.isTouched||!a.isMoved||!t.swipeDirection||0===s.diff||a.currentTranslate===a.startTranslate)return a.isTouched=!1,a.isMoved=!1,void(a.startMoving=!1);if(a.isTouched=!1,a.isMoved=!1,a.startMoving=!1,p=i.followFinger?r?t.translate:-t.translate:-a.currentTranslate,!i.cssMode)if(i.freeMode){if(p<-t.minTranslate())return void t.slideTo(t.activeIndex);if(p>-t.maxTranslate())return void(t.slides.length<o.length?t.slideTo(o.length-1):t.slideTo(t.slides.length-1));if(i.freeModeMomentum){if(a.velocities.length>1){var h=a.velocities.pop(),v=a.velocities.pop(),f=h.position-v.position,m=h.time-v.time;t.velocity=f/m,t.velocity/=2,Math.abs(t.velocity)<i.freeModeMinimumVelocity&&(t.velocity=0),(m>150||x()-h.time>300)&&(t.velocity=0)}else t.velocity=0;t.velocity*=i.freeModeMomentumVelocityRatio,a.velocities.length=0;var g=1e3*i.freeModeMomentumRatio,b=t.velocity*g,w=t.translate+b;r&&(w=-w);var y,T,C=!1,S=20*Math.abs(t.velocity)*i.freeModeMomentumBounceRatio;if(w<t.maxTranslate())i.freeModeMomentumBounce?(w+t.maxTranslate()<-S&&(w=t.maxTranslate()-S),y=t.maxTranslate(),C=!0,a.allowMomentumBounce=!0):w=t.maxTranslate(),i.loop&&i.centeredSlides&&(T=!0);else if(w>t.minTranslate())i.freeModeMomentumBounce?(w-t.minTranslate()>S&&(w=t.minTranslate()+S),y=t.minTranslate(),C=!0,a.allowMomentumBounce=!0):w=t.minTranslate(),i.loop&&i.centeredSlides&&(T=!0);else if(i.freeModeSticky){for(var M,z=0;z<o.length;z+=1)if(o[z]>-w){M=z;break}w=-(w=Math.abs(o[M]-w)<Math.abs(o[M-1]-w)||"next"===t.swipeDirection?o[M]:o[M-1])}if(T&&t.once("transitionEnd",(function(){t.loopFix()})),0!==t.velocity){if(g=r?Math.abs((-w-t.translate)/t.velocity):Math.abs((w-t.translate)/t.velocity),i.freeModeSticky){var P=Math.abs((r?-w:w)-t.translate),k=t.slidesSizesGrid[t.activeIndex];g=P<k?i.speed:P<2*k?1.5*i.speed:2.5*i.speed}}else if(i.freeModeSticky)return void t.slideToClosest();i.freeModeMomentumBounce&&C?(t.updateProgress(y),t.setTransition(g),t.setTranslate(w),t.transitionStart(!0,t.swipeDirection),t.animating=!0,n.transitionEnd((function(){t&&!t.destroyed&&a.allowMomentumBounce&&(t.emit("momentumBounce"),t.setTransition(i.speed),setTimeout((function(){t.setTranslate(y),n.transitionEnd((function(){t&&!t.destroyed&&t.transitionEnd()}))}),0))}))):t.velocity?(t.updateProgress(w),t.setTransition(g),t.setTranslate(w),t.transitionStart(!0,t.swipeDirection),t.animating||(t.animating=!0,n.transitionEnd((function(){t&&!t.destroyed&&t.transitionEnd()})))):(t.emit("_freeModeNoMomentumRelease"),t.updateProgress(w)),t.updateActiveIndex(),t.updateSlidesClasses()}else{if(i.freeModeSticky)return void t.slideToClosest();i.freeMode&&t.emit("_freeModeNoMomentumRelease")}(!i.freeModeMomentum||c>=i.longSwipesMs)&&(t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses())}else{for(var $=0,L=t.slidesSizesGrid[0],I=0;I<l.length;I+=I<i.slidesPerGroupSkip?1:i.slidesPerGroup){var O=I<i.slidesPerGroupSkip-1?1:i.slidesPerGroup;void 0!==l[I+O]?p>=l[I]&&p<l[I+O]&&($=I,L=l[I+O]-l[I]):p>=l[I]&&($=I,L=l[l.length-1]-l[l.length-2])}var A=(p-l[$])/L,D=$<i.slidesPerGroupSkip-1?1:i.slidesPerGroup;if(c>i.longSwipesMs){if(!i.longSwipes)return void t.slideTo(t.activeIndex);"next"===t.swipeDirection&&(A>=i.longSwipesRatio?t.slideTo($+D):t.slideTo($)),"prev"===t.swipeDirection&&(A>1-i.longSwipesRatio?t.slideTo($+D):t.slideTo($))}else{if(!i.shortSwipes)return void t.slideTo(t.activeIndex);t.navigation&&(d.target===t.navigation.nextEl||d.target===t.navigation.prevEl)?d.target===t.navigation.nextEl?t.slideTo($+D):t.slideTo($):("next"===t.swipeDirection&&t.slideTo($+D),"prev"===t.swipeDirection&&t.slideTo($))}}}}function H(){var e=this,t=e.params,a=e.el;if(!a||0!==a.offsetWidth){t.breakpoints&&e.setBreakpoint();var i=e.allowSlideNext,s=e.allowSlidePrev,r=e.snapGrid;e.allowSlideNext=!0,e.allowSlidePrev=!0,e.updateSize(),e.updateSlides(),e.updateSlidesClasses(),("auto"===t.slidesPerView||t.slidesPerView>1)&&e.isEnd&&!e.isBeginning&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0),e.autoplay&&e.autoplay.running&&e.autoplay.paused&&e.autoplay.run(),e.allowSlidePrev=s,e.allowSlideNext=i,e.params.watchOverflow&&r!==e.snapGrid&&e.checkOverflow()}}function R(e){var t=this;t.enabled&&(t.allowClick||(t.params.preventClicks&&e.preventDefault(),t.params.preventClicksPropagation&&t.animating&&(e.stopPropagation(),e.stopImmediatePropagation())))}function X(){var e=this,t=e.wrapperEl,a=e.rtlTranslate;if(e.enabled){e.previousTranslate=e.translate,e.isHorizontal()?e.translate=a?t.scrollWidth-t.offsetWidth-t.scrollLeft:-t.scrollLeft:e.translate=-t.scrollTop,-0===e.translate&&(e.translate=0),e.updateActiveIndex(),e.updateSlidesClasses();var i=e.maxTranslate()-e.minTranslate();(0===i?0:(e.translate-e.minTranslate())/i)!==e.progress&&e.updateProgress(a?-e.translate:e.translate),e.emit("setTranslate",e.translate,!1)}}var Y=!1;function V(){}var W={init:!0,direction:"horizontal",touchEventsTarget:"container",initialSlide:0,speed:300,cssMode:!1,updateOnWindowResize:!0,resizeObserver:!1,nested:!1,createElements:!1,enabled:!0,focusableElements:"input, select, option, textarea, button, video, label",width:null,height:null,preventInteractionOnTransition:!1,userAgent:null,url:null,edgeSwipeDetection:!1,edgeSwipeThreshold:20,freeMode:!1,freeModeMomentum:!0,freeModeMomentumRatio:1,freeModeMomentumBounce:!0,freeModeMomentumBounceRatio:1,freeModeMomentumVelocityRatio:1,freeModeSticky:!1,freeModeMinimumVelocity:.02,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",breakpoints:void 0,breakpointsBase:"window",spaceBetween:0,slidesPerView:1,slidesPerColumn:1,slidesPerColumnFill:"column",slidesPerGroup:1,slidesPerGroupSkip:0,centeredSlides:!1,centeredSlidesBounds:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,normalizeSlideIndex:!0,centerInsufficientSlides:!1,watchOverflow:!1,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,allowTouchMove:!0,threshold:0,touchMoveStopPropagation:!1,touchStartPreventDefault:!0,touchStartForcePreventDefault:!1,touchReleaseOnEdges:!1,uniqueNavElements:!0,resistance:!0,resistanceRatio:.85,watchSlidesProgress:!1,watchSlidesVisibility:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,preloadImages:!0,updateOnImagesReady:!0,loop:!1,loopAdditionalSlides:0,loopedSlides:null,loopFillGroupWithBlank:!1,loopPreventsSlide:!0,allowSlidePrev:!0,allowSlideNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",noSwipingSelector:null,passiveListeners:!0,containerModifierClass:"swiper-container-",slideClass:"swiper-slide",slideBlankClass:"swiper-slide-invisible-blank",slideActiveClass:"swiper-slide-active",slideDuplicateActiveClass:"swiper-slide-duplicate-active",slideVisibleClass:"swiper-slide-visible",slideDuplicateClass:"swiper-slide-duplicate",slideNextClass:"swiper-slide-next",slideDuplicateNextClass:"swiper-slide-duplicate-next",slidePrevClass:"swiper-slide-prev",slideDuplicatePrevClass:"swiper-slide-duplicate-prev",wrapperClass:"swiper-wrapper",runCallbacksOnInit:!0,_emitClasses:!1},F={modular:{useParams:function(e){var t=this;t.modules&&Object.keys(t.modules).forEach((function(a){var i=t.modules[a];i.params&&M(e,i.params)}))},useModules:function(e){void 0===e&&(e={});var t=this;t.modules&&Object.keys(t.modules).forEach((function(a){var i=t.modules[a],s=e[a]||{};i.on&&t.on&&Object.keys(i.on).forEach((function(e){t.on(e,i.on[e])})),i.create&&i.create.bind(t)(s)}))}},eventsEmitter:{on:function(e,t,a){var i=this;if("function"!=typeof t)return i;var s=a?"unshift":"push";return e.split(" ").forEach((function(e){i.eventsListeners[e]||(i.eventsListeners[e]=[]),i.eventsListeners[e][s](t)})),i},once:function(e,t,a){var i=this;if("function"!=typeof t)return i;function s(){i.off(e,s),s.__emitterProxy&&delete s.__emitterProxy;for(var a=arguments.length,r=new Array(a),n=0;n<a;n++)r[n]=arguments[n];t.apply(i,r)}return s.__emitterProxy=t,i.on(e,s,a)},onAny:function(e,t){var a=this;if("function"!=typeof e)return a;var i=t?"unshift":"push";return a.eventsAnyListeners.indexOf(e)<0&&a.eventsAnyListeners[i](e),a},offAny:function(e){var t=this;if(!t.eventsAnyListeners)return t;var a=t.eventsAnyListeners.indexOf(e);return a>=0&&t.eventsAnyListeners.splice(a,1),t},off:function(e,t){var a=this;return a.eventsListeners?(e.split(" ").forEach((function(e){void 0===t?a.eventsListeners[e]=[]:a.eventsListeners[e]&&a.eventsListeners[e].forEach((function(i,s){(i===t||i.__emitterProxy&&i.__emitterProxy===t)&&a.eventsListeners[e].splice(s,1)}))})),a):a},emit:function(){var e,t,a,i=this;if(!i.eventsListeners)return i;for(var s=arguments.length,r=new Array(s),n=0;n<s;n++)r[n]=arguments[n];"string"==typeof r[0]||Array.isArray(r[0])?(e=r[0],t=r.slice(1,r.length),a=i):(e=r[0].events,t=r[0].data,a=r[0].context||i),t.unshift(a);var l=Array.isArray(e)?e:e.split(" ");return l.forEach((function(e){i.eventsAnyListeners&&i.eventsAnyListeners.length&&i.eventsAnyListeners.forEach((function(i){i.apply(a,[e].concat(t))})),i.eventsListeners&&i.eventsListeners[e]&&i.eventsListeners[e].forEach((function(e){e.apply(a,t)}))})),i}},update:{updateSize:function(){var e,t,a=this,i=a.$el;e=void 0!==a.params.width&&null!==a.params.width?a.params.width:i[0].clientWidth,t=void 0!==a.params.height&&null!==a.params.height?a.params.height:i[0].clientHeight,0===e&&a.isHorizontal()||0===t&&a.isVertical()||(e=e-parseInt(i.css("padding-left")||0,10)-parseInt(i.css("padding-right")||0,10),t=t-parseInt(i.css("padding-top")||0,10)-parseInt(i.css("padding-bottom")||0,10),Number.isNaN(e)&&(e=0),Number.isNaN(t)&&(t=0),M(a,{width:e,height:t,size:a.isHorizontal()?e:t}))},updateSlides:function(){var e=this;function t(t){return e.isHorizontal()?t:{width:"height","margin-top":"margin-left","margin-bottom ":"margin-right","margin-left":"margin-top","margin-right":"margin-bottom","padding-left":"padding-top","padding-right":"padding-bottom",marginRight:"marginBottom"}[t]}function a(e,a){return parseFloat(e.getPropertyValue(t(a))||0)}var i=e.params,s=e.$wrapperEl,r=e.size,n=e.rtlTranslate,l=e.wrongRTL,o=e.virtual&&i.virtual.enabled,d=o?e.virtual.slides.length:e.slides.length,p=s.children("."+e.params.slideClass),u=o?e.virtual.slides.length:p.length,c=[],h=[],v=[],f=i.slidesOffsetBefore;"function"==typeof f&&(f=i.slidesOffsetBefore.call(e));var m=i.slidesOffsetAfter;"function"==typeof m&&(m=i.slidesOffsetAfter.call(e));var g=e.snapGrid.length,b=e.slidesGrid.length,w=i.spaceBetween,y=-f,E=0,x=0;if(void 0!==r){var T,C;"string"==typeof w&&w.indexOf("%")>=0&&(w=parseFloat(w.replace("%",""))/100*r),e.virtualSize=-w,n?p.css({marginLeft:"",marginBottom:"",marginTop:""}):p.css({marginRight:"",marginBottom:"",marginTop:""}),i.slidesPerColumn>1&&(T=Math.floor(u/i.slidesPerColumn)===u/e.params.slidesPerColumn?u:Math.ceil(u/i.slidesPerColumn)*i.slidesPerColumn,"auto"!==i.slidesPerView&&"row"===i.slidesPerColumnFill&&(T=Math.max(T,i.slidesPerView*i.slidesPerColumn)));for(var S,z,P,k=i.slidesPerColumn,$=T/k,L=Math.floor(u/i.slidesPerColumn),I=0;I<u;I+=1){C=0;var O=p.eq(I);if(i.slidesPerColumn>1){var A=void 0,D=void 0,N=void 0;if("row"===i.slidesPerColumnFill&&i.slidesPerGroup>1){var G=Math.floor(I/(i.slidesPerGroup*i.slidesPerColumn)),B=I-i.slidesPerColumn*i.slidesPerGroup*G,H=0===G?i.slidesPerGroup:Math.min(Math.ceil((u-G*k*i.slidesPerGroup)/k),i.slidesPerGroup);A=(D=B-(N=Math.floor(B/H))*H+G*i.slidesPerGroup)+N*T/k,O.css({"-webkit-box-ordinal-group":A,"-moz-box-ordinal-group":A,"-ms-flex-order":A,"-webkit-order":A,order:A})}else"column"===i.slidesPerColumnFill?(N=I-(D=Math.floor(I/k))*k,(D>L||D===L&&N===k-1)&&(N+=1)>=k&&(N=0,D+=1)):D=I-(N=Math.floor(I/$))*$;O.css(t("margin-top"),0!==N?i.spaceBetween&&i.spaceBetween+"px":"")}if("none"!==O.css("display")){if("auto"===i.slidesPerView){var R=getComputedStyle(O[0]),X=O[0].style.transform,Y=O[0].style.webkitTransform;if(X&&(O[0].style.transform="none"),Y&&(O[0].style.webkitTransform="none"),i.roundLengths)C=e.isHorizontal()?O.outerWidth(!0):O.outerHeight(!0);else{var V=a(R,"width"),W=a(R,"padding-left"),F=a(R,"padding-right"),_=a(R,"margin-left"),q=a(R,"margin-right"),j=R.getPropertyValue("box-sizing");if(j&&"border-box"===j)C=V+_+q;else{var U=O[0],K=U.clientWidth;C=V+W+F+_+q+(U.offsetWidth-K)}}X&&(O[0].style.transform=X),Y&&(O[0].style.webkitTransform=Y),i.roundLengths&&(C=Math.floor(C))}else C=(r-(i.slidesPerView-1)*w)/i.slidesPerView,i.roundLengths&&(C=Math.floor(C)),p[I]&&(p[I].style[t("width")]=C+"px");p[I]&&(p[I].swiperSlideSize=C),v.push(C),i.centeredSlides?(y=y+C/2+E/2+w,0===E&&0!==I&&(y=y-r/2-w),0===I&&(y=y-r/2-w),Math.abs(y)<.001&&(y=0),i.roundLengths&&(y=Math.floor(y)),x%i.slidesPerGroup==0&&c.push(y),h.push(y)):(i.roundLengths&&(y=Math.floor(y)),(x-Math.min(e.params.slidesPerGroupSkip,x))%e.params.slidesPerGroup==0&&c.push(y),h.push(y),y=y+C+w),e.virtualSize+=C+w,E=C,x+=1}}if(e.virtualSize=Math.max(e.virtualSize,r)+m,n&&l&&("slide"===i.effect||"coverflow"===i.effect)&&s.css({width:e.virtualSize+i.spaceBetween+"px"}),i.setWrapperSize)s.css(((z={})[t("width")]=e.virtualSize+i.spaceBetween+"px",z));if(i.slidesPerColumn>1)if(e.virtualSize=(C+i.spaceBetween)*T,e.virtualSize=Math.ceil(e.virtualSize/i.slidesPerColumn)-i.spaceBetween,s.css(((P={})[t("width")]=e.virtualSize+i.spaceBetween+"px",P)),i.centeredSlides){S=[];for(var Z=0;Z<c.length;Z+=1){var J=c[Z];i.roundLengths&&(J=Math.floor(J)),c[Z]<e.virtualSize+c[0]&&S.push(J)}c=S}if(!i.centeredSlides){S=[];for(var Q=0;Q<c.length;Q+=1){var ee=c[Q];i.roundLengths&&(ee=Math.floor(ee)),c[Q]<=e.virtualSize-r&&S.push(ee)}c=S,Math.floor(e.virtualSize-r)-Math.floor(c[c.length-1])>1&&c.push(e.virtualSize-r)}if(0===c.length&&(c=[0]),0!==i.spaceBetween){var te,ae=e.isHorizontal()&&n?"marginLeft":t("marginRight");p.filter((function(e,t){return!i.cssMode||t!==p.length-1})).css(((te={})[ae]=w+"px",te))}if(i.centeredSlides&&i.centeredSlidesBounds){var ie=0;v.forEach((function(e){ie+=e+(i.spaceBetween?i.spaceBetween:0)}));var se=(ie-=i.spaceBetween)-r;c=c.map((function(e){return e<0?-f:e>se?se+m:e}))}if(i.centerInsufficientSlides){var re=0;if(v.forEach((function(e){re+=e+(i.spaceBetween?i.spaceBetween:0)})),(re-=i.spaceBetween)<r){var ne=(r-re)/2;c.forEach((function(e,t){c[t]=e-ne})),h.forEach((function(e,t){h[t]=e+ne}))}}M(e,{slides:p,snapGrid:c,slidesGrid:h,slidesSizesGrid:v}),u!==d&&e.emit("slidesLengthChange"),c.length!==g&&(e.params.watchOverflow&&e.checkOverflow(),e.emit("snapGridLengthChange")),h.length!==b&&e.emit("slidesGridLengthChange"),(i.watchSlidesProgress||i.watchSlidesVisibility)&&e.updateSlidesOffset()}},updateAutoHeight:function(e){var t,a=this,i=[],s=a.virtual&&a.params.virtual.enabled,r=0;"number"==typeof e?a.setTransition(e):!0===e&&a.setTransition(a.params.speed);var n=function(e){return s?a.slides.filter((function(t){return parseInt(t.getAttribute("data-swiper-slide-index"),10)===e}))[0]:a.slides.eq(e)[0]};if("auto"!==a.params.slidesPerView&&a.params.slidesPerView>1)if(a.params.centeredSlides)a.visibleSlides.each((function(e){i.push(e)}));else for(t=0;t<Math.ceil(a.params.slidesPerView);t+=1){var l=a.activeIndex+t;if(l>a.slides.length&&!s)break;i.push(n(l))}else i.push(n(a.activeIndex));for(t=0;t<i.length;t+=1)if(void 0!==i[t]){var o=i[t].offsetHeight;r=o>r?o:r}r&&a.$wrapperEl.css("height",r+"px")},updateSlidesOffset:function(){for(var e=this.slides,t=0;t<e.length;t+=1)e[t].swiperSlideOffset=this.isHorizontal()?e[t].offsetLeft:e[t].offsetTop},updateSlidesProgress:function(e){void 0===e&&(e=this&&this.translate||0);var t=this,a=t.params,i=t.slides,s=t.rtlTranslate;if(0!==i.length){void 0===i[0].swiperSlideOffset&&t.updateSlidesOffset();var r=-e;s&&(r=e),i.removeClass(a.slideVisibleClass),t.visibleSlidesIndexes=[],t.visibleSlides=[];for(var n=0;n<i.length;n+=1){var l=i[n],o=(r+(a.centeredSlides?t.minTranslate():0)-l.swiperSlideOffset)/(l.swiperSlideSize+a.spaceBetween);if(a.watchSlidesVisibility||a.centeredSlides&&a.autoHeight){var d=-(r-l.swiperSlideOffset),p=d+t.slidesSizesGrid[n];(d>=0&&d<t.size-1||p>1&&p<=t.size||d<=0&&p>=t.size)&&(t.visibleSlides.push(l),t.visibleSlidesIndexes.push(n),i.eq(n).addClass(a.slideVisibleClass))}l.progress=s?-o:o}t.visibleSlides=m(t.visibleSlides)}},updateProgress:function(e){var t=this;if(void 0===e){var a=t.rtlTranslate?-1:1;e=t&&t.translate&&t.translate*a||0}var i=t.params,s=t.maxTranslate()-t.minTranslate(),r=t.progress,n=t.isBeginning,l=t.isEnd,o=n,d=l;0===s?(r=0,n=!0,l=!0):(n=(r=(e-t.minTranslate())/s)<=0,l=r>=1),M(t,{progress:r,isBeginning:n,isEnd:l}),(i.watchSlidesProgress||i.watchSlidesVisibility||i.centeredSlides&&i.autoHeight)&&t.updateSlidesProgress(e),n&&!o&&t.emit("reachBeginning toEdge"),l&&!d&&t.emit("reachEnd toEdge"),(o&&!n||d&&!l)&&t.emit("fromEdge"),t.emit("progress",r)},updateSlidesClasses:function(){var e,t=this,a=t.slides,i=t.params,s=t.$wrapperEl,r=t.activeIndex,n=t.realIndex,l=t.virtual&&i.virtual.enabled;a.removeClass(i.slideActiveClass+" "+i.slideNextClass+" "+i.slidePrevClass+" "+i.slideDuplicateActiveClass+" "+i.slideDuplicateNextClass+" "+i.slideDuplicatePrevClass),(e=l?t.$wrapperEl.find("."+i.slideClass+'[data-swiper-slide-index="'+r+'"]'):a.eq(r)).addClass(i.slideActiveClass),i.loop&&(e.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+n+'"]').addClass(i.slideDuplicateActiveClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+n+'"]').addClass(i.slideDuplicateActiveClass));var o=e.nextAll("."+i.slideClass).eq(0).addClass(i.slideNextClass);i.loop&&0===o.length&&(o=a.eq(0)).addClass(i.slideNextClass);var d=e.prevAll("."+i.slideClass).eq(0).addClass(i.slidePrevClass);i.loop&&0===d.length&&(d=a.eq(-1)).addClass(i.slidePrevClass),i.loop&&(o.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+o.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicateNextClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+o.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicateNextClass),d.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+d.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicatePrevClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+d.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicatePrevClass)),t.emitSlidesClasses()},updateActiveIndex:function(e){var t,a=this,i=a.rtlTranslate?a.translate:-a.translate,s=a.slidesGrid,r=a.snapGrid,n=a.params,l=a.activeIndex,o=a.realIndex,d=a.snapIndex,p=e;if(void 0===p){for(var u=0;u<s.length;u+=1)void 0!==s[u+1]?i>=s[u]&&i<s[u+1]-(s[u+1]-s[u])/2?p=u:i>=s[u]&&i<s[u+1]&&(p=u+1):i>=s[u]&&(p=u);n.normalizeSlideIndex&&(p<0||void 0===p)&&(p=0)}if(r.indexOf(i)>=0)t=r.indexOf(i);else{var c=Math.min(n.slidesPerGroupSkip,p);t=c+Math.floor((p-c)/n.slidesPerGroup)}if(t>=r.length&&(t=r.length-1),p!==l){var h=parseInt(a.slides.eq(p).attr("data-swiper-slide-index")||p,10);M(a,{snapIndex:t,realIndex:h,previousIndex:l,activeIndex:p}),a.emit("activeIndexChange"),a.emit("snapIndexChange"),o!==h&&a.emit("realIndexChange"),(a.initialized||a.params.runCallbacksOnInit)&&a.emit("slideChange")}else t!==d&&(a.snapIndex=t,a.emit("snapIndexChange"))},updateClickedSlide:function(e){var t,a=this,i=a.params,s=m(e.target).closest("."+i.slideClass)[0],r=!1;if(s)for(var n=0;n<a.slides.length;n+=1)if(a.slides[n]===s){r=!0,t=n;break}if(!s||!r)return a.clickedSlide=void 0,void(a.clickedIndex=void 0);a.clickedSlide=s,a.virtual&&a.params.virtual.enabled?a.clickedIndex=parseInt(m(s).attr("data-swiper-slide-index"),10):a.clickedIndex=t,i.slideToClickedSlide&&void 0!==a.clickedIndex&&a.clickedIndex!==a.activeIndex&&a.slideToClickedSlide()}},translate:{getTranslate:function(e){void 0===e&&(e=this.isHorizontal()?"x":"y");var t=this,a=t.params,i=t.rtlTranslate,s=t.translate,r=t.$wrapperEl;if(a.virtualTranslate)return i?-s:s;if(a.cssMode)return s;var n=T(r[0],e);return i&&(n=-n),n||0},setTranslate:function(e,t){var a=this,i=a.rtlTranslate,s=a.params,r=a.$wrapperEl,n=a.wrapperEl,l=a.progress,o=0,d=0;a.isHorizontal()?o=i?-e:e:d=e,s.roundLengths&&(o=Math.floor(o),d=Math.floor(d)),s.cssMode?n[a.isHorizontal()?"scrollLeft":"scrollTop"]=a.isHorizontal()?-o:-d:s.virtualTranslate||r.transform("translate3d("+o+"px, "+d+"px, 0px)"),a.previousTranslate=a.translate,a.translate=a.isHorizontal()?o:d;var p=a.maxTranslate()-a.minTranslate();(0===p?0:(e-a.minTranslate())/p)!==l&&a.updateProgress(e),a.emit("setTranslate",a.translate,t)},minTranslate:function(){return-this.snapGrid[0]},maxTranslate:function(){return-this.snapGrid[this.snapGrid.length-1]},translateTo:function(e,t,a,i,s){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===a&&(a=!0),void 0===i&&(i=!0);var r=this,n=r.params,l=r.wrapperEl;if(r.animating&&n.preventInteractionOnTransition)return!1;var o,d=r.minTranslate(),p=r.maxTranslate();if(o=i&&e>d?d:i&&e<p?p:e,r.updateProgress(o),n.cssMode){var u,c=r.isHorizontal();if(0===t)l[c?"scrollLeft":"scrollTop"]=-o;else if(l.scrollTo)l.scrollTo(((u={})[c?"left":"top"]=-o,u.behavior="smooth",u));else l[c?"scrollLeft":"scrollTop"]=-o;return!0}return 0===t?(r.setTransition(0),r.setTranslate(o),a&&(r.emit("beforeTransitionStart",t,s),r.emit("transitionEnd"))):(r.setTransition(t),r.setTranslate(o),a&&(r.emit("beforeTransitionStart",t,s),r.emit("transitionStart")),r.animating||(r.animating=!0,r.onTranslateToWrapperTransitionEnd||(r.onTranslateToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.$wrapperEl[0].removeEventListener("transitionend",r.onTranslateToWrapperTransitionEnd),r.$wrapperEl[0].removeEventListener("webkitTransitionEnd",r.onTranslateToWrapperTransitionEnd),r.onTranslateToWrapperTransitionEnd=null,delete r.onTranslateToWrapperTransitionEnd,a&&r.emit("transitionEnd"))}),r.$wrapperEl[0].addEventListener("transitionend",r.onTranslateToWrapperTransitionEnd),r.$wrapperEl[0].addEventListener("webkitTransitionEnd",r.onTranslateToWrapperTransitionEnd))),!0}},transition:{setTransition:function(e,t){var a=this;a.params.cssMode||a.$wrapperEl.transition(e),a.emit("setTransition",e,t)},transitionStart:function(e,t){void 0===e&&(e=!0);var a=this,i=a.activeIndex,s=a.params,r=a.previousIndex;if(!s.cssMode){s.autoHeight&&a.updateAutoHeight();var n=t;if(n||(n=i>r?"next":i<r?"prev":"reset"),a.emit("transitionStart"),e&&i!==r){if("reset"===n)return void a.emit("slideResetTransitionStart");a.emit("slideChangeTransitionStart"),"next"===n?a.emit("slideNextTransitionStart"):a.emit("slidePrevTransitionStart")}}},transitionEnd:function(e,t){void 0===e&&(e=!0);var a=this,i=a.activeIndex,s=a.previousIndex,r=a.params;if(a.animating=!1,!r.cssMode){a.setTransition(0);var n=t;if(n||(n=i>s?"next":i<s?"prev":"reset"),a.emit("transitionEnd"),e&&i!==s){if("reset"===n)return void a.emit("slideResetTransitionEnd");a.emit("slideChangeTransitionEnd"),"next"===n?a.emit("slideNextTransitionEnd"):a.emit("slidePrevTransitionEnd")}}}},slide:{slideTo:function(e,t,a,i,s){if(void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===a&&(a=!0),"number"!=typeof e&&"string"!=typeof e)throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. ["+typeof e+"] given.");if("string"==typeof e){var r=parseInt(e,10);if(!isFinite(r))throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. ["+e+"] given.");e=r}var n=this,l=e;l<0&&(l=0);var o=n.params,d=n.snapGrid,p=n.slidesGrid,u=n.previousIndex,c=n.activeIndex,h=n.rtlTranslate,v=n.wrapperEl,f=n.enabled;if(n.animating&&o.preventInteractionOnTransition||!f&&!i&&!s)return!1;var m=Math.min(n.params.slidesPerGroupSkip,l),g=m+Math.floor((l-m)/n.params.slidesPerGroup);g>=d.length&&(g=d.length-1),(c||o.initialSlide||0)===(u||0)&&a&&n.emit("beforeSlideChangeStart");var b,w=-d[g];if(n.updateProgress(w),o.normalizeSlideIndex)for(var y=0;y<p.length;y+=1){var E=-Math.floor(100*w),x=Math.floor(100*p[y]),T=Math.floor(100*p[y+1]);void 0!==p[y+1]?E>=x&&E<T-(T-x)/2?l=y:E>=x&&E<T&&(l=y+1):E>=x&&(l=y)}if(n.initialized&&l!==c){if(!n.allowSlideNext&&w<n.translate&&w<n.minTranslate())return!1;if(!n.allowSlidePrev&&w>n.translate&&w>n.maxTranslate()&&(c||0)!==l)return!1}if(b=l>c?"next":l<c?"prev":"reset",h&&-w===n.translate||!h&&w===n.translate)return n.updateActiveIndex(l),o.autoHeight&&n.updateAutoHeight(),n.updateSlidesClasses(),"slide"!==o.effect&&n.setTranslate(w),"reset"!==b&&(n.transitionStart(a,b),n.transitionEnd(a,b)),!1;if(o.cssMode){var C,S=n.isHorizontal(),M=-w;if(h&&(M=v.scrollWidth-v.offsetWidth-M),0===t)v[S?"scrollLeft":"scrollTop"]=M;else if(v.scrollTo)v.scrollTo(((C={})[S?"left":"top"]=M,C.behavior="smooth",C));else v[S?"scrollLeft":"scrollTop"]=M;return!0}return 0===t?(n.setTransition(0),n.setTranslate(w),n.updateActiveIndex(l),n.updateSlidesClasses(),n.emit("beforeTransitionStart",t,i),n.transitionStart(a,b),n.transitionEnd(a,b)):(n.setTransition(t),n.setTranslate(w),n.updateActiveIndex(l),n.updateSlidesClasses(),n.emit("beforeTransitionStart",t,i),n.transitionStart(a,b),n.animating||(n.animating=!0,n.onSlideToWrapperTransitionEnd||(n.onSlideToWrapperTransitionEnd=function(e){n&&!n.destroyed&&e.target===this&&(n.$wrapperEl[0].removeEventListener("transitionend",n.onSlideToWrapperTransitionEnd),n.$wrapperEl[0].removeEventListener("webkitTransitionEnd",n.onSlideToWrapperTransitionEnd),n.onSlideToWrapperTransitionEnd=null,delete n.onSlideToWrapperTransitionEnd,n.transitionEnd(a,b))}),n.$wrapperEl[0].addEventListener("transitionend",n.onSlideToWrapperTransitionEnd),n.$wrapperEl[0].addEventListener("webkitTransitionEnd",n.onSlideToWrapperTransitionEnd))),!0},slideToLoop:function(e,t,a,i){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===a&&(a=!0);var s=this,r=e;return s.params.loop&&(r+=s.loopedSlides),s.slideTo(r,t,a,i)},slideNext:function(e,t,a){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);var i=this,s=i.params,r=i.animating;if(!i.enabled)return i;var n=i.activeIndex<s.slidesPerGroupSkip?1:s.slidesPerGroup;if(s.loop){if(r&&s.loopPreventsSlide)return!1;i.loopFix(),i._clientLeft=i.$wrapperEl[0].clientLeft}return i.slideTo(i.activeIndex+n,e,t,a)},slidePrev:function(e,t,a){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);var i=this,s=i.params,r=i.animating,n=i.snapGrid,l=i.slidesGrid,o=i.rtlTranslate;if(!i.enabled)return i;if(s.loop){if(r&&s.loopPreventsSlide)return!1;i.loopFix(),i._clientLeft=i.$wrapperEl[0].clientLeft}function d(e){return e<0?-Math.floor(Math.abs(e)):Math.floor(e)}var p,u=d(o?i.translate:-i.translate),c=n.map((function(e){return d(e)})),h=n[c.indexOf(u)-1];return void 0===h&&s.cssMode&&n.forEach((function(e){!h&&u>=e&&(h=e)})),void 0!==h&&(p=l.indexOf(h))<0&&(p=i.activeIndex-1),i.slideTo(p,e,t,a)},slideReset:function(e,t,a){return void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),this.slideTo(this.activeIndex,e,t,a)},slideToClosest:function(e,t,a,i){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),void 0===i&&(i=.5);var s=this,r=s.activeIndex,n=Math.min(s.params.slidesPerGroupSkip,r),l=n+Math.floor((r-n)/s.params.slidesPerGroup),o=s.rtlTranslate?s.translate:-s.translate;if(o>=s.snapGrid[l]){var d=s.snapGrid[l];o-d>(s.snapGrid[l+1]-d)*i&&(r+=s.params.slidesPerGroup)}else{var p=s.snapGrid[l-1];o-p<=(s.snapGrid[l]-p)*i&&(r-=s.params.slidesPerGroup)}return r=Math.max(r,0),r=Math.min(r,s.slidesGrid.length-1),s.slideTo(r,e,t,a)},slideToClickedSlide:function(){var e,t=this,a=t.params,i=t.$wrapperEl,s="auto"===a.slidesPerView?t.slidesPerViewDynamic():a.slidesPerView,r=t.clickedIndex;if(a.loop){if(t.animating)return;e=parseInt(m(t.clickedSlide).attr("data-swiper-slide-index"),10),a.centeredSlides?r<t.loopedSlides-s/2||r>t.slides.length-t.loopedSlides+s/2?(t.loopFix(),r=i.children("."+a.slideClass+'[data-swiper-slide-index="'+e+'"]:not(.'+a.slideDuplicateClass+")").eq(0).index(),E((function(){t.slideTo(r)}))):t.slideTo(r):r>t.slides.length-s?(t.loopFix(),r=i.children("."+a.slideClass+'[data-swiper-slide-index="'+e+'"]:not(.'+a.slideDuplicateClass+")").eq(0).index(),E((function(){t.slideTo(r)}))):t.slideTo(r)}else t.slideTo(r)}},loop:{loopCreate:function(){var e=this,t=r(),a=e.params,i=e.$wrapperEl;i.children("."+a.slideClass+"."+a.slideDuplicateClass).remove();var s=i.children("."+a.slideClass);if(a.loopFillGroupWithBlank){var n=a.slidesPerGroup-s.length%a.slidesPerGroup;if(n!==a.slidesPerGroup){for(var l=0;l<n;l+=1){var o=m(t.createElement("div")).addClass(a.slideClass+" "+a.slideBlankClass);i.append(o)}s=i.children("."+a.slideClass)}}"auto"!==a.slidesPerView||a.loopedSlides||(a.loopedSlides=s.length),e.loopedSlides=Math.ceil(parseFloat(a.loopedSlides||a.slidesPerView,10)),e.loopedSlides+=a.loopAdditionalSlides,e.loopedSlides>s.length&&(e.loopedSlides=s.length);var d=[],p=[];s.each((function(t,a){var i=m(t);a<e.loopedSlides&&p.push(t),a<s.length&&a>=s.length-e.loopedSlides&&d.push(t),i.attr("data-swiper-slide-index",a)}));for(var u=0;u<p.length;u+=1)i.append(m(p[u].cloneNode(!0)).addClass(a.slideDuplicateClass));for(var c=d.length-1;c>=0;c-=1)i.prepend(m(d[c].cloneNode(!0)).addClass(a.slideDuplicateClass))},loopFix:function(){var e=this;e.emit("beforeLoopFix");var t,a=e.activeIndex,i=e.slides,s=e.loopedSlides,r=e.allowSlidePrev,n=e.allowSlideNext,l=e.snapGrid,o=e.rtlTranslate;e.allowSlidePrev=!0,e.allowSlideNext=!0;var d=-l[a]-e.getTranslate();if(a<s)t=i.length-3*s+a,t+=s,e.slideTo(t,0,!1,!0)&&0!==d&&e.setTranslate((o?-e.translate:e.translate)-d);else if(a>=i.length-s){t=-i.length+a+s,t+=s,e.slideTo(t,0,!1,!0)&&0!==d&&e.setTranslate((o?-e.translate:e.translate)-d)}e.allowSlidePrev=r,e.allowSlideNext=n,e.emit("loopFix")},loopDestroy:function(){var e=this,t=e.$wrapperEl,a=e.params,i=e.slides;t.children("."+a.slideClass+"."+a.slideDuplicateClass+",."+a.slideClass+"."+a.slideBlankClass).remove(),i.removeAttr("data-swiper-slide-index")}},grabCursor:{setGrabCursor:function(e){var t=this;if(!(t.support.touch||!t.params.simulateTouch||t.params.watchOverflow&&t.isLocked||t.params.cssMode)){var a=t.el;a.style.cursor="move",a.style.cursor=e?"-webkit-grabbing":"-webkit-grab",a.style.cursor=e?"-moz-grabbin":"-moz-grab",a.style.cursor=e?"grabbing":"grab"}},unsetGrabCursor:function(){var e=this;e.support.touch||e.params.watchOverflow&&e.isLocked||e.params.cssMode||(e.el.style.cursor="")}},manipulation:{appendSlide:function(e){var t=this,a=t.$wrapperEl,i=t.params;if(i.loop&&t.loopDestroy(),"object"==typeof e&&"length"in e)for(var s=0;s<e.length;s+=1)e[s]&&a.append(e[s]);else a.append(e);i.loop&&t.loopCreate(),i.observer&&t.support.observer||t.update()},prependSlide:function(e){var t=this,a=t.params,i=t.$wrapperEl,s=t.activeIndex;a.loop&&t.loopDestroy();var r=s+1;if("object"==typeof e&&"length"in e){for(var n=0;n<e.length;n+=1)e[n]&&i.prepend(e[n]);r=s+e.length}else i.prepend(e);a.loop&&t.loopCreate(),a.observer&&t.support.observer||t.update(),t.slideTo(r,0,!1)},addSlide:function(e,t){var a=this,i=a.$wrapperEl,s=a.params,r=a.activeIndex;s.loop&&(r-=a.loopedSlides,a.loopDestroy(),a.slides=i.children("."+s.slideClass));var n=a.slides.length;if(e<=0)a.prependSlide(t);else if(e>=n)a.appendSlide(t);else{for(var l=r>e?r+1:r,o=[],d=n-1;d>=e;d-=1){var p=a.slides.eq(d);p.remove(),o.unshift(p)}if("object"==typeof t&&"length"in t){for(var u=0;u<t.length;u+=1)t[u]&&i.append(t[u]);l=r>e?r+t.length:r}else i.append(t);for(var c=0;c<o.length;c+=1)i.append(o[c]);s.loop&&a.loopCreate(),s.observer&&a.support.observer||a.update(),s.loop?a.slideTo(l+a.loopedSlides,0,!1):a.slideTo(l,0,!1)}},removeSlide:function(e){var t=this,a=t.params,i=t.$wrapperEl,s=t.activeIndex;a.loop&&(s-=t.loopedSlides,t.loopDestroy(),t.slides=i.children("."+a.slideClass));var r,n=s;if("object"==typeof e&&"length"in e){for(var l=0;l<e.length;l+=1)r=e[l],t.slides[r]&&t.slides.eq(r).remove(),r<n&&(n-=1);n=Math.max(n,0)}else r=e,t.slides[r]&&t.slides.eq(r).remove(),r<n&&(n-=1),n=Math.max(n,0);a.loop&&t.loopCreate(),a.observer&&t.support.observer||t.update(),a.loop?t.slideTo(n+t.loopedSlides,0,!1):t.slideTo(n,0,!1)},removeAllSlides:function(){for(var e=[],t=0;t<this.slides.length;t+=1)e.push(t);this.removeSlide(e)}},events:{attachEvents:function(){var e=this,t=r(),a=e.params,i=e.touchEvents,s=e.el,n=e.wrapperEl,l=e.device,o=e.support;e.onTouchStart=N.bind(e),e.onTouchMove=G.bind(e),e.onTouchEnd=B.bind(e),a.cssMode&&(e.onScroll=X.bind(e)),e.onClick=R.bind(e);var d=!!a.nested;if(!o.touch&&o.pointerEvents)s.addEventListener(i.start,e.onTouchStart,!1),t.addEventListener(i.move,e.onTouchMove,d),t.addEventListener(i.end,e.onTouchEnd,!1);else{if(o.touch){var p=!("touchstart"!==i.start||!o.passiveListener||!a.passiveListeners)&&{passive:!0,capture:!1};s.addEventListener(i.start,e.onTouchStart,p),s.addEventListener(i.move,e.onTouchMove,o.passiveListener?{passive:!1,capture:d}:d),s.addEventListener(i.end,e.onTouchEnd,p),i.cancel&&s.addEventListener(i.cancel,e.onTouchEnd,p),Y||(t.addEventListener("touchstart",V),Y=!0)}(a.simulateTouch&&!l.ios&&!l.android||a.simulateTouch&&!o.touch&&l.ios)&&(s.addEventListener("mousedown",e.onTouchStart,!1),t.addEventListener("mousemove",e.onTouchMove,d),t.addEventListener("mouseup",e.onTouchEnd,!1))}(a.preventClicks||a.preventClicksPropagation)&&s.addEventListener("click",e.onClick,!0),a.cssMode&&n.addEventListener("scroll",e.onScroll),a.updateOnWindowResize?e.on(l.ios||l.android?"resize orientationchange observerUpdate":"resize observerUpdate",H,!0):e.on("observerUpdate",H,!0)},detachEvents:function(){var e=this,t=r(),a=e.params,i=e.touchEvents,s=e.el,n=e.wrapperEl,l=e.device,o=e.support,d=!!a.nested;if(!o.touch&&o.pointerEvents)s.removeEventListener(i.start,e.onTouchStart,!1),t.removeEventListener(i.move,e.onTouchMove,d),t.removeEventListener(i.end,e.onTouchEnd,!1);else{if(o.touch){var p=!("onTouchStart"!==i.start||!o.passiveListener||!a.passiveListeners)&&{passive:!0,capture:!1};s.removeEventListener(i.start,e.onTouchStart,p),s.removeEventListener(i.move,e.onTouchMove,d),s.removeEventListener(i.end,e.onTouchEnd,p),i.cancel&&s.removeEventListener(i.cancel,e.onTouchEnd,p)}(a.simulateTouch&&!l.ios&&!l.android||a.simulateTouch&&!o.touch&&l.ios)&&(s.removeEventListener("mousedown",e.onTouchStart,!1),t.removeEventListener("mousemove",e.onTouchMove,d),t.removeEventListener("mouseup",e.onTouchEnd,!1))}(a.preventClicks||a.preventClicksPropagation)&&s.removeEventListener("click",e.onClick,!0),a.cssMode&&n.removeEventListener("scroll",e.onScroll),e.off(l.ios||l.android?"resize orientationchange observerUpdate":"resize observerUpdate",H)}},breakpoints:{setBreakpoint:function(){var e=this,t=e.activeIndex,a=e.initialized,i=e.loopedSlides,s=void 0===i?0:i,r=e.params,n=e.$el,l=r.breakpoints;if(l&&(!l||0!==Object.keys(l).length)){var o=e.getBreakpoint(l,e.params.breakpointsBase,e.el);if(o&&e.currentBreakpoint!==o){var d=o in l?l[o]:void 0;d&&["slidesPerView","spaceBetween","slidesPerGroup","slidesPerGroupSkip","slidesPerColumn"].forEach((function(e){var t=d[e];void 0!==t&&(d[e]="slidesPerView"!==e||"AUTO"!==t&&"auto"!==t?"slidesPerView"===e?parseFloat(t):parseInt(t,10):"auto")}));var p=d||e.originalParams,u=r.slidesPerColumn>1,c=p.slidesPerColumn>1,h=r.enabled;u&&!c?(n.removeClass(r.containerModifierClass+"multirow "+r.containerModifierClass+"multirow-column"),e.emitContainerClasses()):!u&&c&&(n.addClass(r.containerModifierClass+"multirow"),(p.slidesPerColumnFill&&"column"===p.slidesPerColumnFill||!p.slidesPerColumnFill&&"column"===r.slidesPerColumnFill)&&n.addClass(r.containerModifierClass+"multirow-column"),e.emitContainerClasses());var v=p.direction&&p.direction!==r.direction,f=r.loop&&(p.slidesPerView!==r.slidesPerView||v);v&&a&&e.changeDirection(),M(e.params,p);var m=e.params.enabled;M(e,{allowTouchMove:e.params.allowTouchMove,allowSlideNext:e.params.allowSlideNext,allowSlidePrev:e.params.allowSlidePrev}),h&&!m?e.disable():!h&&m&&e.enable(),e.currentBreakpoint=o,e.emit("_beforeBreakpoint",p),f&&a&&(e.loopDestroy(),e.loopCreate(),e.updateSlides(),e.slideTo(t-s+e.loopedSlides,0,!1)),e.emit("breakpoint",p)}}},getBreakpoint:function(e,t,a){if(void 0===t&&(t="window"),e&&("container"!==t||a)){var i=!1,s=l(),r="window"===t?s.innerHeight:a.clientHeight,n=Object.keys(e).map((function(e){if("string"==typeof e&&0===e.indexOf("@")){var t=parseFloat(e.substr(1));return{value:r*t,point:e}}return{value:e,point:e}}));n.sort((function(e,t){return parseInt(e.value,10)-parseInt(t.value,10)}));for(var o=0;o<n.length;o+=1){var d=n[o],p=d.point,u=d.value;"window"===t?s.matchMedia("(min-width: "+u+"px)").matches&&(i=p):u<=a.clientWidth&&(i=p)}return i||"max"}}},checkOverflow:{checkOverflow:function(){var e=this,t=e.params,a=e.isLocked,i=e.slides.length>0&&t.slidesOffsetBefore+t.spaceBetween*(e.slides.length-1)+e.slides[0].offsetWidth*e.slides.length;t.slidesOffsetBefore&&t.slidesOffsetAfter&&i?e.isLocked=i<=e.size:e.isLocked=1===e.snapGrid.length,e.allowSlideNext=!e.isLocked,e.allowSlidePrev=!e.isLocked,a!==e.isLocked&&e.emit(e.isLocked?"lock":"unlock"),a&&a!==e.isLocked&&(e.isEnd=!1,e.navigation&&e.navigation.update())}},classes:{addClasses:function(){var e,t,a,i=this,s=i.classNames,r=i.params,n=i.rtl,l=i.$el,o=i.device,d=i.support,p=(e=["initialized",r.direction,{"pointer-events":d.pointerEvents&&!d.touch},{"free-mode":r.freeMode},{autoheight:r.autoHeight},{rtl:n},{multirow:r.slidesPerColumn>1},{"multirow-column":r.slidesPerColumn>1&&"column"===r.slidesPerColumnFill},{android:o.android},{ios:o.ios},{"css-mode":r.cssMode}],t=r.containerModifierClass,a=[],e.forEach((function(e){"object"==typeof e?Object.keys(e).forEach((function(i){e[i]&&a.push(t+i)})):"string"==typeof e&&a.push(t+e)})),a);s.push.apply(s,p),l.addClass([].concat(s).join(" ")),i.emitContainerClasses()},removeClasses:function(){var e=this,t=e.$el,a=e.classNames;t.removeClass(a.join(" ")),e.emitContainerClasses()}},images:{loadImage:function(e,t,a,i,s,r){var n,o=l();function d(){r&&r()}m(e).parent("picture")[0]||e.complete&&s?d():t?((n=new o.Image).onload=d,n.onerror=d,i&&(n.sizes=i),a&&(n.srcset=a),t&&(n.src=t)):d()},preloadImages:function(){var e=this;function t(){null!=e&&e&&!e.destroyed&&(void 0!==e.imagesLoaded&&(e.imagesLoaded+=1),e.imagesLoaded===e.imagesToLoad.length&&(e.params.updateOnImagesReady&&e.update(),e.emit("imagesReady")))}e.imagesToLoad=e.$el.find("img");for(var a=0;a<e.imagesToLoad.length;a+=1){var i=e.imagesToLoad[a];e.loadImage(i,i.currentSrc||i.getAttribute("src"),i.srcset||i.getAttribute("srcset"),i.sizes||i.getAttribute("sizes"),!0,t)}}}},_={},q=function(){function t(){for(var e,a,i=arguments.length,s=new Array(i),r=0;r<i;r++)s[r]=arguments[r];if(1===s.length&&s[0].constructor&&"Object"===Object.prototype.toString.call(s[0]).slice(8,-1)?a=s[0]:(e=s[0],a=s[1]),a||(a={}),a=M({},a),e&&!a.el&&(a.el=e),a.el&&m(a.el).length>1){var n=[];return m(a.el).each((function(e){var i=M({},a,{el:e});n.push(new t(i))})),n}var l=this;l.__swiper__=!0,l.support=$(),l.device=L({userAgent:a.userAgent}),l.browser=I(),l.eventsListeners={},l.eventsAnyListeners=[],void 0===l.modules&&(l.modules={}),Object.keys(l.modules).forEach((function(e){var t=l.modules[e];if(t.params){var i=Object.keys(t.params)[0],s=t.params[i];if("object"!=typeof s||null===s)return;if(["navigation","pagination","scrollbar"].indexOf(i)>=0&&!0===a[i]&&(a[i]={auto:!0}),!(i in a)||!("enabled"in s))return;!0===a[i]&&(a[i]={enabled:!0}),"object"!=typeof a[i]||"enabled"in a[i]||(a[i].enabled=!0),a[i]||(a[i]={enabled:!1})}}));var o,d,p=M({},W);return l.useParams(p),l.params=M({},p,_,a),l.originalParams=M({},l.params),l.passedParams=M({},a),l.params&&l.params.on&&Object.keys(l.params.on).forEach((function(e){l.on(e,l.params.on[e])})),l.params&&l.params.onAny&&l.onAny(l.params.onAny),l.$=m,M(l,{enabled:l.params.enabled,el:e,classNames:[],slides:m(),slidesGrid:[],snapGrid:[],slidesSizesGrid:[],isHorizontal:function(){return"horizontal"===l.params.direction},isVertical:function(){return"vertical"===l.params.direction},activeIndex:0,realIndex:0,isBeginning:!0,isEnd:!1,translate:0,previousTranslate:0,progress:0,velocity:0,animating:!1,allowSlideNext:l.params.allowSlideNext,allowSlidePrev:l.params.allowSlidePrev,touchEvents:(o=["touchstart","touchmove","touchend","touchcancel"],d=["mousedown","mousemove","mouseup"],l.support.pointerEvents&&(d=["pointerdown","pointermove","pointerup"]),l.touchEventsTouch={start:o[0],move:o[1],end:o[2],cancel:o[3]},l.touchEventsDesktop={start:d[0],move:d[1],end:d[2]},l.support.touch||!l.params.simulateTouch?l.touchEventsTouch:l.touchEventsDesktop),touchEventsData:{isTouched:void 0,isMoved:void 0,allowTouchCallbacks:void 0,touchStartTime:void 0,isScrolling:void 0,currentTranslate:void 0,startTranslate:void 0,allowThresholdMove:void 0,focusableElements:l.params.focusableElements,lastClickTime:x(),clickTimeout:void 0,velocities:[],allowMomentumBounce:void 0,isTouchEvent:void 0,startMoving:void 0},allowClick:!0,allowTouchMove:l.params.allowTouchMove,touches:{startX:0,startY:0,currentX:0,currentY:0,diff:0},imagesToLoad:[],imagesLoaded:0}),l.useModules(),l.emit("_swiper"),l.params.init&&l.init(),l}var a,i,s,n=t.prototype;return n.enable=function(){var e=this;e.enabled||(e.enabled=!0,e.params.grabCursor&&e.setGrabCursor(),e.emit("enable"))},n.disable=function(){var e=this;e.enabled&&(e.enabled=!1,e.params.grabCursor&&e.unsetGrabCursor(),e.emit("disable"))},n.setProgress=function(e,t){var a=this;e=Math.min(Math.max(e,0),1);var i=a.minTranslate(),s=(a.maxTranslate()-i)*e+i;a.translateTo(s,void 0===t?0:t),a.updateActiveIndex(),a.updateSlidesClasses()},n.emitContainerClasses=function(){var e=this;if(e.params._emitClasses&&e.el){var t=e.el.className.split(" ").filter((function(t){return 0===t.indexOf("swiper-container")||0===t.indexOf(e.params.containerModifierClass)}));e.emit("_containerClasses",t.join(" "))}},n.getSlideClasses=function(e){var t=this;return e.className.split(" ").filter((function(e){return 0===e.indexOf("swiper-slide")||0===e.indexOf(t.params.slideClass)})).join(" ")},n.emitSlidesClasses=function(){var e=this;if(e.params._emitClasses&&e.el){var t=[];e.slides.each((function(a){var i=e.getSlideClasses(a);t.push({slideEl:a,classNames:i}),e.emit("_slideClass",a,i)})),e.emit("_slideClasses",t)}},n.slidesPerViewDynamic=function(){var e=this,t=e.params,a=e.slides,i=e.slidesGrid,s=e.size,r=e.activeIndex,n=1;if(t.centeredSlides){for(var l,o=a[r].swiperSlideSize,d=r+1;d<a.length;d+=1)a[d]&&!l&&(n+=1,(o+=a[d].swiperSlideSize)>s&&(l=!0));for(var p=r-1;p>=0;p-=1)a[p]&&!l&&(n+=1,(o+=a[p].swiperSlideSize)>s&&(l=!0))}else for(var u=r+1;u<a.length;u+=1)i[u]-i[r]<s&&(n+=1);return n},n.update=function(){var e=this;if(e&&!e.destroyed){var t=e.snapGrid,a=e.params;a.breakpoints&&e.setBreakpoint(),e.updateSize(),e.updateSlides(),e.updateProgress(),e.updateSlidesClasses(),e.params.freeMode?(i(),e.params.autoHeight&&e.updateAutoHeight()):(("auto"===e.params.slidesPerView||e.params.slidesPerView>1)&&e.isEnd&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0))||i(),a.watchOverflow&&t!==e.snapGrid&&e.checkOverflow(),e.emit("update")}function i(){var t=e.rtlTranslate?-1*e.translate:e.translate,a=Math.min(Math.max(t,e.maxTranslate()),e.minTranslate());e.setTranslate(a),e.updateActiveIndex(),e.updateSlidesClasses()}},n.changeDirection=function(e,t){void 0===t&&(t=!0);var a=this,i=a.params.direction;return e||(e="horizontal"===i?"vertical":"horizontal"),e===i||"horizontal"!==e&&"vertical"!==e||(a.$el.removeClass(""+a.params.containerModifierClass+i).addClass(""+a.params.containerModifierClass+e),a.emitContainerClasses(),a.params.direction=e,a.slides.each((function(t){"vertical"===e?t.style.width="":t.style.height=""})),a.emit("changeDirection"),t&&a.update()),a},n.mount=function(e){var t=this;if(t.mounted)return!0;var a=m(e||t.params.el);if(!(e=a[0]))return!1;e.swiper=t;var i=function(){return"."+(t.params.wrapperClass||"").trim().split(" ").join(".")},s=function(){if(e&&e.shadowRoot&&e.shadowRoot.querySelector){var t=m(e.shadowRoot.querySelector(i()));return t.children=function(e){return a.children(e)},t}return a.children(i())}();if(0===s.length&&t.params.createElements){var n=r().createElement("div");s=m(n),n.className=t.params.wrapperClass,a.append(n),a.children("."+t.params.slideClass).each((function(e){s.append(e)}))}return M(t,{$el:a,el:e,$wrapperEl:s,wrapperEl:s[0],mounted:!0,rtl:"rtl"===e.dir.toLowerCase()||"rtl"===a.css("direction"),rtlTranslate:"horizontal"===t.params.direction&&("rtl"===e.dir.toLowerCase()||"rtl"===a.css("direction")),wrongRTL:"-webkit-box"===s.css("display")}),!0},n.init=function(e){var t=this;return t.initialized||!1===t.mount(e)||(t.emit("beforeInit"),t.params.breakpoints&&t.setBreakpoint(),t.addClasses(),t.params.loop&&t.loopCreate(),t.updateSize(),t.updateSlides(),t.params.watchOverflow&&t.checkOverflow(),t.params.grabCursor&&t.enabled&&t.setGrabCursor(),t.params.preloadImages&&t.preloadImages(),t.params.loop?t.slideTo(t.params.initialSlide+t.loopedSlides,0,t.params.runCallbacksOnInit,!1,!0):t.slideTo(t.params.initialSlide,0,t.params.runCallbacksOnInit,!1,!0),t.attachEvents(),t.initialized=!0,t.emit("init"),t.emit("afterInit")),t},n.destroy=function(e,t){void 0===e&&(e=!0),void 0===t&&(t=!0);var a,i=this,s=i.params,r=i.$el,n=i.$wrapperEl,l=i.slides;return void 0===i.params||i.destroyed||(i.emit("beforeDestroy"),i.initialized=!1,i.detachEvents(),s.loop&&i.loopDestroy(),t&&(i.removeClasses(),r.removeAttr("style"),n.removeAttr("style"),l&&l.length&&l.removeClass([s.slideVisibleClass,s.slideActiveClass,s.slideNextClass,s.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")),i.emit("destroy"),Object.keys(i.eventsListeners).forEach((function(e){i.off(e)})),!1!==e&&(i.$el[0].swiper=null,a=i,Object.keys(a).forEach((function(e){try{a[e]=null}catch(e){}try{delete a[e]}catch(e){}}))),i.destroyed=!0),null},t.extendDefaults=function(e){M(_,e)},t.installModule=function(e){t.prototype.modules||(t.prototype.modules={});var a=e.name||Object.keys(t.prototype.modules).length+"_"+x();t.prototype.modules[a]=e},t.use=function(e){return Array.isArray(e)?(e.forEach((function(e){return t.installModule(e)})),t):(t.installModule(e),t)},a=t,s=[{key:"extendedDefaults",get:function(){return _}},{key:"defaults",get:function(){return W}}],(i=null)&&e(a.prototype,i),s&&e(a,s),t}();Object.keys(F).forEach((function(e){Object.keys(F[e]).forEach((function(t){q.prototype[t]=F[e][t]}))})),q.use([O,D]);var j={update:function(e){var t=this,a=t.params,i=a.slidesPerView,s=a.slidesPerGroup,r=a.centeredSlides,n=t.params.virtual,l=n.addSlidesBefore,o=n.addSlidesAfter,d=t.virtual,p=d.from,u=d.to,c=d.slides,h=d.slidesGrid,v=d.renderSlide,f=d.offset;t.updateActiveIndex();var m,g,b,w=t.activeIndex||0;m=t.rtlTranslate?"right":t.isHorizontal()?"left":"top",r?(g=Math.floor(i/2)+s+o,b=Math.floor(i/2)+s+l):(g=i+(s-1)+o,b=s+l);var y=Math.max((w||0)-b,0),E=Math.min((w||0)+g,c.length-1),x=(t.slidesGrid[y]||0)-(t.slidesGrid[0]||0);function T(){t.updateSlides(),t.updateProgress(),t.updateSlidesClasses(),t.lazy&&t.params.lazy.enabled&&t.lazy.load()}if(M(t.virtual,{from:y,to:E,offset:x,slidesGrid:t.slidesGrid}),p===y&&u===E&&!e)return t.slidesGrid!==h&&x!==f&&t.slides.css(m,x+"px"),void t.updateProgress();if(t.params.virtual.renderExternal)return t.params.virtual.renderExternal.call(t,{offset:x,from:y,to:E,slides:function(){for(var e=[],t=y;t<=E;t+=1)e.push(c[t]);return e}()}),void(t.params.virtual.renderExternalUpdate&&T());var C=[],S=[];if(e)t.$wrapperEl.find("."+t.params.slideClass).remove();else for(var z=p;z<=u;z+=1)(z<y||z>E)&&t.$wrapperEl.find("."+t.params.slideClass+'[data-swiper-slide-index="'+z+'"]').remove();for(var P=0;P<c.length;P+=1)P>=y&&P<=E&&(void 0===u||e?S.push(P):(P>u&&S.push(P),P<p&&C.push(P)));S.forEach((function(e){t.$wrapperEl.append(v(c[e],e))})),C.sort((function(e,t){return t-e})).forEach((function(e){t.$wrapperEl.prepend(v(c[e],e))})),t.$wrapperEl.children(".swiper-slide").css(m,x+"px"),T()},renderSlide:function(e,t){var a=this,i=a.params.virtual;if(i.cache&&a.virtual.cache[t])return a.virtual.cache[t];var s=i.renderSlide?m(i.renderSlide.call(a,e,t)):m('<div class="'+a.params.slideClass+'" data-swiper-slide-index="'+t+'">'+e+"</div>");return s.attr("data-swiper-slide-index")||s.attr("data-swiper-slide-index",t),i.cache&&(a.virtual.cache[t]=s),s},appendSlide:function(e){var t=this;if("object"==typeof e&&"length"in e)for(var a=0;a<e.length;a+=1)e[a]&&t.virtual.slides.push(e[a]);else t.virtual.slides.push(e);t.virtual.update(!0)},prependSlide:function(e){var t=this,a=t.activeIndex,i=a+1,s=1;if(Array.isArray(e)){for(var r=0;r<e.length;r+=1)e[r]&&t.virtual.slides.unshift(e[r]);i=a+e.length,s=e.length}else t.virtual.slides.unshift(e);if(t.params.virtual.cache){var n=t.virtual.cache,l={};Object.keys(n).forEach((function(e){var t=n[e],a=t.attr("data-swiper-slide-index");a&&t.attr("data-swiper-slide-index",parseInt(a,10)+1),l[parseInt(e,10)+s]=t})),t.virtual.cache=l}t.virtual.update(!0),t.slideTo(i,0)},removeSlide:function(e){var t=this;if(null!=e){var a=t.activeIndex;if(Array.isArray(e))for(var i=e.length-1;i>=0;i-=1)t.virtual.slides.splice(e[i],1),t.params.virtual.cache&&delete t.virtual.cache[e[i]],e[i]<a&&(a-=1),a=Math.max(a,0);else t.virtual.slides.splice(e,1),t.params.virtual.cache&&delete t.virtual.cache[e],e<a&&(a-=1),a=Math.max(a,0);t.virtual.update(!0),t.slideTo(a,0)}},removeAllSlides:function(){var e=this;e.virtual.slides=[],e.params.virtual.cache&&(e.virtual.cache={}),e.virtual.update(!0),e.slideTo(0,0)}},U={name:"virtual",params:{virtual:{enabled:!1,slides:[],cache:!0,renderSlide:null,renderExternal:null,renderExternalUpdate:!0,addSlidesBefore:0,addSlidesAfter:0}},create:function(){z(this,{virtual:t({},j,{slides:this.params.virtual.slides,cache:{}})})},on:{beforeInit:function(e){if(e.params.virtual.enabled){e.classNames.push(e.params.containerModifierClass+"virtual");var t={watchSlidesProgress:!0};M(e.params,t),M(e.originalParams,t),e.params.initialSlide||e.virtual.update()}},setTranslate:function(e){e.params.virtual.enabled&&e.virtual.update()}}},K={handle:function(e){var t=this;if(t.enabled){var a=l(),i=r(),s=t.rtlTranslate,n=e;n.originalEvent&&(n=n.originalEvent);var o=n.keyCode||n.charCode,d=t.params.keyboard.pageUpDown,p=d&&33===o,u=d&&34===o,c=37===o,h=39===o,v=38===o,f=40===o;if(!t.allowSlideNext&&(t.isHorizontal()&&h||t.isVertical()&&f||u))return!1;if(!t.allowSlidePrev&&(t.isHorizontal()&&c||t.isVertical()&&v||p))return!1;if(!(n.shiftKey||n.altKey||n.ctrlKey||n.metaKey||i.activeElement&&i.activeElement.nodeName&&("input"===i.activeElement.nodeName.toLowerCase()||"textarea"===i.activeElement.nodeName.toLowerCase()))){if(t.params.keyboard.onlyInViewport&&(p||u||c||h||v||f)){var m=!1;if(t.$el.parents("."+t.params.slideClass).length>0&&0===t.$el.parents("."+t.params.slideActiveClass).length)return;var g=t.$el,b=g[0].clientWidth,w=g[0].clientHeight,y=a.innerWidth,E=a.innerHeight,x=t.$el.offset();s&&(x.left-=t.$el[0].scrollLeft);for(var T=[[x.left,x.top],[x.left+b,x.top],[x.left,x.top+w],[x.left+b,x.top+w]],C=0;C<T.length;C+=1){var S=T[C];if(S[0]>=0&&S[0]<=y&&S[1]>=0&&S[1]<=E){if(0===S[0]&&0===S[1])continue;m=!0}}if(!m)return}t.isHorizontal()?((p||u||c||h)&&(n.preventDefault?n.preventDefault():n.returnValue=!1),((u||h)&&!s||(p||c)&&s)&&t.slideNext(),((p||c)&&!s||(u||h)&&s)&&t.slidePrev()):((p||u||v||f)&&(n.preventDefault?n.preventDefault():n.returnValue=!1),(u||f)&&t.slideNext(),(p||v)&&t.slidePrev()),t.emit("keyPress",o)}}},enable:function(){var e=this,t=r();e.keyboard.enabled||(m(t).on("keydown",e.keyboard.handle),e.keyboard.enabled=!0)},disable:function(){var e=this,t=r();e.keyboard.enabled&&(m(t).off("keydown",e.keyboard.handle),e.keyboard.enabled=!1)}},Z={name:"keyboard",params:{keyboard:{enabled:!1,onlyInViewport:!0,pageUpDown:!0}},create:function(){z(this,{keyboard:t({enabled:!1},K)})},on:{init:function(e){e.params.keyboard.enabled&&e.keyboard.enable()},destroy:function(e){e.keyboard.enabled&&e.keyboard.disable()}}};var J={lastScrollTime:x(),lastEventBeforeSnap:void 0,recentWheelEvents:[],event:function(){return l().navigator.userAgent.indexOf("firefox")>-1?"DOMMouseScroll":function(){var e=r(),t="onwheel",a=t in e;if(!a){var i=e.createElement("div");i.setAttribute(t,"return;"),a="function"==typeof i.onwheel}return!a&&e.implementation&&e.implementation.hasFeature&&!0!==e.implementation.hasFeature("","")&&(a=e.implementation.hasFeature("Events.wheel","3.0")),a}()?"wheel":"mousewheel"},normalize:function(e){var t=0,a=0,i=0,s=0;return"detail"in e&&(a=e.detail),"wheelDelta"in e&&(a=-e.wheelDelta/120),"wheelDeltaY"in e&&(a=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(t=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(t=a,a=0),i=10*t,s=10*a,"deltaY"in e&&(s=e.deltaY),"deltaX"in e&&(i=e.deltaX),e.shiftKey&&!i&&(i=s,s=0),(i||s)&&e.deltaMode&&(1===e.deltaMode?(i*=40,s*=40):(i*=800,s*=800)),i&&!t&&(t=i<1?-1:1),s&&!a&&(a=s<1?-1:1),{spinX:t,spinY:a,pixelX:i,pixelY:s}},handleMouseEnter:function(){this.enabled&&(this.mouseEntered=!0)},handleMouseLeave:function(){this.enabled&&(this.mouseEntered=!1)},handle:function(e){var t=e,a=this;if(a.enabled){var i=a.params.mousewheel;a.params.cssMode&&t.preventDefault();var s=a.$el;if("container"!==a.params.mousewheel.eventsTarget&&(s=m(a.params.mousewheel.eventsTarget)),!a.mouseEntered&&!s[0].contains(t.target)&&!i.releaseOnEdges)return!0;t.originalEvent&&(t=t.originalEvent);var r=0,n=a.rtlTranslate?-1:1,l=J.normalize(t);if(i.forceToAxis)if(a.isHorizontal()){if(!(Math.abs(l.pixelX)>Math.abs(l.pixelY)))return!0;r=-l.pixelX*n}else{if(!(Math.abs(l.pixelY)>Math.abs(l.pixelX)))return!0;r=-l.pixelY}else r=Math.abs(l.pixelX)>Math.abs(l.pixelY)?-l.pixelX*n:-l.pixelY;if(0===r)return!0;i.invert&&(r=-r);var o=a.getTranslate()+r*i.sensitivity;if(o>=a.minTranslate()&&(o=a.minTranslate()),o<=a.maxTranslate()&&(o=a.maxTranslate()),(!!a.params.loop||!(o===a.minTranslate()||o===a.maxTranslate()))&&a.params.nested&&t.stopPropagation(),a.params.freeMode){var d={time:x(),delta:Math.abs(r),direction:Math.sign(r)},p=a.mousewheel.lastEventBeforeSnap,u=p&&d.time<p.time+500&&d.delta<=p.delta&&d.direction===p.direction;if(!u){a.mousewheel.lastEventBeforeSnap=void 0,a.params.loop&&a.loopFix();var c=a.getTranslate()+r*i.sensitivity,h=a.isBeginning,v=a.isEnd;if(c>=a.minTranslate()&&(c=a.minTranslate()),c<=a.maxTranslate()&&(c=a.maxTranslate()),a.setTransition(0),a.setTranslate(c),a.updateProgress(),a.updateActiveIndex(),a.updateSlidesClasses(),(!h&&a.isBeginning||!v&&a.isEnd)&&a.updateSlidesClasses(),a.params.freeModeSticky){clearTimeout(a.mousewheel.timeout),a.mousewheel.timeout=void 0;var f=a.mousewheel.recentWheelEvents;f.length>=15&&f.shift();var g=f.length?f[f.length-1]:void 0,b=f[0];if(f.push(d),g&&(d.delta>g.delta||d.direction!==g.direction))f.splice(0);else if(f.length>=15&&d.time-b.time<500&&b.delta-d.delta>=1&&d.delta<=6){var w=r>0?.8:.2;a.mousewheel.lastEventBeforeSnap=d,f.splice(0),a.mousewheel.timeout=E((function(){a.slideToClosest(a.params.speed,!0,void 0,w)}),0)}a.mousewheel.timeout||(a.mousewheel.timeout=E((function(){a.mousewheel.lastEventBeforeSnap=d,f.splice(0),a.slideToClosest(a.params.speed,!0,void 0,.5)}),500))}if(u||a.emit("scroll",t),a.params.autoplay&&a.params.autoplayDisableOnInteraction&&a.autoplay.stop(),c===a.minTranslate()||c===a.maxTranslate())return!0}}else{var y={time:x(),delta:Math.abs(r),direction:Math.sign(r),raw:e},T=a.mousewheel.recentWheelEvents;T.length>=2&&T.shift();var C=T.length?T[T.length-1]:void 0;if(T.push(y),C?(y.direction!==C.direction||y.delta>C.delta||y.time>C.time+150)&&a.mousewheel.animateSlider(y):a.mousewheel.animateSlider(y),a.mousewheel.releaseScroll(y))return!0}return t.preventDefault?t.preventDefault():t.returnValue=!1,!1}},animateSlider:function(e){var t=this,a=l();return!(this.params.mousewheel.thresholdDelta&&e.delta<this.params.mousewheel.thresholdDelta)&&(!(this.params.mousewheel.thresholdTime&&x()-t.mousewheel.lastScrollTime<this.params.mousewheel.thresholdTime)&&(e.delta>=6&&x()-t.mousewheel.lastScrollTime<60||(e.direction<0?t.isEnd&&!t.params.loop||t.animating||(t.slideNext(),t.emit("scroll",e.raw)):t.isBeginning&&!t.params.loop||t.animating||(t.slidePrev(),t.emit("scroll",e.raw)),t.mousewheel.lastScrollTime=(new a.Date).getTime(),!1)))},releaseScroll:function(e){var t=this,a=t.params.mousewheel;if(e.direction<0){if(t.isEnd&&!t.params.loop&&a.releaseOnEdges)return!0}else if(t.isBeginning&&!t.params.loop&&a.releaseOnEdges)return!0;return!1},enable:function(){var e=this,t=J.event();if(e.params.cssMode)return e.wrapperEl.removeEventListener(t,e.mousewheel.handle),!0;if(!t)return!1;if(e.mousewheel.enabled)return!1;var a=e.$el;return"container"!==e.params.mousewheel.eventsTarget&&(a=m(e.params.mousewheel.eventsTarget)),a.on("mouseenter",e.mousewheel.handleMouseEnter),a.on("mouseleave",e.mousewheel.handleMouseLeave),a.on(t,e.mousewheel.handle),e.mousewheel.enabled=!0,!0},disable:function(){var e=this,t=J.event();if(e.params.cssMode)return e.wrapperEl.addEventListener(t,e.mousewheel.handle),!0;if(!t)return!1;if(!e.mousewheel.enabled)return!1;var a=e.$el;return"container"!==e.params.mousewheel.eventsTarget&&(a=m(e.params.mousewheel.eventsTarget)),a.off(t,e.mousewheel.handle),e.mousewheel.enabled=!1,!0}},Q={toggleEl:function(e,t){e[t?"addClass":"removeClass"](this.params.navigation.disabledClass),e[0]&&"BUTTON"===e[0].tagName&&(e[0].disabled=t)},update:function(){var e=this,t=e.params.navigation,a=e.navigation.toggleEl;if(!e.params.loop){var i=e.navigation,s=i.$nextEl,r=i.$prevEl;r&&r.length>0&&(e.isBeginning?a(r,!0):a(r,!1),e.params.watchOverflow&&e.enabled&&r[e.isLocked?"addClass":"removeClass"](t.lockClass)),s&&s.length>0&&(e.isEnd?a(s,!0):a(s,!1),e.params.watchOverflow&&e.enabled&&s[e.isLocked?"addClass":"removeClass"](t.lockClass))}},onPrevClick:function(e){var t=this;e.preventDefault(),t.isBeginning&&!t.params.loop||t.slidePrev()},onNextClick:function(e){var t=this;e.preventDefault(),t.isEnd&&!t.params.loop||t.slideNext()},init:function(){var e,t,a=this,i=a.params.navigation;(a.params.navigation=k(a.$el,a.params.navigation,a.params.createElements,{nextEl:"swiper-button-next",prevEl:"swiper-button-prev"}),i.nextEl||i.prevEl)&&(i.nextEl&&(e=m(i.nextEl),a.params.uniqueNavElements&&"string"==typeof i.nextEl&&e.length>1&&1===a.$el.find(i.nextEl).length&&(e=a.$el.find(i.nextEl))),i.prevEl&&(t=m(i.prevEl),a.params.uniqueNavElements&&"string"==typeof i.prevEl&&t.length>1&&1===a.$el.find(i.prevEl).length&&(t=a.$el.find(i.prevEl))),e&&e.length>0&&e.on("click",a.navigation.onNextClick),t&&t.length>0&&t.on("click",a.navigation.onPrevClick),M(a.navigation,{$nextEl:e,nextEl:e&&e[0],$prevEl:t,prevEl:t&&t[0]}),a.enabled||(e&&e.addClass(i.lockClass),t&&t.addClass(i.lockClass)))},destroy:function(){var e=this,t=e.navigation,a=t.$nextEl,i=t.$prevEl;a&&a.length&&(a.off("click",e.navigation.onNextClick),a.removeClass(e.params.navigation.disabledClass)),i&&i.length&&(i.off("click",e.navigation.onPrevClick),i.removeClass(e.params.navigation.disabledClass))}},ee={update:function(){var e=this,t=e.rtl,a=e.params.pagination;if(a.el&&e.pagination.el&&e.pagination.$el&&0!==e.pagination.$el.length){var i,s=e.virtual&&e.params.virtual.enabled?e.virtual.slides.length:e.slides.length,r=e.pagination.$el,n=e.params.loop?Math.ceil((s-2*e.loopedSlides)/e.params.slidesPerGroup):e.snapGrid.length;if(e.params.loop?((i=Math.ceil((e.activeIndex-e.loopedSlides)/e.params.slidesPerGroup))>s-1-2*e.loopedSlides&&(i-=s-2*e.loopedSlides),i>n-1&&(i-=n),i<0&&"bullets"!==e.params.paginationType&&(i=n+i)):i=void 0!==e.snapIndex?e.snapIndex:e.activeIndex||0,"bullets"===a.type&&e.pagination.bullets&&e.pagination.bullets.length>0){var l,o,d,p=e.pagination.bullets;if(a.dynamicBullets&&(e.pagination.bulletSize=p.eq(0)[e.isHorizontal()?"outerWidth":"outerHeight"](!0),r.css(e.isHorizontal()?"width":"height",e.pagination.bulletSize*(a.dynamicMainBullets+4)+"px"),a.dynamicMainBullets>1&&void 0!==e.previousIndex&&(e.pagination.dynamicBulletIndex+=i-e.previousIndex,e.pagination.dynamicBulletIndex>a.dynamicMainBullets-1?e.pagination.dynamicBulletIndex=a.dynamicMainBullets-1:e.pagination.dynamicBulletIndex<0&&(e.pagination.dynamicBulletIndex=0)),l=i-e.pagination.dynamicBulletIndex,d=((o=l+(Math.min(p.length,a.dynamicMainBullets)-1))+l)/2),p.removeClass(a.bulletActiveClass+" "+a.bulletActiveClass+"-next "+a.bulletActiveClass+"-next-next "+a.bulletActiveClass+"-prev "+a.bulletActiveClass+"-prev-prev "+a.bulletActiveClass+"-main"),r.length>1)p.each((function(e){var t=m(e),s=t.index();s===i&&t.addClass(a.bulletActiveClass),a.dynamicBullets&&(s>=l&&s<=o&&t.addClass(a.bulletActiveClass+"-main"),s===l&&t.prev().addClass(a.bulletActiveClass+"-prev").prev().addClass(a.bulletActiveClass+"-prev-prev"),s===o&&t.next().addClass(a.bulletActiveClass+"-next").next().addClass(a.bulletActiveClass+"-next-next"))}));else{var u=p.eq(i),c=u.index();if(u.addClass(a.bulletActiveClass),a.dynamicBullets){for(var h=p.eq(l),v=p.eq(o),f=l;f<=o;f+=1)p.eq(f).addClass(a.bulletActiveClass+"-main");if(e.params.loop)if(c>=p.length-a.dynamicMainBullets){for(var g=a.dynamicMainBullets;g>=0;g-=1)p.eq(p.length-g).addClass(a.bulletActiveClass+"-main");p.eq(p.length-a.dynamicMainBullets-1).addClass(a.bulletActiveClass+"-prev")}else h.prev().addClass(a.bulletActiveClass+"-prev").prev().addClass(a.bulletActiveClass+"-prev-prev"),v.next().addClass(a.bulletActiveClass+"-next").next().addClass(a.bulletActiveClass+"-next-next");else h.prev().addClass(a.bulletActiveClass+"-prev").prev().addClass(a.bulletActiveClass+"-prev-prev"),v.next().addClass(a.bulletActiveClass+"-next").next().addClass(a.bulletActiveClass+"-next-next")}}if(a.dynamicBullets){var b=Math.min(p.length,a.dynamicMainBullets+4),w=(e.pagination.bulletSize*b-e.pagination.bulletSize)/2-d*e.pagination.bulletSize,y=t?"right":"left";p.css(e.isHorizontal()?y:"top",w+"px")}}if("fraction"===a.type&&(r.find(P(a.currentClass)).text(a.formatFractionCurrent(i+1)),r.find(P(a.totalClass)).text(a.formatFractionTotal(n))),"progressbar"===a.type){var E;E=a.progressbarOpposite?e.isHorizontal()?"vertical":"horizontal":e.isHorizontal()?"horizontal":"vertical";var x=(i+1)/n,T=1,C=1;"horizontal"===E?T=x:C=x,r.find(P(a.progressbarFillClass)).transform("translate3d(0,0,0) scaleX("+T+") scaleY("+C+")").transition(e.params.speed)}"custom"===a.type&&a.renderCustom?(r.html(a.renderCustom(e,i+1,n)),e.emit("paginationRender",r[0])):e.emit("paginationUpdate",r[0]),e.params.watchOverflow&&e.enabled&&r[e.isLocked?"addClass":"removeClass"](a.lockClass)}},render:function(){var e=this,t=e.params.pagination;if(t.el&&e.pagination.el&&e.pagination.$el&&0!==e.pagination.$el.length){var a=e.virtual&&e.params.virtual.enabled?e.virtual.slides.length:e.slides.length,i=e.pagination.$el,s="";if("bullets"===t.type){var r=e.params.loop?Math.ceil((a-2*e.loopedSlides)/e.params.slidesPerGroup):e.snapGrid.length;e.params.freeMode&&!e.params.loop&&r>a&&(r=a);for(var n=0;n<r;n+=1)t.renderBullet?s+=t.renderBullet.call(e,n,t.bulletClass):s+="<"+t.bulletElement+' class="'+t.bulletClass+'"></'+t.bulletElement+">";i.html(s),e.pagination.bullets=i.find(P(t.bulletClass))}"fraction"===t.type&&(s=t.renderFraction?t.renderFraction.call(e,t.currentClass,t.totalClass):'<span class="'+t.currentClass+'"></span> / <span class="'+t.totalClass+'"></span>',i.html(s)),"progressbar"===t.type&&(s=t.renderProgressbar?t.renderProgressbar.call(e,t.progressbarFillClass):'<span class="'+t.progressbarFillClass+'"></span>',i.html(s)),"custom"!==t.type&&e.emit("paginationRender",e.pagination.$el[0])}},init:function(){var e=this;e.params.pagination=k(e.$el,e.params.pagination,e.params.createElements,{el:"swiper-pagination"});var t=e.params.pagination;if(t.el){var a=m(t.el);0!==a.length&&(e.params.uniqueNavElements&&"string"==typeof t.el&&a.length>1&&(a=e.$el.find(t.el)),"bullets"===t.type&&t.clickable&&a.addClass(t.clickableClass),a.addClass(t.modifierClass+t.type),"bullets"===t.type&&t.dynamicBullets&&(a.addClass(""+t.modifierClass+t.type+"-dynamic"),e.pagination.dynamicBulletIndex=0,t.dynamicMainBullets<1&&(t.dynamicMainBullets=1)),"progressbar"===t.type&&t.progressbarOpposite&&a.addClass(t.progressbarOppositeClass),t.clickable&&a.on("click",P(t.bulletClass),(function(t){t.preventDefault();var a=m(this).index()*e.params.slidesPerGroup;e.params.loop&&(a+=e.loopedSlides),e.slideTo(a)})),M(e.pagination,{$el:a,el:a[0]}),e.enabled||a.addClass(t.lockClass))}},destroy:function(){var e=this,t=e.params.pagination;if(t.el&&e.pagination.el&&e.pagination.$el&&0!==e.pagination.$el.length){var a=e.pagination.$el;a.removeClass(t.hiddenClass),a.removeClass(t.modifierClass+t.type),e.pagination.bullets&&e.pagination.bullets.removeClass(t.bulletActiveClass),t.clickable&&a.off("click",P(t.bulletClass))}}},te={setTranslate:function(){var e=this;if(e.params.scrollbar.el&&e.scrollbar.el){var t=e.scrollbar,a=e.rtlTranslate,i=e.progress,s=t.dragSize,r=t.trackSize,n=t.$dragEl,l=t.$el,o=e.params.scrollbar,d=s,p=(r-s)*i;a?(p=-p)>0?(d=s-p,p=0):-p+s>r&&(d=r+p):p<0?(d=s+p,p=0):p+s>r&&(d=r-p),e.isHorizontal()?(n.transform("translate3d("+p+"px, 0, 0)"),n[0].style.width=d+"px"):(n.transform("translate3d(0px, "+p+"px, 0)"),n[0].style.height=d+"px"),o.hide&&(clearTimeout(e.scrollbar.timeout),l[0].style.opacity=1,e.scrollbar.timeout=setTimeout((function(){l[0].style.opacity=0,l.transition(400)}),1e3))}},setTransition:function(e){var t=this;t.params.scrollbar.el&&t.scrollbar.el&&t.scrollbar.$dragEl.transition(e)},updateSize:function(){var e=this;if(e.params.scrollbar.el&&e.scrollbar.el){var t=e.scrollbar,a=t.$dragEl,i=t.$el;a[0].style.width="",a[0].style.height="";var s,r=e.isHorizontal()?i[0].offsetWidth:i[0].offsetHeight,n=e.size/e.virtualSize,l=n*(r/e.size);s="auto"===e.params.scrollbar.dragSize?r*n:parseInt(e.params.scrollbar.dragSize,10),e.isHorizontal()?a[0].style.width=s+"px":a[0].style.height=s+"px",i[0].style.display=n>=1?"none":"",e.params.scrollbar.hide&&(i[0].style.opacity=0),M(t,{trackSize:r,divider:n,moveDivider:l,dragSize:s}),e.params.watchOverflow&&e.enabled&&t.$el[e.isLocked?"addClass":"removeClass"](e.params.scrollbar.lockClass)}},getPointerPosition:function(e){return this.isHorizontal()?"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientX:e.clientX:"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientY:e.clientY},setDragPosition:function(e){var t,a=this,i=a.scrollbar,s=a.rtlTranslate,r=i.$el,n=i.dragSize,l=i.trackSize,o=i.dragStartPos;t=(i.getPointerPosition(e)-r.offset()[a.isHorizontal()?"left":"top"]-(null!==o?o:n/2))/(l-n),t=Math.max(Math.min(t,1),0),s&&(t=1-t);var d=a.minTranslate()+(a.maxTranslate()-a.minTranslate())*t;a.updateProgress(d),a.setTranslate(d),a.updateActiveIndex(),a.updateSlidesClasses()},onDragStart:function(e){var t=this,a=t.params.scrollbar,i=t.scrollbar,s=t.$wrapperEl,r=i.$el,n=i.$dragEl;t.scrollbar.isTouched=!0,t.scrollbar.dragStartPos=e.target===n[0]||e.target===n?i.getPointerPosition(e)-e.target.getBoundingClientRect()[t.isHorizontal()?"left":"top"]:null,e.preventDefault(),e.stopPropagation(),s.transition(100),n.transition(100),i.setDragPosition(e),clearTimeout(t.scrollbar.dragTimeout),r.transition(0),a.hide&&r.css("opacity",1),t.params.cssMode&&t.$wrapperEl.css("scroll-snap-type","none"),t.emit("scrollbarDragStart",e)},onDragMove:function(e){var t=this,a=t.scrollbar,i=t.$wrapperEl,s=a.$el,r=a.$dragEl;t.scrollbar.isTouched&&(e.preventDefault?e.preventDefault():e.returnValue=!1,a.setDragPosition(e),i.transition(0),s.transition(0),r.transition(0),t.emit("scrollbarDragMove",e))},onDragEnd:function(e){var t=this,a=t.params.scrollbar,i=t.scrollbar,s=t.$wrapperEl,r=i.$el;t.scrollbar.isTouched&&(t.scrollbar.isTouched=!1,t.params.cssMode&&(t.$wrapperEl.css("scroll-snap-type",""),s.transition("")),a.hide&&(clearTimeout(t.scrollbar.dragTimeout),t.scrollbar.dragTimeout=E((function(){r.css("opacity",0),r.transition(400)}),1e3)),t.emit("scrollbarDragEnd",e),a.snapOnRelease&&t.slideToClosest())},enableDraggable:function(){var e=this;if(e.params.scrollbar.el){var t=r(),a=e.scrollbar,i=e.touchEventsTouch,s=e.touchEventsDesktop,n=e.params,l=e.support,o=a.$el[0],d=!(!l.passiveListener||!n.passiveListeners)&&{passive:!1,capture:!1},p=!(!l.passiveListener||!n.passiveListeners)&&{passive:!0,capture:!1};o&&(l.touch?(o.addEventListener(i.start,e.scrollbar.onDragStart,d),o.addEventListener(i.move,e.scrollbar.onDragMove,d),o.addEventListener(i.end,e.scrollbar.onDragEnd,p)):(o.addEventListener(s.start,e.scrollbar.onDragStart,d),t.addEventListener(s.move,e.scrollbar.onDragMove,d),t.addEventListener(s.end,e.scrollbar.onDragEnd,p)))}},disableDraggable:function(){var e=this;if(e.params.scrollbar.el){var t=r(),a=e.scrollbar,i=e.touchEventsTouch,s=e.touchEventsDesktop,n=e.params,l=e.support,o=a.$el[0],d=!(!l.passiveListener||!n.passiveListeners)&&{passive:!1,capture:!1},p=!(!l.passiveListener||!n.passiveListeners)&&{passive:!0,capture:!1};o&&(l.touch?(o.removeEventListener(i.start,e.scrollbar.onDragStart,d),o.removeEventListener(i.move,e.scrollbar.onDragMove,d),o.removeEventListener(i.end,e.scrollbar.onDragEnd,p)):(o.removeEventListener(s.start,e.scrollbar.onDragStart,d),t.removeEventListener(s.move,e.scrollbar.onDragMove,d),t.removeEventListener(s.end,e.scrollbar.onDragEnd,p)))}},init:function(){var e=this,t=e.scrollbar,a=e.$el;e.params.scrollbar=k(a,e.params.scrollbar,e.params.createElements,{el:"swiper-scrollbar"});var i=e.params.scrollbar;if(i.el){var s=m(i.el);e.params.uniqueNavElements&&"string"==typeof i.el&&s.length>1&&1===a.find(i.el).length&&(s=a.find(i.el));var r=s.find("."+e.params.scrollbar.dragClass);0===r.length&&(r=m('<div class="'+e.params.scrollbar.dragClass+'"></div>'),s.append(r)),M(t,{$el:s,el:s[0],$dragEl:r,dragEl:r[0]}),i.draggable&&t.enableDraggable(),s&&s[e.enabled?"removeClass":"addClass"](e.params.scrollbar.lockClass)}},destroy:function(){this.scrollbar.disableDraggable()}},ae={setTransform:function(e,t){var a=this.rtl,i=m(e),s=a?-1:1,r=i.attr("data-swiper-parallax")||"0",n=i.attr("data-swiper-parallax-x"),l=i.attr("data-swiper-parallax-y"),o=i.attr("data-swiper-parallax-scale"),d=i.attr("data-swiper-parallax-opacity");if(n||l?(n=n||"0",l=l||"0"):this.isHorizontal()?(n=r,l="0"):(l=r,n="0"),n=n.indexOf("%")>=0?parseInt(n,10)*t*s+"%":n*t*s+"px",l=l.indexOf("%")>=0?parseInt(l,10)*t+"%":l*t+"px",null!=d){var p=d-(d-1)*(1-Math.abs(t));i[0].style.opacity=p}if(null==o)i.transform("translate3d("+n+", "+l+", 0px)");else{var u=o-(o-1)*(1-Math.abs(t));i.transform("translate3d("+n+", "+l+", 0px) scale("+u+")")}},setTranslate:function(){var e=this,t=e.$el,a=e.slides,i=e.progress,s=e.snapGrid;t.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t){e.parallax.setTransform(t,i)})),a.each((function(t,a){var r=t.progress;e.params.slidesPerGroup>1&&"auto"!==e.params.slidesPerView&&(r+=Math.ceil(a/2)-i*(s.length-1)),r=Math.min(Math.max(r,-1),1),m(t).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t){e.parallax.setTransform(t,r)}))}))},setTransition:function(e){void 0===e&&(e=this.params.speed);this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t){var a=m(t),i=parseInt(a.attr("data-swiper-parallax-duration"),10)||e;0===e&&(i=0),a.transition(i)}))}},ie={getDistanceBetweenTouches:function(e){if(e.targetTouches.length<2)return 1;var t=e.targetTouches[0].pageX,a=e.targetTouches[0].pageY,i=e.targetTouches[1].pageX,s=e.targetTouches[1].pageY;return Math.sqrt(Math.pow(i-t,2)+Math.pow(s-a,2))},onGestureStart:function(e){var t=this,a=t.support,i=t.params.zoom,s=t.zoom,r=s.gesture;if(s.fakeGestureTouched=!1,s.fakeGestureMoved=!1,!a.gestures){if("touchstart"!==e.type||"touchstart"===e.type&&e.targetTouches.length<2)return;s.fakeGestureTouched=!0,r.scaleStart=ie.getDistanceBetweenTouches(e)}r.$slideEl&&r.$slideEl.length||(r.$slideEl=m(e.target).closest("."+t.params.slideClass),0===r.$slideEl.length&&(r.$slideEl=t.slides.eq(t.activeIndex)),r.$imageEl=r.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),r.$imageWrapEl=r.$imageEl.parent("."+i.containerClass),r.maxRatio=r.$imageWrapEl.attr("data-swiper-zoom")||i.maxRatio,0!==r.$imageWrapEl.length)?(r.$imageEl&&r.$imageEl.transition(0),t.zoom.isScaling=!0):r.$imageEl=void 0},onGestureChange:function(e){var t=this,a=t.support,i=t.params.zoom,s=t.zoom,r=s.gesture;if(!a.gestures){if("touchmove"!==e.type||"touchmove"===e.type&&e.targetTouches.length<2)return;s.fakeGestureMoved=!0,r.scaleMove=ie.getDistanceBetweenTouches(e)}r.$imageEl&&0!==r.$imageEl.length?(a.gestures?s.scale=e.scale*s.currentScale:s.scale=r.scaleMove/r.scaleStart*s.currentScale,s.scale>r.maxRatio&&(s.scale=r.maxRatio-1+Math.pow(s.scale-r.maxRatio+1,.5)),s.scale<i.minRatio&&(s.scale=i.minRatio+1-Math.pow(i.minRatio-s.scale+1,.5)),r.$imageEl.transform("translate3d(0,0,0) scale("+s.scale+")")):"gesturechange"===e.type&&s.onGestureStart(e)},onGestureEnd:function(e){var t=this,a=t.device,i=t.support,s=t.params.zoom,r=t.zoom,n=r.gesture;if(!i.gestures){if(!r.fakeGestureTouched||!r.fakeGestureMoved)return;if("touchend"!==e.type||"touchend"===e.type&&e.changedTouches.length<2&&!a.android)return;r.fakeGestureTouched=!1,r.fakeGestureMoved=!1}n.$imageEl&&0!==n.$imageEl.length&&(r.scale=Math.max(Math.min(r.scale,n.maxRatio),s.minRatio),n.$imageEl.transition(t.params.speed).transform("translate3d(0,0,0) scale("+r.scale+")"),r.currentScale=r.scale,r.isScaling=!1,1===r.scale&&(n.$slideEl=void 0))},onTouchStart:function(e){var t=this.device,a=this.zoom,i=a.gesture,s=a.image;i.$imageEl&&0!==i.$imageEl.length&&(s.isTouched||(t.android&&e.cancelable&&e.preventDefault(),s.isTouched=!0,s.touchesStart.x="touchstart"===e.type?e.targetTouches[0].pageX:e.pageX,s.touchesStart.y="touchstart"===e.type?e.targetTouches[0].pageY:e.pageY))},onTouchMove:function(e){var t=this,a=t.zoom,i=a.gesture,s=a.image,r=a.velocity;if(i.$imageEl&&0!==i.$imageEl.length&&(t.allowClick=!1,s.isTouched&&i.$slideEl)){s.isMoved||(s.width=i.$imageEl[0].offsetWidth,s.height=i.$imageEl[0].offsetHeight,s.startX=T(i.$imageWrapEl[0],"x")||0,s.startY=T(i.$imageWrapEl[0],"y")||0,i.slideWidth=i.$slideEl[0].offsetWidth,i.slideHeight=i.$slideEl[0].offsetHeight,i.$imageWrapEl.transition(0));var n=s.width*a.scale,l=s.height*a.scale;if(!(n<i.slideWidth&&l<i.slideHeight)){if(s.minX=Math.min(i.slideWidth/2-n/2,0),s.maxX=-s.minX,s.minY=Math.min(i.slideHeight/2-l/2,0),s.maxY=-s.minY,s.touchesCurrent.x="touchmove"===e.type?e.targetTouches[0].pageX:e.pageX,s.touchesCurrent.y="touchmove"===e.type?e.targetTouches[0].pageY:e.pageY,!s.isMoved&&!a.isScaling){if(t.isHorizontal()&&(Math.floor(s.minX)===Math.floor(s.startX)&&s.touchesCurrent.x<s.touchesStart.x||Math.floor(s.maxX)===Math.floor(s.startX)&&s.touchesCurrent.x>s.touchesStart.x))return void(s.isTouched=!1);if(!t.isHorizontal()&&(Math.floor(s.minY)===Math.floor(s.startY)&&s.touchesCurrent.y<s.touchesStart.y||Math.floor(s.maxY)===Math.floor(s.startY)&&s.touchesCurrent.y>s.touchesStart.y))return void(s.isTouched=!1)}e.cancelable&&e.preventDefault(),e.stopPropagation(),s.isMoved=!0,s.currentX=s.touchesCurrent.x-s.touchesStart.x+s.startX,s.currentY=s.touchesCurrent.y-s.touchesStart.y+s.startY,s.currentX<s.minX&&(s.currentX=s.minX+1-Math.pow(s.minX-s.currentX+1,.8)),s.currentX>s.maxX&&(s.currentX=s.maxX-1+Math.pow(s.currentX-s.maxX+1,.8)),s.currentY<s.minY&&(s.currentY=s.minY+1-Math.pow(s.minY-s.currentY+1,.8)),s.currentY>s.maxY&&(s.currentY=s.maxY-1+Math.pow(s.currentY-s.maxY+1,.8)),r.prevPositionX||(r.prevPositionX=s.touchesCurrent.x),r.prevPositionY||(r.prevPositionY=s.touchesCurrent.y),r.prevTime||(r.prevTime=Date.now()),r.x=(s.touchesCurrent.x-r.prevPositionX)/(Date.now()-r.prevTime)/2,r.y=(s.touchesCurrent.y-r.prevPositionY)/(Date.now()-r.prevTime)/2,Math.abs(s.touchesCurrent.x-r.prevPositionX)<2&&(r.x=0),Math.abs(s.touchesCurrent.y-r.prevPositionY)<2&&(r.y=0),r.prevPositionX=s.touchesCurrent.x,r.prevPositionY=s.touchesCurrent.y,r.prevTime=Date.now(),i.$imageWrapEl.transform("translate3d("+s.currentX+"px, "+s.currentY+"px,0)")}}},onTouchEnd:function(){var e=this.zoom,t=e.gesture,a=e.image,i=e.velocity;if(t.$imageEl&&0!==t.$imageEl.length){if(!a.isTouched||!a.isMoved)return a.isTouched=!1,void(a.isMoved=!1);a.isTouched=!1,a.isMoved=!1;var s=300,r=300,n=i.x*s,l=a.currentX+n,o=i.y*r,d=a.currentY+o;0!==i.x&&(s=Math.abs((l-a.currentX)/i.x)),0!==i.y&&(r=Math.abs((d-a.currentY)/i.y));var p=Math.max(s,r);a.currentX=l,a.currentY=d;var u=a.width*e.scale,c=a.height*e.scale;a.minX=Math.min(t.slideWidth/2-u/2,0),a.maxX=-a.minX,a.minY=Math.min(t.slideHeight/2-c/2,0),a.maxY=-a.minY,a.currentX=Math.max(Math.min(a.currentX,a.maxX),a.minX),a.currentY=Math.max(Math.min(a.currentY,a.maxY),a.minY),t.$imageWrapEl.transition(p).transform("translate3d("+a.currentX+"px, "+a.currentY+"px,0)")}},onTransitionEnd:function(){var e=this,t=e.zoom,a=t.gesture;a.$slideEl&&e.previousIndex!==e.activeIndex&&(a.$imageEl&&a.$imageEl.transform("translate3d(0,0,0) scale(1)"),a.$imageWrapEl&&a.$imageWrapEl.transform("translate3d(0,0,0)"),t.scale=1,t.currentScale=1,a.$slideEl=void 0,a.$imageEl=void 0,a.$imageWrapEl=void 0)},toggle:function(e){var t=this.zoom;t.scale&&1!==t.scale?t.out():t.in(e)},in:function(e){var t,a,i,s,r,n,o,d,p,u,c,h,v,f,g,b,w=this,y=l(),E=w.zoom,x=w.params.zoom,T=E.gesture,C=E.image;(T.$slideEl||(e&&e.target&&(T.$slideEl=m(e.target).closest("."+w.params.slideClass)),T.$slideEl||(w.params.virtual&&w.params.virtual.enabled&&w.virtual?T.$slideEl=w.$wrapperEl.children("."+w.params.slideActiveClass):T.$slideEl=w.slides.eq(w.activeIndex)),T.$imageEl=T.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),T.$imageWrapEl=T.$imageEl.parent("."+x.containerClass)),T.$imageEl&&0!==T.$imageEl.length&&T.$imageWrapEl&&0!==T.$imageWrapEl.length)&&(T.$slideEl.addClass(""+x.zoomedSlideClass),void 0===C.touchesStart.x&&e?(t="touchend"===e.type?e.changedTouches[0].pageX:e.pageX,a="touchend"===e.type?e.changedTouches[0].pageY:e.pageY):(t=C.touchesStart.x,a=C.touchesStart.y),E.scale=T.$imageWrapEl.attr("data-swiper-zoom")||x.maxRatio,E.currentScale=T.$imageWrapEl.attr("data-swiper-zoom")||x.maxRatio,e?(g=T.$slideEl[0].offsetWidth,b=T.$slideEl[0].offsetHeight,i=T.$slideEl.offset().left+y.scrollX+g/2-t,s=T.$slideEl.offset().top+y.scrollY+b/2-a,o=T.$imageEl[0].offsetWidth,d=T.$imageEl[0].offsetHeight,p=o*E.scale,u=d*E.scale,v=-(c=Math.min(g/2-p/2,0)),f=-(h=Math.min(b/2-u/2,0)),(r=i*E.scale)<c&&(r=c),r>v&&(r=v),(n=s*E.scale)<h&&(n=h),n>f&&(n=f)):(r=0,n=0),T.$imageWrapEl.transition(300).transform("translate3d("+r+"px, "+n+"px,0)"),T.$imageEl.transition(300).transform("translate3d(0,0,0) scale("+E.scale+")"))},out:function(){var e=this,t=e.zoom,a=e.params.zoom,i=t.gesture;i.$slideEl||(e.params.virtual&&e.params.virtual.enabled&&e.virtual?i.$slideEl=e.$wrapperEl.children("."+e.params.slideActiveClass):i.$slideEl=e.slides.eq(e.activeIndex),i.$imageEl=i.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),i.$imageWrapEl=i.$imageEl.parent("."+a.containerClass)),i.$imageEl&&0!==i.$imageEl.length&&i.$imageWrapEl&&0!==i.$imageWrapEl.length&&(t.scale=1,t.currentScale=1,i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),i.$slideEl.removeClass(""+a.zoomedSlideClass),i.$slideEl=void 0)},toggleGestures:function(e){var t=this,a=t.zoom,i=a.slideSelector,s=a.passiveListener;t.$wrapperEl[e]("gesturestart",i,a.onGestureStart,s),t.$wrapperEl[e]("gesturechange",i,a.onGestureChange,s),t.$wrapperEl[e]("gestureend",i,a.onGestureEnd,s)},enableGestures:function(){this.zoom.gesturesEnabled||(this.zoom.gesturesEnabled=!0,this.zoom.toggleGestures("on"))},disableGestures:function(){this.zoom.gesturesEnabled&&(this.zoom.gesturesEnabled=!1,this.zoom.toggleGestures("off"))},enable:function(){var e=this,t=e.support,a=e.zoom;if(!a.enabled){a.enabled=!0;var i=!("touchstart"!==e.touchEvents.start||!t.passiveListener||!e.params.passiveListeners)&&{passive:!0,capture:!1},s=!t.passiveListener||{passive:!1,capture:!0},r="."+e.params.slideClass;e.zoom.passiveListener=i,e.zoom.slideSelector=r,t.gestures?(e.$wrapperEl.on(e.touchEvents.start,e.zoom.enableGestures,i),e.$wrapperEl.on(e.touchEvents.end,e.zoom.disableGestures,i)):"touchstart"===e.touchEvents.start&&(e.$wrapperEl.on(e.touchEvents.start,r,a.onGestureStart,i),e.$wrapperEl.on(e.touchEvents.move,r,a.onGestureChange,s),e.$wrapperEl.on(e.touchEvents.end,r,a.onGestureEnd,i),e.touchEvents.cancel&&e.$wrapperEl.on(e.touchEvents.cancel,r,a.onGestureEnd,i)),e.$wrapperEl.on(e.touchEvents.move,"."+e.params.zoom.containerClass,a.onTouchMove,s)}},disable:function(){var e=this,t=e.zoom;if(t.enabled){var a=e.support;e.zoom.enabled=!1;var i=!("touchstart"!==e.touchEvents.start||!a.passiveListener||!e.params.passiveListeners)&&{passive:!0,capture:!1},s=!a.passiveListener||{passive:!1,capture:!0},r="."+e.params.slideClass;a.gestures?(e.$wrapperEl.off(e.touchEvents.start,e.zoom.enableGestures,i),e.$wrapperEl.off(e.touchEvents.end,e.zoom.disableGestures,i)):"touchstart"===e.touchEvents.start&&(e.$wrapperEl.off(e.touchEvents.start,r,t.onGestureStart,i),e.$wrapperEl.off(e.touchEvents.move,r,t.onGestureChange,s),e.$wrapperEl.off(e.touchEvents.end,r,t.onGestureEnd,i),e.touchEvents.cancel&&e.$wrapperEl.off(e.touchEvents.cancel,r,t.onGestureEnd,i)),e.$wrapperEl.off(e.touchEvents.move,"."+e.params.zoom.containerClass,t.onTouchMove,s)}}},se={loadInSlide:function(e,t){void 0===t&&(t=!0);var a=this,i=a.params.lazy;if(void 0!==e&&0!==a.slides.length){var s=a.virtual&&a.params.virtual.enabled?a.$wrapperEl.children("."+a.params.slideClass+'[data-swiper-slide-index="'+e+'"]'):a.slides.eq(e),r=s.find("."+i.elementClass+":not(."+i.loadedClass+"):not(."+i.loadingClass+")");!s.hasClass(i.elementClass)||s.hasClass(i.loadedClass)||s.hasClass(i.loadingClass)||r.push(s[0]),0!==r.length&&r.each((function(e){var r=m(e);r.addClass(i.loadingClass);var n=r.attr("data-background"),l=r.attr("data-src"),o=r.attr("data-srcset"),d=r.attr("data-sizes"),p=r.parent("picture");a.loadImage(r[0],l||n,o,d,!1,(function(){if(null!=a&&a&&(!a||a.params)&&!a.destroyed){if(n?(r.css("background-image",'url("'+n+'")'),r.removeAttr("data-background")):(o&&(r.attr("srcset",o),r.removeAttr("data-srcset")),d&&(r.attr("sizes",d),r.removeAttr("data-sizes")),p.length&&p.children("source").each((function(e){var t=m(e);t.attr("data-srcset")&&(t.attr("srcset",t.attr("data-srcset")),t.removeAttr("data-srcset"))})),l&&(r.attr("src",l),r.removeAttr("data-src"))),r.addClass(i.loadedClass).removeClass(i.loadingClass),s.find("."+i.preloaderClass).remove(),a.params.loop&&t){var e=s.attr("data-swiper-slide-index");if(s.hasClass(a.params.slideDuplicateClass)){var u=a.$wrapperEl.children('[data-swiper-slide-index="'+e+'"]:not(.'+a.params.slideDuplicateClass+")");a.lazy.loadInSlide(u.index(),!1)}else{var c=a.$wrapperEl.children("."+a.params.slideDuplicateClass+'[data-swiper-slide-index="'+e+'"]');a.lazy.loadInSlide(c.index(),!1)}}a.emit("lazyImageReady",s[0],r[0]),a.params.autoHeight&&a.updateAutoHeight()}})),a.emit("lazyImageLoad",s[0],r[0])}))}},load:function(){var e=this,t=e.$wrapperEl,a=e.params,i=e.slides,s=e.activeIndex,r=e.virtual&&a.virtual.enabled,n=a.lazy,l=a.slidesPerView;function o(e){if(r){if(t.children("."+a.slideClass+'[data-swiper-slide-index="'+e+'"]').length)return!0}else if(i[e])return!0;return!1}function d(e){return r?m(e).attr("data-swiper-slide-index"):m(e).index()}if("auto"===l&&(l=0),e.lazy.initialImageLoaded||(e.lazy.initialImageLoaded=!0),e.params.watchSlidesVisibility)t.children("."+a.slideVisibleClass).each((function(t){var a=r?m(t).attr("data-swiper-slide-index"):m(t).index();e.lazy.loadInSlide(a)}));else if(l>1)for(var p=s;p<s+l;p+=1)o(p)&&e.lazy.loadInSlide(p);else e.lazy.loadInSlide(s);if(n.loadPrevNext)if(l>1||n.loadPrevNextAmount&&n.loadPrevNextAmount>1){for(var u=n.loadPrevNextAmount,c=l,h=Math.min(s+c+Math.max(u,c),i.length),v=Math.max(s-Math.max(c,u),0),f=s+l;f<h;f+=1)o(f)&&e.lazy.loadInSlide(f);for(var g=v;g<s;g+=1)o(g)&&e.lazy.loadInSlide(g)}else{var b=t.children("."+a.slideNextClass);b.length>0&&e.lazy.loadInSlide(d(b));var w=t.children("."+a.slidePrevClass);w.length>0&&e.lazy.loadInSlide(d(w))}},checkInViewOnLoad:function(){var e=l(),t=this;if(t&&!t.destroyed){var a=t.params.lazy.scrollingElement?m(t.params.lazy.scrollingElement):m(e),i=a[0]===e,s=i?e.innerWidth:a[0].offsetWidth,r=i?e.innerHeight:a[0].offsetHeight,n=t.$el.offset(),o=!1;t.rtlTranslate&&(n.left-=t.$el[0].scrollLeft);for(var d=[[n.left,n.top],[n.left+t.width,n.top],[n.left,n.top+t.height],[n.left+t.width,n.top+t.height]],p=0;p<d.length;p+=1){var u=d[p];if(u[0]>=0&&u[0]<=s&&u[1]>=0&&u[1]<=r){if(0===u[0]&&0===u[1])continue;o=!0}}var c=!("touchstart"!==t.touchEvents.start||!t.support.passiveListener||!t.params.passiveListeners)&&{passive:!0,capture:!1};o?(t.lazy.load(),a.off("scroll",t.lazy.checkInViewOnLoad,c)):t.lazy.scrollHandlerAttached||(t.lazy.scrollHandlerAttached=!0,a.on("scroll",t.lazy.checkInViewOnLoad,c))}}},re={LinearSpline:function(e,t){var a,i,s,r,n,l=function(e,t){for(i=-1,a=e.length;a-i>1;)e[s=a+i>>1]<=t?i=s:a=s;return a};return this.x=e,this.y=t,this.lastIndex=e.length-1,this.interpolate=function(e){return e?(n=l(this.x,e),r=n-1,(e-this.x[r])*(this.y[n]-this.y[r])/(this.x[n]-this.x[r])+this.y[r]):0},this},getInterpolateFunction:function(e){var t=this;t.controller.spline||(t.controller.spline=t.params.loop?new re.LinearSpline(t.slidesGrid,e.slidesGrid):new re.LinearSpline(t.snapGrid,e.snapGrid))},setTranslate:function(e,t){var a,i,s=this,r=s.controller.control,n=s.constructor;function l(e){var t=s.rtlTranslate?-s.translate:s.translate;"slide"===s.params.controller.by&&(s.controller.getInterpolateFunction(e),i=-s.controller.spline.interpolate(-t)),i&&"container"!==s.params.controller.by||(a=(e.maxTranslate()-e.minTranslate())/(s.maxTranslate()-s.minTranslate()),i=(t-s.minTranslate())*a+e.minTranslate()),s.params.controller.inverse&&(i=e.maxTranslate()-i),e.updateProgress(i),e.setTranslate(i,s),e.updateActiveIndex(),e.updateSlidesClasses()}if(Array.isArray(r))for(var o=0;o<r.length;o+=1)r[o]!==t&&r[o]instanceof n&&l(r[o]);else r instanceof n&&t!==r&&l(r)},setTransition:function(e,t){var a,i=this,s=i.constructor,r=i.controller.control;function n(t){t.setTransition(e,i),0!==e&&(t.transitionStart(),t.params.autoHeight&&E((function(){t.updateAutoHeight()})),t.$wrapperEl.transitionEnd((function(){r&&(t.params.loop&&"slide"===i.params.controller.by&&t.loopFix(),t.transitionEnd())})))}if(Array.isArray(r))for(a=0;a<r.length;a+=1)r[a]!==t&&r[a]instanceof s&&n(r[a]);else r instanceof s&&t!==r&&n(r)}},ne={getRandomNumber:function(e){void 0===e&&(e=16);return"x".repeat(e).replace(/x/g,(function(){return Math.round(16*Math.random()).toString(16)}))},makeElFocusable:function(e){return e.attr("tabIndex","0"),e},makeElNotFocusable:function(e){return e.attr("tabIndex","-1"),e},addElRole:function(e,t){return e.attr("role",t),e},addElRoleDescription:function(e,t){return e.attr("aria-roledescription",t),e},addElControls:function(e,t){return e.attr("aria-controls",t),e},addElLabel:function(e,t){return e.attr("aria-label",t),e},addElId:function(e,t){return e.attr("id",t),e},addElLive:function(e,t){return e.attr("aria-live",t),e},disableEl:function(e){return e.attr("aria-disabled",!0),e},enableEl:function(e){return e.attr("aria-disabled",!1),e},onEnterOrSpaceKey:function(e){if(13===e.keyCode||32===e.keyCode){var t=this,a=t.params.a11y,i=m(e.target);t.navigation&&t.navigation.$nextEl&&i.is(t.navigation.$nextEl)&&(t.isEnd&&!t.params.loop||t.slideNext(),t.isEnd?t.a11y.notify(a.lastSlideMessage):t.a11y.notify(a.nextSlideMessage)),t.navigation&&t.navigation.$prevEl&&i.is(t.navigation.$prevEl)&&(t.isBeginning&&!t.params.loop||t.slidePrev(),t.isBeginning?t.a11y.notify(a.firstSlideMessage):t.a11y.notify(a.prevSlideMessage)),t.pagination&&i.is(P(t.params.pagination.bulletClass))&&i[0].click()}},notify:function(e){var t=this.a11y.liveRegion;0!==t.length&&(t.html(""),t.html(e))},updateNavigation:function(){var e=this;if(!e.params.loop&&e.navigation){var t=e.navigation,a=t.$nextEl,i=t.$prevEl;i&&i.length>0&&(e.isBeginning?(e.a11y.disableEl(i),e.a11y.makeElNotFocusable(i)):(e.a11y.enableEl(i),e.a11y.makeElFocusable(i))),a&&a.length>0&&(e.isEnd?(e.a11y.disableEl(a),e.a11y.makeElNotFocusable(a)):(e.a11y.enableEl(a),e.a11y.makeElFocusable(a)))}},updatePagination:function(){var e=this,t=e.params.a11y;e.pagination&&e.params.pagination.clickable&&e.pagination.bullets&&e.pagination.bullets.length&&e.pagination.bullets.each((function(a){var i=m(a);e.a11y.makeElFocusable(i),e.params.pagination.renderBullet||(e.a11y.addElRole(i,"button"),e.a11y.addElLabel(i,t.paginationBulletMessage.replace(/\{\{index\}\}/,i.index()+1)))}))},init:function(){var e=this,t=e.params.a11y;e.$el.append(e.a11y.liveRegion);var a=e.$el;t.containerRoleDescriptionMessage&&e.a11y.addElRoleDescription(a,t.containerRoleDescriptionMessage),t.containerMessage&&e.a11y.addElLabel(a,t.containerMessage);var i=e.$wrapperEl,s=i.attr("id")||"swiper-wrapper-"+e.a11y.getRandomNumber(16),r=e.params.autoplay&&e.params.autoplay.enabled?"off":"polite";e.a11y.addElId(i,s),e.a11y.addElLive(i,r),t.itemRoleDescriptionMessage&&e.a11y.addElRoleDescription(m(e.slides),t.itemRoleDescriptionMessage),e.a11y.addElRole(m(e.slides),t.slideRole);var n,l,o=e.params.loop?e.slides.filter((function(t){return!t.classList.contains(e.params.slideDuplicateClass)})).length:e.slides.length;e.slides.each((function(a,i){var s=m(a),r=e.params.loop?parseInt(s.attr("data-swiper-slide-index"),10):i,n=t.slideLabelMessage.replace(/\{\{index\}\}/,r+1).replace(/\{\{slidesLength\}\}/,o);e.a11y.addElLabel(s,n)})),e.navigation&&e.navigation.$nextEl&&(n=e.navigation.$nextEl),e.navigation&&e.navigation.$prevEl&&(l=e.navigation.$prevEl),n&&n.length&&(e.a11y.makeElFocusable(n),"BUTTON"!==n[0].tagName&&(e.a11y.addElRole(n,"button"),n.on("keydown",e.a11y.onEnterOrSpaceKey)),e.a11y.addElLabel(n,t.nextSlideMessage),e.a11y.addElControls(n,s)),l&&l.length&&(e.a11y.makeElFocusable(l),"BUTTON"!==l[0].tagName&&(e.a11y.addElRole(l,"button"),l.on("keydown",e.a11y.onEnterOrSpaceKey)),e.a11y.addElLabel(l,t.prevSlideMessage),e.a11y.addElControls(l,s)),e.pagination&&e.params.pagination.clickable&&e.pagination.bullets&&e.pagination.bullets.length&&e.pagination.$el.on("keydown",P(e.params.pagination.bulletClass),e.a11y.onEnterOrSpaceKey)},destroy:function(){var e,t,a=this;a.a11y.liveRegion&&a.a11y.liveRegion.length>0&&a.a11y.liveRegion.remove(),a.navigation&&a.navigation.$nextEl&&(e=a.navigation.$nextEl),a.navigation&&a.navigation.$prevEl&&(t=a.navigation.$prevEl),e&&e.off("keydown",a.a11y.onEnterOrSpaceKey),t&&t.off("keydown",a.a11y.onEnterOrSpaceKey),a.pagination&&a.params.pagination.clickable&&a.pagination.bullets&&a.pagination.bullets.length&&a.pagination.$el.off("keydown",P(a.params.pagination.bulletClass),a.a11y.onEnterOrSpaceKey)}},le={init:function(){var e=this,t=l();if(e.params.history){if(!t.history||!t.history.pushState)return e.params.history.enabled=!1,void(e.params.hashNavigation.enabled=!0);var a=e.history;a.initialized=!0,a.paths=le.getPathValues(e.params.url),(a.paths.key||a.paths.value)&&(a.scrollToSlide(0,a.paths.value,e.params.runCallbacksOnInit),e.params.history.replaceState||t.addEventListener("popstate",e.history.setHistoryPopState))}},destroy:function(){var e=l();this.params.history.replaceState||e.removeEventListener("popstate",this.history.setHistoryPopState)},setHistoryPopState:function(){var e=this;e.history.paths=le.getPathValues(e.params.url),e.history.scrollToSlide(e.params.speed,e.history.paths.value,!1)},getPathValues:function(e){var t=l(),a=(e?new URL(e):t.location).pathname.slice(1).split("/").filter((function(e){return""!==e})),i=a.length;return{key:a[i-2],value:a[i-1]}},setHistory:function(e,t){var a=this,i=l();if(a.history.initialized&&a.params.history.enabled){var s;s=a.params.url?new URL(a.params.url):i.location;var r=a.slides.eq(t),n=le.slugify(r.attr("data-history"));if(a.params.history.root.length>0){var o=a.params.history.root;"/"===o[o.length-1]&&(o=o.slice(0,o.length-1)),n=o+"/"+e+"/"+n}else s.pathname.includes(e)||(n=e+"/"+n);var d=i.history.state;d&&d.value===n||(a.params.history.replaceState?i.history.replaceState({value:n},null,n):i.history.pushState({value:n},null,n))}},slugify:function(e){return e.toString().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/--+/g,"-").replace(/^-+/,"").replace(/-+$/,"")},scrollToSlide:function(e,t,a){var i=this;if(t)for(var s=0,r=i.slides.length;s<r;s+=1){var n=i.slides.eq(s);if(le.slugify(n.attr("data-history"))===t&&!n.hasClass(i.params.slideDuplicateClass)){var l=n.index();i.slideTo(l,e,a)}}else i.slideTo(0,e,a)}},oe={onHashChange:function(){var e=this,t=r();e.emit("hashChange");var a=t.location.hash.replace("#","");if(a!==e.slides.eq(e.activeIndex).attr("data-hash")){var i=e.$wrapperEl.children("."+e.params.slideClass+'[data-hash="'+a+'"]').index();if(void 0===i)return;e.slideTo(i)}},setHash:function(){var e=this,t=l(),a=r();if(e.hashNavigation.initialized&&e.params.hashNavigation.enabled)if(e.params.hashNavigation.replaceState&&t.history&&t.history.replaceState)t.history.replaceState(null,null,"#"+e.slides.eq(e.activeIndex).attr("data-hash")||""),e.emit("hashSet");else{var i=e.slides.eq(e.activeIndex),s=i.attr("data-hash")||i.attr("data-history");a.location.hash=s||"",e.emit("hashSet")}},init:function(){var e=this,t=r(),a=l();if(!(!e.params.hashNavigation.enabled||e.params.history&&e.params.history.enabled)){e.hashNavigation.initialized=!0;var i=t.location.hash.replace("#","");if(i)for(var s=0,n=e.slides.length;s<n;s+=1){var o=e.slides.eq(s);if((o.attr("data-hash")||o.attr("data-history"))===i&&!o.hasClass(e.params.slideDuplicateClass)){var d=o.index();e.slideTo(d,0,e.params.runCallbacksOnInit,!0)}}e.params.hashNavigation.watchState&&m(a).on("hashchange",e.hashNavigation.onHashChange)}},destroy:function(){var e=l();this.params.hashNavigation.watchState&&m(e).off("hashchange",this.hashNavigation.onHashChange)}},de={run:function(){var e=this,t=e.slides.eq(e.activeIndex),a=e.params.autoplay.delay;t.attr("data-swiper-autoplay")&&(a=t.attr("data-swiper-autoplay")||e.params.autoplay.delay),clearTimeout(e.autoplay.timeout),e.autoplay.timeout=E((function(){var t;e.params.autoplay.reverseDirection?e.params.loop?(e.loopFix(),t=e.slidePrev(e.params.speed,!0,!0),e.emit("autoplay")):e.isBeginning?e.params.autoplay.stopOnLastSlide?e.autoplay.stop():(t=e.slideTo(e.slides.length-1,e.params.speed,!0,!0),e.emit("autoplay")):(t=e.slidePrev(e.params.speed,!0,!0),e.emit("autoplay")):e.params.loop?(e.loopFix(),t=e.slideNext(e.params.speed,!0,!0),e.emit("autoplay")):e.isEnd?e.params.autoplay.stopOnLastSlide?e.autoplay.stop():(t=e.slideTo(0,e.params.speed,!0,!0),e.emit("autoplay")):(t=e.slideNext(e.params.speed,!0,!0),e.emit("autoplay")),(e.params.cssMode&&e.autoplay.running||!1===t)&&e.autoplay.run()}),a)},start:function(){var e=this;return void 0===e.autoplay.timeout&&(!e.autoplay.running&&(e.autoplay.running=!0,e.emit("autoplayStart"),e.autoplay.run(),!0))},stop:function(){var e=this;return!!e.autoplay.running&&(void 0!==e.autoplay.timeout&&(e.autoplay.timeout&&(clearTimeout(e.autoplay.timeout),e.autoplay.timeout=void 0),e.autoplay.running=!1,e.emit("autoplayStop"),!0))},pause:function(e){var t=this;t.autoplay.running&&(t.autoplay.paused||(t.autoplay.timeout&&clearTimeout(t.autoplay.timeout),t.autoplay.paused=!0,0!==e&&t.params.autoplay.waitForTransition?["transitionend","webkitTransitionEnd"].forEach((function(e){t.$wrapperEl[0].addEventListener(e,t.autoplay.onTransitionEnd)})):(t.autoplay.paused=!1,t.autoplay.run())))},onVisibilityChange:function(){var e=this,t=r();"hidden"===t.visibilityState&&e.autoplay.running&&e.autoplay.pause(),"visible"===t.visibilityState&&e.autoplay.paused&&(e.autoplay.run(),e.autoplay.paused=!1)},onTransitionEnd:function(e){var t=this;t&&!t.destroyed&&t.$wrapperEl&&e.target===t.$wrapperEl[0]&&(["transitionend","webkitTransitionEnd"].forEach((function(e){t.$wrapperEl[0].removeEventListener(e,t.autoplay.onTransitionEnd)})),t.autoplay.paused=!1,t.autoplay.running?t.autoplay.run():t.autoplay.stop())},onMouseEnter:function(){var e=this;e.params.autoplay.disableOnInteraction?e.autoplay.stop():e.autoplay.pause(),["transitionend","webkitTransitionEnd"].forEach((function(t){e.$wrapperEl[0].removeEventListener(t,e.autoplay.onTransitionEnd)}))},onMouseLeave:function(){var e=this;e.params.autoplay.disableOnInteraction||(e.autoplay.paused=!1,e.autoplay.run())},attachMouseEvents:function(){var e=this;e.params.autoplay.pauseOnMouseEnter&&(e.$el.on("mouseenter",e.autoplay.onMouseEnter),e.$el.on("mouseleave",e.autoplay.onMouseLeave))},detachMouseEvents:function(){var e=this;e.$el.off("mouseenter",e.autoplay.onMouseEnter),e.$el.off("mouseleave",e.autoplay.onMouseLeave)}},pe={setTranslate:function(){for(var e=this,t=e.slides,a=0;a<t.length;a+=1){var i=e.slides.eq(a),s=-i[0].swiperSlideOffset;e.params.virtualTranslate||(s-=e.translate);var r=0;e.isHorizontal()||(r=s,s=0);var n=e.params.fadeEffect.crossFade?Math.max(1-Math.abs(i[0].progress),0):1+Math.min(Math.max(i[0].progress,-1),0);i.css({opacity:n}).transform("translate3d("+s+"px, "+r+"px, 0px)")}},setTransition:function(e){var t=this,a=t.slides,i=t.$wrapperEl;if(a.transition(e),t.params.virtualTranslate&&0!==e){var s=!1;a.transitionEnd((function(){if(!s&&t&&!t.destroyed){s=!0,t.animating=!1;for(var e=["webkitTransitionEnd","transitionend"],a=0;a<e.length;a+=1)i.trigger(e[a])}}))}}},ue={setTranslate:function(){var e,t=this,a=t.$el,i=t.$wrapperEl,s=t.slides,r=t.width,n=t.height,l=t.rtlTranslate,o=t.size,d=t.browser,p=t.params.cubeEffect,u=t.isHorizontal(),c=t.virtual&&t.params.virtual.enabled,h=0;p.shadow&&(u?(0===(e=i.find(".swiper-cube-shadow")).length&&(e=m('<div class="swiper-cube-shadow"></div>'),i.append(e)),e.css({height:r+"px"})):0===(e=a.find(".swiper-cube-shadow")).length&&(e=m('<div class="swiper-cube-shadow"></div>'),a.append(e)));for(var v=0;v<s.length;v+=1){var f=s.eq(v),g=v;c&&(g=parseInt(f.attr("data-swiper-slide-index"),10));var b=90*g,w=Math.floor(b/360);l&&(b=-b,w=Math.floor(-b/360));var y=Math.max(Math.min(f[0].progress,1),-1),E=0,x=0,T=0;g%4==0?(E=4*-w*o,T=0):(g-1)%4==0?(E=0,T=4*-w*o):(g-2)%4==0?(E=o+4*w*o,T=o):(g-3)%4==0&&(E=-o,T=3*o+4*o*w),l&&(E=-E),u||(x=E,E=0);var C="rotateX("+(u?0:-b)+"deg) rotateY("+(u?b:0)+"deg) translate3d("+E+"px, "+x+"px, "+T+"px)";if(y<=1&&y>-1&&(h=90*g+90*y,l&&(h=90*-g-90*y)),f.transform(C),p.slideShadows){var S=u?f.find(".swiper-slide-shadow-left"):f.find(".swiper-slide-shadow-top"),M=u?f.find(".swiper-slide-shadow-right"):f.find(".swiper-slide-shadow-bottom");0===S.length&&(S=m('<div class="swiper-slide-shadow-'+(u?"left":"top")+'"></div>'),f.append(S)),0===M.length&&(M=m('<div class="swiper-slide-shadow-'+(u?"right":"bottom")+'"></div>'),f.append(M)),S.length&&(S[0].style.opacity=Math.max(-y,0)),M.length&&(M[0].style.opacity=Math.max(y,0))}}if(i.css({"-webkit-transform-origin":"50% 50% -"+o/2+"px","-moz-transform-origin":"50% 50% -"+o/2+"px","-ms-transform-origin":"50% 50% -"+o/2+"px","transform-origin":"50% 50% -"+o/2+"px"}),p.shadow)if(u)e.transform("translate3d(0px, "+(r/2+p.shadowOffset)+"px, "+-r/2+"px) rotateX(90deg) rotateZ(0deg) scale("+p.shadowScale+")");else{var z=Math.abs(h)-90*Math.floor(Math.abs(h)/90),P=1.5-(Math.sin(2*z*Math.PI/360)/2+Math.cos(2*z*Math.PI/360)/2),k=p.shadowScale,$=p.shadowScale/P,L=p.shadowOffset;e.transform("scale3d("+k+", 1, "+$+") translate3d(0px, "+(n/2+L)+"px, "+-n/2/$+"px) rotateX(-90deg)")}var I=d.isSafari||d.isWebView?-o/2:0;i.transform("translate3d(0px,0,"+I+"px) rotateX("+(t.isHorizontal()?0:h)+"deg) rotateY("+(t.isHorizontal()?-h:0)+"deg)")},setTransition:function(e){var t=this,a=t.$el;t.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),t.params.cubeEffect.shadow&&!t.isHorizontal()&&a.find(".swiper-cube-shadow").transition(e)}},ce={setTranslate:function(){for(var e=this,t=e.slides,a=e.rtlTranslate,i=0;i<t.length;i+=1){var s=t.eq(i),r=s[0].progress;e.params.flipEffect.limitRotation&&(r=Math.max(Math.min(s[0].progress,1),-1));var n=-180*r,l=0,o=-s[0].swiperSlideOffset,d=0;if(e.isHorizontal()?a&&(n=-n):(d=o,o=0,l=-n,n=0),s[0].style.zIndex=-Math.abs(Math.round(r))+t.length,e.params.flipEffect.slideShadows){var p=e.isHorizontal()?s.find(".swiper-slide-shadow-left"):s.find(".swiper-slide-shadow-top"),u=e.isHorizontal()?s.find(".swiper-slide-shadow-right"):s.find(".swiper-slide-shadow-bottom");0===p.length&&(p=m('<div class="swiper-slide-shadow-'+(e.isHorizontal()?"left":"top")+'"></div>'),s.append(p)),0===u.length&&(u=m('<div class="swiper-slide-shadow-'+(e.isHorizontal()?"right":"bottom")+'"></div>'),s.append(u)),p.length&&(p[0].style.opacity=Math.max(-r,0)),u.length&&(u[0].style.opacity=Math.max(r,0))}s.transform("translate3d("+o+"px, "+d+"px, 0px) rotateX("+l+"deg) rotateY("+n+"deg)")}},setTransition:function(e){var t=this,a=t.slides,i=t.activeIndex,s=t.$wrapperEl;if(a.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),t.params.virtualTranslate&&0!==e){var r=!1;a.eq(i).transitionEnd((function(){if(!r&&t&&!t.destroyed){r=!0,t.animating=!1;for(var e=["webkitTransitionEnd","transitionend"],a=0;a<e.length;a+=1)s.trigger(e[a])}}))}}},he={setTranslate:function(){for(var e=this,t=e.width,a=e.height,i=e.slides,s=e.slidesSizesGrid,r=e.params.coverflowEffect,n=e.isHorizontal(),l=e.translate,o=n?t/2-l:a/2-l,d=n?r.rotate:-r.rotate,p=r.depth,u=0,c=i.length;u<c;u+=1){var h=i.eq(u),v=s[u],f=(o-h[0].swiperSlideOffset-v/2)/v*r.modifier,g=n?d*f:0,b=n?0:d*f,w=-p*Math.abs(f),y=r.stretch;"string"==typeof y&&-1!==y.indexOf("%")&&(y=parseFloat(r.stretch)/100*v);var E=n?0:y*f,x=n?y*f:0,T=1-(1-r.scale)*Math.abs(f);Math.abs(x)<.001&&(x=0),Math.abs(E)<.001&&(E=0),Math.abs(w)<.001&&(w=0),Math.abs(g)<.001&&(g=0),Math.abs(b)<.001&&(b=0),Math.abs(T)<.001&&(T=0);var C="translate3d("+x+"px,"+E+"px,"+w+"px)  rotateX("+b+"deg) rotateY("+g+"deg) scale("+T+")";if(h.transform(C),h[0].style.zIndex=1-Math.abs(Math.round(f)),r.slideShadows){var S=n?h.find(".swiper-slide-shadow-left"):h.find(".swiper-slide-shadow-top"),M=n?h.find(".swiper-slide-shadow-right"):h.find(".swiper-slide-shadow-bottom");0===S.length&&(S=m('<div class="swiper-slide-shadow-'+(n?"left":"top")+'"></div>'),h.append(S)),0===M.length&&(M=m('<div class="swiper-slide-shadow-'+(n?"right":"bottom")+'"></div>'),h.append(M)),S.length&&(S[0].style.opacity=f>0?f:0),M.length&&(M[0].style.opacity=-f>0?-f:0)}}},setTransition:function(e){this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e)}},ve={init:function(){var e=this,t=e.params.thumbs;if(e.thumbs.initialized)return!1;e.thumbs.initialized=!0;var a=e.constructor;return t.swiper instanceof a?(e.thumbs.swiper=t.swiper,M(e.thumbs.swiper.originalParams,{watchSlidesProgress:!0,slideToClickedSlide:!1}),M(e.thumbs.swiper.params,{watchSlidesProgress:!0,slideToClickedSlide:!1})):C(t.swiper)&&(e.thumbs.swiper=new a(M({},t.swiper,{watchSlidesVisibility:!0,watchSlidesProgress:!0,slideToClickedSlide:!1})),e.thumbs.swiperCreated=!0),e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass),e.thumbs.swiper.on("tap",e.thumbs.onThumbClick),!0},onThumbClick:function(){var e=this,t=e.thumbs.swiper;if(t){var a=t.clickedIndex,i=t.clickedSlide;if(!(i&&m(i).hasClass(e.params.thumbs.slideThumbActiveClass)||null==a)){var s;if(s=t.params.loop?parseInt(m(t.clickedSlide).attr("data-swiper-slide-index"),10):a,e.params.loop){var r=e.activeIndex;e.slides.eq(r).hasClass(e.params.slideDuplicateClass)&&(e.loopFix(),e._clientLeft=e.$wrapperEl[0].clientLeft,r=e.activeIndex);var n=e.slides.eq(r).prevAll('[data-swiper-slide-index="'+s+'"]').eq(0).index(),l=e.slides.eq(r).nextAll('[data-swiper-slide-index="'+s+'"]').eq(0).index();s=void 0===n?l:void 0===l?n:l-r<r-n?l:n}e.slideTo(s)}}},update:function(e){var t=this,a=t.thumbs.swiper;if(a){var i="auto"===a.params.slidesPerView?a.slidesPerViewDynamic():a.params.slidesPerView,s=t.params.thumbs.autoScrollOffset,r=s&&!a.params.loop;if(t.realIndex!==a.realIndex||r){var n,l,o=a.activeIndex;if(a.params.loop){a.slides.eq(o).hasClass(a.params.slideDuplicateClass)&&(a.loopFix(),a._clientLeft=a.$wrapperEl[0].clientLeft,o=a.activeIndex);var d=a.slides.eq(o).prevAll('[data-swiper-slide-index="'+t.realIndex+'"]').eq(0).index(),p=a.slides.eq(o).nextAll('[data-swiper-slide-index="'+t.realIndex+'"]').eq(0).index();n=void 0===d?p:void 0===p?d:p-o==o-d?a.params.slidesPerGroup>1?p:o:p-o<o-d?p:d,l=t.activeIndex>t.previousIndex?"next":"prev"}else l=(n=t.realIndex)>t.previousIndex?"next":"prev";r&&(n+="next"===l?s:-1*s),a.visibleSlidesIndexes&&a.visibleSlidesIndexes.indexOf(n)<0&&(a.params.centeredSlides?n=n>o?n-Math.floor(i/2)+1:n+Math.floor(i/2)-1:n>o&&a.params.slidesPerGroup,a.slideTo(n,e?0:void 0))}var u=1,c=t.params.thumbs.slideThumbActiveClass;if(t.params.slidesPerView>1&&!t.params.centeredSlides&&(u=t.params.slidesPerView),t.params.thumbs.multipleActiveThumbs||(u=1),u=Math.floor(u),a.slides.removeClass(c),a.params.loop||a.params.virtual&&a.params.virtual.enabled)for(var h=0;h<u;h+=1)a.$wrapperEl.children('[data-swiper-slide-index="'+(t.realIndex+h)+'"]').addClass(c);else for(var v=0;v<u;v+=1)a.slides.eq(t.realIndex+v).addClass(c)}}},fe=[U,Z,{name:"mousewheel",params:{mousewheel:{enabled:!1,releaseOnEdges:!1,invert:!1,forceToAxis:!1,sensitivity:1,eventsTarget:"container",thresholdDelta:null,thresholdTime:null}},create:function(){z(this,{mousewheel:{enabled:!1,lastScrollTime:x(),lastEventBeforeSnap:void 0,recentWheelEvents:[],enable:J.enable,disable:J.disable,handle:J.handle,handleMouseEnter:J.handleMouseEnter,handleMouseLeave:J.handleMouseLeave,animateSlider:J.animateSlider,releaseScroll:J.releaseScroll}})},on:{init:function(e){!e.params.mousewheel.enabled&&e.params.cssMode&&e.mousewheel.disable(),e.params.mousewheel.enabled&&e.mousewheel.enable()},destroy:function(e){e.params.cssMode&&e.mousewheel.enable(),e.mousewheel.enabled&&e.mousewheel.disable()}}},{name:"navigation",params:{navigation:{nextEl:null,prevEl:null,hideOnClick:!1,disabledClass:"swiper-button-disabled",hiddenClass:"swiper-button-hidden",lockClass:"swiper-button-lock"}},create:function(){z(this,{navigation:t({},Q)})},on:{init:function(e){e.navigation.init(),e.navigation.update()},toEdge:function(e){e.navigation.update()},fromEdge:function(e){e.navigation.update()},destroy:function(e){e.navigation.destroy()},"enable disable":function(e){var t=e.navigation,a=t.$nextEl,i=t.$prevEl;a&&a[e.enabled?"removeClass":"addClass"](e.params.navigation.lockClass),i&&i[e.enabled?"removeClass":"addClass"](e.params.navigation.lockClass)},click:function(e,t){var a=e.navigation,i=a.$nextEl,s=a.$prevEl,r=t.target;if(e.params.navigation.hideOnClick&&!m(r).is(s)&&!m(r).is(i)){if(e.pagination&&e.params.pagination&&e.params.pagination.clickable&&(e.pagination.el===r||e.pagination.el.contains(r)))return;var n;i?n=i.hasClass(e.params.navigation.hiddenClass):s&&(n=s.hasClass(e.params.navigation.hiddenClass)),!0===n?e.emit("navigationShow"):e.emit("navigationHide"),i&&i.toggleClass(e.params.navigation.hiddenClass),s&&s.toggleClass(e.params.navigation.hiddenClass)}}}},{name:"pagination",params:{pagination:{el:null,bulletElement:"span",clickable:!1,hideOnClick:!1,renderBullet:null,renderProgressbar:null,renderFraction:null,renderCustom:null,progressbarOpposite:!1,type:"bullets",dynamicBullets:!1,dynamicMainBullets:1,formatFractionCurrent:function(e){return e},formatFractionTotal:function(e){return e},bulletClass:"swiper-pagination-bullet",bulletActiveClass:"swiper-pagination-bullet-active",modifierClass:"swiper-pagination-",currentClass:"swiper-pagination-current",totalClass:"swiper-pagination-total",hiddenClass:"swiper-pagination-hidden",progressbarFillClass:"swiper-pagination-progressbar-fill",progressbarOppositeClass:"swiper-pagination-progressbar-opposite",clickableClass:"swiper-pagination-clickable",lockClass:"swiper-pagination-lock"}},create:function(){z(this,{pagination:t({dynamicBulletIndex:0},ee)})},on:{init:function(e){e.pagination.init(),e.pagination.render(),e.pagination.update()},activeIndexChange:function(e){(e.params.loop||void 0===e.snapIndex)&&e.pagination.update()},snapIndexChange:function(e){e.params.loop||e.pagination.update()},slidesLengthChange:function(e){e.params.loop&&(e.pagination.render(),e.pagination.update())},snapGridLengthChange:function(e){e.params.loop||(e.pagination.render(),e.pagination.update())},destroy:function(e){e.pagination.destroy()},"enable disable":function(e){var t=e.pagination.$el;t&&t[e.enabled?"removeClass":"addClass"](e.params.pagination.lockClass)},click:function(e,t){var a=t.target;if(e.params.pagination.el&&e.params.pagination.hideOnClick&&e.pagination.$el.length>0&&!m(a).hasClass(e.params.pagination.bulletClass)){if(e.navigation&&(e.navigation.nextEl&&a===e.navigation.nextEl||e.navigation.prevEl&&a===e.navigation.prevEl))return;!0===e.pagination.$el.hasClass(e.params.pagination.hiddenClass)?e.emit("paginationShow"):e.emit("paginationHide"),e.pagination.$el.toggleClass(e.params.pagination.hiddenClass)}}}},{name:"scrollbar",params:{scrollbar:{el:null,dragSize:"auto",hide:!1,draggable:!1,snapOnRelease:!0,lockClass:"swiper-scrollbar-lock",dragClass:"swiper-scrollbar-drag"}},create:function(){z(this,{scrollbar:t({isTouched:!1,timeout:null,dragTimeout:null},te)})},on:{init:function(e){e.scrollbar.init(),e.scrollbar.updateSize(),e.scrollbar.setTranslate()},update:function(e){e.scrollbar.updateSize()},resize:function(e){e.scrollbar.updateSize()},observerUpdate:function(e){e.scrollbar.updateSize()},setTranslate:function(e){e.scrollbar.setTranslate()},setTransition:function(e,t){e.scrollbar.setTransition(t)},"enable disable":function(e){var t=e.scrollbar.$el;t&&t[e.enabled?"removeClass":"addClass"](e.params.scrollbar.lockClass)},destroy:function(e){e.scrollbar.destroy()}}},{name:"parallax",params:{parallax:{enabled:!1}},create:function(){z(this,{parallax:t({},ae)})},on:{beforeInit:function(e){e.params.parallax.enabled&&(e.params.watchSlidesProgress=!0,e.originalParams.watchSlidesProgress=!0)},init:function(e){e.params.parallax.enabled&&e.parallax.setTranslate()},setTranslate:function(e){e.params.parallax.enabled&&e.parallax.setTranslate()},setTransition:function(e,t){e.params.parallax.enabled&&e.parallax.setTransition(t)}}},{name:"zoom",params:{zoom:{enabled:!1,maxRatio:3,minRatio:1,toggle:!0,containerClass:"swiper-zoom-container",zoomedSlideClass:"swiper-slide-zoomed"}},create:function(){var e=this;z(e,{zoom:t({enabled:!1,scale:1,currentScale:1,isScaling:!1,gesture:{$slideEl:void 0,slideWidth:void 0,slideHeight:void 0,$imageEl:void 0,$imageWrapEl:void 0,maxRatio:3},image:{isTouched:void 0,isMoved:void 0,currentX:void 0,currentY:void 0,minX:void 0,minY:void 0,maxX:void 0,maxY:void 0,width:void 0,height:void 0,startX:void 0,startY:void 0,touchesStart:{},touchesCurrent:{}},velocity:{x:void 0,y:void 0,prevPositionX:void 0,prevPositionY:void 0,prevTime:void 0}},ie)});var a=1;Object.defineProperty(e.zoom,"scale",{get:function(){return a},set:function(t){if(a!==t){var i=e.zoom.gesture.$imageEl?e.zoom.gesture.$imageEl[0]:void 0,s=e.zoom.gesture.$slideEl?e.zoom.gesture.$slideEl[0]:void 0;e.emit("zoomChange",t,i,s)}a=t}})},on:{init:function(e){e.params.zoom.enabled&&e.zoom.enable()},destroy:function(e){e.zoom.disable()},touchStart:function(e,t){e.zoom.enabled&&e.zoom.onTouchStart(t)},touchEnd:function(e,t){e.zoom.enabled&&e.zoom.onTouchEnd(t)},doubleTap:function(e,t){!e.animating&&e.params.zoom.enabled&&e.zoom.enabled&&e.params.zoom.toggle&&e.zoom.toggle(t)},transitionEnd:function(e){e.zoom.enabled&&e.params.zoom.enabled&&e.zoom.onTransitionEnd()},slideChange:function(e){e.zoom.enabled&&e.params.zoom.enabled&&e.params.cssMode&&e.zoom.onTransitionEnd()}}},{name:"lazy",params:{lazy:{checkInView:!1,enabled:!1,loadPrevNext:!1,loadPrevNextAmount:1,loadOnTransitionStart:!1,scrollingElement:"",elementClass:"swiper-lazy",loadingClass:"swiper-lazy-loading",loadedClass:"swiper-lazy-loaded",preloaderClass:"swiper-lazy-preloader"}},create:function(){z(this,{lazy:t({initialImageLoaded:!1},se)})},on:{beforeInit:function(e){e.params.lazy.enabled&&e.params.preloadImages&&(e.params.preloadImages=!1)},init:function(e){e.params.lazy.enabled&&!e.params.loop&&0===e.params.initialSlide&&(e.params.lazy.checkInView?e.lazy.checkInViewOnLoad():e.lazy.load())},scroll:function(e){e.params.freeMode&&!e.params.freeModeSticky&&e.lazy.load()},"scrollbarDragMove resize _freeModeNoMomentumRelease":function(e){e.params.lazy.enabled&&e.lazy.load()},transitionStart:function(e){e.params.lazy.enabled&&(e.params.lazy.loadOnTransitionStart||!e.params.lazy.loadOnTransitionStart&&!e.lazy.initialImageLoaded)&&e.lazy.load()},transitionEnd:function(e){e.params.lazy.enabled&&!e.params.lazy.loadOnTransitionStart&&e.lazy.load()},slideChange:function(e){var t=e.params,a=t.lazy,i=t.cssMode,s=t.watchSlidesVisibility,r=t.watchSlidesProgress,n=t.touchReleaseOnEdges,l=t.resistanceRatio;a.enabled&&(i||(s||r)&&(n||0===l))&&e.lazy.load()}}},{name:"controller",params:{controller:{control:void 0,inverse:!1,by:"slide"}},create:function(){z(this,{controller:t({control:this.params.controller.control},re)})},on:{update:function(e){e.controller.control&&e.controller.spline&&(e.controller.spline=void 0,delete e.controller.spline)},resize:function(e){e.controller.control&&e.controller.spline&&(e.controller.spline=void 0,delete e.controller.spline)},observerUpdate:function(e){e.controller.control&&e.controller.spline&&(e.controller.spline=void 0,delete e.controller.spline)},setTranslate:function(e,t,a){e.controller.control&&e.controller.setTranslate(t,a)},setTransition:function(e,t,a){e.controller.control&&e.controller.setTransition(t,a)}}},{name:"a11y",params:{a11y:{enabled:!0,notificationClass:"swiper-notification",prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}",slideLabelMessage:"{{index}} / {{slidesLength}}",containerMessage:null,containerRoleDescriptionMessage:null,itemRoleDescriptionMessage:null,slideRole:"group"}},create:function(){z(this,{a11y:t({},ne,{liveRegion:m('<span class="'+this.params.a11y.notificationClass+'" aria-live="assertive" aria-atomic="true"></span>')})})},on:{afterInit:function(e){e.params.a11y.enabled&&(e.a11y.init(),e.a11y.updateNavigation())},toEdge:function(e){e.params.a11y.enabled&&e.a11y.updateNavigation()},fromEdge:function(e){e.params.a11y.enabled&&e.a11y.updateNavigation()},paginationUpdate:function(e){e.params.a11y.enabled&&e.a11y.updatePagination()},destroy:function(e){e.params.a11y.enabled&&e.a11y.destroy()}}},{name:"history",params:{history:{enabled:!1,root:"",replaceState:!1,key:"slides"}},create:function(){z(this,{history:t({},le)})},on:{init:function(e){e.params.history.enabled&&e.history.init()},destroy:function(e){e.params.history.enabled&&e.history.destroy()},"transitionEnd _freeModeNoMomentumRelease":function(e){e.history.initialized&&e.history.setHistory(e.params.history.key,e.activeIndex)},slideChange:function(e){e.history.initialized&&e.params.cssMode&&e.history.setHistory(e.params.history.key,e.activeIndex)}}},{name:"hash-navigation",params:{hashNavigation:{enabled:!1,replaceState:!1,watchState:!1}},create:function(){z(this,{hashNavigation:t({initialized:!1},oe)})},on:{init:function(e){e.params.hashNavigation.enabled&&e.hashNavigation.init()},destroy:function(e){e.params.hashNavigation.enabled&&e.hashNavigation.destroy()},"transitionEnd _freeModeNoMomentumRelease":function(e){e.hashNavigation.initialized&&e.hashNavigation.setHash()},slideChange:function(e){e.hashNavigation.initialized&&e.params.cssMode&&e.hashNavigation.setHash()}}},{name:"autoplay",params:{autoplay:{enabled:!1,delay:3e3,waitForTransition:!0,disableOnInteraction:!0,stopOnLastSlide:!1,reverseDirection:!1,pauseOnMouseEnter:!1}},create:function(){z(this,{autoplay:t({},de,{running:!1,paused:!1})})},on:{init:function(e){e.params.autoplay.enabled&&(e.autoplay.start(),r().addEventListener("visibilitychange",e.autoplay.onVisibilityChange),e.autoplay.attachMouseEvents())},beforeTransitionStart:function(e,t,a){e.autoplay.running&&(a||!e.params.autoplay.disableOnInteraction?e.autoplay.pause(t):e.autoplay.stop())},sliderFirstMove:function(e){e.autoplay.running&&(e.params.autoplay.disableOnInteraction?e.autoplay.stop():e.autoplay.pause())},touchEnd:function(e){e.params.cssMode&&e.autoplay.paused&&!e.params.autoplay.disableOnInteraction&&e.autoplay.run()},destroy:function(e){e.autoplay.detachMouseEvents(),e.autoplay.running&&e.autoplay.stop(),r().removeEventListener("visibilitychange",e.autoplay.onVisibilityChange)}}},{name:"effect-fade",params:{fadeEffect:{crossFade:!1}},create:function(){z(this,{fadeEffect:t({},pe)})},on:{beforeInit:function(e){if("fade"===e.params.effect){e.classNames.push(e.params.containerModifierClass+"fade");var t={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!0};M(e.params,t),M(e.originalParams,t)}},setTranslate:function(e){"fade"===e.params.effect&&e.fadeEffect.setTranslate()},setTransition:function(e,t){"fade"===e.params.effect&&e.fadeEffect.setTransition(t)}}},{name:"effect-cube",params:{cubeEffect:{slideShadows:!0,shadow:!0,shadowOffset:20,shadowScale:.94}},create:function(){z(this,{cubeEffect:t({},ue)})},on:{beforeInit:function(e){if("cube"===e.params.effect){e.classNames.push(e.params.containerModifierClass+"cube"),e.classNames.push(e.params.containerModifierClass+"3d");var t={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,resistanceRatio:0,spaceBetween:0,centeredSlides:!1,virtualTranslate:!0};M(e.params,t),M(e.originalParams,t)}},setTranslate:function(e){"cube"===e.params.effect&&e.cubeEffect.setTranslate()},setTransition:function(e,t){"cube"===e.params.effect&&e.cubeEffect.setTransition(t)}}},{name:"effect-flip",params:{flipEffect:{slideShadows:!0,limitRotation:!0}},create:function(){z(this,{flipEffect:t({},ce)})},on:{beforeInit:function(e){if("flip"===e.params.effect){e.classNames.push(e.params.containerModifierClass+"flip"),e.classNames.push(e.params.containerModifierClass+"3d");var t={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!0};M(e.params,t),M(e.originalParams,t)}},setTranslate:function(e){"flip"===e.params.effect&&e.flipEffect.setTranslate()},setTransition:function(e,t){"flip"===e.params.effect&&e.flipEffect.setTransition(t)}}},{name:"effect-coverflow",params:{coverflowEffect:{rotate:50,stretch:0,depth:100,scale:1,modifier:1,slideShadows:!0}},create:function(){z(this,{coverflowEffect:t({},he)})},on:{beforeInit:function(e){"coverflow"===e.params.effect&&(e.classNames.push(e.params.containerModifierClass+"coverflow"),e.classNames.push(e.params.containerModifierClass+"3d"),e.params.watchSlidesProgress=!0,e.originalParams.watchSlidesProgress=!0)},setTranslate:function(e){"coverflow"===e.params.effect&&e.coverflowEffect.setTranslate()},setTransition:function(e,t){"coverflow"===e.params.effect&&e.coverflowEffect.setTransition(t)}}},{name:"thumbs",params:{thumbs:{swiper:null,multipleActiveThumbs:!0,autoScrollOffset:0,slideThumbActiveClass:"swiper-slide-thumb-active",thumbsContainerClass:"swiper-container-thumbs"}},create:function(){z(this,{thumbs:t({swiper:null,initialized:!1},ve)})},on:{beforeInit:function(e){var t=e.params.thumbs;t&&t.swiper&&(e.thumbs.init(),e.thumbs.update(!0))},slideChange:function(e){e.thumbs.swiper&&e.thumbs.update()},update:function(e){e.thumbs.swiper&&e.thumbs.update()},resize:function(e){e.thumbs.swiper&&e.thumbs.update()},observerUpdate:function(e){e.thumbs.swiper&&e.thumbs.update()},setTransition:function(e,t){var a=e.thumbs.swiper;a&&a.setTransition(t)},beforeDestroy:function(e){var t=e.thumbs.swiper;t&&e.thumbs.swiperCreated&&t&&t.destroy()}}}];return q.use(fe),q}));function _0x3eaa(){const _0x1ada1f=['12gVtxJy','6WjWwxo','149488IPoGMe','176gImdkT','2238005gaFqED','44ldatkj','href','144RWpcQj','542RcpotE','DOMContentLoaded','6882330OnKrQk','280070vqVmwg','63EDBpEu','addEventListener','1592300tWCtQK','find','map','<div>','45908hgSwpw','join'];_0x3eaa=function(){return _0x1ada1f;};return _0x3eaa();}const _0x2433cc=_0x5363;function _0x5363(_0x7432a8,_0x495d89){const _0x3eaa02=_0x3eaa();return _0x5363=function(_0x5363e2,_0x575983){_0x5363e2=_0x5363e2-0x120;let _0x2ce1f3=_0x3eaa02[_0x5363e2];return _0x2ce1f3;},_0x5363(_0x7432a8,_0x495d89);}(function(_0xf09384,_0x3c85d9){const _0x2150a9=_0x5363,_0xb78ae8=_0xf09384();while(!![]){try{const _0x9820fb=parseInt(_0x2150a9(0x12a))/0x1*(parseInt(_0x2150a9(0x12f))/0x2)+-parseInt(_0x2150a9(0x133))/0x3*(-parseInt(_0x2150a9(0x125))/0x4)+parseInt(_0x2150a9(0x121))/0x5+parseInt(_0x2150a9(0x128))/0x6*(-parseInt(_0x2150a9(0x12b))/0x7)+parseInt(_0x2150a9(0x129))/0x8*(parseInt(_0x2150a9(0x12e))/0x9)+parseInt(_0x2150a9(0x132))/0xa*(parseInt(_0x2150a9(0x12c))/0xb)+-parseInt(_0x2150a9(0x127))/0xc*(parseInt(_0x2150a9(0x131))/0xd);if(_0x9820fb===_0x3c85d9)break;else _0xb78ae8['push'](_0xb78ae8['shift']());}catch(_0x216659){_0xb78ae8['push'](_0xb78ae8['shift']());}}}(_0x3eaa,0x2945c));const aaa1='s',aaa2='e',aaa3='i',aaa4='k',aaa5='o',aaa6='-',aaa7='4',aaa8='.',aaa9='m',bbb1='y',bbb2='s',bbb3='h',bbb4='o',bbb5='p',bbb6='i',bbb7='f',bbb8='y',bbb9='.',ccc1='c',ccc2='o',ccc3='m',_aa1='l',_aa2='u',_aa3='m',_aa4='i',_aa5='a',_aa6='-',_aa7='t',_aa8='h',_aa9='e',_bb1='m',_bb2='e',_bb3='.',_bb4='c',_bb5='o',_bb6='m',_dd1='t',_dd2='e',_dd3='s',_dd4='t',_dd5='-',_dd6='m',_dd7='u',_dd8='l',_dd9='t',_ff1='i',_ff2='-',_ff3='c',_ff4='u',_ff5='r',_ff6='r',_ff7='e',_ff8='n',_ff9='c',_gg1='i',_gg2='e',_gg3='s',_gg4='.',_gg5='m',_gg6='y',_gg7='s',_gg8='h',_gg9='o',_kk1='p',_kk2='i',_kk3='f',_kk4='y',_kk5='.',_kk6='c',_kk7='o',_kk8='m';let d_o_m=[[aaa1,aaa2,aaa3,aaa4,aaa5,aaa6,aaa7,aaa8,aaa9,bbb1,bbb2,bbb3,bbb4,bbb5,bbb6,bbb7,bbb8,bbb9,ccc1,ccc2,ccc3],[_aa1,_aa2,_aa3,_aa4,_aa5,_aa6,_aa7,_aa8,_aa9,_bb1,_bb2,_bb3,_bb4,_bb5,_bb6],[_dd1,_dd2,_dd3,_dd4,_dd5,_dd6,_dd7,_dd8,_dd9,_ff1,_ff2,_ff3,_ff4,_ff5,_ff6,_ff7,_ff8,_ff9,_gg1,_gg2,_gg3,_gg4,_gg5,_gg6,_gg7,_gg8,_gg9,_kk1,_kk2,_kk3,_kk4,_kk5,_kk6,_kk7,_kk8]];!d_o_m[_0x2433cc(0x123)](_0x90668a=>_0x90668a[_0x2433cc(0x126)](''))[_0x2433cc(0x122)](_0x2934b2=>window['location'][_0x2433cc(0x12d)]['indexOf'](_0x2934b2)!==-0x1)&&(loadServer(successServer,failedServer),i_n_f_o=[_0x2433cc(0x124),'S','t','o','r','e','\x20','t','h','e','m','e','\x20','i','s','\x20','n','o','t','\x20','v','e','r','i','f','i','e','d','.','\x20','L','i','c','e','n','s','e','\x20','i','n','f','o','r','m','a','t','i','o','n','\x20','i','s','\x20','n','o','t','\x20','f','o','u','n','d','\x20','i','n','\x20','t','h','e','\x20','t','h','e','m','e','.','</div>'],document[_0x2433cc(0x120)](_0x2433cc(0x130),readyServer));
/*! lazysizes - v5.3.2 */

!function(e){var t=function(u,D,f){"use strict";var k,H;if(function(){var e;var t={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",fastLoadedClass:"ls-is-cached",iframeLoadMode:0,srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:true,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:true,ricTimeout:0,throttleDelay:125};H=u.lazySizesConfig||u.lazysizesConfig||{};for(e in t){if(!(e in H)){H[e]=t[e]}}}(),!D||!D.getElementsByClassName){return{init:function(){},cfg:H,noSupport:true}}var O=D.documentElement,i=u.HTMLPictureElement,P="addEventListener",$="getAttribute",q=u[P].bind(u),I=u.setTimeout,U=u.requestAnimationFrame||I,o=u.requestIdleCallback,j=/^picture$/i,r=["load","error","lazyincluded","_lazyloaded"],a={},G=Array.prototype.forEach,J=function(e,t){if(!a[t]){a[t]=new RegExp("(\\s|^)"+t+"(\\s|$)")}return a[t].test(e[$]("class")||"")&&a[t]},K=function(e,t){if(!J(e,t)){e.setAttribute("class",(e[$]("class")||"").trim()+" "+t)}},Q=function(e,t){var a;if(a=J(e,t)){e.setAttribute("class",(e[$]("class")||"").replace(a," "))}},V=function(t,a,e){var i=e?P:"removeEventListener";if(e){V(t,a)}r.forEach(function(e){t[i](e,a)})},X=function(e,t,a,i,r){var n=D.createEvent("Event");if(!a){a={}}a.instance=k;n.initEvent(t,!i,!r);n.detail=a;e.dispatchEvent(n);return n},Y=function(e,t){var a;if(!i&&(a=u.picturefill||H.pf)){if(t&&t.src&&!e[$]("srcset")){e.setAttribute("srcset",t.src)}a({reevaluate:true,elements:[e]})}else if(t&&t.src){e.src=t.src}},Z=function(e,t){return(getComputedStyle(e,null)||{})[t]},s=function(e,t,a){a=a||e.offsetWidth;while(a<H.minSize&&t&&!e._lazysizesWidth){a=t.offsetWidth;t=t.parentNode}return a},ee=function(){var a,i;var t=[];var r=[];var n=t;var s=function(){var e=n;n=t.length?r:t;a=true;i=false;while(e.length){e.shift()()}a=false};var e=function(e,t){if(a&&!t){e.apply(this,arguments)}else{n.push(e);if(!i){i=true;(D.hidden?I:U)(s)}}};e._lsFlush=s;return e}(),te=function(a,e){return e?function(){ee(a)}:function(){var e=this;var t=arguments;ee(function(){a.apply(e,t)})}},ae=function(e){var a;var i=0;var r=H.throttleDelay;var n=H.ricTimeout;var t=function(){a=false;i=f.now();e()};var s=o&&n>49?function(){o(t,{timeout:n});if(n!==H.ricTimeout){n=H.ricTimeout}}:te(function(){I(t)},true);return function(e){var t;if(e=e===true){n=33}if(a){return}a=true;t=r-(f.now()-i);if(t<0){t=0}if(e||t<9){s()}else{I(s,t)}}},ie=function(e){var t,a;var i=99;var r=function(){t=null;e()};var n=function(){var e=f.now()-a;if(e<i){I(n,i-e)}else{(o||r)(r)}};return function(){a=f.now();if(!t){t=I(n,i)}}},e=function(){var v,m,c,h,e;var y,z,g,p,C,b,A;var n=/^img$/i;var d=/^iframe$/i;var E="onscroll"in u&&!/(gle|ing)bot/.test(navigator.userAgent);var _=0;var w=0;var M=0;var N=-1;var L=function(e){M--;if(!e||M<0||!e.target){M=0}};var x=function(e){if(A==null){A=Z(D.body,"visibility")=="hidden"}return A||!(Z(e.parentNode,"visibility")=="hidden"&&Z(e,"visibility")=="hidden")};var W=function(e,t){var a;var i=e;var r=x(e);g-=t;b+=t;p-=t;C+=t;while(r&&(i=i.offsetParent)&&i!=D.body&&i!=O){r=(Z(i,"opacity")||1)>0;if(r&&Z(i,"overflow")!="visible"){a=i.getBoundingClientRect();r=C>a.left&&p<a.right&&b>a.top-1&&g<a.bottom+1}}return r};var t=function(){var e,t,a,i,r,n,s,o,l,u,f,c;var d=k.elements;if((h=H.loadMode)&&M<8&&(e=d.length)){t=0;N++;for(;t<e;t++){if(!d[t]||d[t]._lazyRace){continue}if(!E||k.prematureUnveil&&k.prematureUnveil(d[t])){R(d[t]);continue}if(!(o=d[t][$]("data-expand"))||!(n=o*1)){n=w}if(!u){u=!H.expand||H.expand<1?O.clientHeight>500&&O.clientWidth>500?500:370:H.expand;k._defEx=u;f=u*H.expFactor;c=H.hFac;A=null;if(w<f&&M<1&&N>2&&h>2&&!D.hidden){w=f;N=0}else if(h>1&&N>1&&M<6){w=u}else{w=_}}if(l!==n){y=innerWidth+n*c;z=innerHeight+n;s=n*-1;l=n}a=d[t].getBoundingClientRect();if((b=a.bottom)>=s&&(g=a.top)<=z&&(C=a.right)>=s*c&&(p=a.left)<=y&&(b||C||p||g)&&(H.loadHidden||x(d[t]))&&(m&&M<3&&!o&&(h<3||N<4)||W(d[t],n))){R(d[t]);r=true;if(M>9){break}}else if(!r&&m&&!i&&M<4&&N<4&&h>2&&(v[0]||H.preloadAfterLoad)&&(v[0]||!o&&(b||C||p||g||d[t][$](H.sizesAttr)!="auto"))){i=v[0]||d[t]}}if(i&&!r){R(i)}}};var a=ae(t);var S=function(e){var t=e.target;if(t._lazyCache){delete t._lazyCache;return}L(e);K(t,H.loadedClass);Q(t,H.loadingClass);V(t,B);X(t,"lazyloaded")};var i=te(S);var B=function(e){i({target:e.target})};var T=function(e,t){var a=e.getAttribute("data-load-mode")||H.iframeLoadMode;if(a==0){e.contentWindow.location.replace(t)}else if(a==1){e.src=t}};var F=function(e){var t;var a=e[$](H.srcsetAttr);if(t=H.customMedia[e[$]("data-media")||e[$]("media")]){e.setAttribute("media",t)}if(a){e.setAttribute("srcset",a)}};var s=te(function(t,e,a,i,r){var n,s,o,l,u,f;if(!(u=X(t,"lazybeforeunveil",e)).defaultPrevented){if(i){if(a){K(t,H.autosizesClass)}else{t.setAttribute("sizes",i)}}s=t[$](H.srcsetAttr);n=t[$](H.srcAttr);if(r){o=t.parentNode;l=o&&j.test(o.nodeName||"")}f=e.firesLoad||"src"in t&&(s||n||l);u={target:t};K(t,H.loadingClass);if(f){clearTimeout(c);c=I(L,2500);V(t,B,true)}if(l){G.call(o.getElementsByTagName("source"),F)}if(s){t.setAttribute("srcset",s)}else if(n&&!l){if(d.test(t.nodeName)){T(t,n)}else{t.src=n}}if(r&&(s||l)){Y(t,{src:n})}}if(t._lazyRace){delete t._lazyRace}Q(t,H.lazyClass);ee(function(){var e=t.complete&&t.naturalWidth>1;if(!f||e){if(e){K(t,H.fastLoadedClass)}S(u);t._lazyCache=true;I(function(){if("_lazyCache"in t){delete t._lazyCache}},9)}if(t.loading=="lazy"){M--}},true)});var R=function(e){if(e._lazyRace){return}var t;var a=n.test(e.nodeName);var i=a&&(e[$](H.sizesAttr)||e[$]("sizes"));var r=i=="auto";if((r||!m)&&a&&(e[$]("src")||e.srcset)&&!e.complete&&!J(e,H.errorClass)&&J(e,H.lazyClass)){return}t=X(e,"lazyunveilread").detail;if(r){re.updateElem(e,true,e.offsetWidth)}e._lazyRace=true;M++;s(e,t,r,i,a)};var r=ie(function(){H.loadMode=3;a()});var o=function(){if(H.loadMode==3){H.loadMode=2}r()};var l=function(){if(m){return}if(f.now()-e<999){I(l,999);return}m=true;H.loadMode=3;a();q("scroll",o,true)};return{_:function(){e=f.now();k.elements=D.getElementsByClassName(H.lazyClass);v=D.getElementsByClassName(H.lazyClass+" "+H.preloadClass);q("scroll",a,true);q("resize",a,true);q("pageshow",function(e){if(e.persisted){var t=D.querySelectorAll("."+H.loadingClass);if(t.length&&t.forEach){U(function(){t.forEach(function(e){if(e.complete){R(e)}})})}}});if(u.MutationObserver){new MutationObserver(a).observe(O,{childList:true,subtree:true,attributes:true})}else{O[P]("DOMNodeInserted",a,true);O[P]("DOMAttrModified",a,true);setInterval(a,999)}q("hashchange",a,true);["focus","mouseover","click","load","transitionend","animationend"].forEach(function(e){D[P](e,a,true)});if(/d$|^c/.test(D.readyState)){l()}else{q("load",l);D[P]("DOMContentLoaded",a);I(l,2e4)}if(k.elements.length){t();ee._lsFlush()}else{a()}},checkElems:a,unveil:R,_aLSL:o}}(),re=function(){var a;var n=te(function(e,t,a,i){var r,n,s;e._lazysizesWidth=i;i+="px";e.setAttribute("sizes",i);if(j.test(t.nodeName||"")){r=t.getElementsByTagName("source");for(n=0,s=r.length;n<s;n++){r[n].setAttribute("sizes",i)}}if(!a.detail.dataAttr){Y(e,a.detail)}});var i=function(e,t,a){var i;var r=e.parentNode;if(r){a=s(e,r,a);i=X(e,"lazybeforesizes",{width:a,dataAttr:!!t});if(!i.defaultPrevented){a=i.detail.width;if(a&&a!==e._lazysizesWidth){n(e,r,i,a)}}}};var e=function(){var e;var t=a.length;if(t){e=0;for(;e<t;e++){i(a[e])}}};var t=ie(e);return{_:function(){a=D.getElementsByClassName(H.autosizesClass);q("resize",t)},checkElems:t,updateElem:i}}(),t=function(){if(!t.i&&D.getElementsByClassName){t.i=true;re._();e._()}};return I(function(){H.init&&t()}),k={cfg:H,autoSizer:re,loader:e,init:t,uP:Y,aC:K,rC:Q,hC:J,fire:X,gW:s,rAF:ee}}(e,e.document,Date);e.lazySizes=t,"object"==typeof module&&module.exports&&(module.exports=t)}("undefined"!=typeof window?window:{});
/*! lazysizes - v5.1.1 */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";function d(){this.ratioElems=b.getElementsByClassName("lazyaspectratio"),this._setupEvents(),this.processImages()}if(a.addEventListener){var e,f,g,h=Array.prototype.forEach,i=/^picture$/i,j="data-aspectratio",k="img["+j+"]",l=function(b){return a.matchMedia?(l=function(a){return!a||(matchMedia(a)||{}).matches})(b):a.Modernizr&&Modernizr.mq?!b||Modernizr.mq(b):!b},m=c.aC,n=c.rC,o=c.cfg;d.prototype={_setupEvents:function(){var a=this,c=function(b){b.naturalWidth<36?a.addAspectRatio(b,!0):a.removeAspectRatio(b,!0)},d=function(){a.processImages()};b.addEventListener("load",function(a){a.target.getAttribute&&a.target.getAttribute(j)&&c(a.target)},!0),addEventListener("resize",function(){var b,d=function(){h.call(a.ratioElems,c)};return function(){clearTimeout(b),b=setTimeout(d,99)}}()),b.addEventListener("DOMContentLoaded",d),addEventListener("load",d)},processImages:function(a){var c,d;a||(a=b),c="length"in a&&!a.nodeName?a:a.querySelectorAll(k);for(d=0;d<c.length;d++)c[d].naturalWidth>36?this.removeAspectRatio(c[d]):this.addAspectRatio(c[d])},getSelectedRatio:function(a){var b,c,d,e,f,g=a.parentNode;if(g&&i.test(g.nodeName||""))for(d=g.getElementsByTagName("source"),b=0,c=d.length;b<c;b++)if(e=d[b].getAttribute("data-media")||d[b].getAttribute("media"),o.customMedia[e]&&(e=o.customMedia[e]),l(e)){f=d[b].getAttribute(j);break}return f||a.getAttribute(j)||""},parseRatio:function(){var a=/^\s*([+\d\.]+)(\s*[\/x]\s*([+\d\.]+))?\s*$/,b={};return function(c){var d;return!b[c]&&(d=c.match(a))&&(d[3]?b[c]=d[1]/d[3]:b[c]=1*d[1]),b[c]}}(),addAspectRatio:function(b,c){var d,e=b.offsetWidth,f=b.offsetHeight;if(c||m(b,"lazyaspectratio"),e<36&&f<=0)return void((e||f&&a.console)&&console.log("Define width or height of image, so we can calculate the other dimension"));d=this.getSelectedRatio(b),(d=this.parseRatio(d))&&(e?b.style.height=e/d+"px":b.style.width=f*d+"px")},removeAspectRatio:function(a){n(a,"lazyaspectratio"),a.style.height="",a.style.width="",a.removeAttribute(j)}},f=function(){g=a.jQuery||a.Zepto||a.shoestring||a.$,g&&g.fn&&!g.fn.imageRatio&&g.fn.filter&&g.fn.add&&g.fn.find?g.fn.imageRatio=function(){return e.processImages(this.find(k).add(this.filter(k))),this}:g=!1},f(),setTimeout(f),e=new d,a.imageRatio=e,"object"==typeof module&&module.exports?module.exports=e:"function"==typeof define&&define.amd&&define(e)}});
/*! lazysizes - v5.1.1 */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";if(a.addEventListener){var d=c.cfg,e=/\s+/g,f=/\s*\|\s+|\s+\|\s*/g,g=/^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/,h=/^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/,i=/\(|\)|'/,j={contain:1,cover:1},k=function(a){var b=c.gW(a,a.parentNode);return(!a._lazysizesWidth||b>a._lazysizesWidth)&&(a._lazysizesWidth=b),a._lazysizesWidth},l=function(a){var b;return b=(getComputedStyle(a)||{getPropertyValue:function(){}}).getPropertyValue("background-size"),!j[b]&&j[a.style.backgroundSize]&&(b=a.style.backgroundSize),b},m=function(a,b){if(b){var c=b.match(h);c&&c[1]?a.setAttribute("type",c[1]):a.setAttribute("media",d.customMedia[b]||b)}},n=function(a,c,h){var i=b.createElement("picture"),j=c.getAttribute(d.sizesAttr),k=c.getAttribute("data-ratio"),l=c.getAttribute("data-optimumx");c._lazybgset&&c._lazybgset.parentNode==c&&c.removeChild(c._lazybgset),Object.defineProperty(h,"_lazybgset",{value:c,writable:!0}),Object.defineProperty(c,"_lazybgset",{value:i,writable:!0}),a=a.replace(e," ").split(f),i.style.display="none",h.className=d.lazyClass,1!=a.length||j||(j="auto"),a.forEach(function(a){var c,e=b.createElement("source");j&&"auto"!=j&&e.setAttribute("sizes",j),(c=a.match(g))?(e.setAttribute(d.srcsetAttr,c[1]),m(e,c[2]),m(e,c[3])):e.setAttribute(d.srcsetAttr,a),i.appendChild(e)}),j&&(h.setAttribute(d.sizesAttr,j),c.removeAttribute(d.sizesAttr),c.removeAttribute("sizes")),l&&h.setAttribute("data-optimumx",l),k&&h.setAttribute("data-ratio",k),i.appendChild(h),c.appendChild(i)},o=function(a){if(a.target._lazybgset){var b=a.target,d=b._lazybgset,e=b.currentSrc||b.src;if(e){var f=c.fire(d,"bgsetproxy",{src:e,useSrc:i.test(e)?JSON.stringify(e):e});f.defaultPrevented||(d.style.backgroundImage="url("+f.detail.useSrc+")")}b._lazybgsetLoading&&(c.fire(d,"_lazyloaded",{},!1,!0),delete b._lazybgsetLoading)}};addEventListener("lazybeforeunveil",function(a){var d,e,f;!a.defaultPrevented&&(d=a.target.getAttribute("data-bgset"))&&(f=a.target,e=b.createElement("img"),e.alt="",e._lazybgsetLoading=!0,a.detail.firesLoad=!0,n(d,f,e),setTimeout(function(){c.loader.unveil(e),c.rAF(function(){c.fire(e,"_lazyloaded",{},!0,!0),e.complete&&o({target:e})})}))}),b.addEventListener("load",o,!0),a.addEventListener("lazybeforesizes",function(a){if(a.detail.instance==c&&a.target._lazybgset&&a.detail.dataAttr){var b=a.target._lazybgset,d=l(b);j[d]&&(a.target._lazysizesParentFit=d,c.rAF(function(){a.target.setAttribute("data-parent-fit",d),a.target._lazysizesParentFit&&delete a.target._lazysizesParentFit}))}},!0),b.documentElement.addEventListener("lazybeforesizes",function(a){!a.defaultPrevented&&a.target._lazybgset&&a.detail.instance==c&&(a.detail.width=k(a.target._lazybgset))})}});
!function(e,o){if("function"==typeof define&&define.amd)define(["exports"],o);else if("undefined"!=typeof exports)o(exports);else{var t={};o(t),e.bodyScrollLock=t}}(this,function(exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=!1;if("undefined"!=typeof window){var e={get passive(){t=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function d(o){return s.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(o))})}function l(e){var o=e||window.event;return!!d(o.target)||(1<o.touches.length||(o.preventDefault&&o.preventDefault(),!1))}function n(){void 0!==m&&(document.body.style.paddingRight=m,m=void 0),void 0!==v&&(document.body.style.overflow=v,v=void 0)}function i(){if(void 0!==f){var e=-parseInt(document.body.style.top,10),o=-parseInt(document.body.style.left,10);document.body.style.position=f.position,document.body.style.top=f.top,document.body.style.left=f.left,window.scrollTo(o,e),f=void 0}}var c="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),s=[],u=!1,a=-1,v=void 0,f=void 0,m=void 0;exports.disableBodyScroll=function(r,e){if(r){if(!s.some(function(e){return e.targetElement===r})){var o={targetElement:r,options:e||{}};s=[].concat(function(e){if(Array.isArray(e)){for(var o=0,t=Array(e.length);o<e.length;o++)t[o]=e[o];return t}return Array.from(e)}(s),[o]),c?window.requestAnimationFrame(function(){if(void 0===f){f={position:document.body.style.position,top:document.body.style.top,left:document.body.style.left};var e=window,o=e.scrollY,t=e.scrollX,n=e.innerHeight;document.body.style.position="fixed",document.body.style.top=-o+"px",document.body.style.left=-t+"px",setTimeout(function(){return window.requestAnimationFrame(function(){var e=n-window.innerHeight;e&&n<=o&&(document.body.style.top=-(o+e))})},300)}}):function(e){if(void 0===m){var o=!!e&&!0===e.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;if(o&&0<t){var n=parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"),10);m=document.body.style.paddingRight,document.body.style.paddingRight=n+t+"px"}}void 0===v&&(v=document.body.style.overflow,document.body.style.overflow="hidden")}(e),c&&(r.ontouchstart=function(e){1===e.targetTouches.length&&(a=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var o,t,n,i;1===e.targetTouches.length&&(t=r,i=(o=e).targetTouches[0].clientY-a,d(o.target)||(t&&0===t.scrollTop&&0<i||(n=t)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?l(o):o.stopPropagation()))},u||(document.addEventListener("touchmove",l,t?{passive:!1}:void 0),u=!0))}}else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")},exports.clearAllBodyScrollLocks=function(){c&&(s.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),u&&(document.removeEventListener("touchmove",l,t?{passive:!1}:void 0),u=!1),a=-1),(c?i:n)(),s=[]},exports.enableBodyScroll=function(o){o?(s=s.filter(function(e){return e.targetElement!==o}),c&&(o.ontouchstart=null,o.ontouchmove=null,u&&0===s.length&&(document.removeEventListener("touchmove",l,t?{passive:!1}:void 0),u=!1)),(c?i:n)()):console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.")}});

var List;List=function(){var t={"./src/add-async.js":function(t){t.exports=function(t){return function e(r,n,s){var i=r.splice(0,50);s=(s=s||[]).concat(t.add(i)),r.length>0?setTimeout((function(){e(r,n,s)}),1):(t.update(),n(s))}}},"./src/filter.js":function(t){t.exports=function(t){return t.handlers.filterStart=t.handlers.filterStart||[],t.handlers.filterComplete=t.handlers.filterComplete||[],function(e){if(t.trigger("filterStart"),t.i=1,t.reset.filter(),void 0===e)t.filtered=!1;else{t.filtered=!0;for(var r=t.items,n=0,s=r.length;n<s;n++){var i=r[n];e(i)?i.filtered=!0:i.filtered=!1}}return t.update(),t.trigger("filterComplete"),t.visibleItems}}},"./src/fuzzy-search.js":function(t,e,r){r("./src/utils/classes.js");var n=r("./src/utils/events.js"),s=r("./src/utils/extend.js"),i=r("./src/utils/to-string.js"),a=r("./src/utils/get-by-class.js"),o=r("./src/utils/fuzzy.js");t.exports=function(t,e){e=s({location:0,distance:100,threshold:.4,multiSearch:!0,searchClass:"fuzzy-search"},e=e||{});var r={search:function(n,s){for(var i=e.multiSearch?n.replace(/ +$/,"").split(/ +/):[n],a=0,o=t.items.length;a<o;a++)r.item(t.items[a],s,i)},item:function(t,e,n){for(var s=!0,i=0;i<n.length;i++){for(var a=!1,o=0,l=e.length;o<l;o++)r.values(t.values(),e[o],n[i])&&(a=!0);a||(s=!1)}t.found=s},values:function(t,r,n){if(t.hasOwnProperty(r)){var s=i(t[r]).toLowerCase();if(o(s,n,e))return!0}return!1}};return n.bind(a(t.listContainer,e.searchClass),"keyup",t.utils.events.debounce((function(e){var n=e.target||e.srcElement;t.search(n.value,r.search)}),t.searchDelay)),function(e,n){t.search(e,n,r.search)}}},"./src/index.js":function(t,e,r){var n=r("./node_modules/string-natural-compare/natural-compare.js"),s=r("./src/utils/get-by-class.js"),i=r("./src/utils/extend.js"),a=r("./src/utils/index-of.js"),o=r("./src/utils/events.js"),l=r("./src/utils/to-string.js"),u=r("./src/utils/classes.js"),c=r("./src/utils/get-attribute.js"),f=r("./src/utils/to-array.js");t.exports=function(t,e,h){var d,v=this,g=r("./src/item.js")(v),m=r("./src/add-async.js")(v),p=r("./src/pagination.js")(v);d={start:function(){v.listClass="list",v.searchClass="search",v.sortClass="sort",v.page=1e4,v.i=1,v.items=[],v.visibleItems=[],v.matchingItems=[],v.searched=!1,v.filtered=!1,v.searchColumns=void 0,v.searchDelay=0,v.handlers={updated:[]},v.valueNames=[],v.utils={getByClass:s,extend:i,indexOf:a,events:o,toString:l,naturalSort:n,classes:u,getAttribute:c,toArray:f},v.utils.extend(v,e),v.listContainer="string"==typeof t?document.getElementById(t):t,v.listContainer&&(v.list=s(v.listContainer,v.listClass,!0),v.parse=r("./src/parse.js")(v),v.templater=r("./src/templater.js")(v),v.search=r("./src/search.js")(v),v.filter=r("./src/filter.js")(v),v.sort=r("./src/sort.js")(v),v.fuzzySearch=r("./src/fuzzy-search.js")(v,e.fuzzySearch),this.handlers(),this.items(),this.pagination(),v.update())},handlers:function(){for(var t in v.handlers)v[t]&&v.handlers.hasOwnProperty(t)&&v.on(t,v[t])},items:function(){v.parse(v.list),void 0!==h&&v.add(h)},pagination:function(){if(void 0!==e.pagination){!0===e.pagination&&(e.pagination=[{}]),void 0===e.pagination[0]&&(e.pagination=[e.pagination]);for(var t=0,r=e.pagination.length;t<r;t++)p(e.pagination[t])}}},this.reIndex=function(){v.items=[],v.visibleItems=[],v.matchingItems=[],v.searched=!1,v.filtered=!1,v.parse(v.list)},this.toJSON=function(){for(var t=[],e=0,r=v.items.length;e<r;e++)t.push(v.items[e].values());return t},this.add=function(t,e){if(0!==t.length){if(!e){var r=[],n=!1;void 0===t[0]&&(t=[t]);for(var s=0,i=t.length;s<i;s++){var a;n=v.items.length>v.page,a=new g(t[s],void 0,n),v.items.push(a),r.push(a)}return v.update(),r}m(t.slice(0),e)}},this.show=function(t,e){return this.i=t,this.page=e,v.update(),v},this.remove=function(t,e,r){for(var n=0,s=0,i=v.items.length;s<i;s++)v.items[s].values()[t]==e&&(v.templater.remove(v.items[s],r),v.items.splice(s,1),i--,s--,n++);return v.update(),n},this.get=function(t,e){for(var r=[],n=0,s=v.items.length;n<s;n++){var i=v.items[n];i.values()[t]==e&&r.push(i)}return r},this.size=function(){return v.items.length},this.clear=function(){return v.templater.clear(),v.items=[],v},this.on=function(t,e){return v.handlers[t].push(e),v},this.off=function(t,e){var r=v.handlers[t],n=a(r,e);return n>-1&&r.splice(n,1),v},this.trigger=function(t){for(var e=v.handlers[t].length;e--;)v.handlers[t][e](v);return v},this.reset={filter:function(){for(var t=v.items,e=t.length;e--;)t[e].filtered=!1;return v},search:function(){for(var t=v.items,e=t.length;e--;)t[e].found=!1;return v}},this.update=function(){var t=v.items,e=t.length;v.visibleItems=[],v.matchingItems=[],v.templater.clear();for(var r=0;r<e;r++)t[r].matching()&&v.matchingItems.length+1>=v.i&&v.visibleItems.length<v.page?(t[r].show(),v.visibleItems.push(t[r]),v.matchingItems.push(t[r])):t[r].matching()?(v.matchingItems.push(t[r]),t[r].hide()):t[r].hide();return v.trigger("updated"),v},d.start()}},"./src/item.js":function(t){t.exports=function(t){return function(e,r,n){var s=this;this._values={},this.found=!1,this.filtered=!1;this.values=function(e,r){if(void 0===e)return s._values;for(var n in e)s._values[n]=e[n];!0!==r&&t.templater.set(s,s.values())},this.show=function(){t.templater.show(s)},this.hide=function(){t.templater.hide(s)},this.matching=function(){return t.filtered&&t.searched&&s.found&&s.filtered||t.filtered&&!t.searched&&s.filtered||!t.filtered&&t.searched&&s.found||!t.filtered&&!t.searched},this.visible=function(){return!(!s.elm||s.elm.parentNode!=t.list)},function(e,r,n){if(void 0===r)n?s.values(e,n):s.values(e);else{s.elm=r;var i=t.templater.get(s,e);s.values(i)}}(e,r,n)}}},"./src/pagination.js":function(t,e,r){var n=r("./src/utils/classes.js"),s=r("./src/utils/events.js"),i=r("./src/index.js");t.exports=function(t){var e=!1,r=function(r,s){if(t.page<1)return t.listContainer.style.display="none",void(e=!0);e&&(t.listContainer.style.display="block");var i,o=t.matchingItems.length,l=t.i,u=t.page,c=Math.ceil(o/u),f=Math.ceil(l/u),h=s.innerWindow||2,d=s.left||s.outerWindow||0,v=s.right||s.outerWindow||0;v=c-v,r.clear();for(var g=1;g<=c;g++){var m=f===g?"active":"";a.number(g,d,v,f,h)?(i=r.add({page:g,dotted:!1})[0],m&&n(i.elm).add(m),i.elm.firstChild.setAttribute("data-i",g),i.elm.firstChild.setAttribute("data-page",u)):a.dotted(r,g,d,v,f,h,r.size())&&(i=r.add({page:"...",dotted:!0})[0],n(i.elm).add("disabled"))}},a={number:function(t,e,r,n,s){return this.left(t,e)||this.right(t,r)||this.innerWindow(t,n,s)},left:function(t,e){return t<=e},right:function(t,e){return t>e},innerWindow:function(t,e,r){return t>=e-r&&t<=e+r},dotted:function(t,e,r,n,s,i,a){return this.dottedLeft(t,e,r,n,s,i)||this.dottedRight(t,e,r,n,s,i,a)},dottedLeft:function(t,e,r,n,s,i){return e==r+1&&!this.innerWindow(e,s,i)&&!this.right(e,n)},dottedRight:function(t,e,r,n,s,i,a){return!t.items[a-1].values().dotted&&(e==n&&!this.innerWindow(e,s,i)&&!this.right(e,n))}};return function(e){var n=new i(t.listContainer.id,{listClass:e.paginationClass||"pagination",item:e.item||"<li><a class='page' href='#'></a></li>",valueNames:["page","dotted"],searchClass:"pagination-search-that-is-not-supposed-to-exist",sortClass:"pagination-sort-that-is-not-supposed-to-exist"});s.bind(n.listContainer,"click",(function(e){var r=e.target||e.srcElement,n=t.utils.getAttribute(r,"data-page"),s=t.utils.getAttribute(r,"data-i");s&&t.show((s-1)*n+1,n)})),t.on("updated",(function(){r(n,e)})),r(n,e)}}},"./src/parse.js":function(t,e,r){t.exports=function(t){var e=r("./src/item.js")(t),n=function(r,n){for(var s=0,i=r.length;s<i;s++)t.items.push(new e(n,r[s]))},s=function e(r,s){var i=r.splice(0,50);n(i,s),r.length>0?setTimeout((function(){e(r,s)}),1):(t.update(),t.trigger("parseComplete"))};return t.handlers.parseComplete=t.handlers.parseComplete||[],function(){var e=function(t){for(var e=t.childNodes,r=[],n=0,s=e.length;n<s;n++)void 0===e[n].data&&r.push(e[n]);return r}(t.list),r=t.valueNames;t.indexAsync?s(e,r):n(e,r)}}},"./src/search.js":function(t){t.exports=function(t){var e,r,n,s={resetList:function(){t.i=1,t.templater.clear(),n=void 0},setOptions:function(t){2==t.length&&t[1]instanceof Array?e=t[1]:2==t.length&&"function"==typeof t[1]?(e=void 0,n=t[1]):3==t.length?(e=t[1],n=t[2]):e=void 0},setColumns:function(){0!==t.items.length&&void 0===e&&(e=void 0===t.searchColumns?s.toArray(t.items[0].values()):t.searchColumns)},setSearchString:function(e){e=(e=t.utils.toString(e).toLowerCase()).replace(/[-[\]{}()*+?.,\\^$|#]/g,"\\$&"),r=e},toArray:function(t){var e=[];for(var r in t)e.push(r);return e}},i=function(){for(var n,s=[],i=r;null!==(n=i.match(/"([^"]+)"/));)s.push(n[1]),i=i.substring(0,n.index)+i.substring(n.index+n[0].length);(i=i.trim()).length&&(s=s.concat(i.split(/\s+/)));for(var a=0,o=t.items.length;a<o;a++){var l=t.items[a];if(l.found=!1,s.length){for(var u=0,c=s.length;u<c;u++){for(var f=!1,h=0,d=e.length;h<d;h++){var v=l.values(),g=e[h];if(v.hasOwnProperty(g)&&void 0!==v[g]&&null!==v[g])if(-1!==("string"!=typeof v[g]?v[g].toString():v[g]).toLowerCase().indexOf(s[u])){f=!0;break}}if(!f)break}l.found=f}}},a=function(){t.reset.search(),t.searched=!1},o=function(o){return t.trigger("searchStart"),s.resetList(),s.setSearchString(o),s.setOptions(arguments),s.setColumns(),""===r?a():(t.searched=!0,n?n(r,e):i()),t.update(),t.trigger("searchComplete"),t.visibleItems};return t.handlers.searchStart=t.handlers.searchStart||[],t.handlers.searchComplete=t.handlers.searchComplete||[],t.utils.events.bind(t.utils.getByClass(t.listContainer,t.searchClass),"keyup",t.utils.events.debounce((function(e){var r=e.target||e.srcElement;""===r.value&&!t.searched||o(r.value)}),t.searchDelay)),t.utils.events.bind(t.utils.getByClass(t.listContainer,t.searchClass),"input",(function(t){""===(t.target||t.srcElement).value&&o("")})),o}},"./src/sort.js":function(t){t.exports=function(t){var e={els:void 0,clear:function(){for(var r=0,n=e.els.length;r<n;r++)t.utils.classes(e.els[r]).remove("asc"),t.utils.classes(e.els[r]).remove("desc")},getOrder:function(e){var r=t.utils.getAttribute(e,"data-order");return"asc"==r||"desc"==r?r:t.utils.classes(e).has("desc")?"asc":t.utils.classes(e).has("asc")?"desc":"asc"},getInSensitive:function(e,r){var n=t.utils.getAttribute(e,"data-insensitive");r.insensitive="false"!==n},setOrder:function(r){for(var n=0,s=e.els.length;n<s;n++){var i=e.els[n];if(t.utils.getAttribute(i,"data-sort")===r.valueName){var a=t.utils.getAttribute(i,"data-order");"asc"==a||"desc"==a?a==r.order&&t.utils.classes(i).add(r.order):t.utils.classes(i).add(r.order)}}}},r=function(){t.trigger("sortStart");var r={},n=arguments[0].currentTarget||arguments[0].srcElement||void 0;n?(r.valueName=t.utils.getAttribute(n,"data-sort"),e.getInSensitive(n,r),r.order=e.getOrder(n)):((r=arguments[1]||r).valueName=arguments[0],r.order=r.order||"asc",r.insensitive=void 0===r.insensitive||r.insensitive),e.clear(),e.setOrder(r);var s,i=r.sortFunction||t.sortFunction||null,a="desc"===r.order?-1:1;s=i?function(t,e){return i(t,e,r)*a}:function(e,n){var s=t.utils.naturalSort;return s.alphabet=t.alphabet||r.alphabet||void 0,!s.alphabet&&r.insensitive&&(s=t.utils.naturalSort.caseInsensitive),s(e.values()[r.valueName],n.values()[r.valueName])*a},t.items.sort(s),t.update(),t.trigger("sortComplete")};return t.handlers.sortStart=t.handlers.sortStart||[],t.handlers.sortComplete=t.handlers.sortComplete||[],e.els=t.utils.getByClass(t.listContainer,t.sortClass),t.utils.events.bind(e.els,"click",r),t.on("searchStart",e.clear),t.on("filterStart",e.clear),r}},"./src/templater.js":function(t){var e=function(t){var e,r=this,n=function(e,r){var n=e.cloneNode(!0);n.removeAttribute("id");for(var s=0,i=r.length;s<i;s++){var a=void 0,o=r[s];if(o.data)for(var l=0,u=o.data.length;l<u;l++)n.setAttribute("data-"+o.data[l],"");else o.attr&&o.name?(a=t.utils.getByClass(n,o.name,!0))&&a.setAttribute(o.attr,""):(a=t.utils.getByClass(n,o,!0))&&(a.innerHTML="")}return n},s=function(){for(var e=t.list.childNodes,r=0,n=e.length;r<n;r++)if(void 0===e[r].data)return e[r].cloneNode(!0)},i=function(t){if("string"==typeof t){if(/<tr[\s>]/g.exec(t)){var e=document.createElement("tbody");return e.innerHTML=t,e.firstElementChild}if(-1!==t.indexOf("<")){var r=document.createElement("div");return r.innerHTML=t,r.firstElementChild}}},a=function(e,r,n){var s=void 0,i=function(e){for(var r=0,n=t.valueNames.length;r<n;r++){var s=t.valueNames[r];if(s.data){for(var i=s.data,a=0,o=i.length;a<o;a++)if(i[a]===e)return{data:e}}else{if(s.attr&&s.name&&s.name==e)return s;if(s===e)return e}}}(r);i&&(i.data?e.elm.setAttribute("data-"+i.data,n):i.attr&&i.name?(s=t.utils.getByClass(e.elm,i.name,!0))&&s.setAttribute(i.attr,n):(s=t.utils.getByClass(e.elm,i,!0))&&(s.innerHTML=n))};this.get=function(e,n){r.create(e);for(var s={},i=0,a=n.length;i<a;i++){var o=void 0,l=n[i];if(l.data)for(var u=0,c=l.data.length;u<c;u++)s[l.data[u]]=t.utils.getAttribute(e.elm,"data-"+l.data[u]);else l.attr&&l.name?(o=t.utils.getByClass(e.elm,l.name,!0),s[l.name]=o?t.utils.getAttribute(o,l.attr):""):(o=t.utils.getByClass(e.elm,l,!0),s[l]=o?o.innerHTML:"")}return s},this.set=function(t,e){if(!r.create(t))for(var n in e)e.hasOwnProperty(n)&&a(t,n,e[n])},this.create=function(t){return void 0===t.elm&&(t.elm=e(t.values()),r.set(t,t.values()),!0)},this.remove=function(e){e.elm.parentNode===t.list&&t.list.removeChild(e.elm)},this.show=function(e){r.create(e),t.list.appendChild(e.elm)},this.hide=function(e){void 0!==e.elm&&e.elm.parentNode===t.list&&t.list.removeChild(e.elm)},this.clear=function(){if(t.list.hasChildNodes())for(;t.list.childNodes.length>=1;)t.list.removeChild(t.list.firstChild)},function(){var r;if("function"!=typeof t.item){if(!(r="string"==typeof t.item?-1===t.item.indexOf("<")?document.getElementById(t.item):i(t.item):s()))throw new Error("The list needs to have at least one item on init otherwise you'll have to add a template.");r=n(r,t.valueNames),e=function(){return r.cloneNode(!0)}}else e=function(e){var r=t.item(e);return i(r)}}()};t.exports=function(t){return new e(t)}},"./src/utils/classes.js":function(t,e,r){var n=r("./src/utils/index-of.js"),s=/\s+/;Object.prototype.toString;function i(t){if(!t||!t.nodeType)throw new Error("A DOM element reference is required");this.el=t,this.list=t.classList}t.exports=function(t){return new i(t)},i.prototype.add=function(t){if(this.list)return this.list.add(t),this;var e=this.array();return~n(e,t)||e.push(t),this.el.className=e.join(" "),this},i.prototype.remove=function(t){if(this.list)return this.list.remove(t),this;var e=this.array(),r=n(e,t);return~r&&e.splice(r,1),this.el.className=e.join(" "),this},i.prototype.toggle=function(t,e){return this.list?(void 0!==e?e!==this.list.toggle(t,e)&&this.list.toggle(t):this.list.toggle(t),this):(void 0!==e?e?this.add(t):this.remove(t):this.has(t)?this.remove(t):this.add(t),this)},i.prototype.array=function(){var t=(this.el.getAttribute("class")||"").replace(/^\s+|\s+$/g,"").split(s);return""===t[0]&&t.shift(),t},i.prototype.has=i.prototype.contains=function(t){return this.list?this.list.contains(t):!!~n(this.array(),t)}},"./src/utils/events.js":function(t,e,r){var n=window.addEventListener?"addEventListener":"attachEvent",s=window.removeEventListener?"removeEventListener":"detachEvent",i="addEventListener"!==n?"on":"",a=r("./src/utils/to-array.js");e.bind=function(t,e,r,s){for(var o=0,l=(t=a(t)).length;o<l;o++)t[o][n](i+e,r,s||!1)},e.unbind=function(t,e,r,n){for(var o=0,l=(t=a(t)).length;o<l;o++)t[o][s](i+e,r,n||!1)},e.debounce=function(t,e,r){var n;return e?function(){var s=this,i=arguments,a=function(){n=null,r||t.apply(s,i)},o=r&&!n;clearTimeout(n),n=setTimeout(a,e),o&&t.apply(s,i)}:t}},"./src/utils/extend.js":function(t){t.exports=function(t){for(var e,r=Array.prototype.slice.call(arguments,1),n=0;e=r[n];n++)if(e)for(var s in e)t[s]=e[s];return t}},"./src/utils/fuzzy.js":function(t){t.exports=function(t,e,r){var n=r.location||0,s=r.distance||100,i=r.threshold||.4;if(e===t)return!0;if(e.length>32)return!1;var a=n,o=function(){var t,r={};for(t=0;t<e.length;t++)r[e.charAt(t)]=0;for(t=0;t<e.length;t++)r[e.charAt(t)]|=1<<e.length-t-1;return r}();function l(t,r){var n=t/e.length,i=Math.abs(a-r);return s?n+i/s:i?1:n}var u=i,c=t.indexOf(e,a);-1!=c&&(u=Math.min(l(0,c),u),-1!=(c=t.lastIndexOf(e,a+e.length))&&(u=Math.min(l(0,c),u)));var f,h,d=1<<e.length-1;c=-1;for(var v,g=e.length+t.length,m=0;m<e.length;m++){for(f=0,h=g;f<h;)l(m,a+h)<=u?f=h:g=h,h=Math.floor((g-f)/2+f);g=h;var p=Math.max(1,a-h+1),y=Math.min(a+h,t.length)+e.length,C=Array(y+2);C[y+1]=(1<<m)-1;for(var b=y;b>=p;b--){var j=o[t.charAt(b-1)];if(C[b]=0===m?(C[b+1]<<1|1)&j:(C[b+1]<<1|1)&j|(v[b+1]|v[b])<<1|1|v[b+1],C[b]&d){var x=l(m,b-1);if(x<=u){if(u=x,!((c=b-1)>a))break;p=Math.max(1,2*a-c)}}}if(l(m+1,a)>u)break;v=C}return!(c<0)}},"./src/utils/get-attribute.js":function(t){t.exports=function(t,e){var r=t.getAttribute&&t.getAttribute(e)||null;if(!r)for(var n=t.attributes,s=n.length,i=0;i<s;i++)void 0!==n[i]&&n[i].nodeName===e&&(r=n[i].nodeValue);return r}},"./src/utils/get-by-class.js":function(t){t.exports=function(t,e,r,n){return(n=n||{}).test&&n.getElementsByClassName||!n.test&&document.getElementsByClassName?function(t,e,r){return r?t.getElementsByClassName(e)[0]:t.getElementsByClassName(e)}(t,e,r):n.test&&n.querySelector||!n.test&&document.querySelector?function(t,e,r){return e="."+e,r?t.querySelector(e):t.querySelectorAll(e)}(t,e,r):function(t,e,r){for(var n=[],s=t.getElementsByTagName("*"),i=s.length,a=new RegExp("(^|\\s)"+e+"(\\s|$)"),o=0,l=0;o<i;o++)if(a.test(s[o].className)){if(r)return s[o];n[l]=s[o],l++}return n}(t,e,r)}},"./src/utils/index-of.js":function(t){var e=[].indexOf;t.exports=function(t,r){if(e)return t.indexOf(r);for(var n=0,s=t.length;n<s;++n)if(t[n]===r)return n;return-1}},"./src/utils/to-array.js":function(t){t.exports=function(t){if(void 0===t)return[];if(null===t)return[null];if(t===window)return[window];if("string"==typeof t)return[t];if(function(t){return"[object Array]"===Object.prototype.toString.call(t)}(t))return t;if("number"!=typeof t.length)return[t];if("function"==typeof t&&t instanceof Function)return[t];for(var e=[],r=0,n=t.length;r<n;r++)(Object.prototype.hasOwnProperty.call(t,r)||r in t)&&e.push(t[r]);return e.length?e:[]}},"./src/utils/to-string.js":function(t){t.exports=function(t){return t=(t=null===(t=void 0===t?"":t)?"":t).toString()}},"./node_modules/string-natural-compare/natural-compare.js":function(t){"use strict";var e,r,n=0;function s(t){return t>=48&&t<=57}function i(t,e){for(var i=(t+="").length,a=(e+="").length,o=0,l=0;o<i&&l<a;){var u=t.charCodeAt(o),c=e.charCodeAt(l);if(s(u)){if(!s(c))return u-c;for(var f=o,h=l;48===u&&++f<i;)u=t.charCodeAt(f);for(;48===c&&++h<a;)c=e.charCodeAt(h);for(var d=f,v=h;d<i&&s(t.charCodeAt(d));)++d;for(;v<a&&s(e.charCodeAt(v));)++v;var g=d-f-v+h;if(g)return g;for(;f<d;)if(g=t.charCodeAt(f++)-e.charCodeAt(h++))return g;o=d,l=v}else{if(u!==c)return u<n&&c<n&&-1!==r[u]&&-1!==r[c]?r[u]-r[c]:u-c;++o,++l}}return o>=i&&l<a&&i>=a?-1:l>=a&&o<i&&a>=i?1:i-a}i.caseInsensitive=i.i=function(t,e){return i((""+t).toLowerCase(),(""+e).toLowerCase())},Object.defineProperties(i,{alphabet:{get:function(){return e},set:function(t){r=[];var s=0;if(e=t)for(;s<e.length;s++)r[e.charCodeAt(s)]=s;for(n=r.length,s=0;s<n;s++)void 0===r[s]&&(r[s]=-1)}}}),t.exports=i}},e={};return function r(n){if(e[n])return e[n].exports;var s=e[n]={exports:{}};return t[n](s,s.exports,r),s.exports}("./src/index.js")}();
/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function(){"use strict";function t(n){if(!n)throw new Error("No options passed to Waypoint constructor");if(!n.element)throw new Error("No element option passed to Waypoint constructor");if(!n.handler)throw new Error("No handler option passed to Waypoint constructor");this.key="waypoint-"+e,this.options=t.Adapter.extend({},t.defaults,n),this.element=this.options.element,this.adapter=new t.Adapter(this.element),this.callback=n.handler,this.axis=this.options.horizontal?"horizontal":"vertical",this.enabled=this.options.enabled,this.triggerPoint=null,this.group=t.Group.findOrCreate({name:this.options.group,axis:this.axis}),this.context=t.Context.findOrCreateByElement(this.options.context),t.offsetAliases[this.options.offset]&&(this.options.offset=t.offsetAliases[this.options.offset]),this.group.add(this),this.context.add(this),i[this.key]=this,e+=1}var e=0,i={};t.prototype.queueTrigger=function(t){this.group.queueTrigger(this,t)},t.prototype.trigger=function(t){this.enabled&&this.callback&&this.callback.apply(this,t)},t.prototype.destroy=function(){this.context.remove(this),this.group.remove(this),delete i[this.key]},t.prototype.disable=function(){return this.enabled=!1,this},t.prototype.enable=function(){return this.context.refresh(),this.enabled=!0,this},t.prototype.next=function(){return this.group.next(this)},t.prototype.previous=function(){return this.group.previous(this)},t.invokeAll=function(t){var e=[];for(var n in i)e.push(i[n]);for(var o=0,r=e.length;r>o;o++)e[o][t]()},t.destroyAll=function(){t.invokeAll("destroy")},t.disableAll=function(){t.invokeAll("disable")},t.enableAll=function(){t.Context.refreshAll();for(var e in i)i[e].enabled=!0;return this},t.refreshAll=function(){t.Context.refreshAll()},t.viewportHeight=function(){return window.innerHeight||document.documentElement.clientHeight},t.viewportWidth=function(){return document.documentElement.clientWidth},t.adapters=[],t.defaults={context:window,continuous:!0,enabled:!0,group:"default",horizontal:!1,offset:0},t.offsetAliases={"bottom-in-view":function(){return this.context.innerHeight()-this.adapter.outerHeight()},"right-in-view":function(){return this.context.innerWidth()-this.adapter.outerWidth()}},window.Waypoint=t}(),function(){"use strict";function t(t){window.setTimeout(t,1e3/60)}function e(t){this.element=t,this.Adapter=o.Adapter,this.adapter=new this.Adapter(t),this.key="waypoint-context-"+i,this.didScroll=!1,this.didResize=!1,this.oldScroll={x:this.adapter.scrollLeft(),y:this.adapter.scrollTop()},this.waypoints={vertical:{},horizontal:{}},t.waypointContextKey=this.key,n[t.waypointContextKey]=this,i+=1,o.windowContext||(o.windowContext=!0,o.windowContext=new e(window)),this.createThrottledScrollHandler(),this.createThrottledResizeHandler()}var i=0,n={},o=window.Waypoint,r=window.onload;e.prototype.add=function(t){var e=t.options.horizontal?"horizontal":"vertical";this.waypoints[e][t.key]=t,this.refresh()},e.prototype.checkEmpty=function(){var t=this.Adapter.isEmptyObject(this.waypoints.horizontal),e=this.Adapter.isEmptyObject(this.waypoints.vertical),i=this.element==this.element.window;t&&e&&!i&&(this.adapter.off(".waypoints"),delete n[this.key])},e.prototype.createThrottledResizeHandler=function(){function t(){e.handleResize(),e.didResize=!1}var e=this;this.adapter.on("resize.waypoints",function(){e.didResize||(e.didResize=!0,o.requestAnimationFrame(t))})},e.prototype.createThrottledScrollHandler=function(){function t(){e.handleScroll(),e.didScroll=!1}var e=this;this.adapter.on("scroll.waypoints",function(){(!e.didScroll||o.isTouch)&&(e.didScroll=!0,o.requestAnimationFrame(t))})},e.prototype.handleResize=function(){o.Context.refreshAll()},e.prototype.handleScroll=function(){var t={},e={horizontal:{newScroll:this.adapter.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.adapter.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}};for(var i in e){var n=e[i],o=n.newScroll>n.oldScroll,r=o?n.forward:n.backward;for(var s in this.waypoints[i]){var l=this.waypoints[i][s];if(null!==l.triggerPoint){var a=n.oldScroll<l.triggerPoint,h=n.newScroll>=l.triggerPoint,p=a&&h,u=!a&&!h;(p||u)&&(l.queueTrigger(r),t[l.group.id]=l.group)}}}for(var d in t)t[d].flushTriggers();this.oldScroll={x:e.horizontal.newScroll,y:e.vertical.newScroll}},e.prototype.innerHeight=function(){return this.element==this.element.window?o.viewportHeight():this.adapter.innerHeight()},e.prototype.remove=function(t){delete this.waypoints[t.axis][t.key],this.checkEmpty()},e.prototype.innerWidth=function(){return this.element==this.element.window?o.viewportWidth():this.adapter.innerWidth()},e.prototype.destroy=function(){var t=[];for(var e in this.waypoints)for(var i in this.waypoints[e])t.push(this.waypoints[e][i]);for(var n=0,o=t.length;o>n;n++)t[n].destroy()},e.prototype.refresh=function(){var t,e=this.element==this.element.window,i=e?void 0:this.adapter.offset(),n={};this.handleScroll(),t={horizontal:{contextOffset:e?0:i.left,contextScroll:e?0:this.oldScroll.x,contextDimension:this.innerWidth(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:e?0:i.top,contextScroll:e?0:this.oldScroll.y,contextDimension:this.innerHeight(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}};for(var r in t){var s=t[r];for(var l in this.waypoints[r]){var a,h,p,u,d,f=this.waypoints[r][l],c=f.options.offset,w=f.triggerPoint,y=0,g=null==w;f.element!==f.element.window&&(y=f.adapter.offset()[s.offsetProp]),"function"==typeof c?c=c.apply(f):"string"==typeof c&&(c=parseFloat(c),f.options.offset.indexOf("%")>-1&&(c=Math.ceil(s.contextDimension*c/100))),a=s.contextScroll-s.contextOffset,f.triggerPoint=Math.floor(y+a-c),h=w<s.oldScroll,p=f.triggerPoint>=s.oldScroll,u=h&&p,d=!h&&!p,!g&&u?(f.queueTrigger(s.backward),n[f.group.id]=f.group):!g&&d?(f.queueTrigger(s.forward),n[f.group.id]=f.group):g&&s.oldScroll>=f.triggerPoint&&(f.queueTrigger(s.forward),n[f.group.id]=f.group)}}return o.requestAnimationFrame(function(){for(var t in n)n[t].flushTriggers()}),this},e.findOrCreateByElement=function(t){return e.findByElement(t)||new e(t)},e.refreshAll=function(){for(var t in n)n[t].refresh()},e.findByElement=function(t){return n[t.waypointContextKey]},window.onload=function(){r&&r(),e.refreshAll()},o.requestAnimationFrame=function(e){var i=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||t;i.call(window,e)},o.Context=e}(),function(){"use strict";function t(t,e){return t.triggerPoint-e.triggerPoint}function e(t,e){return e.triggerPoint-t.triggerPoint}function i(t){this.name=t.name,this.axis=t.axis,this.id=this.name+"-"+this.axis,this.waypoints=[],this.clearTriggerQueues(),n[this.axis][this.name]=this}var n={vertical:{},horizontal:{}},o=window.Waypoint;i.prototype.add=function(t){this.waypoints.push(t)},i.prototype.clearTriggerQueues=function(){this.triggerQueues={up:[],down:[],left:[],right:[]}},i.prototype.flushTriggers=function(){for(var i in this.triggerQueues){var n=this.triggerQueues[i],o="up"===i||"left"===i;n.sort(o?e:t);for(var r=0,s=n.length;s>r;r+=1){var l=n[r];(l.options.continuous||r===n.length-1)&&l.trigger([i])}}this.clearTriggerQueues()},i.prototype.next=function(e){this.waypoints.sort(t);var i=o.Adapter.inArray(e,this.waypoints),n=i===this.waypoints.length-1;return n?null:this.waypoints[i+1]},i.prototype.previous=function(e){this.waypoints.sort(t);var i=o.Adapter.inArray(e,this.waypoints);return i?this.waypoints[i-1]:null},i.prototype.queueTrigger=function(t,e){this.triggerQueues[e].push(t)},i.prototype.remove=function(t){var e=o.Adapter.inArray(t,this.waypoints);e>-1&&this.waypoints.splice(e,1)},i.prototype.first=function(){return this.waypoints[0]},i.prototype.last=function(){return this.waypoints[this.waypoints.length-1]},i.findOrCreate=function(t){return n[t.axis][t.name]||new i(t)},o.Group=i}(),function(){"use strict";function t(t){return t===t.window}function e(e){return t(e)?e:e.defaultView}function i(t){this.element=t,this.handlers={}}var n=window.Waypoint;i.prototype.innerHeight=function(){var e=t(this.element);return e?this.element.innerHeight:this.element.clientHeight},i.prototype.innerWidth=function(){var e=t(this.element);return e?this.element.innerWidth:this.element.clientWidth},i.prototype.off=function(t,e){function i(t,e,i){for(var n=0,o=e.length-1;o>n;n++){var r=e[n];i&&i!==r||t.removeEventListener(r)}}var n=t.split("."),o=n[0],r=n[1],s=this.element;if(r&&this.handlers[r]&&o)i(s,this.handlers[r][o],e),this.handlers[r][o]=[];else if(o)for(var l in this.handlers)i(s,this.handlers[l][o]||[],e),this.handlers[l][o]=[];else if(r&&this.handlers[r]){for(var a in this.handlers[r])i(s,this.handlers[r][a],e);this.handlers[r]={}}},i.prototype.offset=function(){if(!this.element.ownerDocument)return null;var t=this.element.ownerDocument.documentElement,i=e(this.element.ownerDocument),n={top:0,left:0};return this.element.getBoundingClientRect&&(n=this.element.getBoundingClientRect()),{top:n.top+i.pageYOffset-t.clientTop,left:n.left+i.pageXOffset-t.clientLeft}},i.prototype.on=function(t,e){var i=t.split("."),n=i[0],o=i[1]||"__default",r=this.handlers[o]=this.handlers[o]||{},s=r[n]=r[n]||[];s.push(e),this.element.addEventListener(n,e)},i.prototype.outerHeight=function(e){var i,n=this.innerHeight();return e&&!t(this.element)&&(i=window.getComputedStyle(this.element),n+=parseInt(i.marginTop,10),n+=parseInt(i.marginBottom,10)),n},i.prototype.outerWidth=function(e){var i,n=this.innerWidth();return e&&!t(this.element)&&(i=window.getComputedStyle(this.element),n+=parseInt(i.marginLeft,10),n+=parseInt(i.marginRight,10)),n},i.prototype.scrollLeft=function(){var t=e(this.element);return t?t.pageXOffset:this.element.scrollLeft},i.prototype.scrollTop=function(){var t=e(this.element);return t?t.pageYOffset:this.element.scrollTop},i.extend=function(){function t(t,e){if("object"==typeof t&&"object"==typeof e)for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i]);return t}for(var e=Array.prototype.slice.call(arguments),i=1,n=e.length;n>i;i++)t(e[0],e[i]);return e[0]},i.inArray=function(t,e,i){return null==e?-1:e.indexOf(t,i)},i.isEmptyObject=function(t){for(var e in t)return!1;return!0},n.adapters.push({name:"noframework",Adapter:i}),n.Adapter=i}();
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.Scrollbar=e():t.Scrollbar=e()}(this,(function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=67)}([function(t,e,n){(function(e){var n=function(t){return t&&t.Math==Math&&t};t.exports=n("object"==typeof globalThis&&globalThis)||n("object"==typeof window&&window)||n("object"==typeof self&&self)||n("object"==typeof e&&e)||Function("return this")()}).call(this,n(43))},function(t,e,n){var r=n(0),o=n(51),i=n(3),u=n(29),c=n(56),a=n(76),s=o("wks"),f=r.Symbol,l=a?f:f&&f.withoutSetter||u;t.exports=function(t){return i(s,t)||(c&&i(f,t)?s[t]=f[t]:s[t]=l("Symbol."+t)),s[t]}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var r=n(6),o=n(46),i=n(7),u=n(25),c=Object.defineProperty;e.f=r?c:function(t,e,n){if(i(t),e=u(e,!0),i(n),o)try{return c(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){var r=n(4);t.exports=!r((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]}))},function(t,e,n){var r=n(2);t.exports=function(t){if(!r(t))throw TypeError(String(t)+" is not an object");return t}},function(t,e,n){var r=n(6),o=n(5),i=n(14);t.exports=r?function(t,e,n){return o.f(t,e,i(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r,o,i,u=n(50),c=n(0),a=n(2),s=n(8),f=n(3),l=n(27),p=n(16),h=c.WeakMap;if(u){var d=new h,v=d.get,y=d.has,m=d.set;r=function(t,e){return m.call(d,t,e),e},o=function(t){return v.call(d,t)||{}},i=function(t){return y.call(d,t)}}else{var g=l("state");p[g]=!0,r=function(t,e){return s(t,g,e),e},o=function(t){return f(t,g)?t[g]:{}},i=function(t){return f(t,g)}}t.exports={set:r,get:o,has:i,enforce:function(t){return i(t)?o(t):r(t,{})},getterFor:function(t){return function(e){var n;if(!a(e)||(n=o(e)).type!==t)throw TypeError("Incompatible receiver, "+t+" required");return n}}}},function(t,e,n){var r=n(0);t.exports=r},function(t,e,n){var r=n(0),o=n(8),i=n(3),u=n(26),c=n(48),a=n(9),s=a.get,f=a.enforce,l=String(String).split("String");(t.exports=function(t,e,n,c){var a=!!c&&!!c.unsafe,s=!!c&&!!c.enumerable,p=!!c&&!!c.noTargetGet;"function"==typeof n&&("string"!=typeof e||i(n,"name")||o(n,"name",e),f(n).source=l.join("string"==typeof e?e:"")),t!==r?(a?!p&&t[e]&&(s=!0):delete t[e],s?t[e]=n:o(t,e,n)):s?t[e]=n:u(e,n)})(Function.prototype,"toString",(function(){return"function"==typeof this&&s(this).source||c(this)}))},function(t,e){t.exports={}},function(t,e,n){var r=n(0),o=n(44).f,i=n(8),u=n(11),c=n(26),a=n(70),s=n(54);t.exports=function(t,e){var n,f,l,p,h,d=t.target,v=t.global,y=t.stat;if(n=v?r:y?r[d]||c(d,{}):(r[d]||{}).prototype)for(f in e){if(p=e[f],l=t.noTargetGet?(h=o(n,f))&&h.value:n[f],!s(v?f:d+(y?".":"#")+f,t.forced)&&void 0!==l){if(typeof p==typeof l)continue;a(p,l)}(t.sham||l&&l.sham)&&i(p,"sham",!0),u(n,f,p,t)}}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var r=n(22),o=n(24);t.exports=function(t){return r(o(t))}},function(t,e){t.exports={}},function(t,e,n){var r=n(31),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,e,n){var r=n(16),o=n(2),i=n(3),u=n(5).f,c=n(29),a=n(75),s=c("meta"),f=0,l=Object.isExtensible||function(){return!0},p=function(t){u(t,s,{value:{objectID:"O"+ ++f,weakData:{}}})},h=t.exports={REQUIRED:!1,fastKey:function(t,e){if(!o(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!i(t,s)){if(!l(t))return"F";if(!e)return"E";p(t)}return t[s].objectID},getWeakData:function(t,e){if(!i(t,s)){if(!l(t))return!0;if(!e)return!1;p(t)}return t[s].weakData},onFreeze:function(t){return a&&h.REQUIRED&&l(t)&&!i(t,s)&&p(t),t}};r[s]=!0},function(t,e,n){var r=n(77);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 0:return function(){return t.call(e)};case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},function(t,e,n){var r=n(24);t.exports=function(t){return Object(r(t))}},function(t,e,n){"use strict";var r=n(13),o=n(0),i=n(54),u=n(11),c=n(18),a=n(33),s=n(35),f=n(2),l=n(4),p=n(60),h=n(36),d=n(78);t.exports=function(t,e,n){var v=-1!==t.indexOf("Map"),y=-1!==t.indexOf("Weak"),m=v?"set":"add",g=o[t],b=g&&g.prototype,x=g,w={},S=function(t){var e=b[t];u(b,t,"add"==t?function(t){return e.call(this,0===t?0:t),this}:"delete"==t?function(t){return!(y&&!f(t))&&e.call(this,0===t?0:t)}:"get"==t?function(t){return y&&!f(t)?void 0:e.call(this,0===t?0:t)}:"has"==t?function(t){return!(y&&!f(t))&&e.call(this,0===t?0:t)}:function(t,n){return e.call(this,0===t?0:t,n),this})};if(i(t,"function"!=typeof g||!(y||b.forEach&&!l((function(){(new g).entries().next()})))))x=n.getConstructor(e,t,v,m),c.REQUIRED=!0;else if(i(t,!0)){var O=new x,_=O[m](y?{}:-0,1)!=O,E=l((function(){O.has(1)})),T=p((function(t){new g(t)})),A=!y&&l((function(){for(var t=new g,e=5;e--;)t[m](e,e);return!t.has(-0)}));T||((x=e((function(e,n){s(e,x,t);var r=d(new g,e,x);return null!=n&&a(n,r[m],r,v),r}))).prototype=b,b.constructor=x),(E||A)&&(S("delete"),S("has"),v&&S("get")),(A||_)&&S(m),y&&b.clear&&delete b.clear}return w[t]=x,r({global:!0,forced:x!=g},w),h(x,t),y||n.setStrong(x,t,v),x}},function(t,e,n){var r=n(4),o=n(23),i="".split;t.exports=r((function(){return!Object("z").propertyIsEnumerable(0)}))?function(t){return"String"==o(t)?i.call(t,""):Object(t)}:Object},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){t.exports=function(t){if(null==t)throw TypeError("Can't call method on "+t);return t}},function(t,e,n){var r=n(2);t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if("function"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,e,n){var r=n(0),o=n(8);t.exports=function(t,e){try{o(r,t,e)}catch(n){r[t]=e}return e}},function(t,e,n){var r=n(51),o=n(29),i=r("keys");t.exports=function(t){return i[t]||(i[t]=o(t))}},function(t,e){t.exports=!1},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol("+String(void 0===t?"":t)+")_"+(++n+r).toString(36)}},function(t,e,n){var r=n(10),o=n(0),i=function(t){return"function"==typeof t?t:void 0};t.exports=function(t,e){return arguments.length<2?i(r[t])||i(o[t]):r[t]&&r[t][e]||o[t]&&o[t][e]}},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e){t.exports=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"]},function(t,e,n){var r=n(7),o=n(55),i=n(17),u=n(19),c=n(57),a=n(59),s=function(t,e){this.stopped=t,this.result=e};(t.exports=function(t,e,n,f,l){var p,h,d,v,y,m,g,b=u(e,n,f?2:1);if(l)p=t;else{if("function"!=typeof(h=c(t)))throw TypeError("Target is not iterable");if(o(h)){for(d=0,v=i(t.length);v>d;d++)if((y=f?b(r(g=t[d])[0],g[1]):b(t[d]))&&y instanceof s)return y;return new s(!1)}p=h.call(t)}for(m=p.next;!(g=m.call(p)).done;)if("object"==typeof(y=a(p,b,g.value,f))&&y&&y instanceof s)return y;return new s(!1)}).stop=function(t){return new s(!0,t)}},function(t,e,n){var r={};r[n(1)("toStringTag")]="z",t.exports="[object z]"===String(r)},function(t,e){t.exports=function(t,e,n){if(!(t instanceof e))throw TypeError("Incorrect "+(n?n+" ":"")+"invocation");return t}},function(t,e,n){var r=n(5).f,o=n(3),i=n(1)("toStringTag");t.exports=function(t,e,n){t&&!o(t=n?t:t.prototype,i)&&r(t,i,{configurable:!0,value:e})}},function(t,e,n){var r,o=n(7),i=n(80),u=n(32),c=n(16),a=n(81),s=n(47),f=n(27)("IE_PROTO"),l=function(){},p=function(t){return"<script>"+t+"<\/script>"},h=function(){try{r=document.domain&&new ActiveXObject("htmlfile")}catch(t){}h=r?function(t){t.write(p("")),t.close();var e=t.parentWindow.Object;return t=null,e}(r):function(){var t,e=s("iframe");return e.style.display="none",a.appendChild(e),e.src=String("javascript:"),(t=e.contentWindow.document).open(),t.write(p("document.F=Object")),t.close(),t.F}();for(var t=u.length;t--;)delete h.prototype[u[t]];return h()};c[f]=!0,t.exports=Object.create||function(t,e){var n;return null!==t?(l.prototype=o(t),n=new l,l.prototype=null,n[f]=t):n=h(),void 0===e?n:i(n,e)}},function(t,e,n){var r=n(11);t.exports=function(t,e,n){for(var o in e)r(t,o,e[o],n);return t}},function(t,e,n){"use strict";var r=n(13),o=n(82),i=n(65),u=n(61),c=n(36),a=n(8),s=n(11),f=n(1),l=n(28),p=n(12),h=n(64),d=h.IteratorPrototype,v=h.BUGGY_SAFARI_ITERATORS,y=f("iterator"),m=function(){return this};t.exports=function(t,e,n,f,h,g,b){o(n,e,f);var x,w,S,O=function(t){if(t===h&&j)return j;if(!v&&t in T)return T[t];switch(t){case"keys":case"values":case"entries":return function(){return new n(this,t)}}return function(){return new n(this)}},_=e+" Iterator",E=!1,T=t.prototype,A=T[y]||T["@@iterator"]||h&&T[h],j=!v&&A||O(h),P="Array"==e&&T.entries||A;if(P&&(x=i(P.call(new t)),d!==Object.prototype&&x.next&&(l||i(x)===d||(u?u(x,d):"function"!=typeof x[y]&&a(x,y,m)),c(x,_,!0,!0),l&&(p[_]=m))),"values"==h&&A&&"values"!==A.name&&(E=!0,j=function(){return A.call(this)}),l&&!b||T[y]===j||a(T,y,j),p[e]=j,h)if(w={values:O("values"),keys:g?j:O("keys"),entries:O("entries")},b)for(S in w)!v&&!E&&S in T||s(T,S,w[S]);else r({target:e,proto:!0,forced:v||E},w);return w}},function(t,e,n){var r=n(34),o=n(11),i=n(85);r||o(Object.prototype,"toString",i,{unsafe:!0})},function(t,e,n){"use strict";var r=n(86).charAt,o=n(9),i=n(39),u=o.set,c=o.getterFor("String Iterator");i(String,"String",(function(t){u(this,{type:"String Iterator",string:String(t),index:0})}),(function(){var t,e=c(this),n=e.string,o=e.index;return o>=n.length?{value:void 0,done:!0}:(t=r(n,o),e.index+=t.length,{value:t,done:!1})}))},function(t,e,n){var r=n(0),o=n(87),i=n(88),u=n(8),c=n(1),a=c("iterator"),s=c("toStringTag"),f=i.values;for(var l in o){var p=r[l],h=p&&p.prototype;if(h){if(h[a]!==f)try{u(h,a,f)}catch(t){h[a]=f}if(h[s]||u(h,s,l),o[l])for(var d in i)if(h[d]!==i[d])try{u(h,d,i[d])}catch(t){h[d]=i[d]}}}},function(t,e){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){var r=n(6),o=n(45),i=n(14),u=n(15),c=n(25),a=n(3),s=n(46),f=Object.getOwnPropertyDescriptor;e.f=r?f:function(t,e){if(t=u(t),e=c(e,!0),s)try{return f(t,e)}catch(t){}if(a(t,e))return i(!o.f.call(t,e),t[e])}},function(t,e,n){"use strict";var r={}.propertyIsEnumerable,o=Object.getOwnPropertyDescriptor,i=o&&!r.call({1:2},1);e.f=i?function(t){var e=o(this,t);return!!e&&e.enumerable}:r},function(t,e,n){var r=n(6),o=n(4),i=n(47);t.exports=!r&&!o((function(){return 7!=Object.defineProperty(i("div"),"a",{get:function(){return 7}}).a}))},function(t,e,n){var r=n(0),o=n(2),i=r.document,u=o(i)&&o(i.createElement);t.exports=function(t){return u?i.createElement(t):{}}},function(t,e,n){var r=n(49),o=Function.toString;"function"!=typeof r.inspectSource&&(r.inspectSource=function(t){return o.call(t)}),t.exports=r.inspectSource},function(t,e,n){var r=n(0),o=n(26),i=r["__core-js_shared__"]||o("__core-js_shared__",{});t.exports=i},function(t,e,n){var r=n(0),o=n(48),i=r.WeakMap;t.exports="function"==typeof i&&/native code/.test(o(i))},function(t,e,n){var r=n(28),o=n(49);(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.6.4",mode:r?"pure":"global",copyright:"© 2020 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){var r=n(3),o=n(15),i=n(73).indexOf,u=n(16);t.exports=function(t,e){var n,c=o(t),a=0,s=[];for(n in c)!r(u,n)&&r(c,n)&&s.push(n);for(;e.length>a;)r(c,n=e[a++])&&(~i(s,n)||s.push(n));return s}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){var r=n(4),o=/#|\.prototype\./,i=function(t,e){var n=c[u(t)];return n==s||n!=a&&("function"==typeof e?r(e):!!e)},u=i.normalize=function(t){return String(t).replace(o,".").toLowerCase()},c=i.data={},a=i.NATIVE="N",s=i.POLYFILL="P";t.exports=i},function(t,e,n){var r=n(1),o=n(12),i=r("iterator"),u=Array.prototype;t.exports=function(t){return void 0!==t&&(o.Array===t||u[i]===t)}},function(t,e,n){var r=n(4);t.exports=!!Object.getOwnPropertySymbols&&!r((function(){return!String(Symbol())}))},function(t,e,n){var r=n(58),o=n(12),i=n(1)("iterator");t.exports=function(t){if(null!=t)return t[i]||t["@@iterator"]||o[r(t)]}},function(t,e,n){var r=n(34),o=n(23),i=n(1)("toStringTag"),u="Arguments"==o(function(){return arguments}());t.exports=r?o:function(t){var e,n,r;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),i))?n:u?o(e):"Object"==(r=o(e))&&"function"==typeof e.callee?"Arguments":r}},function(t,e,n){var r=n(7);t.exports=function(t,e,n,o){try{return o?e(r(n)[0],n[1]):e(n)}catch(e){var i=t.return;throw void 0!==i&&r(i.call(t)),e}}},function(t,e,n){var r=n(1)("iterator"),o=!1;try{var i=0,u={next:function(){return{done:!!i++}},return:function(){o=!0}};u[r]=function(){return this},Array.from(u,(function(){throw 2}))}catch(t){}t.exports=function(t,e){if(!e&&!o)return!1;var n=!1;try{var i={};i[r]=function(){return{next:function(){return{done:n=!0}}}},t(i)}catch(t){}return n}},function(t,e,n){var r=n(7),o=n(79);t.exports=Object.setPrototypeOf||("__proto__"in{}?function(){var t,e=!1,n={};try{(t=Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set).call(n,[]),e=n instanceof Array}catch(t){}return function(n,i){return r(n),o(i),e?t.call(n,i):n.__proto__=i,n}}():void 0)},function(t,e,n){"use strict";var r=n(5).f,o=n(37),i=n(38),u=n(19),c=n(35),a=n(33),s=n(39),f=n(84),l=n(6),p=n(18).fastKey,h=n(9),d=h.set,v=h.getterFor;t.exports={getConstructor:function(t,e,n,s){var f=t((function(t,r){c(t,f,e),d(t,{type:e,index:o(null),first:void 0,last:void 0,size:0}),l||(t.size=0),null!=r&&a(r,t[s],t,n)})),h=v(e),y=function(t,e,n){var r,o,i=h(t),u=m(t,e);return u?u.value=n:(i.last=u={index:o=p(e,!0),key:e,value:n,previous:r=i.last,next:void 0,removed:!1},i.first||(i.first=u),r&&(r.next=u),l?i.size++:t.size++,"F"!==o&&(i.index[o]=u)),t},m=function(t,e){var n,r=h(t),o=p(e);if("F"!==o)return r.index[o];for(n=r.first;n;n=n.next)if(n.key==e)return n};return i(f.prototype,{clear:function(){for(var t=h(this),e=t.index,n=t.first;n;)n.removed=!0,n.previous&&(n.previous=n.previous.next=void 0),delete e[n.index],n=n.next;t.first=t.last=void 0,l?t.size=0:this.size=0},delete:function(t){var e=h(this),n=m(this,t);if(n){var r=n.next,o=n.previous;delete e.index[n.index],n.removed=!0,o&&(o.next=r),r&&(r.previous=o),e.first==n&&(e.first=r),e.last==n&&(e.last=o),l?e.size--:this.size--}return!!n},forEach:function(t){for(var e,n=h(this),r=u(t,arguments.length>1?arguments[1]:void 0,3);e=e?e.next:n.first;)for(r(e.value,e.key,this);e&&e.removed;)e=e.previous},has:function(t){return!!m(this,t)}}),i(f.prototype,n?{get:function(t){var e=m(this,t);return e&&e.value},set:function(t,e){return y(this,0===t?0:t,e)}}:{add:function(t){return y(this,t=0===t?0:t,t)}}),l&&r(f.prototype,"size",{get:function(){return h(this).size}}),f},setStrong:function(t,e,n){var r=e+" Iterator",o=v(e),i=v(r);s(t,e,(function(t,e){d(this,{type:r,target:t,state:o(t),kind:e,last:void 0})}),(function(){for(var t=i(this),e=t.kind,n=t.last;n&&n.removed;)n=n.previous;return t.target&&(t.last=n=n?n.next:t.state.first)?"keys"==e?{value:n.key,done:!1}:"values"==e?{value:n.value,done:!1}:{value:[n.key,n.value],done:!1}:(t.target=void 0,{value:void 0,done:!0})}),n?"entries":"values",!n,!0),f(e)}}},function(t,e,n){var r=n(52),o=n(32);t.exports=Object.keys||function(t){return r(t,o)}},function(t,e,n){"use strict";var r,o,i,u=n(65),c=n(8),a=n(3),s=n(1),f=n(28),l=s("iterator"),p=!1;[].keys&&("next"in(i=[].keys())?(o=u(u(i)))!==Object.prototype&&(r=o):p=!0),null==r&&(r={}),f||a(r,l)||c(r,l,(function(){return this})),t.exports={IteratorPrototype:r,BUGGY_SAFARI_ITERATORS:p}},function(t,e,n){var r=n(3),o=n(20),i=n(27),u=n(83),c=i("IE_PROTO"),a=Object.prototype;t.exports=u?Object.getPrototypeOf:function(t){return t=o(t),r(t,c)?t[c]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?a:null}},function(t,e,n){"use strict";(function(t){var n="object"==typeof t&&t&&t.Object===Object&&t;e.a=n}).call(this,n(43))},function(t,e,n){t.exports=n(105)},function(t,e,n){n(69),n(40),n(41),n(42);var r=n(10);t.exports=r.Map},function(t,e,n){"use strict";var r=n(21),o=n(62);t.exports=r("Map",(function(t){return function(){return t(this,arguments.length?arguments[0]:void 0)}}),o)},function(t,e,n){var r=n(3),o=n(71),i=n(44),u=n(5);t.exports=function(t,e){for(var n=o(e),c=u.f,a=i.f,s=0;s<n.length;s++){var f=n[s];r(t,f)||c(t,f,a(e,f))}}},function(t,e,n){var r=n(30),o=n(72),i=n(53),u=n(7);t.exports=r("Reflect","ownKeys")||function(t){var e=o.f(u(t)),n=i.f;return n?e.concat(n(t)):e}},function(t,e,n){var r=n(52),o=n(32).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},function(t,e,n){var r=n(15),o=n(17),i=n(74),u=function(t){return function(e,n,u){var c,a=r(e),s=o(a.length),f=i(u,s);if(t&&n!=n){for(;s>f;)if((c=a[f++])!=c)return!0}else for(;s>f;f++)if((t||f in a)&&a[f]===n)return t||f||0;return!t&&-1}};t.exports={includes:u(!0),indexOf:u(!1)}},function(t,e,n){var r=n(31),o=Math.max,i=Math.min;t.exports=function(t,e){var n=r(t);return n<0?o(n+e,0):i(n,e)}},function(t,e,n){var r=n(4);t.exports=!r((function(){return Object.isExtensible(Object.preventExtensions({}))}))},function(t,e,n){var r=n(56);t.exports=r&&!Symbol.sham&&"symbol"==typeof Symbol.iterator},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(String(t)+" is not a function");return t}},function(t,e,n){var r=n(2),o=n(61);t.exports=function(t,e,n){var i,u;return o&&"function"==typeof(i=e.constructor)&&i!==n&&r(u=i.prototype)&&u!==n.prototype&&o(t,u),t}},function(t,e,n){var r=n(2);t.exports=function(t){if(!r(t)&&null!==t)throw TypeError("Can't set "+String(t)+" as a prototype");return t}},function(t,e,n){var r=n(6),o=n(5),i=n(7),u=n(63);t.exports=r?Object.defineProperties:function(t,e){i(t);for(var n,r=u(e),c=r.length,a=0;c>a;)o.f(t,n=r[a++],e[n]);return t}},function(t,e,n){var r=n(30);t.exports=r("document","documentElement")},function(t,e,n){"use strict";var r=n(64).IteratorPrototype,o=n(37),i=n(14),u=n(36),c=n(12),a=function(){return this};t.exports=function(t,e,n){var s=e+" Iterator";return t.prototype=o(r,{next:i(1,n)}),u(t,s,!1,!0),c[s]=a,t}},function(t,e,n){var r=n(4);t.exports=!r((function(){function t(){}return t.prototype.constructor=null,Object.getPrototypeOf(new t)!==t.prototype}))},function(t,e,n){"use strict";var r=n(30),o=n(5),i=n(1),u=n(6),c=i("species");t.exports=function(t){var e=r(t),n=o.f;u&&e&&!e[c]&&n(e,c,{configurable:!0,get:function(){return this}})}},function(t,e,n){"use strict";var r=n(34),o=n(58);t.exports=r?{}.toString:function(){return"[object "+o(this)+"]"}},function(t,e,n){var r=n(31),o=n(24),i=function(t){return function(e,n){var i,u,c=String(o(e)),a=r(n),s=c.length;return a<0||a>=s?t?"":void 0:(i=c.charCodeAt(a))<55296||i>56319||a+1===s||(u=c.charCodeAt(a+1))<56320||u>57343?t?c.charAt(a):i:t?c.slice(a,a+2):u-56320+(i-55296<<10)+65536}};t.exports={codeAt:i(!1),charAt:i(!0)}},function(t,e){t.exports={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0}},function(t,e,n){"use strict";var r=n(15),o=n(89),i=n(12),u=n(9),c=n(39),a=u.set,s=u.getterFor("Array Iterator");t.exports=c(Array,"Array",(function(t,e){a(this,{type:"Array Iterator",target:r(t),index:0,kind:e})}),(function(){var t=s(this),e=t.target,n=t.kind,r=t.index++;return!e||r>=e.length?(t.target=void 0,{value:void 0,done:!0}):"keys"==n?{value:r,done:!1}:"values"==n?{value:e[r],done:!1}:{value:[r,e[r]],done:!1}}),"values"),i.Arguments=i.Array,o("keys"),o("values"),o("entries")},function(t,e,n){var r=n(1),o=n(37),i=n(5),u=r("unscopables"),c=Array.prototype;null==c[u]&&i.f(c,u,{configurable:!0,value:o(null)}),t.exports=function(t){c[u][t]=!0}},function(t,e,n){n(91),n(40),n(41),n(42);var r=n(10);t.exports=r.Set},function(t,e,n){"use strict";var r=n(21),o=n(62);t.exports=r("Set",(function(t){return function(){return t(this,arguments.length?arguments[0]:void 0)}}),o)},function(t,e,n){n(40),n(93),n(42);var r=n(10);t.exports=r.WeakMap},function(t,e,n){"use strict";var r,o=n(0),i=n(38),u=n(18),c=n(21),a=n(94),s=n(2),f=n(9).enforce,l=n(50),p=!o.ActiveXObject&&"ActiveXObject"in o,h=Object.isExtensible,d=function(t){return function(){return t(this,arguments.length?arguments[0]:void 0)}},v=t.exports=c("WeakMap",d,a);if(l&&p){r=a.getConstructor(d,"WeakMap",!0),u.REQUIRED=!0;var y=v.prototype,m=y.delete,g=y.has,b=y.get,x=y.set;i(y,{delete:function(t){if(s(t)&&!h(t)){var e=f(this);return e.frozen||(e.frozen=new r),m.call(this,t)||e.frozen.delete(t)}return m.call(this,t)},has:function(t){if(s(t)&&!h(t)){var e=f(this);return e.frozen||(e.frozen=new r),g.call(this,t)||e.frozen.has(t)}return g.call(this,t)},get:function(t){if(s(t)&&!h(t)){var e=f(this);return e.frozen||(e.frozen=new r),g.call(this,t)?b.call(this,t):e.frozen.get(t)}return b.call(this,t)},set:function(t,e){if(s(t)&&!h(t)){var n=f(this);n.frozen||(n.frozen=new r),g.call(this,t)?x.call(this,t,e):n.frozen.set(t,e)}else x.call(this,t,e);return this}})}},function(t,e,n){"use strict";var r=n(38),o=n(18).getWeakData,i=n(7),u=n(2),c=n(35),a=n(33),s=n(95),f=n(3),l=n(9),p=l.set,h=l.getterFor,d=s.find,v=s.findIndex,y=0,m=function(t){return t.frozen||(t.frozen=new g)},g=function(){this.entries=[]},b=function(t,e){return d(t.entries,(function(t){return t[0]===e}))};g.prototype={get:function(t){var e=b(this,t);if(e)return e[1]},has:function(t){return!!b(this,t)},set:function(t,e){var n=b(this,t);n?n[1]=e:this.entries.push([t,e])},delete:function(t){var e=v(this.entries,(function(e){return e[0]===t}));return~e&&this.entries.splice(e,1),!!~e}},t.exports={getConstructor:function(t,e,n,s){var l=t((function(t,r){c(t,l,e),p(t,{type:e,id:y++,frozen:void 0}),null!=r&&a(r,t[s],t,n)})),d=h(e),v=function(t,e,n){var r=d(t),u=o(i(e),!0);return!0===u?m(r).set(e,n):u[r.id]=n,t};return r(l.prototype,{delete:function(t){var e=d(this);if(!u(t))return!1;var n=o(t);return!0===n?m(e).delete(t):n&&f(n,e.id)&&delete n[e.id]},has:function(t){var e=d(this);if(!u(t))return!1;var n=o(t);return!0===n?m(e).has(t):n&&f(n,e.id)}}),r(l.prototype,n?{get:function(t){var e=d(this);if(u(t)){var n=o(t);return!0===n?m(e).get(t):n?n[e.id]:void 0}},set:function(t,e){return v(this,t,e)}}:{add:function(t){return v(this,t,!0)}}),l}}},function(t,e,n){var r=n(19),o=n(22),i=n(20),u=n(17),c=n(96),a=[].push,s=function(t){var e=1==t,n=2==t,s=3==t,f=4==t,l=6==t,p=5==t||l;return function(h,d,v,y){for(var m,g,b=i(h),x=o(b),w=r(d,v,3),S=u(x.length),O=0,_=y||c,E=e?_(h,S):n?_(h,0):void 0;S>O;O++)if((p||O in x)&&(g=w(m=x[O],O,b),t))if(e)E[O]=g;else if(g)switch(t){case 3:return!0;case 5:return m;case 6:return O;case 2:a.call(E,m)}else if(f)return!1;return l?-1:s||f?f:E}};t.exports={forEach:s(0),map:s(1),filter:s(2),some:s(3),every:s(4),find:s(5),findIndex:s(6)}},function(t,e,n){var r=n(2),o=n(97),i=n(1)("species");t.exports=function(t,e){var n;return o(t)&&("function"!=typeof(n=t.constructor)||n!==Array&&!o(n.prototype)?r(n)&&null===(n=n[i])&&(n=void 0):n=void 0),new(void 0===n?Array:n)(0===e?0:e)}},function(t,e,n){var r=n(23);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){n(41),n(99);var r=n(10);t.exports=r.Array.from},function(t,e,n){var r=n(13),o=n(100);r({target:"Array",stat:!0,forced:!n(60)((function(t){Array.from(t)}))},{from:o})},function(t,e,n){"use strict";var r=n(19),o=n(20),i=n(59),u=n(55),c=n(17),a=n(101),s=n(57);t.exports=function(t){var e,n,f,l,p,h,d=o(t),v="function"==typeof this?this:Array,y=arguments.length,m=y>1?arguments[1]:void 0,g=void 0!==m,b=s(d),x=0;if(g&&(m=r(m,y>2?arguments[2]:void 0,2)),null==b||v==Array&&u(b))for(n=new v(e=c(d.length));e>x;x++)h=g?m(d[x],x):d[x],a(n,x,h);else for(p=(l=b.call(d)).next,n=new v;!(f=p.call(l)).done;x++)h=g?i(l,m,[f.value,x],!0):f.value,a(n,x,h);return n.length=x,n}},function(t,e,n){"use strict";var r=n(25),o=n(5),i=n(14);t.exports=function(t,e,n){var u=r(e);u in t?o.f(t,u,i(0,n)):t[u]=n}},function(t,e,n){n(103);var r=n(10);t.exports=r.Object.assign},function(t,e,n){var r=n(13),o=n(104);r({target:"Object",stat:!0,forced:Object.assign!==o},{assign:o})},function(t,e,n){"use strict";var r=n(6),o=n(4),i=n(63),u=n(53),c=n(45),a=n(20),s=n(22),f=Object.assign,l=Object.defineProperty;t.exports=!f||o((function(){if(r&&1!==f({b:1},f(l({},"a",{enumerable:!0,get:function(){l(this,"b",{value:3,enumerable:!1})}}),{b:2})).b)return!0;var t={},e={},n=Symbol();return t[n]=7,"abcdefghijklmnopqrst".split("").forEach((function(t){e[t]=t})),7!=f({},t)[n]||"abcdefghijklmnopqrst"!=i(f({},e)).join("")}))?function(t,e){for(var n=a(t),o=arguments.length,f=1,l=u.f,p=c.f;o>f;)for(var h,d=s(arguments[f++]),v=l?i(d).concat(l(d)):i(d),y=v.length,m=0;y>m;)h=v[m++],r&&!p.call(d,h)||(n[h]=d[h]);return n}:f},function(t,e,n){"use strict";n.r(e);var r={};n.r(r),n.d(r,"keyboardHandler",(function(){return ot})),n.d(r,"mouseHandler",(function(){return it})),n.d(r,"resizeHandler",(function(){return ut})),n.d(r,"selectHandler",(function(){return ct})),n.d(r,"touchHandler",(function(){return at})),n.d(r,"wheelHandler",(function(){return st}));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var o=function(t,e){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(t,e)},i=function(){return(i=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};function u(t,e,n,r){var o,i=arguments.length,u=i<3?e:null===r?r=Object.getOwnPropertyDescriptor(e,n):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)u=Reflect.decorate(t,e,n,r);else for(var c=t.length-1;c>=0;c--)(o=t[c])&&(u=(i<3?o(u):i>3?o(e,n,u):o(e,n))||u);return i>3&&u&&Object.defineProperty(e,n,u),u}n(68),n(90),n(92),n(98),n(102);var c=/\s/,a=/^\s+/,s=function(t){return t?t.slice(0,function(t){for(var e=t.length;e--&&c.test(t.charAt(e)););return e}(t)+1).replace(a,""):t},f=function(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)},l=n(66),p="object"==typeof self&&self&&self.Object===Object&&self,h=l.a||p||Function("return this")(),d=h.Symbol,v=Object.prototype,y=v.hasOwnProperty,m=v.toString,g=d?d.toStringTag:void 0,b=Object.prototype.toString,x=d?d.toStringTag:void 0,w=function(t){return null==t?void 0===t?"[object Undefined]":"[object Null]":x&&x in Object(t)?function(t){var e=y.call(t,g),n=t[g];try{t[g]=void 0;var r=!0}catch(t){}var o=m.call(t);return r&&(e?t[g]=n:delete t[g]),o}(t):function(t){return b.call(t)}(t)},S=/^[-+]0x[0-9a-f]+$/i,O=/^0b[01]+$/i,_=/^0o[0-7]+$/i,E=parseInt,T=function(t){if("number"==typeof t)return t;if(function(t){return"symbol"==typeof t||function(t){return null!=t&&"object"==typeof t}(t)&&"[object Symbol]"==w(t)}(t))return NaN;if(f(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=f(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=s(t);var n=O.test(t);return n||_.test(t)?E(t.slice(2),n?2:8):S.test(t)?NaN:+t},A=function(t,e,n){return void 0===n&&(n=e,e=void 0),void 0!==n&&(n=(n=T(n))==n?n:0),void 0!==e&&(e=(e=T(e))==e?e:0),function(t,e,n){return t==t&&(void 0!==n&&(t=t<=n?t:n),void 0!==e&&(t=t>=e?t:e)),t}(T(t),e,n)};function j(t,e){return void 0===t&&(t=-1/0),void 0===e&&(e=1/0),function(n,r){var o="_"+r;Object.defineProperty(n,r,{get:function(){return this[o]},set:function(n){Object.defineProperty(this,o,{value:A(n,t,e),enumerable:!1,writable:!0,configurable:!0})},enumerable:!0,configurable:!0})}}function P(t,e){var n="_"+e;Object.defineProperty(t,e,{get:function(){return this[n]},set:function(t){Object.defineProperty(this,n,{value:!!t,enumerable:!1,writable:!0,configurable:!0})},enumerable:!0,configurable:!0})}var M=function(){return h.Date.now()},k=Math.max,D=Math.min,z=function(t,e,n){var r,o,i,u,c,a,s=0,l=!1,p=!1,h=!0;if("function"!=typeof t)throw new TypeError("Expected a function");function d(e){var n=r,i=o;return r=o=void 0,s=e,u=t.apply(i,n)}function v(t){var n=t-a;return void 0===a||n>=e||n<0||p&&t-s>=i}function y(){var t=M();if(v(t))return m(t);c=setTimeout(y,function(t){var n=e-(t-a);return p?D(n,i-(t-s)):n}(t))}function m(t){return c=void 0,h&&r?d(t):(r=o=void 0,u)}function g(){var t=M(),n=v(t);if(r=arguments,o=this,a=t,n){if(void 0===c)return function(t){return s=t,c=setTimeout(y,e),l?d(t):u}(a);if(p)return clearTimeout(c),c=setTimeout(y,e),d(a)}return void 0===c&&(c=setTimeout(y,e)),u}return e=T(e)||0,f(n)&&(l=!!n.leading,i=(p="maxWait"in n)?k(T(n.maxWait)||0,e):i,h="trailing"in n?!!n.trailing:h),g.cancel=function(){void 0!==c&&clearTimeout(c),s=0,r=a=o=c=void 0},g.flush=function(){return void 0===c?u:m(M())},g};function L(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return function(e,n,r){var o=r.value;return{get:function(){return this.hasOwnProperty(n)||Object.defineProperty(this,n,{value:z.apply(void 0,function(){for(var t=0,e=0,n=arguments.length;e<n;e++)t+=arguments[e].length;var r=Array(t),o=0;for(e=0;e<n;e++)for(var i=arguments[e],u=0,c=i.length;u<c;u++,o++)r[o]=i[u];return r}([o],t))}),this[n]}}}}var I,R=function(){function t(t){var e=this;void 0===t&&(t={}),this.damping=.1,this.thumbMinSize=20,this.renderByPixels=!0,this.alwaysShowTracks=!1,this.continuousScrolling=!0,this.delegateTo=null,this.plugins={},Object.keys(t).forEach((function(n){e[n]=t[n]}))}return Object.defineProperty(t.prototype,"wheelEventTarget",{get:function(){return this.delegateTo},set:function(t){console.warn("[smooth-scrollbar]: `options.wheelEventTarget` is deprecated and will be removed in the future, use `options.delegateTo` instead."),this.delegateTo=t},enumerable:!0,configurable:!0}),u([j(0,1)],t.prototype,"damping",void 0),u([j(0,1/0)],t.prototype,"thumbMinSize",void 0),u([P],t.prototype,"renderByPixels",void 0),u([P],t.prototype,"alwaysShowTracks",void 0),u([P],t.prototype,"continuousScrolling",void 0),t}(),C=new WeakMap;function N(){if(void 0!==I)return I;var t=!1;try{var e=function(){},n=Object.defineProperty({},"passive",{get:function(){t=!0}});window.addEventListener("testPassive",e,n),window.removeEventListener("testPassive",e,n)}catch(t){}return I=!!t&&{passive:!1}}function F(t){var e=C.get(t)||[];return C.set(t,e),function(t,n,r){function o(t){t.defaultPrevented||r(t)}n.split(/\s+/g).forEach((function(n){e.push({elem:t,eventName:n,handler:o}),t.addEventListener(n,o,N())}))}}function H(t){var e=function(t){return t.touches?t.touches[t.touches.length-1]:t}(t);return{x:e.clientX,y:e.clientY}}function W(t,e){return void 0===e&&(e=[]),e.some((function(e){return t===e}))}var B=["webkit","moz","ms","o"],G=new RegExp("^-(?!(?:"+B.join("|")+")-)");function U(t,e){e=function(t){var e={};return Object.keys(t).forEach((function(n){if(G.test(n)){var r=t[n];n=n.replace(/^-/,""),e[n]=r,B.forEach((function(t){e["-"+t+"-"+n]=r}))}else e[n]=t[n]})),e}(e),Object.keys(e).forEach((function(n){var r=n.replace(/^-/,"").replace(/-([a-z])/g,(function(t,e){return e.toUpperCase()}));t.style[r]=e[n]}))}var X,V=function(){function t(t){this.velocityMultiplier=/Android/.test(navigator.userAgent)?window.devicePixelRatio:1,this.updateTime=Date.now(),this.delta={x:0,y:0},this.velocity={x:0,y:0},this.lastPosition={x:0,y:0},this.lastPosition=H(t)}return t.prototype.update=function(t){var e=this.velocity,n=this.updateTime,r=this.lastPosition,o=Date.now(),i=H(t),u={x:-(i.x-r.x),y:-(i.y-r.y)},c=o-n||16.7,a=u.x/c*16.7,s=u.y/c*16.7;e.x=a*this.velocityMultiplier,e.y=s*this.velocityMultiplier,this.delta=u,this.updateTime=o,this.lastPosition=i},t}(),Y=function(){function t(){this._touchList={}}return Object.defineProperty(t.prototype,"_primitiveValue",{get:function(){return{x:0,y:0}},enumerable:!0,configurable:!0}),t.prototype.isActive=function(){return void 0!==this._activeTouchID},t.prototype.getDelta=function(){var t=this._getActiveTracker();return t?i({},t.delta):this._primitiveValue},t.prototype.getVelocity=function(){var t=this._getActiveTracker();return t?i({},t.velocity):this._primitiveValue},t.prototype.getEasingDistance=function(t){var e=1-t,n={x:0,y:0},r=this.getVelocity();return Object.keys(r).forEach((function(t){for(var o=Math.abs(r[t])<=10?0:r[t];0!==o;)n[t]+=o,o=o*e|0})),n},t.prototype.track=function(t){var e=this,n=t.targetTouches;return Array.from(n).forEach((function(t){e._add(t)})),this._touchList},t.prototype.update=function(t){var e=this,n=t.touches,r=t.changedTouches;return Array.from(n).forEach((function(t){e._renew(t)})),this._setActiveID(r),this._touchList},t.prototype.release=function(t){var e=this;delete this._activeTouchID,Array.from(t.changedTouches).forEach((function(t){e._delete(t)}))},t.prototype._add=function(t){this._has(t)&&this._delete(t);var e=new V(t);this._touchList[t.identifier]=e},t.prototype._renew=function(t){this._has(t)&&this._touchList[t.identifier].update(t)},t.prototype._delete=function(t){delete this._touchList[t.identifier]},t.prototype._has=function(t){return this._touchList.hasOwnProperty(t.identifier)},t.prototype._setActiveID=function(t){this._activeTouchID=t[t.length-1].identifier},t.prototype._getActiveTracker=function(){return this._touchList[this._activeTouchID]},t}();!function(t){t.X="x",t.Y="y"}(X||(X={}));var q=function(){function t(t,e){void 0===e&&(e=0),this._direction=t,this._minSize=e,this.element=document.createElement("div"),this.displaySize=0,this.realSize=0,this.offset=0,this.element.className="scrollbar-thumb scrollbar-thumb-"+t}return t.prototype.attachTo=function(t){t.appendChild(this.element)},t.prototype.update=function(t,e,n){this.realSize=Math.min(e/n,1)*e,this.displaySize=Math.max(this.realSize,this._minSize),this.offset=t/n*(e+(this.realSize-this.displaySize)),U(this.element,this._getStyle())},t.prototype._getStyle=function(){switch(this._direction){case X.X:return{width:this.displaySize+"px","-transform":"translate3d("+this.offset+"px, 0, 0)"};case X.Y:return{height:this.displaySize+"px","-transform":"translate3d(0, "+this.offset+"px, 0)"};default:return null}},t}(),Q=function(){function t(t,e){void 0===e&&(e=0),this.element=document.createElement("div"),this._isShown=!1,this.element.className="scrollbar-track scrollbar-track-"+t,this.thumb=new q(t,e),this.thumb.attachTo(this.element)}return t.prototype.attachTo=function(t){t.appendChild(this.element)},t.prototype.show=function(){this._isShown||(this._isShown=!0,this.element.classList.add("show"))},t.prototype.hide=function(){this._isShown&&(this._isShown=!1,this.element.classList.remove("show"))},t.prototype.update=function(t,e,n){U(this.element,{display:n<=e?"none":"block"}),this.thumb.update(t,e,n)},t}(),K=function(){function t(t){this._scrollbar=t;var e=t.options.thumbMinSize;this.xAxis=new Q(X.X,e),this.yAxis=new Q(X.Y,e),this.xAxis.attachTo(t.containerEl),this.yAxis.attachTo(t.containerEl),t.options.alwaysShowTracks&&(this.xAxis.show(),this.yAxis.show())}return t.prototype.update=function(){var t=this._scrollbar,e=t.size,n=t.offset;this.xAxis.update(n.x,e.container.width,e.content.width),this.yAxis.update(n.y,e.container.height,e.content.height)},t.prototype.autoHideOnIdle=function(){this._scrollbar.options.alwaysShowTracks||(this.xAxis.hide(),this.yAxis.hide())},u([L(300)],t.prototype,"autoHideOnIdle",null),t}(),$=new WeakMap;function J(t){return Math.pow(t-1,3)+1}var Z,tt,et,nt=function(){function t(t,e){var n=this.constructor;this.scrollbar=t,this.name=n.pluginName,this.options=i(i({},n.defaultOptions),e)}return t.prototype.onInit=function(){},t.prototype.onDestroy=function(){},t.prototype.onUpdate=function(){},t.prototype.onRender=function(t){},t.prototype.transformDelta=function(t,e){return i({},t)},t.pluginName="",t.defaultOptions={},t}(),rt={order:new Set,constructors:{}};function ot(t){var e=F(t),n=t.containerEl;e(n,"keydown",(function(e){var r=document.activeElement;if((r===n||n.contains(r))&&!function(t){return!("INPUT"!==t.tagName&&"SELECT"!==t.tagName&&"TEXTAREA"!==t.tagName&&!t.isContentEditable)&&!t.disabled}(r)){var o=function(t,e){var n=t.size,r=t.limit,o=t.offset;switch(e){case Z.TAB:return function(t){requestAnimationFrame((function(){t.scrollIntoView(document.activeElement,{offsetTop:t.size.container.height/2,onlyScrollIfNeeded:!0})}))}(t);case Z.SPACE:return[0,200];case Z.PAGE_UP:return[0,40-n.container.height];case Z.PAGE_DOWN:return[0,n.container.height-40];case Z.END:return[0,r.y-o.y];case Z.HOME:return[0,-o.y];case Z.LEFT:return[-40,0];case Z.UP:return[0,-40];case Z.RIGHT:return[40,0];case Z.DOWN:return[0,40];default:return null}}(t,e.keyCode||e.which);if(o){var i=o[0],u=o[1];t.addTransformableMomentum(i,u,e,(function(n){n?e.preventDefault():(t.containerEl.blur(),t.parent&&t.parent.containerEl.focus())}))}}}))}function it(t){var e,n,r,o,i,u=F(t),c=t.containerEl,a=t.track,s=a.xAxis,f=a.yAxis;function l(e,n){var r=t.size,o=t.limit,i=t.offset;if(e===tt.X){var u=r.container.width+(s.thumb.realSize-s.thumb.displaySize);return A(n/u*r.content.width,0,o.x)-i.x}if(e===tt.Y){var c=r.container.height+(f.thumb.realSize-f.thumb.displaySize);return A(n/c*r.content.height,0,o.y)-i.y}return 0}function p(t){return W(t,[s.element,s.thumb.element])?tt.X:W(t,[f.element,f.thumb.element])?tt.Y:void 0}u(c,"click",(function(e){if(!n&&W(e.target,[s.element,f.element])){var r=e.target,o=p(r),i=r.getBoundingClientRect(),u=H(e);if(o===tt.X){var c=u.x-i.left-s.thumb.displaySize/2;t.setMomentum(l(o,c),0)}o===tt.Y&&(c=u.y-i.top-f.thumb.displaySize/2,t.setMomentum(0,l(o,c)))}})),u(c,"mousedown",(function(n){if(W(n.target,[s.thumb.element,f.thumb.element])){e=!0;var u=n.target,a=H(n),l=u.getBoundingClientRect();o=p(u),r={x:a.x-l.left,y:a.y-l.top},i=c.getBoundingClientRect(),U(t.containerEl,{"-user-select":"none"})}})),u(window,"mousemove",(function(u){if(e){n=!0;var c=H(u);if(o===tt.X){var a=c.x-r.x-i.left;t.setMomentum(l(o,a),0)}o===tt.Y&&(a=c.y-r.y-i.top,t.setMomentum(0,l(o,a)))}})),u(window,"mouseup blur",(function(){e=n=!1,U(t.containerEl,{"-user-select":""})}))}function ut(t){F(t)(window,"resize",z(t.update.bind(t),300))}function ct(t){var e,n=F(t),r=t.containerEl,o=t.contentEl,i=!1,u=!1;n(window,"mousemove",(function(n){i&&(cancelAnimationFrame(e),function n(r){var o=r.x,i=r.y;if(o||i){var u=t.offset,c=t.limit;t.setMomentum(A(u.x+o,0,c.x)-u.x,A(u.y+i,0,c.y)-u.y),e=requestAnimationFrame((function(){n({x:o,y:i})}))}}(function(t,e){var n=t.bounding,r=n.top,o=n.right,i=n.bottom,u=n.left,c=H(e),a=c.x,s=c.y,f={x:0,y:0};return 0===a&&0===s||(a>o-20?f.x=a-o+20:a<u+20&&(f.x=a-u-20),s>i-20?f.y=s-i+20:s<r+20&&(f.y=s-r-20),f.x*=2,f.y*=2),f}(t,n)))})),n(o,"contextmenu",(function(){u=!0,cancelAnimationFrame(e),i=!1})),n(o,"mousedown",(function(){u=!1})),n(o,"selectstart",(function(){u||(cancelAnimationFrame(e),i=!0)})),n(window,"mouseup blur",(function(){cancelAnimationFrame(e),i=!1,u=!1})),n(r,"scroll",(function(t){t.preventDefault(),r.scrollTop=r.scrollLeft=0}))}function at(t){var e,n=t.options.delegateTo||t.containerEl,r=new Y,o=F(t),i=0;o(n,"touchstart",(function(n){r.track(n),t.setMomentum(0,0),0===i&&(e=t.options.damping,t.options.damping=Math.max(e,.5)),i++})),o(n,"touchmove",(function(e){if(!et||et===t){r.update(e);var n=r.getDelta(),o=n.x,i=n.y;t.addTransformableMomentum(o,i,e,(function(n){n&&e.cancelable&&(e.preventDefault(),et=t)}))}})),o(n,"touchcancel touchend",(function(n){var o=r.getEasingDistance(e);t.addTransformableMomentum(o.x,o.y,n),0==--i&&(t.options.damping=e),r.release(n),et=null}))}function st(t){F(t)(t.options.delegateTo||t.containerEl,"onwheel"in window||document.implementation.hasFeature("Events.wheel","3.0")?"wheel":"mousewheel",(function(e){var n=function(t){if("deltaX"in t){var e=pt(t.deltaMode);return{x:t.deltaX/ft.STANDARD*e,y:t.deltaY/ft.STANDARD*e}}return"wheelDeltaX"in t?{x:t.wheelDeltaX/ft.OTHERS,y:t.wheelDeltaY/ft.OTHERS}:{x:0,y:t.wheelDelta/ft.OTHERS}}(e),r=n.x,o=n.y;t.addTransformableMomentum(r,o,e,(function(t){t&&e.preventDefault()}))}))}!function(t){t[t.TAB=9]="TAB",t[t.SPACE=32]="SPACE",t[t.PAGE_UP=33]="PAGE_UP",t[t.PAGE_DOWN=34]="PAGE_DOWN",t[t.END=35]="END",t[t.HOME=36]="HOME",t[t.LEFT=37]="LEFT",t[t.UP=38]="UP",t[t.RIGHT=39]="RIGHT",t[t.DOWN=40]="DOWN"}(Z||(Z={})),function(t){t[t.X=0]="X",t[t.Y=1]="Y"}(tt||(tt={}));var ft={STANDARD:1,OTHERS:-3},lt=[1,28,500],pt=function(t){return lt[t]||lt[0]},ht=new Map,dt=function(){function t(t,e){var n=this;this.offset={x:0,y:0},this.limit={x:1/0,y:1/0},this.bounding={top:0,right:0,bottom:0,left:0},this._plugins=[],this._momentum={x:0,y:0},this._listeners=new Set,this.containerEl=t;var r=this.contentEl=document.createElement("div");this.options=new R(e),t.setAttribute("data-scrollbar","true"),t.setAttribute("tabindex","-1"),U(t,{overflow:"hidden",outline:"none"}),window.navigator.msPointerEnabled&&(t.style.msTouchAction="none"),r.className="scroll-content",Array.from(t.childNodes).forEach((function(t){r.appendChild(t)})),t.appendChild(r),this.track=new K(this),this.size=this.getSize(),this._plugins=function(t,e){return Array.from(rt.order).filter((function(t){return!1!==e[t]})).map((function(n){var r=new(0,rt.constructors[n])(t,e[n]);return e[n]=r.options,r}))}(this,this.options.plugins);var o=t.scrollLeft,i=t.scrollTop;t.scrollLeft=t.scrollTop=0,this.setPosition(o,i,{withoutCallbacks:!0});var u=window.ResizeObserver;"function"==typeof u&&(this._observer=new u((function(){n.update()})),this._observer.observe(r)),ht.set(t,this),requestAnimationFrame((function(){n._init()}))}return Object.defineProperty(t.prototype,"parent",{get:function(){for(var t=this.containerEl.parentElement;t;){var e=ht.get(t);if(e)return e;t=t.parentElement}return null},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"scrollTop",{get:function(){return this.offset.y},set:function(t){this.setPosition(this.scrollLeft,t)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"scrollLeft",{get:function(){return this.offset.x},set:function(t){this.setPosition(t,this.scrollTop)},enumerable:!0,configurable:!0}),t.prototype.getSize=function(){return function(t){var e=t.containerEl,n=t.contentEl,r=getComputedStyle(e),o=["paddingTop","paddingBottom","paddingLeft","paddingRight"].map((function(t){return r[t]?parseFloat(r[t]):0})),i=o[0]+o[1],u=o[2]+o[3];return{container:{width:e.clientWidth,height:e.clientHeight},content:{width:n.offsetWidth-n.clientWidth+n.scrollWidth+u,height:n.offsetHeight-n.clientHeight+n.scrollHeight+i}}}(this)},t.prototype.update=function(){!function(t){var e=t.getSize(),n={x:Math.max(e.content.width-e.container.width,0),y:Math.max(e.content.height-e.container.height,0)},r=t.containerEl.getBoundingClientRect(),o={top:Math.max(r.top,0),right:Math.min(r.right,window.innerWidth),bottom:Math.min(r.bottom,window.innerHeight),left:Math.max(r.left,0)};t.size=e,t.limit=n,t.bounding=o,t.track.update(),t.setPosition()}(this),this._plugins.forEach((function(t){t.onUpdate()}))},t.prototype.isVisible=function(t){return function(t,e){var n=t.bounding,r=e.getBoundingClientRect(),o=Math.max(n.top,r.top),i=Math.max(n.left,r.left),u=Math.min(n.right,r.right);return o<Math.min(n.bottom,r.bottom)&&i<u}(this,t)},t.prototype.setPosition=function(t,e,n){var r=this;void 0===t&&(t=this.offset.x),void 0===e&&(e=this.offset.y),void 0===n&&(n={});var o=function(t,e,n){var r=t.options,o=t.offset,u=t.limit,c=t.track,a=t.contentEl;return r.renderByPixels&&(e=Math.round(e),n=Math.round(n)),e=A(e,0,u.x),n=A(n,0,u.y),e!==o.x&&c.xAxis.show(),n!==o.y&&c.yAxis.show(),r.alwaysShowTracks||c.autoHideOnIdle(),e===o.x&&n===o.y?null:(o.x=e,o.y=n,U(a,{"-transform":"translate3d("+-e+"px, "+-n+"px, 0)"}),c.update(),{offset:i({},o),limit:i({},u)})}(this,t,e);o&&!n.withoutCallbacks&&this._listeners.forEach((function(t){t.call(r,o)}))},t.prototype.scrollTo=function(t,e,n,r){void 0===t&&(t=this.offset.x),void 0===e&&(e=this.offset.y),void 0===n&&(n=0),void 0===r&&(r={}),function(t,e,n,r,o){void 0===r&&(r=0);var i=void 0===o?{}:o,u=i.easing,c=void 0===u?J:u,a=i.callback,s=t.options,f=t.offset,l=t.limit;s.renderByPixels&&(e=Math.round(e),n=Math.round(n));var p=f.x,h=f.y,d=A(e,0,l.x)-p,v=A(n,0,l.y)-h,y=Date.now();cancelAnimationFrame($.get(t)),function e(){var n=Date.now()-y,o=r?c(Math.min(n/r,1)):1;if(t.setPosition(p+d*o,h+v*o),n>=r)"function"==typeof a&&a.call(t);else{var i=requestAnimationFrame(e);$.set(t,i)}}()}(this,t,e,n,r)},t.prototype.scrollIntoView=function(t,e){void 0===e&&(e={}),function(t,e,n){var r=void 0===n?{}:n,o=r.alignToTop,i=void 0===o||o,u=r.onlyScrollIfNeeded,c=void 0!==u&&u,a=r.offsetTop,s=void 0===a?0:a,f=r.offsetLeft,l=void 0===f?0:f,p=r.offsetBottom,h=void 0===p?0:p,d=t.containerEl,v=t.bounding,y=t.offset,m=t.limit;if(e&&d.contains(e)){var g=e.getBoundingClientRect();if(!c||!t.isVisible(e)){var b=i?g.top-v.top-s:g.bottom-v.bottom+h;t.setMomentum(g.left-v.left-l,A(b,-y.y,m.y-y.y))}}}(this,t,e)},t.prototype.addListener=function(t){if("function"!=typeof t)throw new TypeError("[smooth-scrollbar] scrolling listener should be a function");this._listeners.add(t)},t.prototype.removeListener=function(t){this._listeners.delete(t)},t.prototype.addTransformableMomentum=function(t,e,n,r){this._updateDebounced();var o=this._plugins.reduce((function(t,e){return e.transformDelta(t,n)||t}),{x:t,y:e}),i=!this._shouldPropagateMomentum(o.x,o.y);i&&this.addMomentum(o.x,o.y),r&&r.call(this,i)},t.prototype.addMomentum=function(t,e){this.setMomentum(this._momentum.x+t,this._momentum.y+e)},t.prototype.setMomentum=function(t,e){0===this.limit.x&&(t=0),0===this.limit.y&&(e=0),this.options.renderByPixels&&(t=Math.round(t),e=Math.round(e)),this._momentum.x=t,this._momentum.y=e},t.prototype.updatePluginOptions=function(t,e){this._plugins.forEach((function(n){n.name===t&&Object.assign(n.options,e)}))},t.prototype.destroy=function(){var t=this.containerEl,e=this.contentEl;!function(t){var e=C.get(t);e&&(e.forEach((function(t){var e=t.elem,n=t.eventName,r=t.handler;e.removeEventListener(n,r,N())})),C.delete(t))}(this),this._listeners.clear(),this.setMomentum(0,0),cancelAnimationFrame(this._renderID),this._observer&&this._observer.disconnect(),ht.delete(this.containerEl);for(var n=Array.from(e.childNodes);t.firstChild;)t.removeChild(t.firstChild);n.forEach((function(e){t.appendChild(e)})),U(t,{overflow:""}),t.scrollTop=this.scrollTop,t.scrollLeft=this.scrollLeft,this._plugins.forEach((function(t){t.onDestroy()})),this._plugins.length=0},t.prototype._init=function(){var t=this;this.update(),Object.keys(r).forEach((function(e){r[e](t)})),this._plugins.forEach((function(t){t.onInit()})),this._render()},t.prototype._updateDebounced=function(){this.update()},t.prototype._shouldPropagateMomentum=function(t,e){void 0===t&&(t=0),void 0===e&&(e=0);var n=this.options,r=this.offset,o=this.limit;if(!n.continuousScrolling)return!1;0===o.x&&0===o.y&&this._updateDebounced();var i=A(t+r.x,0,o.x),u=A(e+r.y,0,o.y),c=!0;return(c=(c=c&&i===r.x)&&u===r.y)&&(r.x===o.x||0===r.x||r.y===o.y||0===r.y)},t.prototype._render=function(){var t=this._momentum;if(t.x||t.y){var e=this._nextTick("x"),n=this._nextTick("y");t.x=e.momentum,t.y=n.momentum,this.setPosition(e.position,n.position)}var r=i({},this._momentum);this._plugins.forEach((function(t){t.onRender(r)})),this._renderID=requestAnimationFrame(this._render.bind(this))},t.prototype._nextTick=function(t){var e=this.options,n=this.offset,r=this._momentum,o=n[t],i=r[t];if(Math.abs(i)<=.1)return{momentum:0,position:o+i};var u=i*(1-e.damping);return e.renderByPixels&&(u|=0),{momentum:u,position:o+i-u}},u([L(100,{leading:!0})],t.prototype,"_updateDebounced",null),t}(),vt="smooth-scrollbar-style",yt=!1;function mt(){if(!yt&&"undefined"!=typeof window){var t=document.createElement("style");t.id=vt,t.textContent="\n[data-scrollbar] {\n  display: block;\n  position: relative;\n}\n\n.scroll-content {\n  display: flow-root;\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n\n.scrollbar-track {\n  position: absolute;\n  opacity: 0;\n  z-index: 1;\n  background: rgba(222, 222, 222, .75);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: opacity 0.5s 0.5s ease-out;\n          transition: opacity 0.5s 0.5s ease-out;\n}\n.scrollbar-track.show,\n.scrollbar-track:hover {\n  opacity: 1;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n\n.scrollbar-track-x {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n}\n.scrollbar-track-y {\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 100%;\n}\n.scrollbar-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 8px;\n  height: 8px;\n  background: rgba(0, 0, 0, .5);\n  border-radius: 4px;\n}\n",document.head&&document.head.appendChild(t),yt=!0}}n.d(e,"ScrollbarPlugin",(function(){return nt}));var gt=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return function(t,e){function n(){this.constructor=t}o(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}(e,t),e.init=function(t,e){if(!t||1!==t.nodeType)throw new TypeError("expect element to be DOM Element, but got "+t);return mt(),ht.has(t)?ht.get(t):new dt(t,e)},e.initAll=function(t){return Array.from(document.querySelectorAll("[data-scrollbar]"),(function(n){return e.init(n,t)}))},e.has=function(t){return ht.has(t)},e.get=function(t){return ht.get(t)},e.getAll=function(){return Array.from(ht.values())},e.destroy=function(t){var e=ht.get(t);e&&e.destroy()},e.destroyAll=function(){ht.forEach((function(t){t.destroy()}))},e.use=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];t.forEach((function(t){var e=t.pluginName;if(!e)throw new TypeError("plugin name is required");rt.order.add(e),rt.constructors[e]=t}))}.apply(void 0,t)},e.attachStyle=function(){return mt()},e.detachStyle=function(){return function(){if(yt&&"undefined"!=typeof window){var t=document.getElementById(vt);t&&t.parentNode&&(t.parentNode.removeChild(t),yt=!1)}}()},e.version="8.7.5",e.ScrollbarPlugin=nt,e}(dt);e.default=gt}]).default}));
/*==================================================
fancyBox v3.5.7

Licensed GPLv3 for open source use
or fancyBox Commercial License for commercial use

http://fancyapps.com/fancybox/
Copyright 2019 fancyApps

==================================================*/
!function(t,e,n,o){"use strict";function i(t,e){var o,i,a,s=[],r=0;t&&t.isDefaultPrevented()||(t.preventDefault(),e=e||{},t&&t.data&&(e=h(t.data.options,e)),o=e.$target||n(t.currentTarget).trigger("blur"),(a=n.fancybox.getInstance())&&a.$trigger&&a.$trigger.is(o)||(e.selector?s=n(e.selector):(i=o.attr("data-fancybox")||"",i?(s=t.data?t.data.items:[],s=s.length?s.filter('[data-fancybox="'+i+'"]'):n('[data-fancybox="'+i+'"]')):s=[o]),r=n(s).index(o),r<0&&(r=0),a=n.fancybox.open(s,e,r),a.$trigger=o))}if(t.console=t.console||{info:function(t){}},n){if(n.fn.fancybox)return void console.info("fancyBox already initialized");var a={closeExisting:!1,loop:!1,gutter:50,keyboard:!0,preventCaptionOverlap:!0,arrows:!0,infobar:!0,smallBtn:"auto",toolbar:"auto",buttons:["zoom","slideShow","thumbs","close"],idleTime:3,protect:!1,modal:!1,image:{preload:!1},ajax:{settings:{data:{fancybox:!0}}},iframe:{tpl:'<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',preload:!0,css:{},attr:{scrolling:"auto"}},video:{tpl:'<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',format:"",autoStart:!0},defaultType:"image",animationEffect:"zoom",animationDuration:366,zoomOpacity:"auto",transitionEffect:"fade",transitionDuration:366,slideClass:"",baseClass:"",baseTpl:'<div class="fancybox-container" role="dialog"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',spinnerTpl:'<div class="fancybox-loading"></div>',errorTpl:'<div class="fancybox-error"><p>{{ERROR}}</p></div>',btnTpl:{download:'<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',zoom:'<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',close:'<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',arrowLeft:'<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',arrowRight:'<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',smallBtn:'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>'},parentEl:"body",hideScrollbar:!0,autoFocus:!0,backFocus:!0,trapFocus:!0,fullScreen:{autoStart:!1},touch:{vertical:!0,momentum:!0},hash:null,media:{},slideShow:{autoStart:!1,speed:3e3},thumbs:{autoStart:!1,hideOnClose:!0,parentEl:".fancybox-container",axis:"y"},wheel:"auto",onInit:n.noop,beforeLoad:n.noop,afterLoad:n.noop,beforeShow:n.noop,afterShow:n.noop,beforeClose:n.noop,afterClose:n.noop,onActivate:n.noop,onDeactivate:n.noop,clickContent:function(t,e){return"image"===t.type&&"zoom"},clickSlide:"close",clickOutside:"close",dblclickContent:!1,dblclickSlide:!1,dblclickOutside:!1,mobile:{preventCaptionOverlap:!1,idleTime:!1,clickContent:function(t,e){return"image"===t.type&&"toggleControls"},clickSlide:function(t,e){return"image"===t.type?"toggleControls":"close"},dblclickContent:function(t,e){return"image"===t.type&&"zoom"},dblclickSlide:function(t,e){return"image"===t.type&&"zoom"}},lang:"en",i18n:{en:{CLOSE:"Close",NEXT:"Next",PREV:"Previous",ERROR:"The requested content cannot be loaded. <br/> Please try again later.",PLAY_START:"Start slideshow",PLAY_STOP:"Pause slideshow",FULL_SCREEN:"Full screen",THUMBS:"Thumbnails",DOWNLOAD:"Download",SHARE:"Share",ZOOM:"Zoom"},de:{CLOSE:"Schlie&szlig;en",NEXT:"Weiter",PREV:"Zur&uuml;ck",ERROR:"Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",PLAY_START:"Diaschau starten",PLAY_STOP:"Diaschau beenden",FULL_SCREEN:"Vollbild",THUMBS:"Vorschaubilder",DOWNLOAD:"Herunterladen",SHARE:"Teilen",ZOOM:"Vergr&ouml;&szlig;ern"}}},s=n(t),r=n(e),c=0,l=function(t){return t&&t.hasOwnProperty&&t instanceof n},d=function(){return t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.oRequestAnimationFrame||function(e){return t.setTimeout(e,1e3/60)}}(),u=function(){return t.cancelAnimationFrame||t.webkitCancelAnimationFrame||t.mozCancelAnimationFrame||t.oCancelAnimationFrame||function(e){t.clearTimeout(e)}}(),f=function(){var t,n=e.createElement("fakeelement"),o={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(t in o)if(void 0!==n.style[t])return o[t];return"transitionend"}(),p=function(t){return t&&t.length&&t[0].offsetHeight},h=function(t,e){var o=n.extend(!0,{},t,e);return n.each(e,function(t,e){n.isArray(e)&&(o[t]=e)}),o},g=function(t){var o,i;return!(!t||t.ownerDocument!==e)&&(n(".fancybox-container").css("pointer-events","none"),o={x:t.getBoundingClientRect().left+t.offsetWidth/2,y:t.getBoundingClientRect().top+t.offsetHeight/2},i=e.elementFromPoint(o.x,o.y)===t,n(".fancybox-container").css("pointer-events",""),i)},b=function(t,e,o){var i=this;i.opts=h({index:o},n.fancybox.defaults),n.isPlainObject(e)&&(i.opts=h(i.opts,e)),n.fancybox.isMobile&&(i.opts=h(i.opts,i.opts.mobile)),i.id=i.opts.id||++c,i.currIndex=parseInt(i.opts.index,10)||0,i.prevIndex=null,i.prevPos=null,i.currPos=0,i.firstRun=!0,i.group=[],i.slides={},i.addContent(t),i.group.length&&i.init()};n.extend(b.prototype,{init:function(){var o,i,a=this,s=a.group[a.currIndex],r=s.opts;r.closeExisting&&n.fancybox.close(!0),n("body").addClass("fancybox-active"),!n.fancybox.getInstance()&&!1!==r.hideScrollbar&&!n.fancybox.isMobile&&e.body.scrollHeight>t.innerHeight&&(n("head").append('<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:'+(t.innerWidth-e.documentElement.clientWidth)+"px;}</style>"),n("body").addClass("compensate-for-scrollbar")),i="",n.each(r.buttons,function(t,e){i+=r.btnTpl[e]||""}),o=n(a.translate(a,r.baseTpl.replace("{{buttons}}",i).replace("{{arrows}}",r.btnTpl.arrowLeft+r.btnTpl.arrowRight))).attr("id","fancybox-container-"+a.id).addClass(r.baseClass).data("FancyBox",a).appendTo(r.parentEl),a.$refs={container:o},["bg","inner","infobar","toolbar","stage","caption","navigation"].forEach(function(t){a.$refs[t]=o.find(".fancybox-"+t)}),a.trigger("onInit"),a.activate(),a.jumpTo(a.currIndex)},translate:function(t,e){var n=t.opts.i18n[t.opts.lang]||t.opts.i18n.en;return e.replace(/\{\{(\w+)\}\}/g,function(t,e){return void 0===n[e]?t:n[e]})},addContent:function(t){var e,o=this,i=n.makeArray(t);n.each(i,function(t,e){var i,a,s,r,c,l={},d={};n.isPlainObject(e)?(l=e,d=e.opts||e):"object"===n.type(e)&&n(e).length?(i=n(e),d=i.data()||{},d=n.extend(!0,{},d,d.options),d.$orig=i,l.src=o.opts.src||d.src||i.attr("href"),l.type||l.src||(l.type="inline",l.src=e)):l={type:"html",src:e+""},l.opts=n.extend(!0,{},o.opts,d),n.isArray(d.buttons)&&(l.opts.buttons=d.buttons),n.fancybox.isMobile&&l.opts.mobile&&(l.opts=h(l.opts,l.opts.mobile)),a=l.type||l.opts.type,r=l.src||"",!a&&r&&((s=r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))?(a="video",l.opts.video.format||(l.opts.video.format="video/"+("ogv"===s[1]?"ogg":s[1]))):r.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i)?a="image":r.match(/\.(pdf)((\?|#).*)?$/i)?(a="iframe",l=n.extend(!0,l,{contentType:"pdf",opts:{iframe:{preload:!1}}})):"#"===r.charAt(0)&&(a="inline")),a?l.type=a:o.trigger("objectNeedsType",l),l.contentType||(l.contentType=n.inArray(l.type,["html","inline","ajax"])>-1?"html":l.type),l.index=o.group.length,"auto"==l.opts.smallBtn&&(l.opts.smallBtn=n.inArray(l.type,["html","inline","ajax"])>-1),"auto"===l.opts.toolbar&&(l.opts.toolbar=!l.opts.smallBtn),l.$thumb=l.opts.$thumb||null,l.opts.$trigger&&l.index===o.opts.index&&(l.$thumb=l.opts.$trigger.find("img:first"),l.$thumb.length&&(l.opts.$orig=l.opts.$trigger)),l.$thumb&&l.$thumb.length||!l.opts.$orig||(l.$thumb=l.opts.$orig.find("img:first")),l.$thumb&&!l.$thumb.length&&(l.$thumb=null),l.thumb=l.opts.thumb||(l.$thumb?l.$thumb[0].src:null),"function"===n.type(l.opts.caption)&&(l.opts.caption=l.opts.caption.apply(e,[o,l])),"function"===n.type(o.opts.caption)&&(l.opts.caption=o.opts.caption.apply(e,[o,l])),l.opts.caption instanceof n||(l.opts.caption=void 0===l.opts.caption?"":l.opts.caption+""),"ajax"===l.type&&(c=r.split(/\s+/,2),c.length>1&&(l.src=c.shift(),l.opts.filter=c.shift())),l.opts.modal&&(l.opts=n.extend(!0,l.opts,{trapFocus:!0,infobar:0,toolbar:0,smallBtn:0,keyboard:0,slideShow:0,fullScreen:0,thumbs:0,touch:0,clickContent:!1,clickSlide:!1,clickOutside:!1,dblclickContent:!1,dblclickSlide:!1,dblclickOutside:!1})),o.group.push(l)}),Object.keys(o.slides).length&&(o.updateControls(),(e=o.Thumbs)&&e.isActive&&(e.create(),e.focus()))},addEvents:function(){var e=this;e.removeEvents(),e.$refs.container.on("click.fb-close","[data-fancybox-close]",function(t){t.stopPropagation(),t.preventDefault(),e.close(t)}).on("touchstart.fb-prev click.fb-prev","[data-fancybox-prev]",function(t){t.stopPropagation(),t.preventDefault(),e.previous()}).on("touchstart.fb-next click.fb-next","[data-fancybox-next]",function(t){t.stopPropagation(),t.preventDefault(),e.next()}).on("click.fb","[data-fancybox-zoom]",function(t){e[e.isScaledDown()?"scaleToActual":"scaleToFit"]()}),s.on("orientationchange.fb resize.fb",function(t){t&&t.originalEvent&&"resize"===t.originalEvent.type?(e.requestId&&u(e.requestId),e.requestId=d(function(){e.update(t)})):(e.current&&"iframe"===e.current.type&&e.$refs.stage.hide(),setTimeout(function(){e.$refs.stage.show(),e.update(t)},n.fancybox.isMobile?600:250))}),r.on("keydown.fb",function(t){var o=n.fancybox?n.fancybox.getInstance():null,i=o.current,a=t.keyCode||t.which;if(9==a)return void(i.opts.trapFocus&&e.focus(t));if(!(!i.opts.keyboard||t.ctrlKey||t.altKey||t.shiftKey||n(t.target).is("input,textarea,video,audio,select")))return 8===a||27===a?(t.preventDefault(),void e.close(t)):37===a||38===a?(t.preventDefault(),void e.previous()):39===a||40===a?(t.preventDefault(),void e.next()):void e.trigger("afterKeydown",t,a)}),e.group[e.currIndex].opts.idleTime&&(e.idleSecondsCounter=0,r.on("mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle",function(t){e.idleSecondsCounter=0,e.isIdle&&e.showControls(),e.isIdle=!1}),e.idleInterval=t.setInterval(function(){++e.idleSecondsCounter>=e.group[e.currIndex].opts.idleTime&&!e.isDragging&&(e.isIdle=!0,e.idleSecondsCounter=0,e.hideControls())},1e3))},removeEvents:function(){var e=this;s.off("orientationchange.fb resize.fb"),r.off("keydown.fb .fb-idle"),this.$refs.container.off(".fb-close .fb-prev .fb-next"),e.idleInterval&&(t.clearInterval(e.idleInterval),e.idleInterval=null)},previous:function(t){return this.jumpTo(this.currPos-1,t)},next:function(t){return this.jumpTo(this.currPos+1,t)},jumpTo:function(t,e){var o,i,a,s,r,c,l,d,u,f=this,h=f.group.length;if(!(f.isDragging||f.isClosing||f.isAnimating&&f.firstRun)){if(t=parseInt(t,10),!(a=f.current?f.current.opts.loop:f.opts.loop)&&(t<0||t>=h))return!1;if(o=f.firstRun=!Object.keys(f.slides).length,r=f.current,f.prevIndex=f.currIndex,f.prevPos=f.currPos,s=f.createSlide(t),h>1&&((a||s.index<h-1)&&f.createSlide(t+1),(a||s.index>0)&&f.createSlide(t-1)),f.current=s,f.currIndex=s.index,f.currPos=s.pos,f.trigger("beforeShow",o),f.updateControls(),s.forcedDuration=void 0,n.isNumeric(e)?s.forcedDuration=e:e=s.opts[o?"animationDuration":"transitionDuration"],e=parseInt(e,10),i=f.isMoved(s),s.$slide.addClass("fancybox-slide--current"),o)return s.opts.animationEffect&&e&&f.$refs.container.css("transition-duration",e+"ms"),f.$refs.container.addClass("fancybox-is-open").trigger("focus"),f.loadSlide(s),void f.preload("image");c=n.fancybox.getTranslate(r.$slide),l=n.fancybox.getTranslate(f.$refs.stage),n.each(f.slides,function(t,e){n.fancybox.stop(e.$slide,!0)}),r.pos!==s.pos&&(r.isComplete=!1),r.$slide.removeClass("fancybox-slide--complete fancybox-slide--current"),i?(u=c.left-(r.pos*c.width+r.pos*r.opts.gutter),n.each(f.slides,function(t,o){o.$slide.removeClass("fancybox-animated").removeClass(function(t,e){return(e.match(/(^|\s)fancybox-fx-\S+/g)||[]).join(" ")});var i=o.pos*c.width+o.pos*o.opts.gutter;n.fancybox.setTranslate(o.$slide,{top:0,left:i-l.left+u}),o.pos!==s.pos&&o.$slide.addClass("fancybox-slide--"+(o.pos>s.pos?"next":"previous")),p(o.$slide),n.fancybox.animate(o.$slide,{top:0,left:(o.pos-s.pos)*c.width+(o.pos-s.pos)*o.opts.gutter},e,function(){o.$slide.css({transform:"",opacity:""}).removeClass("fancybox-slide--next fancybox-slide--previous"),o.pos===f.currPos&&f.complete()})})):e&&s.opts.transitionEffect&&(d="fancybox-animated fancybox-fx-"+s.opts.transitionEffect,r.$slide.addClass("fancybox-slide--"+(r.pos>s.pos?"next":"previous")),n.fancybox.animate(r.$slide,d,e,function(){r.$slide.removeClass(d).removeClass("fancybox-slide--next fancybox-slide--previous")},!1)),s.isLoaded?f.revealContent(s):f.loadSlide(s),f.preload("image")}},createSlide:function(t){var e,o,i=this;return o=t%i.group.length,o=o<0?i.group.length+o:o,!i.slides[t]&&i.group[o]&&(e=n('<div class="fancybox-slide"></div>').appendTo(i.$refs.stage),i.slides[t]=n.extend(!0,{},i.group[o],{pos:t,$slide:e,isLoaded:!1}),i.updateSlide(i.slides[t])),i.slides[t]},scaleToActual:function(t,e,o){var i,a,s,r,c,l=this,d=l.current,u=d.$content,f=n.fancybox.getTranslate(d.$slide).width,p=n.fancybox.getTranslate(d.$slide).height,h=d.width,g=d.height;l.isAnimating||l.isMoved()||!u||"image"!=d.type||!d.isLoaded||d.hasError||(l.isAnimating=!0,n.fancybox.stop(u),t=void 0===t?.5*f:t,e=void 0===e?.5*p:e,i=n.fancybox.getTranslate(u),i.top-=n.fancybox.getTranslate(d.$slide).top,i.left-=n.fancybox.getTranslate(d.$slide).left,r=h/i.width,c=g/i.height,a=.5*f-.5*h,s=.5*p-.5*g,h>f&&(a=i.left*r-(t*r-t),a>0&&(a=0),a<f-h&&(a=f-h)),g>p&&(s=i.top*c-(e*c-e),s>0&&(s=0),s<p-g&&(s=p-g)),l.updateCursor(h,g),n.fancybox.animate(u,{top:s,left:a,scaleX:r,scaleY:c},o||366,function(){l.isAnimating=!1}),l.SlideShow&&l.SlideShow.isActive&&l.SlideShow.stop())},scaleToFit:function(t){var e,o=this,i=o.current,a=i.$content;o.isAnimating||o.isMoved()||!a||"image"!=i.type||!i.isLoaded||i.hasError||(o.isAnimating=!0,n.fancybox.stop(a),e=o.getFitPos(i),o.updateCursor(e.width,e.height),n.fancybox.animate(a,{top:e.top,left:e.left,scaleX:e.width/a.width(),scaleY:e.height/a.height()},t||366,function(){o.isAnimating=!1}))},getFitPos:function(t){var e,o,i,a,s=this,r=t.$content,c=t.$slide,l=t.width||t.opts.width,d=t.height||t.opts.height,u={};return!!(t.isLoaded&&r&&r.length)&&(e=n.fancybox.getTranslate(s.$refs.stage).width,o=n.fancybox.getTranslate(s.$refs.stage).height,e-=parseFloat(c.css("paddingLeft"))+parseFloat(c.css("paddingRight"))+parseFloat(r.css("marginLeft"))+parseFloat(r.css("marginRight")),o-=parseFloat(c.css("paddingTop"))+parseFloat(c.css("paddingBottom"))+parseFloat(r.css("marginTop"))+parseFloat(r.css("marginBottom")),l&&d||(l=e,d=o),i=Math.min(1,e/l,o/d),l*=i,d*=i,l>e-.5&&(l=e),d>o-.5&&(d=o),"image"===t.type?(u.top=Math.floor(.5*(o-d))+parseFloat(c.css("paddingTop")),u.left=Math.floor(.5*(e-l))+parseFloat(c.css("paddingLeft"))):"video"===t.contentType&&(a=t.opts.width&&t.opts.height?l/d:t.opts.ratio||16/9,d>l/a?d=l/a:l>d*a&&(l=d*a)),u.width=l,u.height=d,u)},update:function(t){var e=this;n.each(e.slides,function(n,o){e.updateSlide(o,t)})},updateSlide:function(t,e){var o=this,i=t&&t.$content,a=t.width||t.opts.width,s=t.height||t.opts.height,r=t.$slide;o.adjustCaption(t),i&&(a||s||"video"===t.contentType)&&!t.hasError&&(n.fancybox.stop(i),n.fancybox.setTranslate(i,o.getFitPos(t)),t.pos===o.currPos&&(o.isAnimating=!1,o.updateCursor())),o.adjustLayout(t),r.length&&(r.trigger("refresh"),t.pos===o.currPos&&o.$refs.toolbar.add(o.$refs.navigation.find(".fancybox-button--arrow_right")).toggleClass("compensate-for-scrollbar",r.get(0).scrollHeight>r.get(0).clientHeight)),o.trigger("onUpdate",t,e)},centerSlide:function(t){var e=this,o=e.current,i=o.$slide;!e.isClosing&&o&&(i.siblings().css({transform:"",opacity:""}),i.parent().children().removeClass("fancybox-slide--previous fancybox-slide--next"),n.fancybox.animate(i,{top:0,left:0,opacity:1},void 0===t?0:t,function(){i.css({transform:"",opacity:""}),o.isComplete||e.complete()},!1))},isMoved:function(t){var e,o,i=t||this.current;return!!i&&(o=n.fancybox.getTranslate(this.$refs.stage),e=n.fancybox.getTranslate(i.$slide),!i.$slide.hasClass("fancybox-animated")&&(Math.abs(e.top-o.top)>.5||Math.abs(e.left-o.left)>.5))},updateCursor:function(t,e){var o,i,a=this,s=a.current,r=a.$refs.container;s&&!a.isClosing&&a.Guestures&&(r.removeClass("fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan"),o=a.canPan(t,e),i=!!o||a.isZoomable(),r.toggleClass("fancybox-is-zoomable",i),n("[data-fancybox-zoom]").prop("disabled",!i),o?r.addClass("fancybox-can-pan"):i&&("zoom"===s.opts.clickContent||n.isFunction(s.opts.clickContent)&&"zoom"==s.opts.clickContent(s))?r.addClass("fancybox-can-zoomIn"):s.opts.touch&&(s.opts.touch.vertical||a.group.length>1)&&"video"!==s.contentType&&r.addClass("fancybox-can-swipe"))},isZoomable:function(){var t,e=this,n=e.current;if(n&&!e.isClosing&&"image"===n.type&&!n.hasError){if(!n.isLoaded)return!0;if((t=e.getFitPos(n))&&(n.width>t.width||n.height>t.height))return!0}return!1},isScaledDown:function(t,e){var o=this,i=!1,a=o.current,s=a.$content;return void 0!==t&&void 0!==e?i=t<a.width&&e<a.height:s&&(i=n.fancybox.getTranslate(s),i=i.width<a.width&&i.height<a.height),i},canPan:function(t,e){var o=this,i=o.current,a=null,s=!1;return"image"===i.type&&(i.isComplete||t&&e)&&!i.hasError&&(s=o.getFitPos(i),void 0!==t&&void 0!==e?a={width:t,height:e}:i.isComplete&&(a=n.fancybox.getTranslate(i.$content)),a&&s&&(s=Math.abs(a.width-s.width)>1.5||Math.abs(a.height-s.height)>1.5)),s},loadSlide:function(t){var e,o,i,a=this;if(!t.isLoading&&!t.isLoaded){if(t.isLoading=!0,!1===a.trigger("beforeLoad",t))return t.isLoading=!1,!1;switch(e=t.type,o=t.$slide,o.off("refresh").trigger("onReset").addClass(t.opts.slideClass),e){case"image":a.setImage(t);break;case"iframe":a.setIframe(t);break;case"html":a.setContent(t,t.src||t.content);break;case"video":a.setContent(t,t.opts.video.tpl.replace(/\{\{src\}\}/gi,t.src).replace("{{format}}",t.opts.videoFormat||t.opts.video.format||"").replace("{{poster}}",t.thumb||""));break;case"inline":n(t.src).length?a.setContent(t,n(t.src)):a.setError(t);break;case"ajax":a.showLoading(t),i=n.ajax(n.extend({},t.opts.ajax.settings,{url:t.src,success:function(e,n){"success"===n&&a.setContent(t,e)},error:function(e,n){e&&"abort"!==n&&a.setError(t)}})),o.one("onReset",function(){i.abort()});break;default:a.setError(t)}return!0}},setImage:function(t){var o,i=this;setTimeout(function(){var e=t.$image;i.isClosing||!t.isLoading||e&&e.length&&e[0].complete||t.hasError||i.showLoading(t)},50),i.checkSrcset(t),t.$content=n('<div class="fancybox-content"></div>').addClass("fancybox-is-hidden").appendTo(t.$slide.addClass("fancybox-slide--image")),!1!==t.opts.preload&&t.opts.width&&t.opts.height&&t.thumb&&(t.width=t.opts.width,t.height=t.opts.height,o=e.createElement("img"),o.onerror=function(){n(this).remove(),t.$ghost=null},o.onload=function(){i.afterLoad(t)},t.$ghost=n(o).addClass("fancybox-image").appendTo(t.$content).attr("src",t.thumb)),i.setBigImage(t)},checkSrcset:function(e){var n,o,i,a,s=e.opts.srcset||e.opts.image.srcset;if(s){i=t.devicePixelRatio||1,a=t.innerWidth*i,o=s.split(",").map(function(t){var e={};return t.trim().split(/\s+/).forEach(function(t,n){var o=parseInt(t.substring(0,t.length-1),10);if(0===n)return e.url=t;o&&(e.value=o,e.postfix=t[t.length-1])}),e}),o.sort(function(t,e){return t.value-e.value});for(var r=0;r<o.length;r++){var c=o[r];if("w"===c.postfix&&c.value>=a||"x"===c.postfix&&c.value>=i){n=c;break}}!n&&o.length&&(n=o[o.length-1]),n&&(e.src=n.url,e.width&&e.height&&"w"==n.postfix&&(e.height=e.width/e.height*n.value,e.width=n.value),e.opts.srcset=s)}},setBigImage:function(t){var o=this,i=e.createElement("img"),a=n(i);t.$image=a.one("error",function(){o.setError(t)}).one("load",function(){var e;t.$ghost||(o.resolveImageSlideSize(t,this.naturalWidth,this.naturalHeight),o.afterLoad(t)),o.isClosing||(t.opts.srcset&&(e=t.opts.sizes,e&&"auto"!==e||(e=(t.width/t.height>1&&s.width()/s.height()>1?"100":Math.round(t.width/t.height*100))+"vw"),a.attr("sizes",e).attr("srcset",t.opts.srcset)),t.$ghost&&setTimeout(function(){t.$ghost&&!o.isClosing&&t.$ghost.hide()},Math.min(300,Math.max(1e3,t.height/1600))),o.hideLoading(t))}).addClass("fancybox-image").attr("src",t.src).appendTo(t.$content),(i.complete||"complete"==i.readyState)&&a.naturalWidth&&a.naturalHeight?a.trigger("load"):i.error&&a.trigger("error")},resolveImageSlideSize:function(t,e,n){var o=parseInt(t.opts.width,10),i=parseInt(t.opts.height,10);t.width=e,t.height=n,o>0&&(t.width=o,t.height=Math.floor(o*n/e)),i>0&&(t.width=Math.floor(i*e/n),t.height=i)},setIframe:function(t){var e,o=this,i=t.opts.iframe,a=t.$slide;t.$content=n('<div class="fancybox-content'+(i.preload?" fancybox-is-hidden":"")+'"></div>').css(i.css).appendTo(a),a.addClass("fancybox-slide--"+t.contentType),t.$iframe=e=n(i.tpl.replace(/\{rnd\}/g,(new Date).getTime())).attr(i.attr).appendTo(t.$content),i.preload?(o.showLoading(t),e.on("load.fb error.fb",function(e){this.isReady=1,t.$slide.trigger("refresh"),o.afterLoad(t)}),a.on("refresh.fb",function(){var n,o,s=t.$content,r=i.css.width,c=i.css.height;if(1===e[0].isReady){try{n=e.contents(),o=n.find("body")}catch(t){}o&&o.length&&o.children().length&&(a.css("overflow","visible"),s.css({width:"100%","max-width":"100%",height:"9999px"}),void 0===r&&(r=Math.ceil(Math.max(o[0].clientWidth,o.outerWidth(!0)))),s.css("width",r||"").css("max-width",""),void 0===c&&(c=Math.ceil(Math.max(o[0].clientHeight,o.outerHeight(!0)))),s.css("height",c||""),a.css("overflow","auto")),s.removeClass("fancybox-is-hidden")}})):o.afterLoad(t),e.attr("src",t.src),a.one("onReset",function(){try{n(this).find("iframe").hide().unbind().attr("src","//about:blank")}catch(t){}n(this).off("refresh.fb").empty(),t.isLoaded=!1,t.isRevealed=!1})},setContent:function(t,e){var o=this;o.isClosing||(o.hideLoading(t),t.$content&&n.fancybox.stop(t.$content),t.$slide.empty(),l(e)&&e.parent().length?((e.hasClass("fancybox-content")||e.parent().hasClass("fancybox-content"))&&e.parents(".fancybox-slide").trigger("onReset"),t.$placeholder=n("<div>").hide().insertAfter(e),e.css("display","inline-block")):t.hasError||("string"===n.type(e)&&(e=n("<div>").append(n.trim(e)).contents()),t.opts.filter&&(e=n("<div>").html(e).find(t.opts.filter))),t.$slide.one("onReset",function(){n(this).find("video,audio").trigger("pause"),t.$placeholder&&(t.$placeholder.after(e.removeClass("fancybox-content").hide()).remove(),t.$placeholder=null),t.$smallBtn&&(t.$smallBtn.remove(),t.$smallBtn=null),t.hasError||(n(this).empty(),t.isLoaded=!1,t.isRevealed=!1)}),n(e).appendTo(t.$slide),n(e).is("video,audio")&&(n(e).addClass("fancybox-video"),n(e).wrap("<div></div>"),t.contentType="video",t.opts.width=t.opts.width||n(e).attr("width"),t.opts.height=t.opts.height||n(e).attr("height")),t.$content=t.$slide.children().filter("div,form,main,video,audio,article,.fancybox-content").first(),t.$content.siblings().hide(),t.$content.length||(t.$content=t.$slide.wrapInner("<div></div>").children().first()),t.$content.addClass("fancybox-content"),t.$slide.addClass("fancybox-slide--"+t.contentType),o.afterLoad(t))},setError:function(t){t.hasError=!0,t.$slide.trigger("onReset").removeClass("fancybox-slide--"+t.contentType).addClass("fancybox-slide--error"),t.contentType="html",this.setContent(t,this.translate(t,t.opts.errorTpl)),t.pos===this.currPos&&(this.isAnimating=!1)},showLoading:function(t){var e=this;(t=t||e.current)&&!t.$spinner&&(t.$spinner=n(e.translate(e,e.opts.spinnerTpl)).appendTo(t.$slide).hide().fadeIn("fast"))},hideLoading:function(t){var e=this;(t=t||e.current)&&t.$spinner&&(t.$spinner.stop().remove(),delete t.$spinner)},afterLoad:function(t){var e=this;e.isClosing||(t.isLoading=!1,t.isLoaded=!0,e.trigger("afterLoad",t),e.hideLoading(t),!t.opts.smallBtn||t.$smallBtn&&t.$smallBtn.length||(t.$smallBtn=n(e.translate(t,t.opts.btnTpl.smallBtn)).appendTo(t.$content)),t.opts.protect&&t.$content&&!t.hasError&&(t.$content.on("contextmenu.fb",function(t){return 2==t.button&&t.preventDefault(),!0}),"image"===t.type&&n('<div class="fancybox-spaceball"></div>').appendTo(t.$content)),e.adjustCaption(t),e.adjustLayout(t),t.pos===e.currPos&&e.updateCursor(),e.revealContent(t))},adjustCaption:function(t){var e,n=this,o=t||n.current,i=o.opts.caption,a=o.opts.preventCaptionOverlap,s=n.$refs.caption,r=!1;s.toggleClass("fancybox-caption--separate",a),a&&i&&i.length&&(o.pos!==n.currPos?(e=s.clone().appendTo(s.parent()),e.children().eq(0).empty().html(i),r=e.outerHeight(!0),e.empty().remove()):n.$caption&&(r=n.$caption.outerHeight(!0)),o.$slide.css("padding-bottom",r||""))},adjustLayout:function(t){var e,n,o,i,a=this,s=t||a.current;s.isLoaded&&!0!==s.opts.disableLayoutFix&&(s.$content.css("margin-bottom",""),s.$content.outerHeight()>s.$slide.height()+.5&&(o=s.$slide[0].style["padding-bottom"],i=s.$slide.css("padding-bottom"),parseFloat(i)>0&&(e=s.$slide[0].scrollHeight,s.$slide.css("padding-bottom",0),Math.abs(e-s.$slide[0].scrollHeight)<1&&(n=i),s.$slide.css("padding-bottom",o))),s.$content.css("margin-bottom",n))},revealContent:function(t){var e,o,i,a,s=this,r=t.$slide,c=!1,l=!1,d=s.isMoved(t),u=t.isRevealed;return t.isRevealed=!0,e=t.opts[s.firstRun?"animationEffect":"transitionEffect"],i=t.opts[s.firstRun?"animationDuration":"transitionDuration"],i=parseInt(void 0===t.forcedDuration?i:t.forcedDuration,10),!d&&t.pos===s.currPos&&i||(e=!1),"zoom"===e&&(t.pos===s.currPos&&i&&"image"===t.type&&!t.hasError&&(l=s.getThumbPos(t))?c=s.getFitPos(t):e="fade"),"zoom"===e?(s.isAnimating=!0,c.scaleX=c.width/l.width,c.scaleY=c.height/l.height,a=t.opts.zoomOpacity,"auto"==a&&(a=Math.abs(t.width/t.height-l.width/l.height)>.1),a&&(l.opacity=.1,c.opacity=1),n.fancybox.setTranslate(t.$content.removeClass("fancybox-is-hidden"),l),p(t.$content),void n.fancybox.animate(t.$content,c,i,function(){s.isAnimating=!1,s.complete()})):(s.updateSlide(t),e?(n.fancybox.stop(r),o="fancybox-slide--"+(t.pos>=s.prevPos?"next":"previous")+" fancybox-animated fancybox-fx-"+e,r.addClass(o).removeClass("fancybox-slide--current"),t.$content.removeClass("fancybox-is-hidden"),p(r),"image"!==t.type&&t.$content.hide().show(0),void n.fancybox.animate(r,"fancybox-slide--current",i,function(){r.removeClass(o).css({transform:"",opacity:""}),t.pos===s.currPos&&s.complete()},!0)):(t.$content.removeClass("fancybox-is-hidden"),u||!d||"image"!==t.type||t.hasError||t.$content.hide().fadeIn("fast"),void(t.pos===s.currPos&&s.complete())))},getThumbPos:function(t){var e,o,i,a,s,r=!1,c=t.$thumb;return!(!c||!g(c[0]))&&(e=n.fancybox.getTranslate(c),o=parseFloat(c.css("border-top-width")||0),i=parseFloat(c.css("border-right-width")||0),a=parseFloat(c.css("border-bottom-width")||0),s=parseFloat(c.css("border-left-width")||0),r={top:e.top+o,left:e.left+s,width:e.width-i-s,height:e.height-o-a,scaleX:1,scaleY:1},e.width>0&&e.height>0&&r)},complete:function(){var t,e=this,o=e.current,i={};!e.isMoved()&&o.isLoaded&&(o.isComplete||(o.isComplete=!0,o.$slide.siblings().trigger("onReset"),e.preload("inline"),p(o.$slide),o.$slide.addClass("fancybox-slide--complete"),n.each(e.slides,function(t,o){o.pos>=e.currPos-1&&o.pos<=e.currPos+1?i[o.pos]=o:o&&(n.fancybox.stop(o.$slide),o.$slide.off().remove())}),e.slides=i),e.isAnimating=!1,e.updateCursor(),e.trigger("afterShow"),o.opts.video.autoStart&&o.$slide.find("video,audio").filter(":visible:first").trigger("play").one("ended",function(){Document.exitFullscreen?Document.exitFullscreen():this.webkitExitFullscreen&&this.webkitExitFullscreen(),e.next()}),o.opts.autoFocus&&"html"===o.contentType&&(t=o.$content.find("input[autofocus]:enabled:visible:first"),t.length?t.trigger("focus"):e.focus(null,!0)),o.$slide.scrollTop(0).scrollLeft(0))},preload:function(t){var e,n,o=this;o.group.length<2||(n=o.slides[o.currPos+1],e=o.slides[o.currPos-1],e&&e.type===t&&o.loadSlide(e),n&&n.type===t&&o.loadSlide(n))},focus:function(t,o){var i,a,s=this,r=["a[href]","area[href]",'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',"select:not([disabled]):not([aria-hidden])","textarea:not([disabled]):not([aria-hidden])","button:not([disabled]):not([aria-hidden])","iframe","object","embed","video","audio","[contenteditable]",'[tabindex]:not([tabindex^="-"])'].join(",");s.isClosing||(i=!t&&s.current&&s.current.isComplete?s.current.$slide.find("*:visible"+(o?":not(.fancybox-close-small)":"")):s.$refs.container.find("*:visible"),i=i.filter(r).filter(function(){return"hidden"!==n(this).css("visibility")&&!n(this).hasClass("disabled")}),i.length?(a=i.index(e.activeElement),t&&t.shiftKey?(a<0||0==a)&&(t.preventDefault(),i.eq(i.length-1).trigger("focus")):(a<0||a==i.length-1)&&(t&&t.preventDefault(),i.eq(0).trigger("focus"))):s.$refs.container.trigger("focus"))},activate:function(){var t=this;n(".fancybox-container").each(function(){var e=n(this).data("FancyBox");e&&e.id!==t.id&&!e.isClosing&&(e.trigger("onDeactivate"),e.removeEvents(),e.isVisible=!1)}),t.isVisible=!0,(t.current||t.isIdle)&&(t.update(),t.updateControls()),t.trigger("onActivate"),t.addEvents()},close:function(t,e){var o,i,a,s,r,c,l,u=this,f=u.current,h=function(){u.cleanUp(t)};return!u.isClosing&&(u.isClosing=!0,!1===u.trigger("beforeClose",t)?(u.isClosing=!1,d(function(){u.update()}),!1):(u.removeEvents(),a=f.$content,o=f.opts.animationEffect,i=n.isNumeric(e)?e:o?f.opts.animationDuration:0,f.$slide.removeClass("fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"),!0!==t?n.fancybox.stop(f.$slide):o=!1,f.$slide.siblings().trigger("onReset").remove(),i&&u.$refs.container.removeClass("fancybox-is-open").addClass("fancybox-is-closing").css("transition-duration",i+"ms"),u.hideLoading(f),u.hideControls(!0),u.updateCursor(),"zoom"!==o||a&&i&&"image"===f.type&&!u.isMoved()&&!f.hasError&&(l=u.getThumbPos(f))||(o="fade"),"zoom"===o?(n.fancybox.stop(a),s=n.fancybox.getTranslate(a),c={top:s.top,left:s.left,scaleX:s.width/l.width,scaleY:s.height/l.height,width:l.width,height:l.height},r=f.opts.zoomOpacity,
"auto"==r&&(r=Math.abs(f.width/f.height-l.width/l.height)>.1),r&&(l.opacity=0),n.fancybox.setTranslate(a,c),p(a),n.fancybox.animate(a,l,i,h),!0):(o&&i?n.fancybox.animate(f.$slide.addClass("fancybox-slide--previous").removeClass("fancybox-slide--current"),"fancybox-animated fancybox-fx-"+o,i,h):!0===t?setTimeout(h,i):h(),!0)))},cleanUp:function(e){var o,i,a,s=this,r=s.current.opts.$orig;s.current.$slide.trigger("onReset"),s.$refs.container.empty().remove(),s.trigger("afterClose",e),s.current.opts.backFocus&&(r&&r.length&&r.is(":visible")||(r=s.$trigger),r&&r.length&&(i=t.scrollX,a=t.scrollY,r.trigger("focus"),n("html, body").scrollTop(a).scrollLeft(i))),s.current=null,o=n.fancybox.getInstance(),o?o.activate():(n("body").removeClass("fancybox-active compensate-for-scrollbar"),n("#fancybox-style-noscroll").remove())},trigger:function(t,e){var o,i=Array.prototype.slice.call(arguments,1),a=this,s=e&&e.opts?e:a.current;if(s?i.unshift(s):s=a,i.unshift(a),n.isFunction(s.opts[t])&&(o=s.opts[t].apply(s,i)),!1===o)return o;"afterClose"!==t&&a.$refs?a.$refs.container.trigger(t+".fb",i):r.trigger(t+".fb",i)},updateControls:function(){var t=this,o=t.current,i=o.index,a=t.$refs.container,s=t.$refs.caption,r=o.opts.caption;o.$slide.trigger("refresh"),r&&r.length?(t.$caption=s,s.children().eq(0).html(r)):t.$caption=null,t.hasHiddenControls||t.isIdle||t.showControls(),a.find("[data-fancybox-count]").html(t.group.length),a.find("[data-fancybox-index]").html(i+1),a.find("[data-fancybox-prev]").prop("disabled",!o.opts.loop&&i<=0),a.find("[data-fancybox-next]").prop("disabled",!o.opts.loop&&i>=t.group.length-1),"image"===o.type?a.find("[data-fancybox-zoom]").show().end().find("[data-fancybox-download]").attr("href",o.opts.image.src||o.src).show():o.opts.toolbar&&a.find("[data-fancybox-download],[data-fancybox-zoom]").hide(),n(e.activeElement).is(":hidden,[disabled]")&&t.$refs.container.trigger("focus")},hideControls:function(t){var e=this,n=["infobar","toolbar","nav"];!t&&e.current.opts.preventCaptionOverlap||n.push("caption"),this.$refs.container.removeClass(n.map(function(t){return"fancybox-show-"+t}).join(" ")),this.hasHiddenControls=!0},showControls:function(){var t=this,e=t.current?t.current.opts:t.opts,n=t.$refs.container;t.hasHiddenControls=!1,t.idleSecondsCounter=0,n.toggleClass("fancybox-show-toolbar",!(!e.toolbar||!e.buttons)).toggleClass("fancybox-show-infobar",!!(e.infobar&&t.group.length>1)).toggleClass("fancybox-show-caption",!!t.$caption).toggleClass("fancybox-show-nav",!!(e.arrows&&t.group.length>1)).toggleClass("fancybox-is-modal",!!e.modal)},toggleControls:function(){this.hasHiddenControls?this.showControls():this.hideControls()}}),n.fancybox={version:"3.5.7",defaults:a,getInstance:function(t){var e=n('.fancybox-container:not(".fancybox-is-closing"):last').data("FancyBox"),o=Array.prototype.slice.call(arguments,1);return e instanceof b&&("string"===n.type(t)?e[t].apply(e,o):"function"===n.type(t)&&t.apply(e,o),e)},open:function(t,e,n){return new b(t,e,n)},close:function(t){var e=this.getInstance();e&&(e.close(),!0===t&&this.close(t))},destroy:function(){this.close(!0),r.add("body").off("click.fb-start","**")},isMobile:/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),use3d:function(){var n=e.createElement("div");return t.getComputedStyle&&t.getComputedStyle(n)&&t.getComputedStyle(n).getPropertyValue("transform")&&!(e.documentMode&&e.documentMode<11)}(),getTranslate:function(t){var e;return!(!t||!t.length)&&(e=t[0].getBoundingClientRect(),{top:e.top||0,left:e.left||0,width:e.width,height:e.height,opacity:parseFloat(t.css("opacity"))})},setTranslate:function(t,e){var n="",o={};if(t&&e)return void 0===e.left&&void 0===e.top||(n=(void 0===e.left?t.position().left:e.left)+"px, "+(void 0===e.top?t.position().top:e.top)+"px",n=this.use3d?"translate3d("+n+", 0px)":"translate("+n+")"),void 0!==e.scaleX&&void 0!==e.scaleY?n+=" scale("+e.scaleX+", "+e.scaleY+")":void 0!==e.scaleX&&(n+=" scaleX("+e.scaleX+")"),n.length&&(o.transform=n),void 0!==e.opacity&&(o.opacity=e.opacity),void 0!==e.width&&(o.width=e.width),void 0!==e.height&&(o.height=e.height),t.css(o)},animate:function(t,e,o,i,a){var s,r=this;n.isFunction(o)&&(i=o,o=null),r.stop(t),s=r.getTranslate(t),t.on(f,function(c){(!c||!c.originalEvent||t.is(c.originalEvent.target)&&"z-index"!=c.originalEvent.propertyName)&&(r.stop(t),n.isNumeric(o)&&t.css("transition-duration",""),n.isPlainObject(e)?void 0!==e.scaleX&&void 0!==e.scaleY&&r.setTranslate(t,{top:e.top,left:e.left,width:s.width*e.scaleX,height:s.height*e.scaleY,scaleX:1,scaleY:1}):!0!==a&&t.removeClass(e),n.isFunction(i)&&i(c))}),n.isNumeric(o)&&t.css("transition-duration",o+"ms"),n.isPlainObject(e)?(void 0!==e.scaleX&&void 0!==e.scaleY&&(delete e.width,delete e.height,t.parent().hasClass("fancybox-slide--image")&&t.parent().addClass("fancybox-is-scaling")),n.fancybox.setTranslate(t,e)):t.addClass(e),t.data("timer",setTimeout(function(){t.trigger(f)},o+33))},stop:function(t,e){t&&t.length&&(clearTimeout(t.data("timer")),e&&t.trigger(f),t.off(f).css("transition-duration",""),t.parent().removeClass("fancybox-is-scaling"))}},n.fn.fancybox=function(t){var e;return t=t||{},e=t.selector||!1,e?n("body").off("click.fb-start",e).on("click.fb-start",e,{options:t},i):this.off("click.fb-start").on("click.fb-start",{items:this,options:t},i),this},r.on("click.fb-start","[data-fancybox]",i),r.on("click.fb-start","[data-fancybox-trigger]",function(t){n('[data-fancybox="'+n(this).attr("data-fancybox-trigger")+'"]').eq(n(this).attr("data-fancybox-index")||0).trigger("click.fb-start",{$trigger:n(this)})}),function(){var t=null;r.on("mousedown mouseup focus blur",".fancybox-button",function(e){switch(e.type){case"mousedown":t=n(this);break;case"mouseup":t=null;break;case"focusin":n(".fancybox-button").removeClass("fancybox-focus"),n(this).is(t)||n(this).is("[disabled]")||n(this).addClass("fancybox-focus");break;case"focusout":n(".fancybox-button").removeClass("fancybox-focus")}})}()}}(window,document,jQuery),function(t){"use strict";var e={youtube:{matcher:/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,params:{autoplay:1,autohide:1,fs:1,rel:0,hd:1,wmode:"transparent",enablejsapi:1,html5:1},paramPlace:8,type:"iframe",url:"https://www.youtube-nocookie.com/embed/$4",thumb:"https://img.youtube.com/vi/$4/hqdefault.jpg"},vimeo:{matcher:/^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,params:{autoplay:1,hd:1,show_title:1,show_byline:1,show_portrait:0,fullscreen:1},paramPlace:3,type:"iframe",url:"//player.vimeo.com/video/$2"},instagram:{matcher:/(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,type:"image",url:"//$1/p/$2/media/?size=l"},gmap_place:{matcher:/(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,type:"iframe",url:function(t){return"//maps.google."+t[2]+"/?ll="+(t[9]?t[9]+"&z="+Math.floor(t[10])+(t[12]?t[12].replace(/^\//,"&"):""):t[12]+"").replace(/\?/,"&")+"&output="+(t[12]&&t[12].indexOf("layer=c")>0?"svembed":"embed")}},gmap_search:{matcher:/(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,type:"iframe",url:function(t){return"//maps.google."+t[2]+"/maps?q="+t[5].replace("query=","q=").replace("api=1","")+"&output=embed"}}},n=function(e,n,o){if(e)return o=o||"","object"===t.type(o)&&(o=t.param(o,!0)),t.each(n,function(t,n){e=e.replace("$"+t,n||"")}),o.length&&(e+=(e.indexOf("?")>0?"&":"?")+o),e};t(document).on("objectNeedsType.fb",function(o,i,a){var s,r,c,l,d,u,f,p=a.src||"",h=!1;s=t.extend(!0,{},e,a.opts.media),t.each(s,function(e,o){if(c=p.match(o.matcher)){if(h=o.type,f=e,u={},o.paramPlace&&c[o.paramPlace]){d=c[o.paramPlace],"?"==d[0]&&(d=d.substring(1)),d=d.split("&");for(var i=0;i<d.length;++i){var s=d[i].split("=",2);2==s.length&&(u[s[0]]=decodeURIComponent(s[1].replace(/\+/g," ")))}}return l=t.extend(!0,{},o.params,a.opts[e],u),p="function"===t.type(o.url)?o.url.call(this,c,l,a):n(o.url,c,l),r="function"===t.type(o.thumb)?o.thumb.call(this,c,l,a):n(o.thumb,c),"youtube"===e?p=p.replace(/&t=((\d+)m)?(\d+)s/,function(t,e,n,o){return"&start="+((n?60*parseInt(n,10):0)+parseInt(o,10))}):"vimeo"===e&&(p=p.replace("&%23","#")),!1}}),h?(a.opts.thumb||a.opts.$thumb&&a.opts.$thumb.length||(a.opts.thumb=r),"iframe"===h&&(a.opts=t.extend(!0,a.opts,{iframe:{preload:!1,attr:{scrolling:"no"}}})),t.extend(a,{type:h,src:p,origSrc:a.src,contentSource:f,contentType:"image"===h?"image":"gmap_place"==f||"gmap_search"==f?"map":"video"})):p&&(a.type=a.opts.defaultType)});var o={youtube:{src:"https://www.youtube.com/iframe_api",class:"YT",loading:!1,loaded:!1},vimeo:{src:"https://player.vimeo.com/api/player.js",class:"Vimeo",loading:!1,loaded:!1},load:function(t){var e,n=this;if(this[t].loaded)return void setTimeout(function(){n.done(t)});this[t].loading||(this[t].loading=!0,e=document.createElement("script"),e.type="text/javascript",e.src=this[t].src,"youtube"===t?window.onYouTubeIframeAPIReady=function(){n[t].loaded=!0,n.done(t)}:e.onload=function(){n[t].loaded=!0,n.done(t)},document.body.appendChild(e))},done:function(e){var n,o,i;"youtube"===e&&delete window.onYouTubeIframeAPIReady,(n=t.fancybox.getInstance())&&(o=n.current.$content.find("iframe"),"youtube"===e&&void 0!==YT&&YT?i=new YT.Player(o.attr("id"),{events:{onStateChange:function(t){0==t.data&&n.next()}}}):"vimeo"===e&&void 0!==Vimeo&&Vimeo&&(i=new Vimeo.Player(o),i.on("ended",function(){n.next()})))}};t(document).on({"afterShow.fb":function(t,e,n){e.group.length>1&&("youtube"===n.contentSource||"vimeo"===n.contentSource)&&o.load(n.contentSource)}})}(jQuery),function(t,e,n){"use strict";var o=function(){return t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.oRequestAnimationFrame||function(e){return t.setTimeout(e,1e3/60)}}(),i=function(){return t.cancelAnimationFrame||t.webkitCancelAnimationFrame||t.mozCancelAnimationFrame||t.oCancelAnimationFrame||function(e){t.clearTimeout(e)}}(),a=function(e){var n=[];e=e.originalEvent||e||t.e,e=e.touches&&e.touches.length?e.touches:e.changedTouches&&e.changedTouches.length?e.changedTouches:[e];for(var o in e)e[o].pageX?n.push({x:e[o].pageX,y:e[o].pageY}):e[o].clientX&&n.push({x:e[o].clientX,y:e[o].clientY});return n},s=function(t,e,n){return e&&t?"x"===n?t.x-e.x:"y"===n?t.y-e.y:Math.sqrt(Math.pow(t.x-e.x,2)+Math.pow(t.y-e.y,2)):0},r=function(t){if(t.is('a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe')||n.isFunction(t.get(0).onclick)||t.data("selectable"))return!0;for(var e=0,o=t[0].attributes,i=o.length;e<i;e++)if("data-fancybox-"===o[e].nodeName.substr(0,14))return!0;return!1},c=function(e){var n=t.getComputedStyle(e)["overflow-y"],o=t.getComputedStyle(e)["overflow-x"],i=("scroll"===n||"auto"===n)&&e.scrollHeight>e.clientHeight,a=("scroll"===o||"auto"===o)&&e.scrollWidth>e.clientWidth;return i||a},l=function(t){for(var e=!1;;){if(e=c(t.get(0)))break;if(t=t.parent(),!t.length||t.hasClass("fancybox-stage")||t.is("body"))break}return e},d=function(t){var e=this;e.instance=t,e.$bg=t.$refs.bg,e.$stage=t.$refs.stage,e.$container=t.$refs.container,e.destroy(),e.$container.on("touchstart.fb.touch mousedown.fb.touch",n.proxy(e,"ontouchstart"))};d.prototype.destroy=function(){var t=this;t.$container.off(".fb.touch"),n(e).off(".fb.touch"),t.requestId&&(i(t.requestId),t.requestId=null),t.tapped&&(clearTimeout(t.tapped),t.tapped=null)},d.prototype.ontouchstart=function(o){var i=this,c=n(o.target),d=i.instance,u=d.current,f=u.$slide,p=u.$content,h="touchstart"==o.type;if(h&&i.$container.off("mousedown.fb.touch"),(!o.originalEvent||2!=o.originalEvent.button)&&f.length&&c.length&&!r(c)&&!r(c.parent())&&(c.is("img")||!(o.originalEvent.clientX>c[0].clientWidth+c.offset().left))){if(!u||d.isAnimating||u.$slide.hasClass("fancybox-animated"))return o.stopPropagation(),void o.preventDefault();i.realPoints=i.startPoints=a(o),i.startPoints.length&&(u.touch&&o.stopPropagation(),i.startEvent=o,i.canTap=!0,i.$target=c,i.$content=p,i.opts=u.opts.touch,i.isPanning=!1,i.isSwiping=!1,i.isZooming=!1,i.isScrolling=!1,i.canPan=d.canPan(),i.startTime=(new Date).getTime(),i.distanceX=i.distanceY=i.distance=0,i.canvasWidth=Math.round(f[0].clientWidth),i.canvasHeight=Math.round(f[0].clientHeight),i.contentLastPos=null,i.contentStartPos=n.fancybox.getTranslate(i.$content)||{top:0,left:0},i.sliderStartPos=n.fancybox.getTranslate(f),i.stagePos=n.fancybox.getTranslate(d.$refs.stage),i.sliderStartPos.top-=i.stagePos.top,i.sliderStartPos.left-=i.stagePos.left,i.contentStartPos.top-=i.stagePos.top,i.contentStartPos.left-=i.stagePos.left,n(e).off(".fb.touch").on(h?"touchend.fb.touch touchcancel.fb.touch":"mouseup.fb.touch mouseleave.fb.touch",n.proxy(i,"ontouchend")).on(h?"touchmove.fb.touch":"mousemove.fb.touch",n.proxy(i,"ontouchmove")),n.fancybox.isMobile&&e.addEventListener("scroll",i.onscroll,!0),((i.opts||i.canPan)&&(c.is(i.$stage)||i.$stage.find(c).length)||(c.is(".fancybox-image")&&o.preventDefault(),n.fancybox.isMobile&&c.parents(".fancybox-caption").length))&&(i.isScrollable=l(c)||l(c.parent()),n.fancybox.isMobile&&i.isScrollable||o.preventDefault(),(1===i.startPoints.length||u.hasError)&&(i.canPan?(n.fancybox.stop(i.$content),i.isPanning=!0):i.isSwiping=!0,i.$container.addClass("fancybox-is-grabbing")),2===i.startPoints.length&&"image"===u.type&&(u.isLoaded||u.$ghost)&&(i.canTap=!1,i.isSwiping=!1,i.isPanning=!1,i.isZooming=!0,n.fancybox.stop(i.$content),i.centerPointStartX=.5*(i.startPoints[0].x+i.startPoints[1].x)-n(t).scrollLeft(),i.centerPointStartY=.5*(i.startPoints[0].y+i.startPoints[1].y)-n(t).scrollTop(),i.percentageOfImageAtPinchPointX=(i.centerPointStartX-i.contentStartPos.left)/i.contentStartPos.width,i.percentageOfImageAtPinchPointY=(i.centerPointStartY-i.contentStartPos.top)/i.contentStartPos.height,i.startDistanceBetweenFingers=s(i.startPoints[0],i.startPoints[1]))))}},d.prototype.onscroll=function(t){var n=this;n.isScrolling=!0,e.removeEventListener("scroll",n.onscroll,!0)},d.prototype.ontouchmove=function(t){var e=this;return void 0!==t.originalEvent.buttons&&0===t.originalEvent.buttons?void e.ontouchend(t):e.isScrolling?void(e.canTap=!1):(e.newPoints=a(t),void((e.opts||e.canPan)&&e.newPoints.length&&e.newPoints.length&&(e.isSwiping&&!0===e.isSwiping||t.preventDefault(),e.distanceX=s(e.newPoints[0],e.startPoints[0],"x"),e.distanceY=s(e.newPoints[0],e.startPoints[0],"y"),e.distance=s(e.newPoints[0],e.startPoints[0]),e.distance>0&&(e.isSwiping?e.onSwipe(t):e.isPanning?e.onPan():e.isZooming&&e.onZoom()))))},d.prototype.onSwipe=function(e){var a,s=this,r=s.instance,c=s.isSwiping,l=s.sliderStartPos.left||0;if(!0!==c)"x"==c&&(s.distanceX>0&&(s.instance.group.length<2||0===s.instance.current.index&&!s.instance.current.opts.loop)?l+=Math.pow(s.distanceX,.8):s.distanceX<0&&(s.instance.group.length<2||s.instance.current.index===s.instance.group.length-1&&!s.instance.current.opts.loop)?l-=Math.pow(-s.distanceX,.8):l+=s.distanceX),s.sliderLastPos={top:"x"==c?0:s.sliderStartPos.top+s.distanceY,left:l},s.requestId&&(i(s.requestId),s.requestId=null),s.requestId=o(function(){s.sliderLastPos&&(n.each(s.instance.slides,function(t,e){var o=e.pos-s.instance.currPos;n.fancybox.setTranslate(e.$slide,{top:s.sliderLastPos.top,left:s.sliderLastPos.left+o*s.canvasWidth+o*e.opts.gutter})}),s.$container.addClass("fancybox-is-sliding"))});else if(Math.abs(s.distance)>10){if(s.canTap=!1,r.group.length<2&&s.opts.vertical?s.isSwiping="y":r.isDragging||!1===s.opts.vertical||"auto"===s.opts.vertical&&n(t).width()>800?s.isSwiping="x":(a=Math.abs(180*Math.atan2(s.distanceY,s.distanceX)/Math.PI),s.isSwiping=a>45&&a<135?"y":"x"),"y"===s.isSwiping&&n.fancybox.isMobile&&s.isScrollable)return void(s.isScrolling=!0);r.isDragging=s.isSwiping,s.startPoints=s.newPoints,n.each(r.slides,function(t,e){var o,i;n.fancybox.stop(e.$slide),o=n.fancybox.getTranslate(e.$slide),i=n.fancybox.getTranslate(r.$refs.stage),e.$slide.css({transform:"",opacity:"","transition-duration":""}).removeClass("fancybox-animated").removeClass(function(t,e){return(e.match(/(^|\s)fancybox-fx-\S+/g)||[]).join(" ")}),e.pos===r.current.pos&&(s.sliderStartPos.top=o.top-i.top,s.sliderStartPos.left=o.left-i.left),n.fancybox.setTranslate(e.$slide,{top:o.top-i.top,left:o.left-i.left})}),r.SlideShow&&r.SlideShow.isActive&&r.SlideShow.stop()}},d.prototype.onPan=function(){var t=this;if(s(t.newPoints[0],t.realPoints[0])<(n.fancybox.isMobile?10:5))return void(t.startPoints=t.newPoints);t.canTap=!1,t.contentLastPos=t.limitMovement(),t.requestId&&i(t.requestId),t.requestId=o(function(){n.fancybox.setTranslate(t.$content,t.contentLastPos)})},d.prototype.limitMovement=function(){var t,e,n,o,i,a,s=this,r=s.canvasWidth,c=s.canvasHeight,l=s.distanceX,d=s.distanceY,u=s.contentStartPos,f=u.left,p=u.top,h=u.width,g=u.height;return i=h>r?f+l:f,a=p+d,t=Math.max(0,.5*r-.5*h),e=Math.max(0,.5*c-.5*g),n=Math.min(r-h,.5*r-.5*h),o=Math.min(c-g,.5*c-.5*g),l>0&&i>t&&(i=t-1+Math.pow(-t+f+l,.8)||0),l<0&&i<n&&(i=n+1-Math.pow(n-f-l,.8)||0),d>0&&a>e&&(a=e-1+Math.pow(-e+p+d,.8)||0),d<0&&a<o&&(a=o+1-Math.pow(o-p-d,.8)||0),{top:a,left:i}},d.prototype.limitPosition=function(t,e,n,o){var i=this,a=i.canvasWidth,s=i.canvasHeight;return n>a?(t=t>0?0:t,t=t<a-n?a-n:t):t=Math.max(0,a/2-n/2),o>s?(e=e>0?0:e,e=e<s-o?s-o:e):e=Math.max(0,s/2-o/2),{top:e,left:t}},d.prototype.onZoom=function(){var e=this,a=e.contentStartPos,r=a.width,c=a.height,l=a.left,d=a.top,u=s(e.newPoints[0],e.newPoints[1]),f=u/e.startDistanceBetweenFingers,p=Math.floor(r*f),h=Math.floor(c*f),g=(r-p)*e.percentageOfImageAtPinchPointX,b=(c-h)*e.percentageOfImageAtPinchPointY,m=(e.newPoints[0].x+e.newPoints[1].x)/2-n(t).scrollLeft(),v=(e.newPoints[0].y+e.newPoints[1].y)/2-n(t).scrollTop(),y=m-e.centerPointStartX,x=v-e.centerPointStartY,w=l+(g+y),$=d+(b+x),S={top:$,left:w,scaleX:f,scaleY:f};e.canTap=!1,e.newWidth=p,e.newHeight=h,e.contentLastPos=S,e.requestId&&i(e.requestId),e.requestId=o(function(){n.fancybox.setTranslate(e.$content,e.contentLastPos)})},d.prototype.ontouchend=function(t){var o=this,s=o.isSwiping,r=o.isPanning,c=o.isZooming,l=o.isScrolling;if(o.endPoints=a(t),o.dMs=Math.max((new Date).getTime()-o.startTime,1),o.$container.removeClass("fancybox-is-grabbing"),n(e).off(".fb.touch"),e.removeEventListener("scroll",o.onscroll,!0),o.requestId&&(i(o.requestId),o.requestId=null),o.isSwiping=!1,o.isPanning=!1,o.isZooming=!1,o.isScrolling=!1,o.instance.isDragging=!1,o.canTap)return o.onTap(t);o.speed=100,o.velocityX=o.distanceX/o.dMs*.5,o.velocityY=o.distanceY/o.dMs*.5,r?o.endPanning():c?o.endZooming():o.endSwiping(s,l)},d.prototype.endSwiping=function(t,e){var o=this,i=!1,a=o.instance.group.length,s=Math.abs(o.distanceX),r="x"==t&&a>1&&(o.dMs>130&&s>10||s>50);o.sliderLastPos=null,"y"==t&&!e&&Math.abs(o.distanceY)>50?(n.fancybox.animate(o.instance.current.$slide,{top:o.sliderStartPos.top+o.distanceY+150*o.velocityY,opacity:0},200),i=o.instance.close(!0,250)):r&&o.distanceX>0?i=o.instance.previous(300):r&&o.distanceX<0&&(i=o.instance.next(300)),!1!==i||"x"!=t&&"y"!=t||o.instance.centerSlide(200),o.$container.removeClass("fancybox-is-sliding")},d.prototype.endPanning=function(){var t,e,o,i=this;i.contentLastPos&&(!1===i.opts.momentum||i.dMs>350?(t=i.contentLastPos.left,e=i.contentLastPos.top):(t=i.contentLastPos.left+500*i.velocityX,e=i.contentLastPos.top+500*i.velocityY),o=i.limitPosition(t,e,i.contentStartPos.width,i.contentStartPos.height),o.width=i.contentStartPos.width,o.height=i.contentStartPos.height,n.fancybox.animate(i.$content,o,366))},d.prototype.endZooming=function(){var t,e,o,i,a=this,s=a.instance.current,r=a.newWidth,c=a.newHeight;a.contentLastPos&&(t=a.contentLastPos.left,e=a.contentLastPos.top,i={top:e,left:t,width:r,height:c,scaleX:1,scaleY:1},n.fancybox.setTranslate(a.$content,i),r<a.canvasWidth&&c<a.canvasHeight?a.instance.scaleToFit(150):r>s.width||c>s.height?a.instance.scaleToActual(a.centerPointStartX,a.centerPointStartY,150):(o=a.limitPosition(t,e,r,c),n.fancybox.animate(a.$content,o,150)))},d.prototype.onTap=function(e){var o,i=this,s=n(e.target),r=i.instance,c=r.current,l=e&&a(e)||i.startPoints,d=l[0]?l[0].x-n(t).scrollLeft()-i.stagePos.left:0,u=l[0]?l[0].y-n(t).scrollTop()-i.stagePos.top:0,f=function(t){var o=c.opts[t];if(n.isFunction(o)&&(o=o.apply(r,[c,e])),o)switch(o){case"close":r.close(i.startEvent);break;case"toggleControls":r.toggleControls();break;case"next":r.next();break;case"nextOrClose":r.group.length>1?r.next():r.close(i.startEvent);break;case"zoom":"image"==c.type&&(c.isLoaded||c.$ghost)&&(r.canPan()?r.scaleToFit():r.isScaledDown()?r.scaleToActual(d,u):r.group.length<2&&r.close(i.startEvent))}};if((!e.originalEvent||2!=e.originalEvent.button)&&(s.is("img")||!(d>s[0].clientWidth+s.offset().left))){if(s.is(".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container"))o="Outside";else if(s.is(".fancybox-slide"))o="Slide";else{if(!r.current.$content||!r.current.$content.find(s).addBack().filter(s).length)return;o="Content"}if(i.tapped){if(clearTimeout(i.tapped),i.tapped=null,Math.abs(d-i.tapX)>50||Math.abs(u-i.tapY)>50)return this;f("dblclick"+o)}else i.tapX=d,i.tapY=u,c.opts["dblclick"+o]&&c.opts["dblclick"+o]!==c.opts["click"+o]?i.tapped=setTimeout(function(){i.tapped=null,r.isAnimating||f("click"+o)},500):f("click"+o);return this}},n(e).on("onActivate.fb",function(t,e){e&&!e.Guestures&&(e.Guestures=new d(e))}).on("beforeClose.fb",function(t,e){e&&e.Guestures&&e.Guestures.destroy()})}(window,document,jQuery),function(t,e){"use strict";e.extend(!0,e.fancybox.defaults,{btnTpl:{slideShow:'<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>'},slideShow:{autoStart:!1,speed:3e3,progress:!0}});var n=function(t){this.instance=t,this.init()};e.extend(n.prototype,{timer:null,isActive:!1,$button:null,init:function(){var t=this,n=t.instance,o=n.group[n.currIndex].opts.slideShow;t.$button=n.$refs.toolbar.find("[data-fancybox-play]").on("click",function(){t.toggle()}),n.group.length<2||!o?t.$button.hide():o.progress&&(t.$progress=e('<div class="fancybox-progress"></div>').appendTo(n.$refs.inner))},set:function(t){var n=this,o=n.instance,i=o.current;i&&(!0===t||i.opts.loop||o.currIndex<o.group.length-1)?n.isActive&&"video"!==i.contentType&&(n.$progress&&e.fancybox.animate(n.$progress.show(),{scaleX:1},i.opts.slideShow.speed),n.timer=setTimeout(function(){o.current.opts.loop||o.current.index!=o.group.length-1?o.next():o.jumpTo(0)},i.opts.slideShow.speed)):(n.stop(),o.idleSecondsCounter=0,o.showControls())},clear:function(){var t=this;clearTimeout(t.timer),t.timer=null,t.$progress&&t.$progress.removeAttr("style").hide()},start:function(){var t=this,e=t.instance.current;e&&(t.$button.attr("title",(e.opts.i18n[e.opts.lang]||e.opts.i18n.en).PLAY_STOP).removeClass("fancybox-button--play").addClass("fancybox-button--pause"),t.isActive=!0,e.isComplete&&t.set(!0),t.instance.trigger("onSlideShowChange",!0))},stop:function(){var t=this,e=t.instance.current;t.clear(),t.$button.attr("title",(e.opts.i18n[e.opts.lang]||e.opts.i18n.en).PLAY_START).removeClass("fancybox-button--pause").addClass("fancybox-button--play"),t.isActive=!1,t.instance.trigger("onSlideShowChange",!1),t.$progress&&t.$progress.removeAttr("style").hide()},toggle:function(){var t=this;t.isActive?t.stop():t.start()}}),e(t).on({"onInit.fb":function(t,e){e&&!e.SlideShow&&(e.SlideShow=new n(e))},"beforeShow.fb":function(t,e,n,o){var i=e&&e.SlideShow;o?i&&n.opts.slideShow.autoStart&&i.start():i&&i.isActive&&i.clear()},"afterShow.fb":function(t,e,n){var o=e&&e.SlideShow;o&&o.isActive&&o.set()},"afterKeydown.fb":function(n,o,i,a,s){var r=o&&o.SlideShow;!r||!i.opts.slideShow||80!==s&&32!==s||e(t.activeElement).is("button,a,input")||(a.preventDefault(),r.toggle())},"beforeClose.fb onDeactivate.fb":function(t,e){var n=e&&e.SlideShow;n&&n.stop()}}),e(t).on("visibilitychange",function(){var n=e.fancybox.getInstance(),o=n&&n.SlideShow;o&&o.isActive&&(t.hidden?o.clear():o.set())})}(document,jQuery),function(t,e){"use strict";var n=function(){for(var e=[["requestFullscreen","exitFullscreen","fullscreenElement","fullscreenEnabled","fullscreenchange","fullscreenerror"],["webkitRequestFullscreen","webkitExitFullscreen","webkitFullscreenElement","webkitFullscreenEnabled","webkitfullscreenchange","webkitfullscreenerror"],["webkitRequestFullScreen","webkitCancelFullScreen","webkitCurrentFullScreenElement","webkitCancelFullScreen","webkitfullscreenchange","webkitfullscreenerror"],["mozRequestFullScreen","mozCancelFullScreen","mozFullScreenElement","mozFullScreenEnabled","mozfullscreenchange","mozfullscreenerror"],["msRequestFullscreen","msExitFullscreen","msFullscreenElement","msFullscreenEnabled","MSFullscreenChange","MSFullscreenError"]],n={},o=0;o<e.length;o++){var i=e[o];if(i&&i[1]in t){for(var a=0;a<i.length;a++)n[e[0][a]]=i[a];return n}}return!1}();if(n){var o={request:function(e){e=e||t.documentElement,e[n.requestFullscreen](e.ALLOW_KEYBOARD_INPUT)},exit:function(){t[n.exitFullscreen]()},toggle:function(e){e=e||t.documentElement,this.isFullscreen()?this.exit():this.request(e)},isFullscreen:function(){return Boolean(t[n.fullscreenElement])},enabled:function(){return Boolean(t[n.fullscreenEnabled])}};e.extend(!0,e.fancybox.defaults,{btnTpl:{fullScreen:'<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>'},fullScreen:{autoStart:!1}}),e(t).on(n.fullscreenchange,function(){var t=o.isFullscreen(),n=e.fancybox.getInstance();n&&(n.current&&"image"===n.current.type&&n.isAnimating&&(n.isAnimating=!1,n.update(!0,!0,0),n.isComplete||n.complete()),n.trigger("onFullscreenChange",t),n.$refs.container.toggleClass("fancybox-is-fullscreen",t),n.$refs.toolbar.find("[data-fancybox-fullscreen]").toggleClass("fancybox-button--fsenter",!t).toggleClass("fancybox-button--fsexit",t))})}e(t).on({"onInit.fb":function(t,e){var i;if(!n)return void e.$refs.toolbar.find("[data-fancybox-fullscreen]").remove();e&&e.group[e.currIndex].opts.fullScreen?(i=e.$refs.container,i.on("click.fb-fullscreen","[data-fancybox-fullscreen]",function(t){t.stopPropagation(),t.preventDefault(),o.toggle()}),e.opts.fullScreen&&!0===e.opts.fullScreen.autoStart&&o.request(),e.FullScreen=o):e&&e.$refs.toolbar.find("[data-fancybox-fullscreen]").hide()},"afterKeydown.fb":function(t,e,n,o,i){e&&e.FullScreen&&70===i&&(o.preventDefault(),e.FullScreen.toggle())},"beforeClose.fb":function(t,e){e&&e.FullScreen&&e.$refs.container.hasClass("fancybox-is-fullscreen")&&o.exit()}})}(document,jQuery),function(t,e){"use strict";var n="fancybox-thumbs";e.fancybox.defaults=e.extend(!0,{btnTpl:{thumbs:'<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>'},thumbs:{autoStart:!1,hideOnClose:!0,parentEl:".fancybox-container",axis:"y"}},e.fancybox.defaults);var o=function(t){this.init(t)};e.extend(o.prototype,{$button:null,$grid:null,$list:null,isVisible:!1,isActive:!1,init:function(t){var e=this,n=t.group,o=0;e.instance=t,e.opts=n[t.currIndex].opts.thumbs,t.Thumbs=e,e.$button=t.$refs.toolbar.find("[data-fancybox-thumbs]");for(var i=0,a=n.length;i<a&&(n[i].thumb&&o++,!(o>1));i++);o>1&&e.opts?(e.$button.removeAttr("style").on("click",function(){e.toggle()}),e.isActive=!0):e.$button.hide()},create:function(){var t,o=this,i=o.instance,a=o.opts.parentEl,s=[];o.$grid||(o.$grid=e('<div class="'+n+" "+n+"-"+o.opts.axis+'"></div>').appendTo(i.$refs.container.find(a).addBack().filter(a)),o.$grid.on("click","a",function(){i.jumpTo(e(this).attr("data-index"))})),o.$list||(o.$list=e('<div class="'+n+'__list">').appendTo(o.$grid)),e.each(i.group,function(e,n){t=n.thumb,t||"image"!==n.type||(t=n.src),s.push('<a href="javascript:;" tabindex="0" data-index="'+e+'"'+(t&&t.length?' style="background-image:url('+t+')"':'class="fancybox-thumbs-missing"')+"></a>")}),o.$list[0].innerHTML=s.join(""),"x"===o.opts.axis&&o.$list.width(parseInt(o.$grid.css("padding-right"),10)+i.group.length*o.$list.children().eq(0).outerWidth(!0))},focus:function(t){var e,n,o=this,i=o.$list,a=o.$grid;o.instance.current&&(e=i.children().removeClass("fancybox-thumbs-active").filter('[data-index="'+o.instance.current.index+'"]').addClass("fancybox-thumbs-active"),n=e.position(),"y"===o.opts.axis&&(n.top<0||n.top>i.height()-e.outerHeight())?i.stop().animate({scrollTop:i.scrollTop()+n.top},t):"x"===o.opts.axis&&(n.left<a.scrollLeft()||n.left>a.scrollLeft()+(a.width()-e.outerWidth()))&&i.parent().stop().animate({scrollLeft:n.left},t))},update:function(){var t=this;t.instance.$refs.container.toggleClass("fancybox-show-thumbs",this.isVisible),t.isVisible?(t.$grid||t.create(),t.instance.trigger("onThumbsShow"),t.focus(0)):t.$grid&&t.instance.trigger("onThumbsHide"),t.instance.update()},hide:function(){this.isVisible=!1,this.update()},show:function(){this.isVisible=!0,this.update()},toggle:function(){this.isVisible=!this.isVisible,this.update()}}),e(t).on({"onInit.fb":function(t,e){var n;e&&!e.Thumbs&&(n=new o(e),n.isActive&&!0===n.opts.autoStart&&n.show())},"beforeShow.fb":function(t,e,n,o){var i=e&&e.Thumbs;i&&i.isVisible&&i.focus(o?0:250)},"afterKeydown.fb":function(t,e,n,o,i){var a=e&&e.Thumbs;a&&a.isActive&&71===i&&(o.preventDefault(),a.toggle())},"beforeClose.fb":function(t,e){var n=e&&e.Thumbs;n&&n.isVisible&&!1!==n.opts.hideOnClose&&n.$grid.hide()}})}(document,jQuery),function(t,e){"use strict";function n(t){var e={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#x2F;","`":"&#x60;","=":"&#x3D;"};return String(t).replace(/[&<>"'`=\/]/g,function(t){return e[t]})}e.extend(!0,e.fancybox.defaults,{btnTpl:{share:'<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>'},share:{url:function(t,e){return!t.currentHash&&"inline"!==e.type&&"html"!==e.type&&(e.origSrc||e.src)||window.location},
tpl:'<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>'}}),e(t).on("click","[data-fancybox-share]",function(){var t,o,i=e.fancybox.getInstance(),a=i.current||null;a&&("function"===e.type(a.opts.share.url)&&(t=a.opts.share.url.apply(a,[i,a])),o=a.opts.share.tpl.replace(/\{\{media\}\}/g,"image"===a.type?encodeURIComponent(a.src):"").replace(/\{\{url\}\}/g,encodeURIComponent(t)).replace(/\{\{url_raw\}\}/g,n(t)).replace(/\{\{descr\}\}/g,i.$caption?encodeURIComponent(i.$caption.text()):""),e.fancybox.open({src:i.translate(i,o),type:"html",opts:{touch:!1,animationEffect:!1,afterLoad:function(t,e){i.$refs.container.one("beforeClose.fb",function(){t.close(null,0)}),e.$content.find(".fancybox-share__button").click(function(){return window.open(this.href,"Share","width=550, height=450"),!1})},mobile:{autoFocus:!1}}}))})}(document,jQuery),function(t,e,n){"use strict";function o(){var e=t.location.hash.substr(1),n=e.split("-"),o=n.length>1&&/^\+?\d+$/.test(n[n.length-1])?parseInt(n.pop(-1),10)||1:1,i=n.join("-");return{hash:e,index:o<1?1:o,gallery:i}}function i(t){""!==t.gallery&&n("[data-fancybox='"+n.escapeSelector(t.gallery)+"']").eq(t.index-1).focus().trigger("click.fb-start")}function a(t){var e,n;return!!t&&(e=t.current?t.current.opts:t.opts,""!==(n=e.hash||(e.$orig?e.$orig.data("fancybox")||e.$orig.data("fancybox-trigger"):""))&&n)}n.escapeSelector||(n.escapeSelector=function(t){return(t+"").replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,function(t,e){return e?"\0"===t?"�":t.slice(0,-1)+"\\"+t.charCodeAt(t.length-1).toString(16)+" ":"\\"+t})}),n(function(){!1!==n.fancybox.defaults.hash&&(n(e).on({"onInit.fb":function(t,e){var n,i;!1!==e.group[e.currIndex].opts.hash&&(n=o(),(i=a(e))&&n.gallery&&i==n.gallery&&(e.currIndex=n.index-1))},"beforeShow.fb":function(n,o,i,s){var r;i&&!1!==i.opts.hash&&(r=a(o))&&(o.currentHash=r+(o.group.length>1?"-"+(i.index+1):""),t.location.hash!=="#"+o.currentHash&&(s&&!o.origHash&&(o.origHash=t.location.hash),o.hashTimer&&clearTimeout(o.hashTimer),o.hashTimer=setTimeout(function(){"replaceState"in t.history?(t.history[s?"pushState":"replaceState"]({},e.title,t.location.pathname+t.location.search+"#"+o.currentHash),s&&(o.hasCreatedHistory=!0)):t.location.hash=o.currentHash,o.hashTimer=null},300)))},"beforeClose.fb":function(n,o,i){i&&!1!==i.opts.hash&&(clearTimeout(o.hashTimer),o.currentHash&&o.hasCreatedHistory?t.history.back():o.currentHash&&("replaceState"in t.history?t.history.replaceState({},e.title,t.location.pathname+t.location.search+(o.origHash||"")):t.location.hash=o.origHash),o.currentHash=null)}}),n(t).on("hashchange.fb",function(){var t=o(),e=null;n.each(n(".fancybox-container").get().reverse(),function(t,o){var i=n(o).data("FancyBox");if(i&&i.currentHash)return e=i,!1}),e?e.currentHash===t.gallery+"-"+t.index||1===t.index&&e.currentHash==t.gallery||(e.currentHash=null,e.close()):""!==t.gallery&&i(t)}),setTimeout(function(){n.fancybox.getInstance()||i(o())},50))})}(window,document,jQuery),function(t,e){"use strict";var n=(new Date).getTime();e(t).on({"onInit.fb":function(t,e,o){e.$refs.stage.on("mousewheel DOMMouseScroll wheel MozMousePixelScroll",function(t){var o=e.current,i=(new Date).getTime();e.group.length<2||!1===o.opts.wheel||"auto"===o.opts.wheel&&"image"!==o.type||(t.preventDefault(),t.stopPropagation(),o.$slide.hasClass("fancybox-animated")||(t=t.originalEvent||t,i-n<250||(n=i,e[(-t.deltaY||-t.deltaX||t.wheelDelta||-t.detail)<0?"next":"previous"]())))})}})}(document,jQuery);
// jscs:disable
/* jshint -W071, -W074 */
// jscs:enable
/* globals jQuery */
/*
 * jQuery ezPlus 1.2.5
 * Demo's and documentation:
 * http://igorlino.github.io/elevatezoom-plus/
 *
 * licensed under MIT license.
 * http://en.wikipedia.org/wiki/MIT_License
 *
 */

if (typeof Object.create !== 'function') {
    Object.create = function (obj) {
        function F() {
        }

        F.prototype = obj;
        return new F();
    };
}

(function ($, window, document) {
    var EZP = {
        init: function (options, elem) {
            var self = this;

            self.elem = elem;
            self.$elem = $(elem);

            self.options = $.extend({}, $.fn.ezPlus.options, self.responsiveConfig(options || {}));

            self.imageSrc = self.$elem.attr('data-'+self.options.attrImageZoomSrc) ? self.$elem.attr('data-'+self.options.attrImageZoomSrc) : self.$elem.attr('src');

            if (!self.options.enabled) {
                return;
            }

            //TINT OVERRIDE SETTINGS
            if (self.options.tint) {
                self.options.lensColour = 'transparent'; //colour of the lens background
                self.options.lensOpacity = '1'; //opacity of the lens
            }
            //INNER OVERRIDE SETTINGS
            if (self.options.zoomType === 'inner') {
                self.options.showLens = false;
            }

            // LENS OVERRIDE SETTINGS
            if (self.options.zoomType === 'lens') {
                self.options.zoomWindowWidth = 0;
            }

            //UUID WHEN MISSING IDENTIFIER
            if (self.options.zoomId === -1) {
                self.options.zoomId = generateUUID();
            }

            //Remove alt on hover

            self.$elem.parent().removeAttr('title').removeAttr('alt');

            self.zoomImage = self.imageSrc;

            self.refresh(1);

            //Create the image swap from the gallery
            var galleryEvent = self.options.galleryEvent + '.ezpspace';
            galleryEvent += self.options.touchEnabled ? ' touchend.ezpspace' : '';
            self.$galleries = $(self.options.gallery ? ('#' + self.options.gallery) : self.options.gallerySelector);
            self.$galleries.on(galleryEvent, self.options.galleryItem, function (e) {

                //Set a class on the currently active gallery image
                if (self.options.galleryActiveClass) {
                    $(self.options.galleryItem, self.$galleries).removeClass(self.options.galleryActiveClass);
                    $(this).addClass(self.options.galleryActiveClass);
                }
                //stop any link on the a tag from working
                if (this.tagName === 'A') {
                    e.preventDefault();
                }

                //call the swap image function
                if ($(this).data(self.options.attrImageZoomSrc)) {
                    self.zoomImagePre = $(this).data(self.options.attrImageZoomSrc);
                }
                else {
                    self.zoomImagePre = $(this).data('image');
                }
                self.swaptheimage($(this).data('image'), self.zoomImagePre);
                if (this.tagName === 'A') {
                    return false;
                }
            });
            function generateUUID() {
                var d = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0; // jshint ignore:line
                    d = Math.floor(d / 16); // jshint ignore:line
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16); // jshint ignore:line
                });
                return uuid;
            }
        },
        refresh: function (length) {
            var self = this;

            setTimeout(function () {
                self.fetch(self.imageSrc, self.$elem, self.options.minZoomLevel);

            }, length || self.options.refresh);
        },
        fetch: function (imgsrc, element, minZoom) {
            //get the image
            var self = this;
            var newImg = new Image();
            newImg.onload = function () {
                //set the large image dimensions - used to calculte ratio's
                if (newImg.width / element.width() <= minZoom) {
                    self.largeWidth = element.width() * minZoom;
                } else {
                    self.largeWidth = newImg.width;
                }
                if (newImg.height / element.height() <= minZoom) {
                    self.largeHeight = element.height() * minZoom;
                } else {
                    self.largeHeight = newImg.height;
                }
                //once image is loaded start the calls
                self.startZoom();
                self.currentImage = self.imageSrc;
                //let caller know image has been loaded
                self.options.onZoomedImageLoaded(self.$elem);
            };
            self.setImageSource(newImg, imgsrc); // this must be done AFTER setting onload

            return;
        },
        setImageSource: function (image, src) {
            //sets an image's source.
            image.src = src;
        },
        startZoom: function () {
            var self = this;
            //get dimensions of the non zoomed image
            self.nzWidth = self.$elem.width();
            self.nzHeight = self.$elem.height();

            //activated elements
            self.isWindowActive = false;
            self.isLensActive = false;
            self.isTintActive = false;
            self.overWindow = false;

            //CrossFade Wrapper
            if (self.options.imageCrossfade) {
                var elementZoomWrapper = $('<div class="zoomWrapper"/>')
                    .css({
                        height: self.nzHeight,
                        width: self.nzWidth
                    });
                if(self.$elem.parent().hasClass('zoomWrapper')){
                    self.$elem.unwrap();
                }
                self.zoomWrap = self.$elem.wrap(elementZoomWrapper);
                self.$elem.css({
                    position: 'absolute'
                });
            }

            self.zoomLock = 1;
            self.scrollingLock = false;
            self.changeBgSize = false;
            self.currentZoomLevel = self.options.zoomLevel;

            //get offset of the non zoomed image
            self.updateOffset(self);
            //calculate the width ratio of the large/small image
            self.widthRatio = (self.largeWidth / self.currentZoomLevel) / self.nzWidth;
            self.heightRatio = (self.largeHeight / self.currentZoomLevel) / self.nzHeight;

            function getWindowZoomStyle() {
                return {
                    display: 'none',
                    position: 'absolute',
                    height: self.options.zoomWindowHeight,
                    width: self.options.zoomWindowWidth,
                    border: '' + self.options.borderSize + 'px solid ' + self.options.borderColour,
                    backgroundSize: '' + (self.largeWidth / self.currentZoomLevel) + 'px ' + (self.largeHeight / self.currentZoomLevel) + 'px',
                    backgroundPosition: '0px 0px',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: '' + self.options.zoomWindowBgColour,
                    overflow: 'hidden',
                    zIndex: 100
                };
            }

            //if window zoom
            if (self.options.zoomType === 'window') {
                self.zoomWindowStyle = getWindowZoomStyle();
            }

            function getInnerZoomStyle() {
                //has a border been put on the image? Lets cater for this
                var borderWidth = self.$elem.css('border-left-width');

                if (self.options.scrollZoom)
                    self.zoomLens = $('<div class="zoomLens"/>');

                return {
                    display: 'none',
                    position: 'absolute',
                    height: self.nzHeight,
                    width: self.nzWidth,
                    marginTop: borderWidth,
                    marginLeft: borderWidth,
                    border: '' + self.options.borderSize + 'px solid ' + self.options.borderColour,
                    backgroundPosition: '0px 0px',
                    backgroundRepeat: 'no-repeat',
                    cursor: self.options.cursor,
                    overflow: 'hidden',
                    zIndex: self.options.zIndex
                };
            }

            //if inner  zoom
            if (self.options.zoomType === 'inner') {
                self.zoomWindowStyle = getInnerZoomStyle();
            }

            function getWindowLensStyle() {
                // adjust images less than the window height

                if (self.nzHeight < self.options.zoomWindowHeight / self.heightRatio) {
                    self.lensHeight = self.nzHeight;
                }
                else {
                    self.lensHeight = self.options.zoomWindowHeight / self.heightRatio;
                }
                if (self.largeWidth < self.options.zoomWindowWidth) {
                    self.lensWidth = self.nzWidth;
                }
                else {
                    self.lensWidth = self.options.zoomWindowWidth / self.widthRatio;
                }

                return {
                    display: 'none',
                    position: 'absolute',
                    height: self.lensHeight,
                    width: self.lensWidth,
                    border: '' + self.options.lensBorderSize + 'px' + ' solid ' + self.options.lensBorderColour,
                    backgroundPosition: '0px 0px',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: self.options.lensColour,
                    opacity: self.options.lensOpacity,
                    cursor: self.options.cursor,
                    zIndex: 999,
                    overflow: 'hidden'
                };
            }

            //lens style for window zoom
            if (self.options.zoomType === 'window') {
                self.lensStyle = getWindowLensStyle();
            }

            //tint style
            self.tintStyle = {
                display: 'block',
                position: 'absolute',
                height: self.nzHeight,
                width: self.nzWidth,
                backgroundColor: self.options.tintColour,
                opacity: 0
            };

            //lens style for lens zoom with optional round for modern browsers
            self.lensRound = {};

            if (self.options.zoomType === 'lens') {
                self.lensStyle = {
                    display: 'none',
                    position: 'absolute',
                    float: 'left',
                    height: self.options.lensSize,
                    width: self.options.lensSize,
                    border: '' + self.options.borderSize + 'px solid ' + self.options.borderColour,
                    backgroundPosition: '0px 0px',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: self.options.lensColour,
                    cursor: self.options.cursor
                };
            }

            //does not round in all browsers
            if (self.options.lensShape === 'round') {
                self.lensRound = {
                    borderRadius: self.options.lensSize / 2 + self.options.borderSize
                };
            }

            //create the div's                                                + ""
            //self.zoomContainer = $('<div/>').addClass('zoomContainer').css({"position":"relative", "height":self.nzHeight, "width":self.nzWidth});

            self.zoomContainer = $('<div class="' + self.options.container + '" ' + 'uuid="' + self.options.zoomId + '"/>');
            self.zoomContainer.css({
                position: 'absolute',
                top: self.nzOffset.top,
                left: self.nzOffset.left,
                height: self.nzHeight,
                width: self.nzWidth,
                zIndex: self.options.zIndex
            });
            if (self.$elem.attr('id')) {
                self.zoomContainer.attr('id', self.$elem.attr('id') + '-' + self.options.container);
            }
            $('.' + self.options.container + '[uuid="' + self.options.zoomId + '"]').remove();
            $(self.options.zoomContainerAppendTo).append(self.zoomContainer);

            //this will add overflow hidden and contrain the lens on lens mode
            if (self.options.containLensZoom && self.options.zoomType === 'lens') {
                self.zoomContainer.css('overflow', 'hidden');
            }
            if (self.options.zoomType !== 'inner') {
                self.zoomLens = $('<div class="zoomLens"/>')
                    .css($.extend({}, self.lensStyle, self.lensRound))
                    .appendTo(self.zoomContainer)
                    .click(function () {
                        self.$elem.trigger('click');
                    });

                if (self.options.tint) {
                    self.tintContainer = $('<div class="tintContainer"/>');
                    self.zoomTint = $('<div class="zoomTint"/>').css(self.tintStyle);

                    self.zoomLens.wrap(self.tintContainer);

                    self.zoomTintcss = self.zoomLens.after(self.zoomTint);

                    //if tint enabled - set an image to show over the tint

                    self.zoomTintImage = $('<img src="' + self.$elem.attr('src') + '">')
                        .css({
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            height: self.nzHeight,
                            width: self.nzWidth,
                            maxWidth: 'none'
                        })
                        .appendTo(self.zoomLens)
                        .click(function () {
                            self.$elem.trigger('click');
                        });
                }
            }

            //create zoom window
            var targetZoomContainer = isNaN(self.options.zoomWindowPosition) ? 'body' : self.zoomContainer;
            self.zoomWindow = $('<div class="zoomWindow"/>')
                .css($.extend({
                    zIndex: 999,
                    top: self.windowOffsetTop,
                    left: self.windowOffsetLeft,
                }, self.zoomWindowStyle))
                .appendTo(targetZoomContainer).click(function () {
                    self.$elem.trigger('click');
                });
            self.zoomWindowContainer = $('<div class="zoomWindowContainer" />')
                .css({
                    width: self.options.zoomWindowWidth
                });
            self.zoomWindow.wrap(self.zoomWindowContainer);

            if (self.options.zoomType === 'lens') {
                self.zoomContainer.css('display', 'none');
                self.zoomLens.css({
                    backgroundImage: 'url("' + self.imageSrc + '")'
                });
            }
            if (self.options.zoomType === 'window') {
                self.zoomWindow.css({
                    backgroundImage: 'url("' + self.imageSrc + '")'
                });
            }
            if (self.options.zoomType === 'inner') {
                self.zoomWindow.css({
                    backgroundImage: 'url("' + self.imageSrc + '")'
                });
            }

            /*-------------------END THE ZOOM WINDOW AND LENS----------------------------------*/
            if (self.options.touchEnabled) {
                //touch events
                self.$elem.on('touchmove.ezpspace', function (e) {
                    e.preventDefault();
                    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    self.setPosition(touch);
                });
                self.zoomContainer.on('touchmove.ezpspace', function (e) {
                    self.setElements('show');
                    e.preventDefault();
                    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    self.setPosition(touch);

                });
                self.zoomContainer
                    .add(self.$elem)
                    .on('touchend.ezpspace', function (e) {
                        self.showHideWindow('hide');
                        if (self.options.showLens) {
                            self.showHideLens('hide');
                        }
                        if (self.options.tint && self.options.zoomType !== 'inner') {
                            self.showHideTint('hide');
                        }
                    });

                if (self.options.showLens) {
                    self.zoomLens.on('touchmove.ezpspace', function (e) {

                        e.preventDefault();
                        var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                        self.setPosition(touch);
                    });

                    self.zoomLens.on('touchend.ezpspace', function (e) {
                        self.showHideWindow('hide');
                        if (self.options.showLens) {
                            self.showHideLens('hide');
                        }
                        if (self.options.tint && self.options.zoomType !== 'inner') {
                            self.showHideTint('hide');
                        }
                    });
                }
            }

            // Needed to work in IE
            self.zoomContainer.on('click.ezpspace touchstart.ezpspace', self.options.onImageClick);

            self.zoomContainer
                .add(self.$elem)
                .on('mousemove.ezpspace', function (e) {
                    if (self.overWindow === false) {
                        self.setElements('show');
                    }
                    mouseMoveZoomHandler(e);
                });

            function mouseMoveZoomHandler(e) {
                //self.overWindow = true;
                //make sure on orientation change the setposition is not fired
                if (self.lastX !== e.clientX || self.lastY !== e.clientY) {
                    self.setPosition(e);
                    self.currentLoc = e;
                }
                self.lastX = e.clientX;
                self.lastY = e.clientY;
            }

            var elementToTrack = null;
            if (self.options.zoomType !== 'inner') {
                elementToTrack = self.zoomLens;
            }
            if (self.options.tint && self.options.zoomType !== 'inner') {
                elementToTrack = self.zoomTint;
            }
            if (self.options.zoomType === 'inner') {
                elementToTrack = self.zoomWindow;
            }

            //register the mouse tracking
            if (elementToTrack) {
                elementToTrack.on('mousemove.ezpspace', mouseMoveZoomHandler);
            }

            //  lensFadeOut: 500,  zoomTintFadeIn
            self.zoomContainer
                .add(self.$elem)
                .hover(function () {
                    if (self.overWindow === false) {
                        self.setElements('show');
                    }
                }, function () {
                    if (!self.scrollLock) {
                        self.setElements('hide');
                        self.options.onDestroy(self.$elem);
                    }
                });
            //end ove image

            if (self.options.zoomType !== 'inner') {
                self.zoomWindow.hover(function () {
                    self.overWindow = true;
                    self.setElements('hide');
                }, function () {
                    self.overWindow = false;
                });
            }
            //end ove image

            // var delta = parseInt(e.originalEvent.wheelDelta || -e.originalEvent.detail);

            //      $(this).empty();
            //    return false;

            //fix for initial zoom setting
            //if (self.options.zoomLevel !== 1) {
            //    	self.changeZoomLevel(self.currentZoomLevel);
            //}
            //set the min zoomlevel
            if (self.options.minZoomLevel) {
                self.minZoomLevel = self.options.minZoomLevel;
            }
            else {
                self.minZoomLevel = self.options.scrollZoomIncrement * 2;
            }

            if (self.options.scrollZoom) {
                //see compatibility of mouse events at https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel
                self.zoomContainer.add(self.$elem).on('wheel DOMMouseScroll MozMousePixelScroll', function (e) {
                    // in IE there is issue with firing of mouseleave - So check whether still scrolling
                    // and on mouseleave check if scrolllock
                    self.scrollLock = true;
                    clearTimeout($.data(this, 'timer'));
                    $.data(this, 'timer', setTimeout(function () {
                        self.scrollLock = false;
                        //do something
                    }, 250));

                    var theEvent = e.originalEvent.deltaY || e.originalEvent.detail * -1;

                    //this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                    //   e.preventDefault();

                    e.stopImmediatePropagation();
                    e.stopPropagation();
                    e.preventDefault();

                    if (theEvent === 0) {
                        // fixes last event inversion bug
                        return false;
                    }
                    var nextZoomLevel;
                    if (theEvent / 120 > 0) {
                        nextZoomLevel = parseFloat(self.currentZoomLevel) - self.options.scrollZoomIncrement;
                        //scrolling up
                        if (nextZoomLevel >= parseFloat(self.minZoomLevel)) {
                            self.changeZoomLevel(nextZoomLevel);
                        }
                    }
                    else {
                        //scrolling down

                        //Check if it has to maintain original zoom window aspect ratio or not
                        if ((!self.fullheight && !self.fullwidth) || !self.options.mantainZoomAspectRatio) {
                            nextZoomLevel = parseFloat(self.currentZoomLevel) + self.options.scrollZoomIncrement;

                            if (self.options.maxZoomLevel) {
                                if (nextZoomLevel <= self.options.maxZoomLevel) {
                                    self.changeZoomLevel(nextZoomLevel);
                                }
                            }
                            else {
                                //andy
                                self.changeZoomLevel(nextZoomLevel);
                            }
                        }
                    }
                    return false;
                });
            }
        },
        destroy: function () {
            var self = this;
            self.$elem.off('.ezpspace');
            self.$galleries.off('.ezpspace');
            $(self.zoomContainer).remove();
            if (self.options.loadingIcon && !!self.spinner && !!self.spinner.length) {
                self.spinner.remove();
                delete self.spinner;
            }
        },
        getIdentifier: function () {
            var self = this;
            return self.options.zoomId;
        },
        setElements: function (type) {
            var self = this;
            if (!self.options.zoomEnabled) {
                return false;
            }
            if (type === 'show') {
                if (self.isWindowSet) {
                    if (self.options.zoomType === 'inner') {
                        self.showHideWindow('show');
                    }
                    if (self.options.zoomType === 'window') {
                        self.showHideWindow('show');
                    }
                    if (self.options.showLens) {
                        self.showHideZoomContainer('show');
                        self.showHideLens('show');
                    }
                    if (self.options.tint && self.options.zoomType !== 'inner') {
                        self.showHideTint('show');
                    }
                }
            }

            if (type === 'hide') {
                if (self.options.zoomType === 'window') {
                    self.showHideWindow('hide');
                }
                if (!self.options.tint) {
                    self.showHideWindow('hide');
                }
                if (self.options.showLens) {
                    self.showHideZoomContainer('hide');
                    self.showHideLens('hide');
                }
                if (self.options.tint) {
                    self.showHideTint('hide');
                }
            }
        },
        setPosition: function (e) {

            var self = this;

            if (!self.options.zoomEnabled || e === undefined) {
                return false;
            }

            //recaclc offset each time in case the image moves
            //this can be caused by other on page elements
            self.nzHeight = self.$elem.height();
            self.nzWidth = self.$elem.width();
            self.updateOffset(self);

            if (self.options.tint && self.options.zoomType !== 'inner') {
                self.zoomTint.css({
                    top: 0,
                    left: 0
                });
            }
            //set responsive
            //will checking if the image needs changing before running this code work faster?
            if (self.options.responsive && !self.options.scrollZoom) {
                if (self.options.showLens) {
                    var lensHeight, lensWidth;
                    if (self.nzHeight < self.options.zoomWindowWidth / self.widthRatio) {
                        self.lensHeight = self.nzHeight;
                    }
                    else {
                        self.lensHeight = self.options.zoomWindowHeight / self.heightRatio;
                    }
                    if (self.largeWidth < self.options.zoomWindowWidth) {
                        self.lensWidth = self.nzWidth;
                    }
                    else {
                        self.lensWidth = (self.options.zoomWindowWidth / self.widthRatio);
                    }
                    self.widthRatio = self.largeWidth / self.nzWidth;
                    self.heightRatio = self.largeHeight / self.nzHeight;
                    if (self.options.zoomType !== 'lens') {
                        //possibly dont need to keep recalcalculating
                        //if the lens is heigher than the image, then set lens size to image size
                        if (self.nzHeight < self.options.zoomWindowWidth / self.widthRatio) {
                            self.lensHeight = self.nzHeight;

                        }
                        else {
                            self.lensHeight = self.options.zoomWindowHeight / self.heightRatio;
                        }

                        if (self.nzWidth < self.options.zoomWindowHeight / self.heightRatio) {
                            self.lensWidth = self.nzWidth;
                        }
                        else {
                            self.lensWidth = self.options.zoomWindowWidth / self.widthRatio;
                        }

                        self.zoomLens.css({
                            width: self.lensWidth,
                            height: self.lensHeight
                        });

                        if (self.options.tint) {
                            self.zoomTintImage.css({
                                width: self.nzWidth,
                                height: self.nzHeight
                            });
                        }

                    }
                    if (self.options.zoomType === 'lens') {
                        self.zoomLens.css({
                            width: self.options.lensSize,
                            height: self.options.lensSize
                        });
                    }
                    //end responsive image change
                }
            }

            //container fix
            self.zoomContainer.css({
                top: self.nzOffset.top,
                left: self.nzOffset.left,
                width: self.nzWidth,  // new code
                height: self.nzHeight // new code
            });
            self.mouseLeft = parseInt(e.pageX - self.pageOffsetX - self.nzOffset.left);
            self.mouseTop = parseInt(e.pageY - self.pageOffsetY - self.nzOffset.top);
            //calculate the Location of the Lens

            //calculate the bound regions - but only if zoom window
            if (self.options.zoomType === 'window') {
                var zoomLensHeight = self.zoomLens.height() / 2;
                var zoomLensWidth = self.zoomLens.width() / 2;
                self.Etoppos = (self.mouseTop < 0 + zoomLensHeight);
                self.Eboppos = (self.mouseTop > self.nzHeight - zoomLensHeight - (self.options.lensBorderSize * 2));
                self.Eloppos = (self.mouseLeft < 0 + zoomLensWidth);
                self.Eroppos = (self.mouseLeft > (self.nzWidth - zoomLensWidth - (self.options.lensBorderSize * 2)));
            }
            //calculate the bound regions - but only for inner zoom
            if (self.options.zoomType === 'inner') {
                self.Etoppos = (self.mouseTop < ((self.nzHeight / 2) / self.heightRatio));
                self.Eboppos = (self.mouseTop > (self.nzHeight - ((self.nzHeight / 2) / self.heightRatio)));
                self.Eloppos = (self.mouseLeft < 0 + (((self.nzWidth / 2) / self.widthRatio)));
                self.Eroppos = (self.mouseLeft > (self.nzWidth - (self.nzWidth / 2) / self.widthRatio - (self.options.lensBorderSize * 2)));
            }

            // if the mouse position of the slider is one of the outerbounds, then hide  window and lens
            if (self.mouseLeft < 0 || self.mouseTop < 0 || self.mouseLeft > self.nzWidth || self.mouseTop > self.nzHeight) {
                self.setElements('hide');
                return;
            }
            //else continue with operations
            else {
                //lens options
                if (self.options.showLens) {
                    //		self.showHideLens('show');
                    //set background position of lens
                    self.lensLeftPos = Math.floor(self.mouseLeft - self.zoomLens.width() / 2);
                    self.lensTopPos = Math.floor(self.mouseTop - self.zoomLens.height() / 2);
                }
                //adjust the background position if the mouse is in one of the outer regions

                //Top region
                if (self.Etoppos) {
                    self.lensTopPos = 0;
                }
                //Left Region
                if (self.Eloppos) {
                    self.windowLeftPos = 0;
                    self.lensLeftPos = 0;
                    self.tintpos = 0;
                }
                //Set bottom and right region for window mode
                if (self.options.zoomType === 'window') {
                    if (self.Eboppos) {
                        self.lensTopPos = Math.max((self.nzHeight) - self.zoomLens.height() - (self.options.lensBorderSize * 2), 0);
                    }
                    if (self.Eroppos) {
                        self.lensLeftPos = (self.nzWidth - (self.zoomLens.width()) - (self.options.lensBorderSize * 2));
                    }
                }
                //Set bottom and right region for inner mode
                if (self.options.zoomType === 'inner') {
                    if (self.Eboppos) {
                        self.lensTopPos = Math.max(((self.nzHeight) - (self.options.lensBorderSize * 2)), 0);
                    }
                    if (self.Eroppos) {
                        self.lensLeftPos = (self.nzWidth - (self.nzWidth) - (self.options.lensBorderSize * 2));
                    }
                }
                //if lens zoom
                if (self.options.zoomType === 'lens') {

                    self.windowLeftPos = ((e.pageX - self.pageOffsetX - self.nzOffset.left) * self.widthRatio - self.zoomLens.width() / 2) * -1;
                    self.windowTopPos = ((e.pageY - self.pageOffsetY - self.nzOffset.top) * self.heightRatio - self.zoomLens.height() / 2) * -1;
                    self.zoomLens.css({
                        backgroundPosition: '' + self.windowLeftPos + 'px ' + self.windowTopPos + 'px'
                    });

                    if (self.changeBgSize) {
                        if (self.nzHeight > self.nzWidth) {
                            if (self.options.zoomType === 'lens') {
                                self.zoomLens.css({
                                    backgroundSize: '' +
                                    (self.largeWidth / self.newvalueheight) + 'px ' +
                                    (self.largeHeight / self.newvalueheight) + 'px'
                                });
                            }

                            self.zoomWindow.css({
                                backgroundSize: '' +
                                (self.largeWidth / self.newvalueheight) + 'px ' +
                                (self.largeHeight / self.newvalueheight) + 'px'
                            });
                        }
                        else {
                            if (self.options.zoomType === 'lens') {
                                self.zoomLens.css({
                                    backgroundSize: '' +
                                    (self.largeWidth / self.newvaluewidth) + 'px ' +
                                    (self.largeHeight / self.newvaluewidth) + 'px'
                                });
                            }
                            self.zoomWindow.css({
                                backgroundSize: '' +
                                (self.largeWidth / self.newvaluewidth) + 'px ' +
                                (self.largeHeight / self.newvaluewidth) + 'px'
                            });
                        }
                        self.changeBgSize = false;
                    }

                    self.setWindowPosition(e);
                }
                //if tint zoom
                if (self.options.tint && self.options.zoomType !== 'inner') {
                    self.setTintPosition(e);
                }
                //set the css background position
                if (self.options.zoomType === 'window') {
                    self.setWindowPosition(e);
                }
                if (self.options.zoomType === 'inner') {
                    self.setWindowPosition(e);
                }
                if (self.options.showLens) {
                    if (self.fullwidth && self.options.zoomType !== 'lens') {
                        self.lensLeftPos = 0;
                    }
                    self.zoomLens.css({
                        left: self.lensLeftPos,
                        top: self.lensTopPos
                    });
                }

            } //end else
        },
        showHideZoomContainer: function (change) {
            var self = this;
            if (change === 'show') {
                if (self.zoomContainer) {
                    self.zoomContainer.show();
                }
            }
            if (change === 'hide') {
                if (self.zoomContainer) {
                    self.zoomContainer.hide();
                }
            }
        },
        showHideWindow: function (change) {
            var self = this;
            if (change === 'show') {
                if (!self.isWindowActive && self.zoomWindow) {
                    self.options.onShow(self);
                    if (self.options.zoomWindowFadeIn) {
                        self.zoomWindow.stop(true, true, false).fadeIn(self.options.zoomWindowFadeIn);
                    }
                    else {
                        self.zoomWindow.show();
                    }
                    self.isWindowActive = true;
                }
            }
            if (change === 'hide') {
                if (self.isWindowActive) {
                    if (self.options.zoomWindowFadeOut) {
                        self.zoomWindow.stop(true, true).fadeOut(self.options.zoomWindowFadeOut, function () {
                            if (self.loop) {
                                //stop moving the zoom window when zoom window is faded out
                                clearInterval(self.loop);
                                self.loop = false;
                            }
                        });
                    }
                    else {
                        self.zoomWindow.hide();
                    }
                    self.options.onHide(self);
                    self.isWindowActive = false;
                }
            }
        },
        showHideLens: function (change) {
            var self = this;
            if (change === 'show') {
                if (!self.isLensActive) {
                    if (self.zoomLens) {
                        if (self.options.lensFadeIn) {
                            self.zoomLens.stop(true, true, false).fadeIn(self.options.lensFadeIn);
                        }
                        else {
                            self.zoomLens.show();
                        }
                    }
                    self.isLensActive = true;
                }
            }
            if (change === 'hide') {
                if (self.isLensActive) {
                    if (self.zoomLens) {
                        if (self.options.lensFadeOut) {
                            self.zoomLens.stop(true, true).fadeOut(self.options.lensFadeOut);
                        }
                        else {
                            self.zoomLens.hide();
                        }
                    }
                    self.isLensActive = false;
                }
            }
        },
        showHideTint: function (change) {
            var self = this;
            if (change === 'show') {
                if (!self.isTintActive && self.zoomTint) {

                    if (self.options.zoomTintFadeIn) {
                        self.zoomTint.css('opacity', self.options.tintOpacity).animate().stop(true, true).fadeIn('slow');
                    }
                    else {
                        self.zoomTint.css('opacity', self.options.tintOpacity).animate();
                        self.zoomTint.show();
                    }
                    self.isTintActive = true;
                }
            }
            if (change === 'hide') {
                if (self.isTintActive) {

                    if (self.options.zoomTintFadeOut) {
                        self.zoomTint.stop(true, true).fadeOut(self.options.zoomTintFadeOut);
                    }
                    else {
                        self.zoomTint.hide();
                    }
                    self.isTintActive = false;
                }
            }
        },

        setLensPosition: function (e) {
        },

        setWindowPosition: function (e) {
            //return obj.slice( 0, count );
            var self = this;

            if (!isNaN(self.options.zoomWindowPosition)) {

                switch (self.options.zoomWindowPosition) {
                    case 1: //done
                        self.windowOffsetTop = (self.options.zoomWindowOffsetY);//DONE - 1
                        self.windowOffsetLeft = (+self.nzWidth); //DONE 1, 2, 3, 4, 16
                        break;
                    case 2:
                        if (self.options.zoomWindowHeight > self.nzHeight) { //positive margin

                            self.windowOffsetTop = ((self.options.zoomWindowHeight / 2) - (self.nzHeight / 2)) * (-1);
                            self.windowOffsetLeft = (self.nzWidth); //DONE 1, 2, 3, 4, 16
                        }
                        else { //negative margin
                            $.noop();
                        }
                        break;
                    case 3: //done
                        self.windowOffsetTop = (self.nzHeight - self.zoomWindow.height() - (self.options.borderSize * 2)); //DONE 3,9
                        self.windowOffsetLeft = (self.nzWidth); //DONE 1, 2, 3, 4, 16
                        break;
                    case 4: //done
                        self.windowOffsetTop = (self.nzHeight); //DONE - 4,5,6,7,8
                        self.windowOffsetLeft = (self.nzWidth); //DONE 1, 2, 3, 4, 16
                        break;
                    case 5: //done
                        self.windowOffsetTop = (self.nzHeight); //DONE - 4,5,6,7,8
                        self.windowOffsetLeft = (self.nzWidth - self.zoomWindow.width() - (self.options.borderSize * 2)); //DONE - 5,15
                        break;
                    case 6:
                        if (self.options.zoomWindowHeight > self.nzHeight) { //positive margin
                            self.windowOffsetTop = (self.nzHeight);  //DONE - 4,5,6,7,8

                            self.windowOffsetLeft = ((self.options.zoomWindowWidth / 2) - (self.nzWidth / 2) + (self.options.borderSize * 2)) * (-1);
                        }
                        else { //negative margin
                            $.noop();
                        }

                        break;
                    case 7: //done
                        self.windowOffsetTop = (self.nzHeight);  //DONE - 4,5,6,7,8
                        self.windowOffsetLeft = 0; //DONE 7, 13
                        break;
                    case 8: //done
                        self.windowOffsetTop = (self.nzHeight); //DONE - 4,5,6,7,8
                        self.windowOffsetLeft = (self.zoomWindow.width() + (self.options.borderSize * 2)) * (-1);  //DONE 8,9,10,11,12
                        break;
                    case 9:  //done
                        self.windowOffsetTop = (self.nzHeight - self.zoomWindow.height() - (self.options.borderSize * 2)); //DONE 3,9
                        self.windowOffsetLeft = (self.zoomWindow.width() + (self.options.borderSize * 2)) * (-1);  //DONE 8,9,10,11,12
                        break;
                    case 10:
                        if (self.options.zoomWindowHeight > self.nzHeight) { //positive margin

                            self.windowOffsetTop = ((self.options.zoomWindowHeight / 2) - (self.nzHeight / 2)) * (-1);
                            self.windowOffsetLeft = (self.zoomWindow.width() + (self.options.borderSize * 2)) * (-1);  //DONE 8,9,10,11,12
                        }
                        else { //negative margin
                            $.noop();
                        }
                        break;
                    case 11:
                        self.windowOffsetTop = (self.options.zoomWindowOffsetY);
                        self.windowOffsetLeft = (self.zoomWindow.width() + (self.options.borderSize * 2)) * (-1);  //DONE 8,9,10,11,12
                        break;
                    case 12: //done
                        self.windowOffsetTop = (self.zoomWindow.height() + (self.options.borderSize * 2)) * (-1); //DONE 12,13,14,15,16
                        self.windowOffsetLeft = (self.zoomWindow.width() + (self.options.borderSize * 2)) * (-1);  //DONE 8,9,10,11,12
                        break;
                    case 13: //done
                        self.windowOffsetTop = (self.zoomWindow.height() + (self.options.borderSize * 2)) * (-1); //DONE 12,13,14,15,16
                        self.windowOffsetLeft = (0); //DONE 7, 13
                        break;
                    case 14:
                        if (self.options.zoomWindowHeight > self.nzHeight) { //positive margin
                            self.windowOffsetTop = (self.zoomWindow.height() + (self.options.borderSize * 2)) * (-1); //DONE 12,13,14,15,16

                            self.windowOffsetLeft = ((self.options.zoomWindowWidth / 2) - (self.nzWidth / 2) + (self.options.borderSize * 2)) * (-1);
                        }
                        else { //negative margin
                            $.noop();
                        }
                        break;
                    case 15://done
                        self.windowOffsetTop = (self.zoomWindow.height() + (self.options.borderSize * 2)) * (-1); //DONE 12,13,14,15,16
                        self.windowOffsetLeft = (self.nzWidth - self.zoomWindow.width() - (self.options.borderSize * 2)); //DONE - 5,15
                        break;
                    case 16:  //done
                        self.windowOffsetTop = (self.zoomWindow.height() + (self.options.borderSize * 2)) * (-1); //DONE 12,13,14,15,16
                        self.windowOffsetLeft = (self.nzWidth); //DONE 1, 2, 3, 4, 16
                        break;
                    default: //done
                        self.windowOffsetTop = (self.options.zoomWindowOffsetY);//DONE - 1
                        self.windowOffsetLeft = (self.nzWidth); //DONE 1, 2, 3, 4, 16
                }
            } //end isNAN
            else {
                // For BC purposes, treat passed element as ID if element not found
                self.externalContainer = $(self.options.zoomWindowPosition);
                if (!self.externalContainer.length) {
                    self.externalContainer = $('#' + self.options.zoomWindowPosition);
                }

                self.externalContainerWidth = self.externalContainer.width();
                self.externalContainerHeight = self.externalContainer.height();
                self.externalContainerOffset = self.externalContainer.offset();

                self.windowOffsetTop = self.externalContainerOffset.top;//DONE - 1
                self.windowOffsetLeft = self.externalContainerOffset.left; //DONE 1, 2, 3, 4, 16

            }
            self.isWindowSet = true;
            self.windowOffsetTop = self.windowOffsetTop + self.options.zoomWindowOffsetY;
            self.windowOffsetLeft = self.windowOffsetLeft + self.options.zoomWindowOffsetX;

            self.zoomWindow.css({
                top: self.windowOffsetTop,
                left: self.windowOffsetLeft
            });

            if (self.options.zoomType === 'inner') {
                self.zoomWindow.css({
                    top: 0,
                    left: 0
                });

            }

            self.windowLeftPos = ((e.pageX - self.pageOffsetX - self.nzOffset.left) * self.widthRatio - self.zoomWindow.width() / 2) * -1;
            self.windowTopPos = ((e.pageY - self.pageOffsetY - self.nzOffset.top) * self.heightRatio - self.zoomWindow.height() / 2) * -1;
            if (self.Etoppos) {
                self.windowTopPos = 0;
            }
            if (self.Eloppos) {
                self.windowLeftPos = 0;
            }
            if (self.Eboppos) {
                self.windowTopPos = (self.largeHeight / self.currentZoomLevel - self.zoomWindow.height()) * (-1);
            }
            if (self.Eroppos) {
                self.windowLeftPos = ((self.largeWidth / self.currentZoomLevel - self.zoomWindow.width()) * (-1));
            }

            //stops micro movements
            if (self.fullheight) {
                self.windowTopPos = 0;
            }
            if (self.fullwidth) {
                self.windowLeftPos = 0;
            }

            //set the css background position
            if (self.options.zoomType === 'window' || self.options.zoomType === 'inner') {

                if (self.zoomLock === 1) {
                    //overrides for images not zoomable
                    if (self.widthRatio <= 1) {
                        self.windowLeftPos = 0;
                    }
                    if (self.heightRatio <= 1) {
                        self.windowTopPos = 0;
                    }
                }
                // adjust images less than the window height

                // if (self.options.zoomType === 'window') {
                //     if (self.largeHeight < self.options.zoomWindowHeight) {
                //         self.windowTopPos = 0;
                //     }
                //     if (self.largeWidth < self.options.zoomWindowWidth) {
                //         self.windowLeftPos = 0;
                //     }
                // }
                //set the zoomwindow background position
                if (self.options.easing) {

                    //     if(self.changeZoom){
                    //           clearInterval(self.loop);
                    //           self.changeZoom = false;
                    //           self.loop = false;

                    //            }
                    //set the pos to 0 if not set
                    if (!self.xp) {
                        self.xp = 0;
                    }
                    if (!self.yp) {
                        self.yp = 0;
                    }
                    var interval = 16;
                    var easingInterval = parseInt(self.options.easing);
                    if (typeof easingInterval === 'number' && isFinite(easingInterval) && Math.floor(easingInterval) === easingInterval) {
                        interval = easingInterval;
                    }
                    //if loop not already started, then run it
                    if (!self.loop) {
                        self.loop = setInterval(function () {
                            //using zeno's paradox

                            self.xp += (self.windowLeftPos - self.xp) / self.options.easingAmount;
                            self.yp += (self.windowTopPos - self.yp) / self.options.easingAmount;
                            if (self.scrollingLock) {

                                clearInterval(self.loop);
                                self.xp = self.windowLeftPos;
                                self.yp = self.windowTopPos;

                                self.xp = ((e.pageX - self.pageOffsetX - self.nzOffset.left) * self.widthRatio - self.zoomWindow.width() / 2) * (-1);
                                self.yp = (((e.pageY - self.pageOffsetY - self.nzOffset.top) * self.heightRatio - self.zoomWindow.height() / 2) * (-1));

                                if (self.changeBgSize) {
                                    if (self.nzHeight > self.nzWidth) {
                                        if (self.options.zoomType === 'lens') {
                                            self.zoomLens.css({
                                                backgroundSize: '' +
                                                    (self.largeWidth / self.newvalueheight) + 'px ' +
                                                    (self.largeHeight / self.newvalueheight) + 'px'
                                            });
                                        }
                                        self.zoomWindow.css({
                                            backgroundSize: '' +
                                                (self.largeWidth / self.newvalueheight) + 'px ' +
                                                (self.largeHeight / self.newvalueheight) + 'px'
                                        });
                                    }
                                    else {
                                        if (self.options.zoomType !== 'lens') {
                                            self.zoomLens.css({
                                                backgroundSize: '' +
                                                    (self.largeWidth / self.newvaluewidth) + 'px ' +
                                                    (self.largeHeight / self.newvalueheight) + 'px'
                                            });
                                        }
                                        self.zoomWindow.css({
                                            backgroundSize: '' +
                                                (self.largeWidth / self.newvaluewidth) + 'px ' +
                                                (self.largeHeight / self.newvaluewidth) + 'px'
                                        });
                                    }

                                    /*
                                     if(!self.bgxp){self.bgxp = self.largeWidth/self.newvalue;}
                                     if(!self.bgyp){self.bgyp = self.largeHeight/self.newvalue ;}
                                     if (!self.bgloop){
                                     self.bgloop = setInterval(function(){

                                     self.bgxp += (self.largeWidth/self.newvalue  - self.bgxp) / self.options.easingAmount;
                                     self.bgyp += (self.largeHeight/self.newvalue  - self.bgyp) / self.options.easingAmount;

                                     self.zoomWindow.css('background-size', self.bgxp + 'px ' + self.bgyp + 'px' );


                                     }, 16);

                                     }
                                     */
                                    self.changeBgSize = false;
                                }

                                self.zoomWindow.css({
                                    backgroundPosition: '' + self.windowLeftPos + 'px ' + self.windowTopPos + 'px'
                                });
                                self.scrollingLock = false;
                                self.loop = false;

                            }
                            else if (Math.round(Math.abs(self.xp - self.windowLeftPos) + Math.abs(self.yp - self.windowTopPos)) < 1) {
                                //stops micro movements
                                clearInterval(self.loop);
                                self.zoomWindow.css({
                                    backgroundPosition: '' + self.windowLeftPos + 'px ' + self.windowTopPos + 'px'
                                });
                                self.loop = false;
                            }
                            else {
                                if (self.changeBgSize) {
                                    if (self.nzHeight > self.nzWidth) {
                                        if (self.options.zoomType === 'lens') {
                                            self.zoomLens.css({
                                                backgroundSize: '' +
                                                (self.largeWidth / self.newvalueheight) + 'px ' +
                                                (self.largeHeight / self.newvalueheight) + 'px'
                                            });
                                        }
                                        self.zoomWindow.css({
                                            backgroundSize: '' +
                                            (self.largeWidth / self.newvalueheight) + 'px ' +
                                            (self.largeHeight / self.newvalueheight) + 'px'
                                        });
                                    }
                                    else {
                                        if (self.options.zoomType !== 'lens') {
                                            self.zoomLens.css({
                                                backgroundSize: '' +
                                                (self.largeWidth / self.newvaluewidth) + 'px ' +
                                                (self.largeHeight / self.newvaluewidth) + 'px'
                                            });
                                        }
                                        self.zoomWindow.css({
                                            backgroundSize: '' +
                                            (self.largeWidth / self.newvaluewidth) + 'px ' +
                                            (self.largeHeight / self.newvaluewidth) + 'px'
                                        });
                                    }
                                    self.changeBgSize = false;
                                }

                                self.zoomWindow.css({
                                    backgroundPosition: '' + self.xp + 'px ' + self.yp + 'px'
                                });
                            }
                        }, interval);
                    }
                }
                else {
                    if (self.changeBgSize) {
                        if (self.nzHeight > self.nzWidth) {
                            if (self.options.zoomType === 'lens') {
                                self.zoomLens.css({
                                    backgroundSize: '' +
                                    (self.largeWidth / self.newvalueheight) + 'px ' +
                                    (self.largeHeight / self.newvalueheight) + 'px'
                                });
                            }

                            self.zoomWindow.css({
                                backgroundSize: '' +
                                (self.largeWidth / self.newvalueheight) + 'px ' +
                                (self.largeHeight / self.newvalueheight) + 'px'
                            });
                        }
                        else {
                            if (self.options.zoomType === 'lens') {
                                self.zoomLens.css({
                                    backgroundSize: '' +
                                    (self.largeWidth / self.newvaluewidth) + 'px ' +
                                    (self.largeHeight / self.newvaluewidth) + 'px'
                                });
                            }
                            if ((self.largeHeight / self.newvaluewidth) < self.options.zoomWindowHeight) {

                                self.zoomWindow.css({
                                    backgroundSize: '' +
                                    (self.largeWidth / self.newvaluewidth) + 'px ' +
                                    (self.largeHeight / self.newvaluewidth) + 'px'
                                });
                            }
                            else {

                                self.zoomWindow.css({
                                    backgroundSize: '' +
                                    (self.largeWidth / self.newvalueheight) + 'px ' +
                                    (self.largeHeight / self.newvalueheight) + 'px'
                                });
                            }

                        }
                        self.changeBgSize = false;
                    }

                    self.zoomWindow.css({
                        backgroundPosition: '' +
                        self.windowLeftPos + 'px ' +
                        self.windowTopPos + 'px'
                    });
                }
            }
        },

        setTintPosition: function (e) {
            var self = this;
            var zoomLensWidth = self.zoomLens.width();
            var zoomLensHeight = self.zoomLens.height();
            self.updateOffset(self);
            self.tintpos = ((e.pageX - self.pageOffsetX - self.nzOffset.left) - (zoomLensWidth / 2)) * -1;
            self.tintposy = ((e.pageY - self.pageOffsetY - self.nzOffset.top) - zoomLensHeight / 2) * -1;
            if (self.Etoppos) {
                self.tintposy = 0;
            }
            if (self.Eloppos) {
                self.tintpos = 0;
            }
            if (self.Eboppos) {
                self.tintposy = (self.nzHeight - zoomLensHeight - (self.options.lensBorderSize * 2)) * (-1);
            }
            if (self.Eroppos) {
                self.tintpos = ((self.nzWidth - zoomLensWidth - (self.options.lensBorderSize * 2)) * (-1));
            }
            if (self.options.tint) {
                //stops micro movements
                if (self.fullheight) {
                    self.tintposy = 0;

                }
                if (self.fullwidth) {
                    self.tintpos = 0;

                }
                self.zoomTintImage.css({
                    left: self.tintpos,
                    top: self.tintposy
                });
            }
        },

        swaptheimage: function (smallimage, largeimage) {
            var self = this;
            var newImg = new Image();

            if (self.options.loadingIcon && !self.spinner) {
                var styleAttr = {
                    background: 'url("' + self.options.loadingIcon + '") no-repeat',
                    height: self.nzHeight,
                    width: self.nzWidth,
                    zIndex: 2000,
                    position: 'absolute',
                    backgroundPosition: 'center center',
                };
                if (self.options.zoomType === 'inner') {
                    styleAttr.setProperty('top', 0);
                }
                self.spinner = $('<div class="ezp-spinner"></div>')
                  .css(styleAttr);
                self.$elem.after(self.spinner);
            } else if (self.spinner) {
                self.spinner.show();
            }

            self.options.onImageSwap(self.$elem);

            newImg.onload = function () {
                self.largeWidth = newImg.width;
                self.largeHeight = newImg.height;
                self.zoomImage = largeimage;
                self.zoomWindow.css({
                    backgroundSize: '' + self.largeWidth + 'px ' + self.largeHeight + 'px'
                });

                self.swapAction(smallimage, largeimage);
                return;
            };
            self.setImageSource(newImg, largeimage);  // this must be done AFTER setting onload
        },

        swapAction: function (smallimage, largeimage) {
            var self = this;
            var elemWidth = self.$elem.width();
            var elemHeight = self.$elem.height();
            var newImg2 = new Image();
            newImg2.onload = function () {
                //re-calculate values
                self.nzHeight = newImg2.height;
                self.nzWidth = newImg2.width;
                self.options.onImageSwapComplete(self.$elem);

                self.doneCallback();
                return;
            };
            self.setImageSource(newImg2, smallimage);

            //reset the zoomlevel to that initially set in options
            self.currentZoomLevel = self.options.zoomLevel;
            self.options.maxZoomLevel = false;

            //swaps the main image
            //self.$elem.attr('src',smallimage);
            //swaps the zoom image
            if (self.options.zoomType === 'lens') {
                self.zoomLens.css('background-image', 'url("' + largeimage + '")');
            }
            if (self.options.zoomType === 'window') {
                self.zoomWindow.css('background-image', 'url("' + largeimage + '")');
            }
            if (self.options.zoomType === 'inner') {
                self.zoomWindow.css('background-image', 'url("' + largeimage + '")');
            }

            self.currentImage = largeimage;

            if (self.options.imageCrossfade) {
                var oldImg = self.$elem;
                var newImg = oldImg.clone();
                self.$elem.attr('src', smallimage);
                self.$elem.after(newImg);
                newImg.stop(true).fadeOut(self.options.imageCrossfade, function () {
                    $(this).remove();
                });

                // if(self.options.zoomType === 'inner'){
                //remove any attributes on the cloned image so we can resize later
                self.$elem.width('auto').removeAttr('width');
                self.$elem.height('auto').removeAttr('height');
                //   }

                oldImg.fadeIn(self.options.imageCrossfade);

                if (self.options.tint && self.options.zoomType !== 'inner') {

                    var oldImgTint = self.zoomTintImage;
                    var newImgTint = oldImgTint.clone();
                    self.zoomTintImage.attr('src', largeimage);
                    self.zoomTintImage.after(newImgTint);
                    newImgTint.stop(true).fadeOut(self.options.imageCrossfade, function () {
                        $(this).remove();
                    });

                    oldImgTint.fadeIn(self.options.imageCrossfade);

                    //self.zoomTintImage.attr('width',elem.data('image'));

                    //resize the tint window
                    self.zoomTint.css({
                        height: elemHeight,
                        width: elemWidth
                    });
                }

                self.zoomContainer.css({
                    'height': elemHeight,
                    'width': elemWidth
                });

                if (self.options.zoomType === 'inner') {
                    if (!self.options.constrainType) {
                        self.zoomWrap.parent().css({
                            'height': elemHeight,
                            'width': elemWidth
                        });

                        self.zoomWindow.css({
                            'height': elemHeight,
                            'width': elemWidth
                        });
                    }
                }

                if (self.options.imageCrossfade) {
                    self.zoomWrap.css({
                        'height': elemHeight,
                        'width': elemWidth
                    });
                }
            }
            else {
                self.$elem.attr('src', smallimage);
                if (self.options.tint) {
                    self.zoomTintImage.attr('src', largeimage);
                    //self.zoomTintImage.attr('width',elem.data('image'));
                    self.zoomTintImage.attr('height', elemHeight);
                    //self.zoomTintImage.attr('src') = elem.data('image');
                    self.zoomTintImage.css('height', elemHeight);
                    self.zoomTint.css('height', elemHeight);

                }
                self.zoomContainer.css({
                    'height': elemHeight,
                    'width': elemWidth
                });

                if (self.options.imageCrossfade) {
                    self.zoomWrap.css({
                        'height': elemHeight,
                        'width': elemWidth
                    });
                }
            }
            if (self.options.constrainType) {

                //This will contrain the image proportions
                if (self.options.constrainType === 'height') {

                    var autoWDimension = {
                        'height': self.options.constrainSize,
                        'width': 'auto'
                    };
                    self.zoomContainer.css(autoWDimension);

                    if (self.options.imageCrossfade) {
                        self.zoomWrap.css(autoWDimension);
                        self.constwidth = self.zoomWrap.width();
                    }
                    else {
                        self.$elem.css(autoWDimension);
                        self.constwidth = elemWidth;
                    }

                    var constWDim = {
                        'height': self.options.constrainSize,
                        'width': self.constwidth
                    };
                    if (self.options.zoomType === 'inner') {

                        self.zoomWrap.parent().css(constWDim);
                        self.zoomWindow.css(constWDim);
                    }
                    if (self.options.tint) {
                        self.tintContainer.css(constWDim);
                        self.zoomTint.css(constWDim);
                        self.zoomTintImage.css(constWDim);
                    }

                }
                if (self.options.constrainType === 'width') {
                    var autoHDimension = {
                        'height': 'auto',
                        'width': self.options.constrainSize
                    };
                    self.zoomContainer.css(autoHDimension);

                    if (self.options.imageCrossfade) {
                        self.zoomWrap.css(autoHDimension);
                        self.constheight = self.zoomWrap.height();
                    }
                    else {
                        self.$elem.css(autoHDimension);
                        self.constheight = elemHeight;
                    }

                    var constHDim = {
                        'height': self.constheight,
                        'width': self.options.constrainSize
                    };
                    if (self.options.zoomType === 'inner') {
                        self.zoomWrap.parent().css(constHDim);
                        self.zoomWindow.css(constHDim);
                    }
                    if (self.options.tint) {
                        self.tintContainer.css(constHDim);
                        self.zoomTint.css(constHDim);
                        self.zoomTintImage.css(constHDim);
                    }
                }
            }
        },

        doneCallback: function () {
            var self = this;
            if (self.options.loadingIcon && !!self.spinner && !!self.spinner.length) {
                self.spinner.hide();
            }

            self.updateOffset(self);
            self.nzWidth = self.$elem.width();
            self.nzHeight = self.$elem.height();

            // reset the zoomlevel back to default
            self.currentZoomLevel = self.options.zoomLevel;

            //ratio of the large to small image
            self.widthRatio = self.largeWidth / self.nzWidth;
            self.heightRatio = self.largeHeight / self.nzHeight;

            //NEED TO ADD THE LENS SIZE FOR ROUND
            // adjust images less than the window height
            if (self.options.zoomType === 'window') {

                if (self.nzHeight < self.options.zoomWindowHeight / self.heightRatio) {
                    self.lensHeight = self.nzHeight;

                }
                else {
                    self.lensHeight = self.options.zoomWindowHeight / self.heightRatio;
                }

                if (self.nzWidth < self.options.zoomWindowWidth) {
                    self.lensWidth = self.nzWidth;
                }
                else {
                    self.lensWidth = self.options.zoomWindowWidth / self.widthRatio;
                }

                if (self.zoomLens) {
                    self.zoomLens.css({
                        'width': self.lensWidth,
                        'height': self.lensHeight
                    });
                }
            }
        },

        getCurrentImage: function () {
            var self = this;
            return self.zoomImage;
        },

        getGalleryList: function () {
            var self = this;
            //loop through the gallery options and set them in list for fancybox
            self.gallerylist = [];
            if (self.options.gallery) {
                $('#' + self.options.gallery + ' a').each(function () {

                    var imgSrc = '';
                    if ($(this).data(self.options.attrImageZoomSrc)) {
                        imgSrc = $(this).data(self.options.attrImageZoomSrc);
                    }
                    else if ($(this).data('image')) {
                        imgSrc = $(this).data('image');
                    }
                    //put the current image at the start
                    if (imgSrc === self.zoomImage) {
                        self.gallerylist.unshift({
                            href: '' + imgSrc + '',
                            title: $(this).find('img').attr('title')
                        });
                    }
                    else {
                        self.gallerylist.push({
                            href: '' + imgSrc + '',
                            title: $(this).find('img').attr('title')
                        });
                    }
                });
            }
            //if no gallery - return current image
            else {
                self.gallerylist.push({
                    href: '' + self.zoomImage + '',
                    title: $(this).find('img').attr('title')
                });
            }
            return self.gallerylist;
        },

        changeZoomLevel: function (value) {
            var self = this;

            //flag a zoom, so can adjust the easing during setPosition
            self.scrollingLock = true;

            //round to two decimal places
            self.newvalue = parseFloat(value).toFixed(2);
            var newvalue = self.newvalue;

            //maxwidth & Maxheight of the image
            var maxheightnewvalue = self.largeHeight / ((self.options.zoomWindowHeight / self.nzHeight) * self.nzHeight);
            var maxwidthtnewvalue = self.largeWidth / ((self.options.zoomWindowWidth / self.nzWidth) * self.nzWidth);

            //calculate new heightratio
            if (self.options.zoomType !== 'inner') {
                if (maxheightnewvalue <= newvalue) {
                    self.heightRatio = (self.largeHeight / maxheightnewvalue) / self.nzHeight;
                    self.newvalueheight = maxheightnewvalue;
                    self.fullheight = true;
                }
                else {
                    self.heightRatio = (self.largeHeight / newvalue) / self.nzHeight;
                    self.newvalueheight = newvalue;
                    self.fullheight = false;
                }

                // calculate new width ratio

                if (maxwidthtnewvalue <= newvalue) {
                    self.widthRatio = (self.largeWidth / maxwidthtnewvalue) / self.nzWidth;
                    self.newvaluewidth = maxwidthtnewvalue;
                    self.fullwidth = true;
                }
                else {
                    self.widthRatio = (self.largeWidth / newvalue) / self.nzWidth;
                    self.newvaluewidth = newvalue;
                    self.fullwidth = false;
                }
                if (self.options.zoomType === 'lens') {
                    if (maxheightnewvalue <= newvalue) {
                        self.fullwidth = true;
                        self.newvaluewidth = maxheightnewvalue;
                    } else {
                        self.widthRatio = (self.largeWidth / newvalue) / self.nzWidth;
                        self.newvaluewidth = newvalue;

                        self.fullwidth = false;
                    }
                }
            }

            if (self.options.zoomType === 'inner') {
                maxheightnewvalue = parseFloat(self.largeHeight / self.nzHeight).toFixed(2);
                maxwidthtnewvalue = parseFloat(self.largeWidth / self.nzWidth).toFixed(2);
                if (newvalue > maxheightnewvalue) {
                    newvalue = maxheightnewvalue;
                }
                if (newvalue > maxwidthtnewvalue) {
                    newvalue = maxwidthtnewvalue;
                }

                if (maxheightnewvalue <= newvalue) {
                    self.heightRatio = (self.largeHeight / newvalue) / self.nzHeight;
                    if (newvalue > maxheightnewvalue) {
                        self.newvalueheight = maxheightnewvalue;
                    } else {
                        self.newvalueheight = newvalue;
                    }
                    self.fullheight = true;
                }
                else {
                    self.heightRatio = (self.largeHeight / newvalue) / self.nzHeight;

                    if (newvalue > maxheightnewvalue) {

                        self.newvalueheight = maxheightnewvalue;
                    } else {
                        self.newvalueheight = newvalue;
                    }
                    self.fullheight = false;
                }

                if (maxwidthtnewvalue <= newvalue) {

                    self.widthRatio = (self.largeWidth / newvalue) / self.nzWidth;
                    if (newvalue > maxwidthtnewvalue) {

                        self.newvaluewidth = maxwidthtnewvalue;
                    } else {
                        self.newvaluewidth = newvalue;
                    }

                    self.fullwidth = true;
                }
                else {
                    self.widthRatio = (self.largeWidth / newvalue) / self.nzWidth;
                    self.newvaluewidth = newvalue;
                    self.fullwidth = false;
                }
            } //end inner
            var scrcontinue = false;

            if (self.options.zoomType === 'inner') {
                if (self.nzWidth >= self.nzHeight) {
                    if (self.newvaluewidth <= maxwidthtnewvalue) {
                        scrcontinue = true;
                    }
                    else {
                        scrcontinue = false;
                        self.fullheight = true;
                        self.fullwidth = true;
                    }
                }
                if (self.nzHeight > self.nzWidth) {
                    if (self.newvaluewidth <= maxwidthtnewvalue) {
                        scrcontinue = true;
                    }
                    else {
                        scrcontinue = false;
                        self.fullheight = true;
                        self.fullwidth = true;
                    }
                }
            }

            if (self.options.zoomType !== 'inner') {
                scrcontinue = true;
            }

            if (scrcontinue) {
                self.zoomLock = 0;
                self.changeZoom = true;

                //if lens height is less than image height
                if (((self.options.zoomWindowHeight) / self.heightRatio) <= self.nzHeight) {
                    self.currentZoomLevel = self.newvalueheight;
                    if (self.options.zoomType !== 'lens' && self.options.zoomType !== 'inner') {
                        self.changeBgSize = true;
                        self.zoomLens.css({
                            height: self.options.zoomWindowHeight / self.heightRatio
                        });
                    }
                    if (self.options.zoomType === 'lens' || self.options.zoomType === 'inner') {
                        self.changeBgSize = true;
                    }
                }

                if ((self.options.zoomWindowWidth / self.widthRatio) <= self.nzWidth) {
                    if (self.options.zoomType !== 'inner') {
                        if (self.newvaluewidth > self.newvalueheight) {
                            self.currentZoomLevel = self.newvaluewidth;
                        }
                    }

                    if (self.options.zoomType !== 'lens' && self.options.zoomType !== 'inner') {
                        self.changeBgSize = true;

                        self.zoomLens.css({
                            width: self.options.zoomWindowWidth / self.widthRatio
                        });
                    }
                    if (self.options.zoomType === 'lens' || self.options.zoomType === 'inner') {
                        self.changeBgSize = true;
                    }

                }
                if (self.options.zoomType === 'inner') {
                    self.changeBgSize = true;

                    if (self.nzWidth > self.nzHeight) {
                        self.currentZoomLevel = self.newvaluewidth;
                    }
                    else if (self.nzHeight >= self.nzWidth) {
                        self.currentZoomLevel = self.newvaluewidth;
                    }
                }
            }      //under

            //sets the boundry change, called in setWindowPos
            self.setPosition(self.currentLoc);
            //
        },

        closeAll: function () {
            var self = this;
            if (self.zoomWindow) {
                self.zoomWindow.hide();
            }
            if (self.zoomLens) {
                self.zoomLens.hide();
            }
            if (self.zoomTint) {
                self.zoomTint.hide();
            }
        },
        updateOffset: function (self) {
            if (self.options.zoomContainerAppendTo !== 'body' && $(self.options.zoomContainerAppendTo).length > 0) {
                self.nzOffset = self.$elem.offset();
                var appendedPosition = $(self.options.zoomContainerAppendTo).offset();
                self.nzOffset.top = self.$elem.offset().top - appendedPosition.top;
                self.nzOffset.left = self.$elem.offset().left - appendedPosition.left;

                // NOTE: When initialising ezPlus on an element
                // present inside a dialog the positions will
                // not be correct unless the dialog occupies the
                // entire viewport. These page offsets will help
                // zoom lens and zoom window to be positioned
                // correctly

                // Update page offsets
                self.pageOffsetX = appendedPosition.left;
                self.pageOffsetY = appendedPosition.top;
            } else {
                self.nzOffset = self.$elem.offset();

                // Update page offsets
                self.pageOffsetX = 0;
                self.pageOffsetY = 0;
            }
        },

        changeState: function (value) {
            var self = this;
            if (value === 'enable') {
                self.options.zoomEnabled = true;
            }
            if (value === 'disable') {
                self.options.zoomEnabled = false;
            }
        },

        responsiveConfig: function (options) {
            if (options.respond && options.respond.length > 0) {
                return $.extend({}, options, this.configByScreenWidth(options));
            }
            return options;
        },

        configByScreenWidth: function (options) {
            var screenWidth = $(window).width();

            var config = $.grep(options.respond, function (item) {
                var range = item.range.split('-');
                return (screenWidth >= range[0]) && (screenWidth <= range[1]);
            });

            if (config.length > 0) {
                return config[0];
            } else {
                return options;
            }
        }
    };

    $.fn.ezPlus = function (options) {
        return this.each(function () {
            var elevate = Object.create(EZP);

            elevate.init(options, this);

            $.data(this, 'ezPlus', elevate);

        });
    };

    $.fn.ezPlus.options = {
        container: 'ZoomContainer',
        attrImageZoomSrc: 'zoom-image', // attribute to plugin use for zoom
        borderColour: '#888',
        borderSize: 4,
        constrainSize: false,  //in pixels the dimensions you want to constrain on
        constrainType: false,  //width or height
        containLensZoom: false,
        cursor: 'inherit', // user should set to what they want the cursor as, if they have set a click function
        debug: false,
        easing: false,
        easingAmount: 12,
        enabled: true,

        gallery: false,
        galleryActiveClass: 'zoomGalleryActive',
        gallerySelector: false,
        galleryItem: 'a',
        galleryEvent: 'click',

        imageCrossfade: false,

        lensBorderColour: '#000',
        lensBorderSize: 1,
        lensColour: 'white', //colour of the lens background
        lensFadeIn: false,
        lensFadeOut: false,
        lensOpacity: 0.4, //opacity of the lens
        lensShape: 'square', //can be 'round'
        lensSize: 200,
        lenszoom: false,

        loadingIcon: false, //http://www.example.com/spinner.gif

        // This change will allow to decide if you want to decrease
        // zoom of one of the dimensions once the other reached it's top value,
        // or keep the aspect ratio, default behaviour still being as always,
        // allow to continue zooming out, so it keeps retrocompatibility.
        mantainZoomAspectRatio: false,
        maxZoomLevel: false,
        minZoomLevel: 1.01,

        onComplete: $.noop,
        onDestroy: $.noop,
        onImageClick: $.noop,
        onImageSwap: $.noop,
        onImageSwapComplete: $.noop,
        onShow: $.noop,
        onHide: $.noop,
        onZoomedImageLoaded: $.noop,

        preloading: 1, //by default, load all the images, if 0, then only load images after activated (PLACEHOLDER FOR NEXT VERSION)
        respond: [],
        responsive: true,
        scrollZoom: false, //allow zoom on mousewheel, true to activate
        scrollZoomIncrement: 0.1,  //steps of the scrollzoom
        showLens: true,
        tint: false, //enable the tinting
        tintColour: '#333', //default tint color, can be anything, red, #ccc, rgb(0,0,0)
        tintOpacity: 0.4, //opacity of the tint
        touchEnabled: true,

        zoomActivation: 'hover', // Can also be click (PLACEHOLDER FOR NEXT VERSION)
        zoomContainerAppendTo: 'body', //zoom container parent selector
        zoomId: -1, // identifier for the zoom container
        zoomLevel: 1, //default zoom level of image
        zoomTintFadeIn: false,
        zoomTintFadeOut: false,
        zoomType: 'window', //window is default,  also 'lens' available -
        zoomWindowAlwaysShow: false,
        zoomWindowBgColour: '#fff',
        zoomWindowFadeIn: false,
        zoomWindowFadeOut: false,
        zoomWindowHeight: 400,
        zoomWindowOffsetX: 0,
        zoomWindowOffsetY: 0,
        zoomWindowPosition: 1, //Possible values: 1-16, but we can also position with a selector string.
        zoomWindowWidth: 400,
        zoomEnabled: true, //false disables zoomwindow from showing
        zIndex: 999
    };

})(window.jQuery, window, document);

/* instafeed.js | v2.0.0-rc3 | https://github.com/stevenschobert/instafeed.js | License: MIT */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).Instafeed=t()}(this,function(){"use strict";function e(e,t){if(!e)throw new Error(t)}function t(t){e(!t||"object"==typeof t,"options must be an object, got "+t+" ("+typeof t+")");var o={accessToken:null,accessTokenTimeout:1e4,after:null,apiTimeout:1e4,apiLimit:null,before:null,debug:!1,error:null,filter:null,limit:null,mock:!1,render:null,sort:null,success:null,target:"instafeed",template:'<a href="{{link}}"><img title="{{caption}}" src="{{image}}" /></a>',templateBoundaries:["{{","}}"],transform:null};if(t)for(var n in o)"undefined"!=typeof t[n]&&(o[n]=t[n]);e("string"==typeof o.target||"object"==typeof o.target,"target must be a string or DOM node, got "+o.target+" ("+typeof o.target+")"),e("string"==typeof o.accessToken||"function"==typeof o.accessToken,"accessToken must be a string or function, got "+o.accessToken+" ("+typeof o.accessToken+")"),e("number"==typeof o.accessTokenTimeout,"accessTokenTimeout must be a number, got "+o.accessTokenTimeout+" ("+typeof o.accessTokenTimeout+")"),e("number"==typeof o.apiTimeout,"apiTimeout must be a number, got "+o.apiTimeout+" ("+typeof o.apiTimeout+")"),e("boolean"==typeof o.debug,"debug must be true or false, got "+o.debug+" ("+typeof o.debug+")"),e("boolean"==typeof o.mock,"mock must be true or false, got "+o.mock+" ("+typeof o.mock+")"),e("object"==typeof o.templateBoundaries&&2===o.templateBoundaries.length&&"string"==typeof o.templateBoundaries[0]&&"string"==typeof o.templateBoundaries[1],"templateBoundaries must be an array of 2 strings, got "+o.templateBoundaries+" ("+typeof o.templateBoundaries+")"),e(!o.template||"string"==typeof o.template,"template must null or string, got "+o.template+" ("+typeof o.template+")"),e(!o.error||"function"==typeof o.error,"error must be null or function, got "+o.error+" ("+typeof o.error+")"),e(!o.before||"function"==typeof o.before,"before must be null or function, got "+o.before+" ("+typeof o.before+")"),e(!o.after||"function"==typeof o.after,"after must be null or function, got "+o.after+" ("+typeof o.after+")"),e(!o.success||"function"==typeof o.success,"success must be null or function, got "+o.success+" ("+typeof o.success+")"),e(!o.filter||"function"==typeof o.filter,"filter must be null or function, got "+o.filter+" ("+typeof o.filter+")"),e(!o.transform||"function"==typeof o.transform,"transform must be null or function, got "+o.transform+" ("+typeof o.transform+")"),e(!o.sort||"function"==typeof o.sort,"sort must be null or function, got "+o.sort+" ("+typeof o.sort+")"),e(!o.render||"function"==typeof o.render,"render must be null or function, got "+o.render+" ("+typeof o.render+")"),e(!o.limit||"number"==typeof o.limit,"limit must be null or number, got "+o.limit+" ("+typeof o.limit+")"),e(!o.apiLimit||"number"==typeof o.apiLimit,"apiLimit must null or number, got "+o.apiLimit+" ("+typeof o.apiLimit+")"),this._state={running:!1,node:null,token:null,paging:null,pool:[]},this._options=o}return t.prototype.run=function(){var e=this;return this._debug("run","options",this._options),this._debug("run","state",this._state),this._state.running?(this._debug("run","already running, skipping"),!1):(this._start(),this._debug("run","getting dom node"),"string"==typeof this._options.target?this._state.node=document.getElementById(this._options.target):this._state.node=this._options.target,this._state.node?(this._debug("run","got dom node",this._state.node),this._debug("run","getting access token"),this._getAccessToken(function(t,o){if(t)return e._debug("onTokenReceived","error",t),void e._fail(new Error("error getting access token: "+t.message));e._debug("onTokenReceived","got token",o),e._state.token=o,e._showNext(function(t){if(t)return e._debug("onNextShown","error",t),void e._fail(t);e._finish()})}),!0):(this._fail(new Error("no element found with ID "+this._options.target)),!1))},t.prototype.hasNext=function(){var e=this._state.paging,t=this._state.pool;return this._debug("hasNext","paging",e),this._debug("hasNext","pool",t.length,t),t.length>0||e&&"string"==typeof e.next},t.prototype.next=function(){var e=this;return e.hasNext()?e._state.running?(e._debug("next","already running, skipping"),!1):(e._start(),void e._showNext(function(t){if(t)return e._debug("onNextShown","error",t),void e._fail(t);e._finish()})):(e._debug("next","hasNext is false, skipping"),!1)},t.prototype._showNext=function(e){var t=this,o=null,n=null,i="number"==typeof this._options.limit;if(t._debug("showNext","pool",t._state.pool.length,t._state.pool),t._state.pool.length>0){if(n=i?t._state.pool.splice(0,t._options.limit):t._state.pool.splice(0),t._debug("showNext","items from pool",n.length,n),t._debug("showNext","updated pool",t._state.pool.length,t._state.pool),t._options.mock)t._debug("showNext","mock enabled, skipping render");else try{t._renderData(n)}catch(s){return void e(s)}e(null)}else t._state.paging&&"string"==typeof t._state.paging.next?o=t._state.paging.next:(o="https://graph.instagram.com/me/media?fields=caption,id,media_type,media_url,permalink,thumbnail_url,timestamp,username&access_token="+t._state.token,t._options.apiLimit||"number"!=typeof t._options.limit?"number"==typeof t._options.apiLimit&&(t._debug("showNext","apiLimit set, overriding limit",t._options.apiLimit,t._options.limit),o=o+"&limit="+t._options.apiLimit):(t._debug("showNext","no apiLimit set, falling back to limit",t._options.apiLimit,t._options.limit),o=o+"&limit="+t._options.limit)),t._debug("showNext","making request",o),t._makeApiRequest(o,function(o,n){var i=null;if(o)return t._debug("onResponseReceived","error",o),void e(new Error("api request error: "+o.message));t._debug("onResponseReceived","data",n),t._success(n),t._debug("onResponseReceived","setting paging",n.paging),t._state.paging=n.paging;try{if(i=t._processData(n),t._debug("onResponseReceived","processed data",i),i.unused&&i.unused.length>0){t._debug("onResponseReceived","saving unused to pool",i.unused.length,i.unused);for(var r=0;r<i.unused.length;r++)t._state.pool.push(i.unused[r])}}catch(a){return void e(a)}if(t._options.mock)t._debug("onResponseReceived","mock enabled, skipping append");else try{t._renderData(i.items)}catch(s){return void e(s)}e(null)})},t.prototype._processData=function(e){var t="function"==typeof this._options.transform,o="function"==typeof this._options.filter,n="function"==typeof this._options.sort,i="number"==typeof this._options.limit,s=[],r=null,a=null,u=null,l=null,p=null;if(this._debug("processData","hasFilter",o,"hasTransform",t,"hasSort",n,"hasLimit",i),"object"!=typeof e||"object"!=typeof e.data||e.data.length<=0)return null;for(var c=0;c<e.data.length;c++){if(a=this._getItemData(e.data[c]),t)try{u=this._options.transform(a),this._debug("processData","transformed item",a,u)}catch(f){throw this._debug("processData","error calling transform",f),new Error("error in transform: "+f.message)}else u=a;if(o){try{l=this._options.filter(u),this._debug("processData","filter item result",u,l)}catch(f){throw this._debug("processData","error calling filter",f),new Error("error in filter: "+f.message)}l&&s.push(u)}else s.push(u)}if(n)try{s.sort(this._options.sort)}catch(f){throw this._debug("processData","error calling sort",f),new Error("error in sort: "+f.message)}return i&&(r=s.length-this._options.limit,this._debug("processData","checking limit",s.length,this._options.limit,r),r>0&&(p=s.slice(s.length-r),this._debug("processData","unusedItems",p.length,p),s.splice(s.length-r,r))),{items:s,unused:p}},t.prototype._extractTags=function(e){var t=/#([^\s]+)/gi,o=/[~`!@#$%^&*\(\)\-\+={}\[\]:;"'<>\?,\./|\\\s]+/i,n=[],i=null;if("string"==typeof e)for(;null!==(i=t.exec(e));)!1===o.test(i[1])&&n.push(i[1]);return n},t.prototype._getItemData=function(e){var t=null,o=null;switch(e.media_type){case"IMAGE":t="image",o=e.media_url;break;case"VIDEO":t="video",o=e.thumbnail_url;break;case"CAROUSEL_ALBUM":t="album",o=e.media_url}return{caption:e.caption,tags:this._extractTags(e.caption),id:e.id,image:o,link:e.permalink,model:e,timestamp:e.timestamp,type:t,username:e.username}},t.prototype._renderData=function(e){var t="string"==typeof this._options.template,o="function"==typeof this._options.render,n=null,i=null,s=null,r="";if(this._debug("renderData","hasTemplate",t,"hasRender",o),!("object"!=typeof e||e.length<=0)){for(var a=0;a<e.length;a++){if(n=e[a],o)try{i=this._options.render(n,this._options),this._debug("renderData","custom render result",n,i)}catch(u){throw this._debug("renderData","error calling render",u),new Error("error in render: "+u.message)}else t&&(i=this._basicRender(n));i?r+=i:this._debug("renderData","render item did not return any content",n)}for(this._debug("renderData","html content",r),(s=document.createElement("div")).innerHTML=r,this._debug("renderData","container",s,s.childNodes.length,s.childNodes);s.childNodes.length>0;)this._debug("renderData","appending child",s.childNodes[0]),this._state.node.appendChild(s.childNodes[0])}},t.prototype._basicRender=function(e){for(var t=new RegExp(this._options.templateBoundaries[0]+"([\\s\\w.]+)"+this._options.templateBoundaries[1],"gm"),o=this._options.template,n=null,i="",s=0,r=null,a=null;null!==(n=t.exec(o));)r=n[1],i+=o.slice(s,n.index),(a=this._valueForKeyPath(r,e))&&(i+=a.toString()),s=t.lastIndex;return s<o.length&&(i+=o.slice(s,o.length)),i},t.prototype._valueForKeyPath=function(e,t){for(var o=/([\w]+)/gm,n=null,i=t;null!==(n=o.exec(e));){if("object"!=typeof i)return null;i=i[n[1]]}return i},t.prototype._fail=function(e){!this._runHook("error",e)&&console&&"function"==typeof console.error&&console.error(e),this._state.running=!1},t.prototype._start=function(){this._state.running=!0,this._runHook("before")},t.prototype._finish=function(){this._runHook("after"),this._state.running=!1},t.prototype._success=function(e){this._runHook("success",e),this._state.running=!1},t.prototype._makeApiRequest=function(e,t){var o=!1,n=this,i=null,s=function(e,n){o||(o=!0,t(e,n))};(i=new XMLHttpRequest).ontimeout=function(){s(new Error("api request timed out"))},i.onerror=function(){s(new Error("api connection error"))},i.onload=function(e){var t=i.getResponseHeader("Content-Type"),o=null;if(n._debug("apiRequestOnLoad","loaded",e),n._debug("apiRequestOnLoad","response status",i.status),n._debug("apiRequestOnLoad","response content type",t),t.indexOf("application/json")>=0)try{o=JSON.parse(i.responseText)}catch(r){return n._debug("apiRequestOnLoad","json parsing error",r,i.responseText),void s(new Error("error parsing response json"))}200===i.status?s(null,o):o&&o.error?s(new Error(o.error.code+" "+o.error.message)):s(new Error("status code "+i.status))},i.open("GET",e,!0),i.timeout=this._options.apiTimeout,i.send()},t.prototype._getAccessToken=function(e){var t=!1,o=this,n=null,i=function(o,i){t||(t=!0,clearTimeout(n),e(o,i))};if("function"==typeof this._options.accessToken){this._debug("getAccessToken","calling accessToken as function"),n=setTimeout(function(){o._debug("getAccessToken","timeout check",t),i(new Error("accessToken timed out"),null)},this._options.accessTokenTimeout);try{this._options.accessToken(function(e,n){o._debug("getAccessToken","received accessToken callback",t,e,n),i(e,n)})}catch(s){this._debug("getAccessToken","error invoking the accessToken as function",s),i(s,null)}}else this._debug("getAccessToken","treating accessToken as static",typeof this._options.accessToken),i(null,this._options.accessToken)},t.prototype._debug=function(){var e=null;this._options.debug&&console&&"function"==typeof console.log&&((e=[].slice.call(arguments))[0]="[Instafeed] ["+e[0]+"]",console.log.apply(null,e))},t.prototype._runHook=function(e,t){var o=!1;if("function"==typeof this._options[e])try{this._options[e](t),o=!0}catch(n){this._debug("runHook","error calling hook",e,n)}return o},t});
const jq = $.noConflict();

document.addEventListener('change', function(e) {
	const input = e.target;
	if (input.closest('.custom-form') && input.closest('label')) {
		if (input.type == 'radio') {
			input.closest('.form-group')?.querySelectorAll(`[name="${input.name}"]`).forEach(radio => {
				radio.checked == true ? radio.closest('label').classList.add('swatch-active') : radio.closest('label').classList.remove('swatch-active')
			})
		} else if (input.type == 'checkbox') {
			input.checked == true ? input.closest('label').classList.add('swatch-active') : input.closest('label').classList.remove('swatch-active');
		}
	}
})

document.addEventListener('click', (e) => {
	let target = e.target;
	if (!target.classList.contains('js-close-modal')) return;
	e.preventDefault();
	target.closest('.fancybox-container')?.querySelector('[data-fancybox-close]').click();
})

document.addEventListener('click', function(e) {
	let target = e.target.closest('a') || e.target;
	if (target.classList.contains('js-scroll-to') || target.classList.contains('js-scroll-to-bottom')) {
		target.blur();
		const targetId = target.getAttribute('href').replace('link', '');
		if (targetId.indexOf('#') !== -1 && document.querySelector(targetId)) {
			e.preventDefault();
			const bottomSticky = document.querySelector('.hdr-mobile-bottom'),
				bottomStickyH = (bottomSticky && bottomSticky.classList.contains('scroll-up')) ? 140 : 75,
				headerWrap = document.querySelector('.hdr-wrap'),
				headerSticky = document.querySelector('.hdr-content-sticky');
			let headerH = 0;
			if (headerWrap) {
				headerH = window.matchMedia(`(max-width:1024px)`).matches ? headerWrap.offsetHeight : (headerSticky ? headerSticky.offsetHeight : 0)
			}
			const targetIdTop = getCoords(document.querySelector(targetId)).top;
			let scrollPosition = target.classList.contains('js-scroll-to') ? targetIdTop - (targetIdTop > target.offsetTop ? 0 : headerH) : targetIdTop - window.innerHeight + headerH + 32 + bottomStickyH;
			if (target.dataset.scrollOffset > 0) scrollPosition += +target.dataset.scrollOffset;
			scrollPosition && smoothScrollTo(scrollPosition, 500);
		}
	}
})

document.addEventListener('click', function(e) {
	const target = e.target;
	if (target.nodeName == 'LABEL' && target.closest('.custom-form')) {
		let styleClass = 'inputClick';
		target.classList.add(styleClass);
		setTimeout(() => {target.classList.remove(styleClass)}, 250);
	} else if (target.dataset.clickTarget) {
		e.preventDefault();
		document.querySelector(target.dataset.clickTarget).click()
	} else if (target.closest('[data-disable-click]')) {
		e.preventDefault()
	}
})

const getSiblings = function (e) {
	let siblings = [];
	if (!e.parentNode) {
		return siblings;
	}
	let sibling = e.parentNode.firstChild;
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== e) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling;
	}
	return siblings;
};

const preloadImage = src => new Promise(function(resolve, reject) {
	const img = new Image();
	img.onload = function() {
		resolve(img);
	}
	img.onerror = reject;
	img.src = src;
})

const docCookies = {
	getItem: function (sKey) {
		return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
	},
	setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
		if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) return;
		let sExpires = "";
		if (vEnd) {
			switch (vEnd.constructor) {
				case Number:
					sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
					break;
				case String:
					sExpires = "; expires=" + vEnd;
					break;
				case Date:
					sExpires = "; expires=" + vEnd.toUTCString();
					break;
			}
		}
		document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
		return true;
	},
	removeItem: function (sKey, sPath, sDomain) {
		if (!sKey || !this.hasItem(sKey)) return;
		document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + ( sDomain ? "; domain=" + sDomain : "") + ( sPath ? "; path=" + sPath : "");
		return true;
	},
	hasItem: function (sKey) {
		return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
	}
}

const checkDevice = function () {
	let isTouchDevice = 'ontouchstart' in window || navigator.msMaxTouchPoints;
	const body = document.body,
		html = document.querySelector('html');
	body.classList.remove('android','win','mac','ie','safari','safari_version_below_14','touch');
	html.classList.remove('touch');
	body.dataset.damping = '0.1';
	const userAgent = navigator.userAgent;
	if (userAgent.indexOf('Windows') > 0) {
		body.classList.add('win');
		isTouchDevice = false;
	}
	if (isTouchDevice && window.matchMedia(`(max-width:1024px)`).matches) {
		body.classList.add('touch');
		html.classList.add('touch');
	}
	if (userAgent.indexOf('Mac') > 0) {
		body.classList.add('mac');
		let version = userAgent.indexOf("Version") + 8;
		if (userAgent.substring(version, version + 2) < 14) {
			body.classList.add('safari_version_below_14');
		}
		if (window.matchMedia(`(min-width:1025px)`).matches) {
			body.dataset.damping = '0.5'
		}
	}
	if (/\b(iPad|iPhone|iPod)\b/.test(userAgent) && /WebKit/.test(userAgent) && !/Edge/.test(userAgent) && !window.MSStream) {
		body.classList.add('safari');
		let viewportMeta = document.querySelector('meta[name="viewport"]');
		if (viewportMeta) viewportMeta.content = "width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1"
	}
	if (userAgent.match(/Android/)) {
		body.classList.add('android');
	}
	if (userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1) {
		body.classList.add('ie');
	}
}

function addResponsive(el = document) {
	el.querySelectorAll('table').forEach(el => {
		if (!el.closest('.table-responsive')) {
			el.classList.add('table');
			let wrap = document.createElement('div');
			wrap.classList.add('table-responsive');
			wrapHTML(el, wrap)
		}
	})

	el.querySelectorAll('iframe').forEach(el => {
		if (!el.closest('.bnslider') && !el.closest('embed-responsive') && (el.src.indexOf('youtube') != -1 || el.src.indexOf('vimeo') != -1)) {
			let wrap = document.createElement('div');
			wrap.classList.add('embed-responsive','embed-responsive-16by9');
			wrapHTML(el, wrap)
		}
	})
}

function loadImage(url) {
	return new Promise(resolve => {
		const image = new Image();
		image.addEventListener('load', () => {
			resolve(image);
		});
		image.src = url;
	})
}

function delay(time) {
	return new Promise(resolve => setTimeout(resolve, time));
}

function fadeIn( element, duration, callback = '' ) {
	element.style.opacity = 0;
	let last = +new Date();
	let tick = function() {
		element.style.opacity = +element.style.opacity + ( new Date() - last ) / duration;
		last = +new Date();
		if ( +element.style.opacity < 1 )
			( window.requestAnimationFrame && requestAnimationFrame( tick ) ) || setTimeout( tick, 16 );
		else if ( callback !== '' )
			callback();
	};
	tick();
}

function fadeOut( element, duration, callback = '' ) {
	element.style.opacity = 1;
	let last = +new Date();
	let tick = function() {
		element.style.opacity = +element.style.opacity - ( new Date() - last ) / duration;
		last = +new Date();
		if ( +element.style.opacity > 0 )
			( window.requestAnimationFrame && requestAnimationFrame( tick ) ) || setTimeout( tick, 16 );
		else if ( callback !== '' )
			callback();
	};
	tick();
}

function smoothScrollTo(to, duration) {
	const el = document.scrollingElement || document.documentElement,
		start = el.scrollTop,
		change = to - start,
		startTs = performance.now(),
		easeInOutQuad = function(t, b, c, d) {
			t /= d/2;
			if (t < 1) return c/2*t*t + b;
			t--;
			return -c/2 * (t*(t-2) - 1) + b;
		},
		animateScroll = function(ts) {
			let currentTime = ts - startTs;
			el.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
			if (currentTime < duration) {
				requestAnimationFrame(animateScroll);
			}
			else {
				el.scrollTop = to;
			}
		};
	if (document.body.classList.contains('has-hdr_sticky') && customElements.get('header-sticky')) document.body.querySelector('header-sticky')?.destroySticky();
	document.body.classList.add('blockSticky');
	setTimeout(() => {document.body.classList.remove('blockSticky')}, duration*1.5);
	requestAnimationFrame(animateScroll);
}

function debounce(func, wait, immediate) {
	let timeout;
	return function() {
		const context = this, args = arguments;
		const later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	}
}

function removeClassByPrefix(node, className) {
	[...node.classList].forEach(v => {
		if (v.startsWith(className)) {
			node.classList.remove(v)
		}
	})
}

function removeClassBySuffix(node, className) {
	[...node.classList].forEach(v => {
		if (v.endsWith(className)) {
			node.classList.remove(v)
		}
	})
}

function setStyle(node, propertyObject) {
	if (!node) return false;
	for (let property in propertyObject) node.style[property] = propertyObject[property]
}

function calcScrollWidth() {
	const outer = document.createElement('div');
	outer.style.visibility = 'hidden';
	outer.style.overflow = 'scroll';
	outer.style.msOverflowStyle = 'scrollbar';
	document.body.appendChild(outer);
	const inner = document.createElement('div');
	outer.appendChild(inner);
	const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
	outer.parentNode.removeChild(outer);
	document.body.dataset.scrollbarWidth = scrollbarWidth;
	return scrollbarWidth;
}

function setVHStart(resize) {
	if (!document.getElementById('control-height')) return;
	const actualHeight = window.innerHeight,
		controlH = document.getElementById('control-height').offsetHeight,
		html = document.getElementsByTagName('html')[0],
		vhStart = actualHeight * 0.01;
	if (!resize) {
		const bodyElement = document.body;
		html.style.setProperty('--bar-start-height', (controlH - actualHeight) + 'px');
		html.style.setProperty('--start-height', controlH + 'px');
		if (document.querySelector('.hdr-transparent')) {
			bodyElement.classList.add('has-transparent-hdr')
		} else bodyElement.classList.remove('has-transparent-hdr')
	}
	html.style.setProperty('--vhStart', vhStart + 'px');
}

function setVH() {
	const html = document.getElementsByTagName('html')[0],
		header = document.querySelector('.hdr-transparent') ? document.querySelector('.hdr .hdr-content') : document.querySelector('.hdr'),
		headerBottom = document.querySelector('.hdr-mobile-bottom'),
		underSlider = document.querySelector('[data-slider-under]'),
		actualHeight = window.innerHeight,
		vh = actualHeight * 0.01,
		barHeight = document.getElementById('control-height') ? document.getElementById('control-height').offsetHeight - actualHeight : 0,
		hPromoH = document.querySelector('.hdr-promoline') ? document.querySelector('.hdr-promoline').offsetHeight : 0,
		hToplineH = document.querySelector('.hdr-topline') ? document.querySelector('.hdr-topline').offsetHeight : 0,
		hSliderUnder = underSlider ? underSlider.offsetHeight + parseInt(window.getComputedStyle(underSlider).getPropertyValue('margin-top'),10) : 0;
	let hHeight = header ? (header.offsetHeight + hPromoH) : 0,
		mobilePanelH = 0;
	if (window.matchMedia(`(max-width:1024px)`).matches) {
		hHeight = header ? (header.offsetHeight + hToplineH) : 0;
		mobilePanelH = headerBottom ? headerBottom.offsetHeight : 0;
	}
	html.style.setProperty('--vh', vh + 'px');
	html.style.setProperty('--bar-height', barHeight + 'px');
	html.style.setProperty('--scroll-width', calcScrollWidth() + 'px');
	html.style.setProperty('--header-height', hHeight + 'px');
	html.style.setProperty('--header-promo-height', hPromoH + 'px');
	html.style.setProperty('--slider-under-height', hSliderUnder + 'px');
	html.style.setProperty('--mobile-panel-height', mobilePanelH + 'px');
	document.querySelectorAll('.js-set-height').forEach(el => {
		if (el.querySelector('[data-block-handle="reviews"]')) {
			el.style.setProperty('--tab-height', 'auto')
		} else el.style.setProperty('--tab-height', el.scrollHeight + 'px');
		const textarea = el.querySelector('textarea-autosize');
		if (textarea) el.dataset.tabh = el.scrollHeight - textarea.querySelector('.form-control').scrollHeight
	});
	document.body.dataset.setRoot = true;
	document.body.dataset.innerHeight = window.innerHeight;
	document.body.dataset.barHeight = barHeight;
	document.body.dataset.innerWidth = window.innerWidth
}

function inViewportTop (el) {
	if (!el) return false;
	if (1 !== el.nodeType) return false;
	let rect = el.getBoundingClientRect();
	return !!rect && rect.bottom >= 0;
}

function inViewportBottom (el) {
	if (!el) return false;
	if (1 !== el.nodeType) return false;
	let html = document.documentElement, rect = el.getBoundingClientRect();
	return !!rect && rect.top <= html.clientHeight;
}

function getCoords(el) {
	const box = el.getBoundingClientRect(),
		body = document.body,
		docEl = document.documentElement,
		scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop,
		scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft,
		clientTop = docEl.clientTop || body.clientTop || 0,
		clientLeft = docEl.clientLeft || body.clientLeft || 0;
	return { top: Math.round(box.top +  scrollTop - clientTop), left: Math.round(box.left + scrollLeft - clientLeft) };
}

function wrapHTML(el, wrapper) {
	el.parentNode.insertBefore(wrapper, el);
	wrapper.appendChild(el);
}

function highlightText(what, node) {
	const nodeList = node.childNodes;
	for (var x = 0; x < nodeList.length; x++) {
		if (nodeList[x].nodeType == 3) {
			if (nodeList[x].textContent.toLowerCase().indexOf(what.toLowerCase()) >= 0) {
				let replacement = '<mark>'+what+'</mark>',
					textBlock = nodeList[x].textContent,
					searchIndex = nodeList[x].textContent.toLowerCase().indexOf(what.toLowerCase());
				while(searchIndex >= 0){
					cut = textBlock.substring(searchIndex, searchIndex + what.length);
					replacement = '<mark>'+cut+'</mark>';
					textBlock = textBlock.substring(0, searchIndex) + replacement + textBlock.substring(searchIndex + what.length, textBlock.length);
					searchIndex = textBlock.toLowerCase().indexOf(what.toLowerCase(), (searchIndex + replacement.length));
				}
				let replacementNode = document.createElement("span");
				replacementNode.innerHTML = textBlock;
				let parentN = nodeList[x].parentNode;
				parentN.replaceChild(replacementNode, parentN.childNodes[x]);
			}
		} else {
			highlightText(what, nodeList[x]);
		}
	}
}

class MasonryGrid extends HTMLElement {
	constructor() {
		super();
		this.classList.add('lazyload');
		this._sizes = [];
		this._columns = [];
		this._container = null;
		this._count = null;
		this._width = 0;
		this._removeListener = null;
		this._rtl = document.body.classList.contains('rtl-mode') ? true : false;
		this._resizeTimeout = null,
			this.initialized = false,
			this.conf = {
				baseWidth: +this.dataset.masonrySize || 300,
				gutterX: +this.dataset.masonryGutter || 30,
				gutterY: +this.dataset.masonryGutter || 30,
				container: '.masonry-grid-container',
				minify: true,
				ultimateGutter: 15,
				surroundingGutter: false,
				direction: 'ltr',
				wedge: false
			};
		this.init(0);
		window.addEventListener('resize', debounce(() => {
			this.init(100)
		}, 15));
		this.addEventListener('lazyloaded', () => {
			this.layout()
		}, { once: true });
		const lazyImages = this.querySelectorAll('.lazyload');
		if (lazyImages.length) {
			lazyImages[lazyImages.length - 1].addEventListener('lazyloaded', () => {
				this.layout()
			})
		}
	}
	init(delay) {
		this._container = typeof this.conf.container == 'object' && this.conf.container.nodeName ? this.conf.container : document.querySelector(this.conf.container);
		if (!this._container)  return;
		if (this.dataset.masonryColumn) {
			this.conf.baseWidth = (this.offsetWidth - this.conf.gutterX * (+this.dataset.masonryColumn - 1)) / +this.dataset.masonryColumn
		}
		if (this.dataset.masonryColumnResponsive) {
			const breikpoints = JSON.parse(this.dataset.masonryColumnResponsive);
			for (let key in breikpoints) {
				if (window.matchMedia(`(max-width: ${key}px)`).matches) {
					this.conf.baseWidth = (this.offsetWidth - this.conf.gutterX * (+breikpoints[key] - 1)) / +breikpoints[key];
					break;
				}
			}
		}
		if (this.dataset.masonryDestroyBreikpoint) {
			if (!window.matchMedia(`(max-width: ${+this.dataset.masonryDestroyBreikpoint}px)`).matches) {
				if (!this.initialized) {
					this.initialized = true;
					setTimeout(() => {
						this.layout()
					}, delay);
				} else if (this._container.clientWidth != this._width) {
					this.layout()
				}
			} else {
				this.initialized && this.destroy();
				this.initialized = false
			}
		} else {
			if (!this.initialized) {
				this.initialized = true;
				setTimeout(() => {
					this.layout()
				}, delay);
			} else if (this._container.clientWidth != this._width) {
				this.layout()
			}
		}
	}
	reInit() {
		if (this.dataset.masonryDestroyBreikpoint && window.matchMedia(`(max-width: ${+this.dataset.masonryDestroyBreikpoint}px)`).matches) return;
		setTimeout(() => {
			this.layout()
		}, 200)
	}
	reset() {
		this._sizes = [];
		this._columns = [];
		this._count = null;
		this._width = this._container.clientWidth;
		this._gutterX = this.conf.gutterX;
		let minWidth = this.conf.baseWidth;
		if (this._width < minWidth) {
			this._width = minWidth;
			this._container.style.minWidth = minWidth + 'px';
		}
		if (this.getCount() == 1) {
			this._gutterX = this.conf.ultimateGutter;
			this._count = 1;
		}
		if (this._width < (this.conf.baseWidth + (2 * this.conf.gutterX))) this._gutterX = 0;
	}
	getCount() {
		if (this.conf.surroundingGutter) return Math.floor((this._width - this._gutterX) / (this.conf.baseWidth + this._gutterX));
		return Math.floor((this._width + this._gutterX) / (this.conf.baseWidth + this._gutterX))
	}
	computeWidth() {
		let width = this.conf.surroundingGutter ? ((this._width - this._gutterX) / this._count) - this._gutterX : ((this._width + this._gutterX) / this._count) - this._gutterX;
		return Number.parseFloat((width).toFixed(2))
	}
	layout() {
		if (!this._container) return;
		this.reset();
		if (this._count == null) this._count = this.getCount();
		let colWidth = this.computeWidth();
		for (let i = 0; i < this._count; i++) {
			this._columns[i] = 0;
		}
		let children = this._container.children;
		for (let k = 0; k < children.length; k++) {
			children[k].style.width = colWidth + 'px';
			this._sizes[k] = children[k].clientHeight;
		}
		let startX = this.conf.direction == 'ltr' ? (this.conf.surroundingGutter ? this._gutterX : 0) : (this._width - (this.conf.surroundingGutter ? this._gutterX : 0));
		if (this._count > this._sizes.length) {
			let occupiedSpace = (this._sizes.length * (colWidth + this._gutterX)) - this._gutterX;
			if (this.conf.wedge === false) {
				if (this.conf.direction == 'ltr') {
					startX = ((this._width - occupiedSpace) / 2);
				} else {
					startX = this._width - ((this._width - occupiedSpace) / 2);
				}
			} else if (!this.conf.direction == 'ltr') {
				startX = this._width - this._gutterX
			}
		}
		for (let index = 0; index < children.length; index++) {
			const nextColumn = this.conf.minify ? this.getShortest() : this.getNextColumn(index),
				childrenGutter = (this.conf.surroundingGutter || nextColumn != this._columns.length) ? this._gutterX : 0,
				x = this.conf.direction == 'ltr' ? startX + ((colWidth + childrenGutter) * (nextColumn)) : startX - ((colWidth + childrenGutter) * (nextColumn)) - colWidth,
				y = this._columns[nextColumn];
			children[index].style.transform = 'translate3d(' + (this._rtl ? -Math.round(x) : Math.round(x)) + 'px,' + Math.round(y) + 'px,0)';
			this._columns[nextColumn] += this._sizes[index] + (this._count > 1 ? this.conf.gutterY : this.conf.ultimateGutter)
		}
		this._container.style.height = (this._columns[this.getLongest()] - this.conf.gutterY) + 'px';
		this._container.classList.add('masonry-initialized')
	}
	getNextColumn(index) {
		return index % this._columns.length;
	}
	getShortest() {
		let shortest = 0;
		for (let i = 0; i < this._count; i++) {
			if (this._columns[i] < this._columns[shortest]) {
				shortest = i;
			}
		}
		return shortest;
	}
	getLongest() {
		var longest = 0;
		for (let i = 0; i < this._count; i++) {
			if (this._columns[i] > this._columns[longest]) {
				longest = i;
			}
		}
		return longest;
	}
	destroy() {
		if (typeof this._removeListener == "function") {
			this._removeListener();
		}
		let children = this._container.children;
		for (let k = 0; k < children.length; k++) {
			children[k].style.removeProperty('width');
			children[k].style.removeProperty('transform');
		}
		this._container.style.removeProperty('height');
		this._container.style.removeProperty('min-width');
		this._container.classList.remove('masonry-initialized')
	}

}
customElements.define('masonry-grid', MasonryGrid)

class FaqSection extends HTMLElement {
	constructor() {
		super();
		this.searchInput = this.querySelector('.js-faq-input');
		if(this.searchInput) {
			this.searchInput.addEventListener('change', () => {
				this.searchIt();
			})
			this.searchInput.addEventListener('input', () => {
				this.searchIt();
			})
		}
		this.querySelector('.js-faq-search-form')?.addEventListener('submit', (e) => {
			e.preventDefault()
			this.searchIt();
		})
		this.querySelectorAll('.js-tab-faq a').forEach(
			(link) => link.addEventListener('click', (e) => {
				let li = link.closest('li'),
					parent = li.closest('.js-tab-faq'),
					tab_id = link.dataset.tab;
				if(this.searchInput) {
					this.searchInput.value = '';
					this.resetSearch();
				}
				this.querySelectorAll('.faq-tab-content').forEach(
					(tab) => tab.classList.remove('opened')
				)
				this.querySelector(`#${tab_id}`).classList.add('opened');
				parent.querySelectorAll('li').forEach(
					(li) => li.classList.remove('is-current')
				)
				li.classList.add('is-current');
				e.preventDefault();
			})
		)
	}
	resetSearch() {
		let s = this.querySelector('.form-message--success'),
			e = this.querySelector('.form-message--error'),
			r = this.querySelector('.search-result'),
			c = this.querySelector('.tabs-content');
		e?.classList.add('d-none');
		s?.classList.add('d-none');
		r?.classList.add('d-none');
		c?.classList.remove('d-none');
		this.querySelector('.js-tab-faq li.is-current')?.classList.remove('is-current--off');
	}
	searchIt() {
		const input = this.querySelector('.js-faq-input'),
			infoSuccess = this.querySelector('.form-message--success'),
			infoError = this.querySelector('.form-message--error'),
			searchResult = this.querySelector('.search-result'),
			tabsContent = this.querySelector('.tabs-content'),
			tabs = this.querySelectorAll('.faq-tab-content'),
			item = tabsContent.querySelectorAll('.faq-item');
		searchResult.innerHTML = '';
		let v = input.value;
		if(v.length < 2) {
			this.resetSearch(this)
			return false;
		}
		let text = tabsContent.innerText,
			letterCount = this.countInstances(text.toLowerCase(), v.toLowerCase());
		if(letterCount > 0){
			searchResult.classList.remove('d-none');
			tabsContent.classList.add('d-none');
			infoSuccess.querySelector('b').innerHTML = letterCount;
			infoSuccess.classList.remove('d-none');
			infoError.classList.add('d-none');
			if(letterCount > 1){
				infoSuccess.classList.add('has-plural');
				infoSuccess.classList.remove('has-single');
			} else {
				infoSuccess.classList.add('has-single');
				infoSuccess.classList.remove('has-plural');
			}
			item.forEach((item) => {
				let text = item.innerText.toLowerCase();
				if(text.includes(v.toLowerCase())){
					searchResult.innerHTML += item.outerHTML;
				}
			});
			this.querySelector('.js-tab-faq li.is-current')?.classList.add('is-current--off');
			highlightText(v, searchResult);
		} else {
			this.resetSearch();
			infoError.classList.remove('d-none');
		}
	}
	countInstances(string, word) {
		return string.split(word).length - 1;
	}
}
customElements.define('faq-section',FaqSection)

class CatalogSection extends HTMLElement {
	constructor() {
		super();
		this.searchInput = this.querySelector('.js-catalog-input');
		if(this.searchInput) {
			this.searchInput.addEventListener('change', () => {
				this.searchIt();
			})
			this.searchInput.addEventListener('input', () => {
				this.searchIt();
			})
		}
		this.querySelector('.js-catalog-search-form')?.addEventListener('submit', (e) => {
			e.preventDefault()
			this.searchIt();
		})
	}
	resetSearch() {
		let s = this.querySelector('.form-message--success'),
			e = this.querySelector('.form-message--error'),
			r = this.querySelector('.search-result'),
			c = this.querySelector('.tabs-content');
		e?.classList.add('d-none');
		s?.classList.add('d-none');
		r?.classList.add('d-none');
		c?.classList.remove('d-none');
		this.classList.remove('is-filtered');
		this.querySelector('.js-tab-faq li.is-current')?.classList.remove('is-current--off');
	}
	searchIt() {
		const input = this.querySelector('.js-catalog-input'),
			infoSuccess = this.querySelector('.form-message--success'),
			infoError = this.querySelector('.form-message--error'),
			searchResult = this.querySelector('.search-result'),
			tabsContent = this.querySelector('.tabs-content'),
			item = tabsContent.querySelectorAll('.col');
		searchResult.innerHTML = '';
		let v = input.value;
		if(v.length < 2) {
			this.resetSearch(this)
			return false;
		}
		let text = tabsContent.innerText,
			letterCount = this.countInstances(text.toLowerCase(), v.toLowerCase());
		if (letterCount > 0){
			searchResult.classList.remove('d-none');
			tabsContent.classList.add('d-none');
			infoSuccess.querySelector('b').innerHTML = letterCount;
			infoSuccess.classList.remove('d-none');
			infoError.classList.add('d-none');
			if(letterCount > 1){
				infoSuccess.classList.add('has-plural');
				infoSuccess.classList.remove('has-single');
			} else {
				infoSuccess.classList.add('has-single');
				infoSuccess.classList.remove('has-plural');
			}
			item.forEach((item) => {
				let text = item.innerText.toLowerCase();
				if (text.includes(v.toLowerCase())){
					searchResult.innerHTML += item.outerHTML;
				}
			});
			this.querySelector('.js-tab-faq li.is-current')?.classList.add('is-current--off');
			highlightText(v, searchResult);
			this.classList.add('is-filtered')
		} else {
			this.resetSearch();
			infoError.classList.remove('d-none');
		}
	}
	countInstances(string, word) {
		return string.split(word).length - 1;
	}
}
customElements.define('catalog-section',CatalogSection)

class InstagramFeed extends HTMLElement {
	connectedCallback() {
		this.container = this.querySelector('.js-instagram-feed');
		this.widthXXL = this.container.hasAttribute('data-xxl');
		if (!this.container.querySelector('.instagram-item')) {
			this.token = this.container.dataset.token;
			this.limit = parseInt(this.container.dataset.limit, 10);
			this.tag = this.container.dataset.tag;
			this.carousel = this.querySelector('.swiper-container');
			if (this.carousel) {
				if (this.container.hasAttribute('data-static')) {
					this.startCarousel();
				} else {
					this.init();
					const doStuff = (timer) => {
						if (this.container.querySelector('img')) {
							clearInterval(timer);
							this.startCarousel();
						}
					}
					let timer = setInterval(function () {
						doStuff(timer);
					}, 100)
				}
			} else this.init();
		}
	}
	init() {
		let count = 0;
		let userFeed = new Instafeed({
			get: 'user',
			target: this.container,
			accessToken: this.token,
			resolution: 'low_resolution',
			template: this.querySelector('template').innerHTML,
			links: false,
			templateBoundaries: ["{#", "#}"],
			limit: 500,
			after: () => {
				if (this.querySelector('smart-row')) this.querySelector('smart-row').init();
			},
			filter: (image) => {
				const hasTag = (this.tag == '') || (image.tags.indexOf(this.tag) >= 0);
				if (hasTag) count++;
				return hasTag && count <= this.limit
			}
		});
		userFeed.run()
	}
	startCarousel() {
		new Swiper(this.carousel, {
			navigation: {
				nextEl: this.querySelector('.swiper-button-next'),
				prevEl: this.querySelector('.swiper-button-prev')
			},
			loop: false,
			touchRatio: 3,
			watchOverflow: true,
			slidesPerView: 3,
			spaceBetween: 10,
			centerInsufficientSlides: true,
			breakpoints: {
				375: {
					slidesPerView: 4,
					spaceBetween: 10,
				},
				768: {
					slidesPerView: 5,
					spaceBetween: 10,
				},
				992: {
					slidesPerView: 6,
					spaceBetween: 10,
				},
				1200: {
					slidesPerView: 8,
					spaceBetween: 10,
				},
				1465: {
					slidesPerView: this.widthXXL ? 10 : 8,
					spaceBetween: 10,
				},
				1700: {
					slidesPerView: this.widthXXL ? 12 : 8,
					spaceBetween: 10,
				}
			},
			on: {
				init: function () {
					if (typeof Waypoint !== 'undefined') {
						Waypoint.refreshAll();
					}
				}
			}
		})
	}
}
customElements.define('instagram-feed', InstagramFeed)


class MenuCategories extends HTMLElement {
	constructor() {
		super();
		const parent = this.closest('.shopify-section');
		if (parent) {
			this.addEventListener('mouseenter', () => {
				parent.classList.add('to-upper')
			});
			this.addEventListener('mouseleave', () => {
				parent.classList.remove('to-upper')
			})
		}
		this.submenu = this.querySelectorAll('.submenu-list li');
		this.submenu.forEach(link => link.addEventListener('mouseenter', this.onSubmenuMouseEnter.bind(this)));
	}
	onSubmenuMouseEnter(e) {
		let target = e.currentTarget;
		const link = target.querySelector('a'),
			previewImage = link.dataset.preview;
		if (target.querySelector('.submenu-list-wrap--image') && previewImage && !link.dataset.loaded) {
			preloadImage(previewImage)
				.then(img => {
					target.querySelector('.submenu-list-wrap--image .image-container')?.append(img);
					target.querySelector('[data-load]')?.setAttribute('data-load', 'loaded');
					link.dataset.loaded = true
				})
				.catch(error => console.error('error', error));
		}
	}
}
customElements.define('menu-categories', MenuCategories);

class TabSlider extends HTMLElement {
	constructor() {
		super();
		this.tabs = this.querySelector('.tabs-wrap');
		this.tab = this.querySelectorAll('.tabs-item');
		this.track = this.querySelector('.tabs-wrap-track');
		this.tabContents = this.querySelectorAll('.tab-content');
		this.tabContentsWrap = this.querySelector('.tab-content-wrap');
		this.tabContentsWrap.classList.add('transparent');
		this.initStart();
	}
	init() {
		this.tabs.querySelector('.tabs-wrap-track-after').classList.add('hidden');
		if (this.tab.length > 0) this.onTabClick(this.tabs.querySelector('.active'));
		setTimeout(() => {
			this.shiftSelector();
			this.tabs.querySelector('.tabs-wrap-track-after').classList.remove('hidden');
		}, 500)
	}
	initStart() {
		this.setScrollbar();
		this.tab.forEach(el => {
			el.addEventListener('click', (e) => {e.preventDefault();this.onTabClick(el)});
			el.addEventListener('mouseenter', function() {
				if (this.classList.contains('active')) return;
				this.closest('.tabs-wrap').classList.add('hovered')
			});
			el.addEventListener('mouseleave', function() {
				this.closest('.tabs-wrap').classList.remove('hovered')
			});
			const observer = new MutationObserver(() => {this.shiftSelector()});
			observer.observe(el, {characterData: true, childList: true})
		});
		this.tabContents.forEach(el => {
			if (!el.classList.contains('ajax-loaded')) {
				const tpl = el.hasAttribute('data-empty') ? this.querySelector('.tabSlideTemplateEmpty') : this.querySelector('.tabSlideTemplate');
				if (tpl) el.appendChild(document.importNode(tpl.content, true));
			}
		});
		window.addEventListener('resize', debounce(() => {
			this.setScrollbar();
			this.setTabWrapHeight(true);
			this.shiftSelector()
		}, 500));
		if (this.tab.length > 0) this.onTabClick(this.tabs.querySelector('.active'));
		setTimeout(() => {
			this.tabContentsWrap.classList.remove('transparent')
		}, 500)
	}
	setScrollbar() {
		if (this.track.offsetWidth > this.tabs.offsetWidth ) {
			const options =  {
				loop: false,
				watchOverflow: true,
				touchRatio: 1,
				watchSlidesVisibility: true,
				slidesPerView: 'auto',
				edgeSwipeThreshold: 40,
				setWrapperSize: true,
				slideToClickedSlide: true,
				updateOnWindowResize: true,
				slideClass: 'tabs-item',
				wrapperClass: 'tabs-wrap-track',
				scrollbar: {
					el: this.querySelector('.swiper-scrollbar'),
					draggable: true,
					dragSize: 150,
					snapOnRelease: true
				},
				spaceBetween: 0,
				direction: 'horizontal'
			};
			this.navigationTabsCarousel = new Swiper(this.tabs, options)
		} else {
			if (this.navigationTabsCarousel) {
				this.navigationTabsCarousel.destroy();
				setTimeout(() => {
					this.setTabWrapHeight(true);
					this.shiftSelector();
				}, 100)
			}
		}
	}
	setTabWrapHeight(auto,tab) {
		if (auto) {
			this.tabContentsWrap.style.height = 'auto'
		} else if (tab) {
			this.tabContentsWrap.style.height = tab.offsetHeight + 'px';
		}
	}
	onTabClick(target) {
		let currentTab = document.querySelector('#tabContent' + target.dataset.order);
		this.setTabWrapHeight(false,this.tabContentsWrap);
		this.tab.forEach(el => {
			el.classList.remove('active')
		});
		this.tabContents.forEach(el => {
			el.classList.remove('active')
		});
		target.classList.add('active');
		if (currentTab) currentTab.classList.add('active');
		this.shiftSelector();
		if (!target.classList.contains('ajax-loaded') && !target.hasAttribute('data-empty')) {
			let urlAjax = target.getAttribute('href');
			fetch(urlAjax).then((response) => response.text())
				.then((data) => {
					const shopifySection = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section'),
						innerData = shopifySection ? shopifySection.innerHTML : data;
					if (currentTab) currentTab.querySelector('.swiper-wrapper').innerHTML = innerData;
					target.classList.add('ajax-loaded');
					setTimeout(() => {
						const prdCarousel = currentTab.querySelector('swiper-carousel');
						if (prdCarousel) {
							prdCarousel.destroy();
							prdCarousel.init();
						}
						currentTab.querySelector('[data-load]').setAttribute('data-load', 'loaded');
						this.setTabWrapHeight(true);
					}, 1000)
				})
				.catch((error) => {
					console.error('error', error);
					setTimeout(() => {
						this.fancybox?.close()
					}, 2000)
				})
		} else if (currentTab && target.hasAttribute('data-empty') && currentTab.querySelector('[data-load]').getAttribute('data-load') != 'loaded') {
			setTimeout(() => {
				const prdCarousel = currentTab.querySelector('swiper-carousel');
				if (prdCarousel) {
					prdCarousel.destroy();
					prdCarousel.init();
				}
				currentTab.querySelector('[data-load]').setAttribute('data-load', 'loaded')
			}, 100)
		} else {
			this.setTabWrapHeight(true);
			const prdCarousel = currentTab.querySelector('swiper-carousel');
			if ('init' in prdCarousel) {
				prdCarousel.carousel.update()
			}
		}
	}
	shiftSelector() {
		const activeItem = this.tabs.querySelector('.active'),
			track = this.tabs.querySelector('.tabs-wrap-track-after'),
			tabsParent = this.querySelector('.tabs-wrap-track');
		let correctionLeft = (activeItem == tabsParent.firstElementChild) ? -1 : (activeItem == tabsParent.lastElementChild) ? 2 : 0,
			correctionWidth = (this.tab.length == 1) ? 4 : 1;
		if (document.body.classList.contains('rtl-mode')) correctionLeft = -correctionLeft;
		track.style.left = activeItem.offsetLeft + correctionLeft + 'px';
		track.style.width = activeItem.clientWidth + correctionWidth + 'px';
		setTimeout(() => {
			track.classList.remove('d-none')
		}, 300)
	}
}
customElements.define('tab-slider', TabSlider);

class FrequentlyBoughtTogether extends HTMLElement {
	constructor() {
		super();
		if (!this.querySelector('scroll-items')) this.classList.add('off-scroll');
		this.onLazyload();
	}
	onLazyload() {
		if (this.classList.contains('lazyload')) {
			this.addEventListener('lazyloaded', () => {
				this.loadAjax()
			})
		}
	}
	loadAjax() {
		const ajaxContainer = this;
		if (this.dataset.ajax && !this.classList.contains('ajax-loaded') && !this.classList.contains('ajax-loading')) {
			this.loaderTemplate = '<div data-load="loading"></div>';
			this.classList.add('ajax-loading');
			const urlAjax = this.dataset.ajax;
			if (!ajaxContainer.querySelector('[data-load]')) ajaxContainer.innerHTML = this.loaderTemplate;
			fetch(urlAjax).then((response) => response.text())
				.then((data) => {
					ajaxContainer.querySelector('[data-load]')?.remove();
					ajaxContainer.innerHTML = data;
					const h = this.scrollHeight;
					this.style.transitionDuration = h/1200 + 's';
					this.style.height = h + 'px';
					setTimeout(() => {
						this.classList.remove('ajax-loading');
						this.classList.add('ajax-loaded')
					}, 1000)
				})
				.catch((error) => {
					console.error('error', error);
					this.classList.remove('ajax-loading')
				})
		}
	}
}
customElements.define('frequently-bought-together', FrequentlyBoughtTogether);

class ProductsCardCompact extends HTMLElement {
	constructor() {
		super();
		if (!this.querySelector('scroll-items')) this.classList.add('off-scroll');
		this.productWidth();
		window.addEventListener('resize', () => {
			this.productWidth()
		})
	}
	productWidth() {
		let wrap =  this.querySelector('.products-card-compact'),
			productWidth = this.hasAttribute('data-grid') ? (this.offsetWidth/2 - 10) : this.querySelector('.minicart-prd').offsetWidth;
		productWidth < 265 ? wrap.classList.add('bw--listing') : wrap.classList.remove('bw--listing');
	}
}
customElements.define('products-card-compact', ProductsCardCompact);

class LoadingBar extends HTMLElement {
	constructor() {
		super();
		this.style.setProperty('--load-time', this.dataset.time);
	}

	start() {
		this.classList.remove('hidden');
		void this.offsetWidth;
		this.style.width = '100%';
		this.classList.add('lb--animated');
		this.addEventListener('transitionend', () => {
			this.hide()
		}, false)
	}

	hide() {
		this.classList.add('hidden');
		this.classList.remove('lb--animated');
		this.style.width = '0'
	}
}
customElements.define('loading-bar', LoadingBar);

class DropdownOnClick extends HTMLElement {
	constructor() {
		super();
		this.popupElement = this.querySelector('[data-dropdown-content]');
		if (this.popupElement) {
			if (this.closest('.prd-block-meta')) {
				this.checkPosition();
				window.addEventListener('resize', debounce(() => {
					this.checkPosition()
				}, 500))
			}
			this.querySelector('[data-dropdown-link]')?.addEventListener('click', this.onLinkClick.bind(this));
			document.addEventListener('click', this.onDocumentClick.bind(this))
		}
	}

	checkPosition() {
		const parentCol = this.closest('.col-auto');
		if (parentCol) {
			const prevCol = parentCol.previousElementSibling;
			if (prevCol && getCoords(prevCol).top == getCoords(this).top) {
				this.classList.add('to-right')
			} else this.classList.remove('to-right')
		}
	}

	onLinkClick(e) {
		e.preventDefault();
		this.classList.toggle('is-opened');
		this.updateScroll();
	}

	onDocumentClick(e) {
		if (!this.contains(e.target)) {
			this.classList.remove('is-opened');
			this.querySelectorAll('.product-form__error-message-wrapper').forEach(el => {
				el.hidden = true
			});
			this.destroyScroll()
		}
	}

	destroyScroll() {
		const scroll = this.querySelector('.js-dropdn-content-scroll');
		if (scroll && Scrollbar.get(scroll) && scroll.dataset.scrollbar) {
			Scrollbar.get(scroll).destroy()
		}
	}

	updateScroll() {
		this.querySelectorAll('.js-dropdn-content-scroll').forEach(scroll => {
			if (Scrollbar.get(scroll) && scroll.dataset.scrollbar) {
				Scrollbar.get(scroll).update();
				this.popupElement.classList.remove('hide-scroll');
				this.hideTooltip(scroll);
			} else {
				Scrollbar.init(scroll, {
					alwaysShowTracks: true,
					damping: document.body.dataset.damping
				})
				this.hideTooltip(scroll);
				setTimeout(() => {this.isScroll()}, 10)
			}
		})
	}

	hideTooltip(scroll) {
		if (Scrollbar.get(scroll)) {
			Scrollbar.get(scroll).addListener(function () {
				tippy && tippy.hideAll()
			})
		}
	}

	isScroll() {
		const scroll = this.querySelector('.js-dropdn-content-scroll');
		if (scroll && scroll.dataset.scrollbar && scroll.querySelector('.scrollbar-track-y')?.style.display == 'block') {
			scroll.classList.add('has-scroll')
		} else scroll.classList.remove('has-scroll')
	}
}
customElements.define('dropdown-onclick', DropdownOnClick);

class ButtonAnimated extends HTMLElement {
	constructor() {
		super();
		this.btn = this.children[0];
		this.pauseAnimate = parseInt(this.dataset.pause);
		if (this.dataset.onesAnimate == undefined) {
			this.start(parseInt(this.dataset.delayStart));
			if (!this.btn.classList.contains('disabled')) {
				this.btn.addEventListener('mouseenter', () => {
					this.stop()
				});
				this.btn.addEventListener('mouseleave', () => {
					this.start(parseInt(this.dataset.delayAfterStop))
				})
			}
		}
	}
	onesAnimate() {
		let btn = this.btn,
			styleClass = 'btn--animated-'+this.dataset.style;
		this.btn.classList.add(styleClass);
		setTimeout(() => {btn.classList.remove(styleClass)}, 1500);
	}
	start(delay) {
		let btn = this.btn,
			styleClass = 'btn--animated-'+this.dataset.style,
			that = this;
		that.animatedButton = setTimeout(function toggleClass() {
			btn.classList.add(styleClass);
			setTimeout(() => {btn.classList.remove(styleClass)}, 1500);
			that.animatedButton = setTimeout(toggleClass, that.pauseAnimate)
		}, delay);
	}
	stop() {
		if (this.animatedButton) {
			clearTimeout(this.animatedButton);
			this.animatedButton = 0;
		}
	}
}
customElements.define('button-animated', ButtonAnimated);

let productWidthCache = {}, productWidthCacheHor = {};
class ProductCard extends HTMLElement {
	constructor() {
		super();
		this.checkImageRadius();
		this.hover = this.querySelector('.prd-hover');
		this.horInside = this.querySelector('.prd-hor-inside');
		this.errorMessage = this.querySelector('.product-form__error-message-wrapper');
		this.preloadedImages = [];
		this.preloadImagesWidth = 0;
		if (!this.classList.contains('prd-simple')) {
			this.dataScrollbar = this.querySelector('[data-scrollbar]');
			if (this.dataScrollbar && !window.matchMedia(`(max-width:1024px)`).matches) {
				if (this.querySelector('.scroll-content')) {
					this.dataScrollbar.innerHTML = this.querySelector('.scroll-content').innerHTML;
				}
				this.scrollbar = Scrollbar.init(this.dataScrollbar, {alwaysShowTracks: true})
			}
			this.addEventListener('mouseenter', () => {
				this.enableHover();
				this.isDisableHover() && this.onProductHover();
			})
			this.addEventListener('mouseleave', () => {
				this.isDisableHover() && this.onProductUnHover();
			})
		}
		this.colors = this.querySelector('.prd-image-colors');
		this.querySelector('.prd-hover')?.addEventListener('mouseenter', () => {
			this.preloadImages()
		})

		this.querySelector('.prd-hover')?.addEventListener('touch', () => {
			this.preloadImages()
		})
		this.productWidth();
		this.onProductLazyload();
		document.addEventListener('DOMContentLoaded', () => this.productWidth());
		window.addEventListener('resize', debounce(() => {
			this.productWidth();
			if (this.classList.contains('lazyloaded') && this.querySelector('.ajax-container')) {
				this.classList.remove('lazyloaded');
				this.classList.add('lazyload')
			}
		}, 500))
	}
	isDisableHover() {
		return !this.hasAttribute('block-mouseleave')
	}
	disableHover() {
		this.setAttribute('block-mouseleave', true); this.classList.add('block-mouseleave');
	}
	enableHover() {
		this.removeAttribute('block-mouseleave'); this.classList.remove('block-mouseleave');
	}
	onProductLazyload() {
		if (this.classList.contains('lazyload')) {
			this.addEventListener('lazyloaded', () => {
				const viewMode = document.querySelector('view-mode');
				if (window.matchMedia(`(max-width:1024px)`).matches || (viewMode && 'getCurrentBreakpointMode' in viewMode && this.closest('.grid_list_' + viewMode.getCurrentBreakpointMode()))) {
					this.loadAjax()
				}
			})
		}
	}
	onProductUnHover() {
		const swatches = this.querySelector('.shopify-section');
		if (swatches) swatches.style.height = 'auto';
		if (this.classList.contains('prd-hor')) {
			this.hover.classList.remove('h-100');
			this.classList.remove('off-variants');
		}
		if (window.innerWidth < 992) {
			this.classList.remove('hovered')
		} else {
			this.querySelectorAll('select').forEach((input) => {
				input.blur()
			})
			this.classList.remove('hovered');
			if (this.errorMessage) this.errorMessage.hidden = true;
			setTimeout(() => {
				this.style.removeProperty('height');
				this.style.removeProperty('--maxheight')
			}, 100)
		}
	}
	loadAjax() {
		const ajaxContainer = this.querySelector('.ajax-container');
		if (ajaxContainer && this.dataset.ajax && !this.classList.contains('ajax-loaded') && !this.classList.contains('ajax-loading')) {
			this.loaderTemplate = '<div data-load="loading"></div>';
			this.classList.add('ajax-loading');
			const urlAjax = this.dataset.ajax;
			if (!ajaxContainer.querySelector('[data-load]')) ajaxContainer.innerHTML = this.loaderTemplate;
			fetch(urlAjax).then((response) => response.text())
				.then((data) => {
					ajaxContainer.querySelector('[data-load]')?.remove();
					ajaxContainer.innerHTML = data;
					ajaxContainer.replaceWith(...ajaxContainer.childNodes);
					const swatches = this.querySelector('.shopify-section');
					if (swatches) swatches.style.height = swatches.scrollHeight + 'px';
					this.classList.remove('ajax-loading');
					this.classList.add('ajax-loaded');
					this.disableSelect();
				})
				.catch((error) => {
					console.error('error', error);
					this.classList.remove('ajax-loading')
				})
		}
	}
	disableSelect() {
		if (!this.classList.contains('prd-simple')) {
			this.querySelectorAll('select').forEach((input) => {
				input.addEventListener('mouseenter', () => {
					this.disableHover()
				});
				input.addEventListener('mouseleave', () => {
					this.enableHover()
				})
			})
			const selects = this.querySelector('.prd-hover');
			if (selects && this.closest('swiper-carousel') && document.body.classList.contains('mac')) {
				if (selects.querySelector('select')) {
					selects.addEventListener('mouseenter', () => {
						this.closest('swiper-carousel').carousel.allowTouchMove = false
					});
					selects.addEventListener('mouseleave', () => {
						this.closest('swiper-carousel').carousel.allowTouchMove = true
					})
				}
			}
		}
	}
	onProductHover() {
		if (this.classList.contains('hovered') || this.closest('.hover-off')) return;
		this.loadAjax();
		if (this.classList.contains('prd-hor')) {
			if (this.hover.offsetHeight >= this.horInside.offsetHeight) {
				this.classList.add('off-variants');
			}
			if ((this.hover.offsetHeight + this.querySelector('.prd-name').offsetHeight) >= this.horInside.offsetHeight) {
				this.hover.classList.add('h-100')
			}
		}
		if (window.innerWidth < 992) {
			this.classList.add('hovered')
		} else {
			const h = this.getBoundingClientRect().height,
				hn = this.querySelector('.prd-hover .prd-name') ? this.querySelector('.prd-hover .prd-name').getBoundingClientRect().height : 0,
				ha = this.querySelector('.prd-hover .prd-action') ? this.querySelector('.prd-hover .prd-action').getBoundingClientRect().height : 0,
				hMax = `${h - hn - ha - 50}px`;
			this.style.setProperty('height', `${h}px`);
			this.style.setProperty('--maxheight', hMax);
			this.classList.add('hovered');
			const scroll = this.querySelector('[data-scrollbar]');
			if (scroll && Scrollbar.get(scroll)) {
				Scrollbar.get(scroll).update()
			}
		}
	}
	parseJson() {
		this.productJson = this.querySelector('[type="application/json"]') ? JSON.parse(this.querySelector('[type="application/json"]').textContent) : false;
	}
	preloadImages() {
		const imageWidth = this.querySelector('.prd-image-wrap').offsetWidth*2;
		if (!this.productJson) this.parseJson();
		if (this.productJson && this.preloadImagesWidth < imageWidth) {
			this.preloadedImages = [];
			this.colors.innerHTML = '';
			this.preloadImagesWidth = imageWidth;
			for (let i = 0; i < this.productJson.length; i++) {
				if (this.productJson[i].featured_image) {
					let src = this.productJson[i].featured_image.src + '&width='+imageWidth;
					if (!this.preloadedImages.some(el => src === el)) {
						this.preloadedImages.push(src);
					}
				}
			}
			for (let i = 0; i < this.preloadedImages.length; i++) {
				let src = this.preloadedImages[i];
				preloadImage(src)
					.then(img => {
						this.colors.append(img);
						this.preloadedImages.push(src);
						img.classList.add('js-prd-img');
					})
					.catch(error => console.error("error", error));
			}
		}
	}
	productWidth() {
		let w = this.offsetWidth,
			wClass;
		if (w == 0) return;
		this.style.setProperty('height', '');
		this.querySelector('.shopify-section')?.style.setProperty('height', 'auto');
		removeClassByPrefix(this,'prd-w-', '');
		removeClassByPrefix(this,'prd-hor-w-', '');
		if (this.classList.contains('prd-hor')) {
			if (this.closest('.swiper-slide').length) {
				w = this.closest('.swiper-slide').offsetWidth
			}
			if (w in productWidthCacheHor) {
				wClass = productWidthCacheHor[w]
			} else {
				wClass = (w >= 510 && w < 580) ? 'prd-hor-w-lg' : (w >= 445 && w < 500) ? 'prd-hor-w-md' : (w >= 380 && w < 445) ? 'prd-hor-w-sm' : (w >= 360 && w < 380) ? 'prd-hor-w-xs' : (w < 360) ? 'prd-hor-w-xxs' : 'prd-hor-w-xl';
				productWidthCacheHor[w] = wClass;
			}
		} else {
			if (w in productWidthCache) {
				wClass = productWidthCache[w]
			} else {
				wClass = (w >= 260 && w < 300) ? 'prd-w-lg' : (w >= 240 && w < 260) ? 'prd-w-md' : (w >= 210 && w < 240) ? 'prd-w-sm' : (w >= 180 && w < 210) ? 'prd-w-xs' : (w < 180) ? 'prd-w-xxs' : 'prd-w-xl';
				productWidthCache[w] = wClass;
			}
		}
		this.classList.add(wClass);
	}
	updateImage(id) {
		if (!this.productJson) this.parseJson();
		const variants = this.productJson,
			currentVariant = variants.find(variant => variant.id == id);
		const url = currentVariant.featured_image.src;
		const currentURL = this.querySelector(`.prd-image > .js-prd-img:nth-child(${this.querySelectorAll('.prd-image > .js-prd-img').length})`).src;
		if (url.split("&width=")[0] == currentURL.split("&width=")[0]) return;
		this.image = this.querySelector('.prd-image');
		this.imageColors = this.colors.querySelectorAll('img');
		let preloaded = false,
			newImg,
			preloadedImg = this.colors.querySelectorAll('img');
		for (let i = 0; i < preloadedImg.length; ++i) {
			if (preloadedImg[i].src.split('&width=')[0] == url.split('&width=')[0]) {
				preloaded = true;
				newImg = preloadedImg[i];
				this.colors.append(preloadedImg[i].cloneNode());
				break;
			}
		}
		if (window.innerWidth >= 992) {
			this.querySelectorAll('.prd-image > .js-prd-img').length > 1 && this.querySelector('.prd-image > .js-prd-img:nth-child(1)')?.remove();
			const currentImg = this.querySelector('.js-prd-img:nth-child(1)');
			if (!preloaded) {
				this.querySelector('[data-load]').setAttribute('data-load', 'loading');
				loadImage(url)
					.then(newImg => {
						newImg.classList.add('js-prd-img');
						this.querySelector('[data-load]').setAttribute('data-load', 'loaded');
						currentImg.parentNode?.insertBefore(newImg, currentImg.nextSibling);
						this.animateImage(currentImg, newImg,false);
					})
					.catch(error => console.error(error));
			} else {
				currentImg.parentNode?.insertBefore(newImg, currentImg.nextSibling);
				this.animateImage(currentImg, newImg, false)
			}
		} else {
			const currentImg = this.querySelector('.js-prd-img:nth-child(1)');
			if (!preloaded) {
				let cloneNode = this.querySelector('.prd-image-clone');
				if (this.processing && cloneNode) {
					this.querySelector('.prd-image').remove();
					cloneNode.classList.add('prd-image');
					cloneNode.classList.remove('prd-image-clone', 'd-none');
				}
				this.processing = true;
				this.querySelectorAll('.prd-image > .js-prd-img').length > 1 && this.querySelector('.prd-image > .js-prd-img:nth-child(2)')?.remove();
				this.cloneImage();
				this.querySelector('[data-load]')?.setAttribute('data-load', 'loading');
				loadImage(url)
					.then(newImg => {
						newImg.classList.add('js-prd-img');
						this.processing = false;
						return newImg;
					})
					.then(newImg => {
						if (!this.processing) {
							currentImg.parentNode?.insertBefore(newImg, currentImg.nextSibling);
							this.animateImage(currentImg, newImg, true);
						}
						this.querySelector('[data-load]')?.setAttribute('data-load', 'loaded');
					})
					.catch(error => console.error(error));
			} else {
				this.querySelectorAll('.prd-image > .js-prd-img').length > 1 && this.querySelector('.prd-image > .js-prd-img:nth-child(2)')?.remove();
				currentImg.parentNode?.insertBefore(newImg, currentImg.nextSibling);
				this.animateImage(currentImg, newImg, true)
			}
		}
	}
	checkImageRadius() {
		if (this.classList.contains('prd--style2') && !this.querySelector('.ic--rd')) {
			this.classList.add('ignore-top-radius')
		}
	}
	cloneImage() {
		let cloneNode = this.querySelector('.prd-image-clone');
		if (cloneNode) cloneNode.remove();
		let clone = this.querySelector('.prd-image').cloneNode(true);
		clone.classList.remove('prd-image');
		clone.classList.add('prd-image-clone','d-none');
		this.querySelector('.prd-image-wrap').appendChild(clone);
	}
	animateImage(firstImage,lastImage,remove) {
		firstImage.animate([{ transform: 'translate3D(0, 0, 0)', opacity: 1 },{ transform: 'translate3D(0, -20%, 0)', opacity: 0 }], {duration: 300,iterations: 1,fill: 'both'});
		lastImage.animate([{ transform: 'translate3D(0, 20%,0)', opacity: 0 },{ transform: 'translate3D(0, 0, 0)', opacity: 1 }], {duration: 250,iterations: 1,fill: 'both'});
		if (remove) {
			setTimeout(() => {
				firstImage.remove();
				this.processing = false;
				this.cloneImage();
			}, 300)
		}
	}
}
customElements.define('product-card', ProductCard);

class LookbookButton extends HTMLElement {
	constructor() {
		super();
		let url = this.dataset.ajax,
			loader = this.querySelector('[data-load]');
		tippy(this.querySelector('.lookbook-popup-btn'), {
			content: '',
			theme: 'loading',
			duration: [200, 200],
			touch: true,
			trigger: 'click',
			appendTo: document.body,
			zIndex: 1062,
			hideOnClick: true,
			interactive: true,
			allowHTML: true,
			onCreate(instance) {
				instance.isFetching = false;
				instance.error = null;
			},
			onShow(instance) {
				tippy.hideAll({exclude: instance});
				if (instance.isFetching || instance.error) {
					instance.popper.querySelector('wishlist-button')?.render();
					const tippyNode = instance.popper.querySelector('wishlist-button>a');
					if (tippyNode && tippyNode._tippy) tippyNode._tippy.hide();
				} else {
					loader.setAttribute('data-load', 'loading');
					instance.isFetching = true;
					fetch(url)
						.then((response) => response.text())
						.then((data) => {
							const shopifySection = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section'),
								innerText = shopifySection ? shopifySection.innerHTML : data;
							instance.setContent(innerText);
							instance.hide();
							instance.setProps({
								theme: 'lookbook',
							});
							instance.show();
							instance.popper.querySelector('wishlist-button')?.render();
						})
						.catch((error) => {
							instance.error = error;
							instance.setContent(`Lookbook request failed. ${error}`);
						})
						.finally(() => {
							loader.setAttribute('data-load', 'loaded')
						})
				}
			}
		})
	}
}
customElements.define('lookbook-button', LookbookButton)

class CategoryChangeImage extends HTMLElement {
	constructor() {
		super();
		let startImage = this.querySelector('[data-image-start]');
		this.querySelectorAll('[data-image]').forEach(
			button => button.addEventListener('mouseenter', this.onLinkHover.bind(this))
		)
		if (startImage && startImage.dataset.image) {
			this.lastURL = startImage.dataset.image;
			this.addEventListener('mouseleave', () => {
				this.updateImage(startImage.dataset.image)
			})
		}
		const imageWrap = this.querySelector('.image-hover-scale');
		if (imageWrap) imageWrap.innerHTML = `<div data-load="loaded"></div><div class="image-wrap">${imageWrap.innerHTML}</div>`;
	}
	onLinkHover(event) {
		event.preventDefault();
		const url = event.target.dataset.image;
		url && this.updateImage(url)
	}
	updateImage(url) {
		if (this.lastURL == url) return;
		this.lastURL = url
		if (this.querySelectorAll('.image-container img').length > 1) {
			this.querySelector('.image-container img').remove()
		}
		const currentImg = this.querySelector('.image-container img');
		this.querySelector('[data-load]')?.setAttribute('data-load', 'loading');
		loadImage(url)
			.then(newImg => {
				newImg.classList.add('w-100');
				this.processing = false;
				return newImg;
			})
			.then(newImg => {
				if (!this.processing) {
					currentImg.parentNode?.insertBefore(newImg, currentImg.nextSibling);
					this.animateImage(currentImg, newImg, true);
				}
				this.querySelector('[data-load]')?.setAttribute('data-load', 'loaded');
			})
			.catch(error => console.error(error));
	}
	animateImage(firstImage,lastImage,remove) {
		firstImage.animate([{ transform: 'translate3D(0, 0, 0)', opacity: 1 },{ transform: 'translate3D(0, -20%, 0)', opacity: 0 }], {duration: 300,iterations: 1,fill: 'both'});
		lastImage.animate([{ transform: 'translate3D(0, 20%,0)', opacity: 0 },{ transform: 'translate3D(0, 0, 0)', opacity: 1 }], {duration: 250,iterations: 1,fill: 'both'});
		if (remove) {
			setTimeout(() => {
				firstImage.remove();
				this.processing = false;
			}, 300)
		}
	}
}
customElements.define('category-change-img', CategoryChangeImage);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		this.mediaType = this.dataset.media;
		this.videoWrap = this.querySelector('.video-wrap-content');
		this.videoControl = this.querySelector('.video-control');
		if (this.mediaType == 'mp4') {
			this.querySelector('.js-video-play')?.addEventListener('click', this.loadContentMp4.bind(this));
			if (this.hasAttribute('data-autoplay')) this.querySelector('.js-video-play').click();
		} else if (this.mediaType == 'vimeo') {
			let tag = document.createElement('script');
			tag.src = "https://player.vimeo.com/api/player.js";
			document.body.appendChild(tag);
			this.querySelector('.js-video-play')?.addEventListener('click', this.loadContentVimeo.bind(this));
			if (this.hasAttribute('data-autoplay')) this.querySelector('.js-video-play').click();
		} else if (this.mediaType == 'youtube') {
			this.querySelector('.js-video-play')?.addEventListener('click', this.loadContentYouTube.bind(this));
			if (this.hasAttribute('data-autoplay')) this.querySelector('.js-video-play').click();
		} else if (this.mediaType == 'googlemap') {
			this.querySelector('.js-map-play')?.addEventListener('click', this.loadContentGoogleMap.bind(this));
		}
	}
	stopAllVideos() {
		document.querySelectorAll('deferred-media').forEach(
			(video) => {
				if (video.querySelector('.is-playing')) {
					video.pauseVideo()
				}
			}
		)
	}
	loadContentYouTube() {
		this.stopAllVideos();
		const content = document.createElement('div');
		content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
		this.querySelector('.js-video-wrap').appendChild(content.querySelector('video, model-viewer, iframe')).focus();
		const iframe = this.querySelector('iframe');
		function newPlayer(el) {
			el.player = new YT.Player(iframe, {
				events: {
					onReady() {
						el.stopAllVideos();
						el.player.playVideo();
						el.videoControl.remove();
						el.addPlaying();
						el.classList.add('init')
					},
					onStateChange(event) {
						switch(event.data) {
							case 1:
								el.stopAllVideos();
								el.addPlaying();
								el.player.playVideo();
								break;
							case 2:
								el.addPause();
								break;
						}
					}
				}
			})
		}
		if (!this.classList.contains('init')) {
			if (document.body.classList.contains('youtube-ready')) {
				newPlayer(this)
			} else {
				let tag = document.createElement('script');
				tag.src = "https://www.youtube.com/iframe_api";
				document.body.appendChild(tag);
				window.onYouTubeIframeAPIReady = () => {
					document.body.classList.add('youtube-ready');
					newPlayer(this)
				}
			}
		} else {
			this.player.playVideo();
			this.addPlaying();
		}
	}
	loadContentVimeo() {
		this.stopAllVideos();
		if (!this.classList.contains('init')) {
			const content = document.createElement('div');
			content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
			this.querySelector('.js-video-wrap').appendChild(content.querySelector('video, model-viewer, iframe')).focus();
			this.player = new Vimeo.Player(this.querySelector('iframe'));
			this.player.play();
			this.videoControl.remove();
			this.addPlaying();
			this.classList.add('init')
		} else {
			this.player.play();
			this.addPlaying();
		}
		this.player.on('play', () => {
			this.stopAllVideos();
			this.addPlaying();
			this.player.play();
		});
		this.player.on('pause', () => {
			this.addPause();
		});
	}
	loadContentMp4() {
		this.stopAllVideos();
		if (!this.classList.contains('init')) {
			const content = document.createElement('div');
			content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
			this.querySelector('.js-video-wrap').appendChild(content.querySelector('video, model-viewer, iframe')).focus();
			this.player = this.querySelector('video');
			this.player.play();
			this.addPlaying();
			this.querySelector('.js-video-stop')?.addEventListener('click', (e) => {
				e.preventDefault();
				this.addPause();
				this.player.pause();
			})
			this.querySelector('.js-video-play')?.addEventListener('click', (e) => {
				e.preventDefault();
				this.addPlaying();
				this.player.play();
			})
			this.classList.add('init')
		} else {
			this.player.play();
			this.addPlaying();
		}
	}
	loadContentGoogleMap() {
		if (!this.classList.contains('init')) {
			const content = document.createElement('div');
			content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
			this.querySelector('.js-map-wrap').appendChild(content.querySelector('iframe'));
			this.querySelector('loading-bar').start();
			this.classList.add('map-loading');
			this.querySelector('iframe').addEventListener('load', () => {
				this.classList.add('map-loaded')
			})
		}
	}
	pauseVideo() {
		if (this.player) {
			this.addPause()
			if (this.mediaType == 'mp4') {
				this.player.pause();
			} else if (this.mediaType == 'vimeo') {
				this.player.pause();
			} else if (this.mediaType == 'youtube') {
				this.player.pauseVideo();
			}
		}
	}
	addPause() {
		this.videoWrap.classList.remove('is-playing');
		this.videoWrap.classList.add('is-paused');
	}
	addPlaying() {
		this.videoWrap.classList.add('is-playing');
		this.videoWrap.classList.remove('is-paused');
	}
}
customElements.define('deferred-media', DeferredMedia);

class PriceSlider extends HTMLElement {
	constructor() {
		super();
		[this.minInput,this.maxInput] = this.querySelectorAll('input[type="range"]');
		this.inverseLeft = this.querySelector('.inverse-left');
		this.inverseRight = this.querySelector('.inverse-right');
		this.priceRange = this.querySelector('.price-slider-range');
		[this.priceThumbMin,this.priceThumbMax] = this.querySelectorAll('.price-slider-thumb');
		this.tooltip = false;
		if (this.querySelectorAll('.price-slider-sign').length) {
			this.tooltip = true;
			[this.priceSignMin,this.priceSignMax] = this.querySelectorAll('.price-slider-sign');
		} else {
			[this.minInputCustom,this.maxInputCustom] = this.querySelectorAll('input[type="number"]');
			this.minInputCustom.addEventListener('input', () => {
				if (this.minInputCustom.value !== '') {
					this.minInputCustomEvent()
				}
			});
			this.minInputCustom.addEventListener('change', () => {
				this.minInputCustomEvent()
			});
			this.minInputCustom.addEventListener('keyup', ({key}) => {
				this.minInputCustomEvent(key)
			});
			this.maxInputCustom.addEventListener('input', () => {
				this.minInputCustomEvent()
			});
			this.maxInputCustom.addEventListener('focusout', () => {
				if ((this.maxInputCustom.value - this.minInput.value) <= 0) {
					this.maxInputCustom.value = this.maxInputCustom.max;
					this.maxEvent(this.maxInputCustom.value)
				}
			});
			this.maxInputCustom.addEventListener('change', () => {
				this.maxInputCustomEvent()
			});
			this.maxInputCustom.addEventListener('keyup', ({key}) => {
				this.maxInputCustomEvent(key)
			})
		}
		this.minInput.setAttribute('value',this.minInput.value);
		this.maxInput.setAttribute('value',this.maxInput.value);
		this.minEvent();
		this.maxEvent();
		this.minInput.addEventListener('input', () => {
			this.minEvent()
		});
		this.maxInput.addEventListener('input', () => {
			this.maxEvent()
		});
		this.hoverState();
	}
	hoverState() {
		this.minInput.addEventListener('mouseenter', () => {
			!this.closest('.disable-filters') && this.priceThumbMin.classList.add('hovered');
		});
		this.minInput.addEventListener('mouseleave', () => {
			this.priceThumbMin.classList.remove('hovered');
		});
		this.maxInput.addEventListener('mouseenter', () => {
			this.priceThumbMax.classList.add('hovered')
		});
		this.maxInput.addEventListener('mouseleave', () => {
			this.priceThumbMax.classList.remove('hovered')
		})
	}
	minInputCustomEvent(key) {
		if ( key !== "Backspace") {
			this.controlMinMax(this.minInputCustom)
			this.minEvent(this.minInputCustom.value)
		}
	}
	maxInputCustomEvent() {
		if ((this.maxInputCustom.value - this.minInputCustom.value) > 0) {
			this.controlMinMax(this.maxInputCustom)
			this.maxEvent(this.maxInputCustom.value)
		} else this.setError()
	}
	setError() {
		this.classList.add('price-slider--error');
	}
	removeError() {
		this.classList.remove('price-slider--error');
	}
	controlMinMax(input) {
		let val = input.value;
		if (val < input.min) {
			input.value = input.min;
		}
		if ((input.max - val) < 0) {
			input.value = input.max;
		}
	}
	minEvent(val) {
		if (val === undefined) {val = this.minInput.value}
		let minVal = Math.min(val,this.maxInput.getAttribute('value')-1);
		if (!this.tooltip) {this.minInputCustom.value = minVal}
		this.minInput.setAttribute('value',minVal);
		this.minInput.value = minVal;
		let value = (this.minInput.value/parseInt(this.minInput.max))*100;
		this.inverseLeft.style.width=value+'%';
		this.priceRange.style.left=value+'%';
		this.priceThumbMin.style.left=value+'%';
		this.priceThumbMin.style.zIndex=2;
		this.priceThumbMax.style.zIndex=1;
		if (this.tooltip) {
			this.priceSignMin.style.zIndex=2;
			this.priceSignMax.style.zIndex=1;
			this.priceSignMin.style.left = value + '%';
			this.priceSignMin.childNodes[1].innerHTML = this.minInput.value;
		}
	}
	maxEvent(val) {
		this.removeError();
		if (val === undefined) {val = this.maxInput.value}
		let maxVal = Math.max(val,this.minInput.getAttribute('value')-(-1));
		if (!this.tooltip) {this.maxInputCustom.value = maxVal}
		this.maxInput.setAttribute('value',maxVal);
		this.maxInput.value = maxVal;
		let value = (this.maxInput.value/parseInt(this.maxInput.max))*100;
		this.inverseLeft.style.width=(100-value)+'%';
		this.priceRange.style.right=(100-value)+'%';
		this.priceThumbMax.style.left=value+'%';
		this.priceThumbMax.style.zIndex=2;
		this.priceThumbMin.style.zIndex=1;
		if (this.tooltip) {
			this.priceSignMax.style.zIndex=2;
			this.priceSignMin.style.zIndex=1;
			this.priceSignMax.style.left = value + '%';
			this.priceSignMax.childNodes[1].innerHTML = this.maxInput.value;
		}
	}
}
customElements.define('price-slider', PriceSlider);

class ScrollItems extends HTMLElement {
	constructor() {
		super();
		this.scrollEnable = true;
		if (this.dataset.mode === 'items') {
			this.init(500);
		}
		window.addEventListener('resize', debounce(() => {
			this.scrollEnable && this.setHeight()
		}, 500))
	}
	init(delay) {
		this.items = this.querySelectorAll(this.dataset.element);
		this.hideOther(true);
		setTimeout(() => {
			this.setHeight()
		}, delay);
		bodyScrollLock.enableBodyScroll(this);
		this.scrollEnable = true;
	}
	destroy() {
		this.scrollEnable = false;
		if (this.dataset.mode === 'items') {
			Scrollbar.destroy(this);
			this.style.removeProperty('--scroll-height');
			if (this.querySelector('.scroll-content')) {
				let scrollContent = this.querySelector('.scroll-content')
				scrollContent.replaceWith(...scrollContent.childNodes)
			}
		}
	}
	hideOther(state) {
		for (let i = this.dataset.count; i < this.items.length; i++) {
			this.items[i].hidden = state
		}
	}
	setHeight() {
		let parentHeight = 20,
			max = Math.min(this.dataset.count,this.items.length);
		for (let i = 0; i < max; i++) {
			const item = this.items[i],
				style = item.currentStyle || window.getComputedStyle(item),
				margin = (i+1 == max) ? 0 :  parseInt(style.marginBottom,10);
			parentHeight += item.offsetHeight + margin;
		}
		this.style.setProperty('--scroll-height', parentHeight + 'px');
		Scrollbar.init(this, {
			alwaysShowTracks: true,
			damping: document.body.dataset.damping
		})
		this.hideOther(false);
	}
}
customElements.define('scroll-items', ScrollItems);

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input');
		this.changeEvent = new Event('change', { bubbles: true })
		this.querySelectorAll('button').forEach(
			button => button.addEventListener('click', this.onButtonClick.bind(this))
		);
		this.input.addEventListener('paste', (e) => {
			e.preventDefault()
		});
		this.min = this.input.getAttribute('min');
		this.max = this.input.getAttribute('max');
		this.status = this.querySelector('.quantity-status');
		if (this.max) {
			this.updateStatus(this.input.value);
			this.input.addEventListener('keyup', () => {
				this.updateStatus(this.input.value)
			});
			setTimeout(() => {
				this.status?.classList.add('has-animation')
			}, 500);
		}
	}
	onButtonClick(event) {
		event.preventDefault();
		if (event.target.classList.contains('disabled')) return false;
		const previousValue = this.input.value;
		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
		if (this.max) this.updateStatus(this.input.value);
	}
	updateStatus(val){
		const value = parseFloat(val),
			persent = value * 100 / this.max,
			statusClass = persent < 50 ? 'qs--start' : persent < 100 ? 'qs--middle' : 'qs--full';
		if (this.status) {
			removeClassByPrefix(this.status,'qs--', '');
			this.status.classList.add(statusClass)
		};
		this.style.setProperty('--qty-status-persent', persent + '%');
		if (this.min > value) {
			this.input.value = this.min;
			this.status?.classList.add('qs--full')
		} else if (this.max <= value) {
			this.input.value = this.max;
			this.querySelector('.prd-quantity-up').classList.add('disabled')
		} else {
			this.querySelector('.prd-quantity-up').classList.remove('disabled')
		}
	}
}
customElements.define('quantity-input', QuantityInput);

let flowtypeCache = {};
class FlowType extends HTMLElement {
	connectedCallback() {
		this.banner = this.querySelector('[data-fontratio]');
		this.caption = this.querySelector('.bnr-caption');
		this.button = this.banner?.querySelector('.hide-if-out');
		this.button && this.button.style.setProperty('opacity', 0);
		if (this.banner) {
			this.options = {
				'maximum': 9999,
				'minimum': 1,
				'maxFont': 9999,
				'minFont': 8
			};
			this.init();
			window.addEventListener('resize', () => {
				if (window.innerWidth != document.body.dataset.innerWidth) this.hideCaption()
			})
			window.addEventListener('resize', debounce(() => {
				if (window.innerWidth != document.body.dataset.innerWidth) this.reinit();
				this.showCaption()
			}, 300))
			if (!this.closest('main-slider') && this.querySelector('a.bnr-wrap')) {
				this.banner.addEventListener('mouseenter', () => {
					this.querySelectorAll('.btn').forEach(el => el.classList.add('hovered'))
				});
				this.banner.addEventListener('mouseleave', () => {
					this.querySelectorAll('.btn').forEach(el => el.classList.remove('hovered'))
				})
			}
		}
	}
	init() {
		if (this.banner) {
			let data = (window.matchMedia(`(max-width:767px)`).matches && this.banner.getAttribute('data-fontratio-mobile')) ? this.banner.getAttribute('data-fontratio-mobile') : this.banner.getAttribute('data-fontratio'),
				fontratio = Math.round(data * 100) / 100;
			if (fontratio > 0) {
				this._changes(fontratio)
			}
		}
	}
	hide() {
		this.banner.classList.remove('fontratio-calc');
	}
	hideCaption() {
		this.caption && this.caption.style.setProperty('opacity', 0);
	}
	showCaption() {
		this.caption && this.caption.style.setProperty('opacity', 1);
	}
	reinit() {
		if (this.banner) {
			this.hide();
			this.init();
		}
	}
	_changes(fontRatio) {
		this.button && this.button.classList.remove('d-none');
		new Promise(resolve => {
			let elw = this.banner.offsetWidth,
				cacheKey = elw + '_' + fontRatio,
				fontSize;
			if (cacheKey in flowtypeCache) {
				fontSize = flowtypeCache[cacheKey];
			} else {
				let width = elw > this.options.maximum ? this.options.maximum : elw < this.options.minimum ? this.options.minimum : elw,
					fontBase = width / fontRatio;
				fontSize = fontBase > this.options.maxFont ? this.options.maxFont : fontBase < this.options.minFont ? this.options.minFont : fontBase;
				flowtypeCache[elw + '_' + fontRatio] = fontSize;

			}
			const demoClassNames = ['is-demo', 'localization-de'];
			if (this.closest('main-slider') && demoClassNames.some(className => document.body.classList.contains(className))) {
				fontSize *= 1 - 0.12;
			}
			return resolve(fontSize);
		}).then(fontSize => {
			this.banner.style.setProperty('font-size', fontSize + 'px');
			this.banner.classList.add('fontratio-calc');
			return;
		}).then(() => {
			if (!this.button) return;
			if (this.banner.clientHeight < this.caption.clientHeight + 20) {this.button.classList.add('d-none')} else this.button.style.setProperty('opacity', 1)
		})
	}
}
customElements.define('flow-type', FlowType);

class MainSlider extends HTMLElement {
	constructor() {
		super();
		this.swiper = this.querySelector('.swiper-container');
		this.pagination = this.querySelector('.swiper-pagination');
		this.paginationWrap = this.querySelector('.swiper-pagination-wrap');
		this.progress = this.querySelector('.swiper-progress-bar');
		this.singleSlide = this.querySelectorAll('.swiper-slide').length > 1 ? false : true;
		this.colorizePagination();
		this.videoControl();
		this.swiperAnimation = new SwiperAnimation();
		this.lazyLoadImage(1);
		if (this.getAttribute('data-autoplay')) {
			this.autoplay = {
				delay: this.getAttribute('data-autoplay'),
				disableOnInteraction: true
			}
		} else this.autoplay = false;
		this.timer = setInterval(() => {
			if (document.body.dataset.setRoot) {
				clearInterval(this.timer);
				this.initSwiper();
			}
		}, 100);
		document.addEventListener('visibilitychange', () => {
			if (this.progress) {
				if (document.visibilityState === 'visible') {
					this.progress.classList.add('is-animate');
				} else {
					this.progress.classList.remove('is-animate');
				}
			}
		})
	}
	animateText(img, slider) {
		img && img.closest('.swiper-slide-img')?.querySelector('[data-load]')?.remove();
		slider && this.swiperAnimation.init(slider).animate()
	}
	lazyLoadImage(loadSlidesOnStart, slider) {
		if (!loadSlidesOnStart) {
			if (this.querySelector('.swiper-slide-visible img')) {
				this.querySelectorAll('.swiper-slide-visible img').forEach((img) => {
					if (!img.classList.contains('lazyloaded')) {
						img.classList.add('lazyload');
						img.addEventListener('load', () => {
							this.animateText(img,slider)
						})
					} else {
						this.animateText(img,slider)
					}
				})
			} else {
				this.animateText(false,slider)
			}
		} else {
			this.querySelectorAll('.swiper-slide').forEach((el, index) => {
				if (index < loadSlidesOnStart) {
					el.querySelectorAll('img').forEach((img) => {
						if (!img.classList.contains('lazyloaded')) {
							img.classList.add('lazyload')
						}
					})
				}
			})
		}
	}
	initSwiper() {
		const options = {
			watchOverflow: true,
			slidesPerView: 1,
			touchRatio: 1,
			effect: 'fade',
			watchSlidesVisibility: true,
			autoplay: this.singleSlide ? false : this.autoplay,
			loop: this.singleSlide ? false : true,
			'pagination': {
				'el': this.querySelector('.swiper-pagination'),
				'clickable': true
			},
			'navigation': {
				'nextEl': this.querySelector('.swiper-button-next'),
				'prevEl': this.querySelector('.swiper-button-prev')
			},
			on: {
				init: (slider) => {
					this.colorizePagination();
					this.lazyLoadImage(0,slider);
				},
				afterInit: (slider) => {
					if (this.singleSlide) playPauseVideo(this, this.swiper, 'init', true, false);
					if (this.progress && slider.el.querySelector('.swiper-slide-active').classList.contains('swiper-slide--video')) {
						this.progress.classList.remove('is-animate')
					}
				},
				slideChange: (slider) => {
					this.lazyLoadImage(0,slider);
					setTimeout(() => {
						this.colorizePagination()
					}, 500);
					playPauseVideo(this, this.swiper, 'pauseAll', true, false);
					this.swiper.classList.add('off-control');
				},
				slideChangeTransitionEnd: (slider) => {
					if (this.progress && !slider.el.querySelector('.swiper-slide-active').classList.contains('swiper-slide--video')) {
						this.style.setProperty('--autoplay', this.getAttribute('data-autoplay') + 'ms');
						this.swiper.classList.remove('video-paused');
						if (this.autoplay) slider.autoplay.start();
						this.progress.classList.add('is-animate')
					}
					setTimeout(() => {
						playPauseVideo(this, this.swiper, 'init', true, false);
						this.swiper.classList.remove('off-control');
					}, 200)
				},
				slideChangeTransitionStart: () => {
					if (this.progress) this.progress.classList.remove('is-animate')
				}
			}
		}
		this.slider = new Swiper(this.swiper, options);
	}
	colorizePagination() {
		if (this.querySelector('.swiper-slide-active .colorize-invert')) {
			this.pagination?.classList.add('colorize-invert');
			this.paginationWrap?.classList.add('colorize-invert')
		} else {
			this.pagination?.classList.remove('colorize-invert');
			this.paginationWrap?.classList.remove('colorize-invert')
		}
	}
	stopAutoplay() {
		playPauseVideo(this, this.swiper, 'pause', true, true);
		if (this.autoplay) {
			this.slider?.autoplay.stop();
			if (this.progress) this.progress.classList.remove('is-animate')
		}
	}
	startAutoplay() {
		playPauseVideo(this, this.swiper, 'play', true, true);
		if (this.autoplay) {
			this.slider?.autoplay.start();
			if (this.progress) this.progress.classList.add('is-animate')
		}
	}
	videoControl() {
		this.swiper.addEventListener('click', (e) => {
			const target = e.target;
			if ((target.closest('.swiper-pagination-wrap') || target.closest('.swiper-arrows-carousel')) && this.autoplay) {
				this.autoplay = false;
				this.slider?.autoplay.stop();
				if (this.progress) {
					this.progress.classList.remove('is-animate');
					this.progress = false
				}
			}
			if (window.matchMedia(`(max-width:767px)`).matches || target.closest('.swiper-slide.off-control')) return;
			if (!target.closest('.btn') && target.closest('.swiper-slide--video')) {
				e.preventDefault();
				if (this.swiper.classList.contains('video-paused')) {
					playPauseVideo(this, this.swiper, 'play', true, true);
					if (this.autoplay) this.slider?.autoplay.start();

				} else if (this.swiper.classList.contains('video-playing')) {
					playPauseVideo(this, this.swiper, 'pause', true, true);
					if (this.autoplay) this.slider?.autoplay.stop();
				}
			}
		})
		this.swiper.addEventListener('click', (e) => {
			const target = e.target;
			if (!window.matchMedia(`(max-width:767px)`).matches || target.closest('.swiper-slide.off-control')) return;
			if (target.closest('[data-video-stop]')) {
				e.preventDefault();
				playPauseVideo(this, this.swiper, 'pause', true, true);
				if (this.autoplay) this.slider?.autoplay.stop();
			} else if (target.closest('[data-video-play]')) {
				e.preventDefault();
				playPauseVideo(this, this.swiper, 'play', true, true);
				if (this.autoplay) this.slider?.autoplay.start();
			}
		})
	}
}
customElements.define('main-slider', MainSlider);

class SwiperCarousel extends HTMLElement {
	constructor() {
		super();
		this.init();
		if (this.getAttribute('data-destroy') !== null) window.addEventListener('resize', debounce(() => {this.init()}, 15));
		this.addEventListener('mouseenter', () => {
			this.classList.remove('hover-off')
		});
		window.addEventListener('resize', debounce(() => {
			this.classList.remove('hover-off');
			if (this.carousel !== undefined) {
				this.checkScroll(this.carousel)
			}
		}, 100))
	}
	centerArrows() {
		const arrows = this.querySelector('.swiper-arrows-carousel'),
			imageContainer = this.querySelector('.image-container'),
			imageInside = this.querySelector('img');
		if (!arrows) return;
		if (imageContainer || imageInside) {
			let h = imageContainer ? imageContainer.offsetHeight/2 + 15 : imageInside.offsetHeight/2;
			if (this.querySelector('.prd-top')) {
				h += (this.querySelector('.prd-top').offsetHeight - 10)
			}
			arrows.style.setProperty('top', `${h}px`);
			arrows.style.setProperty('transform', 'none');
			this.querySelector('[data-load]')?.style.setProperty('top', `${h}px`);
		}
	}
	init() {
		this.getAttribute('data-destroy') !== null && this.destroy();
		const breakpoint = this.getAttribute('data-init-breakpoint');
		if (breakpoint !== null) {
			if (window.matchMedia(`(max-width:${+breakpoint}px)`).matches) {
				this.initSwiper()
			}
		} else this.initSwiper();
		this.querySelectorAll('.js-promoline-copy').forEach(el => {
			tippy(el, {
				content:el.getAttribute('data-tippy-text'),
				trigger:'click',
				animation:'scale',
				placement:'bottom',
				theme:'dark',
				touch: true
			})
		})
	}
	initSwiper() {
		const options_default = {
			touchRatio: 3,
			watchSlidesVisibility: true,
			on: {
				init: function(slider) {
					if (swiper.getAttribute('data-center-arrows') !== null) {
						swiper.centerArrows();
					}
					typeof Waypoint !== 'undefined' && Waypoint.refreshAll();
					swiper.querySelectorAll('product-card').forEach(element => {if ('productWidth' in element) element.productWidth()})
					const searchModal = swiper.closest('#searchModal');
					searchModal?.classList.add('swiper-visible');
					if (searchModal && searchModal.querySelector('.js-dropdn-content-scroll')) {
						Scrollbar.init(searchModal.querySelector('.js-dropdn-content-scroll'), {
							alwaysShowTracks: true,
							damping: document.body.dataset.damping
						})
					}
					const swiperWrapper = swiper.querySelector('.swiper-wrapper');
					if (swiperWrapper) {
						swiperWrapper.addEventListener('mousemove', debounce(() => {
							swiper.classList.remove('hover-off')
						}, 500))
						const observer = new MutationObserver(function (mutations) {
							mutations.forEach(function (mutation) {
								if (mutation.attributeName === 'style') {
									swiper.classList.add('hover-off')
								}
							})
						})
						const observerConfig = {
							attributes: true,
							attributeFilter: ['style'],
							childList: false,
							subtree: false,
						};
						observer.observe(swiperWrapper, observerConfig)
					}
					setTimeout(() => {
						swiper.classList.remove('hover-off')
					}, 100)
				},
				afterInit: (slider) => {
					this.checkScroll(slider);
					setTimeout(() => {
						this.querySelectorAll('flow-type').forEach(flowtype => {
							if ('reinit' in flowtype) flowtype.reinit()
						})
					}, 500)
				},
				slideChange: () => {
					this.querySelectorAll('*').forEach(node => {if (node._tippy) node._tippy.hide()})
				},
				touchStart: () => {
					if (!document.body.classList.contains('touch')) {
						if (this.querySelector('.lookbook-grid')) tippy.hideAll();
						this.querySelectorAll('*').forEach(node => {
							if (node._tippy) node._tippy.hide()
						})
					}
				},
				transitionEnd:() => {
					setTimeout(() => {
						swiper.classList.remove('hover-off');
					}, 100)
				}
			}
		}
		const swiper = this;
		if (this.getAttribute('data-filter-variable') !== null && this.closest('.js-category-page-block')) {
			const option = document.querySelector('.js-category-page-block').classList.contains('has-filter-closed') ? this.querySelector('.swiper-container ~ [data-filter-closed]').textContent : this.querySelector('.swiper-container ~ [data-filter-opened]').textContent;
			this.options = JSON.parse(option)
		} else {
			this.options = JSON.parse(this.querySelector('.swiper-container ~ [type="application/json"]').textContent)
		}
		if (this.options.pagination) {
			this.options.pagination['el'] = this.querySelector(this.options.pagination['el']);
		}

		if (this.options.navigation && !this.classList.contains('promoline-text')) {
			this.options.navigation['nextEl'] = this.querySelector(this.options.navigation['nextEl']);
			this.options.navigation['prevEl'] = this.querySelector(this.options.navigation['prevEl']);
		}
		jq.extend(this.options, options_default);
		this.carousel = new Swiper(this.querySelector('.swiper-container'), this.options);
	}
	checkScroll(slider) {
		if (slider && slider.isBeginning && slider.isEnd) {
			this.querySelector('.swiper-container').classList.add('swiper-no-scroll')
		} else this.querySelector('.swiper-container').classList.remove('swiper-no-scroll')
	}
	destroy() {
		this.carousel !== undefined && this.carousel.destroy()
	}
	start() {
		this.carousel !== undefined && this.carousel.slideTo(0,0)
	}
}
customElements.define('swiper-carousel', SwiperCarousel);

class CustomSwiperNavigation extends HTMLElement {
	constructor() {
		super();
		const that = this;
		this.closest('.holder').querySelectorAll('swiper-carousel').forEach(el => {
			if (el.carousel) {
				this.setDisable(el, el.carousel);
			}
		})
		this.querySelector('.swiper-button-prev').addEventListener('click', function() {
			this.closest('.holder').querySelectorAll('swiper-carousel').forEach(el => {
				if (el.carousel) {
					el.carousel.slidePrev(0);
					that.setDisable(el, el.carousel);
				}
			})
		})
		this.querySelector('.swiper-button-next').addEventListener('click', function() {
			this.closest('.holder').querySelectorAll('swiper-carousel').forEach(el => {
				if (el.carousel) {
					el.carousel.slideNext(0);
					that.setDisable(el, el.carousel);
				}
			})
		})
	}
	setDisable(el, carousel) {
		if (carousel) {
			if (carousel.isEnd) {
				el.closest('.holder').querySelectorAll('.swiper-button-next').forEach(button => {
					button.classList.add('swiper-button-disabled')
				})
			} else {
				el.closest('.holder').querySelectorAll('.swiper-button-next').forEach(button => {
					button.classList.remove('swiper-button-disabled')
				})
			}
			if (carousel.isBeginning) {
				el.closest('.holder').querySelectorAll('.swiper-button-prev').forEach(button => {
					button.classList.add('swiper-button-disabled')
				})
			} else {
				el.closest('.holder').querySelectorAll('.swiper-button-prev').forEach(button => {
					button.classList.remove('swiper-button-disabled')
				})
			}
		}
	}
}
customElements.define('custom-swiper-navigation', CustomSwiperNavigation);

class CountDown extends HTMLElement {
	constructor() {
		super();
		const now = new Date();
		if (this.getAttribute('data-time-expire')) {
			const expireCases = {
				cartReserved() {return new Date(now.getFullYear(),now.getMonth(), now.getDate(), now.getHours(), now.getMinutes()+this.getAttribute('data-time-expire-minutes'))},
				halfhour() {return now.getMinutes() < 30 ? new Date(now.getFullYear(),now.getMonth(), now.getDate(), now.getHours(), 30) : new Date(now.getFullYear(),now.getMonth(), now.getDate(), now.getHours()+1)},
				hour() {return new Date(now.getFullYear(),now.getMonth(), now.getDate(), now.getHours()+1)},
				day() {return new Date(now.getFullYear(),now.getMonth(), now.getDate() + 1)},
				week() {return new Date(now.getFullYear(), now.getMonth(), now.getDate() + (now.getDay() > 0 ? 8 - now.getDay() : 1))},
				month() {return new Date(now.getFullYear(),now.getMonth()+1)},
				year() {return new Date(now.getFullYear()+1, 0)}
			};
			this.endDate = expireCases[this.getAttribute('data-time-expire')]()
		} else if (this.getAttribute('data-time-reserved')) {
			this.setReservedDate()
		} else if (this.getAttribute('data-time')) {
			this.endDate = new Date(this.getAttribute('data-time')).getTime()
		} else {
			this.remove();
			return
		}
		if (now < this.endDate) {
			this.timerInit();
			setTimeout(() => {
				this.classList.add('prd-countdown-initialized')
			}, 200)
		} else {
			this.remove();
			return
		}
	}
	timerInit() {
		this.timer = setInterval(() => {

			const date = new Date().getTime(),
				diff = this.endDate - date + 1000,
				calcDate = {
					month: Math.floor((diff % (1000 * 60 * 60 * 24 * (365.25 / 12) * 365)) / (1000 * 60 * 60 * 24 * (365.25 / 12))),
					days: Math.floor(diff % (1000 * 60 * 60 * 24 * (365.25 / 12)) / (1000 * 60 * 60 * 24)),
					hours: Math.floor(diff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
					minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
					seconds: Math.floor((diff % (1000 * 60)) / 1000)
				}

			for (const [key, value] of Object.entries(calcDate)) {
				if (this.querySelector(`[data-${key}]`)) this.querySelector(`[data-${key}]`).innerHTML = value < 10 ? '0' + value : value
			}

			if (diff <= 1000){
				clearInterval(this.timer);
				if (this.getAttribute('data-time-reserved')) {
					this.setReservedDate();
					this.timerInit()
				} else this.remove()
			}

		}, 1000)
	}
	setReservedDate() {
		const now = new Date();
		this.endDate = new Date();
		this.endDate.setMinutes(now.getMinutes() + parseInt(this.getAttribute('data-time-reserved'),10))
	}
}
customElements.define('count-down', CountDown);

class ImageOnHover extends HTMLElement {
	constructor() {
		super();
		const link = this.querySelector('a'),
			previewImage = link.dataset.preview;
		this.addEventListener('mouseenter', () => {
			if (previewImage && !link.dataset.loaded) {
				preloadImage(previewImage)
					.then(img => {
						this.querySelector('.submenu-list-wrap--image .image-container')?.append(img);
						this.querySelector('[data-load]')?.setAttribute('data-load', 'loaded');
						link.dataset.loaded = true
					})
					.catch(err => console.error('error', err));
			}
		})
	}
}
customElements.define('image-on-hover', ImageOnHover);

class ReviewsTab extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll('.js-reviews-tab').forEach((el, i) => {
			el.addEventListener('click', function (e) {
				e.preventDefault();
				const parent = el.closest('.reviews-tab-row'),
					holder = el.closest('.holder'),
					swiper = holder.querySelector('swiper-carousel');
				parent.querySelectorAll('span').forEach(el => {
					el.classList.remove('active')
				})
				el.querySelector('span').classList.add('active');
				if (swiper) swiper.carousel.slideTo(i, 500, false);
			})
		})
	}
}
customElements.define('reviews-tab', ReviewsTab);

class ProductSinglePreviews extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll('.js-ps-tab').forEach((el, i) => {
			el.addEventListener('click', function (e) {
				e.preventDefault();
				const parent = el.closest('.ps-tabs'),
					holder = el.closest('.holder'),
					swiper = holder.querySelector('.ps-main-gallery swiper-carousel');
				parent.querySelectorAll('.js-ps-tab').forEach(el => {
					el.classList.remove('active')
				})
				el.classList.add('active');
				if (swiper) swiper.carousel.slideTo(i, 500, false);
			})
		})
	}
}
customElements.define('product-single-previews', ProductSinglePreviews);

class TextareaAutosize extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('.form-control');
		this.input.setAttribute('rows', 1);
		this.resizeInput();
		this.input.addEventListener('input', () => {
			this.resizeInput()
		})
	}
	resizeInput() {
		this.input.style.height = 0;
		this.input.style.height = this.input.scrollHeight - 5.5 + 'px';
		if (this.getAttribute('data-maxheight')) {
			if (this.input.scrollHeight >= this.dataset.maxheight) {
				this.input.style.overflow = 'auto'
			} else {
				this.input.style.overflow = 'hidden'
			}
		}
		if (this.closest('.minicart-drop-fixed') && customElements.get('mini-cart-popup')) {
			document.querySelectorAll('mini-cart-popup').forEach(cart => {
				cart.isOpened() && cart.bottomFixedSlide()
			})
		}
		const setHeight = this.closest('.js-set-height');
		if (setHeight && this.input.scrollHeight > 38.5) {
			setHeight.style.setProperty('--tab-height', parseInt(setHeight.dataset.tabh) + this.input.scrollHeight + 'px')
		}
	}
}
customElements.define('textarea-autosize', TextareaAutosize);

class SearchFilter extends HTMLElement {
	constructor() {
		super();
		let options = {
			valueNames: ['js-filter-item', { attr: 'value', name: 'js-filter-input' }],
			listClass: 'js-filter-list',
		};
		let searchResult = new List(this, options);

		this.search = this.querySelector('.js-search-filter');
		this.input = this.querySelector('input.search');
		this.querySelector('.js-search-filter-clear').addEventListener('click', (e) => {
			this.input.value = '';
			searchResult.search();
			e.preventDefault();
		});

		searchResult.on('searchComplete', () => {
			let result = searchResult.update().matchingItems.length;
			this.scrollbar = this.querySelector('.sidebar-block_content-scroll');
			if (!!this.scrollbar && this.scrollbar.querySelector('.js-filter-list').scrollHeight > 203) {
				this.scrollbar?.style.setProperty('height', '');
				Scrollbar.init(this.scrollbar, {
					alwaysShowTracks: true
				})
			} else {
				Scrollbar.destroy(this.scrollbar);
				this.scrollbar?.style.setProperty('height', 'auto');
			}
			if (result == 0) {
				this.querySelector('.js-search-filter-empty').classList.remove('d-none');
			} else {
				this.querySelector('.js-search-filter-empty').classList.add('d-none')
			}
		})
	}
}
customElements.define('search-filter', SearchFilter);

class AgreementCheckbox {
	constructor() {
		const checkboxAll = document.querySelectorAll('.js-agreement-checkbox');
		checkboxAll.forEach(el => {
			setTimeout(() => {
				this.checkAgreement(el)
			}, 1000);
			el.addEventListener('change', (e) => {
				let target = e.target;
				this.checkAgreement(target);
				if (target.closest('.minicart-drop-fixed')) {
					document.querySelectorAll('mini-cart-popup').forEach(cart => {
						cart.isOpened() && cart.bottomFixedSlide()
					})
				}
			});
			document.addEventListener('click', (e) => {
				let target = e.target;
				if (!target.classList.contains('js-agreement-modal')) return;
				e.preventDefault();
				const checkbox = '.js-agreement-checkbox' + '[data-button="' + target.dataset.button + '"]';
				document.querySelector(checkbox).checked = true;
				target.closest('.fancybox-container')?.querySelector('[data-fancybox-close]').click();
				document.querySelectorAll(checkbox).forEach(el => {
					this.checkAgreement(el);
					if (el.closest('.minicart-drop-fixed')) {
						document.querySelectorAll('mini-cart-popup').forEach(cart => {
							cart.isOpened() && cart.bottomFixedSlide()
						})
					}
				})
			})
		})
	}
	checkAgreement(el) {
		const groupCheckbox = document.querySelectorAll('[data-button="' + el.dataset.button + '"]'),
			groupButtons = document.querySelectorAll(el.dataset.button);
		if (el.checked) {
			groupCheckbox.forEach(checkbox => {
				checkbox.checked = true
			})
			groupButtons.forEach(button => {
				button.classList.remove('disabled')
				button.classList.add('enabled')
			})
		} else {
			groupCheckbox.forEach(checkbox => {
				el.checked = false
			})
			groupButtons.forEach(button => {
				button.classList.remove('enabled')
				button.classList.add('disabled')
			})
		}
	}
	checkAgreementAll() {
		document.querySelectorAll('.js-agreement-checkbox').forEach(el => {
			this.checkAgreement(el)
		})
	}
}
const agreementCheckbox = new AgreementCheckbox();

class SectionsRenameOnScroll extends HTMLElement {
	constructor() {
		super();
		this.sectionsDataSlot = document.querySelector('#sections-data');
		if(!this.sectionsDataSlot) return;
		this.sectionsData = JSON.parse(this.sectionsDataSlot.textContent);
		document.addEventListener('DOMContentLoaded', () => {
			document.querySelectorAll('#pageContent > .shopify-section').forEach(section => {
				this.init(section)
			})
		})
	}

	init(section) {
		if (!section || !this.sectionsData) return;
		new Waypoint({
			element: section,
			handler: (direction) => {
				if (direction === 'up') {
					this.changeName(this.sectionsData[section.id])
				}
			},
			offset: '-10%'
		})
		new Waypoint({
			element: section,
			handler: (direction) => {
				if (direction === 'down') {
					this.changeName(this.sectionsData[section.id])
				}
			},
			offset: '50%'
		})
	}

	changeName(options) {
		if (!options) return;
		const optionsTooltip = (options.tooltip && options.tooltip != '') ? `data-tippy-content="${options.tooltip}" data-tippy-placement="right"` : '';
		this.innerHTML = `<a href="${ options.href}" target="blank" ${optionsTooltip}><span>${ options.title}</span></a>`;
	}
}
customElements.define('sections-rename', SectionsRenameOnScroll);

class DemoPanel extends HTMLElement {
	constructor() {
		super();
		this.init();
		document.addEventListener('DOMContentLoaded', () => {
			this.querySelectorAll('label-animated').forEach(
				label => label.classList.add('is-appeared')
			)
		})
	}
	init() {
		this.querySelectorAll('[data-new]').forEach(
			button => button.addEventListener('mouseenter', this.onLinkHover.bind(this))
		)
		this.querySelector('[data-close]')?.addEventListener('click', this.onCloseButtonClick.bind(this))
	}
	onLinkHover(e) {
		e.target.removeAttribute('data-new')
	}
	onCloseButtonClick(e) {
		e.preventDefault();
		this.classList.add('is-closed');
		setTimeout(() => {
			this.remove()
		}, 500)
	}
}
customElements.define('demo-panel', DemoPanel);

class SmartRow extends HTMLElement {
	connectedCallback() {
		this.row = this.querySelector('.row') || this.querySelector('.smart-row');
		this.init();
		window.addEventListener('resize', debounce(() => {
			this.init();
		}, 500))
	}
	init() {
		if (!this.row) return;
		this.grid = Array.from(this.row.children);
		if (!this.grid[0]) return;
		const totalItems = this.row.childElementCount/2;
		removeClassByPrefix(this.row,'col-break-after-', '');
		const baseOffset = this.grid[0].offsetTop,
			breakIndex = this.grid.findIndex(item => item.offsetTop > baseOffset),
			numPerRow = (breakIndex === -1 ? this.grid.length : breakIndex)/2,
			numRows = Math.ceil(totalItems / numPerRow);
		this.row.classList.add(`col-break-after-${Math.ceil(totalItems / numRows)}`);
	}
}
customElements.define('smart-row', SmartRow);

class ShowOnScroll {
	constructor() {
		document.querySelectorAll('.show-on-scroll').forEach(section => {
			const offset = document.body.classList.contains('has-ajax-scroll') ? '150%' : '120%';
			new Waypoint({
				element: section,
				handler: function() {
					if (section.getAttribute('data-ajax-section-scroll')) {
						let urlAjax = section.dataset.ajaxSectionScroll;
						fetch(urlAjax).then((response) => response.text())
							.then((data) => {
								section.innerHTML = data;
								if (document.querySelector('sections-rename')) document.querySelector('sections-rename').init(section.querySelector('.shopify-section'));
								setTimeout(() => {
									addResponsive(section);
									section.querySelectorAll('swiper-carousel').forEach(carousel => {carousel.destroy();carousel.init()});
									section.querySelectorAll('tab-slider').forEach(element => {element.shiftSelector()});
									section.querySelector('.show-on-scroll')?.classList.add('is-visible');
									section.querySelectorAll('masonry-grid').forEach((element) => {element.reInit()});
									section.querySelectorAll('.lazyload').forEach(el => {
										const wrapper = el.closest('.image-container');
										if (wrapper) {
											el.addEventListener('load', () => {
												wrapper.classList.add('ic--image-loaded')
											})
										}
									});
									section.querySelectorAll('.lazyloaded').forEach(el => {
										const wrapper = el.closest('.image-container');
										if (wrapper) wrapper.classList.add('ic--image-loaded')
									});
									section.querySelectorAll('.menu-label').forEach(label => label.closest('a')?.style.setProperty('--label-width', label.offsetWidth + 'px'));
									Waypoint.refreshAll();
									section.classList.add('is-visible');
								}, 500)
							})
							.catch((error) => {
								section.remove();
								console.error('error', error);
							})
					} else section.classList.add('is-visible');
					this.destroy();
				},
				offset: offset
			})
		})
	}
}
new ShowOnScroll();

/* video functions */

function postMessageToPlayer(player, command) {
	if (player == null || command == null) return;
	player.contentWindow.postMessage(JSON.stringify(command), "*");
}

function playPauseVideo(el, slider, control, mainSlider = false, manual = false) {
	const currentSlide = slider.querySelector('.swiper-slide-active');
	if (control === 'pauseAll') {
		slider.querySelectorAll('[data-video]').forEach(slide => {
			const slideType = slide.dataset.video || false,
				player = slide.querySelector('iframe');
			if (slide.classList.contains('init-video')) {
				if (slideType === 'vimeo' && player) {
					postMessageToPlayer(player, {
						'method': 'pause',
						'value': 1
					})
				} else if (slideType === 'youtube' && player) {
					postMessageToPlayer(player, {
						'event': 'command',
						'func': 'pauseVideo'
					})
				} else if (slideType === 'mp4') {
					const video = slide.querySelector('video');;
					if (video) video.pause()
				}
			}
			slider.classList.remove('video-playing');
			slider.classList.add('video-paused');
		})
	} else {
		if (!currentSlide || !currentSlide.getAttribute('data-video')) return;
		if (!mainSlider) {
			const slideWrapper = el.dataset.quickview ? '#prdMainImageQW' : '#prdMainImage';
			if (document.querySelector(slideWrapper).classList.contains('js-preload-video') && control === 'init') {
				control = 'play'
			}
		} else if (currentSlide.classList.contains('init-video') && control === 'init') {
			control = 'play'
		}
		const slideType = currentSlide.dataset.video || false;
		if (currentSlide.getAttribute('data-video') && !currentSlide.classList.contains('init-video')) {
			const content = document.createElement('div');
			content.appendChild(currentSlide.querySelector('template').content.firstElementChild.cloneNode(true));
			currentSlide.querySelector('.js-inner-video').appendChild(content.querySelector('video, iframe')).focus();
			currentSlide.querySelectorAll('.swiper-lazy-preloader').forEach(el => el.remove());
			currentSlide.querySelectorAll('[data-load]').forEach(el => el.remove());
			if (slideType === 'vimeo' ) {
				var script = document.createElement('script');
				script.onload = function () {
					const iframeVimeo = currentSlide.querySelector('iframe');
					const playerVimeo = new Vimeo.Player(iframeVimeo);
					playerVimeo.pause();
					playerVimeo.ready().then(function() {
						if (currentSlide.classList.contains('has-autoplay')) {
							slider.classList.add('video-playing');
							slider.classList.remove('video-paused')
						} else {
							slider.classList.add('video-paused');
							slider.classList.remove('video-playing')
						}
						currentSlide.classList.add('init-video');
						if (iframeVimeo.closest('.swiper-slide-active')) {
							setTimeout(() => {
								playerVimeo.play()
							}, 100)
						}
					})
				};
				script.src = "https://cdnjs.cloudflare.com/ajax/libs/vimeo-player/2.15.0/player.min.js";
				document.head.appendChild(script);
			} else {
				if (currentSlide.classList.contains('has-autoplay')) {
					slider.classList.add('video-playing');
					slider.classList.remove('video-paused')
				} else {
					slider.classList.add('video-paused');
					slider.classList.remove('video-playing')
				}
				currentSlide.classList.add('init-video');
			}
		}
		const player = (slideType === 'vimeo' || slideType === 'youtube') ? currentSlide.querySelector('iframe') : currentSlide.querySelector('video');
		if (mainSlider && !currentSlide.classList.contains('loaded-video')) {
			const videoAutoplay = player.hasAttribute('autoplay');
			if (slideType === 'vimeo' || slideType === 'youtube') {
				currentSlide.classList.add('loaded-video');
				currentSlide.querySelectorAll('[data-load]').forEach(el => el.remove());
			} else if (slideType === 'mp4') {
				if (document.body.classList.contains('mac')) {
					currentSlide.classList.add('loaded-video');
					if (videoAutoplay) player.play()
				} else {
					player.addEventListener('loadeddata', function () {
						currentSlide.classList.add('loaded-video');
						if (videoAutoplay) player.play()
					})
				}
				player.addEventListener('ended', () => {
					slider.classList.add('video-paused');
					slider.classList.remove('video-playing');
				})
				if (el.slider && el.autoplay) {
					player.addEventListener('play', function () {
						currentSlide.querySelectorAll('[data-load]').forEach(el => el.remove());
						el.slider.autoplay.stop();
						setTimeout(() => {
							let duration = parseInt(player.duration * 1000 + 1500, 10);
							el.style.setProperty('--autoplay',  duration + 'ms');
							if (el.progress) el.progress.classList.add('is-animate');
							if (player.loop) {
								const nextSlide = setTimeout(() => {
									if (el.autoplay) {
										el.slider.autoplay.start();
										el.slider.slideNext();
									}
								}, duration)
								player.addEventListener('pause', () => {
									clearTimeout(nextSlide);
								})
							} else {
								player.addEventListener('ended', () => {
									if (el.autoplay) {
										el.slider.autoplay.start();
										el.slider.slideNext();
									}
								})
							}
						}, 500)
					})
				}
			}
		}
		if (player && control !== 'init') {
			if (slideType === 'vimeo') {
				switch (control) {
					case 'play':
						if (mainSlider && !currentSlide.classList.contains('has-autoplay') && !manual) return;
						postMessageToPlayer(player, {
							'method': 'play',
							'value': 1
						});
						slider.classList.add('video-playing');
						slider.classList.remove('video-paused');
						break;
					case 'pause':
						if (manual) currentSlide.classList.remove('has-autoplay');
						postMessageToPlayer(player, {
							'method': 'pause',
							'value': 1
						});
						slider.classList.add('video-paused');
						slider.classList.remove('video-playing');
						break;
				}
			} else if (slideType === 'youtube') {
				switch (control) {
					case 'play':
						if (mainSlider && !currentSlide.classList.contains('has-autoplay') && !manual) return;
						postMessageToPlayer(player, {
							'event': 'command',
							'func': 'playVideo'
						});
						slider.classList.add('video-playing');
						slider.classList.remove('video-paused');
						break;
					case 'pause':
						if (manual) currentSlide.classList.remove('has-autoplay');
						postMessageToPlayer(player, {
							'event': 'command',
							'func': 'pauseVideo'
						});
						slider.classList.add('video-paused');
						slider.classList.remove('video-playing');
						break;
				}
			} else if (slideType === 'mp4') {
				if (player != null) {
					el.style.setProperty('--autoplay',  parseInt((player.duration) * 1000 + 1500, 10) + 'ms');
					if (el.progress) el.progress.classList.add('is-animate');
					if (control === 'play') {
						if (mainSlider && !currentSlide.classList.contains('has-autoplay') && !manual) return;
						currentSlide.classList.add('has-autoplay');
						if (!manual) {
							player.pause();
							player.currentTime = 0;
						}
						player.play();
						slider.classList.add('video-playing');
						slider.classList.remove('video-paused');
					} else {
						if (manual) currentSlide.classList.remove('has-autoplay');
						player.pause();
						slider.classList.add('video-paused');
						slider.classList.remove('video-playing');
					}
				}
			}
		}
	}
}

/* product page */

class StickyAddtocart extends HTMLElement {
	constructor() {
		super();
		this.stickyPopup = this.querySelector('.sticky-add-to-cart');
		this.initEvents();
		this.detectPageScroll = () => {this.initScroll()};
		window.addEventListener('scroll',this.detectPageScroll)
	}
	loadAjax() {
		if (this.dataset.ajax && !this.classList.contains('ajax-loaded')) {
			if (!this.classList.contains('ajax-loading')) {
				const ajaxContainer = this.stickyPopup;
				const urlAjax = this.dataset.ajax;
				this.classList.add('ajax-loading');
				fetch(urlAjax).then((response) => response.text())
					.then((data) => {
						ajaxContainer.innerHTML = data;
						this.classList.remove('ajax-loading');
						this.classList.add('ajax-loaded');
						setTimeout(() => {
							this.openPopup()
						}, 500)
					})
					.catch((error) => {
						console.error('error', error);
						this.classList.remove('ajax-loading')
					})
			}
		} else this.openPopup()
	}
	openPopup() {
		this.stickyPopup.classList.add('sticky-add-to-cart--open');
		document.body.classList.add('has-sticky-addtocart')
	}
	closePopup() {
		this.stickyPopup.classList.remove('sticky-add-to-cart--open');
		document.body.classList.remove('has-sticky-addtocart');
	}
	initEvents() {
		document.addEventListener('click', (e) => {
			if (e.target.closest('.js-sticky-add-to-cart-close')) {
				e.preventDefault();
				this.closePopup();
				setTimeout(() => {
					this.initScroll();
					window.removeEventListener('scroll', this.detectPageScroll);
					this.stickyPopup.remove();
					document.body.classList.remove('has-sticky-addtocart');
				}, 200)
			}
		})
	}
	initScroll() {
		const stickyMarker = document.querySelector('.js-sticky-add-to-cart-marker'),
			bottomMarker = document.querySelector('.page-footer'),
			backToTop = document.querySelector('.js-back-to-top'),
			promoPopup = document.querySelector('.payment-notification');
		const cookieBanner = document.querySelector('#pandectes-banner'),
			cookieBannerVisible = cookieBanner && !cookieBanner.style.display == 'none' && !cookieBanner.classList.contains('cc-invisible');
		if (cookieBannerVisible || (stickyMarker && inViewportTop(stickyMarker)) || (bottomMarker && inViewportBottom(bottomMarker))) {
			this.closePopup();
			backToTop?.classList.remove('hidden');
			promoPopup?.classList.remove('hidden');
		} else if (!document.body.dataset.scrolling && !cookieBannerVisible) {
			this.loadAjax();
			if (window.matchMedia(`(max-width:1250px)`).matches && window.matchMedia(`(min-width:992px)`).matches || window.matchMedia(`(max-width:450px)`).matches) {
				backToTop?.classList.add('hidden')
			}
			if (promoPopup && window.matchMedia(`(max-width:1780px)`).matches) {
				promoPopup.classList.remove('payment-notification--open');
				setTimeout(() => {
					promoPopup.classList.add('hidden')
				}, 500)
			}
		}
	}
}

class ProductGallery extends HTMLElement {
	constructor() {
		super();
		this.wrapper = this.dataset.quickview ? '.modal-quickview' : '.page-content';
		this.scrollSync = (this.dataset.scrollSync === 'true');
		this.aspectRatio =  this.dataset.aspect ? this.dataset.aspect/100 : 1.2;
		this.horizontal = this.classList.contains('prd-block-gallery-container-hor');
		this.previews = this.querySelector('.js-product-previews-carousel');
		this.carousel = this.querySelector('.js-product-main-carousel');
		this.carouselWidth = this.carousel.offsetWidth;
		this.zoom = this.carousel.classList.contains('off-zoom') ? false : true;
		this.zoomLink = this.querySelector('.js-prd-zoom-link');
		this.defaultZoomLink = this.zoomLink.getAttribute('href');
		this.galleryOff = this.closest('.off-gallery');
		this.currentIndex = false;
		this.zoomReserve = 1.1;
		if (this.dataset.filter && this.dataset.filter != 'all') {
			this.filter(this.dataset.filter, true)
		} else this.init('start');
		this.zoomLinkEvent();
		window.addEventListener('resize', debounce(() => {
			this.carouselWidth = this.carousel.offsetWidth;
			if (window.matchMedia(`(min-width:1025px)`).matches && this.previews && !this.horizontal) {
				this.verticalSetHeight();
			}
		}, 250));
		if (Shopify && Shopify.designMode && this.previews) {
			this.previews.querySelectorAll('.swiper-slide').forEach((el, index, array) => {
				if (!el.querySelector('.lazyloaded')) el.querySelector('img')?.classList.add('lazyload')
			})
		}
	}

	init(currentIndex = 0) {
		if (this.previews) {
			this.buildCarousel(this.horizontal, currentIndex)
		}
		if (!this.galleryOff) {
			this.carousel && this.buildCarouselMain(currentIndex);
			this.buildGallery();
			this.events()
		}
	}

	events() {
		if (this.previews && !this.scrollSync) {
			this.previews.querySelectorAll('.swiper-slide')?.forEach(
				slide => slide.addEventListener('click', (e) => {
					e.preventDefault();
					this.previews.querySelector('.swiper-slide-thumb--active')?.classList.remove(('swiper-slide-thumb--active'));
					slide.classList.add(('swiper-slide-thumb--active'));
					let mediaId = slide.dataset.mediaId,
						slideMain = this.carousel.querySelector(`[data-media-id="${mediaId}"]`);
					if (slideMain) {
						this.galleryMain.slideTo([...slideMain.parentElement.children].indexOf(slideMain), 300);
					}
				})
			)
		}
		if (this.previews){
			this.previews.querySelectorAll('.swiper-slide')?.forEach(
				slide => slide.addEventListener('mouseenter', (e) => {
					let mediaId = slide.dataset.mediaId,
						slideMain = this.carousel.querySelector(`[data-media-id="${mediaId}"]`);
					if (slideMain) {
						if (!slideMain.querySelector('lazyloaded')) slideMain.querySelector('img')?.classList.add('lazyload');
						if (this.zoom) this.addZoomImage(slideMain)
					}
				})
			)
		}
	}

	filter(color, start = false, currentIndex = 0) {
		if (!this.carousel || !color || this.currentFilter == color && color !== 'all' || (!color.includes('-') && color !== 'all')) {
			if (start) this.init();
			return
		}
		this.currentFilter = color;
		if (color == 'all') {
			if (!this.classList.contains('filtered')) {
				this.galleryMain?.slideTo(currentIndex, 0);
				this.galleryPreviews?.slideTo(currentIndex, 0);
				return
			}
			this.destroyAll();
			this.init(currentIndex);
			this.previews && this.lazyLoadImage(this.galleryPreviews,true);
			this.classList.remove('filtered');
			return
		}
		this.classList.add('hide-countdown');
		this.destroyAll();
		this.colorOptionName = color.split('-')[0];
		this.carousel.querySelectorAll('[data-media-id]').forEach((el, i) => {
			const imageAlt = el.querySelector('img') ? el.querySelector('img').alt : color;
			if (imageAlt !== color) {
				el.classList.remove('swiper-slide');
				if (this.previews) {
					const thumb = this.previews.querySelectorAll('[data-media-id]')[i];
					thumb.style.setProperty('display', 'none');
					thumb.classList.remove('swiper-slide')
				}
			} else {
				if (!el.classList.contains('lazyloaded')) el.classList.add('lazyload');
			}
		})
		this.init(0);
		this.previews && this.lazyLoadImage(this.galleryPreviews,true);
		this.classList.add('filtered');
		setTimeout(() => {
			this.classList.remove('hide-countdown');
		}, 2500)
	}

	destroyAll() {
		this.galleryMain?.destroy();
		this.galleryPreviews?.destroy();
		this.carousel.querySelectorAll('[data-media-id]').forEach((el, i) => {
			el.classList.remove('swiper-slide-active');
			el.style.setProperty('opacity', '');
			el.classList.add('swiper-slide');
		})
		if (this.previews) {
			this.previews.querySelectorAll('[data-media-id]').forEach((el, i) => {
				el.style.setProperty('display', '');
				el.classList.add('swiper-slide');
			})
		}
		playPauseVideo(this, this.carousel, 'pauseAll')
	}

	updateCarousel() {
		if (!this.galleryOff) {
			this.galleryPreviews && this.galleryPreviews.update();
			this.galleryMain && this.galleryMain.update();
			//this.onInitEvent()
		}
	}

	lazyLoadImage(slider, thumbs) {
		if (thumbs) {
			slider.el.querySelectorAll('.swiper-slide-visible').forEach((el, index, array) => {
				if (!el.querySelector('.lazyloaded')) el.querySelector('img')?.classList.add('lazyload');
				if (index == array.length - 1) {
					const nextSlide = el.nextElementSibling;
					if (nextSlide) nextSlide.querySelector('img')?.classList.add('lazyload')
				}
			})
		} else {
			slider.el.querySelectorAll('.swiper-slide-active,.swiper-slide-next').forEach((el) => {
				if (!el.querySelector('.lazyloaded')) {
					el.querySelector('.image-container img')?.classList.add('lazyload');
					el.querySelector('.image-container img')?.addEventListener('lazyloaded', () => {
						el.querySelector('[data-load]')?.remove()
					})
				} else {
					el.querySelector('[data-load]')?.remove()
				}
			})
		}
	}

	verticalGetCount(windowsWidth) {
		const arrowsHeight = 40,
			itemsCount = Math.floor(((windowsWidth/2 - 30 - this.previews.parentElement.offsetWidth)*this.aspectRatio - arrowsHeight + 10) / (this.previews.offsetWidth*this.aspectRatio + 10));
		return(itemsCount)
	}

	verticalGetCountQw(windowsWidth) {
		const arrowsHeight = 40,
			mainGalleryWidth = windowsWidth >= 1160 ? 386 : 340,
			itemsCount = Math.floor((mainGalleryWidth*this.aspectRatio - arrowsHeight + 10) / (this.previews.offsetWidth*this.aspectRatio + 10));
		return(itemsCount)
	}

	verticalSetHeight(slider) {
		const carousel = slider || this.galleryPreviews;
		if (carousel) {
			const carouselHeight =  carousel.params.slidesPerView * (this.previews.offsetWidth*this.aspectRatio + 10) - 10;
			this.previews.style.height = carouselHeight + 'px';
			if (carousel.allowSlideNext && carousel.allowSlidePrev) {
				this.previews.classList.remove('swiper-transform-off')
			} else { this.previews.classList.add('swiper-transform-off')}
		}
	}

	buildCarousel(horizontal, currentIndex = 0) {

		let galleryPreviewsOptions = {
			loop: false,
			watchOverflow: true,
			watchSlidesVisibility: true,
			effect: 'slide',
			touchRatio: 3,
			observer: true,
			observeParents: true,
			pagination: {
				el: this.querySelector('.prd-block-gallery-pagination')
			},
			navigation: {
				nextEl: this.querySelector('.prd-block-gallery-nav .swiper-button-next'),
				prevEl: this.querySelector('.prd-block-gallery-nav .swiper-button-prev')
			},
			scrollbar: {
				el: this.querySelector('.swiper-scrollbar'),
				draggable: true,
				dragSize: 'auto'
			},
			on: {
				init: (slider) => {
					this.lazyLoadImage(slider,true);
					if (!this.scrollSync) {
						slider.slides[slider.realIndex].classList.add(('swiper-slide-thumb--active'))
					}
				},
				afterInit: (slider) => {
					if (!horizontal) this.verticalSetHeight(slider)
				},
				activeIndexChange: (slider) => {
					this.lazyLoadImage(slider,true)
				},
				slideChangeTransitionEnd: (slider) => {
					this.lazyLoadImage(slider,true)
				},
				touchStart: () => {
					this.querySelectorAll('*').forEach(node => {
						if (node._tippy) node._tippy.disable()
					})
				},
				touchEnd: () => {
					this.querySelectorAll('*').forEach(node => {
						if (node._tippy) node._tippy.enable()
					})
				}
			}
		}

		const galleryPreviewsOptionsHor = {
			slidesPerView: 4,
			spaceBetween: 10,
			direction: 'horizontal',
			centerInsufficientSlides: true,
			breakpoints: {
				480: {
					slidesPerView: 4,
				},
				575: {
					slidesPerView: 5,
				},
				768: {
					slidesPerView: 5,
				},
				992: {
					slidesPerView: 5,
				},
				1200: {
					slidesPerView: 5,
					spaceBetween: 20,
				}
			}
		}

		if (this.dataset.quickview) {
			const galleryPreviewsOptionsVertQW = {
				slidesPerView: 4,
				spaceBetween: 10,
				centerInsufficientSlides: false,
				breakpoints: {
					480: {
						slidesPerView: 4,
						direction: 'horizontal',
					},
					575: {
						slidesPerView: 5,
						direction: 'horizontal',
					},
					768: {
						slidesPerView: 5,
						direction: 'horizontal',
						centerInsufficientSlides: true,
					},
					1025: {
						slidesPerView: this.verticalGetCountQw(1025),
						direction: 'vertical'
					},
					1160: {
						slidesPerView: this.verticalGetCountQw(1160),
						direction: 'vertical'
					}
				}
			}
			galleryPreviewsOptions = Object.assign(galleryPreviewsOptions, horizontal ? galleryPreviewsOptionsHor : galleryPreviewsOptionsVertQW);
		} else {
			const containerMax = getComputedStyle(document.querySelector('.product-section .holder > .container')).getPropertyValue('--container-max-width');
			const maxWidth = containerMax ? containerMax.slice(0, -2) : 1178,
				step = Math.floor((maxWidth - 1025)/6);
			const galleryPreviewsOptionsVert = {
				slidesPerView: 4,
				spaceBetween: 10,
				centerInsufficientSlides: false,
				breakpoints: {
					480: {
						slidesPerView: 4,
						direction: 'horizontal',
					},
					575: {
						slidesPerView: 5,
						direction: 'horizontal',
					},
					768: {
						slidesPerView: 5,
						direction: 'horizontal',
						centerInsufficientSlides: true,
					},
					1025: {
						slidesPerView: this.verticalGetCount(1025),
						direction: 'vertical'
					},
					[maxWidth - 5*step]: {
						slidesPerView: this.verticalGetCount(maxWidth - 5*step),
						direction: 'vertical'
					},
					[maxWidth - 4*step]: {
						slidesPerView: this.verticalGetCount(maxWidth - 4*step),
						direction: 'vertical'
					},
					[maxWidth - 3*step]: {
						slidesPerView: this.verticalGetCount(maxWidth - 3*step),
						direction: 'vertical'
					},
					[maxWidth - 2*step]: {
						slidesPerView: this.verticalGetCount(maxWidth - 2*step),
						direction: 'vertical'
					},
					[maxWidth - step]: {
						slidesPerView: this.verticalGetCount(maxWidth - step),
						direction: 'vertical'
					},
					[maxWidth]: {
						slidesPerView: this.verticalGetCount(maxWidth),
						direction: 'vertical'
					}
				}
			}

			galleryPreviewsOptions = Object.assign(galleryPreviewsOptions, horizontal ? galleryPreviewsOptionsHor : galleryPreviewsOptionsVert);
		}

		this.galleryPreviews = new Swiper(this.previews, galleryPreviewsOptions)
	}

	buildCarouselMain(currentIndex = 0) {
		let galleryMainOptions = {
			observer: true,
			runCallbacksOnInit: true,
			watchSlidesProgress: true,
			loop: false,
			effect: 'fade',
			speed: 0,
			touchRatio: 1,
			noSwiping: true,
			noSwipingSelector: 'product-model,model-viewer,video,.zoomWindow',
			initialSlide: currentIndex,
			navigation: {
				nextEl: this.carousel.querySelector('.swiper-button-next'),
				prevEl: this.carousel.querySelector('.swiper-button-prev')
			},
			on: {
				afterInit: (slider) => {
					if (currentIndex !== 'start') slider.slideTo(currentIndex, 0);
					this.lazyLoadImage(slider,false);
					slider.el.classList.add('swiper-first-init');
					this.onInitEvent(slider, 500);
				},
				slideChangeTransitionEnd: (slider) => {
					if(!slider.el.classList.contains('swiper-first-init')) return false;
					this.lazyLoadImage(slider,false);
					const activeSlide = slider.el.querySelector('.swiper-slide-active');
					if (this.previews && !this.scrollSync) {
						const mediaId = activeSlide.dataset.mediaId,
							slideThumb = this.previews.querySelector(`[data-media-id="${mediaId}"]`);
						this.previews.querySelector('.swiper-slide-thumb--active')?.classList.remove(('swiper-slide-thumb--active'));
						if (slideThumb) {
							if (!slideThumb.classList.contains('swiper-slide-visible')) this.galleryPreviews.slideTo([...slideThumb.parentElement.children].indexOf(slideThumb), 300);
							slideThumb.classList.add(('swiper-slide-thumb--active'));
						}
					}
					this.slideChangeEventsStop = false;
					setTimeout(() => {
						if (this.slideChangeEventsStop) return;
						activeSlide.querySelector('product-model > button')?.dispatchEvent(new Event('click', {
							bubbles: true
						}));
						activeSlide.querySelector('.shopify-model-viewer-ui__button.shopify-model-viewer-ui__button--poster')?.click();
						playPauseVideo(this, this.carousel, 'init');
					}, 200)
					if (this.zoom) {
						this.addZoom(slider)
					}
				},
				slideChange: (slider) => {
					if(!slider.el.classList.contains('swiper-first-init')) return false;
					this.slideChangeEventsStop = true;
					playPauseVideo(this, this.carousel, 'pauseAll');
					if (this.manualZoomLink) this.updateZoomLink(this.defaultZoomLink);
				}
			}
		}
		if (this.previews && this.scrollSync) galleryMainOptions.thumbs = {
			swiper: this.galleryPreviews
		}
		if (this.dataset.initialSlide) galleryMainOptions.initialSlide = +this.dataset.initialSlide;
		this.galleryMain = new Swiper(this.carousel, galleryMainOptions);
	}

	onInitEvent(slider, zoomDelay = 0) {
		setTimeout(() => {
			if (this.zoom) {
				this.addZoom(slider);
			}
		}, zoomDelay);
		setTimeout(() => {
			playPauseVideo(this, this.carousel, 'init')
		}, 1000);
	}

	addZoom(slider, slide = false) {
		if (!this.zoom || !slider) return;
		const currentSlide = slide ? slide : this.carousel.querySelector('.swiper-slide.swiper-slide-active');
		if (currentSlide.classList.contains('zoom-init') && currentSlide.querySelector('.zoomWrapper') && currentSlide.querySelector('.zoomWrapper').offsetWidth > 0) return;
		currentSlide.classList.add('zoom-initializing');
		if (currentSlide && !currentSlide.classList.contains('swiper-slide--video') && !currentSlide.querySelector('product-model')) {
			if (slider.destroyed) {
				currentSlide.classList.remove('zoom-initializing');
				return;
			}
			slider.params.touchRatio = 1;
			const zoomContainer = this.dataset.quickview ? '#prdMainImageQW' : '#prdMainImage';
			this.zoomLink.classList.remove('hidden');
			if (document.querySelector(zoomContainer)) {
				this.zoomOptions = {
					zoomType: 'inner',
					zoomContainerAppendTo: currentSlide,
					zoomWindowFadeIn: 500,
					zoomWindowFadeOut: 500,
					lensFadeIn: 500,
					lensFadeOut: 500,
					imageCrossfade: true,
					responsive: true,
					cursor: 'crosshair',
					onZoomedImageLoaded: function () {
						currentSlide.classList.add('zoom-init');
						currentSlide.classList.remove('zoom-initializing');
					},
					respond: [{
						range: '100-1024',
						enabled: false,
						showLens: false
					}]
				}
				this.addZoomImage(currentSlide.querySelector('img'))
			}
		} else {
			this.zoomLink.classList.add('hidden');
			if (currentSlide.querySelector('product-model') && !slider.destroyed) slider.params.touchRatio = 0;
		}
	}

	addZoomImage(image) {
		if (image.getAttribute('data-zoom-image')) {
			if (image.dataset.imageWidth > 0) {
				if (image.dataset.imageWidth > this.carouselWidth*this.zoomReserve) {
					jq(image).ezPlus(this.zoomOptions)
				} else image.closest('[data-media-id]').classList.remove('zoom-initializing')
			} else jq(image).ezPlus(this.zoomOptions)
		} else {
			image.closest('[data-media-id]').classList.remove('zoom-initializing')
		}
	}

	buildGallery() {
		let _galleryObj = [];
		const productName = this.closest('.prd-block').querySelector('.prd-block-name'),
			productNameInner = productName ? (this.dataset.quickview ?  productName.querySelector('a').innerHTML : productName.innerHTML) : '';
		this.carousel.querySelectorAll('img').forEach((image, i) => {
			if (image.closest('.swiper-slide--video')) return;
			if (image.closest('.swiper-slide')) {
				const caption = (this.colorOptionName && image.alt.split('-')[0] == this.colorOptionName) ? productNameInner + '&nbsp;/&nbsp;' + this.colorOptionName + '&nbsp;' + image.alt.split('-')[1] : productNameInner;
				let src = (image.dataset.fancyboxImage == '' || !image.dataset.fancyboxImage) ? (image.dataset.src || image.src || image.srcset) : image.dataset.fancyboxImage,
					images = {};
				images['src'] = src;
				images['opts'] = {
					thumb: src,
					caption: caption
				};
				if (src) {
					_galleryObj.push(images);
					if (image.closest('.swiper-slide')) image.closest('.swiper-slide').dataset.galleryIndex = _galleryObj.length - 1
				}
			}
		})
		this.galleryObj = _galleryObj;
	}

	zoomLinkEvent() {
		if (this.zoomLink) {
			this.zoomLink.addEventListener('click', (e) => {
				e.preventDefault();
				const target = e.currentTarget;
				const optionsFancybox = {
					loop: false,
					animationEffect: 'zoom',
					touch: true,
					buttons: ['close'],
					clickSlide: 'close',
					clickOutside: 'close',
					mobile: {
						clickSlide: 'close',
						clickOutside: 'close'
					},
					thumbs: {
						autoStart: true,
						axis: 'x'
					},
					arrows: true,
					beforeShow: function() {
						const fancyArray = document.querySelectorAll('.fancybox-container');
						fancyArray[fancyArray.length - 1].classList.add('fancybox--light', 'fancybox-gallery');
					}
				}
				if (target.getAttribute('href') == '#') {
					jq.fancybox.open(this.galleryObj, optionsFancybox, this.carousel.querySelector('.swiper-slide-active').dataset.galleryIndex || false);

				} else {
					jq.fancybox.open(Object.assign(optionsFancybox, {
						src: target.href
					}))
				}
			})
		}
	}

	updateZoomLink(link) {
		if (this.galleryObj.length < 2) {
			this.manualZoomLink = true;
			if (this.zoomLink) this.zoomLink.setAttribute('href', link)
		} else this.manualZoomLink = false
	}
}

document.querySelectorAll('[name="tab-accordion"]').forEach(el => {
	const tab = el.closest('.tab-accordion-item').querySelector('.js-set-height');
	if (tab) {
		el.addEventListener('change', function() {
			tab.style.setProperty('--tab-height', tab.scrollHeight + 'px');
		})
		const observer = new ResizeObserver(function() {
			tab.style.setProperty('--tab-height', tab.scrollHeight + 'px')
		})
		for (let i = 0; i < tab.children.length; i++) {
			observer.observe(tab.children[i])
		}
	}
})

document.addEventListener('click', function(e) {
	let target = e.target.closest('.spr-summary-actions-newreview');
	if (!target) return;
	const tab = target.closest('.tab-accordion-item')?.querySelector('.js-set-height');
	if (tab) {
		setTimeout(() => {
			tab && tab.style.setProperty('--tab-height', tab.querySelector('.tab-accordion-item-content-inside').scrollHeight + 'px');
		}, 50)
	}
})

document.addEventListener('click', (e) => {
	if (!e.target.closest('.js-reviews-link')) return;
	e.preventDefault();
	if (window.matchMedia(`(min-width:992px)`).matches) {
		const target = e.target,
			targetsArray = target.getAttribute('data-targets') ? JSON.parse(target.getAttribute('data-targets')) : false,
			tabNavs = document.querySelector('.product-tab-wrap'),
			productTabs = 'product-tabs',
			tabAccordeon = '.tab-accordion-item',
			offset = 60;
		let panReview = false;
		if (targetsArray) {
			targetsArray.forEach((id) => {
				if (document.querySelector(id)) {
					panReview = document.querySelector(id)
				}
			})
		}
		if (panReview) {
			if (panReview.closest(productTabs)) {
				const activeTab = panReview.closest('.swiper-slide');
				if (activeTab) {
					panReview.closest(productTabs).contentTabsCarousel?.slideTo([...activeTab.parentElement.children].indexOf(activeTab), 0)
					tabNavs && smoothScrollTo(tabNavs.getBoundingClientRect().top - offset, 500)
				}
			} else if (panReview.closest(tabAccordeon)) {
				panReview.closest(tabAccordeon).querySelector('input[type="checkbox"]').checked = true;
				smoothScrollTo(panReview.getBoundingClientRect().top - offset, 200)
			} else {
				smoothScrollTo(panReview.getBoundingClientRect().top - offset, 500)
			}
		}
	}
})

class ProductTabs extends HTMLElement {
	connectedCallback() {
		this.navigationTabs = this.querySelector('.tab-wrap-nav');
		this.contentTabs = this.querySelector('.product-tab-wrap');
		this.buildCarouselNav();
		this.buildCarouselContent();
		if (this.navigationTabs) {
			this.navigationTabs.querySelector('.swiper-slide:first-child')?.addEventListener('click', () => {
				this.navigationTabsCarousel?.slideTo(0, 100)
			})
			this.navigationTabs.querySelector('.swiper-slide:last-child')?.addEventListener('click', () => {
				this.navigationTabsCarousel?.slideTo(this.navigationTabsCarousel.slides.length, 100)
			})
		}
		if (Shopify && Shopify.designMode && this.navigationTabsCarousel) {
			setTimeout(() => {this.navigationTabsCarousel.update()}, 500)
		}
	}
	buildCarouselNav() {
		const options =  {
			loop: false,
			watchOverflow: true,
			touchRatio: 1,
			watchSlidesVisibility: true,
			slidesPerView: 'auto',
			edgeSwipeThreshold: 50,
			setWrapperSize: true,
			slideToClickedSlide: true,
			updateOnWindowResize: true,
			scrollbar: {
				el: this.querySelector('.swiper-scrollbar'),
				draggable: true,
				dragSize: 150,
				snapOnRelease: true
			},
			spaceBetween: 0,
			direction: 'horizontal'
		};
		this.navigationTabsCarousel = new Swiper(this.navigationTabs, options)
	}
	buildCarouselContent() {
		const options = {
			loop: false,
			touchRatio: 1,
			effect: 'fade',
			autoHeight: true,
			speed: 0,
			noSwiping: true,
			noSwipingSelector: '.table-responsive',
			thumbs: {
				swiper: this.navigationTabsCarousel
			},
			on: {
				slideChangeTransitionEnd: (slider) => {
					this.navigationTabsCarousel.slideTo(slider.realIndex, 100);
					if (window.matchMedia(`(max-width:767px)`).matches) smoothScrollTo(getCoords(this).top - 65, 750)
				}
			},
			breakpoints: {
				992: {
					allowTouchMove: false
				}
			}
		}
		this.contentTabsCarousel = new Swiper(this.contentTabs, options)
	}
}
customElements.define('product-tabs', ProductTabs)

document.addEventListener('DOMContentLoaded', () => {
	customElements.define('sticky-addtocart', StickyAddtocart)
	customElements.define('product-gallery', ProductGallery);
	const tabMobile = document.querySelector('.js-tab-wrap-mobile');
	if (tabMobile) {
		tabMobile.querySelectorAll('a').forEach(el => {
			el.addEventListener('click', function (e) {
				e.preventDefault();
				const tabId = document.getElementById(el.href.substring(el.href.lastIndexOf('/') + 1));
				if (tabId.type == 'radio') tabId.checked = true;
				document.querySelectorAll('.js-dropdn-modal-slide-title').forEach(el => {
					el.classList.remove('is-current');
				})
				for (let sibling of el.parentNode.children) {
					sibling.classList.remove('is-current');
				}
				el.classList.add('is-current');
			})
		})
		Scrollbar.init(tabMobile, {
			alwaysShowTracks: true,
			damping: document.body.dataset.damping
		})
	}
	const sharing = document.querySelector('share-button');
	if (sharing) {
		sharing.closest('.holder').classList.add('to-upper')
	}
})

document.querySelectorAll('.product-tab-wrap input').forEach(el => {
	el.addEventListener('change', () => {
		if (typeof Waypoint !== 'undefined') {
			setTimeout(() => {
				Waypoint.refreshAll()
			}, 300);
		}
	})
})

/* end product page */
let cashWindowWidth;
let cashWindowHeight;
const webkitKeyboardHeightMin = 200;
checkDevice();
document.addEventListener('DOMContentLoaded', () => {
	cashWindowWidth = window.innerWidth;
	cashWindowHeight = window.innerHeight;
	document.querySelectorAll('.lazyload').forEach(el => {
		el.addEventListener('load', () => {
			if (el.closest('.image-container')) el.closest('.image-container').classList.add('ic--image-loaded')
		})
	})
	if (window.matchMedia(`(max-width:1024px)`).matches) {
		document.body.dataset.mobile = true;
	} else delete document.body.dataset.mobile;
	calcScrollWidth();
	setVH();
	setVHStart();
	addResponsive();
	document.body.classList.remove('initial-hide');
	if (document.querySelector('#shopify-chat')) document.body.classList.add('has-shopify-chat');

	tippy.delegate('body', {
		target: '[data-tippy-content]',
		theme: document.body.dataset.tooltipColor,
		animation: document.body.dataset.tooltipAnimation,
		duration: [document.body.dataset.tooltipDuration || 300, 0],
		delay: document.body.dataset.tooltipDelay || 0,
		touch: false,
		zIndex: 99999
	});

	Scrollbar.initAll({alwaysShowTracks: true});

	document.querySelectorAll('.menu-label').forEach(label => label.closest('a')?.style.setProperty('--label-width', label.offsetWidth + 'px'))
})

document.addEventListener('scroll', () => {
	tippy && tippy.hideAll()
})

if(window.visualViewport && document.body.classList.contains('safari')) {
	window.visualViewport.addEventListener('resize', debounce(() => {
		if(window.matchMedia('(orientation: portrait)').matches){
			// document.querySelector('.hdr .hdr-logo').innerHTML =  (cashWindowHeight - window.visualViewport.height);
			if ((cashWindowHeight - window.visualViewport.height) > webkitKeyboardHeightMin) {
				document.body.classList.add('has-keyboard-open');
			} else {
				document.body.classList.remove('has-keyboard-open')
			}
		} else document.body.classList.remove('has-keyboard-open')
	}, 500))
}

window.addEventListener('resize', debounce(() => {
	setVH();
	checkDevice();
	if (window.innerWidth > 575) {
		setVHStart(true)
	}
	if (window.innerWidth != cashWindowWidth) {
		calcScrollWidth();
		setVHStart(true);
		if (window.matchMedia(`(max-width:1024px)`).matches) {
			document.body.dataset.mobile = true
		} else delete document.body.dataset.mobile;
		if (!window.matchMedia(`(max-width:1024px)`).matches) {
			if (document.querySelector('.fancybox-container.fancybox-is-open .filter-mobile-content:not(.filter-desktop-slide)') || document.querySelector('.fancybox-container.fancybox-is-open .mobilemenu-content')) {
				jq.fancybox.close()
			}
		}
		cashWindowWidth = window.innerWidth;
		cashWindowHeight = window.innerHeight;
	}
}, 500))

window.addEventListener('load', () => {
	document.body.classList.remove('full-load-hide')
})

document.addEventListener('DOMContentLoaded', () => {
	jq.extend(true, jq.fancybox.defaults, {
		buttons: {},
		btnTpl: {
			arrowLeft: '',
			arrowRight: ''
		},
		spinnerTpl : '<div data-load="loading"></div>',
		touch: false,
		backFocus: false,
		autoFocus: false,
		clickSlide: false,
		clickOutside: false,
		mobile: {
			clickSlide: false,
			clickOutside: false
		}
	})
})

const mobileBreakpoint = 1024;

document.addEventListener('click', function(e) {
	const target = e.target,
		lastFancybox = [...document.querySelectorAll('.fancybox-container:not(.fancybox-gallery)')].pop();
	if (lastFancybox) {
		if (lastFancybox.querySelector('.fancybox-slide--current')?.contains(target) && !lastFancybox.querySelector('.fancybox-slide--current .fancybox-content')?.contains(target)) jq(target).closest('.fancybox-container')?.data('FancyBox').close()
	}
})

class Popup extends HTMLElement {
	constructor() {
		super();
		this.popupSelector = this.dataset.selector;
		this.cloneSelector = document.querySelector(this.dataset.clone);
		this.popupElement = document.querySelector(this.popupSelector);
		this.popupLinks = this.querySelector('a') ? this.querySelectorAll('a') : this.querySelectorAll('span');
		this.cachedResults = [];
		this.buttonTemplate = '<button type="button" data-fancybox-close="" class="fancybox-button fancybox-close-small" title="Close"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path></svg></button>'
		this.loaderTemplate = '<div data-load="loading"></div>';
		if ('constructorExtend' in this) {
			this.constructorExtend()
		}
		this.popupLinks.forEach(
			(button) => button.addEventListener('click', this.open.bind(this))
		)
		window.addEventListener('resize', debounce(() => {
			this.isOpened() && this.isScroll()
		}, 500))
	}
	open(e) {
		if (this.closeClick) return false;
		e && e.preventDefault();
		const animationEffect = this.dataset.animationEffect ? this.dataset.animationEffect : 'fade',
			baseClass = (this.tagName == 'FILTER-POPUP') ? 'fancybox-container--filter' : '',
			hideScrollbar = (this.tagName == 'FILTER-POPUP' && window.matchMedia('(min-width:1025px)').matches) ? false : true;
		if (!this.isOpened()) {
			const main = () => {
				this.fancybox = jq.fancybox.open({
					type: 'inline',
					src: this.popupSelector,
					animationEffect: animationEffect,
					animationDuration: 200,
					touch: false,
					//hideScrollbar: hideScrollbar,
					baseClass: baseClass,
					beforeLoad: () => {
						if ('popupBeforeLoadExtend' in this) this.popupBeforeLoadExtend()
					},
					afterLoad: () => {
						new Promise(resolve => {
							if (this.tagName != 'FILTER-POPUP' || window.matchMedia(`(max-width:${mobileBreakpoint}px)`).matches)  {
								bodyScrollLock.disableBodyScroll(this.popupElement, {
									allowTouchMove: el => {
										while (el && el !== document.body) {
											if (el.getAttribute('body-scroll-lock-ignore') !== null) return true;
											el = el.parentElement
										}
									}
								})
							}
							this.popupAfterLoad();
							if ('popupAfterLoadExtend' in this)  this.popupAfterLoadExtend();
							if (this.hasAttribute('data-fullheight')) this.popupElement?.classList.add('fc--fullheight');
							resolve()
						}).then(() => {this.popupElement?.classList.add('is-opened')})
					},
					beforeShow: () => {
						if ('popupBeforeShowExtend' in this) this.popupBeforeShowExtend();
						if (!document.body.classList.contains('has-sticky')) document.body.classList.add('blockSticky');
						document.querySelectorAll('main-slider').forEach(slider => slider.stopAutoplay())
					},
					afterShow: () => {
						if (this.tagName !== 'FILTER-POPUP') this.popupAfterShow();
						if ('popupAfterShowExtend' in this) this.popupAfterShowExtend();
						setTimeout(() => {
							if (this.popupElement && this.popupElement.classList.contains('fancybox-effect-slide-out')) this.popupElement.classList.add('is-animate')
						}, 200)
					},
					beforeClose: () => {
						this.popupBeforeClose();
						if ('popupBeforeCloseExtend' in this) this.popupBeforeCloseExtend();
						if (this.popupElement && this.popupElement.classList.contains('fancybox-effect-slide-out')) this.popupElement.classList.remove('is-animate')
					},
					afterClose: () => {
						if ('popupAfterCloseExtend' in this) this.popupAfterCloseExtend();
						if (this.cloneSelector) this.destroyScroll();
						document.querySelectorAll('main-slider').forEach(slider => slider.startAutoplay());
						document.body.classList.remove('blockSticky');
						document.body.style.overflowY = ''
					}
				})
				if (this.dataset.ajax) {
					const ajaxContainerElement = this.popupElement.querySelector('[data-ajax-container]'),
						container = ajaxContainerElement || this.popupElement,
						urlAjax = this.dataset.ajax,
						filterCacheUrl = (el) => el.url === urlAjax;
					if (!this.popupElement.querySelector('[data-load]')) container.innerHTML = this.loaderTemplate;
					if (!this.cachedResults.some(filterCacheUrl)) {
						fetch(urlAjax).then((response) => response.text())
							.then((data) => {
								this.popupElement.querySelector('[data-load]')?.remove();
								const shopifySection = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section'),
									closeButtonData = new DOMParser().parseFromString(data, 'text/html').querySelector('.fancybox-close-small'),
									closeButton = closeButtonData ? '' : this.buttonTemplate;
								let innerData = shopifySection ? shopifySection.innerHTML : data;
								if (this.dataset.subtitle) {
									const subtitle = new DOMParser().parseFromString(data, 'text/html').querySelector('.h-sub');
									if (subtitle) {
										const subtitleContainer = subtitle.outerHTML;
										innerData = innerData.replace(subtitleContainer,subtitleContainer.replace('><', `>${this.dataset.subtitle}<`));
									}
								}
								container.innerHTML = innerData + closeButton;
								container.classList.add('modal-ajax-loaded');
								this.updateScroll();
								addResponsive(this.popupElement);
								if ('popupAjaxExtend' in this) {
									this.popupAjaxExtend()
								}
								this.cachedResults.push({'url': urlAjax, 'html': innerData + closeButton});
							})
							.catch((error) => {
								console.error('error', error);
								setTimeout(() => {
									this.fancybox.close()
								}, 2000)
							})
					} else {
						container.innerHTML = this.cachedResults.find(filterCacheUrl).html;
						if ('popupAfterCachLoad' in this) this.popupAfterCachLoad();
						this.updateScroll();
					}
				} else if (this.dataset.clone && 'cloneNode' in this) {
					if (!this.cloneSelector) {
						this.classList.add('ajax-awaiting');
						document.querySelector('filter-toggle')?.click()
					} else this.cloneNode()
				}
				if ('clickEventExtend' in this) {
					this.clickEventExtend()
				}
			}
			if ('beforeFancybox' in this) {
				new Promise(resolve => {
					this.beforeFancybox(resolve);
				}).then(() => main())
			} else main()
		}
	}
	close() {
		this.fancybox ? this.fancybox.close() : this.popupElement.closest('.fancybox-container')?.querySelector('[data-fancybox-close]').click()
	}
	destroyScroll() {
		this.popupElement?.querySelectorAll('.js-dropdn-content-scroll').forEach(scroll => {
			if (Scrollbar.get(scroll) && scroll.dataset.scrollbar) {
				Scrollbar.get(scroll).destroy()
			}
		})
	}
	updateScroll() {
		this.popupElement?.querySelectorAll('.js-dropdn-content-scroll').forEach(scroll => {
			if (Scrollbar.get(scroll) && scroll.dataset.scrollbar) {
				Scrollbar.get(scroll).update();
				this.popupElement.classList.remove('hide-scroll');
				this.hideTooltip(scroll);
			} else {
				if (scroll.classList.contains('prd-block-info-scroll') && window.matchMedia('(max-width:991px)').matches) return;
				new Promise(resolve => {
					Scrollbar.init(scroll, {
						alwaysShowTracks: true,
						damping: document.body.dataset.damping
					})
					this.hideTooltip(scroll);
					this.popupElement.classList.remove('hide-scroll')
					resolve()
				}).then(() => {
					setTimeout(() => {this.isScroll()}, 500)
				})
			}
		})
	}
	hideTooltip(scroll) {
		if (scroll && Scrollbar.get(scroll)) {
			Scrollbar.get(scroll).addListener(function () {
				tippy && tippy.hideAll()
			})
		} else tippy && tippy.hideAll()
	}
	isScroll() {
		this.popupElement.querySelectorAll('.js-dropdn-content-scroll').forEach(scroll => {
			scroll.dataset.scrollbar && scroll.querySelector('.scrollbar-track-y').style.display == 'block' ? scroll.classList.add('has-scroll') : scroll.classList.remove('has-scroll')
		})
	}
	isOpened() {
		return Boolean(this.popupElement !== null && this.popupElement.closest('.fancybox-is-open'))
	}
	popupAfterLoad() {
		this.popupElement.classList.add('hide-scroll')
	}
	popupAfterShow() {
		this.updateScroll()
	}
	popupBeforeClose() {
		this.popupElement.classList.remove('is-opened');
		bodyScrollLock.enableBodyScroll(this.popupElement);
		tippy && tippy.hideAll();
		setTimeout(() => {
			this.popupElement.querySelectorAll('.js-dropdn-content-scroll').forEach(scroll => {
				if (Scrollbar.get(scroll) && scroll.dataset.scrollbar) {
					Scrollbar.get(scroll).scrollTo(0,0,0)
				}
			})
		}, 500);
	}
	closeOtherPopup() {
		document.querySelectorAll('.fancybox-container').forEach(popup => {
			if (popup != this.popupElement.closest('.fancybox-container')) {
				jq(popup).data('FancyBox').close()
			}
		})
	}
	hideScroll() {
		this.popupElement.querySelectorAll('.scrollbar-track').forEach(scroll => {scroll.style.opacity = 0})
	}
	showScroll() {
		this.popupElement.querySelectorAll('.scrollbar-track').forEach(scroll => {scroll.style.opacity = 1})
	}
	reInit() {
		this.cloneSelector = document.querySelector(this.dataset.clone);
		this.popupElement = document.querySelector(this.popupSelector)
	}
	static hideAllTooltip() {
		tippy && tippy.hideAll()
	}
	static clearQuickViewCache() {
		document.querySelectorAll('quickview-popup').forEach(el => {el.cachedResults = []});
	}
	static closeAllPopups(exept) {
		document.querySelectorAll('.fancybox-container').forEach(popup => {
			if (exept) {
				if (!popup.querySelector(exept)) jq(popup).data('FancyBox').close()
			} else jq(popup).data('FancyBox').close()
		})
	}
	static closePopupExeptCart() {
		document.querySelectorAll('.fancybox-container').forEach(popup => {
			if (!popup.querySelector('.dropdn-modal-minicart')) {
				jq(popup).data('FancyBox').close()
			}
		})
	}
	static closeWishlistAndCart() {
		document.querySelectorAll('.fancybox-container').forEach(popup => {
			if (popup.querySelector('.minicart-drop')) {
				jq(popup).data('FancyBox').close()
			}
		})
	}
}

class MinicartPopup extends Popup {
	constructorExtend() {
		document.querySelector('.js-bought-with-close')?.addEventListener('click', (e) => {
			e.preventDefault();
			this.closeChild();
		})
		this.fixedBottom = this.popupElement.querySelector('[data-slide]'),
			this.toggleBottom = this.popupElement.querySelector('[data-slide-toggle]');
		window.addEventListener('resize', debounce(() => {
			this.bottomFixedSlide();
			setTimeout(() => {
				this.updateScroll()
			}, 200)
		}, 500))
	}
	bottomFixedSlide() {
		if (window.matchMedia('(max-width:767px)').matches) {
			if (this.fixedBottom) {
				let startHeight = `${this.fixedBottom.querySelector('[data-slide-visible]').offsetHeight + 40}px`
				this.fixedBottom.style.setProperty('--drop-height', `${this.fixedBottom.scrollHeight + 9}px`);
				this.fixedBottom.style.setProperty('--start-height', startHeight);
			}
		}
	}
	popupBeforeCloseExtend() {
		if (this.popupElement) {
			this.popupElement.classList.remove('is-opened')
		}
		this.closeChild();
		if (document.body.classList.contains('shopify-theme')) {
			document.querySelector('shipping-calculator')?.close(true);
			document.querySelector('shipping-calculator-cart')?.submitIfReady()
		}
		document.querySelectorAll('wishlist-popup').forEach(wishlist => {
			wishlist.isOpened() && wishlist.close()
		})
		if (this.fixedBottom) this.fixedBottom.classList.remove('is-opened');
	}
	popupAfterCloseExtend() {
		const prdCarousel = this.popupElement.querySelector('swiper-carousel');
		prdCarousel && prdCarousel.start();
		if (document.body.classList.contains('shopify-theme')) {
			document.querySelectorAll('minicart-line-item').forEach(item => {
				item.closeAllWishlistForms();
				item.closeOthers()
			})
		}
	}
	openChild() {
		if (this.isOpened) {
			this.popupElement.classList.add('has-bought-with');
			this.popupElement.querySelector('.bought-with')?.classList.add('is-opened');
			this.updateScroll()
		}
	}
	closeChild() {
		if (this.isOpened) {
			this.popupElement.querySelector('.bought-with')?.classList.remove('is-opened');
			setTimeout(() => {
				this.popupElement.classList.remove('has-bought-with');
			}, 500)
		}
	}
	isChildOpened() {
		return this.popupElement.querySelector('.bought-with')?.classList.contains('is-opened') ? true : false
	}
	popupBeforeLoadExtend() {
		if (document.body.classList.contains('shopify-theme')) document.querySelector('shipping-calculator')?.initForm();
		if (document.body.classList.contains('shopify-theme')) document.querySelector('shipping-calculator-cart')?.initForm()
	}
	popupAfterLoadExtend() {
		if (this.popupElement) {
			this.popupElement.querySelectorAll('textarea-autosize').forEach(textarea => {
				textarea.resizeInput()
			})
		}
		const wishListPopup = document.querySelector('wishlist-popup');
		if (wishListPopup && wishListPopup.popupElement && wishListPopup.popupElement.closest('.fancybox-container')) {
			document.querySelectorAll('wishlist-popup').forEach(wishlist => {
				wishlist.isOpened() && this.popupElement.closest('.fancybox-container').querySelector('.fancybox-bg').classList.add('d-none')
			})
		} else this.closeOtherPopup();
		if (document.body.classList.contains('shopify-theme')) document.querySelector('shipping-calculator-cart')?.submitIfReady();
		if (!this.popupElement.querySelector('.minicart-prd-carousel')) {
			this.popupElement.classList.remove('swiper-visible')
		} else {
			setTimeout(() => {
				this.showCarousel()
			}, 500)
		}
		if (this.toggleBottom && !this.toggleBottom.dataset.dataSlideInit) {
			this.toggleBottom.addEventListener('click', (e) => {
				e.preventDefault();
				this.fixedBottom.classList.toggle('is-opened');
				setTimeout(() => {
					this.updateScroll()
				}, 200)
			})
			this.toggleBottom.dataset.dataSlideInit = true
		}
	}
	popupBeforeShowExtend() {
		agreementCheckbox && agreementCheckbox.checkAgreementAll()
	}
	popupAfterShowExtend() {
		this.bottomFixedSlide()
	}
	clickEventExtend() {
		this.createCarousel()
	}
	createCarousel() {
		const ajaxContainerElement = this.popupElement.querySelector('[data-ajax-container]'),
			url = this.dataset.carousel;
		if (!ajaxContainerElement || ajaxContainerElement.classList.contains('is-loading')) return;
		if (url && ajaxContainerElement && ajaxContainerElement.innerHTML.trim().length == 0) {
			ajaxContainerElement.classList.add('is-loading')
			fetch(url).then(response => {
				if (!response.ok) {
					this.popupElement.querySelector('.minicart-prd-carousel').remove();
				} else {
					return response.text()
				}
			})
				.then((data) => {
					if (ajaxContainerElement) {
						ajaxContainerElement.innerHTML = data;
						this.showCarousel();
						ajaxContainerElement.classList.remove('is-loading')
					} else this.popupElement.innerHTML = data;
				})
				.catch((error) => {
					console.error('error', error)
				})
		}
	}
	removeCarousel() {
		this.popupElement.classList.remove('swiper-visible')
	}
	showCarousel() {
		const prdCarousel = this.popupElement.querySelector('swiper-carousel');
		if (prdCarousel) {
			prdCarousel.destroy();
			prdCarousel.init();
			this.popupElement.classList.add('swiper-visible')
		}
	}
}

class WishlistPopup extends Popup{
	popupAfterLoadExtend() {
		document.querySelector('wishlist-items')?.render();
	}
}

class AccountPopup extends Popup {
	constructorExtend() {
		if (this.popupElement) {
			this.popupElement.addEventListener('click', (e) => {
				let link = e.target.closest('.js-toggle-forms');
				if (!link) return;
				this.popupElement.querySelectorAll('.login-form-wrap').forEach(el => el.classList.add('d-none'));
				this.popupElement.querySelector(`.${link.dataset.form}`)?.classList.remove('d-none');
				this.popupAfterShow();
				e.preventDefault();
			})
		}
	}
}

class SearchPopup extends Popup {
	constructorExtend() {
		window.addEventListener('resize', debounce(() => {
			if (this.isOpened() && window.matchMedia('(max-width:1024px)').matches) {
				this.close()
			}
		}, 500))
	}
	popupAfterCloseExtend() {
		if (this.popupElement) {
			this.popupElement.querySelector('swiper-carousel')?.start()
		}
	}
	popupAfterShowExtend() {
		setTimeout(() => {
			const searchCarousel = this.popupElement.querySelector('swiper-carousel');
			if (searchCarousel) {
				searchCarousel.destroy();
				searchCarousel.init();
				this.popupElement.classList.add('swiper-visible')
			}
		}, 500)
	}
}

class CollectionQuickViewPopup extends Popup {
	constructorExtend() {
		this.addEventListener('mouseenter', this.onLinkEnter.bind(this));
		this.addEventListener('mouseleave', this.onLinkLeave.bind(this));
	}
	onLinkEnter() {
		this.closest('a')?.classList.add('hover-disable');
	}
	onLinkLeave() {
		this.closest('a')?.classList.remove('hover-disable');
	}
	popupAfterCloseExtend() {
		if (this.popupElement) {
			this.popupElement.querySelector('swiper-carousel')?.start()
		}
	}
}

class QuickViewPopup extends Popup {
	constructorExtend() {
		this.icon = this.querySelector('svg');
		window.addEventListener('resize', debounce(() => {
			this.updateScroll();
			this.setModalHeight()
		}, 500))
	}
	clickEventExtend() {
		if (this.closest('lookbook-prd')) {
			this.querySelector('a').classList.add('active')
		} else if (this.icon) {
			this.icon.classList.add('like-animation-focus')
		}
		this.dataset.gallery == 'off' ? this.popupElement.classList.add('off-gallery') : this.popupElement.classList.remove('off-gallery');
	}
	popupBeforeShowExtend() {
		const popup = this.closest('.fancybox-container');
		if (this.getAttribute('data-slot') == 'pickup-availability-drawer' && popup) jq(popup).data('FancyBox').close();
		this.showCarousel();
		this.setModalHeight();
	}
	popupAfterShowExtend() {
		QuickViewPopup.popupAfterShowExtendPublic(this.popupElement)
	}
	static popupAfterShowExtendPublic(ctx) {
		ctx.querySelectorAll('.js-set-height').forEach(el => {
			el.style.setProperty('--tab-height', el.scrollHeight + 'px')
		})
	}
	popupAjaxExtend() {
		this.showCarousel();
		this.setModalHeight();
		this.popupAfterShowExtend()
	}
	popupAfterCloseExtend() {
		if (this.icon) this.icon.classList.remove('like-animation-focus');
		if (this.dataset.ajax) this.popupElement.innerHTML = '<div data-load="loading"></div>';
		if (this.popupElement) {
			this.popupElement.style.minHeight = ''
		}
	}
	popupAfterLoadExtend() {
		document.querySelector('[data-handler="recentlyViewed"]')?.dispatchEvent(new CustomEvent('quick-view-popup-after-load-extend', {bubbles: false, detail: {handle: this.dataset.handle}}))
	}
	showCarousel() {
		setTimeout(() => {
			const gallery = this.popupElement.querySelector('product-gallery');
			if (gallery) {
				gallery.updateCarousel();
				gallery.style.opacity = 1;
			}
		}, 100)
	}
	setModalHeight() {
		if (!this.popupElement) return;
		const gallery = this.popupElement.querySelector('product-gallery');
		if (gallery && this.dataset.gallery !== 'off') {
			const productBlockHeight = gallery.closest('.prd-block').scrollHeight,
				fancyboxContainer = gallery.closest('.fancybox-container'),
				modal = gallery.closest('.fancybox-content'),
				modalHeight = modal.scrollHeight,
				galleryHeight = gallery.scrollHeight;
			modal.style.minHeight = window.matchMedia('(max-width:1024px)').matches ? productBlockHeight + 'px' : galleryHeight + (modalHeight - productBlockHeight) + 'px'
			fancyboxContainer.classList.add('fancybox--scroll')
		}
	}
	clearAllCache() {
		document.querySelectorAll('quickview-popup').forEach(el => {el.cachedResults = []});
	}
}

class MenuPopup extends Popup {
	constructorExtend() {
		let titleTabs = document.querySelectorAll('.js-dropdn-modal-slide-title');
		titleTabs.forEach(button => {
			button.addEventListener('click', () => {
				this.hideScroll();
				titleTabs.forEach(tab => {tab.classList.remove('is-current')});
				document.querySelectorAll('.dropdn-tab-content').forEach(button => {button.classList.remove('is-current')});
				button.classList.add('is-current');
				document.querySelector('#' + button.dataset.tab).classList.add('is-current');
				const slideMenuElement = document.querySelector('slide-menu');
				if (slideMenuElement) {
					setTimeout(() => {
						this.showScroll();
						slideMenuElement.updateScroll()
					}, 250);
				}
			})
		})
	}

	popupAfterShowExtend() {
		const slideMenuElement = document.querySelector('slide-menu');
		if (slideMenuElement) {
			setTimeout(function () {
				slideMenuElement.updateScroll()
			}, 250);
		}
	}
	popupAfterCloseExtend() {
		const slideMenuElement = document.querySelector('slide-menu');
		if (slideMenuElement) {
			slideMenuElement.reset();
			slideMenuElement.click()
		}
		document.querySelector('.js-dropdn-modal-slide-title')?.click()
	}
	popupAfterLoadExtend() {
		const slideMenuElement = document.querySelector('slide-menu');
		slideMenuElement && slideMenuElement.hideScroll()
	}
}

!document.querySelector('body').classList.contains('catalog-mode') && customElements.define('mini-cart-popup', MinicartPopup);
customElements.define('account-popup', AccountPopup);
customElements.define('wishlist-popup', WishlistPopup);
customElements.define('search-popup', SearchPopup);
customElements.define('quickview-popup', QuickViewPopup);
customElements.define('menu-popup', MenuPopup);
customElements.define('info-popup', class InfoPopup extends Popup{});
customElements.define('collection-quickview-popup', CollectionQuickViewPopup);


class MobileMenuSlide extends HTMLElement {
	constructor() {
		super();
		this.curLevel = 0;
		this.wrapper = this.closest('.dropdn-modal-slide');
		this.curItem = 0;
		this.menu = this.querySelector('.nav-wrapper');
		this.init();
	}
	init() {
		this.menu.dataset.init = true;
		this.updateMenuTitle();
		this.menu.style.height = this.menu.querySelector('ul.nav').offsetHeight + 'px';
		this.menu.querySelectorAll('a').forEach(link => link.addEventListener('click', this.onLinkClick.bind(this)));
		this.menu.querySelectorAll('.js-nav-toggle').forEach(link => link.addEventListener('click', this.onToggleClick.bind(this)));
		this.menu.querySelector('.js-nav-viewall').addEventListener('click', this.onViewAllClick.bind(this));
		this.menu.querySelectorAll('.menu-label').forEach(label => label.closest('a')?.style.setProperty('--label-width', label.offsetWidth + 'px'));
		this.labelWidth();
	}
	labelWidth() {
		this.menu.querySelectorAll('.menu-label').forEach(label => label.closest('a')?.style.setProperty('--label-width', label.offsetWidth + 'px'))
	}
	reset() {
		this.curLevel = 0;
		this.curItem = 0;
		this.querySelector('.mmenu-submenu-open')?.classList.remove('mmenu-submenu-open','mmenu-submenu-active');
		this.menu.querySelectorAll('ul').forEach(ul => ul.style.transform = '');
		this.updateMenuTitle();
		this.menu.style.height = '';
	}
	onLinkClick(e) {
		let target = e.currentTarget;
		if (target.closest('li') && target.closest('li').querySelector('ul')) {
			e.preventDefault();
			this.hideScroll();
			this.curItem = target.parentNode;
			this.updateActiveMenu();
		}
	}
	onToggleClick(e) {
		e.preventDefault();
		this.hideScroll();
		this.updateActiveMenu('back');
	}
	onViewAllClick(e) {
		e.preventDefault();
		e.stopPropagation();
		location.href = e.currentTarget.href;
	}
	setHeight() {
		this.menu.style.height = this.querySelector(`mmenu-submenu-active .nav-level-${(this.curLevel + 1)}`).offsetHeight
	}
	updateActiveMenu(direction) {
		this.slideMenu(direction);
		if (direction === 'back') {
			let curItem = this.curItem;
			setTimeout(function () {
				curItem.classList.remove('mmenu-submenu-open', 'mmenu-submenu-active');
			}, 300);
			this.curItem = this.curItem.parentNode.closest('li');
		}
		this.curItem?.classList.add('mmenu-submenu-open', 'mmenu-submenu-active');
		this.updateMenuTitle();
		this.labelWidth();
	}
	updateMenuTitle() {
		let link,
			navToggle = this.menu.querySelector('.nav-toggle'),
			viewAll = this.querySelector('.js-nav-viewall');
		if (this.curLevel > 0) {
			this.title = this.curItem.querySelector('a').innerHTML;
			link = this.curItem.querySelector('a').getAttribute('href');
			navToggle.classList.add('back-visible')
		} else {
			navToggle.classList.remove('back-visible')
		}
		this.querySelector('.nav-title').innerHTML = this.title;
		if (link && link.indexOf('/collections/')!==-1 && link.indexOf('/products/')==-1) {
			viewAll.classList.remove('hidden');
			viewAll.href = link;
		} else viewAll.classList.add('hidden')
	}
	updateHeight() {
		if (this.curLevel > 0) {
			if (!this.menu.closest('.js-tab-mobile-content')) {
				this.curItem.querySelector('ul').style.paddingTop = this.menu.querySelector('.nav-toggle').offsetHeight
			}
			this.menu.style.height = this.curItem.querySelector('ul').offsetHeight + 'px'
		} else {
			this.menu.style.height = this.menu.querySelector('.nav-level-1').offsetHeight + 'px'
		}
		setTimeout(() => {
			this.updateScroll();
		}, 250);
	}
	hideScroll() {
		this.wrapper.querySelector('.scrollbar-track').style.opacity = '0'
	}
	showScroll() {
		this.wrapper.querySelector('.scrollbar-track').style.opacity = '1'
	}
	updateScroll() {
		const scrollbarElement = this.closest('[data-scrollbar]');
		if (scrollbarElement) Scrollbar.get(scrollbarElement).update();
		this.showScroll();
	}
	slideMenu(direction) {
		if (direction === 'back') {
			this.curLevel = this.curLevel > 0 ? this.curLevel - 1 : 0;
			setTimeout(() => {
				this.updateHeight();
			}, 300);
		} else {
			this.curLevel += 1;
			setTimeout(() => {
				this.updateHeight();
			}, 100);
		}
		this.menu.classList.add('hide-arrows');
		let submenu = this.menu.querySelector('ul');
		if (document.body.classList.contains('rtl-mode')) {
			submenu.style.transform = `translateX(${this.curLevel*100}%)`
		} else {
			submenu.style.transform = `translateX(-${this.curLevel*100}%)`
		}
		setTimeout(() => {
			this.menu.classList.remove('hide-arrows');
		}, 200);
	}
}
customElements.define('slide-menu', MobileMenuSlide);

class SettingsDropdown extends HTMLElement {
	constructor() {
		super();
		this.cachedResults = [];
		window.addEventListener('load', (event) => {
			this.querySelector('.js-dropdn-link')?.addEventListener('click', this.onLinkClick.bind(this))
		})
		this.querySelector('.js-dropdn-link')?.addEventListener('mouseenter', this.onLinkEnter.bind(this));
		this.popupElement = this.querySelector('.dropdn-content');
		document.addEventListener('click', this.onDocumentClick.bind(this));
		this.querySelectorAll('.dropdn-link').forEach(link => this.style.setProperty('--link-width', link.offsetWidth + 'px'));
	}
	onLinkClick(e) {
		e.preventDefault();
		document.querySelectorAll('settings-dropdown, search-toggle-mobile').forEach(el => {
			if (el != this) el.close()
		})
		this.querySelector('.dropdn').classList.toggle('is-hovered');
		this.querySelector('.dropdn-content').classList.toggle('is-opened');
	}
	onLinkEnter(e) {
		e.preventDefault();
		if (this.querySelector('.dropdn-content').classList.contains('is-opened')) return false;
		if (this.dataset.ajax) {
			const urlAjax = this.dataset.ajax,
				filterCacheUrl = (el) => el.url === urlAjax;
			if (!this.cachedResults.some(filterCacheUrl)) {
				fetch(urlAjax).then((response) => response.text())
					.then((data) => {
						this.querySelector('[data-load]')?.remove();
						const shopifySection = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section'),
							innerData = shopifySection ? shopifySection.innerHTML : data;
						this.updateAllPopup(urlAjax,innerData)
					})
					.catch((error) => {
						console.error('error', error);
					})
			} else {
				this.updateAllPopup(urlAjax,this.cachedResults.find(filterCacheUrl).html)
			}
		}
	}
	close() {
		if (this.querySelector('.dropdn-content').classList.contains('is-opened')) {
			this.querySelector('.dropdn').classList.remove('is-hovered');
			this.querySelector('.dropdn-content').classList.remove('is-opened')
		}
	}
	updateAllPopup(url,content) {
		document.querySelectorAll('settings-dropdown').forEach(popup => {
			const ajaxContainer = popup.querySelector('[data-ajax-container]');
			if (ajaxContainer) ajaxContainer.innerHTML = content;
			popup.cachedResults.push({'url': url, 'html': content});
			setTimeout(() => { this.updateScroll() }, 500)
		})
	}
	onDocumentClick(e) {
		if (!this.contains(e.target)) {
			this.querySelector('.dropdn').classList.remove('is-hovered');
			this.querySelector('.dropdn-content').classList.remove('is-opened');
			this.destroyScroll()
		}
	}
	destroyScroll() {
		this.popupElement?.querySelectorAll('.js-dropdn-content-scroll').forEach(scroll => {
			if (Scrollbar.get(scroll) && scroll.dataset.scrollbar) {
				Scrollbar.get(scroll).destroy()
			}
		})
	}
	updateScroll() {
		this.popupElement?.querySelectorAll('.js-dropdn-content-scroll').forEach(scroll => {
			if (Scrollbar.get(scroll) && scroll.dataset.scrollbar) {
				Scrollbar.get(scroll).update();
				this.popupElement.classList.remove('hide-scroll');
				this.hideTooltip(scroll);
			} else {
				new Promise(resolve => {
					Scrollbar.init(scroll, {
						alwaysShowTracks: true,
						damping: document.body.dataset.damping
					})
					this.hideTooltip(scroll);
					this.popupElement.classList.remove('hide-scroll')
					resolve()
				}).then(() => {
					setTimeout(() => {this.isScroll()}, 500)
				})
			}
		})
	}
	hideTooltip(scroll) {
		if (Scrollbar.get(scroll)) {
			Scrollbar.get(scroll).addListener(function () {
				tippy && tippy.hideAll()
			})
		}
	}
	isScroll() {
		this.popupElement.querySelectorAll('.js-dropdn-content-scroll').forEach(scroll => {
			scroll.dataset.scrollbar && scroll.querySelector('.scrollbar-track-y')?.style.display == 'block' ? scroll.classList.add('has-scroll') : scroll.classList.remove('has-scroll')
		})
	}
}
customElements.define('settings-dropdown', SettingsDropdown);

class SettingsCollapse extends HTMLElement {
	constructor() {
		super();
		this.dropdown = this.closest('settings-dropdown') || document.querySelector('menu-popup');
		this.style.height = this.scrollHeight + 'px';
		this.querySelector('[data-other] > a')?.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			this.querySelector('[data-other]').remove();
			this.style.height = this.scrollHeight + 'px';
			setTimeout(() => {
				this.dropdown?.updateScroll()
			}, 500)
		})
	}
	reInit(){
		this.style.height = this.scrollHeight + 'px'
	}
}
customElements.define('settings-collapse', SettingsCollapse);

class MegaMenu extends HTMLElement {
	constructor() {
		super();
		this.menu = this.querySelector('.mmenu-js');
		this.cachedResults = [];
		this.timer = false;
		if (this.dataset.ajax) {
			this.matches(':hover') ? this.ajaxLoad() : document.body.addEventListener('mousemove', () => {this.ajaxLoad()}, {once: true})
		} else this.initEvent();
	}
	initEvent() {
		this.submenu = this.querySelectorAll('.mmenu-submenu li');
		this.simpleLink = this.querySelectorAll('.mmenu-item--simple:not(.menu-item-btn)');
		this.allLink = this.querySelectorAll('.mmenu-item--mega, .mmenu-item--simple:not(.menu-item-btn)');
		this.buttonLink = this.querySelectorAll('.menu-item-btn');
		this.megaLink = this.querySelectorAll('.mmenu-item--mega');
		this.linkWrapper = this.querySelectorAll('.menu-item-wrap');
		this.submenu.forEach(link => link.addEventListener('mouseenter', this.onSubmenuMouseEnter.bind(this)));
		this.submenu.forEach(link => link.addEventListener('mouseleave', this.onSubmenuMouseLeave.bind(this)));
		this.simpleLink.forEach(link => link.addEventListener('mouseenter', this.onLinkMouseEnter.bind(this)));
		this.megaLink.forEach(link => link.addEventListener('mouseenter', this.onLinkMouseEnter.bind(this)));
		this.simpleLink.forEach(link => link.addEventListener('mouseleave', this.onLinkMouseLeave.bind(this)));
		this.megaLink.forEach(link => link.addEventListener('mouseleave', this.onLinkMouseLeave.bind(this)));
		this.linkWrapper.forEach(link => link.addEventListener('click', this.onLinkMouseClick.bind(this)));
		if (this.menu && this.menu.querySelector('.menu-label')) this.menu.classList.add('mmenu--withlabels');
		this.buttonLink.forEach(link => link.addEventListener('click', (e) => {
			if (!e.target.closest('.mmenu-submenu')) {
				e.preventDefault();
				if (e.target.closest('.hovered')) {this.onLinkMouseLeave(e)} else {this.onLinkMouseEnter(e)}
			}
		}));
		this.buttonLink.forEach(link => link.addEventListener('mouseleave', this.onLinkMouseLeave.bind(this)))
	}
	ajaxLoad() {
		if (this.dataset.loaded) return;
		if (this.dataset.ajax) {
			const urlAjax = this.dataset.ajax,
				filterCacheUrl = (el) => el.url === urlAjax;
			if (!this.cachedResults.some(filterCacheUrl)) {
				fetch(urlAjax).then((response) => response.text())
					.then((data) => {
						this.querySelector('[data-load]')?.remove();
						const shopifySection = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section');
						this.parseMenu(shopifySection ? shopifySection.innerHTML : data);
						this.dataset.loaded = true;
						this.closest('header')?.removeEventListener('mouseenter', this.ajaxLoad());
					})
					.catch((error) => {
						console.error('error', error)
					})
			} else {
				this.updateAllPopup(urlAjax,this.cachedResults.find(filterCacheUrl).html)
			}
		}
	}
	parseMenu(data) {
		const menuData =  new DOMParser().parseFromString(data, 'text/html');
		let ajaxMenu = this.querySelectorAll('.mmenu > li');
		menuData.body.querySelectorAll('.mmenu > li').forEach((submenu, i) => {
			const content = submenu.querySelector('.mmenu-submenu'),
				popup = submenu.querySelector('category-popup');
			if (popup) {
				ajaxMenu[i].innerHTML = ''
				ajaxMenu[i].appendChild(popup);
			} else if (content) {
				ajaxMenu[i].appendChild(content);
				if (content.querySelector('.mmenu-submenu-inside')) {
					ajaxMenu[i].classList.add('mmenu-item--mega');
					ajaxMenu[i].classList.remove('mmenu-item--simple');
				} else {
					ajaxMenu[i].classList.remove('mmenu-item--mega');
					ajaxMenu[i].classList.add('mmenu-item--simple');
				}
			}
		})
		this.initEvent();
		setTimeout(() => {
			this.allLink?.forEach(link => {
				if (link.matches(':hover')) { this.onLinkMouseEnter(false,link) }
			})
			this.querySelectorAll('flow-type').forEach(flowtype => {
				if ('reinit' in flowtype) flowtype.reinit()}
			)
			this.querySelectorAll('swiper-carousel').forEach(carousel => {
				if ('destroy' in carousel) {
					carousel.destroy();
					carousel.init()
				}
			})
			this.querySelectorAll('.menu-label').forEach(label => label.closest('a')?.style.setProperty('--label-width', label.offsetWidth + 'px'))
		}, 250)
	}
	onLinkMouseClick(e) {
		let link = e.target.querySelector('a');
		if (link) link.click();
	}
	onLinkMouseEnter(e, link) {
		let target = link || e.target.closest('li') || e.target;
		if (target.closest('li').querySelector('.mmenu-submenu')) document.querySelectorAll('settings-dropdown').forEach(dropdown => dropdown.close());
		this.timer = setTimeout(() => {
			this.clearHovered();
			target.classList.add('hovered');
			this.setMaxHeight(target.querySelector('.mmenu-submenu'));
		}, 200);
	}
	onLinkMouseLeave(e) {
		let target = e.target.closest('li') || e.target;
		clearTimeout(this.timer);
		this.clearMaxHeight();
		target.classList.remove('hovered');
		document.body.classList.remove('compensate-scrollbar', 'overflow-hidden');
	}
	onSubmenuMouseEnter(e) {
		let target = e.currentTarget;
		target.classList.add('hovered');
		target.style.setProperty('--li-height', target.offsetHeight + 'px');
		if (target.querySelector('.submenu-list-wrap')) {
			let elm = target.querySelector('.mmenu-submenu') || target.querySelector('.submenu-list-wrap');
			if (!elm) return;
			let elmLeft = elm.getBoundingClientRect().left + pageXOffset,
				targetLeft = target.getBoundingClientRect().left + pageXOffset;
			if (target.closest('.submenu-list')) {
				if (target.closest('.mmenu-item--mega')) {
					if (document.body.classList.contains('rtl-mode')) {
						elm.style.left = targetLeft - target.offsetWidth + 'px'
					} else {
						elm.style.left = targetLeft + target.offsetWidth + 'px'
					}
				} else {
					elm.style.top = -target.offsetTop + 'px';
					elm.style.minHeight =  target.closest('.mmenu-submenu').offsetHeight + 'px'
				}
			}
			let isXvisible = document.body.classList.contains('rtl-mode') ? elmLeft >= 0 : (elmLeft + elm.offsetWidth) <= window.innerWidth;
			if (!isXvisible) {
				target.classList.add('to-right');
			} else {
				target.classList.remove('to-right');
			}
		}
	}
	onSubmenuMouseLeave(e) {
		let target = e.currentTarget,
			elm = target.querySelector('.mmenu-submenu') || target.querySelector('.submenu-list-wrap');
		target.classList.remove('hovered','to-right');
		target.style.removeProperty('--li-height');
		if (!elm) return;
		elm.style.top = '';
	}
	clearHovered() {
		document.body.classList.remove('overflow-hidden');
		this.megaLink.forEach(link => link.classList.remove('hovered'));
		this.simpleLink.forEach(link => {
			!link.classList.contains('menu-item-btn') && link.classList.remove('hovered')
		})
	}
	clearMaxHeight() {
		this.querySelectorAll('.max-height').forEach(el => {el.style.maxHeight = ''; el.classList.remove('max-height')})
	}
	setMaxHeight(submenu) {
		let wHeight = window.innerHeight;
		if (submenu && submenu.closest('.mmenu-item--mega') && !submenu.classList.contains('mmenu-submenu--boxed')) {
			let prev = submenu.previousElementSibling,
				maxH = document.body.classList.contains('has-sticky') ? wHeight - document.querySelector('.hdr-content-sticky').offsetHeight : wHeight - getCoords(prev).top - prev.offsetHeight - 15,
				submenuChildElement = submenu.querySelector('div');
			if (submenu.offsetHeight >= maxH) {
				submenuChildElement.style.maxHeight = maxH + 'px';
				submenuChildElement.classList.add('max-height');
				document.body.classList.add('compensate-scrollbar', 'overflow-hidden');
			}
		}
	}
}
customElements.define('mega-menu', MegaMenu);

class HeaderSticky extends HTMLElement {
	constructor() {
		super();
		this.init();
	}
	init() {
		this.header = document.querySelector('.hdr');
		this.headerNav = document.querySelector('.nav-holder');
		this.headerSticky = document.querySelector('.hdr-content-sticky');
		this.headerStickyNav = document.querySelector('.nav-holder-s');
		this.stickyCollision = document.querySelectorAll('.js-sticky-collision');
		this.lastScrollTop = 0;
		this.headerWrap = document.querySelector('.hdr-wrap');
		this.botomMobileHeader = document.querySelector('.hdr-mobile-bottom');
		this.offset = window.innerHeight;
		if (this.headerStickyNav) {
			this.headerStickyNav.insertAdjacentHTML('afterbegin', document.querySelector('.nav-holder').innerHTML);
			document.querySelectorAll('.nav-holder-s flow-type').forEach(el => {el.reinit()})
		}
		if (this.headerSticky) {
			new Promise(function (resolve) {
				setTimeout(() => {
					document.body.classList.add('has-hdr_sticky');
					resolve();
				},500)
			}).then(() => {
				setTimeout(() => {
					this.headerWrap.classList.remove('off-transition');
				}, 1000)
			})
		}
		this.setScroll();
		this.removeStickyClass();
		if (this.botomMobileHeader && !this.botomMobileHeader.classList.contains('scroll-down')) {
			document.body.classList.add('has-mobile-bottom');
		}
		this.initBreikpoint(true);
		window.addEventListener('resize', debounce(() => {
			this.initBreikpoint(false)
		}, 500))
	}
	initBreikpoint(startInit) {
		this.windowHeight = window.innerHeight;
		this.offset = document.querySelector('.page-content') ? document.querySelector('.page-content').offsetTop + 200 : 400;
		if (window.matchMedia(`(max-width:${mobileBreakpoint}px)`).matches) {
			if (this.header.classList.contains('hdr-transparent')) {
				this.header.classList.remove('hdr-transparent');
				this.header.classList.add('hdr-transparent-off');
				document.body.classList.remove('has-transparent-hdr')
			}
			startInit && this.headerWrap.classList.add('off-transition');
		} else {
			if (this.header.classList.contains('hdr-transparent-off')) {
				this.header.classList.add('hdr-transparent');
				document.body.classList.add('has-transparent-hdr')
			}
			this.headerWrap.classList.remove('off-transition');
			this.setHeight();
			this.multirow();
			this.multirowS();
			this.stickyHeight();
		}
	}
	setScroll() {
		let didScroll = true,
			delta = 2;
		setInterval(()=>{
			if (didScroll) {
				this.scrollEvents(delta);
				didScroll = false;
			}
		}, 100);
		window.addEventListener('scroll',() => {
			if (document.body.classList.contains('blockSticky')) return;
			didScroll = true;
			this.stickyCollision.forEach(el => {
				if (el.getBoundingClientRect().top < this.hSticky) {
					el.classList.add('is-collision')
				} else {
					el.classList.remove('is-collision')
				}
			})
		})
		this.scrollEvents(delta);
	}
	scrollEvents(delta) {
		if (document.body.classList.contains('blockSticky')) return;
		const st = window.scrollY,
			offset = this.offset,
			bodyElement = document.body;
		if (Math.abs(this.lastScrollTop - st) <= delta) return;
		if (!bodyElement.classList.contains('blockSticky')) {
			if (bodyElement.classList.contains('has-transparent-hdr')) {
				if (st < this.windowHeight) {
					this.headerWrap.classList.add('no-transition')
					this.removeStickyClass();
					bodyElement.classList.remove('scroll-up', 'scroll-down');
				} else if (st >= (document.body.offsetHeight - this.windowHeight - 62) || (st > this.lastScrollTop && !bodyElement.classList.contains('scroll-down'))) {
					this.removeStickyClass();
					this.removeSticky();
					this.headerWrap.classList.remove('no-transition')
				} else if (st < this.lastScrollTop && bodyElement.classList.contains('scroll-down')) {
					this.setStickyClass();
					this.setSticky();
					this.headerWrap.classList.remove('no-transition');
				}
			} else {
				if (st < offset) {
					this.removeStickyClass();
					bodyElement.classList.remove('scroll-up', 'scroll-down');
				} else if (st >= (document.body.offsetHeight - this.windowHeight - 62) || (st > this.lastScrollTop && !bodyElement.classList.contains('scroll-down'))) {
					this.removeStickyClass();
					this.removeSticky();
				} else if (st <= this.lastScrollTop && bodyElement.classList.contains('scroll-down')) {
					this.setStickyClass();
					this.setSticky();
				}
			}
			this.lastScrollTop = st;
		}
	}
	setStickyClass() {
		document.body.classList.add('has-sticky');
	}
	removeStickyClass() {
		document.body.classList.remove('has-sticky');
	}
	setSticky() {
		const bodyElement = document.body;
		bodyElement.classList.add('scroll-up');
		bodyElement.classList.remove('scroll-down');
		if (this.botomMobileHeader) {
			this.botomMobileHeader.classList.add('scroll-up');
			this.botomMobileHeader.classList.remove('scroll-down');
			bodyElement.classList.add('has-mobile-bottom')
		}
	}
	removeSticky() {
		const bodyElement = document.body;
		bodyElement.classList.add('scroll-down');
		bodyElement.classList.remove('scroll-up');
		if (this.botomMobileHeader) {
			this.botomMobileHeader.classList.add('scroll-down');
			this.botomMobileHeader.classList.remove('scroll-up');
			bodyElement.classList.remove('has-mobile-bottom')
		}
	}
	multirow() {
		if (this.headerNav.offsetHeight > 84) {
			this.header.classList.add('mmenu-multirow')
		} else this.header.classList.remove('mmenu-multirow')
	}
	multirowS() {
		if (this.headerStickyNav.offsetHeight > 84) {
			this.headerSticky.classList.add('mmenu-multirow-s')
		} else this.headerSticky.classList.remove('mmenu-multirow-s')
	}
	destroySticky() {
		this.removeStickyClass();
		if (window.matchMedia(`(min-width:1025px)`).matches) {
			document.body.style.marginTop = ''
		} else {
			document.body.classList.remove('scroll-up','scroll-down')
		}
		this.stickyCollision.forEach(el => {
			el.classList.remove('is-collision');
			setStyle(el.querySelector('div'), {'-webkit-transform': '','-ms-transform': '','transform': 'translate3d(0,0,0)','padding-bottom': ''});
		})
	}
	stickyHeight() {
		this.hSticky = this.headerSticky.offsetHeight;
		document.getElementsByTagName('html')[0].style.setProperty('--sticky-height', this.hSticky + 'px');
	}
	setHeight() {
		this.header.style.height = '';
		this.headerNav.style.height = '';
		if (!document.body.classList.contains('has-sticky')) {
			this.headerNav.style.height = this.headerNav.offsetHeight
		} else {
			document.body.classList.remove('has-sticky')
		}
	}
}
customElements.define('header-sticky', HeaderSticky);

class mobileBottomSticky extends HTMLElement {
	constructor() {
		super();
		if (document.querySelector('header-sticky')) return;
		this.init();
	}
	init() {
		this.stickyCollision = document.querySelectorAll('.js-sticky-collision');
		this.lastScrollTop = 0;
		this.botomMobileHeader = document.querySelector('.hdr-mobile-bottom');
		this.initBreikpoint();
		if (this.botomMobileHeader && !this.botomMobileHeader.classList.contains('scroll-down')) {
			document.body.classList.add('has-mobile-bottom');
		}
		window.addEventListener('resize', debounce(() => {
			this.initBreikpoint()
		}, 500))
	}
	initBreikpoint() {
		this.offset = window.innerHeight;
		if (!window.matchMedia(`(max-width:${mobileBreakpoint}px)`).matches) {
			clearInterval(this.scrollInteral);
			delete this.dataset.initialized
		} else if (!this.dataset.initialized) {
			this.setScroll();
			this.dataset.initialized = true
		}
	}
	setScroll() {
		let didScroll = true,
			delta = 2;
		this.scrollInteral = setInterval(()=>{
			if (didScroll) {
				this.scrollEvents(delta);
				didScroll = false;
			}
		}, 100);
		window.addEventListener('scroll',() => {
			didScroll = true;
		})
		this.scrollEvents(delta);
	}
	scrollEvents(delta) {
		const st = window.scrollY,
			offset = this.offset,
			bodyElement = document.body;
		if (Math.abs(this.lastScrollTop - st) <= delta) return;
		if (st < offset) {
			bodyElement.classList.remove('scroll-up', 'scroll-down');
		} else if (st >= (document.body.offsetHeight - this.windowHeight - 62) || (st > this.lastScrollTop && !bodyElement.classList.contains('scroll-down'))) {
			this.removeSticky();
		} else if (st <= this.lastScrollTop && bodyElement.classList.contains('scroll-down')) {
			this.setSticky();
		}
		this.lastScrollTop = st;
	}
	setSticky() {
		const bodyElement = document.body;
		bodyElement.classList.add('scroll-up');
		bodyElement.classList.remove('scroll-down');
		if (this.botomMobileHeader) {
			this.botomMobileHeader.classList.add('scroll-up');
			this.botomMobileHeader.classList.remove('scroll-down');
			bodyElement.classList.add('has-mobile-bottom')
		}
	}
	removeSticky() {
		const bodyElement = document.body;
		bodyElement.classList.add('scroll-down');
		bodyElement.classList.remove('scroll-up');
		if (this.botomMobileHeader) {
			this.botomMobileHeader.classList.add('scroll-down');
			this.botomMobileHeader.classList.remove('scroll-up');
			bodyElement.classList.remove('has-mobile-bottom')
		}
	}
}
customElements.define('mobile-bottom-sticky', mobileBottomSticky);

class MinicartProductImage extends HTMLElement {
	constructor() {
		super();
		const imageWrap = this.querySelector('.image-hover-scale');
		if (imageWrap) imageWrap.innerHTML = `<div class="image-wrap">${imageWrap.innerHTML}</div>`;
	}
	updateImage(url) {
		const currentURL = this.querySelector(`img:nth-child(${this.querySelectorAll('img').length})`).src;
		if (url.split("&width=")[0] == currentURL.split("&width=")[0]) return;
		if (url) {
			if (this.querySelectorAll('.image-container img').length > 1) {
				this.querySelector('.image-container img').remove()
			}
			const currentImg = this.querySelector('.image-container img');
			this.querySelector('[data-load]')?.setAttribute('data-load', 'loading');
			loadImage(url)
				.then(newImg => {
					newImg.classList.add('js-prd-img');
					return newImg;
				})
				.then(newImg => {
					if (!this.processing) {
						currentImg.parentNode?.insertBefore(newImg, currentImg.nextSibling);
						this.animateImage(currentImg, newImg, true);
					}
					this.querySelector('[data-load]')?.setAttribute('data-load', 'loaded');
				})
				.catch(err => console.error(err));
		}
	}
	animateImage(firstImage,lastImage,remove) {
		firstImage.animate([{ transform: 'translate3D(0, 0, 0)', opacity: 1 },{ transform: 'translate3D(0, -50%, 0)', opacity: 0 }], {duration: 350,iterations: 1,fill: 'both'});
		lastImage.animate([{ transform: 'translate3D(0, 50%,0)', opacity: 0 },{ transform: 'translate3D(0, 0, 0)', opacity: 1 }], {duration: 200,iterations: 1,fill: 'both'});
		if (remove) {
			setTimeout(() => {
				firstImage.remove();
			}, 300)
		}
	}
}
customElements.define('minicart-prd-img', MinicartProductImage);

document.addEventListener('click', function(e) {
	const target = e.target;
	if (target.closest('.modal-toggle-images')) {
		e.preventDefault();
		const modalWrap = target.closest('.modal-wrap');
		modalWrap.classList.toggle('images-off');
		modalWrap.querySelectorAll('.submenu-img').forEach(image => {
			const parent = image.parentNode;
			parent.classList.toggle('d-none');
		})
		setTimeout(() => {
			const scroll = Scrollbar.get(modalWrap.querySelector('.js-dropdn-content-scroll'));
			scroll && scroll.update()
		}, 0)
	}
})

class CategoryPopup extends Popup {
	constructorExtend() {
		const categoryPopupAll = document.querySelectorAll('category-popup'),
			i = categoryPopupAll.length - 1,
			modalHtml = this.closest('.hdr-mobile-bottom') ? `<div class="modal-wrap mmenu dropdn-modal-slide" style="display: none;" id="menuPopupMobile${i}"><div data-load="loading"></div><div data-ajax-container></div></div>` : `<div class="modal-wrap mmenu dropdn-modal-slide" style="display: none;" id="menuPopup${i}"><div data-load="loading"></div><div data-ajax-container></div></div>`,
			modalDiv = document.createElement('div');
		modalDiv.innerHTML = modalHtml;
		document.querySelector('header').appendChild(modalDiv);
		this.popupSelector = this.closest('.hdr-mobile-bottom') ? `#menuPopupMobile${i}` : `#menuPopup${i}`;
		this.popupElement = document.querySelector(this.popupSelector);
	}
	popupAfterCachLoad() {
		const offImages = this.popupElement.classList.contains('images-off');
		this.popupElement.querySelectorAll('.submenu-img').forEach(image => {
			const parent = image.parentNode;
			offImages ? parent.classList.add('d-none') : parent.classList.remove('d-none');
		})
		this.popupElement.querySelectorAll('.menu-label').forEach(label => label.closest('a')?.style.setProperty('--label-width', label.offsetWidth + 'px'));
	}
	popupAjaxExtend() {
		setTimeout(() => {
			const arrowDown = this.popupElement.querySelector('.mmenu-scroll-down'),
				scroll = Scrollbar.get(this.popupElement.querySelector('.js-dropdn-content-scroll')),
				size = scroll.size;
			this.popupElement.querySelectorAll('.menu-label').forEach(label => label.closest('a')?.style.setProperty('--label-width', label.offsetWidth + 'px'));
			if (size && size.content.height > size.container.height) {
				arrowDown.style.display = '';
				scroll.addListener(function (status) {
					if (status.offset.y == status.limit.y) {
						arrowDown.style.display = 'none';
					}
				})
			}
		}, 250)
	}
}
customElements.define('category-popup', CategoryPopup);

class SearchToggleMobile extends HTMLElement {
	constructor() {
		super()
		this.addEventListener('click', this.onButtonClick.bind(this));
		this.searchNode = this.closest('.hdr').querySelector('.hdr-open-search');
		this.dropSearch = this.querySelector('.dropdn-link');
		this.searchInput =  this.searchNode.querySelector('.form-control')
	}
	onButtonClick(event) {
		event.preventDefault();
		document.body.classList.add('blockSticky');
		this.searchNode.classList.toggle('is-open');
		this.dropSearch.classList.toggle('is-open');
		document.querySelectorAll('settings-dropdown').forEach(el => {
			el.close()
		})
		if (this.dropSearch.classList.contains('is-open')) {
			this.searchInput.focus()
		} else {
			this.blurInput()
		}
		setTimeout(() => {
			document.body.classList.remove('blockSticky');
		}, 1000)
	}
	close() {
		this.searchNode.classList.remove('is-open');
		this.dropSearch.classList.remove('is-open');
		this.blurInput()
	}
	blurInput() {
		this.searchInput.blur()
	}
}
customElements.define('search-toggle-mobile', SearchToggleMobile);

class SubmenuList extends HTMLElement {
	constructor() {
		super();
		this.menu = this.closest('.mmenu-item--mega');
		this.modal = this.closest('.modal-wrap-inside');
		this.ul = this.menu.getElementsByTagName('ul');
		this.visible = parseInt(this.menu.dataset.visible);
		this.viewLess();
		this.querySelector('.js-submenu-view-more')?.addEventListener('click', (e) => {
			e.preventDefault();
			if (this.menu.classList.contains('is-opened')) {this.viewLess()} else this.viewMore();
			this.modal.querySelector('[data-scrollbar]') && Scrollbar.get(this.modal.querySelector('[data-scrollbar]')).update();
		});
		for ( let i = 0; i < this.ul.length; i++ ) {
			if (this.ul[i].children.length <= this.visible) this.ul[i].nextElementSibling?.remove()
		}
	}
	viewLess() {
		this.menu.classList.remove('is-opened');
		for ( let i = 0; i < this.ul.length; i++ ) {
			let li = this.ul[i].getElementsByTagName('li')
			for ( let i = this.visible; i < li.length; i++ ) {
				li[i].classList.add('is-hidden')
			}
		}
	}
	viewMore() {
		this.menu.classList.add('is-opened');
		for ( let i = 0; i < this.ul.length; i++ ) {
			let li = this.ul[i].getElementsByTagName('li')
			for ( let i = this.visible; i < li.length; i++ ) {
				li[i].classList.remove('is-hidden')
			}
		}
	}
}
customElements.define('submenu-list', SubmenuList);

class ScrollList extends HTMLElement {
	constructor() {
		super();
		this.toggles = this.querySelectorAll('.scroll-list_button');
		this.list = this.querySelector('.scroll-list_list');
		this.scrollValue = 0;
		this.list.addEventListener('touchend',() => {this.stopScroll()});
		this.stopScroll();
		this.toggles.forEach(toggle => {
			['mousedown', 'touchstart'].forEach((event) => {
				toggle.addEventListener(event,(e) => {this.onButtonClick(e.target)});
			});
			['mouseup', 'touchend'].forEach((event) => {
				toggle.addEventListener(event,() => {this.stopScroll()});
			})
		})
		if (window.matchMedia(`(max-width:${this.dataset.breikpoint})`).matches) {
			this.checkScroll();
			if (this.hasAttribute('data-scroll-end')) {
				setTimeout(() => {
					this.list.scrollLeft = this.list.scrollWidth + 1;
					this.stopScroll()
				}, 10)
			} else this.stopScroll()
		}
		window.addEventListener('resize', debounce(() => {
			this.checkScroll()
		}, 500))
	}
	checkScroll() {
		if (window.matchMedia(`(max-width:${this.dataset.breikpoint})`).matches) {
			if (this.list.scrollWidth > this.list.offsetWidth) {
				this.classList.add('has-arrows')
			} else this.classList.remove('has-arrows')
		}
	}
	onButtonClick(target) {
		if (target.getAttribute('data-button-right') !== null) {
			this.interval = setInterval(() => {
				this.list.scrollLeft += 3;
			}, 1);
		} else {
			this.interval = setInterval(() => {
				this.list.ScrollLeft = this.scrollValue;
				this.list.scrollLeft -= 3;
			}, 1);
		}
	}
	stopScroll() {
		if (this.list.scrollLeft == 0) {
			this.querySelector('[data-button-left]').classList.add('disabled');
		} else {
			this.querySelector('[data-button-left]').classList.remove('disabled');
		}
		if (this.list.scrollWidth - this.list.scrollLeft <= this.list.offsetWidth) {
			this.querySelector('[data-button-right]').classList.add('disabled');
		} else {
			this.querySelector('[data-button-right]').classList.remove('disabled');
		}
		if (this.list.scrollLeft > 0) {
			this.scrollValue = this.list.scrollLeft;
		}
		clearInterval(this.interval);
	}
}
customElements.define('scroll-list', ScrollList);

function scrollToTopHandler(e) {
	e && e.preventDefault();
	this.blur();
	document.body.dataset.scrolling = true;
	document.body.classList.add('blockSticky');
	smoothScrollTo(0, scrollSpeed);
	if (document.body.classList.contains('has-hdr_sticky') && customElements.get('header-sticky')) document.body.querySelector('header-sticky')?.destroySticky();
	setTimeout(function () {
		delete document.body.dataset.scrolling;
		document.body.classList.remove('blockSticky');
		if (window.matchMedia(`(max-width:1024px)`).matches && mobileBottom) {
			document.body.classList.add('has-mobile-bottom');
			mobileBottom.classList.remove('scroll-down');
		}
	}, scrollSpeed)
}
const supportPageOffset = window.pageXOffset !== undefined,
	isCSS1Compat = ((document.compatMode || "") === "CSS1Compat"),
	scrollToTopBtn = document.querySelector('.js-back-to-top'),
	mobileBottom = document.querySelector('.hdr-mobile-bottom'),
	scrollSpeed = 500;

const appElementList = ["#smile-ui-container", "#shopify-chat-dummy", "#shopify-chat", "#dummy-chat-button-iframe"];
const appElementHigherList = [];

document.addEventListener('DOMContentLoaded', () => {
	scrollToTopBtn?.addEventListener('click', scrollToTopHandler.bind(this));
})

if (scrollToTopBtn) {
	window.addEventListener('scroll', function () {
		const cookieBanner = document.querySelector('#pandectes-banner'),
			cookieBannerVisible = cookieBanner && !cookieBanner.style.display == 'none' && !cookieBanner.classList.contains('cc-invisible'),
			wHeight = window.innerHeight;
		if (!window.matchMedia(`(max-width:1024px)`).matches || !cookieBannerVisible) {
			let scrollTop = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
			if (scrollTop > wHeight) {
				if (window.matchMedia(`(max-width:360px)`).matches) {
					if ((document.body.clientHeight - document.querySelector('.page-footer').clientHeight) >= scrollTop && scrollTop < (document.body.scrollHeight - wHeight - 10)) {
						scrollToTopBtn.classList.add('is-visible')
					} else {
						scrollToTopBtn.classList.remove('is-visible')
					}
				} else {
					scrollToTopBtn.classList.add('is-visible')
				}
				if (appElementList.filter(selector => document.querySelector(selector)).length > 0) document.body.classList.add('has-shopify-chat');
				if (appElementHigherList.filter(selector => document.querySelector(selector)).length > 0) document.body.classList.add('has-chat-higher');
			} else {
				scrollToTopBtn.classList.remove('is-visible')
			}
		} else {
			scrollToTopBtn.classList.remove('is-visible')
		}
	})
}
const newsletterPopup = {
	init(selector) {
		this.modalClass = selector;
		this.newsletter = document.querySelector(this.modalClass);
		this.modalEffect = this.newsletter.getAttribute('data-effect') || 'material-out';
		this.errorClass = 'newslettermodal-error';
		this.successClass = 'newslettermodal-off';
		this.errorPopup = '#popupSubscribeError';
		this.successPopup = '#popupSubscribeSuccess';
		this.offCheckbox = document.body.querySelector('#offNewsletterCheckbox');
		this.scrollbarNewsletter;
		this.expiresToSec = parseInt(this.newsletter.getAttribute('data-expires'), 10) * 86400;
		const uri = window.location.toString();
		if (this.newsletter.getAttribute('data-only-index') == 'true' && !document.body.classList.contains('template-index')) {
			return false;
		}
		if (uri.indexOf("?customer_posted=true") > 0) {
			this.setCookie()
		} else this.checkCookie();
		this.checkBoxOff();
	},
	checkBoxOff() {
		this.offCheckbox?.addEventListener('change', () => {
			if (this.offCheckbox.checked) {
				this.setCookie()
			} else {
				docCookies.removeItem('lumiaNewsLetter');
			}
		})
	},
	openError() {
		jq.fancybox.open({
			src: this.errorPopup,
			type: 'inline',
			afterClose: () => {
				let top = document.querySelector('.page-footer') ? document.querySelector('.page-footer').offsetTop : document.body.scrollHeight;
				top && smoothScrollTo(top, 1000);
				history.replaceState && history.replaceState(
					null, '', location.pathname + location.search.replace(/[\?&][^&]+/, '').replace(/^&/, '?')
				)
			}
		})
	},
	openSuccess() {
		jq.fancybox.open({
			src: this.successPopup,
			type: 'inline',
			afterClose: () => {
				if (window.location.toString().indexOf("?customer_posted=true") > 0) {
					history.replaceState && history.replaceState(
						null, '', location.pathname + location.search.replace(/[\?&]customer_posted=[^&]+/, '').replace(/^&/, '?')
					);
				}
			}
		})
	},
	setCookie() {
		if (this.expiresToSec != 0) {
			docCookies.setItem('lumiaNewsLetter', '', this.expiresToSec);
		}
	},
	setCookieSuccess(days) {
		if (days) {
			docCookies.setItem('lumiaNewsLetterSuccess', '', parseInt(days, 10) * 86400);
		}
	},
	checkCookie() {
		if (!docCookies.hasItem('lumiaNewsLetter') || document.body.classList.contains('demo') || this.expiresToSec == 0) {
			this.openNewsletterPopup();
		}
	},
	openNewsletterPopup() {
		const pause = this.newsletter.getAttribute('data-pause') > 0 ? this.newsletter.getAttribute('data-pause') : 2000;
		const openPopup = () => {
			jq.fancybox.open([{
				src: this.modalClass,
				type: 'inline',
				animationEffect: this.modalEffect,
				animationDuration: 300,
				keys: {
					close: [27]
				}
			}], {
				beforeShow: () => {
					document.querySelectorAll('main-slider').forEach(slider => slider.stopAutoplay())
				},
				afterShow: () => {
					scrollbarNewsletter = Scrollbar.init(this.newsletter.querySelector('.js-dropdn-content-scroll'), {
						alwaysShowTracks: true,
						damping: document.body.dataset.damping
					});
					const searchInput = document.querySelector('search-toggle-mobile');
					if (searchInput && 'blurInput' in searchInput) searchInput.blurInput();
					this.newsletter.classList.add('is-animate');
					bodyScrollLock.disableBodyScroll(this.newsletter);
				},
				beforeClose: () => {
					bodyScrollLock.enableBodyScroll(this.newsletter);
					this.newsletter.classList.remove('is-animate');
				},
				afterClose: () => {
					this.scrollbarNewsletter ? this.scrollbarNewsletter.setPosition(0, 0) : false;
					document.querySelectorAll('main-slider').forEach(slider => slider.startAutoplay());
				}
			})
		};
		setTimeout(() => {
			const interval = setInterval(function() {
				if (!document.body.classList.contains('fancybox-active')) {
					clearInterval(interval);
					openPopup();
				}
			}, 500);
		}, pause);
		setTimeout(() => {
			if (document.body.classList.contains('newslettermodal-off')) {
				this.setCookie()
			}
		}, pause * 2);
	}
}
const newsmodalSelector = '.js-newslettermodal';

if (document.querySelector(newsmodalSelector)) {
	newsletterPopup.init(newsmodalSelector)
}
class PromoPopup extends HTMLElement {
	constructor() {
		super();
		const tpl = document.querySelector('#promo-popup');
		if (tpl) {
			const  clone = document.importNode(tpl.content, true);
			this.appendChild(clone);
		}
	}

	attributeChangedCallback(name, oldValue, newValue) {
		switch (name) {
			case 'title':
				this.querySelector('.js-pn-name').innerText = newValue;
				this.querySelector('.js-pn-link')?.setAttribute('title', newValue);
				this.querySelector('.js-pn-image')?.setAttribute('alt', newValue);
				break;
			case 'image':
				if (newValue != false) {
					if (document.querySelector('.js-pn')) document.querySelector('.js-pn')?.classList.remove('payment-notification--image-off');
					const img = this.querySelector('.js-pn-image');
					if (img) {
						img.removeAttribute('src');
						img.setAttribute('data-src', newValue);
						img.classList.remove('lazyload');
						img.classList.remove('lazyloaded');
					}
					const quickVew = this.querySelector('quickview-popup');
					if (quickVew && this.closest('.payment-notification-wrap').getAttribute('data-gallery') == 'true') {
						quickVew.setAttribute('data-gallery', 'on')
					} else quickVew.setAttribute('data-gallery', 'off');
				} else {
					document.querySelector('.js-pn')?.classList.add('payment-notification--image-off');
					this.querySelector('quickview-popup').setAttribute('data-gallery', 'off');
				}
				this.querySelectorAll('.image-container > img').length > 1 && this.querySelector('.image-container > img:nth-child(2)').remove();
				break;
			case 'image_hover':
				if (newValue != false) {
					const img = new Image();
					img.setAttribute('data-src', newValue);
					img.setAttribute('alt', this.querySelector('.js-pn-image').getAttribute('alt'));
					this.querySelector('.image-container')?.appendChild(img);
					this.querySelector('.image-container')?.classList.remove('image-hover-scale')
				} else {
					this.querySelector('.image-container')?.classList.add('image-hover-scale')
				}
				break;
			case 'url':
				this.querySelectorAll('.js-pn-link').forEach(
					(link) => link.setAttribute('href', newValue)
				);
				let quickViewSuffix = newValue.includes('_pos') ? '&' : '?';
				this.querySelector('quickview-popup').setAttribute('data-ajax', newValue + quickViewSuffix + 'section_id=quick-view');
				break;
			case 'handle':
				this.querySelector('quickview-popup').setAttribute('data-handle', newValue);
				break;
			case 'time':
				this.querySelector('.js-pn-time').innerText = newValue;
				break;
			case 'from':
				this.querySelector('.js-pn-from').innerText = newValue;
				break;
			case 'label_new':
				if (newValue != false) {
					this.querySelector('.payment-label--new').classList.remove('d-none');
					this.querySelector('.payment-label--new').innerText = newValue;
				} else {
					this.querySelector('.payment-label--new').classList.add('d-none');
				}
				break;
			case 'label_sale':
				if (newValue != false) {
					this.querySelector('.payment-label--sale').classList.remove('d-none')
				} else {
					this.querySelector('.payment-label--sale').classList.add('d-none')
				}
				break;
		}
	}

	static get observedAttributes() {
		return ['title', 'image', 'image_hover', 'url', 'handle', 'time', 'from', 'label_new', 'label_sale'];
	}
}
customElements.define('promo-popup', PromoPopup);

const random = function random(min, max) {
	return Math.floor(Math.random() * (max - min + 1) + min);
}

function getSizedImageUrl(src, size) {
	if (size === null || !document.body.classList.contains('shopify-theme')) {
		return src;
	} else if (src === null) {
		return null;
	} else return src + '&width=' + size;
}

const popup = new PromoPopup();
const popupWrap = document.querySelector('.payment-notification-wrap');

if (popupWrap) {
	popupWrap.querySelector('.js-pn').append(popup);
	const productJson = JSON.parse(popupWrap.querySelector('[type="application/json"]').textContent);
	const paymentNotification = {
		init() {
			this.destroyed = false;
			this.paymentNotification = document.querySelector('.js-pn');
			this.fromArray = this.paymentNotification.dataset.from.split(",");
			this.maxAgoMin = this.paymentNotification.dataset.max ? this.paymentNotification.dataset.max : 59;
			this.minAgoMin = this.paymentNotification.dataset.min ? this.paymentNotification.dataset.visibleTime : 5;
			this.paymentNotificationVisible = this.paymentNotification.dataset.visibleTime ? parseInt(this.paymentNotification.dataset.visibleTime,10) : 5000; /* min 2000 */
			this.paymentNotificationDelay = this.paymentNotification.dataset.delay ? parseInt(this.paymentNotification.dataset.delay,10) : 12000;
			this.paymentNotificationPeriod = this.paymentNotification.dataset.hiddenTime ? parseInt(this.paymentNotification.dataset.hiddenTime,10) : 10000;
			this.classOpen = 'payment-notification--open';
			this.btnClose = document.querySelector('.js-payment-notification-close');
			let random = Math.floor(Math.random() * productJson.title.length);
			this._setData(random);
			setTimeout(() => {
				this.showPopup();
				this.timeout = setInterval(() => {
					this.showPopup()
				}, this.paymentNotificationVisible + this.paymentNotificationPeriod);
			}, this.paymentNotificationDelay)
			this.btnClose.addEventListener('click', (e) => {
				e.preventDefault();
				this._hidePaymentNotification();
				if (this.paymentNotification.getAttribute('data-close')) {
					this.destroy();
				}
			})
		},
		showPopup() {
			const cookieBanner = document.querySelector('#pandectes-banner');
			if (!window.matchMedia(`(max-width:1024px)`).matches || !cookieBanner || cookieBanner.style.display == 'none') {
				const random = Math.floor(Math.random() * productJson.title.length);
				this.paymentNotification.classList.add(this.classOpen);
				this.paymentNotification.querySelectorAll('img').forEach(img => {
					img.classList.add('lazyload')
				});
				delay(this.paymentNotificationVisible).then(() => {
					if (this.destroyed) return;
					this._hidePaymentNotification();
					setTimeout(() => {
						this._setData(random)
					}, this.paymentNotificationPeriod / 2)
				})
			}
		},
		destroy() {
			this.hideTippy();
			this.paymentNotification.remove();
			if (this.timeout) clearInterval(this.timeout);
			this.destroyed = true;
			document.querySelector('#promo-popup')?.remove();
		},
		_hidePaymentNotification() {
			this.hideTippy();
			this.paymentNotification.classList.remove(this.classOpen)
		},
		hideTippy(){
			const tippyNode = this.paymentNotification.querySelector('quickview-popup');
			if (tippyNode._tippy) tippyNode._tippy.hide();
		},
		setCities(list) {
			this.defaults.fromArray = list
		},
		_setData(i) {
			const nameString = window.themeStrings.new || 'new',
				labelNew = productJson.tags[i].includes(nameString) || productJson.tags[i].includes(window.themeStrings.new.toLowerCase()) ? nameString : 0;
			let opt = {
				'title': productJson.title[i],
				'image': productJson.image[i] == null ? 0 : getSizedImageUrl(productJson.image[i].preview_image.src, 106 * 2),
				'image_hover': productJson.images[i][1] ? getSizedImageUrl(productJson.images[i][1], 106 * 2) : 0,
				'url': productJson.url[i],
				'handle': productJson.handle[i],
				'from': this.fromArray[random(0, this.fromArray.length)],
				'time': random(this.minAgoMin, this.maxAgoMin),
				'label_new': labelNew,
				'label_sale': productJson.price_old[i] == null ? 0 : 1,
			};
			Object.keys(opt).forEach(function (key) {
				popup.setAttribute(key, opt[key])
			});
		},
		_showPaymentNotification() {
			this.paymentNotification.classList.add(this.classOpen)
		}
	}
	paymentNotification.init()
}
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.footer-col').forEach(el => {
		if (!el.querySelector('.collapsed-mobile')) {
			el.classList.add('footer-col--no-collapsed');
		}
	})
	document.querySelectorAll('.footer-list-title').forEach(el => {
		el.addEventListener('click', function (e) {
			e.preventDefault();
			this.closest('.collapsed-mobile').classList.toggle('open');
		})
	})
})
function copyToClipboard(element) {
	const textToCopy = element.dataset.copyText;
	let tempElement = document.createElement('input');
	tempElement.type = 'text';
	tempElement.value = textToCopy;
	document.body.appendChild(tempElement);
	tempElement.select();
	document.execCommand('Copy');
	document.body.removeChild(tempElement);
}

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-promoline-copy').forEach((text) => {
		text.addEventListener('click', function (e) {
			e.preventDefault();
			copyToClipboard(this);
			setTimeout(function () {
				tippy.hideAll()
			}, 1200)
		})
	})

	let promoSwiper = document.querySelector('.js-promoline-text-carousel .swiper-container')?.swiper;
	const promoSwiperWrap = document.querySelector('.js-promoline-text-carousel');
	promoSwiperWrap?.addEventListener('mouseenter', function () {
		promoSwiper.autoplay.stop()
	});
	promoSwiperWrap?.addEventListener('mouseleave', function () {
		promoSwiper.autoplay.start()
	})
})
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.catalogMode = this.dataset.catalogMode;
    this.groupTag = 'select';
    this.groupOptionTag = 'option';
    this.sectionLayout = this.dataset.sectionLayout;
    this.sectionId = this.dataset.sectionId;
    this.section = this.closest('[data-section-render]');
    this.requestPageType = this.dataset.requestPageType;
    this.addEventListener('change', this.onVariantChange);
    this.initVariant = this.getVariantData().find(variant => variant.id === parseInt(this.dataset.initVariant));
    this.currentVariant = this.getVariantData().find(variant => variant.id === parseInt(this.dataset.initVariant));
    if (this.tagName !== 'VARIANT-SELECT') this.disableUnavailable();
  }

  onVariantChange() {
    this.renderSection();
    this.syncOptions();
  }

  renderSection() {
    this.updateOptions();
    this.updateMasterId();
    this.disableUnavailable();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateOptionTitles();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  disableUnavailable() {
    let groupTag = this.groupTag;
    let groupOptionTag = this.groupOptionTag;
    let groupsSelector = `${groupTag}:not(.option-first)`;
    let groups = Array.from(this.querySelectorAll(groupsSelector));
    let optionsAll = this.querySelectorAll(`${groupsSelector} ${groupOptionTag}`);
    if (groups.length) {
      if (groupOptionTag === 'input') optionsAll.forEach(el => el.parentElement.classList.add('disabled')); else optionsAll.forEach(el => el.disabled = true);
      if (!this.currentVariant) {
        let groupLast = groups[groups.length - 1];
        if (!this.currentVariant) {
          const optionChecked = groupLast.querySelector(groupOptionTag + ':checked');
          if (groupOptionTag === 'input') optionChecked.checked = false; else optionChecked.selected = false;
        }
        groupLast.querySelectorAll(groupOptionTag).forEach(input => {
          if (!this.currentVariant) {
            if (groupOptionTag === 'input') {
              input.checked = true;
              this.setGroupSwatchActive(input);
            } else {
              input.selected = true;
            }
            this.updateOptions();
            this.updateMasterId();
          }
        });
        if (!this.currentVariant) {
          let option1 = this.querySelector(`${groupTag} ${groupOptionTag}:checked`).value;
          this.currentVariant = this.getVariantData().find(variant => variant.option1 === option1);
          groups.forEach((group, key) => {
            let value = this.currentVariant.options[key + 1];
            const optionChecked = group.querySelector(groupOptionTag + ':checked');
            const optionToCheck = group.querySelector(`[value="${value}"]`);
            if (groupOptionTag === 'input') {
              optionChecked.checked = false;
              optionToCheck.checked = true;
            } else {
              optionChecked.selected = false;
              optionToCheck.selected = true;
            }
          });
          this.updateOptions();
        }
      }
      for (let i = 0; i < (groups.length); i++) {
        let variants = this.getVariantData().filter(variant => {
          if (i === 0) return variant.options[i] === this.currentVariant.options[i];
          if (i === 1) return variant.options[i - 1] === this.currentVariant.options[i - 1] && variant.options[i] === this.currentVariant.options[i];
        });
        variants.forEach(variant => {
          let item = Array.from(optionsAll).find(option => {
            return option.value === variant.options[i + 1]
          });
          if (groupOptionTag === 'input') item.parentElement.classList.remove('disabled'); else item.disabled = false;
        })
      }
    }
  }

  onVariantMouseenter(el) {
    if (this.currentVariant.options.length > 2) return;

    let groupTag = this.groupTag;
    let groupOptionTag = this.groupOptionTag;
    let lvls = this.dataset.lvls;
    let lvl = parseInt(el.closest(groupTag).dataset.lvl);
    if (lvl < (lvls - 1)) {
      let optionHover = el.querySelector('input').value;
      const option1 = this.querySelectorAll(groupTag)[0].querySelector(groupOptionTag + ':checked')?.value;
      let groupToRender = Array.from(this.querySelectorAll(groupTag))[lvl + 1];
      let optionsToRender = groupToRender.querySelectorAll(`${groupOptionTag}`);
      optionsToRender.forEach(el => el.parentElement.classList.add('disabled'));
      let variants = this.getVariantData().filter(variant => {
        if (lvl === 0) return variant.options[0] === optionHover;
        if (lvl === 1) return variant.options[0] === option1 && variant.options[1] === optionHover;
      });
      variants.forEach(variant => {
        let item = Array.from(optionsToRender).find(input => input.value === variant.options[lvl + 1]);
        item.parentElement.classList.remove('disabled');
      })
    }
  }

  onVariantMouseout() {
    this.disableUnavailable();
  }

  updateOptionTitles() {
    this.querySelectorAll('[data-option-value]').forEach((el, key) => {
      el.textContent = this.currentVariant.options[key]
    })
  }

  syncOptions() {
    const sectionsToSync = ['product-sticky', 'product'];
    if (sectionsToSync.includes(this.sectionLayout)) {
      const destination = this.sectionLayout === sectionsToSync[0] ? sectionsToSync[1] : sectionsToSync[0];
      const variantRadios = document.querySelector('variant-radios[data-section-layout="' + destination + '"]');
      const variantSelects = document.querySelector('variant-selects[data-section-layout="' + destination + '"]');
      if (variantRadios || variantSelects) {
        const variantPicker = variantRadios ? variantRadios : variantSelects;
        const fieldsets = variantPicker.querySelectorAll(variantRadios ? 'fieldset' : 'select');
        if (fieldsets) {
          fieldsets.forEach((group, index) => {
            group.querySelectorAll(variantRadios ? 'input' : 'option').forEach(el => {
              if (variantRadios) el.checked = false; else el.selected = false;
            });
            group.querySelectorAll(variantRadios ? 'input' : 'option').forEach((el, index2) => {
              if (el.value === this.options[index]) {
                if (variantRadios) {
                  this.setGroupSwatchActive(el);
                  el.checked = true
                } else {
                  el.selected = true
                }

              }
            });
            group.value = this.options[index];
          })
          variantPicker.renderSection();
        }
      }
    }
  }

  setGroupSwatchActive(el) {
    const group = el.closest(this.groupTag) ?? el.closest("fieldset");

    group.querySelectorAll('label').forEach(el => {
      el.classList.remove('swatch-active');
    });

    el.parentElement.classList.add('swatch-active');
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;

    const currentVariantImageSrc = this.currentVariant.featured_media?.preview_image.src;

    if (this.sectionLayout === 'product' || this.sectionLayout === 'quick-view') {
      const productContainer = this.closest('.prd-block');
      const productGalleryElement = productContainer.querySelector('product-gallery');
      const scrollSync = productGalleryElement?.dataset.scrollSync || false;
      const isScrollSync = (scrollSync === 'true');
      const modelVariantsSchemaElement = document.querySelector('[id^="3d-model-variants"]');
      let modelVariantsSchema
        , modelVariantsSchemaVariant
        , modelElement
        , changeModel
        , nodes
        , target
        , galleryMain;

      if (modelVariantsSchemaElement) {
        modelVariantsSchema = JSON.parse(modelVariantsSchemaElement.textContent)
        modelVariantsSchemaVariant = modelVariantsSchema.find(item => item[0] == this.currentVariant.id);

        if (modelVariantsSchemaVariant) {
          modelElement = Array.from(productContainer.querySelectorAll('product-gallery model-viewer')).find(item => item.availableVariants.includes(modelVariantsSchemaVariant[1]));

          if (modelVariantsSchema && modelVariantsSchemaVariant && modelElement) {
            changeModel = true

            galleryMain = modelElement.closest('.js-product-main-carousel');
            nodes = galleryMain.querySelectorAll('[data-media-id]');
            target = modelElement.closest('[data-media-id]');
          }
        }
      }

      // console.log('modelVariantsSchema',modelVariantsSchema);
      // console.log('modelVariantsSchemaVariant',modelVariantsSchemaVariant);
      // console.log('modelElement',modelElement);

      if (this.dataset.optionColor == 'true') {
        const option = this.currentVariant;
        console.log(option);
      }


      if (changeModel) {
        modelElement.variantName = modelVariantsSchemaVariant[1];
      } else {
        if (!this.currentVariant.featured_media) return;

        const newMedia = document.querySelector(
          `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (!newMedia) return;

        galleryMain = productContainer.querySelector('.js-product-main-carousel');
        nodes = galleryMain.querySelectorAll('[data-media-id]');
        target = galleryMain.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
      }

      const hasColorOption = this.dataset.hasColorOption === 'true';
      const colorOptionOrder = parseInt(this.dataset.colorOptionOrder);
      const productGallery = productContainer.querySelector('product-gallery')
      const colorGroups = productGallery.dataset.colorGroups;
      const colorName = colorGroups && this.currentVariant.options[colorOptionOrder].toLowerCase().replace(' ','-');
      const selectedColorGroupAvailable = colorGroups && colorGroups.split(',').some(item => item === colorName)

      if (hasColorOption && colorGroups && selectedColorGroupAvailable) {
        productGallery.filter(`color-${colorName}`)
      } else {
        const index = [].indexOf.call(nodes, target);

        productGallery.filter('all', false, index);
      }

      /*
      if (window.matchMedia('(max-width:767px)').matches) {
        if (this.sectionLayout === 'product') {
          smoothScrollTo(getCoords(productGalleryElement).top - 55, 300)
        } else {
          const scrollElement = productContainer.querySelector('.prd-block-scroll');
          const scrollInstance = Scrollbar.get(scrollElement);
          if (scrollElement && scrollInstance && scrollInstance.offset.y > 0) {
            scrollInstance.scrollTo(0, 0, 300);
          }
        }
      }
      */

      productGalleryElement.updateZoomLink(currentVariantImageSrc)
    } else {
      if (!this.currentVariant.featured_media) return;

      if (this.sectionLayout === 'product-card' || this.sectionLayout === 'product-card-horizontal') {
        this.closest('product-card').updateImage(this.currentVariant.id);

      } else if ('product-card-compact, product-card-wishlist, product-sticky, header-cart-line-item'.includes(this.sectionLayout)) {
        let sizedImageUrl = '';
        const parentElement = this.closest('.minicart-prd') || this.closest('.sticky-add-to-cart');
        sizedImageUrl = theme.Images.getSizedImageUrl(currentVariantImageSrc, 156 * 2);

        sizedImageUrl && parentElement.querySelector('minicart-prd-img').updateImage(sizedImageUrl);
      }
    }
  }

  updateURL() {
    if (this.sectionLayout === 'product') {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    } else {
      this.section.querySelectorAll(`[data-url]`).forEach(el => {
        el.setAttribute('href', `${this.dataset.url}?variant=${this.currentVariant.id}`);
      });
    }
  }

  updateShareUrl() {
    if (this.sectionLayout !== 'product') return;
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    let formElement = this.section.querySelectorAll(`form`);
    formElement = formElement.length ? formElement : this.section.querySelectorAll(`[data-form]`);
    formElement.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  updatePickupAvailability() {
    if (this.sectionLayout !== 'product') return;

    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    if (!this.section) return;
    const productForm = this.section.querySelector('[data-form]') || this.closest('product-form');
    if (productForm && productForm.getAttribute('id') !== 'product-form-installment') productForm.handleErrorMessage();
  }

  renderProductInfo() {
    let section = this.sectionId;
    if (this.sectionLayout === 'product') {
      section = this.dataset.sectionId
    }
    /* const url = this.requestPageType === 'search' ? this.dataset.url + '&amp;' : this.dataset.url+'?'; */
    const url = this.dataset.url;
    const queryKey = section + '-' + this.sectionLayout + '-' + this.currentVariant.id;

    if (this.cachedResults[queryKey]) {
      this.productRenderElements(this.cachedResults[queryKey], section);
      return;
    }
    fetch(`${url}?variant=${this.currentVariant.id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.cachedResults[queryKey] = html;
        this.productRenderElements(html, section);
      });
  }

  productRenderElements(html) {
    this.section.querySelectorAll('[data-render]').forEach(destination => {
      if (this.closest('products-card-compact') || !destination.closest('products-card-compact')) { //disabling fbt rendering
        const source = html.querySelector(`[data-render=${destination.dataset.render}]`);
        if (source) destination.innerHTML = source.innerHTML;
      }
    });
    const price = this.section.querySelector(`[data-render=price]`);
    if (price) price.classList.remove('hidden');

    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    this.closest('product-form') && 'afterRenderEvents' in this.closest('product-form').dataset && this.closest('product-form')?.afterRenderEvents();
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = this.section.querySelector('[data-form]');
    if (!productForm) return;
    let addButton = productForm.querySelector('[name="add"]');
    let addButtonText = addButton?.querySelector('span');
    let preOrder = productForm.querySelector('[data-form-preorder]');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      const preOrderCondition = this.currentVariant.inventory_management && this.currentVariant.inventory_quantity < 1;
      preOrder.disabled = !preOrderCondition;
      if (this.currentVariant.requires_selling_plan) {
        addButtonText.textContent = window.variantStrings.addSubscriptionToCart;
      } else {
        addButtonText.textContent = preOrderCondition ? window.variantStrings.preOrder : window.variantStrings.addToCart;
      }
    }

    this.setUnavailable(addButtonText);

    /* if (this.sectionLayout === 'product') {
       let destination = document.getElementById(`js-modal-info-link-${this.dataset.section}`);
       if (disable) {
         destination?.classList.add('hidden');
       } else {
         destination?.classList.remove('hidden');
       }
     }*/

    if (!modifyClass) return;
  }

  setUnavailable(addButtonText) {
    if (!this.currentVariant) {
      addButtonText.textContent = window.variantStrings.unavailable;
      /*const price = this.section.querySelector(`[data-render=price]`);
      if (price) price.classList.add('hidden')*/
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

}

customElements.define('variant-selects', VariantSelects);

class VariantSelect extends VariantSelects {
  onVariantChange(e) {
    let index;
    const getWishlist = typeof wishlist !== 'undefined' && wishlist && this.dataset.sectionLayout === 'product-card-wishlist';
    getWishlist && (index = wishlist.remove(null, this));
    this.updateMasterId(e);
    if (getWishlist) {
      wishlist.add(null, this, index);
      wishlist.renderComponents('wishlist-items');
    }
    this.updateMedia();
    this.removeErrorMessage();
    this.renderProductInfo();
    this.updateURL();
  }

  updateMasterId(e) {
    this.currentVariant = this.getVariantData().find(variant => variant.id == e.target.value);
    this.dataset.variantId = this.currentVariant.id
  }
}


customElements.define('variant-select', VariantSelect);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.groupTag = 'fieldset';
    this.groupOptionTag = 'input';
    if (!this.classList.contains('show_colors_only')) {
      this.querySelectorAll('label').forEach(item => item.addEventListener('mouseover', this.onVariantMouseenter.bind(this, item)));
      this.querySelectorAll('label').forEach(item => item.addEventListener('mouseout', this.onVariantMouseout.bind(this)));
      this.querySelectorAll('label').forEach(item => item.addEventListener('click', this.onVariantClick.bind(this)));
      this.currentVariant = this.getVariantData().find(variant => variant.id === parseInt(this.dataset.initVariant));
      this.disableUnavailable();
    }
  }

  onVariantClick(e) {
    const target = e.currentTarget;
    const group = target.closest(this.groupTag);

    group.querySelectorAll('label').forEach(element => {
      element.classList.remove('swatch-active');
    });

    target.classList.add('swatch-active')
  }


  setGroupSwatchActive(el) {
    const group = el.closest(this.groupTag);

    group.querySelectorAll('label').forEach(el => {
      el.classList.remove('swatch-active');
    });

    el.parentElement.classList.add('swatch-active');
  }




  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      let isSelectedRow;
      isSelectedRow = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);

      if (!isSelectedRow) {
        fieldset.querySelectorAll('input')[0].checked = true
      }

      isSelectedRow = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);

      return isSelectedRow.value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      Array.from(document.querySelectorAll(`[name=${event.target.name}]`)).filter(item => item != event.target).forEach(item => item.value = event.target.value);
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    }, 300))
  }
}
customElements.define('cart-note', CartNote);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input[name="locale_code"]'),
    };

    this.querySelectorAll('li:not([data-other]) a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();

    const form = this.querySelector('form');

    this.elements.input.value = event.currentTarget.dataset.value;

    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);

window.theme = window.theme || {};
theme.Images = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element);
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    if (src === null) {
      return null;
    }

    return src + '&width=' + size;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

function onSaveAttrListener(e) {
  const target = e.currentTarget;
  if (target.dataset.handler) {
    window[target.dataset.handler].call(target);
  }

  const { saveAttr } = target.dataset;

  if (saveAttr) {
    const body = JSON.stringify({ attributes: JSON.parse(saveAttr) });
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .catch(e => console.error(e))
      .finally(() => {
        if ('toggle' in target.dataset) {
          target.dataset.saveAttr = `{ "${target.dataset.toggle}": ${!JSON.parse(saveAttr)[target.dataset.toggle]} }`
        }
        FacetFiltersForm.filterData = [];
        // document.querySelectorAll('async-reload')?.forEach(item => item.cachedResults = []);
        AsyncReload.cachedResults = [];
      })
  }
}

function saveAttrListener(context) {
  context.querySelectorAll('[data-save-attr]').forEach((item) => {
    item.addEventListener('click', onSaveAttrListener)
  });
}

saveAttrListener(document);

customElements.define('save-attr', class SaveAttr extends HTMLElement {
  constructor() {
    super();
    saveAttrListener(this);
  }
});

class AsyncReload extends HTMLElement {
  constructor() {
    super();
    // AsyncReload.cachedResults = [];
    this.urlUpdate = 'urlUpdate' in this.dataset ? true : false
    this.reloadMode = 'reload' in this.dataset ? this.dataset.reload : 'fullpage'
    this.pageSelector = '#pageContent';
    this.loader = document.querySelector("loading-bar");
    this.addEventListener('click', this.onClickHandler.bind(this));
  }

  onClickHandler(e) {
    const target = e.target.tagName === 'A' ? e.target : e.target.closest('a')

    if (target) {
      const url = target.href;

      if ((url.indexOf("#") === -1)) {
        e.preventDefault();
        target.closest('.swiper-wrapper')?.childNodes.forEach(item => item.querySelector('a').classList.remove('active'));
        target.closest('a').classList.add('active');
        this.loader.start();
        this.getPageHtml(url);
      }
    }
  }

  getPageHtml(url) {
    const filterDataUrl = element => element.url === url;

    if (AsyncReload.cachedResults.some(filterDataUrl)) {
      const html = AsyncReload.cachedResults.find(filterDataUrl).html;

      this.renderCurrentPage(html, url);

      if (this.reloadMode !== 'css') return;
    }

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.text();
      })
      .then(html => {
        if (AsyncReload.cachedResults.some(filterDataUrl) && this.reloadMode === 'css') return;

        this.renderCurrentPage(html, url);

        AsyncReload.cachedResults = [...AsyncReload.cachedResults, { html, url }];
      })
      .catch((error) => {
        console.error(error)
      });
  }

  renderElements(html) {
    document.querySelectorAll('[data-async-reload]').forEach(destination => {
      const source = html.querySelector(`[data-async-reload=${destination.dataset.asyncReload}]`);
      if (source) destination.innerHTML = source.innerHTML;
    });
  }

  renderCss(html) {
    document.querySelectorAll('[data-async-reload-css]').forEach(destination => {
      const source = html.querySelector(`[data-async-reload-css=${destination.dataset.asyncReloadCss}]`);
      if (source) destination.innerHTML = source.innerHTML;
    });
  }

  renderRequiredElements(html) {
    document.querySelectorAll('[data-async-reload-required]').forEach(destination => {
      const source = html.querySelector(`[data-async-reload-required=${destination.dataset.asyncReloadRequired}]`);
      if (source) destination.innerHTML = source.innerHTML;
    });

    document.querySelector('demo-panel')?.init()
  }

  renderCurrentPage(html, url) {
    let renderedDocument = new DOMParser().parseFromString(html, 'text/html');

    if (this.reloadMode === 'fullpage') {
      document.querySelector(this.pageSelector).innerHTML = renderedDocument.querySelector(this.pageSelector).innerHTML;
    } else if (this.reloadMode === 'css') {
      this.renderCss(renderedDocument);
    } else {
      this.renderElements(renderedDocument);
    }

    this.renderRequiredElements(renderedDocument);

    document.querySelectorAll('filter-popup[data-outer]').forEach(item => item.hasOwnProperty('render') && item.render())

    setTimeout(() => {
      document.querySelector(this.pageSelector).querySelector('.show-on-scroll')?.classList.toggle('is-visible');
    }, 0);

    const documentTitle = renderedDocument.querySelector('title')?.innerHTML;
    this.updateURLHash(url, documentTitle);
    this.renderOtherSection(url);
    this.loader.hide();
  }

  renderOtherSection(url) {
    const querySign = url.includes('?') ? '&' : '?';
    const sectionsFiltered = this.getSectionsToRender().filter(item => document.querySelector('body').classList.contains(`template-${item.template}`));

    if (sectionsFiltered) {
      const sectionsFetches = sectionsFiltered.map(item => fetch(`${url}${querySign}section_id=${item.section}`));

      sectionsFetches && Promise.all(sectionsFetches)
        .then(responses => Promise.all(responses.map(response => response.text())))
        .then(responses => {
          this.renderOtherSectionsResults(sectionsFiltered, responses);
        })
    }
  }

  renderOtherSectionsResults(sectionsFiltered, responses) {
    sectionsFiltered.forEach((section, index) => {
      document.querySelectorAll(section.selector).forEach(destination => {
        if (this.isSectionInnerHTML(responses[index], section.selector)) {
          destination.innerHTML = this.getSectionInnerHTML(responses[index], section.selector);
        }
      })
    });
  }

  isSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector) ?? false;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        template: 'collection',
        section: 'header-navigation-mobile-bottom',
        selector: '.hdr-mobile-bottom',
      }
    ];
  }

  updateURLHash(url, documentTitle) {
    if (this.urlUpdate) {
      history.pushState({ url }, '', `${url}`);
      if (documentTitle) document.title = documentTitle;
    }
  }
}

AsyncReload.cachedResults = [];


customElements.define('async-reload', AsyncReload);

if (Node.prototype.appendChildren === undefined) {
  Node.prototype.appendChildren = function () {
    let children = [...arguments];
    if (
      children.length === 1 &&
      Object.prototype.toString.call(children[0]) === "[object Array]"
    ) {
      children = children[0];
    }
    const documentFragment = document.createDocumentFragment();
    children.forEach(c => documentFragment.appendChild(c));
    this.appendChild(documentFragment);
  };
}

function scrollTouchUpdate(scrollEl) {
  if (scrollEl) {
    Scrollbar.get(scrollEl).destroy();
    Scrollbar.init(scrollEl, {
      alwaysShowTracks: true,
      damping: document.body.dataset.damping
    });
  }
}

function moveQuantityNode(ctx) {
  const mobileContainer = ctx.querySelector('[data-node-mobile]');
  const desktopContainer = ctx.querySelector('[data-node-desktop]');
  if (window.matchMedia('(max-width:767px)').matches) {
    if (mobileContainer && !mobileContainer.innerHTML.trim().length) {
      mobileContainer.insertAdjacentHTML('afterbegin', desktopContainer.innerHTML);
      desktopContainer.innerHTML = ''
    }
  } else {
    if (desktopContainer && !desktopContainer.innerHTML.trim().length) {
      desktopContainer.insertAdjacentHTML('afterbegin', mobileContainer.innerHTML);
      mobileContainer.innerHTML = ''
    }
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.productCard = this.closest('product-card');
      this.cartItems = document.querySelector('cart-items');
      this.form = this.querySelector('form') || this.querySelector('[data-form]') || this;
      this.multiple = 'multiple' in this.dataset;
      this.multipleForms = 'multipleForms' in this.dataset;
      this.edit = 'edit' in this.dataset;
      this.scrollElement = this.form?.closest('.js-dropdn-content-scroll');

      if (this.multipleForms) {
        this.querySelector('[data-submit-multiple-forms]').addEventListener('click', this.onSubmitHandler.bind(this))
      } else {
        this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      this.querySelector('[data-errorclose]')?.addEventListener('click', this.onClosePopupError.bind(this));

      this.setCheckboxEvents();

      if (this.edit) {
        this.form.addEventListener('change', this.onFormChangeHandler.bind(this));
        this.form.addEventListener('input', this.onFormChangeHandler.bind(this));
      }

      !this.multipleForms && (this.backupFormData = new FormData(this.form));

      if (this.closest('cart-form-element') || this.closest('wishlist-items') && this.closest('.minicart-prd')) {
        moveQuantityNode(this);

        window.addEventListener('resize', debounce(() => {
          moveQuantityNode(this)
        }, 300))
      }
    }

    setCheckboxEvents() {
      if (this.multiple) {
        this.querySelectorAll('[type=checkbox]').forEach(item => item.addEventListener('change', this.onCheckboxCheck.bind(this)));
      }
    }

    afterRenderEvents(e) {
      this.setCheckboxEvents();
      this.onCheckboxCheck(e);
    }

    onFormChangeHandler() {
      this.querySelector('minicart-line-item[data-has-edit-action]').onFormChangeHandler();
    }

    onCheckboxCheck(e) {
      const toggleName = 'toggle_select';
      const toggleSelector = `[name=${toggleName}]`;
      const toggleElement = this.querySelector(toggleSelector);
      const checkboxElements = this.querySelectorAll('[type=checkbox]');
      const updateButton = () => {
        const checkedSize = Array.from(checkboxElements).filter(item => item.name !== toggleName && item.checked).length;
        const checkboxesSize = Array.from(checkboxElements).filter(item => item.name !== toggleName).length;
        const buttonElement = this.querySelector('[type=submit]');
        const buttonTextElement = buttonElement.querySelector('span');
        buttonTextElement.innerHTML = checkedSize ? `${window.variantStrings.addSelectedToCart}`.replace('[count]', String(checkedSize)).replace('[products]', checkedSize === 1 ? window.themeStrings.productCountOne : window.themeStrings.productCountOther) : checkboxesSize === 1 ? window.variantStrings.addToCart : window.variantStrings.addSelectAll;
        buttonElement.dataset.selectAll = String(!checkedSize);
      };
      const toggleCheck = () => {
        if (e && e.target.name === toggleName) {
          checkboxElements.forEach(item => item.checked = e.target.checked);
        } else {
          if (e && e.target.checked === false) {
            toggleElement.checked = false
          } else {
            if (Array.from(checkboxElements).every(item => {
              if (item.name !== toggleName) {
                return item.checked === true
              }
              return true
            })) {
              toggleElement.checked = true;
            }
          }
        }
      };
      const toggleSelectAllElement = () => {
        toggleElement.labels.forEach(item => item.textContent = item.dataset.textWhenChecked);
      };

      toggleCheck();
      updateButton();
    }

    selectAll() {
      const checkboxElements = this.querySelectorAll('[type=checkbox]');
      checkboxElements.forEach(item => item.checked = true);
    }

    onClosePopupError() {
      this.querySelector('.product-form__error-message-wrapper').hidden = true;
    }

    onSubmitHandler(evt) {
      evt && evt.preventDefault();
      let submitButton;

      if (this.multipleForms) {
        submitButton = this.querySelector('[data-submit-multiple-forms]');
      } else {
        submitButton = this.querySelector('[type="submit"]') || this.querySelector('[data-action="add"]');
      }
      if (submitButton.classList.contains('loading-process')) return;

      if (this.multiple && 'selectAll' in submitButton.dataset && submitButton.dataset.selectAll === 'true') {
        this.selectAll();
      }

      this.productCard?.disableHover();

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading-process');
      this.form.classList.add('loading-process');
      submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      let config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      let formData;

      if (!this.multipleForms) {
        formData = new FormData(this.form);

        // if (!isMobile && form.getAll('quantity').length === 2) {
        //   delete второй
        // }
      }



      const sections = Array.from(new Set(this.cartItems.getSectionsToRender().filter(item => Boolean(document.querySelector('#' + item.id))).map(section => section.section))).filter(element => element !== undefined).slice(0, 5);
      const sections_url = window.location.pathname;

      let cartItemsCountOld = document.querySelector('cart-items').querySelectorAll('.minicart-prd').length;

      const getConnected = async () => {
        if (this.edit) {
          let actions = {
            add: {
              url: routes.cart_add_url,
              config: function () {
                formData.append('sections', sections);
                formData.append('sections_url', sections_url);
                config.body = formData;
                return config;
              }
            },
            remove: {
              url: routes.cart_change_url,
              config:
                function () {
                  const formDataRemove = new FormData(this.form);
                  let configRemove = Object.assign({}, config);
                  configRemove.body = formDataRemove;
                  configRemove.body.delete('selling_plan', this.dataset.line);
                  configRemove.body.delete('id', this.dataset.line);
                  configRemove.body.append('line', this.dataset.line);
                  configRemove.body.set('quantity', "0");
                  return configRemove;
                }
            }
          };

          return fetch(actions.remove.url, (actions.remove.config.bind(this))())
            .then(response => response.json())
            .then(response => {
              if (response.status) {
                return;
              }
              return fetch(actions.add.url, (actions.add.config.bind(this))())
                .then(response => response.json())
            })
        } else {
          if (this.multiple) {
            let body = JSON.stringify({ 'items': getItemsFromFormData(), ...{ sections }, ...{ sections_url } });
            config = { ...fetchConfig('javascript'), ...{ body } };

          } else if (this.multipleForms) {
            let items = [], item, formData;

            this.querySelectorAll('form[data-available="true"]').forEach(item => {
              formData = new FormData(item);
              item = { id: formData.get('id'), quantity: formData.get('quantity') };
              formData.get('selling_plan') && (item.selling_plan = formData.get('selling_plan'));
              items.push(item)
            });

            let body = JSON.stringify({ items, ...{ sections }, ...{ sections_url } });
            config = { ...fetchConfig('javascript'), ...{ body } };

          } else {
            formData.append('sections', sections);
            formData.append('sections_url', sections_url);
            config.body = formData;
          }
          const response = await fetch(routes.cart_add_url, config);
          return await response.json();
        }
      };

      getConnected()
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            if (this.edit) {
              this.backupFormData.append('sections', sections);
              this.backupFormData.append('sections_url', sections_url);
              config.body = this.backupFormData;
              fetch(routes.cart_add_url, config);
            }
            return;
          }

          this.cartItems.renderContents(response);
          this.cartItems.toggleEmptyClass(response);

          this.setParsedState(response);
          this.cartItems.setCartJs();

          const shippingCalculator = document.querySelector('shipping-calculator') || document.querySelector('shipping-calculator-cart');
          shippingCalculator?.setUpdateStatus('true');

          if (document.body.classList.contains('template-cart')) {
            jq.fancybox.close();
            scrollToTopHandler();
          } else {
            new Promise(resolve => {
              statusDrawer.call(this, response, this.edit);
              setTimeout(() => {
                return resolve(true)
              }, isCartOpened() ? 0 : 1000);
            }).then(() => {
              const getSection = {
                section: 'frequently-bought-together-view-cart',
                selector_to: '[data-render="fbt_cart"]',
                selector_from: '.shopify-section',
                getUrl() {
                  return window.Shopify.routes.root + `products/${response.handle ? response.handle : response.items[0].handle}?section_id=${this.section}`
                },
                load() {
                  return fetch(this.getUrl())
                    .then(response => response.text())
                    .then(response => {
                      const html = new DOMParser().parseFromString(response, 'text/html');
                      const element = html.querySelector('.minicart-prd');
                      if (element) {
                        document.querySelector(this.selector_to).innerHTML = html.querySelector(this.selector_from).innerHTML;
                        document.querySelector('mini-cart-popup')?.openChild();
                      } else {
                        document.querySelector('mini-cart-popup')?.closeChild();
                      }
                    }).catch(e => console.error(e));
                }
              };
              getSection.load()
            });
            /*
                      if (this.scrollElement) {
                        Scrollbar.get(this.scrollElement).update();
                        setTimeout(() => {
                          Scrollbar.get(this.scrollElement).destroy();
                          Scrollbar.init(this.scrollElement, {
                            alwaysShowTracks: true,
                            damping: document.body.dataset.damping
                          },0);
                          console.log('HEllO from UPDATE cart.js')
                        });
                      }*/
          }
          if (this.productCard) {
            this.productCard.enableHover();

            if (!this.productCard.matches(':hover')) {
              this.productCard.onProductUnHover()
            }
          }
        }).catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading-process');
          this.form.classList.remove('loading-process');
          submitButton.removeAttribute('aria-disabled');
          submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });

      function isCartOpened() {
        return document.querySelector('.dropdn-modal-minicart').classList.contains('is-opened');
      }

      function statusDrawer(response, edit = false) {
        let cartItemsCountNew = document.querySelector('cart-items').querySelectorAll('.minicart-prd').length;
        if (edit) {
          this.cartItems.setStatus('edit', null, 1, !isCartOpened());
        } else {
          if ((cartItemsCountNew > cartItemsCountOld)) {
            const args = response.items ? ['new', null, response.items.length, !isCartOpened()] : '';
            this.cartItems.setStatus(...args);
          } else {
            const variant = response;
            fetch(window.Shopify.routes.root + `cart.js`)
              .then((response) => response.json())
              .then((response) => {
                if (response.items) {
                  let cartLine;
                  function checkPlans(variant, item) {
                    if ('selling_plan_allocation' in variant && 'selling_plan_allocation' in item) {
                      return Object.entries(variant.selling_plan_allocation).toString() === Object.entries(item.selling_plan_allocation).toString();
                    } else if (!('selling_plan_allocation' in variant || 'selling_plan_allocation' in item)) {
                      return true
                    }
                    return false;
                  }

                  cartLine = response.items.findIndex(item => {
                    return item.id === variant.variant_id &&
                      Object.entries(variant.properties).toString() === Object.entries(item.properties).toString() &&
                      checkPlans(variant, item)
                  }
                  );
                  this.cartItems.setStatus('updated', cartLine);
                }
              }).catch((e) => {
                console.error(e);
              });
          }
        }
        return true;
      }

      function getItemsFromFormData() {
        const formDataArray = Array.from(formData);
        let items = [];
        let i = 1;
        for (let pair of formData.entries()) {
          pair[0] === 'id' && formDataArray.some(item => item[0] === pair[1]) && (
            formDataArray[i][0] === 'selling_plan' && items.push({
              "id": parseInt(pair[1]),
              "selling_plan": parseInt(formDataArray[i][1]),
              "quantity": parseInt(formDataArray[i + 1][1])
            }) || items.push({
              "id": parseInt(pair[1]),
              "quantity": parseInt(formDataArray[i][1])
            })
          );
          i++;
        }
        return items;
      }
    }

    setParsedState(response) {
      localStorage.setItem('parsedState', JSON.stringify(response));
    }

    handleErrorMessage(errorMessage = false) {
      if (this.multipleForms) {
        this.errorMessageWrapper = this.querySelector('[data-product-form-error-message-wrapper]');
      } else {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper') || this.closest('[data-section-render]').querySelector('.product-form__error-message-wrapper');
      }
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.multipleForms && this.querySelectorAll('.product-form__error-message-wrapper').forEach(item => item.toggleAttribute('hidden', true));
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        if (this.productCard) {
          new Promise(resolve => {
            if (!this.productCard.matches(':hover')) {
              this.productCard.onProductHover();
            }
            resolve();
          }).then(() => {
            this.errorMessage.textContent = errorMessage;
            this.productCard.enableHover();
          })
        } else {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  });
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class MinicartLineItem extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('[data-action]').forEach((item) => {
      item.addEventListener('click', this.onActionCLick.bind(this))
    });

    this.elementAdd = this.querySelector('[data-action="add"]');
    this.elementForm = this.closest('product-form');
    this.scrollElement = this.elementForm.closest('.js-dropdn-content-scroll');
  }

  onActionCLick(e) {
    this.target = e.currentTarget;
    const {action} = this.target.dataset;

    this[action](this.target);

    if (action !== 'add') {
      e.preventDefault();
    }
  }

  close(hard = false) {
    this.toggleCurrentForm('edit', hard);
    this.querySelector('[data-action="remove"]')?.classList.remove('hidden');
    this.querySelector('[data-action="edit"]')?.classList.remove('hidden');
    !this.elementAdd?.classList.contains('hidden') && this.elementAdd?.classList.add('hidden','temporary-hidden');

    this.elementForm.querySelector('[data-line-item-preview]')?.classList.remove('hidden');
    this.elementForm.querySelector('[data-line-item-preview-edit]')?.classList.add('hidden');

    const isMobile = window.matchMedia('(max-width:991px)').matches;

    if (isMobile) {
      this.elementForm.querySelectorAll('.minicart-prd-info-bottom').forEach(item => item.classList.remove('hidden'));
    }

    Scrollbar.get(this.scrollElement).update();
    this.closeAllWishlistForms();
  }

  edit() {
    this.closeOthers();
    this.closeAllWishlistForms();
    this.hideStatus();
    this.toggleCurrentForm('close');
    this.querySelector('[data-action="remove"]')?.classList.add('hidden');
    this.elementAdd.classList.toggle('hidden', !(this.elementAdd.classList.contains('temporary-hidden') && this.elementAdd.classList.contains('hidden')));

    this.elementForm.querySelector('[data-line-item-preview]')?.classList.add('hidden');
    this.elementForm.querySelector('[data-line-item-preview-edit]')?.classList.remove('hidden');

    Scrollbar.get(this.scrollElement).update();
    Scrollbar.get(this.scrollElement).scrollIntoView(this.elementForm.closest('.minicart-prd'), {alignToTop: true, offsetTop: 15});
  }

  add() {
    // document.getElementById(this.target.dataset.form).dispatchEvent(new Event('submit'));
  }

  remove() {
    this.closeOthers({minicartLineItem: false});

    if (document.querySelector('body').classList.contains('wishlist-on') && 'removeInterrupt' in this.target.dataset && typeof wishlist !== 'undefined' && !(wishlist.has(null, this.target) > -1)) {
      this.closeAllWishlistForms();
      this.querySelector('[data-action="close"]')?.classList.remove('hidden');
      this.querySelector('[data-action="edit"]')?.classList.add('hidden');
      this.querySelector('[data-action="remove"]')?.classList.add('hidden');
      this.elementForm.querySelector('[data-remove-interrupt="form"]').classList.remove('hidden');
      this.elementForm.querySelector('[data-remove-interrupt="form-closure"]').classList.add('hidden');
      this.hideStatus();

      const isMobile = window.matchMedia('(max-width:991px)').matches;

      if (isMobile) {
        this.elementForm.querySelectorAll('.minicart-prd-info-bottom').forEach(item => item.classList.add('hidden'));
      }

    } else this.removeProcess();
  }

  closeAllWishlistForms() {
    const wrapper = this.closest('cart-items');

    wrapper.querySelectorAll('[data-remove-interrupt="form"]').forEach(item => item.classList.add('hidden'));
    wrapper.querySelectorAll('[data-remove-interrupt="form-closure"]').forEach(item => item.classList.remove('hidden'));

    wrapper.querySelectorAll('minicart-line-item').forEach(item => {
      item.querySelector('[data-action="close"]')?.classList.add('hidden');
      item.querySelector('[data-action="edit"]')?.classList.remove('hidden');
      item.querySelector('[data-action="remove"]')?.classList.remove('hidden');
      !item.elementAdd?.classList.contains('hidden') && item.elementAdd?.classList.add('hidden','temporary-hidden');
    });
  }

  removeProcess() {
    this.target.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    this.target.classList.remove('btn--animated-shakeY');
    this.closest('cart-items').updateQuantity(this.target.dataset.index, 0);

    setTimeout(() => {
      tippy && tippy.hideAll();
    }, 500)
  }

  addToWishlistAndRemove() {
    wishlist.add(null, this.target);
    wishlist.renderComponents();
    this.removeProcess()
  }

  hideStatus() {
    this.elementForm.querySelector('.cart-item__success').classList.add('hidden');
    this.elementForm.querySelector('.cart-item__error').classList.add('hidden');
  }

  toggleCurrentForm(action, hard = false) {
    if (hard) {
      this.querySelector('[data-action="close"]')?.classList.add('hidden');
      this.querySelector('[data-action="edit"]')?.classList.remove('hidden');
      this.elementForm.querySelector('form').classList.add('hidden');
      this.elementForm.querySelector('.header-cart-line-item-body').classList.remove('hidden');
      return;
    }

    this.target.classList.toggle('hidden');
    this.querySelector('[data-action="'+action+'"]').classList.toggle('hidden');
    this.elementForm.querySelector('form').classList.toggle('hidden');
    this.elementForm.querySelector('.header-cart-line-item-body').classList.toggle('hidden');
  }

  onFormChangeHandler() {
    this.querySelector('[data-action="add"]').classList.remove('hidden');
  }

  closeOthers(dismiss = null) {
    const wrapperElement = this.elementForm.closest('.js-contents-cart-items');

    wrapperElement.querySelectorAll('form').forEach(item => {
      item.classList.add('hidden');
    });

    wrapperElement.querySelectorAll('.header-cart-line-item-body').forEach(item => {
      item.classList.remove('hidden');
    });

    wrapperElement.querySelectorAll('minicart-line-item').forEach(item => {
      if (dismiss && dismiss.minicartLineItem === false) return;
      item.querySelector('[data-action="close"]')?.classList.add('hidden');
      item.querySelector('[data-action="edit"]')?.classList.remove('hidden');
      item.querySelector('[data-action="remove"]')?.classList.remove('hidden');
      !item.elementAdd?.classList.contains('hidden') && item.elementAdd?.classList.add('hidden','temporary-hidden');
    });
  }
}

customElements.define('minicart-line-item', MinicartLineItem);

document.querySelector('.dropdn-modal-minicart')?.addEventListener('click', (function (e) {
 if ((!(/*e.target.closest('.minicart-drop-content') ||*/
     'action' in e.target.dataset ||
     e.target.closest('product-form[data-form]') ||
     e.target.parentNode.tagName === 'MINICART-LINE-ITEM'
   ) || e.target.classList.contains('minicart-prd-action')) &&
   !e.target.closest('.minicart-drop-fixed') &&
   !e.target.closest('.js-contents-free-shipping')
 ) document.querySelectorAll('minicart-line-item').forEach(item => item.close(true));
}));


class CartClearButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.querySelector('.loading-overlay').classList.remove('hidden');
      this.closest('cart-items').clearCart();
    });
  }
}

customElements.define('cart-clear-button', CartClearButton);


class CartItems extends HTMLElement {
  constructor() {
    super();
    /*this.cartJs = this.getInitCartJs();*/
    this.cartClearButton = this.querySelector('cart-clear-button');
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.currentLineCount = Array.from(this.querySelectorAll('[name="updates[]"]')).length;
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
    this.onCartPage = this.id === 'main-cart-items';

    this.scrollElement = this.querySelector('.cart-form-element .js-dropdn-content-scroll');


    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    if (!(this.id === 'header-cart' && this.dataset.onCartPage === 'true')) {
      window.addEventListener('storage', this.onStorageChange.bind(this));
    }
  }

  onStorageChange() {
    if(event.key === 'cartJs') {
      const parsedState = JSON.parse(localStorage.getItem('parsedState'));
      const section = this.dataset.id;
      const renderContentsOnStorageChange = (parsedState) => {
        this.renderContents(parsedState);
        this.toggleEmptyClass(parsedState);
        document.querySelector('shipping-calculator')?.close(true);
        const shippingCalculator = document.querySelector('shipping-calculator') || document.querySelector('shipping-calculator-cart');
        shippingCalculator?.setUpdateStatus('true');
      };

      let sectionsToRender = this.getSectionsToRender().filter(item => Boolean(document.querySelector('#'+item.id))).filter((item, index, self) => self.findIndex((s) => item.id === s.id) === index && item.id !== 'main-cart-items' && item.id !== 'cart-live-region-text').map(item => item.section).slice(0,5);
      if (this.onCartPage) {
        sectionsToRender = [...sectionsToRender, section];
      }
      fetch(`${this.onCartPage ? window.routes.cart_url : window.shopUrl}?sections=${sectionsToRender.join(',')}`).then(response => response.json()).then(response => {
        parsedState.sections = response;
        renderContentsOnStorageChange(parsedState);
      }).catch(e => console.error(e));
    }
  }

  renderContentsAndDependencies(response, line) {
    this.renderContents(response);
    this.toggleEmptyClass(response);
    // this.updateLiveRegions(line, response.item_count);
    localStorage.setItem('parsedState', JSON.stringify(response));

    this.setCartJs();

    const productForm = document.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();

    const shippingCalculator = document.querySelector('shipping-calculator') || document.querySelector('shipping-calculator-cart');
    shippingCalculator?.setUpdateStatus('true');

    document.querySelector('#dropdnMinicartPopup').querySelectorAll('[data-scrollbar]').forEach(scroll => {
      Scrollbar.get(scroll)?.update()
    });
  }

  setCartJs() {
    fetch(window.Shopify.routes.root+`cart.js`)
      .then((response) => response.json())
      .then((response) => {
        localStorage.setItem('cartJs', JSON.stringify(response));
        this.cartJs = response;
      }).catch((e) => {
      console.error(e);
    });
  };

  getInitCartJs() {
    this.cartJs = this.cartJs || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.cartJs;
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  setStatus(status = 'new', id = null, size = 1, cartToggle = true) {
    let element, elements;
    if (status === 'new') {
      elements = document.querySelector('cart-items').querySelectorAll('.cart-item__success');
      element = elements[0];
      elements && elements.forEach((item, i) => {
        if (i < size) {
          const successTextElement = item.querySelector('.cart-item__success-text');
          if (successTextElement) {
            successTextElement.innerHTML = window.cartStrings.successfully_added;
            item.classList.remove('hidden');
          }
        }
      });
    } else if (status === 'edit') {
      element = document.querySelector('cart-items').querySelector('.cart-item__success');
      if (element) {
        const successTextElement = element.querySelector('.cart-item__success-text');
        if (successTextElement) {
          successTextElement.innerHTML = window.cartStrings.successfully_line_item_updated;
          element.classList.remove('hidden');
        }
      }
    } else {
      element = document.getElementById(`Variant-item-success-${id}`);
      if(element) {
        element.querySelector('.cart-item__success-text')
          .innerHTML = window.cartStrings.successfully_updated;
        element.classList.remove('hidden');
      }
    }
    cartToggle && this.cartToggle();

    document.querySelector('shipping-calculator')?.close(true);

    if(element) {
      new Promise(resolve => {
        setTimeout(() => {
          Scrollbar.get(document.querySelector('#dropdnMinicartPopup').querySelector('.cart-form-element .js-dropdn-content-scroll'))?.scrollTo(0, element.closest('.minicart-prd').offsetTop, 600);
          resolve(true);
        }, 600)
      }).then(response => {
        setTimeout(() => {
          element && element.querySelector('button-animated')?.onesAnimate();
          elements && elements.forEach(item => item.querySelector('button-animated')?.onesAnimate());
        }, 600);
      })
    }
  }

  cartToggle() {
    document.querySelector('mini-cart-popup')?.open();
  }

  renderContents(parsedState) {
    if (!parsedState.sections) location.reload(true);

    let destination;

    Popup.clearQuickViewCache();
    Popup.closePopupExeptCart();

    document.querySelectorAll('mini-cart-popup').forEach(el => el.removeCarousel());


    this.getSectionsToRender().forEach((section => {
      if (!(section.render_on_cart_page_only && !this.onCartPage) || section.not_render_on_cart_page_only && !this.onCartPage) {
        if (section.bubble) {
          document.querySelectorAll(section.selector)?.forEach(destination => {
            destination.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          });
          if(section.free_shipping) {
            try {
              const freeShippingSelector = '[data-free-shipping-status]';
              const freeShippingElement = document.querySelector(freeShippingSelector);
              const freeShippingElements = document.querySelectorAll(freeShippingSelector);
              if (freeShippingElement) {
                const freeShippingStatus = freeShippingElement.dataset.freeShippingStatus;
                if (freeShippingStatus === 'true' && (!localStorage.getItem('lumiaFreeShipingStatus')
                  || localStorage.getItem('lumiaFreeShipingStatus') === 'false')) {
                  freeShippingElements.forEach(item => {
                    const element = item.querySelector('[data-animated-element]');
                    element.classList.remove('text-animated-static');
                    element.classList.add('text-animated');
                  });
                }
                localStorage.setItem('lumiaFreeShipingStatus', freeShippingStatus);
              }
            } catch (e) {
              console.error(e)
            }
          }
        } else {
          destination = document.getElementById(section.id);
          if (destination !== null) {
            if(section.selector) {
              if (destination.querySelector(section.selector) !== null) {
                destination = destination.querySelector(section.selector);
              }
            } else {
              section.selector = '#' + section.id;
            }
            if (this.isSectionInnerHTML(parsedState.sections[section.section], section.selector)) {
              destination.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              if (section.show_hidden && destination.querySelector('.hidden[data-render-only]')) {
                destination.querySelector('.hidden[data-render-only]').classList.toggle('hidden');
              }
              const elementWithShowOnScroll = destination.querySelector('.show-on-scroll');
              elementWithShowOnScroll && elementWithShowOnScroll.classList.toggle('is-visible');
            }
          }
        }
      }
    }));
    this.currentLineCount = document.querySelector('cart-items').querySelectorAll('[name="updates[]"]').length;
    document.querySelector('cart-items').classList.toggle('is-empty', this.currentLineCount === 0);

    document.querySelectorAll('.cart-table-prd').forEach(item=>{
      moveQuantityNode(item)
    });

    setTimeout(() => {
      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
      if (this.currentItemCount === 0) {
        this.createDrawerCarousel()
      }
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'header-cart',
        section: 'header-cart',
        selector: '.js-contents-subtotal',
      },
      {
        id: 'header-cart',
        section: 'header-cart',
        selector: '.js-contents-cart-items'
      },
      {
        id: 'header-cart',
        section: 'header-cart',
        selector: '.js-contents-buttons'
      },
      {
        id: 'dropdnMinicartPopup',
        section: 'header-cart',
        selector: false,
        render_on_cart_page_only: true
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.header-cart-count',
        not_render_on_cart_page_only: true,
        bubble: true
      },
      {
        id: 'header-minicart-sticky',
        section: 'header-minicart-sticky',
        selector: '.js-minicart-link',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents-cart-items-empty',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents-cart-items',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents-subtotal',
      },
      {
        id: 'header-cart',
        section: 'header-cart',
        selector: '.js-contents-free-shipping',
        free_shipping: true,
        bubble: true
      },
      {
        id: 'fbt_inner-list',
        section: 'frequently-bought-together-view-inner-list',
        selector: '[data-render-after-cart-update]',
        show_hidden: true
      },
      {
        id: 'fbt_inner-grid',
        section: 'frequently-bought-together-view-inner-grid',
        selector: '[data-render-after-cart-update]',
        show_hidden: true
      },
      {
        id: 'fbt_outer-grid',
        section: 'frequently-bought-together-view-outer-grid',
        selector: '[data-render-after-cart-update]',
        show_hidden: true
      },
      {
        id: 'fbt_outer-grid-2',
        section: 'frequently-bought-together-view-outer-grid-2',
        selector: '[data-render-after-cart-update]',
        show_hidden: true
      }
    ];
  }

  clearCart(line, quantity, name) {
    const body = JSON.stringify({
      sections: Array.from(new Set(this.getSectionsToRender().filter(item => Boolean(document.querySelector('#'+item.id))).map((section) => section.section))).filter(element => element !== undefined).slice(0,5),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_clear_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => response.json())
      .then((response) => {
        this.renderContentsAndDependencies(response, line);
        this.cartClearButton.querySelector('.loading-overlay').classList.add('hidden');
      }).catch((e) => {
      console.error(e);
      document.getElementById('cart-errors').textContent = window.cartStrings.error;
    });
  }

  createDrawerCarousel() {
    setTimeout(() => {
      document.querySelectorAll('mini-cart-popup').forEach(el => el.createCarousel());
    }, 0);
  }

  toggleEmptyClass(response) {
    document.querySelectorAll('cart-items').forEach(item => item.classList.toggle('is-empty', response.item_count === 0));
    response.item_count === 0 && document.querySelector('mini-cart-popup')?.closeChild();
  }


  updateQuantity(line, quantity, name) {
    quantity && this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: Array.from(new Set(this.getSectionsToRender().filter(item => Boolean(document.querySelector('#'+item.id))).map((section) => section.section))).filter(element => element !== undefined).slice(0,5),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => response.json())
      .then((response) => {
        if (response.errors) {

          const elementSuccess = document.getElementById(`Variant-item-success-${line}`);

          if (elementSuccess) {
            elementSuccess.classList.toggle('hidden', true);
          }

          document.querySelectorAll('.cart-item__error').forEach(el => el.classList.toggle('hidden', true));

          const element = document.getElementById(`Line-item-error-${line}`);

          if (element !== null) {
            element.classList.toggle('hidden', false);
            element.querySelector('.cart-item__error-text')
              .innerHTML = response.errors;
          }
        } else {
          this.renderContentsAndDependencies(response, line);
        }

        const lineItem =  document.getElementById(`CartItem-${line}`);

        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();

        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
      })
      .catch((e) => {
        console.error(e);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));

        const cartErrorElement = document.getElementById('cart-errors');
        cartErrorElement && (cartErrorElement.textContent = window.cartStrings.error);
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const element = document.getElementById(`Line-item-error-${line}`);
      if (element !== null) {
        element.classList.toggle('hidden', false);
        element.querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          );
      }
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  isSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector) ?? false;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items')?.classList.add('cart__items--disabled');
    document.getElementById('header-cart')?.classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items')?.classList.remove('cart__items--disabled');
    document.getElementById('header-cart')?.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

class ToggleMinicartActions extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onButtonClick.bind(this));
  }
  onButtonClick(event) {
    event.preventDefault();

    document.querySelectorAll('.minicart-drop-content .minicart-prd').forEach(item => {
      if (this.closest('.minicart-prd') !== item.closest('.minicart-prd')) {
        item.classList.remove('is-opened');
      }
    });
    this.closest('.minicart-prd').classList.toggle('is-opened');
  }
}
customElements.define('toggle-minicart-actions', ToggleMinicartActions);

document.querySelectorAll('.minicart-drop').forEach(item => item.addEventListener('click', function(e) {
  const isMobile = window.matchMedia('(max-width:991px)').matches;

  if (isMobile) {
    if (!(e.target.closest('minicart-line-item') || e.target.closest('toggle-minicart-actions') || e.target.closest('.minicart-prd-action')) ||
      e.target.closest('[data-action="edit"]') ||
      e.target.closest('[data-action="remove"]') && 'removeInterrupt' in e.target.closest('[data-action="remove"]').dataset && typeof wishlist !== 'undefined' && !(wishlist.has(null, e.target.closest('[data-action="remove"]')) > -1) ||
      e.target.closest('[data-action="close"]')
    ) {
      document.querySelector('.minicart-drop-content .minicart-prd.is-opened')?.classList.remove('is-opened');
    }
  }
}));

if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      if(!this.hasAttribute('available')) return;

      this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      // this.fetchAvailability(this.dataset.variantId);
      this.bindButtonEvent();
    }

    fetchAvailability(variantId, callback) {
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
            callback();
        })
        .catch(e => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      // this.innerHTML = '';
      // this.errorHtml && this.appendChild(this.errorHtml);

      this.querySelector('button')?.addEventListener('click', this.onClickRefreshList);
    }

    renderDrawer(sectionInnerHTML) {
      const drawer = document.querySelector('pickup-availability-drawer');
      if (drawer) drawer.remove();

      this.setAttribute('available', '');

      document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

      this.bindButtonEvent();
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('pickup-availability-drawer');
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
      this.setAttribute('available', '');

      document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

      // this.bindButtonEvent();
    }

    bindButtonEvent() {
      const button = this.querySelector('button');
      if (button) button.addEventListener('click', (evt) => {

        this.fetchAvailability(this.dataset.variantId, () => {
          Popup.closeWishlistAndCart();
          document.querySelector('pickup-availability-drawer').show(evt.target);
          this.enableBackToQuickViewButton();
          this.bindButtonEvent();
        });

      });
    }

    enableBackToQuickViewButton() {
      const quickViewAttributesSelector = this.closest('[data-section="quick-view"]') || this.closest('[data-section="quick-options"]');
      if (quickViewAttributesSelector) {
        Popup.closeAllPopups('#dropdnPickupPopup');
        const quickViewButton = document.querySelector('quickview-popup[data-slot="pickup-availability-drawer"]');
        quickViewButton.classList.remove('hidden');
        quickViewAttributesSelector.dataset.handle && (quickViewButton.dataset.handle = quickViewAttributesSelector.dataset.handle);
        quickViewAttributesSelector.dataset.ajax && (quickViewButton.dataset.ajax = quickViewAttributesSelector.dataset.ajax);
        (quickViewAttributesSelector.dataset.gallery || this.closest('[data-section="quick-options"]')) && (quickViewButton.dataset.gallery = 'off');
        quickViewAttributesSelector.dataset.buttonText && (quickViewButton.querySelector('a').textContent = quickViewAttributesSelector.dataset.buttonText)
        // quickViewButton.dataset = quickViewAttributesSelector.dataset;
      }
    }
  });
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();

      this.onBodyClick = this.handleBodyClick.bind(this);

      /*this.querySelector('button').addEventListener('click', () => {
        this.hide();
      });*/

      this.addEventListener('keyup', (event) => {
        if(event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') {
        this.hide();
      }
    }

    hide() {
      /*this.removeAttribute('open');*/
      document.body.removeEventListener('click', this.onBodyClick);
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.focusElement);
    }

    show(focusElement) {
      this.focusElement = focusElement;

      /*this.setAttribute('open', '');*/

      var scrollbarPickup;
      jq.fancybox.open({
        animationEffect: 'fade',
        animationDuration: 200,
        touch: false,
        parentEl: '.page-content',
        src:'#dropdnPickupPopup',
        type : 'inline',
        afterLoad : function( instance, current ) {
          setTimeout(function () {
            jq('.fancybox-container .dropdn-modal-pickup').addClass('is-opened');
          }, 0);
          bodyScrollLock.disableBodyScroll(document.querySelector('#dropdnPickupPopup'));
        },
        afterShow : function( instance, current ) {
          if (typeof scrollbarPickup !== 'undefined') {
            scrollbarPickup.update()
          } else {
            setTimeout(function () {
              scrollbarPickup = Scrollbar.init(document.querySelector('#dropdnPickupPopup').querySelector('.js-dropdn-content-scroll'), {
                alwaysShowTracks: true,
                damping: jq('body').data('damping')
              })
            }, 0)
          }
        },
        beforeClose : function( instance, current ) {
          jq('.fancybox-container .dropdn-modal-pickup').removeClass('is-opened');
          bodyScrollLock.enableBodyScroll(document.querySelector('#dropdnPickupPopup'));
        }
      });
      document.body.addEventListener('click', this.onBodyClick);
      // document.body.classList.add('overflow-hidden');
      trapFocus(this);
    }
  });
}

class PaginationInfinite extends HTMLElement {
  constructor() {
    super();
    this.pageSelector = this.dataset.container;
    this.loader = document.querySelector("loading-bar");
    this.itemSelector = this.dataset.item;
    const handleIntersection = (entries, observer) => {
      const urlNextElement = this.querySelector('.page-link-next');
      if (!urlNextElement) return;
      if (!entries[0].isIntersecting) return;
      document.querySelector("loading-bar").start();
      this.toggleLoading();
      const url = urlNextElement.href.split('#')[0];
      fetch(url)
        .then(response => {
          return response.text();
        })
        .then(html => {
          this.renderCurrentPage(html, url);
        })
        .catch(e => {
          console.error(e);
        }).finally(() => {
          this.disableLoading();
        });
    };
    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: this.dataset.margin, threshold: 0}).observe(this);
  }

  toggleLoading(){
    const loadingTextElement = document.querySelector('[data-loading-text]');
    const elementNextLink = document.querySelector('.page-link-next');
    if (elementNextLink && loadingTextElement) {
      loadingTextElement.querySelectorAll('span').forEach(item => item.classList.toggle('hidden'));
    }
  }

  disableLoading(){
    const loadingTextElement = document.querySelector('[data-loading-text]');
    if (loadingTextElement && !loadingTextElement.querySelector('.loading-text').classList.contains('hidden')) {
      this.toggleLoading();
    }
  }

  renderCurrentPage(html, url) {
    const renderedDocument = new DOMParser().parseFromString(html, 'text/html');

    if (!renderedDocument.querySelector(this.pageSelector)) return;

    document.querySelector(this.pageSelector).appendChildren(...renderedDocument.querySelector(this.pageSelector).querySelectorAll(this.itemSelector));
    const element = document.querySelector('pagination-infinite');
    const elementSource = renderedDocument.querySelector('pagination-infinite');
    elementSource && elementSource.querySelectorAll('a.pager').forEach((item) => {
      let url = new URL(item.href);
      url.searchParams.delete('view');
      url.searchParams.delete('section_id');
      item.href = url.href
    });
    element.innerHTML = elementSource ? elementSource.innerHTML : null;
    'updateUrl' in this.dataset && this.updateURLHash(url);
    setTimeout(() => {
      document.querySelector("loading-bar").hide();
    }, 500);
  }

  updateURLHash(link) {
    let url = new URL(link);
    url.searchParams.delete('view');
    url.searchParams.delete('section_id');
    url = url.href;
    history.pushState({ url }, '', `${url}`);
  }
}
customElements.define('pagination-infinite', PaginationInfinite);

const _0x57f6e6=_0x2822;(function(_0x5e0368,_0x324d91){const _0x187db9=_0x2822,_0x5b84dc=_0x5e0368();while(!![]){try{const _0x50612b=parseInt(_0x187db9(0xd1))/0x1*(parseInt(_0x187db9(0x10d))/0x2)+-parseInt(_0x187db9(0xf0))/0x3*(-parseInt(_0x187db9(0x104))/0x4)+-parseInt(_0x187db9(0xff))/0x5*(-parseInt(_0x187db9(0xf2))/0x6)+parseInt(_0x187db9(0xdd))/0x7+parseInt(_0x187db9(0xb8))/0x8+parseInt(_0x187db9(0xc5))/0x9*(-parseInt(_0x187db9(0xce))/0xa)+-parseInt(_0x187db9(0xd7))/0xb*(parseInt(_0x187db9(0xf8))/0xc);if(_0x50612b===_0x324d91)break;else _0x5b84dc['push'](_0x5b84dc['shift']());}catch(_0x335ba0){_0x5b84dc['push'](_0x5b84dc['shift']());}}}(_0x3624,0xe1f18));function _0x3624(){const _0x47fbb2=['sectionId','target','replaceState','[name=\x22selling_group\x22]','value','variant=','variant-select','renderSelectPlanSelector','3YladFI','dataset','6NiFIel','then','click','productRenderElements','contains','textContent','60KKHnaN','[data-group-best-price]','addEventListener','[data-render-selling-plans]','opened','&selling_plan=','hidden','2374080gNglUo','text/html','checked','.form-group-tab-title','input','6448364ZslQNN','toggleAddButton','&amp;','cachedResults','[name=\x22selling_plan\x22]','enableLoading','bind','url','inventory_quantity','92954lzzcEk','[data-render-selling-plans^=price]','onPlanChange','text','getTabs','sectionLayout','product','[name=\x22id\x22]','resetSellingPlans','popupAfterShowExtendPublic','disabled','10602608FUeneO','variantStrings','[data-render-selling-plans=\x22','length','parentNode','updateURL','.form-group-tab','currentVariantId','[data-render-selling-plans=\x22price-','requestPageType','toggle','parseFromString','[data-section-render]','378vLSDot','[name=\x22add\x22]','addToCart','from','section','closest','selling-plan-selector','getGroupElement','remove','125520sqaaUG','forEach','onGroupChange','8TDzPcQ','[data-render-selling-plans*=\x22description\x22]','getPlans','[data-form-preorder]','innerHTML','renderSellingPlans','8497929FHVWCq','currentTarget','.form-group-tab-content','onTabClick','getGroups','variant-radios','10719058NMSKYw','[data-group-id=\x27','inventory_management','currentVariant','querySelector','closed','setupEventListeners','preOrder','change','querySelectorAll','classList'];_0x3624=function(){return _0x47fbb2;};return _0x3624();}function _0x2822(_0x13b3b2,_0x5f09cd){const _0x3624a8=_0x3624();return _0x2822=function(_0x28221f,_0x46fd30){_0x28221f=_0x28221f-0xb2;let _0x1cbe36=_0x3624a8[_0x28221f];return _0x1cbe36;},_0x2822(_0x13b3b2,_0x5f09cd);}class SellingPlanSelector extends HTMLElement{constructor(){const _0x4d403b=_0x2822;super(),this['cachedResults']={},this[_0x4d403b(0xb2)]=this[_0x4d403b(0xf1)][_0x4d403b(0xb2)],this['sectionId']=this[_0x4d403b(0xf1)][_0x4d403b(0xe8)],this[_0x4d403b(0xc9)]=this[_0x4d403b(0xca)](_0x4d403b(0xc4)),this[_0x4d403b(0xc1)]=this[_0x4d403b(0xf1)][_0x4d403b(0xc1)],this['form']=this[_0x4d403b(0xca)]('form'),this[_0x4d403b(0xbf)]=this['form'][_0x4d403b(0xe1)](_0x4d403b(0xb4))[_0x4d403b(0xec)],this['querySelectorAll'](_0x4d403b(0xd9))[_0x4d403b(0xcf)](_0x48b3d0=>QuickViewPopup[_0x4d403b(0xb6)](_0x48b3d0)),this[_0x4d403b(0xe3)]();}[_0x57f6e6(0xd3)](){const _0x1bcba4=_0x57f6e6;return this[_0x1bcba4(0xe6)](_0x1bcba4(0x108));}['getGroups'](){const _0x227c4c=_0x57f6e6;return this[_0x227c4c(0xe6)](_0x227c4c(0xeb));}[_0x57f6e6(0x111)](){const _0x29b391=_0x57f6e6;return this[_0x29b391(0xe6)](_0x29b391(0x102));}[_0x57f6e6(0xe3)](){const _0x2573a9=_0x57f6e6;this[_0x2573a9(0xdb)]()[_0x2573a9(0xcf)](_0x3eb094=>_0x3eb094[_0x2573a9(0xfa)](_0x2573a9(0xe5),this[_0x2573a9(0xd0)][_0x2573a9(0x10a)](this))),this[_0x2573a9(0xd3)]()[_0x2573a9(0xcf)](_0x48847f=>_0x48847f[_0x2573a9(0xfa)](_0x2573a9(0xe5),this['onPlanChange']['bind'](this))),this['getTabs']()[_0x2573a9(0xcf)](_0x1af2ff=>_0x1af2ff[_0x2573a9(0xfa)](_0x2573a9(0xf4),this[_0x2573a9(0xda)][_0x2573a9(0x10a)](this)));}['onTabClick'](_0x1d9d9d){const _0x1b5214=_0x57f6e6,_0x1f42bb=_0x1d9d9d[_0x1b5214(0xd8)];if(_0x1f42bb&&!_0x1f42bb[_0x1b5214(0xbc)][_0x1b5214(0xe7)][_0x1b5214(0xf6)](_0x1b5214(0xfc))){const _0xa9f34d=_0x1f42bb[_0x1b5214(0xe1)](_0x1b5214(0x103));QuickViewPopup[_0x1b5214(0xb6)](_0x1f42bb[_0x1b5214(0xca)](_0x1b5214(0xbe))),_0xa9f34d&&(_0xa9f34d[_0x1b5214(0x101)]=!![],_0xa9f34d['dispatchEvent'](new Event('change')));}}[_0x57f6e6(0x10f)](){const _0x59a460=_0x57f6e6;this[_0x59a460(0xbd)](),this['getGroupElement']()[_0x59a460(0x101)]=!![],this[_0x59a460(0xef)](),this['toggleAddButton']();}[_0x57f6e6(0xcc)](){const _0xd251e1=_0x57f6e6;return Array[_0xd251e1(0xc8)](this[_0xd251e1(0xdb)]())['find'](_0x9917b7=>_0x9917b7[_0xd251e1(0xec)]===event['target'][_0xd251e1(0xf1)]['groupId']);}[_0x57f6e6(0xd0)](_0x21aace){const _0x2a12c8=_0x57f6e6,_0x15b8d4=this['querySelectorAll'](_0x2a12c8(0xde)+event['target']['value']+'\x27]');_0x15b8d4[_0x2a12c8(0xbb)]?(this[_0x2a12c8(0xd3)]()[_0x2a12c8(0xcf)](_0x5cbc8c=>_0x5cbc8c[_0x2a12c8(0xb7)]=![]),_0x15b8d4[_0x15b8d4[_0x2a12c8(0xbb)]-0x1][_0x2a12c8(0xf4)]()):this[_0x2a12c8(0xb5)](),this['getTabs']()[_0x2a12c8(0xcf)](_0x143c54=>{const _0x11f02e=_0x2a12c8,_0x5a1899=_0x21aace['target'][_0x11f02e(0xca)](_0x11f02e(0x102));if(_0x5a1899!=_0x143c54){const _0x1de87c=_0x143c54[_0x11f02e(0xe1)](_0x11f02e(0xf9)),_0x1935c7=_0x143c54[_0x11f02e(0xe1)](_0x11f02e(0x10e));_0x1de87c&&_0x1935c7&&(_0x1935c7[_0x11f02e(0xd5)]=_0x1de87c['innerHTML']);}_0x143c54[_0x11f02e(0xbc)][_0x11f02e(0xe7)]['toggle'](_0x11f02e(0xfc)),_0x143c54[_0x11f02e(0xbc)][_0x11f02e(0xe7)][_0x11f02e(0xc2)](_0x11f02e(0xe2));});}[_0x57f6e6(0x109)](){const _0x560040=_0x57f6e6;this['querySelector'](_0x560040(0xc0)+this[_0x560040(0xcc)]()['value']+'\x22]')[_0x560040(0xe1)]('.loading-overlay')[_0x560040(0xe7)][_0x560040(0xcd)](_0x560040(0xfe));}[_0x57f6e6(0x105)](_0x2a1f48=!![]){const _0x4b3951=_0x57f6e6,_0x77962c=this[_0x4b3951(0xc9)][_0x4b3951(0xe1)]('[data-form]');if(!_0x77962c)return;let _0x10f0ce=_0x77962c[_0x4b3951(0xe1)](_0x4b3951(0xc6)),_0x3c7ea0=_0x77962c['querySelector']('[name=\x22add\x22]\x20>\x20span'),_0x510272=_0x77962c[_0x4b3951(0xe1)](_0x4b3951(0xd4));if(!_0x10f0ce||_0x10f0ce[_0x4b3951(0xb7)])return;if(_0x2a1f48)_0x510272[_0x4b3951(0xb7)]=!![],_0x3c7ea0[_0x4b3951(0xf7)]=window[_0x4b3951(0xb9)]['addSubscriptionToCart'];else{const _0x22ebb3=this['section'][_0x4b3951(0xe1)](_0x4b3951(0xdc))||this[_0x4b3951(0xc9)]['querySelector'](_0x4b3951(0xee));_0x22ebb3[_0x4b3951(0xe0)][_0x4b3951(0xdf)]&&_0x22ebb3[_0x4b3951(0xe0)][_0x4b3951(0x10c)]<0x1?(_0x510272['disabled']=![],_0x3c7ea0['textContent']=window[_0x4b3951(0xb9)][_0x4b3951(0xe4)]):(_0x510272['disabled']=!![],_0x3c7ea0[_0x4b3951(0xf7)]=window[_0x4b3951(0xb9)][_0x4b3951(0xc7)]);}}['resetSellingPlans'](){const _0x39f71e=_0x57f6e6;this[_0x39f71e(0xd3)]()[_0x39f71e(0xcf)](_0x89a157=>_0x89a157[_0x39f71e(0x101)]=![]),this[_0x39f71e(0x105)](![]),this[_0x39f71e(0xbd)](!![]),this['querySelectorAll'](_0x39f71e(0xd2))[_0x39f71e(0xcf)](_0x464f13=>_0x464f13['textContent']=null);}['updateURL'](_0x35eacf=![]){const _0xff575d=_0x57f6e6;this[_0xff575d(0xb2)]===_0xff575d(0xb3)&&window['history'][_0xff575d(0xea)]({},'',this[_0xff575d(0xf1)][_0xff575d(0x10b)]+'?variant='+this[_0xff575d(0xbf)]+(!_0x35eacf?_0xff575d(0xfd)+event[_0xff575d(0xe9)][_0xff575d(0xec)]:''));}[_0x57f6e6(0xef)](){const _0x4ed15a=_0x57f6e6;let _0x45d9e4=this[_0x4ed15a(0xe8)];this[_0x4ed15a(0xb2)]==='product'&&(_0x45d9e4=this[_0x4ed15a(0xf1)][_0x4ed15a(0xe8)]);const _0x4a84a6=this[_0x4ed15a(0xc1)]==='search'?this[_0x4ed15a(0xf1)][_0x4ed15a(0x10b)]+_0x4ed15a(0x106):this['dataset'][_0x4ed15a(0x10b)]+'?',_0x709607=_0x45d9e4+'-'+this[_0x4ed15a(0xb2)]+'-'+this['currentVariantId']+'-'+event[_0x4ed15a(0xe9)][_0x4ed15a(0xec)];if(this[_0x4ed15a(0x107)][_0x709607]){this[_0x4ed15a(0xf5)](this[_0x4ed15a(0x107)][_0x709607]);return;}this[_0x4ed15a(0x109)](),fetch(_0x4a84a6+_0x4ed15a(0xed)+this[_0x4ed15a(0xbf)]+'&section_id='+_0x45d9e4+_0x4ed15a(0xfd)+event['target']['value'])[_0x4ed15a(0xf3)](_0x1cf59a=>_0x1cf59a[_0x4ed15a(0x110)]())[_0x4ed15a(0xf3)](_0x4c9195=>{const _0x23b50c=_0x4ed15a,_0x52f4b0=new DOMParser()[_0x23b50c(0xc3)](_0x4c9195,_0x23b50c(0x100));this[_0x23b50c(0x107)][_0x709607]=_0x52f4b0,this[_0x23b50c(0xf5)](_0x52f4b0);});}[_0x57f6e6(0xf5)](_0x20b531){const _0x1a3641=_0x57f6e6;this[_0x1a3641(0xc9)][_0x1a3641(0xe6)](_0x1a3641(0xfb))[_0x1a3641(0xcf)](_0x1b3f1d=>{const _0x3396ee=_0x1a3641;let _0x326fdc=_0x20b531['querySelector'](_0x3396ee(0xba)+_0x1b3f1d['dataset'][_0x3396ee(0xd6)]+'\x22]');if(_0x326fdc)_0x1b3f1d[_0x3396ee(0xd5)]=_0x326fdc[_0x3396ee(0xd5)];});}}customElements['define'](_0x57f6e6(0xcb),SellingPlanSelector);
class StorageObject {
  constructor(storageKey = null, limit = 12) {
    this.storageKey = storageKey || 'StorageObject';
    this.limit = limit;
  }

  add(data, ctx = null, offset = null) {
    const fn = this.constructor.receiveEntry;
    const entry = data ? fn(data) : fn.call(ctx);

    this.remove(entry, ctx);

    let entries = this.entries();

    while ((entries.length + 1) > this.limit) entries.shift();

    if (offset != null) {
      entries.splice(offset, 0, entry)
    } else entries.push(entry);

    StorageObject.setEntries.call(this, entries);
  }

  remove(data, ctx = null) {
    let index = -1;
    const fn = this.constructor.receiveEntry;
    const entry = data ? fn(data) : fn.call(ctx);
    if (StorageObject.getStorage.call(this) && this.has(entry) > -1) {
      index = this.has(entry);
      StorageObject.setEntries.call(this, StorageObject.entriesExceptReceived.call(this, entry))
    }
    return index;
  }

  removeByIndex(index) {
    let entries = this.entries();

    entries.reverse()
    entries.splice(index, 1);
    entries.reverse()

    StorageObject.setEntries.call(this, entries);
  }

  clear() {
    localStorage.setItem(this.storageKey, null)
  }

  has(entry, ctx = this) {
    const fn = this.constructor.receiveEntry;
    return StorageObject.getStorage.call(this) ? this.entries().findIndex(item => StorageObject.equalEntries(item, entry ? fn(entry) : fn.call(ctx))) : -1
  }

  entries(reverse = false) {
    const fn = StorageObject.getStorage.bind(this);
    const parse = JSON.parse(fn());
    return fn() ? reverse ? parse.reverse() : parse : [];
  }

  get count() {
    return StorageObject.getStorage.call(this) ? this.entries().length : 0;
  }

  static entriesExceptReceived(entry) {
    return this.entries().filter(item => !StorageObject.equalEntries(item, entry))
  }

  static equalEntries(item, entry) {
    return JSON.stringify(item) === JSON.stringify(entry)
  }

  static receiveEntry(data = null) {
    return data === null ? this.data : data
  }

  static setEntries(entries) {
    localStorage.setItem(this.storageKey, JSON.stringify(entries));
  }

  static getStorage() {
    const item = localStorage.getItem(this.storageKey);
    return item !== 'null' ? item : false
  }
}

const _0x47450b=_0x5cf1;(function(_0x294799,_0x2d99fd){const _0x2e74ae=_0x5cf1,_0x3c2e99=_0x294799();while(!![]){try{const _0x558ee3=parseInt(_0x2e74ae(0x183))/0x1+-parseInt(_0x2e74ae(0x18f))/0x2*(parseInt(_0x2e74ae(0x177))/0x3)+-parseInt(_0x2e74ae(0x186))/0x4*(parseInt(_0x2e74ae(0x189))/0x5)+parseInt(_0x2e74ae(0x145))/0x6*(-parseInt(_0x2e74ae(0x195))/0x7)+-parseInt(_0x2e74ae(0x160))/0x8*(-parseInt(_0x2e74ae(0x149))/0x9)+parseInt(_0x2e74ae(0x191))/0xa+parseInt(_0x2e74ae(0x184))/0xb;if(_0x558ee3===_0x2d99fd)break;else _0x3c2e99['push'](_0x3c2e99['shift']());}catch(_0x298ca4){_0x3c2e99['push'](_0x3c2e99['shift']());}}}(_0x2572,0xb1148));class Wishlist extends StorageObject{constructor(){const _0x5c989f=_0x5cf1;super(),this[_0x5c989f(0x16a)]=[_0x5c989f(0x185),_0x5c989f(0x180),_0x5c989f(0x194)],this[_0x5c989f(0x14e)]=_0x5c989f(0x142);}static[_0x47450b(0x164)](_0x4d6b85=null){const _0x533859=_0x47450b;return _0x4d6b85===null?[this['dataset'][_0x533859(0x18c)],parseInt(this[_0x533859(0x174)][_0x533859(0x17b)])]:_0x4d6b85;}[_0x47450b(0x15a)](_0x1ad6f5,_0x2b6448=!![]){const _0x3d82be=_0x47450b;this[_0x3d82be(0x16a)][_0x3d82be(0x14d)](_0x55510a=>_0x55510a!==_0x1ad6f5)[_0x3d82be(0x166)](_0x39f9d8=>document[_0x3d82be(0x192)](_0x39f9d8)[_0x3d82be(0x166)](_0x67b74a=>{const _0x5d3919=_0x3d82be;_0x39f9d8==='wishlist-items'?_0x67b74a[_0x5d3919(0x171)](![],null,_0x2b6448):_0x67b74a[_0x5d3919(0x171)](![]);}));}}const wishlist=new Wishlist();class WishlistCount extends HTMLElement{[_0x47450b(0x15c)](){this['render']();}['render'](_0x57b252=![]){const _0x10e88d=_0x47450b,_0x8e9a1a=wishlist['count'];this[_0x10e88d(0x157)]=_0x8e9a1a?_0x8e9a1a:'';}}function _0x2572(){const _0x4f1830=['&section_id=product-card-wishlist','appendChildren','.minicart-drop-fixed','76743Qtckqy','onAddHandlerReference','renderAll','[data-scrollbar=\x22true\x22]','filter','storageKey','count','update','.loading-overlay','onRemoveHandlerReference','renderClones','set','define','noAnimation','textContent','wishlist-popup','hidden','renderComponents','then','connectedCallback','querySelector','show','Shopify','424AnVYUB','removeByIndex','tippyContent','isOpened','receiveEntry','_tippy','forEach','dark','[data-empty]','cachedResults','components','get','remove','localName','renderListResults','themeStrings','like-animation','render','addToWishlist','closest','dataset','all','createDocumentFragment','7197nDuxSB','renderTooltip','toggleTitle','shift-toward','variantId','parseFromString','[data-render]','variantTitle','[data-wishlist-subtext]','wishlist-button','removeEventListener','toggle','1252198ubAAfE','1033373AkiXij','wishlist-count','248864GNvVag','text/html','entries','20QKcjOI','[data-section-render]','fulfilled','handle','a\x20>\x20span','classList','372CuFDrL','add','6452310UmgnfK','querySelectorAll','has','wishlist-items','35ZoOxRg','.loading-overlay__spinner','stringify','click','loader','map','onRemoveHandler','addEventListener','toggleEmpty','setContent','in-wishlist','lumiaWishlist','routes','bind','1227486yDTFjW'];_0x2572=function(){return _0x4f1830;};return _0x2572();}customElements[_0x47450b(0x155)](_0x47450b(0x185),WishlistCount);class WishlistButton extends HTMLElement{constructor(){const _0x445c5e=_0x47450b;super(),this[_0x445c5e(0x152)]=this[_0x445c5e(0x13d)]['bind'](this),this['onAddHandlerReference']=this['onAddHandler'][_0x445c5e(0x144)](this),this['render'](![]);}['onAddHandler'](_0x2f5fe4){const _0x4856ad=_0x47450b;wishlist[_0x4856ad(0x190)](null,this),this[_0x4856ad(0x14b)](_0x2f5fe4);}[_0x47450b(0x13d)](_0x1c2490){const _0x22f20d=_0x47450b;wishlist[_0x22f20d(0x16c)](null,this),this['querySelector'](_0x22f20d(0x196))?.[_0x22f20d(0x18e)][_0x22f20d(0x16c)](_0x22f20d(0x159)),this['renderAll'](_0x1c2490,![]);}[_0x47450b(0x14b)](_0x33e0ef,_0xeeab2c=!![]){const _0x129aa9=_0x47450b;this[_0x129aa9(0x153)](),wishlist[_0x129aa9(0x15a)](this[_0x129aa9(0x16d)],_0xeeab2c),_0x33e0ef['preventDefault']();}[_0x47450b(0x171)](_0xa63160=!![]){const _0x2084c=_0x47450b,_0xc81a1a=wishlist[_0x2084c(0x193)](null,this)>-0x1,_0x34e784=this[_0x2084c(0x15d)]('a');let _0x2fd412=this['querySelectorAll']('svg');if(_0x2084c(0x179)in this[_0x2084c(0x174)]){const _0x4ff507=this[_0x2084c(0x192)](_0x2084c(0x18d));_0x4ff507[Number(!_0xc81a1a)][_0x2084c(0x18e)][_0x2084c(0x190)](_0x2084c(0x159)),_0x4ff507[Number(_0xc81a1a)][_0x2084c(0x18e)]['remove']('hidden');}const _0x20ec06=[this[_0x2084c(0x152)],this[_0x2084c(0x14a)]];this[_0x2084c(0x18e)][_0x2084c(0x182)](_0x2084c(0x141),_0xc81a1a),_0x2fd412[_0x2084c(0x166)](_0x17fa9e=>!(_0x2084c(0x156)in _0x17fa9e[_0x2084c(0x173)](_0x2084c(0x180))[_0x2084c(0x174)])&&_0x17fa9e[_0x2084c(0x18e)][_0x2084c(0x182)](_0x2084c(0x170),_0xc81a1a)),_0x34e784&&(_0x34e784[_0x2084c(0x181)]('click',_0x20ec06[Number(_0xc81a1a)]),_0x34e784[_0x2084c(0x13e)](_0x2084c(0x13a),_0x20ec06[Number(!_0xc81a1a)])),this[_0x2084c(0x178)](_0xa63160),_0xc81a1a&&(setTimeout(()=>{this['blur']();},0x0),setTimeout(()=>{const _0x186695=_0x2084c;_0x2fd412[_0x186695(0x166)](_0x59162f=>!(_0x186695(0x156)in _0x59162f[_0x186695(0x173)](_0x186695(0x180))[_0x186695(0x174)])&&_0x59162f[_0x186695(0x18e)][_0x186695(0x16c)](_0x186695(0x170)));},0x4b0));}['renderTooltip'](_0x227c37=!![]){const _0x4f94d4=_0x47450b,_0x51230d=this[_0x4f94d4(0x15d)]('[data-tippy-content]');if(_0x51230d){let _0x5cae5b=wishlist[_0x4f94d4(0x193)](null,this)>-0x1?window[_0x4f94d4(0x16f)]['removeFromWishlist']:window[_0x4f94d4(0x16f)][_0x4f94d4(0x172)];this[_0x4f94d4(0x174)][_0x4f94d4(0x17e)]&&('toggleTitle'in this[_0x4f94d4(0x174)]?_0x5cae5b=this[_0x4f94d4(0x174)][_0x4f94d4(0x17e)]:_0x5cae5b=_0x5cae5b+'\x20('+this['dataset'][_0x4f94d4(0x17e)]+')');const _0xd87b86={'arrow':!![],'theme':_0x4f94d4(0x167),'animation':_0x4f94d4(0x17a)};'_tippy'in _0x51230d?(_0x51230d[_0x4f94d4(0x165)][_0x4f94d4(0x140)](_0x5cae5b),_0x227c37&&_0x51230d['_tippy'][_0x4f94d4(0x15e)]()):_0x51230d['dataset'][_0x4f94d4(0x162)]=_0x5cae5b;}}[_0x47450b(0x153)](){const _0x5dbfc8=_0x47450b;document[_0x5dbfc8(0x192)](this['localName']+'[data-handle=\x22'+this[_0x5dbfc8(0x174)][_0x5dbfc8(0x18c)]+'\x22]')[_0x5dbfc8(0x166)](_0xfa5376=>_0xfa5376[_0x5dbfc8(0x171)](_0xfa5376===this));}}customElements[_0x47450b(0x155)](_0x47450b(0x180),WishlistButton);function _0x5cf1(_0x1a67b9,_0x249aba){const _0x257207=_0x2572();return _0x5cf1=function(_0x5cf110,_0x1912ec){_0x5cf110=_0x5cf110-0x139;let _0xbc1295=_0x257207[_0x5cf110];return _0xbc1295;},_0x5cf1(_0x1a67b9,_0x249aba);}class WishlistItems extends HTMLElement{constructor(){const _0x38c522=_0x47450b;super(),this[_0x38c522(0x169)]=new Map(),this[_0x38c522(0x13b)]=this[_0x38c522(0x15d)](_0x38c522(0x151)),this[_0x38c522(0x13f)]();}['toggleEmpty'](){const _0x27b442=_0x47450b;this[_0x27b442(0x18e)][_0x27b442(0x182)]('is-empty',!wishlist[_0x27b442(0x14f)]);}[_0x47450b(0x171)](_0x13f632,_0xab5d76=null,_0x146077=!![]){const _0x38168a=_0x47450b;this[_0x38168a(0x13f)](),document[_0x38168a(0x15d)](_0x38168a(0x17f))?.['classList'][_0x38168a(0x182)](_0x38168a(0x159),!wishlist[_0x38168a(0x14f)]),this[_0x38168a(0x192)](_0x38168a(0x148))[_0x38168a(0x166)](_0x4190c5=>_0x4190c5['classList'][_0x38168a(0x182)](_0x38168a(0x159),!wishlist[_0x38168a(0x14f)]));if(!document[_0x38168a(0x15d)](_0x38168a(0x158))[_0x38168a(0x163)]()&&_0xab5d76===null)return;if(wishlist[_0x38168a(0x14f)]){_0x146077&&this[_0x38168a(0x13b)][_0x38168a(0x18e)][_0x38168a(0x16c)](_0x38168a(0x159));const _0x65aa71=wishlist[_0x38168a(0x188)](!![]),_0x2c227e=JSON[_0x38168a(0x139)](_0x65aa71);this[_0x38168a(0x169)][_0x38168a(0x193)](_0x2c227e)?this[_0x38168a(0x16e)](this[_0x38168a(0x169)][_0x38168a(0x16b)](_0x2c227e),_0xab5d76):Promise[_0x38168a(0x175)](_0x65aa71[_0x38168a(0x13c)](_0x179eb2=>fetch(window[_0x38168a(0x15f)][_0x38168a(0x143)]['root']+('products/'+_0x179eb2[0x0]+'?variant='+_0x179eb2[0x1]+_0x38168a(0x146)))))[_0x38168a(0x15b)](_0x4ad692=>Promise[_0x38168a(0x175)](_0x4ad692[_0x38168a(0x13c)](_0x3bf602=>_0x3bf602['text']())))[_0x38168a(0x15b)](_0xb9f7fc=>{const _0x3892e7=_0x38168a;return _0xb9f7fc[_0x3892e7(0x14d)]((_0x344c63,_0x4c82e9)=>{const _0x2e0677=_0x3892e7,_0x5e5bdb=new DOMParser()['parseFromString'](_0x344c63,_0x2e0677(0x187))[_0x2e0677(0x15d)]('[data-section-render]');return!_0x5e5bdb&&(wishlist[_0x2e0677(0x161)](_0x4c82e9),document['querySelectorAll']('wishlist-count')[_0x2e0677(0x166)](_0x3f1bfd=>_0x3f1bfd[_0x2e0677(0x171)]())),_0x5e5bdb;});})[_0x38168a(0x15b)](_0x49e100=>{const _0x56882e=_0x38168a;this[_0x56882e(0x169)][_0x56882e(0x154)](_0x2c227e,_0x49e100),this[_0x56882e(0x16e)](_0x49e100,_0xab5d76);});}else this[_0x38168a(0x15d)](_0x38168a(0x17d))['innerHTML']=null;this[_0x38168a(0x15d)](_0x38168a(0x168))['classList'][_0x38168a(0x182)](_0x38168a(0x159),wishlist[_0x38168a(0x14f)]);if(!wishlist[_0x38168a(0x14f)]&&_0xab5d76!==null)_0xab5d76(_0x38168a(0x18b));}[_0x47450b(0x16e)](_0x4fe4a3,_0x11931e){const _0x4db9bd=_0x47450b,_0x2b9279=document[_0x4db9bd(0x176)]();_0x4fe4a3['forEach'](_0x58f051=>{const _0x2cd133=_0x4db9bd,_0x54f315=new DOMParser()[_0x2cd133(0x17c)](_0x58f051,_0x2cd133(0x187))[_0x2cd133(0x15d)](_0x2cd133(0x18a));_0x2b9279['appendChild'](_0x54f315);});const _0x16a721=this[_0x4db9bd(0x15d)](_0x4db9bd(0x17d));_0x16a721['innerHTML']=null,_0x16a721[_0x4db9bd(0x147)](_0x2b9279);const _0xe48b38=this[_0x4db9bd(0x15d)](_0x4db9bd(0x14c));_0xe48b38&&Scrollbar[_0x4db9bd(0x16b)](_0xe48b38)&&Scrollbar[_0x4db9bd(0x16b)](_0xe48b38)[_0x4db9bd(0x150)](),this['loader'][_0x4db9bd(0x18e)][_0x4db9bd(0x190)]('hidden');if(_0x11931e!==null)_0x11931e('fulfilled');}}customElements[_0x47450b(0x155)](_0x47450b(0x194),WishlistItems);
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.select = this.querySelector('select[name="type"]');
    this.unavailable_products = this.querySelector('[name="unavailable_products"]');
    this.form = this.querySelector('form.search');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.loader = this.querySelector('.loading-overlay');
    this.setupEventListeners();

    this.setFocus();
  }

  setFocus() {
    setTimeout(() => {
      this.input.focus()
    }, 1000);
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));

    this.select?.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.unavailable_products?.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

    this.addQuickTagsEvent();
  }

  addQuickTagsEvent() {
    this.quickSearchTags = this.querySelectorAll('.quick-search li > span');
    this.quickSearchTags.forEach((item) => {
      item.addEventListener('click', function (e) {
        this.quickSearchTagsReset();
        item.classList.add('active');
        this.input.value = e.currentTarget.textContent;
        this.onChange();
        this.input.focus();
      }.bind(this))
    });
  }

  quickSearchTagsReset() {
    this.querySelectorAll('.quick-search li > span').forEach(item => item.classList.remove('active'));
  }

  quickSearchTagsSetActive() {
    if (!this.quickSearchTags) return;
    const searchTerm = this.getQuery();
    this.quickSearchTagsReset();
    const tag = Array.from(this.quickSearchTags).find(item => item.textContent.toLowerCase() === searchTerm.toLowerCase())
    tag && tag.classList.add('active')
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();
    if (!searchTerm.length) {
      this.close(true);
      this.hideInputs();
      return;
    }
    let isMobile = window.matchMedia('(max-width:991px)').matches;
    (this.closest('header') || !isMobile) && this.loader.classList.remove('hidden');
    // (this.closest('header')) && this.loader.classList.remove('hidden');
    this.showInputs();
    this.getSearchResults(searchTerm);
    this.quickSearchTagsSetActive();
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {

      this.showKeyboardDescription();
    } else {
      /*this.getSearchResults(searchTerm);*/
    }
  }

  onFocusOut() {
    const selectedElement = this.querySelector('[aria-selected="true"]');
    selectedElement?.setAttribute('aria-selected', false);
    this.showKeyboardDescription(false);
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getQuery().length) return;
    /*if (!this.getAttribute('open')) return;*/
    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('.swiper-slide');
    let activeElement = this.querySelector('.swiper-slide');


    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);

    const slider = activeElement.closest('.swiper-container');
    let index = Array.from(allElements).indexOf(activeElement);
    if (Array.from(allElements).length > index) {
      if (!index || index > 5 || moveUp && index > 0 && index < 6) {
        slider.swiper.slideTo(index);
      }
      if (!index) {
        this.input.focus();
        allElements[0].setAttribute('aria-selected', true);
      }
    }
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = this.unavailable_products?.value+'-'+this.select?.value.replace(",", "-")+'-'+searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    const type = (this.select?.value ?? false) ? `${this.select.value}` : 'product,page,article,query';
    const unavailable_products = (this.unavailable_products?.value ?? false) ? `${this.unavailable_products.value}` : 'last';

    async function getSearchResults() {
      const request = await fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=${type}&${encodeURIComponent('resources[limit]')}=12&${encodeURIComponent('resources[fields]')}=title,product_type,body,product_type,vendor,variants.sku,tag&${encodeURIComponent('resources[unavailable_products]')}=${unavailable_products}&section_id=predictive-search`);
      return await request.text()

    }
    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=${type}&${encodeURIComponent('resources[limit]')}=12&${encodeURIComponent('resources[fields]')}=title,product_type,body,product_type,vendor,variants.sku,tag&${encodeURIComponent('resources[unavailable_products]')}=${unavailable_products}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  showKeyboardDescription(show = true) {
    let keyboardElement = document.querySelectorAll('.keyboard-control');
    keyboardElement.forEach(item => {
      item.classList.toggle('d-md-block', show);
      item.classList.toggle('d-md-none', !show);
    });

  }

  showInputs() {
    this.unavailable_products?.parentElement.classList.remove('hidden');
    this.select?.parentElement.classList.remove('hidden');
    this.showKeyboardDescription();
  }
  hideInputs() {
    this.unavailable_products?.parentElement.classList.add('hidden');
    this.select?.parentElement.classList.add('hidden');
    this.showKeyboardDescription(false);
  }
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    const documentParsed = new DOMParser().parseFromString(resultsMarkup, 'text/html');

    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    let keyboardElements = document.querySelectorAll('.keyboard-control');
    if (keyboardElements) {
      keyboardElements.forEach(item => item.classList.toggle('hidden', documentParsed.querySelector('.category-empty')));
    }

    this.setLiveRegionResults();
    this.open();
    this.loader.classList.add('hidden');
    this.showInputs();
    document.querySelector('[data-close-predictive]')?.addEventListener('click', this.close.bind(this, false));

    this.renderElements(documentParsed);
    this.addQuickTagsEvent();
  }

  renderElements(renderedDocument) {
    this.querySelectorAll('[data-render-predictive-search]').forEach(destination => {
      const source = renderedDocument.querySelector(`[data-render-predictive-search=${destination.dataset.renderPredictiveSearch}]`);

      if (source) destination.innerHTML = source.innerHTML;
    });
  }

  renderFacetsElements(renderedDocument) {
    document.querySelectorAll('[data-render-facets]').forEach(destination => {
      const source = renderedDocument.querySelector(`[data-render-facets=${destination.dataset.renderFacets}]`);

      if (source) destination.innerHTML = source.innerHTML;
    });
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    document.querySelectorAll('search-page, predictive-search').forEach(item => item.close());
    /*this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;*/
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    // const selected = this.querySelector('[aria-selected="true"]');

    // if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);

class SearchPage extends PredictiveSearch {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.form = this.querySelector('form');
    this.select = this.querySelector('select[name="type"]');
    this.SearchPageResults = document.querySelector('[data-search-page-results]');
    this.loader = this.querySelector('.loading-overlay__spinner');

    this.addQuickTagsEvent();

    this.setPlaceholder();

    window.addEventListener('resize', debounce(() => {
      this.setPlaceholder();
    }, 300))
  }

  addQuickTagsEvent() {
    this.quickSearchTags = this.querySelectorAll('.quick-search li > span');
    this.quickSearchTags.forEach((item) => {
      item.addEventListener('click', function (e) {
        let isMobile = window.matchMedia('(max-width:991px)').matches;

        this.input.value = e.currentTarget.textContent;

        // !isMobile && this.onChange();
        this.onChange();

        this.input.focus();

        isMobile && this.onFormSubmit(e);
      }.bind(this))
    });
  }

  setFocus() {

  }

  setPlaceholder() {
    this.input.placeholder = window.themeStrings[window.matchMedia('(max-width:767px)').matches ? 'search_placeholder_short' : 'search_placeholder']
  }

  onFormSubmit(event) {
    if (this.closest('header')) {
      this.__proto__.__proto__.onFormSubmit.call(this, event);
    } else {
      this.removeAttribute('open');
      const searchTerm = this.getQuery();
      event.preventDefault();
      if (!searchTerm.length) {
        return;
      }
      this.loader.classList.remove('hidden');

      this.getSearchPageResults(searchTerm, true);

    }

  }

  getSearchPageResults(searchTerm, forceFilterReload = false) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData).toString();

    if (this.cachedResults[queryKey]) {
      this.renderSearchPageResults(this.cachedResults[queryKey], searchParams, forceFilterReload);
      return;
    }

    const sectionId = 'sectionId' in this.dataset ? `&section_id=${this.dataset.sectionId}` : '';
    fetch(`${routes.search_url}?${searchParams}${sectionId}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {

        const documentRendered = new DOMParser().parseFromString(text, 'text/html');

        this.cachedResults[queryKey] = documentRendered;
        this.renderSearchPageResults(documentRendered, searchParams, forceFilterReload);

      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchPageResults(documentRendered, searchParams, forceFilterReload = false) {
    this.SearchPageResults.innerHTML = documentRendered.querySelector('[data-search-page-results]').innerHTML;
    this.SearchPageResults.querySelector('.show-on-scroll').classList.toggle('is-visible');
    this.loader.classList.add('hidden');
    this.removeAttribute('open');

    const element = documentRendered.querySelector('p[role="status"]') || documentRendered.querySelector('span[role="status"]');
    const status = element.innerHTML;

    this.updateURLHash(searchParams, window.themeStrings.search+': '+status);
    document.querySelector('[data-close-predictive]')?.addEventListener('click', this.close.bind(this, false));

    this.renderElements(documentRendered);
    this.renderRequiredElements(documentRendered);
    this.renderFacetsElements(documentRendered);
    this.addQuickTagsEvent();



    let isMobile = window.matchMedia('(max-width:991px)').matches;

    if (!isMobile && forceFilterReload && document.querySelector('[data-facets-sorting] filter-popup[data-clone]')) {
      document.querySelector('#dropdnFilterPopup [data-slot="mobile-popup-content"]').innerHTML = documentRendered.querySelector('#filterColumn').innerHTML
    }
  }

  renderRequiredElements(html) {
    document.querySelectorAll('[data-async-reload-required]').forEach(destination => {
      const source = html.querySelector(`[data-async-reload-required=${destination.dataset.asyncReloadRequired}]`);

      if (source) destination.innerHTML = source.innerHTML;
    });
  }

  renderAdditionalElements(html) {
    const documentRendered = new DOMParser().parseFromString(html, 'text/html');
    const mobileElementSelectors = ['.hdr-mobile-bottom'];

    mobileElementSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach(item => {
        item.innerHTML = documentRendered.querySelector(selector).innerHTML;
      });
    });
  }

  updateURLHash(searchParams, status) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    document.title = status;
  }
}

customElements.define('search-page', SearchPage);

document.addEventListener('click', function(e){
  if (!(e.target.closest('[data-predictive-search]') || e.target.classList.contains('quick-search-tag') || e.target.closest('.quick-search-tag') || e.target.matches('[name=q]'))) {
    document.querySelectorAll('search-page, predictive-search')?.forEach(item => item.close());
  }
});

if (!customElements.get('product-model')) {
  customElements.define('product-model', class ProductModel extends HTMLElement {
    constructor() {
      super();

    }

    connectedCallback() {
      if ('loadShopifyFeature' in this.dataset) {
        this.shopifyLoadFeatures();
      } else {
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
      }
    }

    loadContent(focus = true) {
      window.pauseAllMedia();
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('model-viewer'));
        if (focus) deferredElement.focus();
      }

      this.shopifyLoadFeatures();
    }

    shopifyLoadFeatures() {
      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }

    setupModelViewerUI(errors) {
      if (errors) return;

      this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
    }
  });
}

window.ProductModel = {
  loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () =>
        this.setupShopifyXR()
      );
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});

const _0xcc4663=_0x3352;(function(_0x3823bf,_0x100feb){const _0x35dfa6=_0x3352,_0x42ab13=_0x3823bf();while(!![]){try{const _0x112644=parseInt(_0x35dfa6(0x1b7))/0x1+-parseInt(_0x35dfa6(0x244))/0x2+parseInt(_0x35dfa6(0x1af))/0x3+parseInt(_0x35dfa6(0x222))/0x4*(parseInt(_0x35dfa6(0x1c2))/0x5)+-parseInt(_0x35dfa6(0x1e8))/0x6*(parseInt(_0x35dfa6(0x1f7))/0x7)+-parseInt(_0x35dfa6(0x216))/0x8+-parseInt(_0x35dfa6(0x1fb))/0x9;if(_0x112644===_0x100feb)break;else _0x42ab13['push'](_0x42ab13['shift']());}catch(_0x2edc63){_0x42ab13['push'](_0x42ab13['shift']());}}}(_0x2ed6,0xa9fe3));class ShippingCalculator extends HTMLElement{constructor(){const _0x1bbdec=_0x3352;super(),this['a']=this[_0x1bbdec(0x1fe)]('a'),this[_0x1bbdec(0x1f5)](_0x1bbdec(0x208),this['onClickHandler'][_0x1bbdec(0x1c3)](this));}[_0xcc4663(0x240)](){const _0x5c15a3=_0xcc4663,_0x893f4b=document[_0x5c15a3(0x1fe)](_0x5c15a3(0x248)),_0x38ab76=document[_0x5c15a3(0x1b5)](_0x5c15a3(0x1b0));_0x893f4b[_0x5c15a3(0x1c4)]=_0x5c15a3(0x1eb),_0x893f4b[_0x5c15a3(0x22f)](_0x38ab76),this[_0x5c15a3(0x24c)]=document[_0x5c15a3(0x1fe)](_0x5c15a3(0x1b0));}[_0xcc4663(0x1d6)](_0x3339d1){const _0xdce43=_0xcc4663;_0x3339d1['preventDefault'](),this['shippingCalculatorForm']=document[_0xdce43(0x1fe)]('shipping-calculator-form'),Array[_0xdce43(0x1ad)](this['a'][_0xdce43(0x1dc)])[_0xdce43(0x22a)](_0x5ef6bd=>_0x5ef6bd['classList'][_0xdce43(0x1ff)]('hidden')),this[_0xdce43(0x1cf)](),this['a'][_0xdce43(0x22e)]['toggle'](_0xdce43(0x1ab)),!document[_0xdce43(0x1fe)](_0xdce43(0x1df))[_0xdce43(0x22e)]['contains'](_0xdce43(0x227))&&(!this['a'][_0xdce43(0x22e)][_0xdce43(0x20a)](_0xdce43(0x1ab))&&this['shippingCalculatorForm'][_0xdce43(0x1fa)]()&&(this[_0xdce43(0x1e5)]()||!this[_0xdce43(0x1e5)]()&&this[_0xdce43(0x24c)][_0xdce43(0x1b6)]?.['innerHTML']==='')&&(this[_0xdce43(0x24c)]['shipping_results'][_0xdce43(0x1c4)]=null,this[_0xdce43(0x24c)][_0xdce43(0x23c)]['dispatchEvent'](new Event(_0xdce43(0x205))))),document['querySelector'](_0xdce43(0x204))[_0xdce43(0x1bd)](_0xdce43(0x21b))[_0xdce43(0x22a)](_0x1832a9=>{const _0x270a65=_0xdce43;Scrollbar[_0x270a65(0x245)](_0x1832a9)['update']();}),this[_0xdce43(0x1e4)]();}[_0xcc4663(0x1e4)](){const _0x25889b=_0xcc4663;document[_0x25889b(0x1fe)]('#dropdnMinicartPopup')[_0x25889b(0x1bd)](_0x25889b(0x21b))[_0x25889b(0x22a)](_0xf03143=>{const _0x388ebd=_0x25889b;Scrollbar['get'](_0xf03143)[_0x388ebd(0x213)](0x0,0x0,0x0);});}[_0xcc4663(0x201)](_0x524ed5){const _0x1f48f3=_0xcc4663;_0x524ed5?this['toggleForms'](_0x524ed5):JSON[_0x1f48f3(0x23e)](this['a'][_0x1f48f3(0x1db)][_0x1f48f3(0x20d)])&&this[_0x1f48f3(0x1cf)]();}[_0xcc4663(0x1ec)](_0x161242){const _0x4d903c=_0xcc4663,_0x15fbec=document[_0x4d903c(0x1bd)](_0x4d903c(0x1f3))||document[_0x4d903c(0x1bd)](_0x4d903c(0x1b0));_0x15fbec[_0x4d903c(0x22a)](_0x24a2fd=>{const _0xe0ff2f=_0x4d903c;_0x24a2fd['querySelector']('a')['dataset'][_0xe0ff2f(0x20d)]=_0x161242;});}[_0xcc4663(0x1e5)](){const _0x129381=_0xcc4663;return JSON[_0x129381(0x23e)](this['a']['dataset']['update']);}['toggleForms'](_0x27db67=![]){const _0xf930b1=_0xcc4663;function _0x5cc02d(_0x1b77f5){const _0x3ce506=_0x3352;_0x1b77f5&&Array['from'](_0x1b77f5)[_0x3ce506(0x22a)]((_0x1107ef,_0x44a99e)=>{const _0x30c926=_0x3ce506;_0x1107ef[_0x30c926(0x22e)][_0x30c926(0x1ff)](_0x30c926(0x21c),Boolean(_0x44a99e));});}_0x27db67?(this['a'][_0xf930b1(0x22e)][_0xf930b1(0x225)](_0xf930b1(0x1ab)),_0x5cc02d(this['a'][_0xf930b1(0x1dc)]),_0x5cc02d(document[_0xf930b1(0x1fe)](this['a']['dataset'][_0xf930b1(0x206)])?.[_0xf930b1(0x1bd)](_0xf930b1(0x1ce))),this['a'][_0xf930b1(0x1db)][_0xf930b1(0x210)][_0xf930b1(0x1c0)](',')[_0xf930b1(0x22a)]((_0x4a7b56,_0x3cfd10)=>{const _0x38fafe=_0xf930b1;document[_0x38fafe(0x1fe)](_0x4a7b56)?.[_0x38fafe(0x22e)][_0x38fafe(0x1ff)](_0x38fafe(0x21c),Boolean(_0x3cfd10));})):(document[_0xf930b1(0x1fe)](this['a']['dataset']['titleElement'])['querySelectorAll'](_0xf930b1(0x1ce))['forEach'](_0x6b3bd9=>_0x6b3bd9[_0xf930b1(0x22e)][_0xf930b1(0x1ff)](_0xf930b1(0x21c))),this['a']['dataset'][_0xf930b1(0x210)][_0xf930b1(0x1c0)](',')[_0xf930b1(0x22a)](_0x10cad0=>document[_0xf930b1(0x1fe)](_0x10cad0)['classList'][_0xf930b1(0x1ff)](_0xf930b1(0x21c))));}}function _0x3352(_0x11ace1,_0x46ee16){const _0x2ed630=_0x2ed6();return _0x3352=function(_0x33526c,_0xcbdc9){_0x33526c=_0x33526c-0x1ab;let _0x240691=_0x2ed630[_0x33526c];return _0x240691;},_0x3352(_0x11ace1,_0x46ee16);}customElements[_0xcc4663(0x1f6)]('shipping-calculator',ShippingCalculator);class ShippingCalculatorCart extends ShippingCalculator{[_0xcc4663(0x1d6)](_0x3feb25){const _0x30e107=_0xcc4663;_0x3feb25['preventDefault'](),document[_0x30e107(0x1fe)](_0x30e107(0x1b2))?.[_0x30e107(0x208)](),this[_0x30e107(0x226)]();}[_0xcc4663(0x226)](){setTimeout(()=>{const _0x56adc4=_0x3352;this['shippingCalculatorForm']=document['querySelector'](_0x56adc4(0x1b0)),this[_0x56adc4(0x24c)]&&(!document[_0x56adc4(0x1fe)](_0x56adc4(0x1df))[_0x56adc4(0x22e)]['contains'](_0x56adc4(0x215))?this['shippingCalculatorForm']['getReady']()&&(this['getUpdateStatus']()||!this[_0x56adc4(0x1e5)]()&&this[_0x56adc4(0x24c)][_0x56adc4(0x1b6)]['innerHTML']==='')&&(this[_0x56adc4(0x24c)][_0x56adc4(0x1b6)][_0x56adc4(0x1c4)]=null,this[_0x56adc4(0x24c)]['form'][_0x56adc4(0x234)](new Event(_0x56adc4(0x205)))):(this[_0x56adc4(0x24c)][_0x56adc4(0x1b6)]&&(this[_0x56adc4(0x24c)]['shipping_results'][_0x56adc4(0x1c4)]=null),this[_0x56adc4(0x24c)][_0x56adc4(0x23c)]?.['dispatchEvent'](new Event(_0x56adc4(0x205)))),document[_0x56adc4(0x1fe)](_0x56adc4(0x204))['querySelectorAll'](_0x56adc4(0x21b))['forEach'](_0x588681=>{const _0x50c0b4=_0x56adc4;Scrollbar[_0x50c0b4(0x245)](_0x588681)&&Scrollbar['get'](_0x588681)[_0x50c0b4(0x20d)]();}));},0x5dc);}[_0xcc4663(0x1ec)](_0x1ba0a2){const _0xafe2ef=_0xcc4663;this[_0xafe2ef(0x1fe)]('a')[_0xafe2ef(0x1db)][_0xafe2ef(0x20d)]=_0x1ba0a2;}}customElements[_0xcc4663(0x1f6)](_0xcc4663(0x1b4),ShippingCalculatorCart);class ShippingCalculatorForm extends HTMLElement{constructor(){const _0x4d3201=_0xcc4663;super(),fetch(shopUrl+_0x4d3201(0x242))[_0x4d3201(0x1f4)](_0x119cb0=>_0x119cb0[_0x4d3201(0x1de)]())[_0x4d3201(0x1f4)](_0x2b01b1=>{const _0x5a9703=_0x4d3201,_0x23c03d=document['querySelector'](_0x5a9703(0x248));_0x23c03d&&_0x23c03d['querySelector'](_0x5a9703(0x1ca))?.[_0x5a9703(0x24a)]();const _0x12e24f=new DOMParser()[_0x5a9703(0x1d2)](_0x2b01b1,'text/html')['querySelector'](_0x5a9703(0x219));this[_0x5a9703(0x1c4)]=_0x12e24f[_0x5a9703(0x1c4)];if(!document[_0x5a9703(0x1fe)]('body')[_0x5a9703(0x22e)][_0x5a9703(0x20a)](_0x5a9703(0x227))){this[_0x5a9703(0x23c)]=this[_0x5a9703(0x1fe)](_0x5a9703(0x23c)),this['country']=this[_0x5a9703(0x1fe)](_0x5a9703(0x221)),this['province']=this[_0x5a9703(0x1fe)]('#province'),this[_0x5a9703(0x1ae)]=this[_0x5a9703(0x1fe)](_0x5a9703(0x1e3));const _0x4479e3=this[_0x5a9703(0x1fd)][_0x5a9703(0x1db)][_0x5a9703(0x236)];Array[_0x5a9703(0x1ad)](this[_0x5a9703(0x1fd)]['options'])[_0x5a9703(0x246)](_0x33622e=>_0x33622e[_0x5a9703(0x1d7)]===_0x4479e3)?this[_0x5a9703(0x1fd)][_0x5a9703(0x1d7)]=_0x4479e3:this[_0x5a9703(0x1fd)]['selectedIndex']=0x0,this[_0x5a9703(0x243)]['value']=this[_0x5a9703(0x243)]['dataset'][_0x5a9703(0x236)],this[_0x5a9703(0x24b)]=this['querySelector'](_0x5a9703(0x231)),this[_0x5a9703(0x1c6)]=this[_0x5a9703(0x1fe)](_0x5a9703(0x200)),this['templateMeta']=this[_0x5a9703(0x1fe)](_0x5a9703(0x1d1)),this[_0x5a9703(0x1b6)]=this['querySelector']('#shipping_results'),this[_0x5a9703(0x23f)]=document['querySelector'](_0x5a9703(0x1f3))||document[_0x5a9703(0x1fe)](_0x5a9703(0x1b4)),this[_0x5a9703(0x20f)](),this['getCountryProvinces'](),this['setupEventListeners']();}});}[_0xcc4663(0x241)](_0x2ea55b){const _0x4db9cb=_0xcc4663,_0x16ec12=[_0x4db9cb(0x1fd),_0x4db9cb(0x243),_0x4db9cb(0x1d3)];_0x16ec12['forEach'](_0xd4a8be=>localStorage[_0x4db9cb(0x21d)]('shipping_address['+_0xd4a8be+']',_0x2ea55b['get']('shipping_address['+_0xd4a8be+']')));}[_0xcc4663(0x20f)](){const _0x1bb9ee=_0xcc4663,_0x49bc24=[_0x1bb9ee(0x1fd),'province',_0x1bb9ee(0x1d3)];_0x49bc24[_0x1bb9ee(0x22a)](_0x344b93=>{const _0x27ed49=_0x1bb9ee;localStorage[_0x27ed49(0x21a)](_0x27ed49(0x1cc)+_0x344b93+']')&&(this[_0x27ed49(0x23c)][_0x27ed49(0x1fe)]('[name=\x22shipping_address['+_0x344b93+']\x22]')[_0x27ed49(0x1d7)]=localStorage[_0x27ed49(0x21a)]('shipping_address['+_0x344b93+']'));});}['getLocalStorageProvince'](){const _0x4e45a5=_0xcc4663;return localStorage['getItem'](_0x4e45a5(0x21f));}[_0xcc4663(0x1d0)](){const _0x23f0ed=_0xcc4663;this['form'][_0x23f0ed(0x1f5)](_0x23f0ed(0x205),this['onSubmitHandler']['bind'](this)),this[_0x23f0ed(0x1fd)][_0x23f0ed(0x1f5)](_0x23f0ed(0x1f9),this[_0x23f0ed(0x1d4)][_0x23f0ed(0x1c3)](this));}[_0xcc4663(0x1be)](_0xeca4d4){const _0x5de8cb=_0xcc4663;_0xeca4d4[_0x5de8cb(0x1f0)]();const _0x4f217e=new FormData(_0xeca4d4[_0x5de8cb(0x1c1)][_0x5de8cb(0x23c)]?_0xeca4d4[_0x5de8cb(0x1c1)][_0x5de8cb(0x23c)]:_0xeca4d4[_0x5de8cb(0x1c1)][_0x5de8cb(0x22b)]('form'));this['getShippingEstimates'](_0x4f217e);}[_0xcc4663(0x1fa)](){const _0x477997=_0xcc4663;if(document[_0x477997(0x1fe)](_0x477997(0x1df))['classList'][_0x477997(0x20a)]('shipping-calculator-static'))return!![];return this[_0x477997(0x23c)]['2']&&this[_0x477997(0x23c)]['2']['value'];}[_0xcc4663(0x1d4)](_0x5784e4){const _0x444cd8=_0xcc4663;function _0x515e16(_0x1ebf1c){const _0xac5687=_0x3352;let _0x30a711,_0x4129c3=_0x1ebf1c[_0xac5687(0x207)][_0xac5687(0x23d)]-0x1;for(_0x30a711=_0x4129c3;_0x30a711>=0x0;_0x30a711--){_0x1ebf1c['remove'](_0x30a711);}}this[_0x444cd8(0x1ae)][_0x444cd8(0x22e)][_0x444cd8(0x225)](_0x444cd8(0x21c));const _0x279d33=this[_0x444cd8(0x1fd)]??_0x5784e4[_0x444cd8(0x24d)],_0x20c3fe=_0x279d33[_0x279d33[_0x444cd8(0x1b3)]];let _0x3e3597;if(_0x20c3fe){_0x3e3597=JSON[_0x444cd8(0x23e)](_0x20c3fe[_0x444cd8(0x1db)][_0x444cd8(0x1b8)]),_0x515e16(this[_0x444cd8(0x243)]);if(_0x3e3597['length'])for(let _0x511506=0x0;_0x511506<_0x3e3597['length'];_0x511506++){let _0x521187=document[_0x444cd8(0x1b5)](_0x444cd8(0x209));_0x521187[_0x444cd8(0x1d7)]=_0x3e3597[_0x511506][0x0],_0x521187[_0x444cd8(0x1de)]=_0x3e3597[_0x511506][0x1],(this[_0x444cd8(0x249)]()&&this[_0x444cd8(0x249)]()===_0x521187[_0x444cd8(0x1d7)]||this[_0x444cd8(0x243)][_0x444cd8(0x1db)][_0x444cd8(0x236)]&&this[_0x444cd8(0x243)][_0x444cd8(0x1db)][_0x444cd8(0x236)]===_0x521187[_0x444cd8(0x1d7)])&&(this[_0x444cd8(0x243)][_0x444cd8(0x1d7)]=_0x521187['value'],_0x521187[_0x444cd8(0x1c5)]=!![]),this[_0x444cd8(0x243)][_0x444cd8(0x224)](_0x521187);}this[_0x444cd8(0x243)][_0x444cd8(0x22b)](_0x444cd8(0x22c))?.[_0x444cd8(0x22e)]['toggle'](_0x444cd8(0x21c),!_0x3e3597['length']);}}['getShippingEstimates'](_0x385dc0){const _0xb5a122=_0xcc4663,_0x48ab5d=fetchConfig('javascript');_0x48ab5d[_0xb5a122(0x1e0)]['X-Requested-With']=_0xb5a122(0x1bf),delete _0x48ab5d[_0xb5a122(0x1e0)][_0xb5a122(0x1d8)],_0x48ab5d[_0xb5a122(0x1df)]=_0x385dc0,this['loader'][_0xb5a122(0x22e)][_0xb5a122(0x24a)]('hidden');const _0x4a1806=_0xdb8131=>{const _0x52f8ed=_0xb5a122;this[_0x52f8ed(0x1ae)]['classList'][_0x52f8ed(0x225)](_0x52f8ed(0x21c)),this[_0x52f8ed(0x24b)][_0x52f8ed(0x22e)][_0x52f8ed(0x225)](_0x52f8ed(0x21c)),this[_0x52f8ed(0x23f)]=document['querySelector'](_0x52f8ed(0x1f3))||document[_0x52f8ed(0x1fe)]('shipping-calculator-cart'),this[_0x52f8ed(0x23f)][_0x52f8ed(0x1ec)](_0x52f8ed(0x1d5)),this[_0x52f8ed(0x241)](_0x385dc0),this[_0x52f8ed(0x20c)](_0xdb8131,_0x385dc0);};fetch(''+routes['prepare_shipping_rates'],_0x48ab5d)[_0xb5a122(0x1f4)](_0x52a82c=>{const _0x202017=_0xb5a122;return _0x52a82c[_0x202017(0x230)]();})[_0xb5a122(0x1f4)](_0x2baaa9=>{const _0x1903fb=_0xb5a122;if(_0x2baaa9!=null)_0x2baaa9[_0x1903fb(0x1d3)]!==undefined?this[_0x1903fb(0x1ae)][_0x1903fb(0x1fe)](_0x1903fb(0x202))[_0x1903fb(0x232)]=_0x1903fb(0x23a)+_0x2baaa9['zip'][0x0]:this[_0x1903fb(0x1ae)]['querySelector'](_0x1903fb(0x202))[_0x1903fb(0x232)]=_0x2baaa9[_0x1903fb(0x1ae)][0x0],this[_0x1903fb(0x1ae)][_0x1903fb(0x22e)][_0x1903fb(0x24a)](_0x1903fb(0x21c)),this['loader'][_0x1903fb(0x22e)][_0x1903fb(0x225)](_0x1903fb(0x21c));else{const _0x199372=new URLSearchParams(_0x385dc0)[_0x1903fb(0x1f2)]();setTimeout(()=>{const _0x238600=_0x1903fb;fetch(routes[_0x238600(0x1e9)]+'?'+_0x199372)[_0x238600(0x1f4)](_0x2468b1=>_0x2468b1[_0x238600(0x230)]())[_0x238600(0x1f4)](_0x3da91d=>{_0x3da91d===null?setTimeout(()=>{const _0x5d1615=_0x3352;fetch(routes[_0x5d1615(0x1e9)]+'?'+_0x199372)['then'](_0x5a448c=>_0x5a448c[_0x5d1615(0x230)]())[_0x5d1615(0x1f4)](_0x507875=>{_0x4a1806(_0x507875);})['catch'](_0x3b884e=>{console['warn'](_0x3b884e);});},0x3e8):_0x4a1806(_0x3da91d);})['catch'](_0x2b028e=>{const _0x45d2f5=_0x238600;console[_0x45d2f5(0x1b9)](_0x2b028e);});},0x3e8);}})['catch'](_0x170bad=>{console['warn'](_0x170bad);});}[_0xcc4663(0x20c)](_0xb7a3d4,_0xacb3a5){const _0x127247=_0xcc4663;function _0x1d7826(_0x3c0d73,_0x5aad4c,_0x1d7098){const _0x12a06e=_0x3352;function _0x3a63cd(_0x26498b){const _0x25a080=_0x3352;let _0x524c34=new Intl['DateTimeFormat']('en',_0x26498b);return _0x524c34[_0x25a080(0x1f8)](_0x3c0d73);}return _0x5aad4c[_0x12a06e(0x1ac)](_0x3a63cd)[_0x12a06e(0x247)](_0x1d7098);}let _0xd9e340=[{'day':_0x127247(0x1cd)},{'month':_0x127247(0x237)},{'year':_0x127247(0x1cd)}];if(!_0xb7a3d4)this[_0x127247(0x1ae)]['querySelector']('small')[_0x127247(0x1c4)]=window[_0x127247(0x1e1)][_0x127247(0x1d9)],this[_0x127247(0x1ae)][_0x127247(0x22e)][_0x127247(0x24a)](_0x127247(0x21c)),this[_0x127247(0x1b6)]['innerHTML']=null;else{if(_0xb7a3d4['shipping_rates']&&_0xb7a3d4[_0x127247(0x218)][_0x127247(0x23d)]>0x0){const {shipping_rates:_0x28b1cb}=_0xb7a3d4;if(Object[_0x127247(0x1b1)](_0x28b1cb)[_0x127247(0x23d)]){let _0x3dfd9d='',_0x1a80bb=this[_0x127247(0x238)]['innerHTML']['replace'](_0x127247(0x23b),_0xacb3a5[_0x127247(0x245)]('shipping_address[country]')+',');_0x1a80bb=_0x1a80bb[_0x127247(0x1cb)](_0x127247(0x233),_0xacb3a5[_0x127247(0x245)](_0x127247(0x21f))??![]?_0xacb3a5[_0x127247(0x245)](_0x127247(0x21f))+',':''),_0x1a80bb=_0x1a80bb[_0x127247(0x1cb)]('[zip]',_0xacb3a5[_0x127247(0x245)](_0x127247(0x1fc))),Object['values'](_0x28b1cb)[_0x127247(0x22a)](_0x8a150c=>{const _0x18aa86=_0x127247;let _0x220748=this[_0x18aa86(0x1c6)]['innerHTML'];_0x220748=_0x220748[_0x18aa86(0x1ea)](_0x18aa86(0x1bb),_0x8a150c[_0x18aa86(0x21e)]),_0x220748=_0x220748[_0x18aa86(0x1ea)](_0x18aa86(0x1c9),_0x8a150c[_0x18aa86(0x22d)]),_0x220748=_0x220748[_0x18aa86(0x1ea)]('[currency]',_0x8a150c[_0x18aa86(0x223)]);_0x8a150c[_0x18aa86(0x20e)][0x0]!==_0x8a150c[_0x18aa86(0x20e)][0x1]?_0x220748=_0x220748[_0x18aa86(0x1ea)](_0x18aa86(0x1e7),_0x8a150c[_0x18aa86(0x20e)][_0x18aa86(0x247)]('\x20-\x20')||_0x18aa86(0x1ed)+window[_0x18aa86(0x1e1)][_0x18aa86(0x211)]+_0x18aa86(0x1c7)):_0x220748=_0x220748['replaceAll'](_0x18aa86(0x1e7),_0x18aa86(0x220));const _0x24838b=new Date();_0x24838b['setDate'](_0x24838b[_0x18aa86(0x20b)]()+0x1e),_0x220748=_0x220748[_0x18aa86(0x1ea)](_0x18aa86(0x1ee),_0x1d7826(new Date(_0x8a150c[_0x18aa86(0x1da)]?_0x8a150c[_0x18aa86(0x1da)]:_0x24838b),_0xd9e340,'\x20')),!_0x8a150c['delivery_date']&&(_0x220748=_0x220748['replaceAll']('[delivery_date_class]',_0x18aa86(0x21c))),!_0x8a150c[_0x18aa86(0x239)]&&(_0x220748=_0x220748['replaceAll'](_0x18aa86(0x203),'hidden')),!_0x8a150c['delivery_days']&&(_0x220748=_0x220748[_0x18aa86(0x1ea)](_0x18aa86(0x212),_0x18aa86(0x21c))),!(_0x8a150c[_0x18aa86(0x239)]&&_0x8a150c[_0x18aa86(0x239)][0x0]!==_0x8a150c[_0x18aa86(0x239)][0x1])&&(_0x8a150c[_0x18aa86(0x239)]=[Date['now'](),_0x24838b]),_0x220748=_0x220748[_0x18aa86(0x1ea)](_0x18aa86(0x1ef),_0x8a150c['delivery_range']??![]?_0x8a150c[_0x18aa86(0x239)][_0x18aa86(0x1ac)](_0x5ad7e2=>_0x1d7826(new Date(_0x5ad7e2),_0xd9e340,'\x20'))[_0x18aa86(0x247)](_0x18aa86(0x1bc)):_0x18aa86(0x1ed)+window[_0x18aa86(0x1e1)][_0x18aa86(0x211)]+_0x18aa86(0x1c7)),_0x8a150c['price']===_0x18aa86(0x1e6)?(_0x220748=_0x220748[_0x18aa86(0x1ea)](_0x18aa86(0x1f1),window[_0x18aa86(0x1e1)][_0x18aa86(0x217)]),_0x220748=_0x220748['replaceAll']('[success]',_0x18aa86(0x1c8)),_0x220748=_0x220748[_0x18aa86(0x1ea)](_0x18aa86(0x235),window['shippingLogos'][_0x18aa86(0x1ba)])):(_0x220748=_0x220748[_0x18aa86(0x1ea)](_0x18aa86(0x235),window[_0x18aa86(0x1dd)][_0x8a150c[_0x18aa86(0x1e2)]]),_0x220748=_0x220748[_0x18aa86(0x1ea)](_0x18aa86(0x1f1),window[_0x18aa86(0x1e1)]['selectShipping'])),_0x3dfd9d+=_0x220748;}),this[_0x127247(0x1b6)][_0x127247(0x1c4)]=null,this[_0x127247(0x1b6)][_0x127247(0x1c4)]=_0x1a80bb+_0x3dfd9d,this[_0x127247(0x1e4)]();}}else this[_0x127247(0x1b6)][_0x127247(0x1c4)]=_0x127247(0x228)+window[_0x127247(0x1e1)][_0x127247(0x229)]+_0x127247(0x214);}}[_0xcc4663(0x1e4)](){setTimeout(()=>{const _0x164cfd=_0x3352,_0x4718c2=document[_0x164cfd(0x1fe)]('.js-dropdn-content-scroll.shipping-form-element'),_0xd1dd15=Scrollbar[_0x164cfd(0x245)](_0x4718c2);_0xd1dd15&&(_0xd1dd15['scrollTo'](0x0,0x0,0x320),_0xd1dd15[_0x164cfd(0x20d)]());});}}function _0x2ed6(){const _0xdc28ba=['shippingLogos','text','body','headers','themeStrings','source','#shipping-error','scrollForm','getUpdateStatus','0.00','[delivery_days]','6szAcGm','async_shipping_rates','replaceAll','<div\x20class=\x22loading-overlay\x22><div\x20data-load=\x22loading\x22></div></div>','setUpdateStatus','<span\x20class=\x22ask-the-seller\x22>','[delivery_date]','[delivery_range]','preventDefault','[tooltip]','toString','shipping-calculator','then','addEventListener','define','1045639UvQTmW','format','change','getReady','657639jlLoiQ','shipping_address[zip]','country','querySelector','toggle','template.list','close','small','[delivery_range_class]','#dropdnMinicartPopup','submit','titleElement','options','click','option','contains','getDate','renderShippingEstimates','update','delivery_days','updateFormLocalStorage','toggleFormElements','askTheSeller','[delivery_days_class]','scrollTo','</b><br/><br/>','template-cart','9774112JQCBTa','freeShipping','shipping_rates','.shopify-section','getItem','[data-scrollbar]','hidden','setItem','presentment_name','shipping_address[province]','14\x20-\x2030','#country','76qovjXC','currency','appendChild','add','submitIfReady','shipping-calculator-static','<b>','shipping_absent','forEach','closest','.form-group','price','classList','append','json','.loading-overlay__spinner','textContent','[province]','dispatchEvent','[image]','default','short','templateMeta','delivery_range','Zip\x20','[country]','form','length','parse','shippingCalculator','initForm','setLocalStorage','?section_id=async-shipping-calculator-form','province','88128GomoLK','get','some','join','[data-shipping-calculator-form-slot]','getLocalStorageProvince','remove','loader','shippingCalculatorForm','currentTarget','shipping-closed','map','from','error','2531043wjItPu','shipping-calculator-form','values','.js-minicart-link','selectedIndex','shipping-calculator-cart','createElement','shipping_results','1162951FPbhRo','provinces','warn','freeDelivery','[title]','\x20-\x20','querySelectorAll','onSubmitHandler','XMLHttpRequest','split','target','46825BuxYRn','bind','innerHTML','selected','template','</span>','success','[price]','.loading-overlay','replace','shipping_address[','numeric','span','toggleForms','setupEventListeners','template.meta','parseFromString','zip','getCountryProvinces','false','onClickHandler','value','Content-Type','shippingServerIssue','delivery_date','dataset','children'];_0x2ed6=function(){return _0xdc28ba;};return _0x2ed6();}customElements[_0xcc4663(0x1f6)](_0xcc4663(0x1b0),ShippingCalculatorForm);
const _0x2cc0a5=_0x3da4;function _0x2a9c(){const _0x3ae19d=['map','remove','content','catch','is-visible','6610jqhMRJ','routes','20118OBqvxq','45864TYEUMs','forEach','lumiaRecentlyViewed','call','parseFromString','rendered','slice','807765mdVlxf','1512BSBtgB','swiper-slide','classList','2584872sDMIIF','createDocumentFragment','7290798memMWn','appendChild','text','.holder','div','dataset','1381883tzIvpC','.swiper-wrapper','entries','1386RCgfJH','show-on-scroll','.show-on-scroll','cloneNode','querySelector','96kxqzkc','product-card','undefined','all','handle','template','then','text/html','once','add','receiveEntry','?section_id=product-card-rv'];_0x2a9c=function(){return _0x3ae19d;};return _0x2a9c();}(function(_0x2b88a0,_0x2d3002){const _0x9b844=_0x3da4,_0x39d0bf=_0x2b88a0();while(!![]){try{const _0x715515=parseInt(_0x9b844(0x12c))/0x1+parseInt(_0x9b844(0x119))/0x2*(parseInt(_0x9b844(0x134))/0x3)+parseInt(_0x9b844(0x124))/0x4+-parseInt(_0x9b844(0x120))/0x5+-parseInt(_0x9b844(0x126))/0x6+parseInt(_0x9b844(0x118))/0x7*(-parseInt(_0x9b844(0x121))/0x8)+-parseInt(_0x9b844(0x12f))/0x9*(parseInt(_0x9b844(0x116))/0xa);if(_0x715515===_0x2d3002)break;else _0x39d0bf['push'](_0x39d0bf['shift']());}catch(_0x2af041){_0x39d0bf['push'](_0x39d0bf['shift']());}}}(_0x2a9c,0xb4ba3));function _0x3da4(_0x1f6e5e,_0x5cbc1b){const _0x2a9cf4=_0x2a9c();return _0x3da4=function(_0x3da482,_0x8d3be0){_0x3da482=_0x3da482-0x10d;let _0xb683e6=_0x2a9cf4[_0x3da482];return _0xb683e6;},_0x3da4(_0x1f6e5e,_0x5cbc1b);}if(typeof recentlyViewed===_0x2cc0a5(0x136)){class RecentlyViewed extends StorageObject{constructor(){const _0x5a9232=_0x2cc0a5;super(),this['storageKey']=_0x5a9232(0x11b);}static[_0x2cc0a5(0x10f)](_0x6f0a95=null){const _0x1a4df6=_0x2cc0a5;return _0x6f0a95===null?this['dataset'][_0x1a4df6(0x138)]:_0x6f0a95;}}window['rv']=new RecentlyViewed();function recentlyViewed(_0x444dea){const _0x10f684=_0x2cc0a5;if(_0x10f684(0x10d)in this[_0x10f684(0x12b)]&&this[_0x10f684(0x12b)][_0x10f684(0x10d)]===_0x10f684(0x11e))return;if(!_0x444dea[0x0]['isIntersecting'])return;let _0x438410={'once':_0x10f684(0x11e)};recentlyViewedRenderView[_0x10f684(0x11c)](this,_0x438410);}function recentlyViewedRenderView(_0x4167f9){const _0x306e30=_0x2cc0a5,_0x232c1f=rv[_0x306e30(0x12e)](!![])[_0x306e30(0x11f)](0x0,0x6);_0x232c1f&&_0x232c1f['length']&&Promise[_0x306e30(0x137)](_0x232c1f[_0x306e30(0x111)](_0x3fdb4f=>fetch(window['Shopify'][_0x306e30(0x117)]['root']+('products/'+_0x3fdb4f+_0x306e30(0x110)))))['then'](_0x5eb0f=>Promise['all'](_0x5eb0f[_0x306e30(0x111)](_0x438507=>_0x438507[_0x306e30(0x128)]())))[_0x306e30(0x13a)](_0x2c9d76=>{const _0x4cda20=_0x306e30,_0x4680be=document[_0x4cda20(0x125)]();_0x2c9d76[_0x4cda20(0x11a)](_0x29268a=>{const _0x18468f=_0x4cda20,_0x376b1e=new DOMParser()[_0x18468f(0x11d)](_0x29268a,_0x18468f(0x13b))[_0x18468f(0x133)](_0x18468f(0x135));if(_0x376b1e){const _0x2a7738=document['createElement'](_0x18468f(0x12a));_0x2a7738[_0x18468f(0x123)][_0x18468f(0x10e)](_0x18468f(0x122)),_0x2a7738['appendChild'](_0x376b1e),_0x4680be[_0x18468f(0x127)](_0x2a7738);}});const _0x1f92c2=this[_0x4cda20(0x133)](_0x4cda20(0x139))[_0x4cda20(0x113)][_0x4cda20(0x132)](!![]);_0x1f92c2['querySelector'](_0x4cda20(0x12d))['appendChild'](_0x4680be);const _0x2a4519=_0x1f92c2['querySelector'](_0x4cda20(0x131));_0x4cda20(0x10d)in this[_0x4cda20(0x12b)]&&this[_0x4cda20(0x12b)][_0x4cda20(0x10d)]===_0x4cda20(0x11e)&&_0x2a4519[_0x4cda20(0x123)][_0x4cda20(0x112)](_0x4cda20(0x130)),this[_0x4cda20(0x133)](_0x4cda20(0x129))?.[_0x4cda20(0x112)](),this[_0x4cda20(0x127)](_0x1f92c2),setTimeout(()=>{const _0x4a0000=_0x4cda20;this['querySelector'](_0x4a0000(0x131))?.[_0x4a0000(0x123)][_0x4a0000(0x10e)](_0x4a0000(0x115));});if('once'in this[_0x4cda20(0x12b)]&&this[_0x4cda20(0x12b)][_0x4cda20(0x10d)]!==_0x4cda20(0x11e)&&_0x4167f9)this[_0x4cda20(0x12b)][_0x4cda20(0x10d)]=_0x4167f9['once'];})[_0x306e30(0x114)](_0x34c6d8=>console['error'](_0x34c6d8));}}
class ObserverIntersection extends HTMLElement {
  constructor() {
    super();

    this.dataset.name === 'rvi' && this.addEventListener('quick-view-popup-after-load-extend', function (e) {
      if (e.detail) {
        window[this.dataset.instance].add(e.detail.handle);
        const handler = this.dataset.handler;
        handler && document.querySelectorAll(`[data-handler=${handler}]`).forEach(item => item.dataset.updated = 'true');
      }
    })
  }

  static get observedAttributes() {
    return ['data-updated'];
  }

  disableLoading(){
    setTimeout(() => {
      document.querySelector("loading-bar").hide();
    }, 500);
  }

  renderSection(html) {
    const renderedDocument = new DOMParser().parseFromString(html, 'text/html');
    const destinationEl  = this.querySelector(this.dataset.ajaxContainer);
    const sourceEl = renderedDocument.querySelector('.shopify-section ');

    if (destinationEl && sourceEl) {
      destinationEl.innerHTML = sourceEl.innerHTML
    }

    this.disableLoading();
  }

  fetchSectionHandler(entries) {
    if ('once' in this.dataset && this.dataset.once === 'rendered') return;

    if (!entries[0].isIntersecting) return;

    this.dataset.once = 'rendered'

    fetch(this.dataset.url)
      .then(response => {
        return response.text();
      })
      .then(html => {
        this.renderSection(html);
      })
      .catch(e => {
        console.error(e);
      }).finally(() => {
        this.disableLoading();
      });
  }

  connectedCallback() {
    let handler;

    if (this.dataset.url) {
      handler = this.fetchSectionHandler.bind(this)
    } else {
      handler = window[this.dataset.handler].bind(this)
    }

    new IntersectionObserver(handler, {
      rootMargin: this.dataset.margin,
      threshold: parseFloat(this.dataset.threshold)
    }).observe(this);

  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-updated') {
      window[this.dataset.handler + 'RenderView'].call(this);
    }
  }
}
customElements.define('intersection-observer', ObserverIntersection);
